var __webpack_modules__ = ({
154(module, exports, __webpack_require__) {
/* module decorator */ module = __webpack_require__.nmd(module);
(function (global, factory) {
   true ? factory(exports) :
  0;
})(this, (function (exports) { 'use strict';

  /** Used for built-in method references. */
  var objectProto$l = Object.prototype;

  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */
  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$l;

    return value === proto;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeKeys = overArg(Object.keys, Object);

  /** Used for built-in method references. */
  var objectProto$k = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$h = objectProto$k.hasOwnProperty;

  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty$h.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }
    return result;
  }

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root$1 = freeGlobal || freeSelf || Function('return this')();

  /** Built-in value references. */
  var Symbol$1 = root$1.Symbol;

  /** Used for built-in method references. */
  var objectProto$j = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$g = objectProto$j.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString$2 = objectProto$j.toString;

  /** Built-in value references. */
  var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty$g.call(value, symToStringTag$1),
        tag = value[symToStringTag$1];

    try {
      value[symToStringTag$1] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString$2.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag$1] = tag;
      } else {
        delete value[symToStringTag$1];
      }
    }
    return result;
  }

  /** Used for built-in method references. */
  var objectProto$i = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString$1 = objectProto$i.toString;

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString$1.call(value);
  }

  /** `Object#toString` result references. */
  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';

  /** Built-in value references. */
  var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return (symToStringTag && symToStringTag in Object(value))
      ? getRawTag(value)
      : objectToString(value);
  }

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject$1(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }

  /** `Object#toString` result references. */
  var asyncTag = '[object AsyncFunction]',
      funcTag$2 = '[object Function]',
      genTag$1 = '[object GeneratorFunction]',
      proxyTag = '[object Proxy]';

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    if (!isObject$1(value)) {
      return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
  }

  /** Used to detect overreaching core-js shims. */
  var coreJsData = root$1['__core-js_shared__'];

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = (function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? ('Symbol(src)_1.' + uid) : '';
  }());

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && (maskSrcKey in func);
  }

  /** Used for built-in method references. */
  var funcProto$2 = Function.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString$2 = funcProto$2.toString;

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString$2.call(func);
      } catch (e) {}
      try {
        return (func + '');
      } catch (e) {}
    }
    return '';
  }

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used for built-in method references. */
  var funcProto$1 = Function.prototype,
      objectProto$h = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString$1 = funcProto$1.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty$f = objectProto$h.hasOwnProperty;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' +
    funcToString$1.call(hasOwnProperty$f).replace(reRegExpChar, '\\$&')
    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
  );

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject$1(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }

  /* Built-in method references that are verified to be native. */
  var DataView = getNative(root$1, 'DataView');

  /* Built-in method references that are verified to be native. */
  var Map = getNative(root$1, 'Map');

  /* Built-in method references that are verified to be native. */
  var Promise$1 = getNative(root$1, 'Promise');

  /* Built-in method references that are verified to be native. */
  var Set = getNative(root$1, 'Set');

  /* Built-in method references that are verified to be native. */
  var WeakMap = getNative(root$1, 'WeakMap');

  /** `Object#toString` result references. */
  var mapTag$6 = '[object Map]',
      objectTag$4 = '[object Object]',
      promiseTag = '[object Promise]',
      setTag$6 = '[object Set]',
      weakMapTag$2 = '[object WeakMap]';

  var dataViewTag$4 = '[object DataView]';

  /** Used to detect maps, sets, and weakmaps. */
  var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise$1),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);

  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  var getTag = baseGetTag;

  // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
  if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag$4) ||
      (Map && getTag(new Map) != mapTag$6) ||
      (Promise$1 && getTag(Promise$1.resolve()) != promiseTag) ||
      (Set && getTag(new Set) != setTag$6) ||
      (WeakMap && getTag(new WeakMap) != weakMapTag$2)) {
    getTag = function(value) {
      var result = baseGetTag(value),
          Ctor = result == objectTag$4 ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : '';

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString: return dataViewTag$4;
          case mapCtorString: return mapTag$6;
          case promiseCtorString: return promiseTag;
          case setCtorString: return setTag$6;
          case weakMapCtorString: return weakMapTag$2;
        }
      }
      return result;
    };
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }

  /** `Object#toString` result references. */
  var argsTag$3 = '[object Arguments]';

  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */
  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag$3;
  }

  /** Used for built-in method references. */
  var objectProto$g = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$e = objectProto$g.hasOwnProperty;

  /** Built-in value references. */
  var propertyIsEnumerable$1 = objectProto$g.propertyIsEnumerable;

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty$e.call(value, 'callee') &&
      !propertyIsEnumerable$1.call(value, 'callee');
  };

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER$1 = 9007199254740991;

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' &&
      value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
  }

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }

  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */
  function stubFalse() {
    return false;
  }

  /** Detect free variable `exports`. */
  var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule$2 = freeExports$2 && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

  /** Built-in value references. */
  var Buffer$1 = moduleExports$2 ? root$1.Buffer : undefined;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = nativeIsBuffer || stubFalse;

  /** `Object#toString` result references. */
  var argsTag$2 = '[object Arguments]',
      arrayTag$2 = '[object Array]',
      boolTag$3 = '[object Boolean]',
      dateTag$3 = '[object Date]',
      errorTag$2 = '[object Error]',
      funcTag$1 = '[object Function]',
      mapTag$5 = '[object Map]',
      numberTag$3 = '[object Number]',
      objectTag$3 = '[object Object]',
      regexpTag$3 = '[object RegExp]',
      setTag$5 = '[object Set]',
      stringTag$4 = '[object String]',
      weakMapTag$1 = '[object WeakMap]';

  var arrayBufferTag$3 = '[object ArrayBuffer]',
      dataViewTag$3 = '[object DataView]',
      float32Tag$2 = '[object Float32Array]',
      float64Tag$2 = '[object Float64Array]',
      int8Tag$2 = '[object Int8Array]',
      int16Tag$2 = '[object Int16Array]',
      int32Tag$2 = '[object Int32Array]',
      uint8Tag$2 = '[object Uint8Array]',
      uint8ClampedTag$2 = '[object Uint8ClampedArray]',
      uint16Tag$2 = '[object Uint16Array]',
      uint32Tag$2 = '[object Uint32Array]';

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
  typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
  typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
  typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
  typedArrayTags[uint32Tag$2] = true;
  typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] =
  typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] =
  typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$3] =
  typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] =
  typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] =
  typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$3] =
  typedArrayTags[setTag$5] = typedArrayTags[stringTag$4] =
  typedArrayTags[weakMapTag$1] = false;

  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */
  function baseIsTypedArray(value) {
    return isObjectLike(value) &&
      isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /** Detect free variable `exports`. */
  var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule$1 = freeExports$1 && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports$1 && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */
  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

  /** `Object#toString` result references. */
  var mapTag$4 = '[object Map]',
      setTag$4 = '[object Set]';

  /** Used for built-in method references. */
  var objectProto$f = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$d = objectProto$f.hasOwnProperty;

  /**
   * Checks if `value` is an empty object, collection, map, or set.
   *
   * Objects are considered empty if they have no own enumerable string keyed
   * properties.
   *
   * Array-like values such as `arguments` objects, arrays, buffers, strings, or
   * jQuery-like collections are considered empty if they have a `length` of `0`.
   * Similarly, maps and sets are considered empty if they have a `size` of `0`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is empty, else `false`.
   * @example
   *
   * _.isEmpty(null);
   * // => true
   *
   * _.isEmpty(true);
   * // => true
   *
   * _.isEmpty(1);
   * // => true
   *
   * _.isEmpty([1, 2, 3]);
   * // => false
   *
   * _.isEmpty({ 'a': 1 });
   * // => false
   */
  function isEmpty(value) {
    if (value == null) {
      return true;
    }
    if (isArrayLike(value) &&
        (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
          isBuffer(value) || isTypedArray(value) || isArguments(value))) {
      return !value.length;
    }
    var tag = getTag(value);
    if (tag == mapTag$4 || tag == setTag$4) {
      return !value.size;
    }
    if (isPrototype(value)) {
      return !baseKeys(value).length;
    }
    for (var key in value) {
      if (hasOwnProperty$d.call(value, key)) {
        return false;
      }
    }
    return true;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;

    return !!length &&
      (type == 'number' ||
        (type != 'symbol' && reIsUint.test(value))) &&
          (value > -1 && value % 1 == 0 && value < length);
  }

  /** Used for built-in method references. */
  var objectProto$e = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$c = objectProto$e.hasOwnProperty;

  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty$c.call(value, key)) &&
          !(skipIndexes && (
             // Safari 9 has enumerable `arguments.length` in strict mode.
             key == 'length' ||
             // Node.js 0.10 has enumerable non-index properties on buffers.
             (isBuff && (key == 'offset' || key == 'parent')) ||
             // PhantomJS 2 has enumerable non-index properties on typed arrays.
             (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
             // Skip index properties.
             isIndex(key, length)
          ))) {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */
  function keys$2(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /** `Object#toString` result references. */
  var symbolTag$3 = '[object Symbol]';

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol(value) {
    return typeof value == 'symbol' ||
      (isObjectLike(value) && baseGetTag(value) == symbolTag$3);
  }

  /** Used to convert symbols to primitives and strings. */
  var symbolProto$2 = Symbol$1 ? Symbol$1.prototype : undefined,
      symbolToString = symbolProto$2 ? symbolProto$2.toString : undefined;

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isArray(value)) {
      // Recursively convert values (susceptible to call stack limits).
      return arrayMap(value, baseToString) + '';
    }
    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -Infinity) ? '-0' : result;
  }

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString$2(value) {
    return value == null ? '' : baseToString(value);
  }

  /** Used to generate unique IDs. */
  var idCounter = 0;

  /**
   * Generates a unique ID. If `prefix` is given, the ID is appended to it.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {string} [prefix=''] The value to prefix the ID with.
   * @returns {string} Returns the unique ID.
   * @example
   *
   * _.uniqueId('contact_');
   * // => 'contact_104'
   *
   * _.uniqueId();
   * // => '105'
   */
  function uniqueId(prefix) {
    var id = ++idCounter;
    return toString$2(prefix) + id;
  }

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /** Used as references for various `Number` constants. */
  var NAN = 0 / 0;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Built-in method references without a dependency on `root`. */
  var freeParseInt = parseInt;

  /**
   * Converts `value` to a number.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {number} Returns the number.
   * @example
   *
   * _.toNumber(3.2);
   * // => 3.2
   *
   * _.toNumber(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toNumber(Infinity);
   * // => Infinity
   *
   * _.toNumber('3.2');
   * // => 3.2
   */
  function toNumber$1(value) {
    if (typeof value == 'number') {
      return value;
    }
    if (isSymbol(value)) {
      return NAN;
    }
    if (isObject$1(value)) {
      var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
      value = isObject$1(other) ? (other + '') : other;
    }
    if (typeof value != 'string') {
      return value === 0 ? value : +value;
    }
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return (isBinary || reIsOctal.test(value))
      ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
      : (reIsBadHex.test(value) ? NAN : +value);
  }

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_INTEGER = 1.7976931348623157e+308;

  /**
   * Converts `value` to a finite number.
   *
   * @static
   * @memberOf _
   * @since 4.12.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted number.
   * @example
   *
   * _.toFinite(3.2);
   * // => 3.2
   *
   * _.toFinite(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toFinite(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toFinite('3.2');
   * // => 3.2
   */
  function toFinite(value) {
    if (!value) {
      return value === 0 ? value : 0;
    }
    value = toNumber$1(value);
    if (value === INFINITY || value === -INFINITY) {
      var sign = (value < 0 ? -1 : 1);
      return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
  }

  /**
   * Converts `value` to an integer.
   *
   * **Note:** This method is loosely based on
   * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted integer.
   * @example
   *
   * _.toInteger(3.2);
   * // => 3
   *
   * _.toInteger(Number.MIN_VALUE);
   * // => 0
   *
   * _.toInteger(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toInteger('3.2');
   * // => 3
   */
  function toInteger(value) {
    var result = toFinite(value),
        remainder = result % 1;

    return result === result ? (remainder ? result - remainder : result) : 0;
  }

  /** Error message constants. */
  var FUNC_ERROR_TEXT$3 = 'Expected a function';

  /**
   * Creates a function that invokes `func`, with the `this` binding and arguments
   * of the created function, while it's called less than `n` times. Subsequent
   * calls to the created function return the result of the last `func` invocation.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Function
   * @param {number} n The number of calls at which `func` is no longer invoked.
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new restricted function.
   * @example
   *
   * jQuery(element).on('click', _.before(5, addContactToList));
   * // => Allows adding up to 4 contacts to the list.
   */
  function before(n, func) {
    var result;
    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT$3);
    }
    n = toInteger(n);
    return function() {
      if (--n > 0) {
        result = func.apply(this, arguments);
      }
      if (n <= 1) {
        func = undefined;
      }
      return result;
    };
  }

  /**
   * Creates a function that is restricted to invoking `func` once. Repeat calls
   * to the function return the value of the first invocation. The `func` is
   * invoked with the `this` binding and arguments of the created function.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new restricted function.
   * @example
   *
   * var initialize = _.once(createApplication);
   * initialize();
   * initialize();
   * // => `createApplication` is invoked once
   */
  function once(func) {
    return before(2, func);
  }

  // Regular expression used to split event strings.
  const eventSplitter = /\s+/;
  /**
   * Iterates over the standard `event, callback` (as well as the fancy multiple
   * space-separated events `"change blur", callback` and jQuery-style event
   * maps `{event: callback}`).
   */
  function eventsApi(iteratee, events, name, callback, opts) {
      let i = 0;
      let names;
      if (name && typeof name === 'object') {
          // Handle event maps.
          if (callback !== undefined && 'context' in opts && opts.context === undefined) {
              opts.context = callback;
          }
          for (names = Object.keys(name); i < names.length; i++) {
              events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
          }
      }
      else if (name && typeof name === 'string' && eventSplitter.test(name)) {
          // Handle space-separated event names by delegating them individually.
          for (names = name.split(eventSplitter); i < names.length; i++) {
              const result = iteratee(events, names[i], callback, opts);
              if (result !== undefined) {
                  events = result;
              }
          }
      }
      else {
          // Finally, standard events.
          events = iteratee(events, name, callback, opts);
      }
      return events;
  }
  /**
   * A reducer that adds a callback to the `events` object.
   */
  function onApi(events, name, callback, options) {
      if (callback) {
          const handlers = events[name] || (events[name] = []);
          const context = options.context;
          const ctx = options.ctx;
          const listening = options.listening;
          if (listening)
              listening.count++;
          handlers.push({ callback, context, ctx: context || ctx, listening });
      }
      return events;
  }
  /**
   * An try-catch guarded #on function, to prevent poisoning the global
   * `_listening` variable.
   */
  function tryCatchOn(obj, name, callback, context) {
      try {
          obj.on(name, callback, context);
      }
      catch (e) {
          return e;
      }
  }
  /**
   * The reducing API that removes a callback from the `events` object.
   */
  function offApi(events, name, callback, options) {
      if (!events)
          return;
      const context = options.context;
      const listeners = options.listeners;
      let i = 0;
      let names;
      // Delete all event listeners and "drop" events.
      if (!name && !context && !callback) {
          if (listeners) {
              for (names = Object.keys(listeners); i < names.length; i++) {
                  listeners[names[i]].cleanup();
              }
          }
          return;
      }
      names = name ? [name] : Object.keys(events);
      for (; i < names.length; i++) {
          const currentName = names[i];
          const handlers = events[currentName];
          // Bail out if there are no events stored.
          if (!handlers) {
              continue;
          }
          // Find any remaining events.
          const remaining = [];
          for (let j = 0; j < handlers.length; j++) {
              const handler = handlers[j];
              if ((callback && callback !== handler.callback && callback !== handler.callback._callback) ||
                  (context && context !== handler.context)) {
                  remaining.push(handler);
              }
              else {
                  const listening = handler.listening;
                  if (listening)
                      listening.stop(currentName, callback);
              }
          }
          // Replace events if there are any remaining.  Otherwise, clean up.
          if (remaining.length) {
              events[currentName] = remaining;
          }
          else {
              delete events[currentName];
          }
      }
      return events;
  }
  /**
   * Reduces the event callbacks into a map of `{event: onceWrapper}`.
   * `offer` unbinds the `onceWrapper` after it has been called.
   */
  function onceMap(map, name, callback, offer) {
      if (callback) {
          const _once = once(function (...args) {
              offer(name, _once);
              callback.apply(this, args);
          });
          map[name] = _once;
          _once._callback = callback;
      }
      return map;
  }
  /** Handles triggering the appropriate event callbacks. */
  function triggerApi(objEvents, name, _callback, args) {
      if (objEvents) {
          const events = objEvents[name];
          let allEvents = objEvents.all;
          if (events && allEvents)
              allEvents = allEvents.slice();
          if (events)
              triggerEvents(events, args);
          if (allEvents)
              triggerEvents(allEvents, [name].concat(args));
      }
      return objEvents;
  }
  /**
   * A difficult-to-believe, but optimized internal dispatch function for
   * triggering events. Tries to keep the usual cases speedy (most internal
   * Backbone events have 3 arguments).
   */
  function triggerEvents(events, args) {
      let ev;
      let i = -1;
      const l = events.length;
      const a1 = args[0];
      const a2 = args[1];
      const a3 = args[2];
      switch (args.length) {
          case 0:
              while (++i < l)
                  (ev = events[i]).callback.call(ev.ctx);
              return;
          case 1:
              while (++i < l)
                  (ev = events[i]).callback.call(ev.ctx, a1);
              return;
          case 2:
              while (++i < l)
                  (ev = events[i]).callback.call(ev.ctx, a1, a2);
              return;
          case 3:
              while (++i < l)
                  (ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
              return;
          default:
              while (++i < l)
                  (ev = events[i]).callback.apply(ev.ctx, args);
              return;
      }
  }

  /**
   * A listening class that tracks and cleans up memory bindings
   * when all callbacks have been offed.
   */
  class Listening {
      constructor(listener, obj) {
          this.id = listener._listenId;
          this.listener = listener;
          this.obj = obj;
          this.interop = true;
          this.count = 0;
          this._events = undefined;
      }
      start(name, callback, context, _listening) {
          const options = {
              context: this.obj,
              ctx: context,
              listening: _listening,
          };
          this._events = eventsApi(onApi, this._events || {}, name, callback, options);
          if (_listening) {
              const listeners = this.obj._listeners || (this.obj._listeners = {});
              listeners[this.id] = this;
              // Allow the listening to use a counter, instead of tracking
              // callbacks for library interop
              this.interop = false;
          }
          return this;
      }
      /**
       * Stop's listening to a callback (or several).
       * Uses an optimized counter if the listenee uses Backbone.Events.
       * Otherwise, falls back to manual tracking to support events
       * library interop.
       */
      stop(name, callback) {
          let cleanup;
          if (this.interop) {
              this._events = eventsApi(offApi, this._events, name, callback, {
                  context: undefined,
                  listeners: undefined,
              });
              cleanup = !this._events;
          }
          else {
              this.count--;
              cleanup = this.count === 0;
          }
          if (cleanup)
              this.cleanup();
      }
      /**
       * Cleans up memory bindings between the listener and the listenee.
       */
      cleanup() {
          if (this.listener._listeningTo) {
              delete this.listener._listeningTo[this.obj._listenId];
          }
          if (!this.interop && this.obj._listeners) {
              delete this.obj._listeners[this.id];
          }
      }
  }

  /**
   * @copyright 2010-2019 Jeremy Ashkenas and DocumentCloud
   * @copyright 2023 JC Brand
   */
  // A private global variable to share between listeners and listenees.
  let _listening;
  /**
   * @public
   */
  function EventEmitter(Base) {
      return class EventEmitter extends Base {
          /**
           * Bind an event to a `callback` function. Passing `"all"` will bind
           * the callback to all events fired.
           */
          on(name, callback, context) {
              this._events = eventsApi(onApi, this._events || {}, name, callback, {
                  context: context,
                  ctx: this,
                  listening: _listening,
              });
              if (_listening) {
                  const listeners = this._listeners || (this._listeners = {});
                  listeners[_listening.id] = _listening;
                  // Allow the listening to use a counter, instead of tracking
                  // callbacks for library interop
                  _listening.interop = false;
              }
              return this;
          }
          /**
           * Inversion-of-control versions of `on`. Tell *this* object to listen to
           * an event in another object... keeping track of what it's listening to
           * for easier unbinding later.
           */
          listenTo(obj, name, callback) {
              if (!obj)
                  return this;
              const id = obj._listenId || (obj._listenId = uniqueId('l'));
              const listeningTo = this._listeningTo || (this._listeningTo = {});
              let listening = (_listening = listeningTo[id]);
              // This object is not listening to any other events on `obj` yet.
              // Setup the necessary references to track the listening callbacks.
              if (!listening) {
                  this._listenId || (this._listenId = uniqueId('l'));
                  listening = _listening = listeningTo[id] = new Listening(this, obj);
              }
              // Bind callbacks on obj.
              const error = tryCatchOn(obj, name, callback, this);
              _listening = undefined;
              if (error)
                  throw error;
              // If the target obj is not Backbone.Events, track events manually.
              if (listening.interop)
                  listening.start(name, callback, this, _listening);
              return this;
          }
          /**
           * Remove one or many callbacks. If `context` is null, removes all
           * callbacks with that function. If `callback` is null, removes all
           * callbacks for the event. If `name` is null, removes all bound
           * callbacks for all events.
           */
          off(name, callback, context) {
              if (!this._events)
                  return this;
              this._events = eventsApi(offApi, this._events, name, callback, {
                  context: context,
                  listeners: this._listeners,
              });
              return this;
          }
          /**
           * Tell this object to stop listening to either specific events ... or
           * to every object it's currently listening to.
           */
          stopListening(obj, name, callback) {
              const listeningTo = this._listeningTo;
              if (!listeningTo)
                  return this;
              const ids = obj ? [obj._listenId] : keys$2(listeningTo);
              for (let i = 0; i < ids.length; i++) {
                  const listening = listeningTo[ids[i]];
                  // If listening doesn't exist, this object is not currently
                  // listening to obj. Break out early.
                  if (!listening)
                      break;
                  listening.obj.off(name, callback, this);
                  if (listening.interop)
                      listening.stop(name, callback);
              }
              if (isEmpty(listeningTo))
                  this._listeningTo = undefined;
              return this;
          }
          /**
           * Bind an event to only be triggered a single time. After the first time
           * the callback is invoked, its listener will be removed. If multiple events
           * are passed in using the space-separated syntax, the handler will fire
           * once for each event, not once for a combination of all events.
           */
          once(name, callback, context) {
              // Map the event into a `{event: once}` object.
              const events = eventsApi(onceMap, {}, name, callback, this.off.bind(this));
              if (typeof name === 'string' && (context === null || context === undefined))
                  callback = undefined;
              return this.on(events, callback, context);
          }
          /**
           * Inversion-of-control versions of `once`.
           */
          listenToOnce(obj, name, callback) {
              // Map the event into a `{event: once}` object.
              const events = eventsApi(onceMap, {}, name, callback, this.stopListening.bind(this, obj));
              return this.listenTo(obj, events);
          }
          /**
           * Trigger one or many events, firing all bound callbacks. Callbacks are
           * passed the same arguments as `trigger` is, apart from the event name
           * (unless you're listening on `"all"`, which will cause your callback to
           * receive the true name of the event as the first argument).
           */
          trigger(name, ...args) {
              if (!this._events)
                  return this;
              eventsApi(triggerApi, this._events, name, undefined, args);
              return this;
          }
      };
  }
  /**
   * @public
   */
  const EventEmitterObject = EventEmitter(Object);

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
  /* global Reflect, Promise */


  function __values(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
          next: function () {
              if (o && i >= o.length) o = void 0;
              return { value: o && o[i++], done: !o };
          }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }

  /*!
  MIT License

  Copyright (c) 2018 Arturas Molcanovas <a.molcanovas@gmail.com>

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.

  */


  /**
   * Abstracts constructing a Blob object, so it also works in older
   * browsers that don't support the native Blob constructor. (i.e.
   * old QtWebKit versions, at least).
   * Abstracts constructing a Blob object, so it also works in older
   * browsers that don't support the native Blob constructor. (i.e.
   * old QtWebKit versions, at least).
   *
   * @param parts
   * @param properties
   */
  function createBlob$1(parts, properties) {
      /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
      parts = parts || [];
      properties = properties || {};
      try {
          return new Blob(parts, properties);
      }
      catch (e) {
          if (e.name !== 'TypeError') {
              throw e;
          }
          //tslint:disable-next-line:variable-name
          var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder
              : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder
                  : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder
                      : WebKitBlobBuilder;
          var builder = new Builder();
          for (var i = 0; i < parts.length; i += 1) {
              builder.append(parts[i]);
          }
          return builder.getBlob(properties.type);
      }
  }

  var BLOB_TYPE_PREFIX_REGEX$1 = /^~~local_forage_type~([^~]+)~/;
  var SERIALIZED_MARKER_LENGTH$1 = "__lfsc__:" /* SERIALIZED_MARKER */.length;
  var TYPE_SERIALIZED_MARKER_LENGTH$1 = SERIALIZED_MARKER_LENGTH$1 + "arbf" /* TYPE_ARRAYBUFFER */.length;
  //tslint:disable:no-magic-numbers no-bitwise prefer-switch no-unbound-method
  var toString$1 = Object.prototype.toString;
  function stringToBuffer$1(serializedString) {
      // Fill the string into a ArrayBuffer.
      var bufferLength = serializedString.length * 0.75;
      var len = serializedString.length;
      if (serializedString[serializedString.length - 1] === '=') {
          bufferLength--;
          if (serializedString[serializedString.length - 2] === '=') {
              bufferLength--;
          }
      }
      var buffer = new ArrayBuffer(bufferLength);
      var bytes = new Uint8Array(buffer);
      for (var i = 0, p = 0; i < len; i += 4) {
          var encoded1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */.indexOf(serializedString[i]);
          var encoded2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */.indexOf(serializedString[i + 1]);
          var encoded3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */.indexOf(serializedString[i + 2]);
          var encoded4 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */.indexOf(serializedString[i + 3]);
          bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
          bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
          bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
      }
      return buffer;
  }
  /**
   * Converts a buffer to a string to store, serialized, in the backend
   * storage library.
   */
  function bufferToString$1(buffer) {
      // base64-arraybuffer
      var bytes = new Uint8Array(buffer);
      var base64String = '';
      for (var i = 0; i < bytes.length; i += 3) {
          /*jslint bitwise: true */
          base64String += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */[bytes[i] >> 2];
          base64String += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
          base64String +=
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
          base64String += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */[bytes[i + 2] & 63];
      }
      if (bytes.length % 3 === 2) {
          base64String = base64String.substring(0, base64String.length - 1) + '=';
      }
      else if (bytes.length % 3 === 1) {
          base64String = base64String.substring(0, base64String.length - 2) + '==';
      }
      return base64String;
  }
  /**
   * Serialize a value, afterwards executing a callback (which usually
   * instructs the `setItem()` callback/promise to be executed). This is how
   * we store binary data with localStorage.
   * @param value
   * @param callback
   */
  function serialize$2(value, callback) {
      var valueType = '';
      if (value) {
          valueType = toString$1.call(value);
      }
      // Cannot use `value instanceof ArrayBuffer` or such here, as these
      // checks fail when running the tests using casper.js...
      if (value && (valueType === '[object ArrayBuffer]' ||
          (value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]'))) {
          // Convert binary arrays to a string and prefix the string with
          // a special marker.
          var buffer = void 0;
          var marker = "__lfsc__:" /* SERIALIZED_MARKER */;
          if (value instanceof ArrayBuffer) {
              buffer = value;
              marker += "arbf" /* TYPE_ARRAYBUFFER */;
          }
          else {
              buffer = value.buffer;
              if (valueType === '[object Int8Array]') {
                  marker += "si08" /* TYPE_INT8ARRAY */;
              }
              else if (valueType === '[object Uint8Array]') {
                  marker += "ui08" /* TYPE_UINT8ARRAY */;
              }
              else if (valueType === '[object Uint8ClampedArray]') {
                  marker += "uic8" /* TYPE_UINT8CLAMPEDARRAY */;
              }
              else if (valueType === '[object Int16Array]') {
                  marker += "si16" /* TYPE_INT16ARRAY */;
              }
              else if (valueType === '[object Uint16Array]') {
                  marker += "ur16" /* TYPE_UINT16ARRAY */;
              }
              else if (valueType === '[object Int32Array]') {
                  marker += "si32" /* TYPE_INT32ARRAY */;
              }
              else if (valueType === '[object Uint32Array]') {
                  marker += "ui32" /* TYPE_UINT32ARRAY */;
              }
              else if (valueType === '[object Float32Array]') {
                  marker += "fl32" /* TYPE_FLOAT32ARRAY */;
              }
              else if (valueType === '[object Float64Array]') {
                  marker += "fl64" /* TYPE_FLOAT64ARRAY */;
              }
              else {
                  callback(new Error('Failed to get type for BinaryArray'));
              }
          }
          callback(marker + bufferToString$1(buffer));
      }
      else if (valueType === '[object Blob]') {
          // Convert the blob to a binaryArray and then to a string.
          var fileReader = new FileReader();
          fileReader.onload = function () {
              // Backwards-compatible prefix for the blob type.
              //tslint:disable-next-line:restrict-plus-operands
              var str = "~~local_forage_type~" /* BLOB_TYPE_PREFIX */ + value.type + "~" + bufferToString$1(this.result);
              callback("__lfsc__:" /* SERIALIZED_MARKER */ + "blob" /* TYPE_BLOB */ + str);
          };
          fileReader.readAsArrayBuffer(value);
      }
      else {
          try {
              callback(JSON.stringify(value));
          }
          catch (e) {
              console.error('Couldn\'t convert value into a JSON string: ', value);
              callback(null, e);
          }
      }
  }
  /**
   * Deserialize data we've inserted into a value column/field. We place
   * special markers into our strings to mark them as encoded; this isn't
   * as nice as a meta field, but it's the only sane thing we can do whilst
   * keeping localStorage support intact.
   *
   * Oftentimes this will just deserialize JSON content, but if we have a
   * special marker (SERIALIZED_MARKER, defined above), we will extract
   * some kind of arraybuffer/binary data/typed array out of the string.
   * @param value
   */
  function deserialize$2(value) {
      // If we haven't marked this string as being specially serialized (i.e.
      // something other than serialized JSON), we can just return it and be
      // done with it.
      if (value.substring(0, SERIALIZED_MARKER_LENGTH$1) !== "__lfsc__:" /* SERIALIZED_MARKER */) {
          return JSON.parse(value);
      }
      // The following code deals with deserializing some kind of Blob or
      // TypedArray. First we separate out the type of data we're dealing
      // with from the data itself.
      var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH$1);
      var type = value.substring(SERIALIZED_MARKER_LENGTH$1, TYPE_SERIALIZED_MARKER_LENGTH$1);
      var blobType;
      // Backwards-compatible blob type serialization strategy.
      // DBs created with older versions of localForage will simply not have the blob type.
      if (type === "blob" /* TYPE_BLOB */ && BLOB_TYPE_PREFIX_REGEX$1.test(serializedString)) {
          var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX$1);
          blobType = matcher[1];
          serializedString = serializedString.substring(matcher[0].length);
      }
      var buffer = stringToBuffer$1(serializedString);
      // Return the right type based on the code/type set during
      // serialization.
      switch (type) {
          case "arbf" /* TYPE_ARRAYBUFFER */:
              return buffer;
          case "blob" /* TYPE_BLOB */:
              return createBlob$1([buffer], { type: blobType });
          case "si08" /* TYPE_INT8ARRAY */:
              return new Int8Array(buffer);
          case "ui08" /* TYPE_UINT8ARRAY */:
              return new Uint8Array(buffer);
          case "uic8" /* TYPE_UINT8CLAMPEDARRAY */:
              return new Uint8ClampedArray(buffer);
          case "si16" /* TYPE_INT16ARRAY */:
              return new Int16Array(buffer);
          case "ur16" /* TYPE_UINT16ARRAY */:
              return new Uint16Array(buffer);
          case "si32" /* TYPE_INT32ARRAY */:
              return new Int32Array(buffer);
          case "ui32" /* TYPE_UINT32ARRAY */:
              return new Uint32Array(buffer);
          case "fl32" /* TYPE_FLOAT32ARRAY */:
              return new Float32Array(buffer);
          case "fl64" /* TYPE_FLOAT64ARRAY */:
              return new Float64Array(buffer);
          default:
              throw new Error('Unkown type: ' + type);
      }
  }

  function clone$1(obj) {
      var e_1, _a;
      if (obj === null || typeof (obj) !== 'object' || 'isActiveClone' in obj) {
          return obj;
      }
      var temp = obj instanceof Date ? new Date(obj) : (obj.constructor());
      try {
          for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
              var key = _c.value;
              if (Object.prototype.hasOwnProperty.call(obj, key)) {
                  obj['isActiveClone'] = null;
                  temp[key] = clone$1(obj[key]);
                  delete obj['isActiveClone'];
              }
          }
      }
      catch (e_1_1) { e_1 = { error: e_1_1 }; }
      finally {
          try {
              if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          }
          finally { if (e_1) throw e_1.error; }
      }
      return temp;
  }

  function getKeyPrefix(options, defaultConfig) {
      return (options.name || defaultConfig.name) + "/" + (options.storeName || defaultConfig.storeName) + "/";
  }

  function executeCallback$2(promise, callback) {
      if (callback) {
          promise.then(function (result) {
              callback(null, result);
          }, function (error) {
              callback(error);
          });
      }
  }

  function getCallback$1() {
      if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
          return arguments[arguments.length - 1];
      }
  }

  //tslint:disable-next-line:no-ignored-initial-value
  function dropInstanceCommon(options, callback) {
      var _this = this;
      callback = getCallback$1.apply(this, arguments);
      options = (typeof options !== 'function' && options) || {};
      if (!options.name) {
          var currentConfig = this.config();
          options.name = options.name || currentConfig.name;
          options.storeName = options.storeName || currentConfig.storeName;
      }
      var promise;
      if (!options.name) {
          promise = Promise.reject('Invalid arguments');
      }
      else {
          promise = new Promise(function (resolve) {
              if (!options.storeName) {
                  resolve(options.name + "/");
              }
              else {
                  resolve(getKeyPrefix(options, _this._defaultConfig));
              }
          });
      }
      return { promise: promise, callback: callback };
  }

  function normaliseKey(key) {
      // Cast the key to a string, as that's all we can set as a key.
      if (typeof key !== 'string') {
          console.warn(key + " used as a key, but it is not a string.");
          key = String(key);
      }
      return key;
  }

  var serialiser = {
      bufferToString: bufferToString$1,
      deserialize: deserialize$2,
      serialize: serialize$2,
      stringToBuffer: stringToBuffer$1
  };

  /*!
  MIT License

  Copyright (c) 2018 Arturas Molcanovas <a.molcanovas@gmail.com>

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.

  */


  var _driver = 'localforage-driver-memory';

  var stores = {};
  /** @internal */
  var Store = /** @class */ (function () {
      function Store(kp) {
          this.kp = kp;
          this.data = {};
      }
      Store.resolve = function (kp) {
          if (!stores[kp]) {
              stores[kp] = new Store(kp);
          }
          return stores[kp];
      };
      Store.prototype.clear = function () {
          this.data = {};
      };
      Store.prototype.drop = function () {
          this.clear();
          delete stores[this.kp];
      };
      Store.prototype.get = function (key) {
          return this.data[key];
      };
      Store.prototype.key = function (idx) {
          return this.keys()[idx];
      };
      Store.prototype.keys = function () {
          return Object.keys(this.data);
      };
      Store.prototype.rm = function (k) {
          delete this.data[k];
      };
      Store.prototype.set = function (k, v) {
          this.data[k] = v;
      };
      return Store;
  }());

  function _initStorage$1(options) {
      var opts = options ? clone$1(options) : {};
      var kp = getKeyPrefix(opts, this._defaultConfig);
      var store = Store.resolve(kp);
      this._dbInfo = opts;
      this._dbInfo.serializer = serialiser;
      this._dbInfo.keyPrefix = kp;
      this._dbInfo.mStore = store;
      return Promise.resolve();
  }

  function clear$1(callback) {
      var _this = this;
      var promise = this.ready().then(function () {
          _this._dbInfo.mStore.clear();
      });
      executeCallback$2(promise, callback);
      return promise;
  }

  function dropInstance$1(_options, _cb) {
      var _a = dropInstanceCommon.apply(this, arguments), promise = _a.promise, callback = _a.callback;
      var outPromise = promise.then(function (keyPrefix) {
          Store.resolve(keyPrefix).drop();
      });
      executeCallback$2(outPromise, callback);
      return promise;
  }

  function getItem$1(key$, callback) {
      var _this = this;
      key$ = normaliseKey(key$);
      var promise = this.ready().then(function () {
          var result = _this._dbInfo.mStore.get(key$);
          // Deserialise if the result is not null or undefined
          return result == null ? null : _this._dbInfo.serializer.deserialize(result); //tslint:disable-line:triple-equals
      });
      executeCallback$2(promise, callback);
      return promise;
  }

  function iterate$1(iterator, callback) {
      var _this = this;
      var promise = this.ready().then(function () {
          var store = _this._dbInfo.mStore;
          var keys = store.keys();
          for (var i = 0; i < keys.length; i++) {
              var value = store.get(keys[i]);
              // If a result was found, parse it from the serialized
              // string into a JS object. If result isn't truthy, the
              // key is likely undefined and we'll pass it straight
              // to the iterator.
              if (value) {
                  value = _this._dbInfo.serializer.deserialize(value);
              }
              value = iterator(value, keys[i], i + 1);
              if (value !== undefined) {
                  return value;
              }
          }
      });
      executeCallback$2(promise, callback);
      return promise;
  }

  function key$1(idx, callback) {
      var _this = this;
      var promise = this.ready().then(function () {
          var result;
          try {
              result = _this._dbInfo.mStore.key(idx);
              if (result === undefined) {
                  result = null;
              }
          }
          catch (_a) {
              result = null;
          }
          return result;
      });
      executeCallback$2(promise, callback);
      return promise;
  }

  function keys$1(callback) {
      var _this = this;
      var promise = this.ready().then(function () {
          return _this._dbInfo.mStore.keys();
      });
      executeCallback$2(promise, callback);
      return promise;
  }

  function length$1(callback) {
      var promise = this.keys().then(function (keys$) { return keys$.length; });
      executeCallback$2(promise, callback);
      return promise;
  }

  function removeItem$1(key$, callback) {
      var _this = this;
      key$ = normaliseKey(key$);
      var promise = this.ready().then(function () {
          _this._dbInfo.mStore.rm(key$);
      });
      executeCallback$2(promise, callback);
      return promise;
  }

  function setItem$1(key$, value, callback) {
      var _this = this;
      key$ = normaliseKey(key$);
      var promise = this.ready().then(function () {
          if (value === undefined) {
              value = null;
          }
          // Save the original value to pass to the callback.
          var originalValue = value;
          return new Promise(function (resolve, reject) {
              _this._dbInfo.serializer.serialize(value, function (value$, error) {
                  if (error) {
                      reject(error);
                  }
                  else {
                      try {
                          _this._dbInfo.mStore.set(key$, value$);
                          resolve(originalValue);
                      }
                      catch (e) {
                          reject(e);
                      }
                  }
              });
          });
      });
      executeCallback$2(promise, callback);
      return promise;
  }

  var _support = true;

  var memoryDriver = /*#__PURE__*/Object.freeze({
    __proto__: null,
    _driver: _driver,
    _initStorage: _initStorage$1,
    _support: _support,
    clear: clear$1,
    dropInstance: dropInstance$1,
    getItem: getItem$1,
    iterate: iterate$1,
    key: key$1,
    keys: keys$1,
    length: length$1,
    removeItem: removeItem$1,
    setItem: setItem$1
  });

  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || (value !== value && other !== other);
  }

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }

  /** Used for built-in method references. */
  var arrayProto = Array.prototype;

  /** Built-in value references. */
  var splice = arrayProto.splice;

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    return index < 0 ? undefined : data[index][1];
  }

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;

  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */
  function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
  }

  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function stackDelete(key) {
    var data = this.__data__,
        result = data['delete'](key);

    this.size = data.size;
    return result;
  }

  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function stackGet(key) {
    return this.__data__.get(key);
  }

  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function stackHas(key) {
    return this.__data__.has(key);
  }

  /* Built-in method references that are verified to be native. */
  var nativeCreate = getNative(Object, 'create');

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }

  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

  /** Used for built-in method references. */
  var objectProto$d = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$b = objectProto$d.hasOwnProperty;

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED$2 ? undefined : result;
    }
    return hasOwnProperty$b.call(data, key) ? data[key] : undefined;
  }

  /** Used for built-in method references. */
  var objectProto$c = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$a = objectProto$c.hasOwnProperty;

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? (data[key] !== undefined) : hasOwnProperty$a.call(data, key);
  }

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
    return this;
  }

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash,
      'map': new (Map || ListCache),
      'string': new Hash
    };
  }

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = typeof value;
    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
      ? (value !== '__proto__')
      : (value === null);
  }

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key)
      ? data[typeof key == 'string' ? 'string' : 'hash']
      : data.map;
  }

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
        size = data.size;

    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
      var pairs = data.__data__;
      if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }

  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }

  // Add methods to `Stack`.
  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  var defineProperty = (function() {
    try {
      var func = getNative(Object, 'defineProperty');
      func({}, '', {});
      return func;
    } catch (e) {}
  }());

  /**
   * The base implementation of `assignValue` and `assignMergeValue` without
   * value checks.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) {
      defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
      });
    } else {
      object[key] = value;
    }
  }

  /** Used for built-in method references. */
  var objectProto$b = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty$9.call(object, key) && eq(objValue, value)) ||
        (value === undefined && !(key in object))) {
      baseAssignValue(object, key, value);
    }
  }

  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */
  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});

    var index = -1,
        length = props.length;

    while (++index < length) {
      var key = props[index];

      var newValue = undefined;

      if (newValue === undefined) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }
    return object;
  }

  /**
   * The base implementation of `_.assign` without support for multiple sources
   * or `customizer` functions.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @returns {Object} Returns `object`.
   */
  function baseAssign(object, source) {
    return object && copyObject(source, keys$2(source), object);
  }

  /**
   * This function is like
   * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * except that it includes inherited enumerable properties.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }

  /** Used for built-in method references. */
  var objectProto$a = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

  /**
   * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeysIn(object) {
    if (!isObject$1(object)) {
      return nativeKeysIn(object);
    }
    var isProto = isPrototype(object),
        result = [];

    for (var key in object) {
      if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * Creates an array of the own and inherited enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keysIn(new Foo);
   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
   */
  function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
  }

  /**
   * The base implementation of `_.assignIn` without support for multiple sources
   * or `customizer` functions.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @returns {Object} Returns `object`.
   */
  function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
  }

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? root$1.Buffer : undefined,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

    buffer.copy(result);
    return result;
  }

  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */
  function copyArray(source, array) {
    var index = -1,
        length = source.length;

    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */
  function stubArray() {
    return [];
  }

  /** Used for built-in method references. */
  var objectProto$9 = Object.prototype;

  /** Built-in value references. */
  var propertyIsEnumerable = objectProto$9.propertyIsEnumerable;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

  /**
   * Creates an array of the own enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */
  var getSymbols = !nativeGetSymbols$1 ? stubArray : function(object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
      return propertyIsEnumerable.call(object, symbol);
    });
  };

  /**
   * Copies own symbols of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy symbols from.
   * @param {Object} [object={}] The object to copy symbols to.
   * @returns {Object} Returns `object`.
   */
  function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /** Built-in value references. */
  var getPrototype = overArg(Object.getPrototypeOf, Object);

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeGetSymbols = Object.getOwnPropertySymbols;

  /**
   * Creates an array of the own and inherited enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */
  var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while (object) {
      arrayPush(result, getSymbols(object));
      object = getPrototype(object);
    }
    return result;
  };

  /**
   * Copies own and inherited symbols of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy symbols from.
   * @param {Object} [object={}] The object to copy symbols to.
   * @returns {Object} Returns `object`.
   */
  function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
  }

  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }

  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function getAllKeys(object) {
    return baseGetAllKeys(object, keys$2, getSymbols);
  }

  /**
   * Creates an array of own and inherited enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
  }

  /** Used for built-in method references. */
  var objectProto$8 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

  /**
   * Initializes an array clone.
   *
   * @private
   * @param {Array} array The array to clone.
   * @returns {Array} Returns the initialized clone.
   */
  function initCloneArray(array) {
    var length = array.length,
        result = new array.constructor(length);

    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty$7.call(array, 'index')) {
      result.index = array.index;
      result.input = array.input;
    }
    return result;
  }

  /** Built-in value references. */
  var Uint8Array$1 = root$1.Uint8Array;

  /**
   * Creates a clone of `arrayBuffer`.
   *
   * @private
   * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
   * @returns {ArrayBuffer} Returns the cloned array buffer.
   */
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
    return result;
  }

  /**
   * Creates a clone of `dataView`.
   *
   * @private
   * @param {Object} dataView The data view to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned data view.
   */
  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /**
   * Creates a clone of `regexp`.
   *
   * @private
   * @param {Object} regexp The regexp to clone.
   * @returns {Object} Returns the cloned regexp.
   */
  function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
  }

  /** Used to convert symbols to primitives and strings. */
  var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : undefined,
      symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : undefined;

  /**
   * Creates a clone of the `symbol` object.
   *
   * @private
   * @param {Object} symbol The symbol object to clone.
   * @returns {Object} Returns the cloned symbol object.
   */
  function cloneSymbol(symbol) {
    return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
  }

  /**
   * Creates a clone of `typedArray`.
   *
   * @private
   * @param {Object} typedArray The typed array to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned typed array.
   */
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }

  /** `Object#toString` result references. */
  var boolTag$2 = '[object Boolean]',
      dateTag$2 = '[object Date]',
      mapTag$3 = '[object Map]',
      numberTag$2 = '[object Number]',
      regexpTag$2 = '[object RegExp]',
      setTag$3 = '[object Set]',
      stringTag$3 = '[object String]',
      symbolTag$2 = '[object Symbol]';

  var arrayBufferTag$2 = '[object ArrayBuffer]',
      dataViewTag$2 = '[object DataView]',
      float32Tag$1 = '[object Float32Array]',
      float64Tag$1 = '[object Float64Array]',
      int8Tag$1 = '[object Int8Array]',
      int16Tag$1 = '[object Int16Array]',
      int32Tag$1 = '[object Int32Array]',
      uint8Tag$1 = '[object Uint8Array]',
      uint8ClampedTag$1 = '[object Uint8ClampedArray]',
      uint16Tag$1 = '[object Uint16Array]',
      uint32Tag$1 = '[object Uint32Array]';

  /**
   * Initializes an object clone based on its `toStringTag`.
   *
   * **Note:** This function only supports cloning values with tags of
   * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {string} tag The `toStringTag` of the object to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the initialized clone.
   */
  function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
      case arrayBufferTag$2:
        return cloneArrayBuffer(object);

      case boolTag$2:
      case dateTag$2:
        return new Ctor(+object);

      case dataViewTag$2:
        return cloneDataView(object, isDeep);

      case float32Tag$1: case float64Tag$1:
      case int8Tag$1: case int16Tag$1: case int32Tag$1:
      case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
        return cloneTypedArray(object, isDeep);

      case mapTag$3:
        return new Ctor;

      case numberTag$2:
      case stringTag$3:
        return new Ctor(object);

      case regexpTag$2:
        return cloneRegExp(object);

      case setTag$3:
        return new Ctor;

      case symbolTag$2:
        return cloneSymbol(object);
    }
  }

  /** Built-in value references. */
  var objectCreate = Object.create;

  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} proto The object to inherit from.
   * @returns {Object} Returns the new object.
   */
  var baseCreate = (function() {
    function object() {}
    return function(proto) {
      if (!isObject$1(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result = new object;
      object.prototype = undefined;
      return result;
    };
  }());

  /**
   * Initializes an object clone.
   *
   * @private
   * @param {Object} object The object to clone.
   * @returns {Object} Returns the initialized clone.
   */
  function initCloneObject(object) {
    return (typeof object.constructor == 'function' && !isPrototype(object))
      ? baseCreate(getPrototype(object))
      : {};
  }

  /** `Object#toString` result references. */
  var mapTag$2 = '[object Map]';

  /**
   * The base implementation of `_.isMap` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a map, else `false`.
   */
  function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag$2;
  }

  /* Node.js helper references. */
  var nodeIsMap = nodeUtil && nodeUtil.isMap;

  /**
   * Checks if `value` is classified as a `Map` object.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a map, else `false`.
   * @example
   *
   * _.isMap(new Map);
   * // => true
   *
   * _.isMap(new WeakMap);
   * // => false
   */
  var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

  /** `Object#toString` result references. */
  var setTag$2 = '[object Set]';

  /**
   * The base implementation of `_.isSet` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a set, else `false`.
   */
  function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag$2;
  }

  /* Node.js helper references. */
  var nodeIsSet = nodeUtil && nodeUtil.isSet;

  /**
   * Checks if `value` is classified as a `Set` object.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a set, else `false`.
   * @example
   *
   * _.isSet(new Set);
   * // => true
   *
   * _.isSet(new WeakSet);
   * // => false
   */
  var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG$3 = 1,
      CLONE_FLAT_FLAG$1 = 2,
      CLONE_SYMBOLS_FLAG$3 = 4;

  /** `Object#toString` result references. */
  var argsTag$1 = '[object Arguments]',
      arrayTag$1 = '[object Array]',
      boolTag$1 = '[object Boolean]',
      dateTag$1 = '[object Date]',
      errorTag$1 = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag$1 = '[object Map]',
      numberTag$1 = '[object Number]',
      objectTag$2 = '[object Object]',
      regexpTag$1 = '[object RegExp]',
      setTag$1 = '[object Set]',
      stringTag$2 = '[object String]',
      symbolTag$1 = '[object Symbol]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag$1 = '[object ArrayBuffer]',
      dataViewTag$1 = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] =
  cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] =
  cloneableTags[boolTag$1] = cloneableTags[dateTag$1] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag$1] =
  cloneableTags[numberTag$1] = cloneableTags[objectTag$2] =
  cloneableTags[regexpTag$1] = cloneableTags[setTag$1] =
  cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag$1] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /**
   * The base implementation of `_.clone` and `_.cloneDeep` which tracks
   * traversed objects.
   *
   * @private
   * @param {*} value The value to clone.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Deep clone
   *  2 - Flatten inherited properties
   *  4 - Clone symbols
   * @param {Function} [customizer] The function to customize cloning.
   * @param {string} [key] The key of `value`.
   * @param {Object} [object] The parent object of `value`.
   * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
   * @returns {*} Returns the cloned value.
   */
  function baseClone(value, bitmask, customizer, key, object, stack) {
    var result,
        isDeep = bitmask & CLONE_DEEP_FLAG$3,
        isFlat = bitmask & CLONE_FLAT_FLAG$1,
        isFull = bitmask & CLONE_SYMBOLS_FLAG$3;

    if (customizer) {
      result = object ? customizer(value, key, object, stack) : customizer(value);
    }
    if (result !== undefined) {
      return result;
    }
    if (!isObject$1(value)) {
      return value;
    }
    var isArr = isArray(value);
    if (isArr) {
      result = initCloneArray(value);
      if (!isDeep) {
        return copyArray(value, result);
      }
    } else {
      var tag = getTag(value),
          isFunc = tag == funcTag || tag == genTag;

      if (isBuffer(value)) {
        return cloneBuffer(value, isDeep);
      }
      if (tag == objectTag$2 || tag == argsTag$1 || (isFunc && !object)) {
        result = (isFlat || isFunc) ? {} : initCloneObject(value);
        if (!isDeep) {
          return isFlat
            ? copySymbolsIn(value, baseAssignIn(result, value))
            : copySymbols(value, baseAssign(result, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value : {};
        }
        result = initCloneByTag(value, tag, isDeep);
      }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) {
      return stacked;
    }
    stack.set(value, result);

    if (isSet(value)) {
      value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
      });
    } else if (isMap(value)) {
      value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
    }

    var keysFunc = isFull
      ? (isFlat ? getAllKeysIn : getAllKeys)
      : (isFlat ? keysIn : keys$2);

    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
      if (props) {
        key = subValue;
        subValue = value[key];
      }
      // Recursively populate clone (susceptible to call stack limits).
      assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
  }

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG$2 = 1,
      CLONE_SYMBOLS_FLAG$2 = 4;

  /**
   * This method is like `_.clone` except that it recursively clones `value`.
   *
   * @static
   * @memberOf _
   * @since 1.0.0
   * @category Lang
   * @param {*} value The value to recursively clone.
   * @returns {*} Returns the deep cloned value.
   * @see _.clone
   * @example
   *
   * var objects = [{ 'a': 1 }, { 'b': 2 }];
   *
   * var deep = _.cloneDeep(objects);
   * console.log(deep[0] === objects[0]);
   * // => false
   */
  function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG$2 | CLONE_SYMBOLS_FLAG$2);
  }

  /** `Object#toString` result references. */
  var stringTag$1 = '[object String]';

  /**
   * Checks if `value` is classified as a `String` primitive or object.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a string, else `false`.
   * @example
   *
   * _.isString('abc');
   * // => true
   *
   * _.isString(1);
   * // => false
   */
  function isString(value) {
    return typeof value == 'string' ||
      (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag$1);
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

  function getDefaultExportFromCjs (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function commonjsRequire(path) {
  	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
  }

  var localforage = {exports: {}};

  /*!
      localForage -- Offline Storage, Improved
      Version 1.10.0
      https://localforage.github.io/localForage
      (c) 2013-2017 Mozilla, Apache License 2.0
  */

  var hasRequiredLocalforage;

  function requireLocalforage () {
  	if (hasRequiredLocalforage) return localforage.exports;
  	hasRequiredLocalforage = 1;
  	(function (module, exports) {
  		(function(f){{module.exports=f();}})(function(){return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof commonjsRequire=="function"&&commonjsRequire;if(!u&&a)return a(o,true);if(i)return i(o,true);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r);}return n[o].exports}var i=typeof commonjsRequire=="function"&&commonjsRequire;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
  		(function (global){
  		var Mutation = global.MutationObserver || global.WebKitMutationObserver;

  		var scheduleDrain;

  		{
  		  if (Mutation) {
  		    var called = 0;
  		    var observer = new Mutation(nextTick);
  		    var element = global.document.createTextNode('');
  		    observer.observe(element, {
  		      characterData: true
  		    });
  		    scheduleDrain = function () {
  		      element.data = (called = ++called % 2);
  		    };
  		  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
  		    var channel = new global.MessageChannel();
  		    channel.port1.onmessage = nextTick;
  		    scheduleDrain = function () {
  		      channel.port2.postMessage(0);
  		    };
  		  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
  		    scheduleDrain = function () {

  		      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
  		      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
  		      var scriptEl = global.document.createElement('script');
  		      scriptEl.onreadystatechange = function () {
  		        nextTick();

  		        scriptEl.onreadystatechange = null;
  		        scriptEl.parentNode.removeChild(scriptEl);
  		        scriptEl = null;
  		      };
  		      global.document.documentElement.appendChild(scriptEl);
  		    };
  		  } else {
  		    scheduleDrain = function () {
  		      setTimeout(nextTick, 0);
  		    };
  		  }
  		}

  		var draining;
  		var queue = [];
  		//named nextTick for less confusing stack traces
  		function nextTick() {
  		  draining = true;
  		  var i, oldQueue;
  		  var len = queue.length;
  		  while (len) {
  		    oldQueue = queue;
  		    queue = [];
  		    i = -1;
  		    while (++i < len) {
  		      oldQueue[i]();
  		    }
  		    len = queue.length;
  		  }
  		  draining = false;
  		}

  		module.exports = immediate;
  		function immediate(task) {
  		  if (queue.push(task) === 1 && !draining) {
  		    scheduleDrain();
  		  }
  		}

  		}).call(this,typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
  		},{}],2:[function(_dereq_,module,exports){
  		var immediate = _dereq_(1);

  		/* istanbul ignore next */
  		function INTERNAL() {}

  		var handlers = {};

  		var REJECTED = ['REJECTED'];
  		var FULFILLED = ['FULFILLED'];
  		var PENDING = ['PENDING'];

  		module.exports = Promise;

  		function Promise(resolver) {
  		  if (typeof resolver !== 'function') {
  		    throw new TypeError('resolver must be a function');
  		  }
  		  this.state = PENDING;
  		  this.queue = [];
  		  this.outcome = void 0;
  		  if (resolver !== INTERNAL) {
  		    safelyResolveThenable(this, resolver);
  		  }
  		}

  		Promise.prototype["catch"] = function (onRejected) {
  		  return this.then(null, onRejected);
  		};
  		Promise.prototype.then = function (onFulfilled, onRejected) {
  		  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
  		    typeof onRejected !== 'function' && this.state === REJECTED) {
  		    return this;
  		  }
  		  var promise = new this.constructor(INTERNAL);
  		  if (this.state !== PENDING) {
  		    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
  		    unwrap(promise, resolver, this.outcome);
  		  } else {
  		    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  		  }

  		  return promise;
  		};
  		function QueueItem(promise, onFulfilled, onRejected) {
  		  this.promise = promise;
  		  if (typeof onFulfilled === 'function') {
  		    this.onFulfilled = onFulfilled;
  		    this.callFulfilled = this.otherCallFulfilled;
  		  }
  		  if (typeof onRejected === 'function') {
  		    this.onRejected = onRejected;
  		    this.callRejected = this.otherCallRejected;
  		  }
  		}
  		QueueItem.prototype.callFulfilled = function (value) {
  		  handlers.resolve(this.promise, value);
  		};
  		QueueItem.prototype.otherCallFulfilled = function (value) {
  		  unwrap(this.promise, this.onFulfilled, value);
  		};
  		QueueItem.prototype.callRejected = function (value) {
  		  handlers.reject(this.promise, value);
  		};
  		QueueItem.prototype.otherCallRejected = function (value) {
  		  unwrap(this.promise, this.onRejected, value);
  		};

  		function unwrap(promise, func, value) {
  		  immediate(function () {
  		    var returnValue;
  		    try {
  		      returnValue = func(value);
  		    } catch (e) {
  		      return handlers.reject(promise, e);
  		    }
  		    if (returnValue === promise) {
  		      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
  		    } else {
  		      handlers.resolve(promise, returnValue);
  		    }
  		  });
  		}

  		handlers.resolve = function (self, value) {
  		  var result = tryCatch(getThen, value);
  		  if (result.status === 'error') {
  		    return handlers.reject(self, result.value);
  		  }
  		  var thenable = result.value;

  		  if (thenable) {
  		    safelyResolveThenable(self, thenable);
  		  } else {
  		    self.state = FULFILLED;
  		    self.outcome = value;
  		    var i = -1;
  		    var len = self.queue.length;
  		    while (++i < len) {
  		      self.queue[i].callFulfilled(value);
  		    }
  		  }
  		  return self;
  		};
  		handlers.reject = function (self, error) {
  		  self.state = REJECTED;
  		  self.outcome = error;
  		  var i = -1;
  		  var len = self.queue.length;
  		  while (++i < len) {
  		    self.queue[i].callRejected(error);
  		  }
  		  return self;
  		};

  		function getThen(obj) {
  		  // Make sure we only access the accessor once as required by the spec
  		  var then = obj && obj.then;
  		  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
  		    return function appyThen() {
  		      then.apply(obj, arguments);
  		    };
  		  }
  		}

  		function safelyResolveThenable(self, thenable) {
  		  // Either fulfill, reject or reject with error
  		  var called = false;
  		  function onError(value) {
  		    if (called) {
  		      return;
  		    }
  		    called = true;
  		    handlers.reject(self, value);
  		  }

  		  function onSuccess(value) {
  		    if (called) {
  		      return;
  		    }
  		    called = true;
  		    handlers.resolve(self, value);
  		  }

  		  function tryToUnwrap() {
  		    thenable(onSuccess, onError);
  		  }

  		  var result = tryCatch(tryToUnwrap);
  		  if (result.status === 'error') {
  		    onError(result.value);
  		  }
  		}

  		function tryCatch(func, value) {
  		  var out = {};
  		  try {
  		    out.value = func(value);
  		    out.status = 'success';
  		  } catch (e) {
  		    out.status = 'error';
  		    out.value = e;
  		  }
  		  return out;
  		}

  		Promise.resolve = resolve;
  		function resolve(value) {
  		  if (value instanceof this) {
  		    return value;
  		  }
  		  return handlers.resolve(new this(INTERNAL), value);
  		}

  		Promise.reject = reject;
  		function reject(reason) {
  		  var promise = new this(INTERNAL);
  		  return handlers.reject(promise, reason);
  		}

  		Promise.all = all;
  		function all(iterable) {
  		  var self = this;
  		  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
  		    return this.reject(new TypeError('must be an array'));
  		  }

  		  var len = iterable.length;
  		  var called = false;
  		  if (!len) {
  		    return this.resolve([]);
  		  }

  		  var values = new Array(len);
  		  var resolved = 0;
  		  var i = -1;
  		  var promise = new this(INTERNAL);

  		  while (++i < len) {
  		    allResolver(iterable[i], i);
  		  }
  		  return promise;
  		  function allResolver(value, i) {
  		    self.resolve(value).then(resolveFromAll, function (error) {
  		      if (!called) {
  		        called = true;
  		        handlers.reject(promise, error);
  		      }
  		    });
  		    function resolveFromAll(outValue) {
  		      values[i] = outValue;
  		      if (++resolved === len && !called) {
  		        called = true;
  		        handlers.resolve(promise, values);
  		      }
  		    }
  		  }
  		}

  		Promise.race = race;
  		function race(iterable) {
  		  var self = this;
  		  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
  		    return this.reject(new TypeError('must be an array'));
  		  }

  		  var len = iterable.length;
  		  var called = false;
  		  if (!len) {
  		    return this.resolve([]);
  		  }

  		  var i = -1;
  		  var promise = new this(INTERNAL);

  		  while (++i < len) {
  		    resolver(iterable[i]);
  		  }
  		  return promise;
  		  function resolver(value) {
  		    self.resolve(value).then(function (response) {
  		      if (!called) {
  		        called = true;
  		        handlers.resolve(promise, response);
  		      }
  		    }, function (error) {
  		      if (!called) {
  		        called = true;
  		        handlers.reject(promise, error);
  		      }
  		    });
  		  }
  		}

  		},{"1":1}],3:[function(_dereq_,module,exports){
  		(function (global){
  		if (typeof global.Promise !== 'function') {
  		  global.Promise = _dereq_(2);
  		}

  		}).call(this,typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
  		},{"2":2}],4:[function(_dereq_,module,exports){

  		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  		function getIDB() {
  		    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
  		    try {
  		        if (typeof indexedDB !== 'undefined') {
  		            return indexedDB;
  		        }
  		        if (typeof webkitIndexedDB !== 'undefined') {
  		            return webkitIndexedDB;
  		        }
  		        if (typeof mozIndexedDB !== 'undefined') {
  		            return mozIndexedDB;
  		        }
  		        if (typeof OIndexedDB !== 'undefined') {
  		            return OIndexedDB;
  		        }
  		        if (typeof msIndexedDB !== 'undefined') {
  		            return msIndexedDB;
  		        }
  		    } catch (e) {
  		        return;
  		    }
  		}

  		var idb = getIDB();

  		function isIndexedDBValid() {
  		    try {
  		        // Initialize IndexedDB; fall back to vendor-prefixed versions
  		        // if needed.
  		        if (!idb || !idb.open) {
  		            return false;
  		        }
  		        // We mimic PouchDB here;
  		        //
  		        // We test for openDatabase because IE Mobile identifies itself
  		        // as Safari. Oh the lulz...
  		        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

  		        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

  		        // Safari <10.1 does not meet our requirements for IDB support
  		        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
  		        // Safari 10.1 shipped with fetch, we can use that to detect it.
  		        // Note: this creates issues with `window.fetch` polyfills and
  		        // overrides; see:
  		        // https://github.com/localForage/localForage/issues/856
  		        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
  		        // some outdated implementations of IDB that appear on Samsung
  		        // and HTC Android devices <4.4 are missing IDBKeyRange
  		        // See: https://github.com/mozilla/localForage/issues/128
  		        // See: https://github.com/mozilla/localForage/issues/272
  		        typeof IDBKeyRange !== 'undefined';
  		    } catch (e) {
  		        return false;
  		    }
  		}

  		// Abstracts constructing a Blob object, so it also works in older
  		// browsers that don't support the native Blob constructor. (i.e.
  		// old QtWebKit versions, at least).
  		// Abstracts constructing a Blob object, so it also works in older
  		// browsers that don't support the native Blob constructor. (i.e.
  		// old QtWebKit versions, at least).
  		function createBlob(parts, properties) {
  		    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
  		    parts = parts || [];
  		    properties = properties || {};
  		    try {
  		        return new Blob(parts, properties);
  		    } catch (e) {
  		        if (e.name !== 'TypeError') {
  		            throw e;
  		        }
  		        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
  		        var builder = new Builder();
  		        for (var i = 0; i < parts.length; i += 1) {
  		            builder.append(parts[i]);
  		        }
  		        return builder.getBlob(properties.type);
  		    }
  		}

  		// This is CommonJS because lie is an external dependency, so Rollup
  		// can just ignore it.
  		if (typeof Promise === 'undefined') {
  		    // In the "nopromises" build this will just throw if you don't have
  		    // a global promise object, but it would throw anyway later.
  		    _dereq_(3);
  		}
  		var Promise$1 = Promise;

  		function executeCallback(promise, callback) {
  		    if (callback) {
  		        promise.then(function (result) {
  		            callback(null, result);
  		        }, function (error) {
  		            callback(error);
  		        });
  		    }
  		}

  		function executeTwoCallbacks(promise, callback, errorCallback) {
  		    if (typeof callback === 'function') {
  		        promise.then(callback);
  		    }

  		    if (typeof errorCallback === 'function') {
  		        promise["catch"](errorCallback);
  		    }
  		}

  		function normalizeKey(key) {
  		    // Cast the key to a string, as that's all we can set as a key.
  		    if (typeof key !== 'string') {
  		        console.warn(key + ' used as a key, but it is not a string.');
  		        key = String(key);
  		    }

  		    return key;
  		}

  		function getCallback() {
  		    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
  		        return arguments[arguments.length - 1];
  		    }
  		}

  		// Some code originally from async_storage.js in
  		// [Gaia](https://github.com/mozilla-b2g/gaia).

  		var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
  		var supportsBlobs = void 0;
  		var dbContexts = {};
  		var toString = Object.prototype.toString;

  		// Transaction Modes
  		var READ_ONLY = 'readonly';
  		var READ_WRITE = 'readwrite';

  		// Transform a binary string to an array buffer, because otherwise
  		// weird stuff happens when you try to work with the binary string directly.
  		// It is known.
  		// From http://stackoverflow.com/questions/14967647/ (continues on next line)
  		// encode-decode-image-with-base64-breaks-image (2013-04-21)
  		function _binStringToArrayBuffer(bin) {
  		    var length = bin.length;
  		    var buf = new ArrayBuffer(length);
  		    var arr = new Uint8Array(buf);
  		    for (var i = 0; i < length; i++) {
  		        arr[i] = bin.charCodeAt(i);
  		    }
  		    return buf;
  		}

  		//
  		// Blobs are not supported in all versions of IndexedDB, notably
  		// Chrome <37 and Android <5. In those versions, storing a blob will throw.
  		//
  		// Various other blob bugs exist in Chrome v37-42 (inclusive).
  		// Detecting them is expensive and confusing to users, and Chrome 37-42
  		// is at very low usage worldwide, so we do a hacky userAgent check instead.
  		//
  		// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
  		// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
  		// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
  		//
  		// Code borrowed from PouchDB. See:
  		// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
  		//
  		function _checkBlobSupportWithoutCaching(idb) {
  		    return new Promise$1(function (resolve) {
  		        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
  		        var blob = createBlob(['']);
  		        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

  		        txn.onabort = function (e) {
  		            // If the transaction aborts now its due to not being able to
  		            // write to the database, likely due to the disk being full
  		            e.preventDefault();
  		            e.stopPropagation();
  		            resolve(false);
  		        };

  		        txn.oncomplete = function () {
  		            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
  		            var matchedEdge = navigator.userAgent.match(/Edge\//);
  		            // MS Edge pretends to be Chrome 42:
  		            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
  		            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
  		        };
  		    })["catch"](function () {
  		        return false; // error, so assume unsupported
  		    });
  		}

  		function _checkBlobSupport(idb) {
  		    if (typeof supportsBlobs === 'boolean') {
  		        return Promise$1.resolve(supportsBlobs);
  		    }
  		    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
  		        supportsBlobs = value;
  		        return supportsBlobs;
  		    });
  		}

  		function _deferReadiness(dbInfo) {
  		    var dbContext = dbContexts[dbInfo.name];

  		    // Create a deferred object representing the current database operation.
  		    var deferredOperation = {};

  		    deferredOperation.promise = new Promise$1(function (resolve, reject) {
  		        deferredOperation.resolve = resolve;
  		        deferredOperation.reject = reject;
  		    });

  		    // Enqueue the deferred operation.
  		    dbContext.deferredOperations.push(deferredOperation);

  		    // Chain its promise to the database readiness.
  		    if (!dbContext.dbReady) {
  		        dbContext.dbReady = deferredOperation.promise;
  		    } else {
  		        dbContext.dbReady = dbContext.dbReady.then(function () {
  		            return deferredOperation.promise;
  		        });
  		    }
  		}

  		function _advanceReadiness(dbInfo) {
  		    var dbContext = dbContexts[dbInfo.name];

  		    // Dequeue a deferred operation.
  		    var deferredOperation = dbContext.deferredOperations.pop();

  		    // Resolve its promise (which is part of the database readiness
  		    // chain of promises).
  		    if (deferredOperation) {
  		        deferredOperation.resolve();
  		        return deferredOperation.promise;
  		    }
  		}

  		function _rejectReadiness(dbInfo, err) {
  		    var dbContext = dbContexts[dbInfo.name];

  		    // Dequeue a deferred operation.
  		    var deferredOperation = dbContext.deferredOperations.pop();

  		    // Reject its promise (which is part of the database readiness
  		    // chain of promises).
  		    if (deferredOperation) {
  		        deferredOperation.reject(err);
  		        return deferredOperation.promise;
  		    }
  		}

  		function _getConnection(dbInfo, upgradeNeeded) {
  		    return new Promise$1(function (resolve, reject) {
  		        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

  		        if (dbInfo.db) {
  		            if (upgradeNeeded) {
  		                _deferReadiness(dbInfo);
  		                dbInfo.db.close();
  		            } else {
  		                return resolve(dbInfo.db);
  		            }
  		        }

  		        var dbArgs = [dbInfo.name];

  		        if (upgradeNeeded) {
  		            dbArgs.push(dbInfo.version);
  		        }

  		        var openreq = idb.open.apply(idb, dbArgs);

  		        if (upgradeNeeded) {
  		            openreq.onupgradeneeded = function (e) {
  		                var db = openreq.result;
  		                try {
  		                    db.createObjectStore(dbInfo.storeName);
  		                    if (e.oldVersion <= 1) {
  		                        // Added when support for blob shims was added
  		                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
  		                    }
  		                } catch (ex) {
  		                    if (ex.name === 'ConstraintError') {
  		                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
  		                    } else {
  		                        throw ex;
  		                    }
  		                }
  		            };
  		        }

  		        openreq.onerror = function (e) {
  		            e.preventDefault();
  		            reject(openreq.error);
  		        };

  		        openreq.onsuccess = function () {
  		            var db = openreq.result;
  		            db.onversionchange = function (e) {
  		                // Triggered when the database is modified (e.g. adding an objectStore) or
  		                // deleted (even when initiated by other sessions in different tabs).
  		                // Closing the connection here prevents those operations from being blocked.
  		                // If the database is accessed again later by this instance, the connection
  		                // will be reopened or the database recreated as needed.
  		                e.target.close();
  		            };
  		            resolve(db);
  		            _advanceReadiness(dbInfo);
  		        };
  		    });
  		}

  		function _getOriginalConnection(dbInfo) {
  		    return _getConnection(dbInfo, false);
  		}

  		function _getUpgradedConnection(dbInfo) {
  		    return _getConnection(dbInfo, true);
  		}

  		function _isUpgradeNeeded(dbInfo, defaultVersion) {
  		    if (!dbInfo.db) {
  		        return true;
  		    }

  		    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
  		    var isDowngrade = dbInfo.version < dbInfo.db.version;
  		    var isUpgrade = dbInfo.version > dbInfo.db.version;

  		    if (isDowngrade) {
  		        // If the version is not the default one
  		        // then warn for impossible downgrade.
  		        if (dbInfo.version !== defaultVersion) {
  		            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
  		        }
  		        // Align the versions to prevent errors.
  		        dbInfo.version = dbInfo.db.version;
  		    }

  		    if (isUpgrade || isNewStore) {
  		        // If the store is new then increment the version (if needed).
  		        // This will trigger an "upgradeneeded" event which is required
  		        // for creating a store.
  		        if (isNewStore) {
  		            var incVersion = dbInfo.db.version + 1;
  		            if (incVersion > dbInfo.version) {
  		                dbInfo.version = incVersion;
  		            }
  		        }

  		        return true;
  		    }

  		    return false;
  		}

  		// encode a blob for indexeddb engines that don't support blobs
  		function _encodeBlob(blob) {
  		    return new Promise$1(function (resolve, reject) {
  		        var reader = new FileReader();
  		        reader.onerror = reject;
  		        reader.onloadend = function (e) {
  		            var base64 = btoa(e.target.result || '');
  		            resolve({
  		                __local_forage_encoded_blob: true,
  		                data: base64,
  		                type: blob.type
  		            });
  		        };
  		        reader.readAsBinaryString(blob);
  		    });
  		}

  		// decode an encoded blob
  		function _decodeBlob(encodedBlob) {
  		    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
  		    return createBlob([arrayBuff], { type: encodedBlob.type });
  		}

  		// is this one of our fancy encoded blobs?
  		function _isEncodedBlob(value) {
  		    return value && value.__local_forage_encoded_blob;
  		}

  		// Specialize the default `ready()` function by making it dependent
  		// on the current database operations. Thus, the driver will be actually
  		// ready when it's been initialized (default) *and* there are no pending
  		// operations on the database (initiated by some other instances).
  		function _fullyReady(callback) {
  		    var self = this;

  		    var promise = self._initReady().then(function () {
  		        var dbContext = dbContexts[self._dbInfo.name];

  		        if (dbContext && dbContext.dbReady) {
  		            return dbContext.dbReady;
  		        }
  		    });

  		    executeTwoCallbacks(promise, callback, callback);
  		    return promise;
  		}

  		// Try to establish a new db connection to replace the
  		// current one which is broken (i.e. experiencing
  		// InvalidStateError while creating a transaction).
  		function _tryReconnect(dbInfo) {
  		    _deferReadiness(dbInfo);

  		    var dbContext = dbContexts[dbInfo.name];
  		    var forages = dbContext.forages;

  		    for (var i = 0; i < forages.length; i++) {
  		        var forage = forages[i];
  		        if (forage._dbInfo.db) {
  		            forage._dbInfo.db.close();
  		            forage._dbInfo.db = null;
  		        }
  		    }
  		    dbInfo.db = null;

  		    return _getOriginalConnection(dbInfo).then(function (db) {
  		        dbInfo.db = db;
  		        if (_isUpgradeNeeded(dbInfo)) {
  		            // Reopen the database for upgrading.
  		            return _getUpgradedConnection(dbInfo);
  		        }
  		        return db;
  		    }).then(function (db) {
  		        // store the latest db reference
  		        // in case the db was upgraded
  		        dbInfo.db = dbContext.db = db;
  		        for (var i = 0; i < forages.length; i++) {
  		            forages[i]._dbInfo.db = db;
  		        }
  		    })["catch"](function (err) {
  		        _rejectReadiness(dbInfo, err);
  		        throw err;
  		    });
  		}

  		// FF doesn't like Promises (micro-tasks) and IDDB store operations,
  		// so we have to do it with callbacks
  		function createTransaction(dbInfo, mode, callback, retries) {
  		    if (retries === undefined) {
  		        retries = 1;
  		    }

  		    try {
  		        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
  		        callback(null, tx);
  		    } catch (err) {
  		        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
  		            return Promise$1.resolve().then(function () {
  		                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
  		                    // increase the db version, to create the new ObjectStore
  		                    if (dbInfo.db) {
  		                        dbInfo.version = dbInfo.db.version + 1;
  		                    }
  		                    // Reopen the database for upgrading.
  		                    return _getUpgradedConnection(dbInfo);
  		                }
  		            }).then(function () {
  		                return _tryReconnect(dbInfo).then(function () {
  		                    createTransaction(dbInfo, mode, callback, retries - 1);
  		                });
  		            })["catch"](callback);
  		        }

  		        callback(err);
  		    }
  		}

  		function createDbContext() {
  		    return {
  		        // Running localForages sharing a database.
  		        forages: [],
  		        // Shared database.
  		        db: null,
  		        // Database readiness (promise).
  		        dbReady: null,
  		        // Deferred operations on the database.
  		        deferredOperations: []
  		    };
  		}

  		// Open the IndexedDB database (automatically creates one if one didn't
  		// previously exist), using any options set in the config.
  		function _initStorage(options) {
  		    var self = this;
  		    var dbInfo = {
  		        db: null
  		    };

  		    if (options) {
  		        for (var i in options) {
  		            dbInfo[i] = options[i];
  		        }
  		    }

  		    // Get the current context of the database;
  		    var dbContext = dbContexts[dbInfo.name];

  		    // ...or create a new context.
  		    if (!dbContext) {
  		        dbContext = createDbContext();
  		        // Register the new context in the global container.
  		        dbContexts[dbInfo.name] = dbContext;
  		    }

  		    // Register itself as a running localForage in the current context.
  		    dbContext.forages.push(self);

  		    // Replace the default `ready()` function with the specialized one.
  		    if (!self._initReady) {
  		        self._initReady = self.ready;
  		        self.ready = _fullyReady;
  		    }

  		    // Create an array of initialization states of the related localForages.
  		    var initPromises = [];

  		    function ignoreErrors() {
  		        // Don't handle errors here,
  		        // just makes sure related localForages aren't pending.
  		        return Promise$1.resolve();
  		    }

  		    for (var j = 0; j < dbContext.forages.length; j++) {
  		        var forage = dbContext.forages[j];
  		        if (forage !== self) {
  		            // Don't wait for itself...
  		            initPromises.push(forage._initReady()["catch"](ignoreErrors));
  		        }
  		    }

  		    // Take a snapshot of the related localForages.
  		    var forages = dbContext.forages.slice(0);

  		    // Initialize the connection process only when
  		    // all the related localForages aren't pending.
  		    return Promise$1.all(initPromises).then(function () {
  		        dbInfo.db = dbContext.db;
  		        // Get the connection or open a new one without upgrade.
  		        return _getOriginalConnection(dbInfo);
  		    }).then(function (db) {
  		        dbInfo.db = db;
  		        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
  		            // Reopen the database for upgrading.
  		            return _getUpgradedConnection(dbInfo);
  		        }
  		        return db;
  		    }).then(function (db) {
  		        dbInfo.db = dbContext.db = db;
  		        self._dbInfo = dbInfo;
  		        // Share the final connection amongst related localForages.
  		        for (var k = 0; k < forages.length; k++) {
  		            var forage = forages[k];
  		            if (forage !== self) {
  		                // Self is already up-to-date.
  		                forage._dbInfo.db = dbInfo.db;
  		                forage._dbInfo.version = dbInfo.version;
  		            }
  		        }
  		    });
  		}

  		function getItem(key, callback) {
  		    var self = this;

  		    key = normalizeKey(key);

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
  		                if (err) {
  		                    return reject(err);
  		                }

  		                try {
  		                    var store = transaction.objectStore(self._dbInfo.storeName);
  		                    var req = store.get(key);

  		                    req.onsuccess = function () {
  		                        var value = req.result;
  		                        if (value === undefined) {
  		                            value = null;
  		                        }
  		                        if (_isEncodedBlob(value)) {
  		                            value = _decodeBlob(value);
  		                        }
  		                        resolve(value);
  		                    };

  		                    req.onerror = function () {
  		                        reject(req.error);
  		                    };
  		                } catch (e) {
  		                    reject(e);
  		                }
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		// Iterate over all items stored in database.
  		function iterate(iterator, callback) {
  		    var self = this;

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
  		                if (err) {
  		                    return reject(err);
  		                }

  		                try {
  		                    var store = transaction.objectStore(self._dbInfo.storeName);
  		                    var req = store.openCursor();
  		                    var iterationNumber = 1;

  		                    req.onsuccess = function () {
  		                        var cursor = req.result;

  		                        if (cursor) {
  		                            var value = cursor.value;
  		                            if (_isEncodedBlob(value)) {
  		                                value = _decodeBlob(value);
  		                            }
  		                            var result = iterator(value, cursor.key, iterationNumber++);

  		                            // when the iterator callback returns any
  		                            // (non-`undefined`) value, then we stop
  		                            // the iteration immediately
  		                            if (result !== void 0) {
  		                                resolve(result);
  		                            } else {
  		                                cursor["continue"]();
  		                            }
  		                        } else {
  		                            resolve();
  		                        }
  		                    };

  		                    req.onerror = function () {
  		                        reject(req.error);
  		                    };
  		                } catch (e) {
  		                    reject(e);
  		                }
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);

  		    return promise;
  		}

  		function setItem(key, value, callback) {
  		    var self = this;

  		    key = normalizeKey(key);

  		    var promise = new Promise$1(function (resolve, reject) {
  		        var dbInfo;
  		        self.ready().then(function () {
  		            dbInfo = self._dbInfo;
  		            if (toString.call(value) === '[object Blob]') {
  		                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
  		                    if (blobSupport) {
  		                        return value;
  		                    }
  		                    return _encodeBlob(value);
  		                });
  		            }
  		            return value;
  		        }).then(function (value) {
  		            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
  		                if (err) {
  		                    return reject(err);
  		                }

  		                try {
  		                    var store = transaction.objectStore(self._dbInfo.storeName);

  		                    // The reason we don't _save_ null is because IE 10 does
  		                    // not support saving the `null` type in IndexedDB. How
  		                    // ironic, given the bug below!
  		                    // See: https://github.com/mozilla/localForage/issues/161
  		                    if (value === null) {
  		                        value = undefined;
  		                    }

  		                    var req = store.put(value, key);

  		                    transaction.oncomplete = function () {
  		                        // Cast to undefined so the value passed to
  		                        // callback/promise is the same as what one would get out
  		                        // of `getItem()` later. This leads to some weirdness
  		                        // (setItem('foo', undefined) will return `null`), but
  		                        // it's not my fault localStorage is our baseline and that
  		                        // it's weird.
  		                        if (value === undefined) {
  		                            value = null;
  		                        }

  		                        resolve(value);
  		                    };
  		                    transaction.onabort = transaction.onerror = function () {
  		                        var err = req.error ? req.error : req.transaction.error;
  		                        reject(err);
  		                    };
  		                } catch (e) {
  		                    reject(e);
  		                }
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function removeItem(key, callback) {
  		    var self = this;

  		    key = normalizeKey(key);

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
  		                if (err) {
  		                    return reject(err);
  		                }

  		                try {
  		                    var store = transaction.objectStore(self._dbInfo.storeName);
  		                    // We use a Grunt task to make this safe for IE and some
  		                    // versions of Android (including those used by Cordova).
  		                    // Normally IE won't like `.delete()` and will insist on
  		                    // using `['delete']()`, but we have a build step that
  		                    // fixes this for us now.
  		                    var req = store["delete"](key);
  		                    transaction.oncomplete = function () {
  		                        resolve();
  		                    };

  		                    transaction.onerror = function () {
  		                        reject(req.error);
  		                    };

  		                    // The request will be also be aborted if we've exceeded our storage
  		                    // space.
  		                    transaction.onabort = function () {
  		                        var err = req.error ? req.error : req.transaction.error;
  		                        reject(err);
  		                    };
  		                } catch (e) {
  		                    reject(e);
  		                }
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function clear(callback) {
  		    var self = this;

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
  		                if (err) {
  		                    return reject(err);
  		                }

  		                try {
  		                    var store = transaction.objectStore(self._dbInfo.storeName);
  		                    var req = store.clear();

  		                    transaction.oncomplete = function () {
  		                        resolve();
  		                    };

  		                    transaction.onabort = transaction.onerror = function () {
  		                        var err = req.error ? req.error : req.transaction.error;
  		                        reject(err);
  		                    };
  		                } catch (e) {
  		                    reject(e);
  		                }
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function length(callback) {
  		    var self = this;

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
  		                if (err) {
  		                    return reject(err);
  		                }

  		                try {
  		                    var store = transaction.objectStore(self._dbInfo.storeName);
  		                    var req = store.count();

  		                    req.onsuccess = function () {
  		                        resolve(req.result);
  		                    };

  		                    req.onerror = function () {
  		                        reject(req.error);
  		                    };
  		                } catch (e) {
  		                    reject(e);
  		                }
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function key(n, callback) {
  		    var self = this;

  		    var promise = new Promise$1(function (resolve, reject) {
  		        if (n < 0) {
  		            resolve(null);

  		            return;
  		        }

  		        self.ready().then(function () {
  		            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
  		                if (err) {
  		                    return reject(err);
  		                }

  		                try {
  		                    var store = transaction.objectStore(self._dbInfo.storeName);
  		                    var advanced = false;
  		                    var req = store.openKeyCursor();

  		                    req.onsuccess = function () {
  		                        var cursor = req.result;
  		                        if (!cursor) {
  		                            // this means there weren't enough keys
  		                            resolve(null);

  		                            return;
  		                        }

  		                        if (n === 0) {
  		                            // We have the first key, return it if that's what they
  		                            // wanted.
  		                            resolve(cursor.key);
  		                        } else {
  		                            if (!advanced) {
  		                                // Otherwise, ask the cursor to skip ahead n
  		                                // records.
  		                                advanced = true;
  		                                cursor.advance(n);
  		                            } else {
  		                                // When we get here, we've got the nth key.
  		                                resolve(cursor.key);
  		                            }
  		                        }
  		                    };

  		                    req.onerror = function () {
  		                        reject(req.error);
  		                    };
  		                } catch (e) {
  		                    reject(e);
  		                }
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function keys(callback) {
  		    var self = this;

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
  		                if (err) {
  		                    return reject(err);
  		                }

  		                try {
  		                    var store = transaction.objectStore(self._dbInfo.storeName);
  		                    var req = store.openKeyCursor();
  		                    var keys = [];

  		                    req.onsuccess = function () {
  		                        var cursor = req.result;

  		                        if (!cursor) {
  		                            resolve(keys);
  		                            return;
  		                        }

  		                        keys.push(cursor.key);
  		                        cursor["continue"]();
  		                    };

  		                    req.onerror = function () {
  		                        reject(req.error);
  		                    };
  		                } catch (e) {
  		                    reject(e);
  		                }
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function dropInstance(options, callback) {
  		    callback = getCallback.apply(this, arguments);

  		    var currentConfig = this.config();
  		    options = typeof options !== 'function' && options || {};
  		    if (!options.name) {
  		        options.name = options.name || currentConfig.name;
  		        options.storeName = options.storeName || currentConfig.storeName;
  		    }

  		    var self = this;
  		    var promise;
  		    if (!options.name) {
  		        promise = Promise$1.reject('Invalid arguments');
  		    } else {
  		        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

  		        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
  		            var dbContext = dbContexts[options.name];
  		            var forages = dbContext.forages;
  		            dbContext.db = db;
  		            for (var i = 0; i < forages.length; i++) {
  		                forages[i]._dbInfo.db = db;
  		            }
  		            return db;
  		        });

  		        if (!options.storeName) {
  		            promise = dbPromise.then(function (db) {
  		                _deferReadiness(options);

  		                var dbContext = dbContexts[options.name];
  		                var forages = dbContext.forages;

  		                db.close();
  		                for (var i = 0; i < forages.length; i++) {
  		                    var forage = forages[i];
  		                    forage._dbInfo.db = null;
  		                }

  		                var dropDBPromise = new Promise$1(function (resolve, reject) {
  		                    var req = idb.deleteDatabase(options.name);

  		                    req.onerror = function () {
  		                        var db = req.result;
  		                        if (db) {
  		                            db.close();
  		                        }
  		                        reject(req.error);
  		                    };

  		                    req.onblocked = function () {
  		                        // Closing all open connections in onversionchange handler should prevent this situation, but if
  		                        // we do get here, it just means the request remains pending - eventually it will succeed or error
  		                        console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
  		                    };

  		                    req.onsuccess = function () {
  		                        var db = req.result;
  		                        if (db) {
  		                            db.close();
  		                        }
  		                        resolve(db);
  		                    };
  		                });

  		                return dropDBPromise.then(function (db) {
  		                    dbContext.db = db;
  		                    for (var i = 0; i < forages.length; i++) {
  		                        var _forage = forages[i];
  		                        _advanceReadiness(_forage._dbInfo);
  		                    }
  		                })["catch"](function (err) {
  		                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
  		                    throw err;
  		                });
  		            });
  		        } else {
  		            promise = dbPromise.then(function (db) {
  		                if (!db.objectStoreNames.contains(options.storeName)) {
  		                    return;
  		                }

  		                var newVersion = db.version + 1;

  		                _deferReadiness(options);

  		                var dbContext = dbContexts[options.name];
  		                var forages = dbContext.forages;

  		                db.close();
  		                for (var i = 0; i < forages.length; i++) {
  		                    var forage = forages[i];
  		                    forage._dbInfo.db = null;
  		                    forage._dbInfo.version = newVersion;
  		                }

  		                var dropObjectPromise = new Promise$1(function (resolve, reject) {
  		                    var req = idb.open(options.name, newVersion);

  		                    req.onerror = function (err) {
  		                        var db = req.result;
  		                        db.close();
  		                        reject(err);
  		                    };

  		                    req.onupgradeneeded = function () {
  		                        var db = req.result;
  		                        db.deleteObjectStore(options.storeName);
  		                    };

  		                    req.onsuccess = function () {
  		                        var db = req.result;
  		                        db.close();
  		                        resolve(db);
  		                    };
  		                });

  		                return dropObjectPromise.then(function (db) {
  		                    dbContext.db = db;
  		                    for (var j = 0; j < forages.length; j++) {
  		                        var _forage2 = forages[j];
  		                        _forage2._dbInfo.db = db;
  		                        _advanceReadiness(_forage2._dbInfo);
  		                    }
  		                })["catch"](function (err) {
  		                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
  		                    throw err;
  		                });
  		            });
  		        }
  		    }

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		var asyncStorage = {
  		    _driver: 'asyncStorage',
  		    _initStorage: _initStorage,
  		    _support: isIndexedDBValid(),
  		    iterate: iterate,
  		    getItem: getItem,
  		    setItem: setItem,
  		    removeItem: removeItem,
  		    clear: clear,
  		    length: length,
  		    key: key,
  		    keys: keys,
  		    dropInstance: dropInstance
  		};

  		function isWebSQLValid() {
  		    return typeof openDatabase === 'function';
  		}

  		// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
  		// it to Base64, so this is how we store it to prevent very strange errors with less
  		// verbose ways of binary <-> string data storage.
  		var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

  		var BLOB_TYPE_PREFIX = '~~local_forage_type~';
  		var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

  		var SERIALIZED_MARKER = '__lfsc__:';
  		var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

  		// OMG the serializations!
  		var TYPE_ARRAYBUFFER = 'arbf';
  		var TYPE_BLOB = 'blob';
  		var TYPE_INT8ARRAY = 'si08';
  		var TYPE_UINT8ARRAY = 'ui08';
  		var TYPE_UINT8CLAMPEDARRAY = 'uic8';
  		var TYPE_INT16ARRAY = 'si16';
  		var TYPE_INT32ARRAY = 'si32';
  		var TYPE_UINT16ARRAY = 'ur16';
  		var TYPE_UINT32ARRAY = 'ui32';
  		var TYPE_FLOAT32ARRAY = 'fl32';
  		var TYPE_FLOAT64ARRAY = 'fl64';
  		var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

  		var toString$1 = Object.prototype.toString;

  		function stringToBuffer(serializedString) {
  		    // Fill the string into a ArrayBuffer.
  		    var bufferLength = serializedString.length * 0.75;
  		    var len = serializedString.length;
  		    var i;
  		    var p = 0;
  		    var encoded1, encoded2, encoded3, encoded4;

  		    if (serializedString[serializedString.length - 1] === '=') {
  		        bufferLength--;
  		        if (serializedString[serializedString.length - 2] === '=') {
  		            bufferLength--;
  		        }
  		    }

  		    var buffer = new ArrayBuffer(bufferLength);
  		    var bytes = new Uint8Array(buffer);

  		    for (i = 0; i < len; i += 4) {
  		        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
  		        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
  		        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
  		        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

  		        /*jslint bitwise: true */
  		        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
  		        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
  		        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
  		    }
  		    return buffer;
  		}

  		// Converts a buffer to a string to store, serialized, in the backend
  		// storage library.
  		function bufferToString(buffer) {
  		    // base64-arraybuffer
  		    var bytes = new Uint8Array(buffer);
  		    var base64String = '';
  		    var i;

  		    for (i = 0; i < bytes.length; i += 3) {
  		        /*jslint bitwise: true */
  		        base64String += BASE_CHARS[bytes[i] >> 2];
  		        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
  		        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
  		        base64String += BASE_CHARS[bytes[i + 2] & 63];
  		    }

  		    if (bytes.length % 3 === 2) {
  		        base64String = base64String.substring(0, base64String.length - 1) + '=';
  		    } else if (bytes.length % 3 === 1) {
  		        base64String = base64String.substring(0, base64String.length - 2) + '==';
  		    }

  		    return base64String;
  		}

  		// Serialize a value, afterwards executing a callback (which usually
  		// instructs the `setItem()` callback/promise to be executed). This is how
  		// we store binary data with localStorage.
  		function serialize(value, callback) {
  		    var valueType = '';
  		    if (value) {
  		        valueType = toString$1.call(value);
  		    }

  		    // Cannot use `value instanceof ArrayBuffer` or such here, as these
  		    // checks fail when running the tests using casper.js...
  		    //
  		    // TODO: See why those tests fail and use a better solution.
  		    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
  		        // Convert binary arrays to a string and prefix the string with
  		        // a special marker.
  		        var buffer;
  		        var marker = SERIALIZED_MARKER;

  		        if (value instanceof ArrayBuffer) {
  		            buffer = value;
  		            marker += TYPE_ARRAYBUFFER;
  		        } else {
  		            buffer = value.buffer;

  		            if (valueType === '[object Int8Array]') {
  		                marker += TYPE_INT8ARRAY;
  		            } else if (valueType === '[object Uint8Array]') {
  		                marker += TYPE_UINT8ARRAY;
  		            } else if (valueType === '[object Uint8ClampedArray]') {
  		                marker += TYPE_UINT8CLAMPEDARRAY;
  		            } else if (valueType === '[object Int16Array]') {
  		                marker += TYPE_INT16ARRAY;
  		            } else if (valueType === '[object Uint16Array]') {
  		                marker += TYPE_UINT16ARRAY;
  		            } else if (valueType === '[object Int32Array]') {
  		                marker += TYPE_INT32ARRAY;
  		            } else if (valueType === '[object Uint32Array]') {
  		                marker += TYPE_UINT32ARRAY;
  		            } else if (valueType === '[object Float32Array]') {
  		                marker += TYPE_FLOAT32ARRAY;
  		            } else if (valueType === '[object Float64Array]') {
  		                marker += TYPE_FLOAT64ARRAY;
  		            } else {
  		                callback(new Error('Failed to get type for BinaryArray'));
  		            }
  		        }

  		        callback(marker + bufferToString(buffer));
  		    } else if (valueType === '[object Blob]') {
  		        // Conver the blob to a binaryArray and then to a string.
  		        var fileReader = new FileReader();

  		        fileReader.onload = function () {
  		            // Backwards-compatible prefix for the blob type.
  		            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

  		            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
  		        };

  		        fileReader.readAsArrayBuffer(value);
  		    } else {
  		        try {
  		            callback(JSON.stringify(value));
  		        } catch (e) {
  		            console.error("Couldn't convert value into a JSON string: ", value);

  		            callback(null, e);
  		        }
  		    }
  		}

  		// Deserialize data we've inserted into a value column/field. We place
  		// special markers into our strings to mark them as encoded; this isn't
  		// as nice as a meta field, but it's the only sane thing we can do whilst
  		// keeping localStorage support intact.
  		//
  		// Oftentimes this will just deserialize JSON content, but if we have a
  		// special marker (SERIALIZED_MARKER, defined above), we will extract
  		// some kind of arraybuffer/binary data/typed array out of the string.
  		function deserialize(value) {
  		    // If we haven't marked this string as being specially serialized (i.e.
  		    // something other than serialized JSON), we can just return it and be
  		    // done with it.
  		    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
  		        return JSON.parse(value);
  		    }

  		    // The following code deals with deserializing some kind of Blob or
  		    // TypedArray. First we separate out the type of data we're dealing
  		    // with from the data itself.
  		    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
  		    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

  		    var blobType;
  		    // Backwards-compatible blob type serialization strategy.
  		    // DBs created with older versions of localForage will simply not have the blob type.
  		    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
  		        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
  		        blobType = matcher[1];
  		        serializedString = serializedString.substring(matcher[0].length);
  		    }
  		    var buffer = stringToBuffer(serializedString);

  		    // Return the right type based on the code/type set during
  		    // serialization.
  		    switch (type) {
  		        case TYPE_ARRAYBUFFER:
  		            return buffer;
  		        case TYPE_BLOB:
  		            return createBlob([buffer], { type: blobType });
  		        case TYPE_INT8ARRAY:
  		            return new Int8Array(buffer);
  		        case TYPE_UINT8ARRAY:
  		            return new Uint8Array(buffer);
  		        case TYPE_UINT8CLAMPEDARRAY:
  		            return new Uint8ClampedArray(buffer);
  		        case TYPE_INT16ARRAY:
  		            return new Int16Array(buffer);
  		        case TYPE_UINT16ARRAY:
  		            return new Uint16Array(buffer);
  		        case TYPE_INT32ARRAY:
  		            return new Int32Array(buffer);
  		        case TYPE_UINT32ARRAY:
  		            return new Uint32Array(buffer);
  		        case TYPE_FLOAT32ARRAY:
  		            return new Float32Array(buffer);
  		        case TYPE_FLOAT64ARRAY:
  		            return new Float64Array(buffer);
  		        default:
  		            throw new Error('Unkown type: ' + type);
  		    }
  		}

  		var localforageSerializer = {
  		    serialize: serialize,
  		    deserialize: deserialize,
  		    stringToBuffer: stringToBuffer,
  		    bufferToString: bufferToString
  		};

  		/*
  		 * Includes code from:
  		 *
  		 * base64-arraybuffer
  		 * https://github.com/niklasvh/base64-arraybuffer
  		 *
  		 * Copyright (c) 2012 Niklas von Hertzen
  		 * Licensed under the MIT license.
  		 */

  		function createDbTable(t, dbInfo, callback, errorCallback) {
  		    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
  		}

  		// Open the WebSQL database (automatically creates one if one didn't
  		// previously exist), using any options set in the config.
  		function _initStorage$1(options) {
  		    var self = this;
  		    var dbInfo = {
  		        db: null
  		    };

  		    if (options) {
  		        for (var i in options) {
  		            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
  		        }
  		    }

  		    var dbInfoPromise = new Promise$1(function (resolve, reject) {
  		        // Open the database; the openDatabase API will automatically
  		        // create it for us if it doesn't exist.
  		        try {
  		            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
  		        } catch (e) {
  		            return reject(e);
  		        }

  		        // Create our key/value table if it doesn't exist.
  		        dbInfo.db.transaction(function (t) {
  		            createDbTable(t, dbInfo, function () {
  		                self._dbInfo = dbInfo;
  		                resolve();
  		            }, function (t, error) {
  		                reject(error);
  		            });
  		        }, reject);
  		    });

  		    dbInfo.serializer = localforageSerializer;
  		    return dbInfoPromise;
  		}

  		function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
  		    t.executeSql(sqlStatement, args, callback, function (t, error) {
  		        if (error.code === error.SYNTAX_ERR) {
  		            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
  		                if (!results.rows.length) {
  		                    // if the table is missing (was deleted)
  		                    // re-create it table and retry
  		                    createDbTable(t, dbInfo, function () {
  		                        t.executeSql(sqlStatement, args, callback, errorCallback);
  		                    }, errorCallback);
  		                } else {
  		                    errorCallback(t, error);
  		                }
  		            }, errorCallback);
  		        } else {
  		            errorCallback(t, error);
  		        }
  		    }, errorCallback);
  		}

  		function getItem$1(key, callback) {
  		    var self = this;

  		    key = normalizeKey(key);

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            var dbInfo = self._dbInfo;
  		            dbInfo.db.transaction(function (t) {
  		                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
  		                    var result = results.rows.length ? results.rows.item(0).value : null;

  		                    // Check to see if this is serialized content we need to
  		                    // unpack.
  		                    if (result) {
  		                        result = dbInfo.serializer.deserialize(result);
  		                    }

  		                    resolve(result);
  		                }, function (t, error) {
  		                    reject(error);
  		                });
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function iterate$1(iterator, callback) {
  		    var self = this;

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            var dbInfo = self._dbInfo;

  		            dbInfo.db.transaction(function (t) {
  		                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
  		                    var rows = results.rows;
  		                    var length = rows.length;

  		                    for (var i = 0; i < length; i++) {
  		                        var item = rows.item(i);
  		                        var result = item.value;

  		                        // Check to see if this is serialized content
  		                        // we need to unpack.
  		                        if (result) {
  		                            result = dbInfo.serializer.deserialize(result);
  		                        }

  		                        result = iterator(result, item.key, i + 1);

  		                        // void(0) prevents problems with redefinition
  		                        // of `undefined`.
  		                        if (result !== void 0) {
  		                            resolve(result);
  		                            return;
  		                        }
  		                    }

  		                    resolve();
  		                }, function (t, error) {
  		                    reject(error);
  		                });
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function _setItem(key, value, callback, retriesLeft) {
  		    var self = this;

  		    key = normalizeKey(key);

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            // The localStorage API doesn't return undefined values in an
  		            // "expected" way, so undefined is always cast to null in all
  		            // drivers. See: https://github.com/mozilla/localForage/pull/42
  		            if (value === undefined) {
  		                value = null;
  		            }

  		            // Save the original value to pass to the callback.
  		            var originalValue = value;

  		            var dbInfo = self._dbInfo;
  		            dbInfo.serializer.serialize(value, function (value, error) {
  		                if (error) {
  		                    reject(error);
  		                } else {
  		                    dbInfo.db.transaction(function (t) {
  		                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
  		                            resolve(originalValue);
  		                        }, function (t, error) {
  		                            reject(error);
  		                        });
  		                    }, function (sqlError) {
  		                        // The transaction failed; check
  		                        // to see if it's a quota error.
  		                        if (sqlError.code === sqlError.QUOTA_ERR) {
  		                            // We reject the callback outright for now, but
  		                            // it's worth trying to re-run the transaction.
  		                            // Even if the user accepts the prompt to use
  		                            // more storage on Safari, this error will
  		                            // be called.
  		                            //
  		                            // Try to re-run the transaction.
  		                            if (retriesLeft > 0) {
  		                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
  		                                return;
  		                            }
  		                            reject(sqlError);
  		                        }
  		                    });
  		                }
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function setItem$1(key, value, callback) {
  		    return _setItem.apply(this, [key, value, callback, 1]);
  		}

  		function removeItem$1(key, callback) {
  		    var self = this;

  		    key = normalizeKey(key);

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            var dbInfo = self._dbInfo;
  		            dbInfo.db.transaction(function (t) {
  		                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
  		                    resolve();
  		                }, function (t, error) {
  		                    reject(error);
  		                });
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		// Deletes every item in the table.
  		// TODO: Find out if this resets the AUTO_INCREMENT number.
  		function clear$1(callback) {
  		    var self = this;

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            var dbInfo = self._dbInfo;
  		            dbInfo.db.transaction(function (t) {
  		                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
  		                    resolve();
  		                }, function (t, error) {
  		                    reject(error);
  		                });
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		// Does a simple `COUNT(key)` to get the number of items stored in
  		// localForage.
  		function length$1(callback) {
  		    var self = this;

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            var dbInfo = self._dbInfo;
  		            dbInfo.db.transaction(function (t) {
  		                // Ahhh, SQL makes this one soooooo easy.
  		                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
  		                    var result = results.rows.item(0).c;
  		                    resolve(result);
  		                }, function (t, error) {
  		                    reject(error);
  		                });
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		// Return the key located at key index X; essentially gets the key from a
  		// `WHERE id = ?`. This is the most efficient way I can think to implement
  		// this rarely-used (in my experience) part of the API, but it can seem
  		// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
  		// the ID of each key will change every time it's updated. Perhaps a stored
  		// procedure for the `setItem()` SQL would solve this problem?
  		// TODO: Don't change ID on `setItem()`.
  		function key$1(n, callback) {
  		    var self = this;

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            var dbInfo = self._dbInfo;
  		            dbInfo.db.transaction(function (t) {
  		                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
  		                    var result = results.rows.length ? results.rows.item(0).key : null;
  		                    resolve(result);
  		                }, function (t, error) {
  		                    reject(error);
  		                });
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function keys$1(callback) {
  		    var self = this;

  		    var promise = new Promise$1(function (resolve, reject) {
  		        self.ready().then(function () {
  		            var dbInfo = self._dbInfo;
  		            dbInfo.db.transaction(function (t) {
  		                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
  		                    var keys = [];

  		                    for (var i = 0; i < results.rows.length; i++) {
  		                        keys.push(results.rows.item(i).key);
  		                    }

  		                    resolve(keys);
  		                }, function (t, error) {
  		                    reject(error);
  		                });
  		            });
  		        })["catch"](reject);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		// https://www.w3.org/TR/webdatabase/#databases
  		// > There is no way to enumerate or delete the databases available for an origin from this API.
  		function getAllStoreNames(db) {
  		    return new Promise$1(function (resolve, reject) {
  		        db.transaction(function (t) {
  		            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
  		                var storeNames = [];

  		                for (var i = 0; i < results.rows.length; i++) {
  		                    storeNames.push(results.rows.item(i).name);
  		                }

  		                resolve({
  		                    db: db,
  		                    storeNames: storeNames
  		                });
  		            }, function (t, error) {
  		                reject(error);
  		            });
  		        }, function (sqlError) {
  		            reject(sqlError);
  		        });
  		    });
  		}

  		function dropInstance$1(options, callback) {
  		    callback = getCallback.apply(this, arguments);

  		    var currentConfig = this.config();
  		    options = typeof options !== 'function' && options || {};
  		    if (!options.name) {
  		        options.name = options.name || currentConfig.name;
  		        options.storeName = options.storeName || currentConfig.storeName;
  		    }

  		    var self = this;
  		    var promise;
  		    if (!options.name) {
  		        promise = Promise$1.reject('Invalid arguments');
  		    } else {
  		        promise = new Promise$1(function (resolve) {
  		            var db;
  		            if (options.name === currentConfig.name) {
  		                // use the db reference of the current instance
  		                db = self._dbInfo.db;
  		            } else {
  		                db = openDatabase(options.name, '', '', 0);
  		            }

  		            if (!options.storeName) {
  		                // drop all database tables
  		                resolve(getAllStoreNames(db));
  		            } else {
  		                resolve({
  		                    db: db,
  		                    storeNames: [options.storeName]
  		                });
  		            }
  		        }).then(function (operationInfo) {
  		            return new Promise$1(function (resolve, reject) {
  		                operationInfo.db.transaction(function (t) {
  		                    function dropTable(storeName) {
  		                        return new Promise$1(function (resolve, reject) {
  		                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
  		                                resolve();
  		                            }, function (t, error) {
  		                                reject(error);
  		                            });
  		                        });
  		                    }

  		                    var operations = [];
  		                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
  		                        operations.push(dropTable(operationInfo.storeNames[i]));
  		                    }

  		                    Promise$1.all(operations).then(function () {
  		                        resolve();
  		                    })["catch"](function (e) {
  		                        reject(e);
  		                    });
  		                }, function (sqlError) {
  		                    reject(sqlError);
  		                });
  		            });
  		        });
  		    }

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		var webSQLStorage = {
  		    _driver: 'webSQLStorage',
  		    _initStorage: _initStorage$1,
  		    _support: isWebSQLValid(),
  		    iterate: iterate$1,
  		    getItem: getItem$1,
  		    setItem: setItem$1,
  		    removeItem: removeItem$1,
  		    clear: clear$1,
  		    length: length$1,
  		    key: key$1,
  		    keys: keys$1,
  		    dropInstance: dropInstance$1
  		};

  		function isLocalStorageValid() {
  		    try {
  		        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
  		        // in IE8 typeof localStorage.setItem === 'object'
  		        !!localStorage.setItem;
  		    } catch (e) {
  		        return false;
  		    }
  		}

  		function _getKeyPrefix(options, defaultConfig) {
  		    var keyPrefix = options.name + '/';

  		    if (options.storeName !== defaultConfig.storeName) {
  		        keyPrefix += options.storeName + '/';
  		    }
  		    return keyPrefix;
  		}

  		// Check if localStorage throws when saving an item
  		function checkIfLocalStorageThrows() {
  		    var localStorageTestKey = '_localforage_support_test';

  		    try {
  		        localStorage.setItem(localStorageTestKey, true);
  		        localStorage.removeItem(localStorageTestKey);

  		        return false;
  		    } catch (e) {
  		        return true;
  		    }
  		}

  		// Check if localStorage is usable and allows to save an item
  		// This method checks if localStorage is usable in Safari Private Browsing
  		// mode, or in any other case where the available quota for localStorage
  		// is 0 and there wasn't any saved items yet.
  		function _isLocalStorageUsable() {
  		    return !checkIfLocalStorageThrows() || localStorage.length > 0;
  		}

  		// Config the localStorage backend, using options set in the config.
  		function _initStorage$2(options) {
  		    var self = this;
  		    var dbInfo = {};
  		    if (options) {
  		        for (var i in options) {
  		            dbInfo[i] = options[i];
  		        }
  		    }

  		    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

  		    if (!_isLocalStorageUsable()) {
  		        return Promise$1.reject();
  		    }

  		    self._dbInfo = dbInfo;
  		    dbInfo.serializer = localforageSerializer;

  		    return Promise$1.resolve();
  		}

  		// Remove all keys from the datastore, effectively destroying all data in
  		// the app's key/value store!
  		function clear$2(callback) {
  		    var self = this;
  		    var promise = self.ready().then(function () {
  		        var keyPrefix = self._dbInfo.keyPrefix;

  		        for (var i = localStorage.length - 1; i >= 0; i--) {
  		            var key = localStorage.key(i);

  		            if (key.indexOf(keyPrefix) === 0) {
  		                localStorage.removeItem(key);
  		            }
  		        }
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		// Retrieve an item from the store. Unlike the original async_storage
  		// library in Gaia, we don't modify return values at all. If a key's value
  		// is `undefined`, we pass that value to the callback function.
  		function getItem$2(key, callback) {
  		    var self = this;

  		    key = normalizeKey(key);

  		    var promise = self.ready().then(function () {
  		        var dbInfo = self._dbInfo;
  		        var result = localStorage.getItem(dbInfo.keyPrefix + key);

  		        // If a result was found, parse it from the serialized
  		        // string into a JS object. If result isn't truthy, the key
  		        // is likely undefined and we'll pass it straight to the
  		        // callback.
  		        if (result) {
  		            result = dbInfo.serializer.deserialize(result);
  		        }

  		        return result;
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		// Iterate over all items in the store.
  		function iterate$2(iterator, callback) {
  		    var self = this;

  		    var promise = self.ready().then(function () {
  		        var dbInfo = self._dbInfo;
  		        var keyPrefix = dbInfo.keyPrefix;
  		        var keyPrefixLength = keyPrefix.length;
  		        var length = localStorage.length;

  		        // We use a dedicated iterator instead of the `i` variable below
  		        // so other keys we fetch in localStorage aren't counted in
  		        // the `iterationNumber` argument passed to the `iterate()`
  		        // callback.
  		        //
  		        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
  		        var iterationNumber = 1;

  		        for (var i = 0; i < length; i++) {
  		            var key = localStorage.key(i);
  		            if (key.indexOf(keyPrefix) !== 0) {
  		                continue;
  		            }
  		            var value = localStorage.getItem(key);

  		            // If a result was found, parse it from the serialized
  		            // string into a JS object. If result isn't truthy, the
  		            // key is likely undefined and we'll pass it straight
  		            // to the iterator.
  		            if (value) {
  		                value = dbInfo.serializer.deserialize(value);
  		            }

  		            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

  		            if (value !== void 0) {
  		                return value;
  		            }
  		        }
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		// Same as localStorage's key() method, except takes a callback.
  		function key$2(n, callback) {
  		    var self = this;
  		    var promise = self.ready().then(function () {
  		        var dbInfo = self._dbInfo;
  		        var result;
  		        try {
  		            result = localStorage.key(n);
  		        } catch (error) {
  		            result = null;
  		        }

  		        // Remove the prefix from the key, if a key is found.
  		        if (result) {
  		            result = result.substring(dbInfo.keyPrefix.length);
  		        }

  		        return result;
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function keys$2(callback) {
  		    var self = this;
  		    var promise = self.ready().then(function () {
  		        var dbInfo = self._dbInfo;
  		        var length = localStorage.length;
  		        var keys = [];

  		        for (var i = 0; i < length; i++) {
  		            var itemKey = localStorage.key(i);
  		            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
  		                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
  		            }
  		        }

  		        return keys;
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		// Supply the number of keys in the datastore to the callback function.
  		function length$2(callback) {
  		    var self = this;
  		    var promise = self.keys().then(function (keys) {
  		        return keys.length;
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		// Remove an item from the store, nice and simple.
  		function removeItem$2(key, callback) {
  		    var self = this;

  		    key = normalizeKey(key);

  		    var promise = self.ready().then(function () {
  		        var dbInfo = self._dbInfo;
  		        localStorage.removeItem(dbInfo.keyPrefix + key);
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		// Set a key's value and run an optional callback once the value is set.
  		// Unlike Gaia's implementation, the callback function is passed the value,
  		// in case you want to operate on that value only after you're sure it
  		// saved, or something like that.
  		function setItem$2(key, value, callback) {
  		    var self = this;

  		    key = normalizeKey(key);

  		    var promise = self.ready().then(function () {
  		        // Convert undefined values to null.
  		        // https://github.com/mozilla/localForage/pull/42
  		        if (value === undefined) {
  		            value = null;
  		        }

  		        // Save the original value to pass to the callback.
  		        var originalValue = value;

  		        return new Promise$1(function (resolve, reject) {
  		            var dbInfo = self._dbInfo;
  		            dbInfo.serializer.serialize(value, function (value, error) {
  		                if (error) {
  		                    reject(error);
  		                } else {
  		                    try {
  		                        localStorage.setItem(dbInfo.keyPrefix + key, value);
  		                        resolve(originalValue);
  		                    } catch (e) {
  		                        // localStorage capacity exceeded.
  		                        // TODO: Make this a specific error/event.
  		                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
  		                            reject(e);
  		                        }
  		                        reject(e);
  		                    }
  		                }
  		            });
  		        });
  		    });

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function dropInstance$2(options, callback) {
  		    callback = getCallback.apply(this, arguments);

  		    options = typeof options !== 'function' && options || {};
  		    if (!options.name) {
  		        var currentConfig = this.config();
  		        options.name = options.name || currentConfig.name;
  		        options.storeName = options.storeName || currentConfig.storeName;
  		    }

  		    var self = this;
  		    var promise;
  		    if (!options.name) {
  		        promise = Promise$1.reject('Invalid arguments');
  		    } else {
  		        promise = new Promise$1(function (resolve) {
  		            if (!options.storeName) {
  		                resolve(options.name + '/');
  		            } else {
  		                resolve(_getKeyPrefix(options, self._defaultConfig));
  		            }
  		        }).then(function (keyPrefix) {
  		            for (var i = localStorage.length - 1; i >= 0; i--) {
  		                var key = localStorage.key(i);

  		                if (key.indexOf(keyPrefix) === 0) {
  		                    localStorage.removeItem(key);
  		                }
  		            }
  		        });
  		    }

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		var localStorageWrapper = {
  		    _driver: 'localStorageWrapper',
  		    _initStorage: _initStorage$2,
  		    _support: isLocalStorageValid(),
  		    iterate: iterate$2,
  		    getItem: getItem$2,
  		    setItem: setItem$2,
  		    removeItem: removeItem$2,
  		    clear: clear$2,
  		    length: length$2,
  		    key: key$2,
  		    keys: keys$2,
  		    dropInstance: dropInstance$2
  		};

  		var sameValue = function sameValue(x, y) {
  		    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
  		};

  		var includes = function includes(array, searchElement) {
  		    var len = array.length;
  		    var i = 0;
  		    while (i < len) {
  		        if (sameValue(array[i], searchElement)) {
  		            return true;
  		        }
  		        i++;
  		    }

  		    return false;
  		};

  		var isArray = Array.isArray || function (arg) {
  		    return Object.prototype.toString.call(arg) === '[object Array]';
  		};

  		// Drivers are stored here when `defineDriver()` is called.
  		// They are shared across all instances of localForage.
  		var DefinedDrivers = {};

  		var DriverSupport = {};

  		var DefaultDrivers = {
  		    INDEXEDDB: asyncStorage,
  		    WEBSQL: webSQLStorage,
  		    LOCALSTORAGE: localStorageWrapper
  		};

  		var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

  		var OptionalDriverMethods = ['dropInstance'];

  		var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

  		var DefaultConfig = {
  		    description: '',
  		    driver: DefaultDriverOrder.slice(),
  		    name: 'localforage',
  		    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
  		    // we can use without a prompt.
  		    size: 4980736,
  		    storeName: 'keyvaluepairs',
  		    version: 1.0
  		};

  		function callWhenReady(localForageInstance, libraryMethod) {
  		    localForageInstance[libraryMethod] = function () {
  		        var _args = arguments;
  		        return localForageInstance.ready().then(function () {
  		            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
  		        });
  		    };
  		}

  		function extend() {
  		    for (var i = 1; i < arguments.length; i++) {
  		        var arg = arguments[i];

  		        if (arg) {
  		            for (var _key in arg) {
  		                if (arg.hasOwnProperty(_key)) {
  		                    if (isArray(arg[_key])) {
  		                        arguments[0][_key] = arg[_key].slice();
  		                    } else {
  		                        arguments[0][_key] = arg[_key];
  		                    }
  		                }
  		            }
  		        }
  		    }

  		    return arguments[0];
  		}

  		var LocalForage = function () {
  		    function LocalForage(options) {
  		        _classCallCheck(this, LocalForage);

  		        for (var driverTypeKey in DefaultDrivers) {
  		            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
  		                var driver = DefaultDrivers[driverTypeKey];
  		                var driverName = driver._driver;
  		                this[driverTypeKey] = driverName;

  		                if (!DefinedDrivers[driverName]) {
  		                    // we don't need to wait for the promise,
  		                    // since the default drivers can be defined
  		                    // in a blocking manner
  		                    this.defineDriver(driver);
  		                }
  		            }
  		        }

  		        this._defaultConfig = extend({}, DefaultConfig);
  		        this._config = extend({}, this._defaultConfig, options);
  		        this._driverSet = null;
  		        this._initDriver = null;
  		        this._ready = false;
  		        this._dbInfo = null;

  		        this._wrapLibraryMethodsWithReady();
  		        this.setDriver(this._config.driver)["catch"](function () {});
  		    }

  		    // Set any config values for localForage; can be called anytime before
  		    // the first API call (e.g. `getItem`, `setItem`).
  		    // We loop through options so we don't overwrite existing config
  		    // values.


  		    LocalForage.prototype.config = function config(options) {
  		        // If the options argument is an object, we use it to set values.
  		        // Otherwise, we return either a specified config value or all
  		        // config values.
  		        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
  		            // If localforage is ready and fully initialized, we can't set
  		            // any new configuration values. Instead, we return an error.
  		            if (this._ready) {
  		                return new Error("Can't call config() after localforage " + 'has been used.');
  		            }

  		            for (var i in options) {
  		                if (i === 'storeName') {
  		                    options[i] = options[i].replace(/\W/g, '_');
  		                }

  		                if (i === 'version' && typeof options[i] !== 'number') {
  		                    return new Error('Database version must be a number.');
  		                }

  		                this._config[i] = options[i];
  		            }

  		            // after all config options are set and
  		            // the driver option is used, try setting it
  		            if ('driver' in options && options.driver) {
  		                return this.setDriver(this._config.driver);
  		            }

  		            return true;
  		        } else if (typeof options === 'string') {
  		            return this._config[options];
  		        } else {
  		            return this._config;
  		        }
  		    };

  		    // Used to define a custom driver, shared across all instances of
  		    // localForage.


  		    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
  		        var promise = new Promise$1(function (resolve, reject) {
  		            try {
  		                var driverName = driverObject._driver;
  		                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

  		                // A driver name should be defined and not overlap with the
  		                // library-defined, default drivers.
  		                if (!driverObject._driver) {
  		                    reject(complianceError);
  		                    return;
  		                }

  		                var driverMethods = LibraryMethods.concat('_initStorage');
  		                for (var i = 0, len = driverMethods.length; i < len; i++) {
  		                    var driverMethodName = driverMethods[i];

  		                    // when the property is there,
  		                    // it should be a method even when optional
  		                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
  		                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
  		                        reject(complianceError);
  		                        return;
  		                    }
  		                }

  		                var configureMissingMethods = function configureMissingMethods() {
  		                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
  		                        return function () {
  		                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
  		                            var promise = Promise$1.reject(error);
  		                            executeCallback(promise, arguments[arguments.length - 1]);
  		                            return promise;
  		                        };
  		                    };

  		                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
  		                        var optionalDriverMethod = OptionalDriverMethods[_i];
  		                        if (!driverObject[optionalDriverMethod]) {
  		                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
  		                        }
  		                    }
  		                };

  		                configureMissingMethods();

  		                var setDriverSupport = function setDriverSupport(support) {
  		                    if (DefinedDrivers[driverName]) {
  		                        console.info('Redefining LocalForage driver: ' + driverName);
  		                    }
  		                    DefinedDrivers[driverName] = driverObject;
  		                    DriverSupport[driverName] = support;
  		                    // don't use a then, so that we can define
  		                    // drivers that have simple _support methods
  		                    // in a blocking manner
  		                    resolve();
  		                };

  		                if ('_support' in driverObject) {
  		                    if (driverObject._support && typeof driverObject._support === 'function') {
  		                        driverObject._support().then(setDriverSupport, reject);
  		                    } else {
  		                        setDriverSupport(!!driverObject._support);
  		                    }
  		                } else {
  		                    setDriverSupport(true);
  		                }
  		            } catch (e) {
  		                reject(e);
  		            }
  		        });

  		        executeTwoCallbacks(promise, callback, errorCallback);
  		        return promise;
  		    };

  		    LocalForage.prototype.driver = function driver() {
  		        return this._driver || null;
  		    };

  		    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
  		        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

  		        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
  		        return getDriverPromise;
  		    };

  		    LocalForage.prototype.getSerializer = function getSerializer(callback) {
  		        var serializerPromise = Promise$1.resolve(localforageSerializer);
  		        executeTwoCallbacks(serializerPromise, callback);
  		        return serializerPromise;
  		    };

  		    LocalForage.prototype.ready = function ready(callback) {
  		        var self = this;

  		        var promise = self._driverSet.then(function () {
  		            if (self._ready === null) {
  		                self._ready = self._initDriver();
  		            }

  		            return self._ready;
  		        });

  		        executeTwoCallbacks(promise, callback, callback);
  		        return promise;
  		    };

  		    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
  		        var self = this;

  		        if (!isArray(drivers)) {
  		            drivers = [drivers];
  		        }

  		        var supportedDrivers = this._getSupportedDrivers(drivers);

  		        function setDriverToConfig() {
  		            self._config.driver = self.driver();
  		        }

  		        function extendSelfWithDriver(driver) {
  		            self._extend(driver);
  		            setDriverToConfig();

  		            self._ready = self._initStorage(self._config);
  		            return self._ready;
  		        }

  		        function initDriver(supportedDrivers) {
  		            return function () {
  		                var currentDriverIndex = 0;

  		                function driverPromiseLoop() {
  		                    while (currentDriverIndex < supportedDrivers.length) {
  		                        var driverName = supportedDrivers[currentDriverIndex];
  		                        currentDriverIndex++;

  		                        self._dbInfo = null;
  		                        self._ready = null;

  		                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
  		                    }

  		                    setDriverToConfig();
  		                    var error = new Error('No available storage method found.');
  		                    self._driverSet = Promise$1.reject(error);
  		                    return self._driverSet;
  		                }

  		                return driverPromiseLoop();
  		            };
  		        }

  		        // There might be a driver initialization in progress
  		        // so wait for it to finish in order to avoid a possible
  		        // race condition to set _dbInfo
  		        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
  		            return Promise$1.resolve();
  		        }) : Promise$1.resolve();

  		        this._driverSet = oldDriverSetDone.then(function () {
  		            var driverName = supportedDrivers[0];
  		            self._dbInfo = null;
  		            self._ready = null;

  		            return self.getDriver(driverName).then(function (driver) {
  		                self._driver = driver._driver;
  		                setDriverToConfig();
  		                self._wrapLibraryMethodsWithReady();
  		                self._initDriver = initDriver(supportedDrivers);
  		            });
  		        })["catch"](function () {
  		            setDriverToConfig();
  		            var error = new Error('No available storage method found.');
  		            self._driverSet = Promise$1.reject(error);
  		            return self._driverSet;
  		        });

  		        executeTwoCallbacks(this._driverSet, callback, errorCallback);
  		        return this._driverSet;
  		    };

  		    LocalForage.prototype.supports = function supports(driverName) {
  		        return !!DriverSupport[driverName];
  		    };

  		    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
  		        extend(this, libraryMethodsAndProperties);
  		    };

  		    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
  		        var supportedDrivers = [];
  		        for (var i = 0, len = drivers.length; i < len; i++) {
  		            var driverName = drivers[i];
  		            if (this.supports(driverName)) {
  		                supportedDrivers.push(driverName);
  		            }
  		        }
  		        return supportedDrivers;
  		    };

  		    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
  		        // Add a stub for each driver API method that delays the call to the
  		        // corresponding driver method until localForage is ready. These stubs
  		        // will be replaced by the driver methods as soon as the driver is
  		        // loaded, so there is no performance impact.
  		        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
  		            callWhenReady(this, LibraryMethods[i]);
  		        }
  		    };

  		    LocalForage.prototype.createInstance = function createInstance(options) {
  		        return new LocalForage(options);
  		    };

  		    return LocalForage;
  		}();

  		// The actual localForage object that we expose as a module or via a
  		// global. It's extended by pulling in one of our other libraries.


  		var localforage_js = new LocalForage();

  		module.exports = localforage_js;

  		},{"3":3}]},{},[4])(4)
  		}); 
  	} (localforage));
  	return localforage.exports;
  }

  var localforageExports = requireLocalforage();
  var localForage = /*@__PURE__*/getDefaultExportFromCjs(localforageExports);

  /**
   * This function is like `assignValue` except that it doesn't assign
   * `undefined` values.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignMergeValue(object, key, value) {
    if ((value !== undefined && !eq(object[key], value)) ||
        (value === undefined && !(key in object))) {
      baseAssignValue(object, key, value);
    }
  }

  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

      while (length--) {
        var key = props[++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }

  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */
  var baseFor = createBaseFor();

  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */
  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }

  /** `Object#toString` result references. */
  var objectTag$1 = '[object Object]';

  /** Used for built-in method references. */
  var funcProto = Function.prototype,
      objectProto$7 = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

  /** Used to infer the `Object` constructor. */
  var objectCtorString = funcToString.call(Object);

  /**
   * Checks if `value` is a plain object, that is, an object created by the
   * `Object` constructor or one with a `[[Prototype]]` of `null`.
   *
   * @static
   * @memberOf _
   * @since 0.8.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * _.isPlainObject(new Foo);
   * // => false
   *
   * _.isPlainObject([1, 2, 3]);
   * // => false
   *
   * _.isPlainObject({ 'x': 0, 'y': 0 });
   * // => true
   *
   * _.isPlainObject(Object.create(null));
   * // => true
   */
  function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag$1) {
      return false;
    }
    var proto = getPrototype(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty$6.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor &&
      funcToString.call(Ctor) == objectCtorString;
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') {
      return;
    }

    if (key == '__proto__') {
      return;
    }

    return object[key];
  }

  /**
   * Converts `value` to a plain object flattening inherited enumerable string
   * keyed properties of `value` to own properties of the plain object.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {Object} Returns the converted plain object.
   * @example
   *
   * function Foo() {
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.assign({ 'a': 1 }, new Foo);
   * // => { 'a': 1, 'b': 2 }
   *
   * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
   * // => { 'a': 1, 'b': 2, 'c': 3 }
   */
  function toPlainObject(value) {
    return copyObject(value, keysIn(value));
  }

  /**
   * A specialized version of `baseMerge` for arrays and objects which performs
   * deep merges and tracks traversed objects enabling objects with circular
   * references to be merged.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {string} key The key of the value to merge.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} mergeFunc The function to merge values.
   * @param {Function} [customizer] The function to customize assigned values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */
  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key),
        srcValue = safeGet(source, key),
        stacked = stack.get(srcValue);

    if (stacked) {
      assignMergeValue(object, key, stacked);
      return;
    }
    var newValue = customizer
      ? customizer(objValue, srcValue, (key + ''), object, source, stack)
      : undefined;

    var isCommon = newValue === undefined;

    if (isCommon) {
      var isArr = isArray(srcValue),
          isBuff = !isArr && isBuffer(srcValue),
          isTyped = !isArr && !isBuff && isTypedArray(srcValue);

      newValue = srcValue;
      if (isArr || isBuff || isTyped) {
        if (isArray(objValue)) {
          newValue = objValue;
        }
        else if (isArrayLikeObject(objValue)) {
          newValue = copyArray(objValue);
        }
        else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer(srcValue, true);
        }
        else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray(srcValue, true);
        }
        else {
          newValue = [];
        }
      }
      else if (isPlainObject(srcValue) || isArguments(srcValue)) {
        newValue = objValue;
        if (isArguments(objValue)) {
          newValue = toPlainObject(objValue);
        }
        else if (!isObject$1(objValue) || isFunction(objValue)) {
          newValue = initCloneObject(srcValue);
        }
      }
      else {
        isCommon = false;
      }
    }
    if (isCommon) {
      // Recursively merge objects and arrays (susceptible to call stack limits).
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
  }

  /**
   * The base implementation of `_.merge` without support for multiple sources.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} [customizer] The function to customize merged values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */
  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }
    baseFor(source, function(srcValue, key) {
      stack || (stack = new Stack);
      if (isObject$1(srcValue)) {
        baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
      }
      else {
        var newValue = customizer
          ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
          : undefined;

        if (newValue === undefined) {
          newValue = srcValue;
        }
        assignMergeValue(object, key, newValue);
      }
    }, keysIn);
  }

  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax$1 = Math.max;

  /**
   * A specialized version of `baseRest` which transforms the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @param {Function} transform The rest array transform.
   * @returns {Function} Returns the new function.
   */
  function overRest(func, start, transform) {
    start = nativeMax$1(start === undefined ? (func.length - 1) : start, 0);
    return function() {
      var args = arguments,
          index = -1,
          length = nativeMax$1(args.length - start, 0),
          array = Array(length);

      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform(array);
      return apply(func, this, otherArgs);
    };
  }

  /**
   * Creates a function that returns `value`.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {*} value The value to return from the new function.
   * @returns {Function} Returns the new constant function.
   * @example
   *
   * var objects = _.times(2, _.constant({ 'a': 1 }));
   *
   * console.log(objects);
   * // => [{ 'a': 1 }, { 'a': 1 }]
   *
   * console.log(objects[0] === objects[1]);
   * // => true
   */
  function constant(value) {
    return function() {
      return value;
    };
  }

  /**
   * The base implementation of `setToString` without support for hot loop shorting.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, 'toString', {
      'configurable': true,
      'enumerable': false,
      'value': constant(string),
      'writable': true
    });
  };

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeNow = Date.now;

  /**
   * Creates a function that'll short out and invoke `identity` instead
   * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
   * milliseconds.
   *
   * @private
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new shortable function.
   */
  function shortOut(func) {
    var count = 0,
        lastCalled = 0;

    return function() {
      var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);

      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(undefined, arguments);
    };
  }

  /**
   * Sets the `toString` method of `func` to return `string`.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var setToString = shortOut(baseSetToString);

  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */
  function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
  }

  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
   *  else `false`.
   */
  function isIterateeCall(value, index, object) {
    if (!isObject$1(object)) {
      return false;
    }
    var type = typeof index;
    if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)
        ) {
      return eq(object[index], value);
    }
    return false;
  }

  /**
   * Creates a function like `_.assign`.
   *
   * @private
   * @param {Function} assigner The function to assign values.
   * @returns {Function} Returns the new assigner function.
   */
  function createAssigner(assigner) {
    return baseRest(function(object, sources) {
      var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined,
          guard = length > 2 ? sources[2] : undefined;

      customizer = (assigner.length > 3 && typeof customizer == 'function')
        ? (length--, customizer)
        : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? undefined : customizer;
        length = 1;
      }
      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer);
        }
      }
      return object;
    });
  }

  /**
   * This method is like `_.assign` except that it recursively merges own and
   * inherited enumerable string keyed properties of source objects into the
   * destination object. Source properties that resolve to `undefined` are
   * skipped if a destination value exists. Array and plain object properties
   * are merged recursively. Other objects and value types are overridden by
   * assignment. Source objects are applied from left to right. Subsequent
   * sources overwrite property assignments of previous sources.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 0.5.0
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @example
   *
   * var object = {
   *   'a': [{ 'b': 2 }, { 'd': 4 }]
   * };
   *
   * var other = {
   *   'a': [{ 'c': 3 }, { 'e': 5 }]
   * };
   *
   * _.merge(object, other);
   * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
   */
  var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
  });

  /**
   * This method is like `_.merge` except that it accepts `customizer` which
   * is invoked to produce the merged values of the destination and source
   * properties. If `customizer` returns `undefined`, merging is handled by the
   * method instead. The `customizer` is invoked with six arguments:
   * (objValue, srcValue, key, object, source, stack).
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} sources The source objects.
   * @param {Function} customizer The function to customize assigned values.
   * @returns {Object} Returns `object`.
   * @example
   *
   * function customizer(objValue, srcValue) {
   *   if (_.isArray(objValue)) {
   *     return objValue.concat(srcValue);
   *   }
   * }
   *
   * var object = { 'a': [1], 'b': [2] };
   * var other = { 'a': [3], 'b': [4] };
   *
   * _.mergeWith(object, other, customizer);
   * // => { 'a': [1, 3], 'b': [2, 4] }
   */
  var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
  });

  function getOpenPromise() {
      const wrapper = {
          isResolved: false,
          isPending: true,
          isRejected: false
      };
      let promise;
      let resolve = () => { };
      let reject = () => { };
      if (typeof Promise.withResolvers === 'function') {
          const { promise: p, resolve: r, reject: j } = Promise.withResolvers();
          promise = p;
          resolve = r;
          reject = j;
      }
      else {
          promise = new Promise((r, j) => {
              resolve = r;
              reject = j;
          });
      }
      Object.assign(promise, {
          ...wrapper,
          resolve,
          reject
      });
      promise.then((v) => {
          promise.isResolved = true;
          promise.isPending = false;
          promise.isRejected = false;
          return v;
      }, (e) => {
          promise.isResolved = false;
          promise.isPending = false;
          promise.isRejected = true;
          throw e;
      });
      return promise;
  }

  /** Error message constants. */
  const FUNC_ERROR_TEXT$2 = 'Expected a function';

  /* Built-in method references for those with the same name as other `lodash` methods. */
  const nativeMax = Math.max;
  const nativeMin = Math.min;

  function toNumber(value) {
    if (typeof value === 'number') {
      return value;
    }
    if (typeof value === 'string') {
      const parsed = parseFloat(value);
      return isNaN(parsed) ? 0 : parsed;
    }
    return 0;
  }

  function isObject(value) {
    const type = typeof value;
    return value != null && (type === 'object' || type === 'function');
  }

  /**
   * Creates a debounced function that delays invoking `func` until after `wait`
   * milliseconds have elapsed since the last time the debounced function was
   * invoked. The debounced function comes with a `cancel` method to cancel
   * delayed `func` invocations and a `flush` method to immediately invoke them.
   *
   * This function differs from lodash's debounce by merging all passed objects
   * before passing them to the final invoked function.
   *
   * Because of this, invoking can only happen on the trailing edge, since
   * passed-in data would be discarded if invoking happened on the leading edge.
   *
   * If `wait` is `0`, `func` invocation is deferred until to the next tick,
   * similar to `setTimeout` with a timeout of `0`.
   *
   * @static
   * @category Function
   * @param {Function} func The function to mergebounce.
   * @param {number} [wait=0] The number of milliseconds to delay.
   * @param {Object} [options={}] The options object.
   * @param {number} [options.maxWait]
   *  The maximum time `func` is allowed to be delayed before it's invoked.
   * @param {boolean} [options.concatArrays=false]
   *  By default arrays will be treated as objects when being merged. When
   *  merging two arrays, the values in the 2nd arrray will replace the
   *  corresponding values (i.e. those with the same indexes) in the first array.
   *  When `concatArrays` is set to `true`, arrays will be concatenated instead.
   * @param {boolean} [options.dedupeArrays=false]
   *  This option is similar to `concatArrays`, except that the concatenated
   *  array will also be deduplicated. Thus any entries that are concatenated to the
   *  existing array, which are already contained in the existing array, will
   *  first be removed.
   * @param {boolean} [options.promise=false]
   *  By default, when calling a merge-debounced function that doesn't execute
   *  immediately, you'll receive the result from its previous execution, or
   *  `undefined` if it has never executed before. By setting the `promise`
   *  option to `true`, a promise will be returned instead of the previous
   *  execution result when the function is debounced. The promise will resolve
   *  with the result of the next execution, as soon as it happens.
   * @returns {Function} Returns the new debounced function.
   * @example
   *
   * // Avoid costly calculations while the window size is in flux.
   * window.addEventListener('resize', mergebounce(calculateLayout, 150));
   *
   * // Invoke `sendMail` when clicked, debouncing subsequent calls.
   * element.addEventListner('click', mergebounce(sendMail, 300));
   *
   * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
   * const mergebounced = mergebounce(batchLog, 250, { 'maxWait': 1000 });
   * const source = new EventSource('/stream');
   * jQuery(source).on('message', mergebounced);
   *
   * // Cancel the trailing debounced invocation.
   * window.addEventListener('popstate', mergebounced.cancel);
   */
  function mergebounce(func, wait, options={}) {
    let lastArgs,
        lastThis,
        maxWait,
        result,
        timerId,
        lastCallTime,
        lastInvokeTime = 0,
        maxing = false;

    let promise = options.promise ? getOpenPromise() : null;

    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT$2);
    }
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
      maxing = 'maxWait' in options;
      maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    }

    function invokeFunc(time) {
      const args = lastArgs;
      const thisArg = lastThis;
      const existingPromise = promise;
      lastArgs = lastThis = undefined;
      lastInvokeTime = time;
      result = func.apply(thisArg, args);
      if (options.promise) {
        existingPromise.resolve(result);
        promise = getOpenPromise();
      }
      return options.promise ? existingPromise : result;
    }

    function leadingEdge(time) {
      // Reset any `maxWait` timer.
      lastInvokeTime = time;
      // Start the timer for the trailing edge.
      timerId = setTimeout(timerExpired, wait);
      return options.promise ? promise : result;
    }

    function remainingWait(time) {
      const timeSinceLastCall = time - lastCallTime;
      const timeSinceLastInvoke = time - lastInvokeTime;
      const timeWaiting = wait - timeSinceLastCall;
      return maxing
        ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
        : timeWaiting;
    }

    function shouldInvoke(time) {
      const timeSinceLastCall = time - lastCallTime;
      const timeSinceLastInvoke = time - lastInvokeTime;

      // Either this is the first call, activity has stopped and we're at the
      // trailing edge, the system time has gone backwards and we're treating
      // it as the trailing edge, or we've hit the `maxWait` limit.
      return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
        (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
    }

    function timerExpired() {
      const time = Date.now();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      // Restart the timer.
      timerId = setTimeout(timerExpired, remainingWait(time));
    }

    function trailingEdge(time) {
      timerId = undefined;

      // Only invoke if we have `lastArgs` which means `func` has been
      // debounced at least once.
      if (lastArgs) {
        return invokeFunc(time);
      }
      lastArgs = lastThis = undefined;
      return options.promise ? promise : result;
    }

    function cancel() {
      if (timerId !== undefined) {
        clearTimeout(timerId);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = undefined;
    }

    function flush() {
      return timerId === undefined ? result : trailingEdge(Date.now());
    }

    function concatArrays(objValue, srcValue) {
      if (Array.isArray(objValue) && Array.isArray(srcValue)) {
        if (options?.dedupeArrays) {
          return objValue.concat(srcValue.filter(i => objValue.indexOf(i) === -1));
        } else {
          return objValue.concat(srcValue);
        }
      }
    }

    function mergeArguments(args) {
      if (lastArgs?.length) {
        if (!args.length) {
          return lastArgs;
        }
        if (options?.concatArrays || options?.dedupeArrays) {
          return mergeWith(lastArgs, args, concatArrays);
        } else {
          return merge(lastArgs, args);
        }
      } else {
        return args || [];
      }
    }

    function debounced() {
      const time = Date.now();
      const isInvoking = shouldInvoke(time);

      lastArgs = mergeArguments(Array.from(arguments));
      lastThis = this;
      lastCallTime = time;

      if (isInvoking) {
        if (timerId === undefined) {
          return leadingEdge(lastCallTime);
        }
        if (maxing) {
          // Handle invocations in a tight loop.
          clearTimeout(timerId);
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }
      if (timerId === undefined) {
        timerId = setTimeout(timerExpired, wait);
      }
      return options.promise ? promise : result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }

  function executeCallback$1(promise, callback) {
      if (callback) {
          promise.then(
              function(result) {
                  callback(null, result);
              },
              function(error) {
                  callback(error);
              }
          );
      }
  }

  function getCallback() {
      if (
          arguments.length &&
          typeof arguments[arguments.length - 1] === 'function'
      ) {
          return arguments[arguments.length - 1];
      }
  }

  function normalizeKey(key) {
      // Cast the key to a string, as that's all we can set as a key.
      if (typeof key !== 'string') {
          console.warn(`${key} used as a key, but it is not a string.`);
          key = String(key);
      }

      return key;
  }

  // Abstracts constructing a Blob object, so it also works in older
  // browsers that don't support the native Blob constructor. (i.e.
  // old QtWebKit versions, at least).
  // Abstracts constructing a Blob object, so it also works in older
  // browsers that don't support the native Blob constructor. (i.e.
  // old QtWebKit versions, at least).
  function createBlob(parts, properties) {
      /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
      parts = parts || [];
      properties = properties || {};
      try {
          return new Blob(parts, properties);
      } catch (e) {
          if (e.name !== 'TypeError') {
              throw e;
          }
          var Builder =
              typeof BlobBuilder !== 'undefined'
                  ? BlobBuilder
                  : typeof MSBlobBuilder !== 'undefined'
                    ? MSBlobBuilder
                    : typeof MozBlobBuilder !== 'undefined'
                      ? MozBlobBuilder
                      : WebKitBlobBuilder;
          var builder = new Builder();
          for (var i = 0; i < parts.length; i += 1) {
              builder.append(parts[i]);
          }
          return builder.getBlob(properties.type);
      }
  }

  /* eslint-disable no-bitwise */

  // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
  // it to Base64, so this is how we store it to prevent very strange errors with less
  // verbose ways of binary <-> string data storage.
  var BASE_CHARS =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

  var BLOB_TYPE_PREFIX = '~~local_forage_type~';
  var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

  var SERIALIZED_MARKER = '__lfsc__:';
  var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

  // OMG the serializations!
  var TYPE_ARRAYBUFFER = 'arbf';
  var TYPE_BLOB = 'blob';
  var TYPE_INT8ARRAY = 'si08';
  var TYPE_UINT8ARRAY = 'ui08';
  var TYPE_UINT8CLAMPEDARRAY = 'uic8';
  var TYPE_INT16ARRAY = 'si16';
  var TYPE_INT32ARRAY = 'si32';
  var TYPE_UINT16ARRAY = 'ur16';
  var TYPE_UINT32ARRAY = 'ui32';
  var TYPE_FLOAT32ARRAY = 'fl32';
  var TYPE_FLOAT64ARRAY = 'fl64';
  var TYPE_SERIALIZED_MARKER_LENGTH =
      SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

  var toString = Object.prototype.toString;

  function stringToBuffer(serializedString) {
      // Fill the string into a ArrayBuffer.
      var bufferLength = serializedString.length * 0.75;
      var len = serializedString.length;
      var i;
      var p = 0;
      var encoded1, encoded2, encoded3, encoded4;

      if (serializedString[serializedString.length - 1] === '=') {
          bufferLength--;
          if (serializedString[serializedString.length - 2] === '=') {
              bufferLength--;
          }
      }

      var buffer = new ArrayBuffer(bufferLength);
      var bytes = new Uint8Array(buffer);

      for (i = 0; i < len; i += 4) {
          encoded1 = BASE_CHARS.indexOf(serializedString[i]);
          encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
          encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
          encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

          /*jslint bitwise: true */
          bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
          bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
          bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
      }
      return buffer;
  }

  // Converts a buffer to a string to store, serialized, in the backend
  // storage library.
  function bufferToString(buffer) {
      // base64-arraybuffer
      var bytes = new Uint8Array(buffer);
      var base64String = '';
      var i;

      for (i = 0; i < bytes.length; i += 3) {
          /*jslint bitwise: true */
          base64String += BASE_CHARS[bytes[i] >> 2];
          base64String += BASE_CHARS[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
          base64String +=
              BASE_CHARS[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
          base64String += BASE_CHARS[bytes[i + 2] & 63];
      }

      if (bytes.length % 3 === 2) {
          base64String = base64String.substring(0, base64String.length - 1) + '=';
      } else if (bytes.length % 3 === 1) {
          base64String =
              base64String.substring(0, base64String.length - 2) + '==';
      }

      return base64String;
  }

  // Serialize a value, afterwards executing a callback (which usually
  // instructs the `setItem()` callback/promise to be executed). This is how
  // we store binary data with localStorage.
  function serialize$1(value, callback) {
      var valueType = '';
      if (value) {
          valueType = toString.call(value);
      }

      // Cannot use `value instanceof ArrayBuffer` or such here, as these
      // checks fail when running the tests using casper.js...
      //
      // TODO: See why those tests fail and use a better solution.
      if (
          value &&
          (valueType === '[object ArrayBuffer]' ||
              (value.buffer &&
                  toString.call(value.buffer) === '[object ArrayBuffer]'))
      ) {
          // Convert binary arrays to a string and prefix the string with
          // a special marker.
          var buffer;
          var marker = SERIALIZED_MARKER;

          if (value instanceof ArrayBuffer) {
              buffer = value;
              marker += TYPE_ARRAYBUFFER;
          } else {
              buffer = value.buffer;

              if (valueType === '[object Int8Array]') {
                  marker += TYPE_INT8ARRAY;
              } else if (valueType === '[object Uint8Array]') {
                  marker += TYPE_UINT8ARRAY;
              } else if (valueType === '[object Uint8ClampedArray]') {
                  marker += TYPE_UINT8CLAMPEDARRAY;
              } else if (valueType === '[object Int16Array]') {
                  marker += TYPE_INT16ARRAY;
              } else if (valueType === '[object Uint16Array]') {
                  marker += TYPE_UINT16ARRAY;
              } else if (valueType === '[object Int32Array]') {
                  marker += TYPE_INT32ARRAY;
              } else if (valueType === '[object Uint32Array]') {
                  marker += TYPE_UINT32ARRAY;
              } else if (valueType === '[object Float32Array]') {
                  marker += TYPE_FLOAT32ARRAY;
              } else if (valueType === '[object Float64Array]') {
                  marker += TYPE_FLOAT64ARRAY;
              } else {
                  callback(new Error('Failed to get type for BinaryArray'));
              }
          }

          callback(marker + bufferToString(buffer));
      } else if (valueType === '[object Blob]') {
          // Conver the blob to a binaryArray and then to a string.
          var fileReader = new FileReader();

          fileReader.onload = function() {
              // Backwards-compatible prefix for the blob type.
              var str =
                  BLOB_TYPE_PREFIX +
                  value.type +
                  '~' +
                  bufferToString(this.result);

              callback(SERIALIZED_MARKER + TYPE_BLOB + str);
          };

          fileReader.readAsArrayBuffer(value);
      } else {
          try {
              callback(JSON.stringify(value));
          } catch (e) {
              console.error("Couldn't convert value into a JSON string: ", value);

              callback(null, e);
          }
      }
  }

  // Deserialize data we've inserted into a value column/field. We place
  // special markers into our strings to mark them as encoded; this isn't
  // as nice as a meta field, but it's the only sane thing we can do whilst
  // keeping localStorage support intact.
  //
  // Oftentimes this will just deserialize JSON content, but if we have a
  // special marker (SERIALIZED_MARKER, defined above), we will extract
  // some kind of arraybuffer/binary data/typed array out of the string.
  function deserialize$1(value) {
      // If we haven't marked this string as being specially serialized (i.e.
      // something other than serialized JSON), we can just return it and be
      // done with it.
      if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
          return JSON.parse(value);
      }

      // The following code deals with deserializing some kind of Blob or
      // TypedArray. First we separate out the type of data we're dealing
      // with from the data itself.
      var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
      var type = value.substring(
          SERIALIZED_MARKER_LENGTH,
          TYPE_SERIALIZED_MARKER_LENGTH
      );

      var blobType;
      // Backwards-compatible blob type serialization strategy.
      // DBs created with older versions of localForage will simply not have the blob type.
      if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
          var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
          blobType = matcher[1];
          serializedString = serializedString.substring(matcher[0].length);
      }
      var buffer = stringToBuffer(serializedString);

      // Return the right type based on the code/type set during
      // serialization.
      switch (type) {
          case TYPE_ARRAYBUFFER:
              return buffer;
          case TYPE_BLOB:
              return createBlob([buffer], { type: blobType });
          case TYPE_INT8ARRAY:
              return new Int8Array(buffer);
          case TYPE_UINT8ARRAY:
              return new Uint8Array(buffer);
          case TYPE_UINT8CLAMPEDARRAY:
              return new Uint8ClampedArray(buffer);
          case TYPE_INT16ARRAY:
              return new Int16Array(buffer);
          case TYPE_UINT16ARRAY:
              return new Uint16Array(buffer);
          case TYPE_INT32ARRAY:
              return new Int32Array(buffer);
          case TYPE_UINT32ARRAY:
              return new Uint32Array(buffer);
          case TYPE_FLOAT32ARRAY:
              return new Float32Array(buffer);
          case TYPE_FLOAT64ARRAY:
              return new Float64Array(buffer);
          default:
              throw new Error('Unkown type: ' + type);
      }
  }

  var localforageSerializer = {
      serialize: serialize$1,
      deserialize: deserialize$1};

  // Copyright 2014 Mozilla
  // Copyright 2015 Thodoris Greasidis
  // Copyright 2018-2025 JC Brand
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  const serialize = localforageSerializer['serialize'];
  const deserialize = localforageSerializer['deserialize'];
  function isSessionStorageValid() {
      try {
          if (sessionStorage && 'setItem' in sessionStorage) {
              return true;
          }
      }
      catch (e) {
          console.log(e);
      }
      return false;
  }
  function _getKeyPrefix(options, defaultConfig) {
      let keyPrefix = options.name + '/';
      if (options.storeName !== defaultConfig.storeName) {
          keyPrefix += options.storeName + '/';
      }
      return keyPrefix;
  }
  const dbInfo = {
      keyPrefix: '',
      serializer: {
          serialize: serialize,
          deserialize: deserialize,
      },
  };
  function _initStorage(options) {
      dbInfo.keyPrefix = _getKeyPrefix(options, this._defaultConfig);
      if (options) {
          for (const i in options) {
              dbInfo[i] = options[i];
          }
      }
  }
  // Remove all keys from the datastore, effectively destroying all data in
  // the app's key/value store!
  function clear(callback) {
      const promise = this.ready().then(function () {
          const keyPrefix = dbInfo.keyPrefix;
          for (let i = sessionStorage.length - 1; i >= 0; i--) {
              const key = sessionStorage.key(i);
              if (key && key.indexOf(keyPrefix) === 0) {
                  sessionStorage.removeItem(key);
              }
          }
      });
      executeCallback$1(promise, callback);
      return promise;
  }
  function getItem(key, callback) {
      key = normalizeKey(key);
      const promise = this.ready().then(function () {
          const result = sessionStorage.getItem(dbInfo.keyPrefix + key);
          // If a result was found, parse it from the serialized
          // string into a JS object. If result isn't truthy, the key
          // is likely undefined and we'll pass it straight to the
          // callback.
          if (result) {
              return dbInfo.serializer.deserialize(result);
          }
          return null;
      });
      executeCallback$1(promise, callback);
      return promise;
  }
  function iterate(iterator, callback) {
      const self = this;
      const promise = self.ready().then(function () {
          const keyPrefix = dbInfo.keyPrefix;
          const keyPrefixLength = keyPrefix.length;
          const length = sessionStorage.length;
          let iterationNumber = 1;
          for (let i = 0; i < length; i++) {
              const key = sessionStorage.key(i);
              if (!key || key.indexOf(keyPrefix) !== 0) {
                  continue;
              }
              // If a result was found, parse it from the serialized
              // string into a JS object. If result isn't truthy, the
              // key is likely undefined and we'll pass it straight
              // to the iterator.
              const item = sessionStorage.getItem(key);
              const value = item ? dbInfo.serializer.deserialize(item) : item;
              const result = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
              if (result !== void 0) {
                  return result;
              }
          }
          return;
      });
      executeCallback$1(promise, callback);
      return promise;
  }
  // Same as sessionStorage's key() method, except takes a callback.
  function key(n, callback) {
      const self = this;
      const promise = self.ready().then(function () {
          let result;
          try {
              result = sessionStorage.key(n);
          }
          catch (error) {
              result = null;
          }
          // Remove the prefix from the key, if a key is found.
          if (result) {
              result = result.substring(dbInfo.keyPrefix.length);
          }
          return result;
      });
      executeCallback$1(promise, callback);
      return promise;
  }
  function keys(callback) {
      const self = this;
      const promise = self.ready().then(function () {
          const length = sessionStorage.length;
          const keys = [];
          for (let i = 0; i < length; i++) {
              const itemKey = sessionStorage.key(i);
              if (itemKey && itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                  keys.push(itemKey.substring(dbInfo.keyPrefix.length));
              }
          }
          return keys;
      });
      executeCallback$1(promise, callback);
      return promise;
  }
  // Supply the number of keys in the datastore to the callback function.
  function length(callback) {
      const self = this;
      const promise = self.keys().then(function (keys) {
          return keys.length;
      });
      executeCallback$1(promise, callback);
      return promise;
  }
  function removeItem(key, callback) {
      key = normalizeKey(key);
      const promise = this.ready().then(function () {
          sessionStorage.removeItem(dbInfo.keyPrefix + key);
      });
      executeCallback$1(promise, callback);
      return promise;
  }
  async function setItem(key, value, callback) {
      key = normalizeKey(key);
      await this.ready();
      value = value ?? null;
      const originalValue = value;
      return new Promise((resolve, reject) => {
          dbInfo.serializer.serialize(value, (serializedValue, error) => {
              if (error) {
                  reject(error);
                  executeCallback$1(Promise.reject(error), callback);
                  return;
              }
              try {
                  sessionStorage.setItem(dbInfo.keyPrefix + key, serializedValue);
                  resolve(originalValue);
                  executeCallback$1(Promise.resolve(originalValue), callback);
              }
              catch (e) {
                  if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                      console.error('Your sessionStorage capacity is used up.');
                  }
                  reject(e);
                  executeCallback$1(Promise.reject(e), callback);
              }
          });
      });
  }
  function dropInstance(options, callback) {
      callback = getCallback.apply(this, arguments);
      options = (typeof options !== 'function' && options) || {};
      if (!options.name) {
          const currentConfig = this.config();
          options.name = options.name || currentConfig.name;
          options.storeName = options.storeName || currentConfig.storeName;
      }
      const self = this;
      let promise;
      if (!options.name) {
          promise = Promise.reject(new Error('Invalid arguments'));
      }
      else {
          promise = new Promise(function (resolve) {
              if (!options.storeName) {
                  resolve(`${options.name}/`);
              }
              else {
                  resolve(_getKeyPrefix(options, self._defaultConfig));
              }
          }).then(function (keyPrefix) {
              for (let i = sessionStorage.length - 1; i >= 0; i--) {
                  const key = sessionStorage.key(i);
                  if (key && key.indexOf(keyPrefix) === 0) {
                      sessionStorage.removeItem(key);
                  }
              }
          });
      }
      executeCallback$1(promise, callback);
      return promise;
  }
  const sessionStorageWrapper = {
      _driver: 'sessionStorageWrapper',
      _initStorage: _initStorage,
      _support: isSessionStorageValid(),
      iterate,
      getItem,
      setItem,
      removeItem,
      clear,
      length,
      key,
      keys,
      dropInstance,
  };

  var localforageSetitems$1 = {exports: {}};

  var localforageSetitems = localforageSetitems$1.exports;

  var hasRequiredLocalforageSetitems;

  function requireLocalforageSetitems () {
  	if (hasRequiredLocalforageSetitems) return localforageSetitems$1.exports;
  	hasRequiredLocalforageSetitems = 1;
  	(function (module, exports) {
  		(function (global, factory) {
  		    factory(exports, requireLocalforage()) ;
  		}(localforageSetitems, (function (exports,localforage) {
  		localforage = 'default' in localforage ? localforage['default'] : localforage;

  		function getSerializerPromise(localForageInstance) {
  		    if (getSerializerPromise.result) {
  		        return getSerializerPromise.result;
  		    }
  		    if (!localForageInstance || typeof localForageInstance.getSerializer !== 'function') {
  		        return Promise.reject(new Error('localforage.getSerializer() was not available! ' + 'localforage v1.4+ is required!'));
  		    }
  		    getSerializerPromise.result = localForageInstance.getSerializer();
  		    return getSerializerPromise.result;
  		}



  		function executeCallback(promise, callback) {
  		    if (callback) {
  		        promise.then(function (result) {
  		            callback(null, result);
  		        }, function (error) {
  		            callback(error);
  		        });
  		    }
  		}

  		function forEachItem(items, keyFn, valueFn, loopFn) {
  		    function ensurePropGetterMethod(propFn, defaultPropName) {
  		        var propName = propFn || defaultPropName;

  		        if ((!propFn || typeof propFn !== 'function') && typeof propName === 'string') {
  		            propFn = function propFn(item) {
  		                return item[propName];
  		            };
  		        }
  		        return propFn;
  		    }

  		    var result = [];
  		    // http://stackoverflow.com/questions/4775722/check-if-object-is-array
  		    if (Object.prototype.toString.call(items) === '[object Array]') {
  		        keyFn = ensurePropGetterMethod(keyFn, 'key');
  		        valueFn = ensurePropGetterMethod(valueFn, 'value');

  		        for (var i = 0, len = items.length; i < len; i++) {
  		            var item = items[i];
  		            result.push(loopFn(keyFn(item), valueFn(item)));
  		        }
  		    } else {
  		        for (var prop in items) {
  		            if (items.hasOwnProperty(prop)) {
  		                result.push(loopFn(prop, items[prop]));
  		            }
  		        }
  		    }
  		    return result;
  		}

  		function setItemsIndexedDB(items, keyFn, valueFn, callback) {
  		    var localforageInstance = this;

  		    var promise = localforageInstance.ready().then(function () {
  		        return new Promise(function (resolve, reject) {
  		            // Inspired from @lu4 PR mozilla/localForage#318
  		            var dbInfo = localforageInstance._dbInfo;
  		            var transaction = dbInfo.db.transaction(dbInfo.storeName, 'readwrite');
  		            var store = transaction.objectStore(dbInfo.storeName);
  		            var lastError;

  		            transaction.oncomplete = function () {
  		                resolve(items);
  		            };
  		            transaction.onabort = transaction.onerror = function (event) {
  		                reject(lastError || event.target);
  		            };

  		            function requestOnError(evt) {
  		                var request = evt.target || this;
  		                lastError = request.error || request.transaction.error;
  		                reject(lastError);
  		            }

  		            forEachItem(items, keyFn, valueFn, function (key, value) {
  		                // The reason we don't _save_ null is because IE 10 does
  		                // not support saving the `null` type in IndexedDB. How
  		                // ironic, given the bug below!
  		                // See: https://github.com/mozilla/localForage/issues/161
  		                if (value === null) {
  		                    value = undefined;
  		                }
  		                var request = store.put(value, key);
  		                request.onerror = requestOnError;
  		            });
  		        });
  		    });
  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function setItemsWebsql(items, keyFn, valueFn, callback) {
  		    var localforageInstance = this;
  		    var promise = new Promise(function (resolve, reject) {
  		        localforageInstance.ready().then(function () {
  		            return getSerializerPromise(localforageInstance);
  		        }).then(function (serializer) {
  		            // Inspired from @lu4 PR mozilla/localForage#318
  		            var dbInfo = localforageInstance._dbInfo;
  		            dbInfo.db.transaction(function (t) {

  		                var query = 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' (key, value) VALUES (?, ?)';

  		                var itemPromises = forEachItem(items, keyFn, valueFn, function (key, value) {
  		                    return new Promise(function (resolve, reject) {
  		                        serializer.serialize(value, function (value, error) {
  		                            if (error) {
  		                                reject(error);
  		                            } else {
  		                                t.executeSql(query, [key, value], function () {
  		                                    resolve();
  		                                }, function (t, error) {
  		                                    reject(error);
  		                                });
  		                            }
  		                        });
  		                    });
  		                });

  		                Promise.all(itemPromises).then(function () {
  		                    resolve(items);
  		                }, reject);
  		            }, function (sqlError) {
  		                reject(sqlError);
  		            } /*, function() {
  		                 if (resolving) {
  		                     resolve(items);
  		                 }
  		              }*/);
  		        }).catch(reject);
  		    });
  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function setItemsGeneric(items, keyFn, valueFn, callback) {
  		    var localforageInstance = this;

  		    var itemPromises = forEachItem(items, keyFn, valueFn, function (key, value) {
  		        return localforageInstance.setItem(key, value);
  		    });
  		    var promise = Promise.all(itemPromises);

  		    executeCallback(promise, callback);
  		    return promise;
  		}

  		function localforageSetItems(items, keyFn, valueFn, callback) {
  		    var localforageInstance = this;
  		    var currentDriver = localforageInstance.driver();

  		    if (currentDriver === localforageInstance.INDEXEDDB) {
  		        return setItemsIndexedDB.call(localforageInstance, items, keyFn, valueFn, callback);
  		    } else if (currentDriver === localforageInstance.WEBSQL) {
  		        return setItemsWebsql.call(localforageInstance, items, keyFn, valueFn, callback);
  		    } else {
  		        return setItemsGeneric.call(localforageInstance, items, keyFn, valueFn, callback);
  		    }
  		}

  		function extendPrototype(localforage$$1) {
  		    var localforagePrototype = Object.getPrototypeOf(localforage$$1);
  		    if (localforagePrototype) {
  		        localforagePrototype.setItems = localforageSetItems;
  		        localforagePrototype.setItems.indexedDB = function () {
  		            return setItemsIndexedDB.apply(this, arguments);
  		        };
  		        localforagePrototype.setItems.websql = function () {
  		            return setItemsWebsql.apply(this, arguments);
  		        };
  		        localforagePrototype.setItems.generic = function () {
  		            return setItemsGeneric.apply(this, arguments);
  		        };
  		    }
  		}

  		var extendPrototypeResult = extendPrototype(localforage);

  		exports.setItemsGeneric = setItemsGeneric;
  		exports.localforageSetItems = localforageSetItems;
  		exports.extendPrototype = extendPrototype;
  		exports.extendPrototypeResult = extendPrototypeResult;

  		Object.defineProperty(exports, '__esModule', { value: true });

  		}))); 
  	} (localforageSetitems$1, localforageSetitems$1.exports));
  	return localforageSetitems$1.exports;
  }

  var localforageSetitemsExports = requireLocalforageSetitems();

  function getSerializerPromise(localForageInstance) {
      if (getSerializerPromise.result) {
          return getSerializerPromise.result;
      }
      if (!localForageInstance || typeof localForageInstance.getSerializer !== 'function') {
          return Promise.reject(new Error('localforage.getSerializer() was not available! ' + 'localforage v1.4+ is required!'));
      }
      getSerializerPromise.result = localForageInstance.getSerializer();
      return getSerializerPromise.result;
  }



  function executeCallback(promise, callback) {
      if (callback) {
          promise.then(function (result) {
              callback(null, result);
          }, function (error) {
              callback(error);
          });
      }
      return promise;
  }

  function getItemKeyValue(key, callback) {
      var localforageInstance = this;
      var promise = localforageInstance.getItem(key).then(function (value) {
          return {
              key: key,
              value: value
          };
      });
      executeCallback(promise, callback);
      return promise;
  }

  function getItemsGeneric(keys /*, callback*/) {
      var localforageInstance = this;
      var promise = new Promise(function (resolve, reject) {
          var itemPromises = [];

          for (var i = 0, len = keys.length; i < len; i++) {
              itemPromises.push(getItemKeyValue.call(localforageInstance, keys[i]));
          }

          Promise.all(itemPromises).then(function (keyValuePairs) {
              var result = {};
              for (var i = 0, len = keyValuePairs.length; i < len; i++) {
                  var keyValuePair = keyValuePairs[i];

                  result[keyValuePair.key] = keyValuePair.value;
              }
              resolve(result);
          }).catch(reject);
      });
      return promise;
  }





  function getAllItemsUsingIterate() {
      var localforageInstance = this;
      var accumulator = {};
      return localforageInstance.iterate(function (value, key /*, iterationNumber*/) {
          accumulator[key] = value;
      }).then(function () {
          return accumulator;
      });
  }

  function getIDBKeyRange() {
      /* global IDBKeyRange, webkitIDBKeyRange, mozIDBKeyRange */
      if (typeof IDBKeyRange !== 'undefined') {
          return IDBKeyRange;
      }
      if (typeof webkitIDBKeyRange !== 'undefined') {
          return webkitIDBKeyRange;
      }
      if (typeof mozIDBKeyRange !== 'undefined') {
          return mozIDBKeyRange;
      }
  }

  var idbKeyRange = getIDBKeyRange();

  function getItemsIndexedDB(keys /*, callback*/) {
      keys = keys.slice();
      var localforageInstance = this;
      function comparer(a, b) {
          return a < b ? -1 : a > b ? 1 : 0;
      }

      var promise = new Promise(function (resolve, reject) {
          localforageInstance.ready().then(function () {
              // Thanks https://hacks.mozilla.org/2014/06/breaking-the-borders-of-indexeddb/
              var dbInfo = localforageInstance._dbInfo;
              var store = dbInfo.db.transaction(dbInfo.storeName, 'readonly').objectStore(dbInfo.storeName);

              var set = keys.sort(comparer);

              var keyRangeValue = idbKeyRange.bound(keys[0], keys[keys.length - 1], false, false);

              var req;

              if ('getAll' in store) {
                  req = store.getAll(keyRangeValue);
                  req.onsuccess = function () {
                      var value = req.result;
                      if (value === undefined) {
                          value = null;
                      }
                      resolve(value);
                  };
              } else {
                  req = store.openCursor(keyRangeValue);
                  var result = {};
                  var i = 0;

                  req.onsuccess = function () /*event*/{
                      var cursor = req.result; // event.target.result;

                      if (!cursor) {
                          resolve(result);
                          return;
                      }

                      var key = cursor.key;

                      while (key > set[i]) {
                          i++; // The cursor has passed beyond this key. Check next.

                          if (i === set.length) {
                              // There is no next. Stop searching.
                              resolve(result);
                              return;
                          }
                      }

                      if (key === set[i]) {
                          // The current cursor value should be included and we should continue
                          // a single step in case next item has the same key or possibly our
                          // next key in set.
                          var value = cursor.value;
                          if (value === undefined) {
                              value = null;
                          }

                          result[key] = value;
                          // onfound(cursor.value);
                          cursor.continue();
                      } else {
                          // cursor.key not yet at set[i]. Forward cursor to the next key to hunt for.
                          cursor.continue(set[i]);
                      }
                  };
              }

              req.onerror = function () /*event*/{
                  reject(req.error);
              };
          }).catch(reject);
      });
      return promise;
  }

  function getItemsWebsql(keys /*, callback*/) {
      var localforageInstance = this;
      var promise = new Promise(function (resolve, reject) {
          localforageInstance.ready().then(function () {
              return getSerializerPromise(localforageInstance);
          }).then(function (serializer) {
              var dbInfo = localforageInstance._dbInfo;
              dbInfo.db.transaction(function (t) {

                  var queryParts = new Array(keys.length);
                  for (var i = 0, len = keys.length; i < len; i++) {
                      queryParts[i] = '?';
                  }

                  t.executeSql('SELECT * FROM ' + dbInfo.storeName + ' WHERE (key IN (' + queryParts.join(',') + '))', keys, function (t, results) {

                      var result = {};

                      var rows = results.rows;
                      for (var i = 0, len = rows.length; i < len; i++) {
                          var item = rows.item(i);
                          var value = item.value;

                          // Check to see if this is serialized content we need to
                          // unpack.
                          if (value) {
                              value = serializer.deserialize(value);
                          }

                          result[item.key] = value;
                      }

                      resolve(result);
                  }, function (t, error) {
                      reject(error);
                  });
              });
          }).catch(reject);
      });
      return promise;
  }

  function localforageGetItems(keys, callback) {
      var localforageInstance = this;

      var promise;
      if (!arguments.length || keys === null) {
          promise = getAllItemsUsingIterate.apply(localforageInstance);
      } else {
          var currentDriver = localforageInstance.driver();
          if (currentDriver === localforageInstance.INDEXEDDB) {
              promise = getItemsIndexedDB.apply(localforageInstance, arguments);
          } else if (currentDriver === localforageInstance.WEBSQL) {
              promise = getItemsWebsql.apply(localforageInstance, arguments);
          } else {
              promise = getItemsGeneric.apply(localforageInstance, arguments);
          }
      }

      executeCallback(promise, callback);
      return promise;
  }

  function extendPrototype(localforage$$1) {
      var localforagePrototype = Object.getPrototypeOf(localforage$$1);
      if (localforagePrototype) {
          localforagePrototype.getItems = localforageGetItems;
          localforagePrototype.getItems.indexedDB = function () {
              return getItemsIndexedDB.apply(this, arguments);
          };
          localforagePrototype.getItems.websql = function () {
              return getItemsWebsql.apply(this, arguments);
          };
          localforagePrototype.getItems.generic = function () {
              return getItemsGeneric.apply(this, arguments);
          };
      }
  }

  extendPrototype(localForage);

  /** Used for built-in method references. */
  var objectProto$6 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

  /**
   * The base implementation of `_.has` without support for deep paths.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {Array|string} key The key to check.
   * @returns {boolean} Returns `true` if `key` exists, else `false`.
   */
  function baseHas(object, key) {
    return object != null && hasOwnProperty$5.call(object, key);
  }

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/;

  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */
  function isKey(value, object) {
    if (isArray(value)) {
      return false;
    }
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' ||
        value == null || isSymbol(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
      (object != null && value in Object(object));
  }

  /** Error message constants. */
  var FUNC_ERROR_TEXT$1 = 'Expected a function';

  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `clear`, `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */
  function memoize(func, resolver) {
    if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
      throw new TypeError(FUNC_ERROR_TEXT$1);
    }
    var memoized = function() {
      var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;

      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result) || cache;
      return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
  }

  // Expose `MapCache`.
  memoize.Cache = MapCache;

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /**
   * A specialized version of `_.memoize` which clears the memoized function's
   * cache when it exceeds `MAX_MEMOIZE_SIZE`.
   *
   * @private
   * @param {Function} func The function to have its output memoized.
   * @returns {Function} Returns the new memoized function.
   */
  function memoizeCapped(func) {
    var result = memoize(func, function(key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }
      return key;
    });

    var cache = result.cache;
    return result;
  }

  /** Used to match property names within property paths. */
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */
  var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */) {
      result.push('');
    }
    string.replace(rePropName, function(match, number, quote, subString) {
      result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
    });
    return result;
  });

  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @param {Object} [object] The object to query keys on.
   * @returns {Array} Returns the cast property path array.
   */
  function castPath(value, object) {
    if (isArray(value)) {
      return value;
    }
    return isKey(value, object) ? [value] : stringToPath(toString$2(value));
  }

  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */
  function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
      return value;
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -Infinity) ? '-0' : result;
  }

  /**
   * Checks if `path` exists on `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @param {Function} hasFunc The function to check properties.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   */
  function hasPath(object, path, hasFunc) {
    path = castPath(path, object);

    var index = -1,
        length = path.length,
        result = false;

    while (++index < length) {
      var key = toKey(path[index]);
      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result || ++index != length) {
      return result;
    }
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) &&
      (isArray(object) || isArguments(object));
  }

  /**
   * Checks if `path` is a direct property of `object`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = { 'a': { 'b': 2 } };
   * var other = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.has(object, 'a');
   * // => true
   *
   * _.has(object, 'a.b');
   * // => true
   *
   * _.has(object, ['a', 'b']);
   * // => true
   *
   * _.has(other, 'a');
   * // => false
   */
  function has(object, path) {
    return object != null && hasPath(object, path, baseHas);
  }

  /**
   * This method is like `_.get` except that if the resolved value is a
   * function it's invoked with the `this` binding of its parent object and
   * its result is returned.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to resolve.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
   *
   * _.result(object, 'a[0].b.c1');
   * // => 3
   *
   * _.result(object, 'a[0].b.c2');
   * // => 4
   *
   * _.result(object, 'a[0].b.c3', 'default');
   * // => 'default'
   *
   * _.result(object, 'a[0].b.c3', _.constant('default'));
   * // => 'default'
   */
  function result(object, path, defaultValue) {
    path = castPath(path, object);

    var index = -1,
        length = path.length;

    // Ensure the loop is entered when path is empty.
    if (!length) {
      length = 1;
      object = undefined;
    }
    while (++index < length) {
      var value = object == null ? undefined : object[toKey(path[index])];
      if (value === undefined) {
        index = length;
        value = defaultValue;
      }
      object = isFunction(value) ? value.call(object) : value;
    }
    return object;
  }

  // (c) 2010-2019 Jeremy Ashkenas and DocumentCloud
  // (c) 2018-2025 JC Brand
  function S4() {
      // Generate four random hex digits.
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  function guid() {
      // Generate a pseudo-GUID by concatenating random hexadecimal.
      return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
  }
  function getResolveablePromise() {
      const wrapper = {
          isResolved: false,
          isPending: true,
          isRejected: false,
          resolve: null,
          reject: null,
      };
      const promise = new Promise((resolve, reject) => {
          wrapper.resolve = resolve;
          wrapper.reject = reject;
      });
      Object.assign(promise, wrapper);
      promise.then(function (v) {
          promise.isResolved = true;
          promise.isPending = false;
          promise.isRejected = false;
          return v;
      }, function (e) {
          promise.isResolved = false;
          promise.isPending = false;
          promise.isRejected = true;
          throw e;
      });
      return promise;
  }
  // Throw an error when a URL is needed, and none is supplied.
  function urlError() {
      throw new Error('A "url" property or function must be specified');
  }
  // Wrap an optional error callback with a fallback error event.
  function wrapError(model, options) {
      const error = options.error;
      options.error = function (resp) {
          if (error)
              error.call(options.context, model, resp, options);
          model.trigger('error', model, resp, options);
      };
  }
  // Map from CRUD to HTTP for our default `sync` implementation.
  const methodMap = {
      create: 'POST',
      update: 'PUT',
      patch: 'PATCH',
      delete: 'DELETE',
      read: 'GET',
  };
  function getSyncMethod(model) {
      const store = result(model, 'browserStorage') || result(model.collection, 'browserStorage');
      return store ? store.sync() : sync;
  }
  /**
   * Override this function to change the manner in which Backbone persists
   * models to the server. You will be passed the type of request, and the
   * model in question. By default makes a `fetch()` API call
   * to the model's `url()`.
   *
   * Some possible customizations could be:
   *
   * - Use `setTimeout` to batch rapid-fire updates into a single request.
   * - Persist models via WebSockets instead of Ajax.
   * - Persist models to browser storage
   */
  /**
   * @public
   */
  function sync(method, model, options = {}) {
      let data = options.data;
      // Ensure that we have the appropriate request data.
      if (data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
          data = options.attrs || model.toJSON();
      }
      const type = methodMap[method];
      const params = {
          method: type,
          body: data ? JSON.stringify(data) : '',
          headers: {
              'Content-Type': 'application/json',
          },
          success: options.success,
          error: options.error,
      };
      const url = options.url || result(model, 'url') || urlError();
      const xhr = fetch(url, params);
      if (options) {
          options.xhr = xhr;
      }
      model.trigger('request', model, xhr, { ...params, xhr });
      return xhr;
  }

  /**
   * IndexedDB, localStorage and sessionStorage adapter
   */
  const IN_MEMORY = _driver;
  localForage.defineDriver(memoryDriver);
  localforageSetitemsExports.extendPrototype(localForage);
  extendPrototype(localForage);
  /**
   * @public
   */
  class BrowserStorage {
      constructor(id, type, batchedWrites = false) {
          if (type === 'local' && !window.localStorage) {
              throw new Error('Skeletor.storage: Environment does not support localStorage.');
          }
          else if (type === 'session' && !window.sessionStorage) {
              throw new Error('Skeletor.storage: Environment does not support sessionStorage.');
          }
          if (isString(type)) {
              this.storeInitialized = this.initStore(type, batchedWrites);
          }
          else {
              this.store = type;
              if (batchedWrites) {
                  this.store.debouncedSetItems = mergebounce((items) => this.store.setItems(items), 50, {
                      'promise': true,
                  });
              }
              this.storeInitialized = Promise.resolve();
          }
          this.name = id;
      }
      /**
       * @param type - The storage type: 'local', 'session', 'indexed', or 'in_memory'
       * @param batchedWrites - Whether to enable batched writes
       */
      async initStore(type, batchedWrites) {
          if (type === 'session') {
              await localForage.setDriver(sessionStorageWrapper._driver);
          }
          else if (type === 'local') {
              await localForage.config({ 'driver': localForage.LOCALSTORAGE });
          }
          else if (type === 'in_memory') {
              await localForage.config({ 'driver': IN_MEMORY });
          }
          else if (type !== 'indexed') {
              throw new Error('Skeletor.storage: No storage type was specified');
          }
          this.store = localForage;
          if (batchedWrites) {
              this.store.debouncedSetItems = mergebounce((items) => this.store.setItems(items), 50, {
                  'promise': true,
              });
          }
      }
      flush() {
          if (this.store.debouncedSetItems && typeof this.store.debouncedSetItems.flush === 'function') {
              this.store.debouncedSetItems.flush();
          }
      }
      async clear() {
          await this.store.removeItem(this.name).catch((e) => console.error(e));
          const re = new RegExp(`^${this.name}-`);
          const keys = await this.store.keys();
          const removed_keys = keys.filter((k) => re.test(k));
          await Promise.all(removed_keys.map((k) => this.store.removeItem(k).catch((e) => console.error(e))));
      }
      sync() {
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const that = this;
          async function localSync(method, model, options) {
              let resp, errorMessage, promise, new_attributes;
              // We get the collection (and if necessary the model attribute.
              // Waiting for storeInitialized will cause another iteration of
              // the event loop, after which the collection reference will
              // be removed from the model.
              const collection = model.collection;
              if (['patch', 'update'].includes(method)) {
                  new_attributes = cloneDeep(model.attributes);
              }
              await that.storeInitialized;
              try {
                  const original_attributes = model.attributes;
                  switch (method) {
                      case 'read':
                          if (model.id !== undefined) {
                              resp = await that.find(model);
                          }
                          else {
                              resp = await that.findAll();
                          }
                          break;
                      case 'create':
                          resp = await that.create(model, options);
                          break;
                      case 'patch':
                      case 'update':
                          if (options.wait) {
                              // When `wait` is set to true, Skeletor waits until
                              // confirmation of storage before setting the values on
                              // the model.
                              // However, the new attributes needs to be sent, so it
                              // sets them manually on the model and then removes
                              // them after calling `sync`.
                              // Because our `sync` method is asynchronous and we
                              // wait for `storeInitialized`, the attributes are
                              // already restored once we get here, so we need to do
                              // the attributes dance again.
                              model.attributes = new_attributes;
                          }
                          promise = that.update(model);
                          if (options.wait) {
                              model.attributes = original_attributes;
                          }
                          resp = await promise;
                          break;
                      case 'delete':
                          resp = await that.destroy(model, collection);
                          break;
                  }
              }
              catch (error) {
                  const storageSize = await that.getStorageSize();
                  if (error.code === 22 && storageSize === 0) {
                      errorMessage = 'Private browsing is unsupported';
                  }
                  else {
                      errorMessage = error.message;
                  }
              }
              if (resp) {
                  if (options && options.success) {
                      // When storing, we don't pass back the response (which is
                      // the set attributes returned from localforage because
                      // Skeletor sets them again on the model and due to the async
                      // nature of localforage it can cause stale attributes to be
                      // set on a model after it's been updated in the meantime.
                      const data = method === 'read' ? resp : null;
                      options.success(data, options);
                  }
              }
              else {
                  errorMessage = errorMessage ? errorMessage : 'Record Not Found';
                  if (options && options.error) {
                      options.error(errorMessage);
                  }
              }
          }
          localSync.__name__ = 'localSync';
          return localSync;
      }
      removeCollectionReference(model, collection) {
          if (!collection) {
              return;
          }
          const ids = collection.filter((m) => m.id !== model.id).map((m) => this.getItemName(m.id));
          return this.store.setItem(this.name, ids);
      }
      addCollectionReference(model, collection) {
          if (!collection) {
              return;
          }
          const ids = collection.map((m) => this.getItemName(m.id));
          const new_id = this.getItemName(model.id);
          if (!ids.includes(new_id)) {
              ids.push(new_id);
          }
          return this.store.setItem(this.name, ids);
      }
      getCollectionReferenceData(model) {
          if (!model.collection) {
              return {};
          }
          const ids = model.collection.map((m) => this.getItemName(m.id));
          const new_id = this.getItemName(model.id);
          if (!ids.includes(new_id)) {
              ids.push(new_id);
          }
          const result = {};
          result[this.name] = ids;
          return result;
      }
      async save(model) {
          if (this.store.setItems) {
              const items = {};
              items[this.getItemName(model.id)] = model.toJSON();
              Object.assign(items, this.getCollectionReferenceData(model));
              return this.store.debouncedSetItems ? this.store.debouncedSetItems(items) : this.store.setItems(items);
          }
          else {
              const key = this.getItemName(model.id);
              const data = await this.store.setItem(key, model.toJSON());
              await this.addCollectionReference(model, model.collection);
              return data;
          }
      }
      create(model, options) {
          /* Add a model, giving it a (hopefully)-unique GUID, if it doesn't already
           * have an id of it's own.
           */
          if (!model.id) {
              model.id = guid();
              model.set(model.idAttribute, model.id, options);
          }
          return this.save(model);
      }
      update(model) {
          return this.save(model);
      }
      find(model) {
          return this.store.getItem(this.getItemName(model.id));
      }
      async findAll() {
          /* Return the array of all models currently in storage.
           */
          const keys = (await this.store.getItem(this.name));
          if (keys?.length) {
              const items = await this.store.getItems(keys);
              return Object.values(items);
          }
          return [];
      }
      async destroy(model, collection) {
          await this.flush();
          await this.store.removeItem(this.getItemName(model.id));
          await this.removeCollectionReference(model, collection);
          return model;
      }
      async getStorageSize() {
          return await this.store.length();
      }
      getItemName(id) {
          return this.name + '-' + id;
      }
  }
  BrowserStorage.sessionStorageInitialized = localForage.defineDriver(sessionStorageWrapper);
  BrowserStorage.localForage = localForage;

  /** Used to compose bitmasks for cloning. */
  var CLONE_SYMBOLS_FLAG$1 = 4;

  /**
   * Creates a shallow clone of `value`.
   *
   * **Note:** This method is loosely based on the
   * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
   * and supports cloning arrays, array buffers, booleans, date objects, maps,
   * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
   * arrays. The own enumerable properties of `arguments` objects are cloned
   * as plain objects. An empty object is returned for uncloneable values such
   * as error objects, functions, DOM nodes, and WeakMaps.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to clone.
   * @returns {*} Returns the cloned value.
   * @see _.cloneDeep
   * @example
   *
   * var objects = [{ 'a': 1 }, { 'b': 2 }];
   *
   * var shallow = _.clone(objects);
   * console.log(shallow[0] === objects[0]);
   * // => true
   */
  function clone(value) {
    return baseClone(value, CLONE_SYMBOLS_FLAG$1);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * The base implementation of `_.forOwn` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Object} Returns `object`.
   */
  function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys$2);
  }

  /**
   * Creates a `baseEach` or `baseEachRight` function.
   *
   * @private
   * @param {Function} eachFunc The function to iterate over a collection.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
      if (collection == null) {
        return collection;
      }
      if (!isArrayLike(collection)) {
        return eachFunc(collection, iteratee);
      }
      var length = collection.length,
          index = -1,
          iterable = Object(collection);

      while ((++index < length)) {
        if (iteratee(iterable[index], index, iterable) === false) {
          break;
        }
      }
      return collection;
    };
  }

  /**
   * The base implementation of `_.forEach` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array|Object} Returns `collection`.
   */
  var baseEach = createBaseEach(baseForOwn);

  /**
   * Aggregates elements of `collection` on `accumulator` with keys transformed
   * by `iteratee` and values set by `setter`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function baseAggregator(collection, setter, iteratee, accumulator) {
    baseEach(collection, function(value, key, collection) {
      setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
  }

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
  }

  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */
  function setCacheHas(value) {
    return this.__data__.has(value);
  }

  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */
  function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;

    this.__data__ = new MapCache;
    while (++index < length) {
      this.add(values[index]);
    }
  }

  // Add methods to `SetCache`.
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$5 = 1,
      COMPARE_UNORDERED_FLAG$3 = 2;

  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
        arrLength = array.length,
        othLength = other.length;

    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) {
      return arrStacked == other && othStacked == array;
    }
    var index = -1,
        result = true,
        seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;

    stack.set(array, other);
    stack.set(other, array);

    // Ignore non-index properties.
    while (++index < arrLength) {
      var arrValue = array[index],
          othValue = other[index];

      if (customizer) {
        var compared = isPartial
          ? customizer(othValue, arrValue, index, other, array, stack)
          : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== undefined) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      // Recursively compare arrays (susceptible to call stack limits).
      if (seen) {
        if (!arraySome(other, function(othValue, othIndex) {
              if (!cacheHas(seen, othIndex) &&
                  (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
          result = false;
          break;
        }
      } else if (!(
            arrValue === othValue ||
              equalFunc(arrValue, othValue, bitmask, customizer, stack)
          )) {
        result = false;
        break;
      }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$4 = 1,
      COMPARE_UNORDERED_FLAG$2 = 2;

  /** `Object#toString` result references. */
  var boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]';

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if ((object.byteLength != other.byteLength) ||
            (object.byteOffset != other.byteOffset)) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;

      case arrayBufferTag:
        if ((object.byteLength != other.byteLength) ||
            !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
          return false;
        }
        return true;

      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);

      case errorTag:
        return object.name == other.name && object.message == other.message;

      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == (other + '');

      case mapTag:
        var convert = mapToArray;

      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
        convert || (convert = setToArray);

        if (object.size != other.size && !isPartial) {
          return false;
        }
        // Assume cyclic values are equal.
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG$2;

        // Recursively compare objects (susceptible to call stack limits).
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack['delete'](object);
        return result;

      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$3 = 1;

  /** Used for built-in method references. */
  var objectProto$5 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
        objProps = getAllKeys(object),
        objLength = objProps.length,
        othProps = getAllKeys(other),
        othLength = othProps.length;

    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty$4.call(other, key))) {
        return false;
      }
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) {
      return objStacked == other && othStacked == object;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);

    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
          othValue = other[key];

      if (customizer) {
        var compared = isPartial
          ? customizer(othValue, objValue, key, other, object, stack)
          : customizer(objValue, othValue, key, object, other, stack);
      }
      // Recursively compare objects (susceptible to call stack limits).
      if (!(compared === undefined
            ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
            : compared
          )) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor,
          othCtor = other.constructor;

      // Non `Object` object instances with different constructors are not equal.
      if (objCtor != othCtor &&
          ('constructor' in object && 'constructor' in other) &&
          !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
            typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
  }

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$2 = 1;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      objectTag = '[object Object]';

  /** Used for built-in method references. */
  var objectProto$4 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = objIsArr ? arrayTag : getTag(object),
        othTag = othIsArr ? arrayTag : getTag(other);

    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;

    var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;

    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack);
      return (objIsArr || isTypedArray(object))
        ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
        : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
      var objIsWrapped = objIsObj && hasOwnProperty$3.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty$3.call(other, '__wrapped__');

      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;

        stack || (stack = new Stack);
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }

  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Unordered comparison
   *  2 - Partial comparison
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$1 = 1,
      COMPARE_UNORDERED_FLAG$1 = 2;

  /**
   * The base implementation of `_.isMatch` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to inspect.
   * @param {Object} source The object of property values to match.
   * @param {Array} matchData The property names, values, and compare flags to match.
   * @param {Function} [customizer] The function to customize comparisons.
   * @returns {boolean} Returns `true` if `object` is a match, else `false`.
   */
  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length,
        length = index;

    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if ((data[2])
            ? data[1] !== object[data[0]]
            : !(data[0] in object)
          ) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0],
          objValue = object[key],
          srcValue = data[1];

      if (data[2]) {
        if (objValue === undefined && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack;
        var result; 
        if (!(result === undefined
              ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
              : result
            )) {
          return false;
        }
      }
    }
    return true;
  }

  /**
   * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` if suitable for strict
   *  equality comparisons, else `false`.
   */
  function isStrictComparable(value) {
    return value === value && !isObject$1(value);
  }

  /**
   * Gets the property names, values, and compare flags of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the match data of `object`.
   */
  function getMatchData(object) {
    var result = keys$2(object),
        length = result.length;

    while (length--) {
      var key = result[length],
          value = object[key];

      result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
  }

  /**
   * A specialized version of `matchesProperty` for source values suitable
   * for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function matchesStrictComparable(key, srcValue) {
    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue &&
        (srcValue !== undefined || (key in Object(object)));
    };
  }

  /**
   * The base implementation of `_.matches` which doesn't clone `source`.
   *
   * @private
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }
    return function(object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }

  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */
  function baseGet(object, path) {
    path = castPath(path, object);

    var index = 0,
        length = path.length;

    while (object != null && index < length) {
      object = object[toKey(path[index++])];
    }
    return (index && index == length) ? object : undefined;
  }

  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */
  function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }

  /**
   * The base implementation of `_.hasIn` without support for deep paths.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {Array|string} key The key to check.
   * @returns {boolean} Returns `true` if `key` exists, else `false`.
   */
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }

  /**
   * Checks if `path` is a direct or inherited property of `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.hasIn(object, 'a');
   * // => true
   *
   * _.hasIn(object, 'a.b');
   * // => true
   *
   * _.hasIn(object, ['a', 'b']);
   * // => true
   *
   * _.hasIn(object, 'b');
   * // => false
   */
  function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
  }

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /**
   * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
   *
   * @private
   * @param {string} path The path of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey(path), srcValue);
    }
    return function(object) {
      var objValue = get(object, path);
      return (objValue === undefined && objValue === srcValue)
        ? hasIn(object, path)
        : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * A specialized version of `baseProperty` which supports deep paths.
   *
   * @private
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyDeep(path) {
    return function(object) {
      return baseGet(object, path);
    };
  }

  /**
   * Creates a function that returns the value at `path` of a given object.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   * @example
   *
   * var objects = [
   *   { 'a': { 'b': 2 } },
   *   { 'a': { 'b': 1 } }
   * ];
   *
   * _.map(objects, _.property('a.b'));
   * // => [2, 1]
   *
   * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
   * // => [1, 2]
   */
  function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
  }

  /**
   * The base implementation of `_.iteratee`.
   *
   * @private
   * @param {*} [value=_.identity] The value to convert to an iteratee.
   * @returns {Function} Returns the iteratee.
   */
  function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') {
      return value;
    }
    if (value == null) {
      return identity;
    }
    if (typeof value == 'object') {
      return isArray(value)
        ? baseMatchesProperty(value[0], value[1])
        : baseMatches(value);
    }
    return property(value);
  }

  /**
   * Creates a function like `_.groupBy`.
   *
   * @private
   * @param {Function} setter The function to set accumulator values.
   * @param {Function} [initializer] The accumulator object initializer.
   * @returns {Function} Returns the new aggregator function.
   */
  function createAggregator(setter, initializer) {
    return function(collection, iteratee) {
      var func = isArray(collection) ? arrayAggregator : baseAggregator,
          accumulator = {};

      return func(collection, setter, baseIteratee(iteratee), accumulator);
    };
  }

  /** Used for built-in method references. */
  var objectProto$3 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

  /**
   * Creates an object composed of keys generated from the results of running
   * each element of `collection` thru `iteratee`. The corresponding value of
   * each key is the number of times the key was returned by `iteratee`. The
   * iteratee is invoked with one argument: (value).
   *
   * @static
   * @memberOf _
   * @since 0.5.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
   * @returns {Object} Returns the composed aggregate object.
   * @example
   *
   * _.countBy([6.1, 4.2, 6.3], Math.floor);
   * // => { '4': 1, '6': 2 }
   *
   * // The `_.property` iteratee shorthand.
   * _.countBy(['one', 'two', 'three'], 'length');
   * // => { '3': 2, '5': 1 }
   */
  var countBy = createAggregator(function(result, value, key) {
    if (hasOwnProperty$2.call(result, key)) {
      ++result[key];
    } else {
      baseAssignValue(result, key, 1);
    }
  });

  /** Used for built-in method references. */
  var objectProto$2 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

  /**
   * Creates an object composed of keys generated from the results of running
   * each element of `collection` thru `iteratee`. The order of grouped values
   * is determined by the order they occur in `collection`. The corresponding
   * value of each key is an array of elements responsible for generating the
   * key. The iteratee is invoked with one argument: (value).
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
   * @returns {Object} Returns the composed aggregate object.
   * @example
   *
   * _.groupBy([6.1, 4.2, 6.3], Math.floor);
   * // => { '4': [4.2], '6': [6.1, 6.3] }
   *
   * // The `_.property` iteratee shorthand.
   * _.groupBy(['one', 'two', 'three'], 'length');
   * // => { '3': ['one', 'two'], '5': ['three'] }
   */
  var groupBy = createAggregator(function(result, value, key) {
    if (hasOwnProperty$1.call(result, key)) {
      result[key].push(value);
    } else {
      baseAssignValue(result, key, [value]);
    }
  });

  /**
   * Creates an object composed of keys generated from the results of running
   * each element of `collection` thru `iteratee`. The corresponding value of
   * each key is the last element responsible for generating the key. The
   * iteratee is invoked with one argument: (value).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
   * @returns {Object} Returns the composed aggregate object.
   * @example
   *
   * var array = [
   *   { 'dir': 'left', 'code': 97 },
   *   { 'dir': 'right', 'code': 100 }
   * ];
   *
   * _.keyBy(array, function(o) {
   *   return String.fromCharCode(o.code);
   * });
   * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
   *
   * _.keyBy(array, 'dir');
   * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
   */
  var keyBy = createAggregator(function(result, value, key) {
    baseAssignValue(result, key, value);
  });

  /** Built-in value references. */
  var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : undefined;

  /**
   * Checks if `value` is a flattenable `arguments` object or array.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
   */
  function isFlattenable(value) {
    return isArray(value) || isArguments(value) ||
      !!(spreadableSymbol && value && value[spreadableSymbol]);
  }

  /**
   * The base implementation of `_.flatten` with support for restricting flattening.
   *
   * @private
   * @param {Array} array The array to flatten.
   * @param {number} depth The maximum recursion depth.
   * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
   * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
   * @param {Array} [result=[]] The initial result value.
   * @returns {Array} Returns the new flattened array.
   */
  function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1,
        length = array.length;

    predicate || (predicate = isFlattenable);
    result || (result = []);

    while (++index < length) {
      var value = array[index];
      if (predicate(value)) {
        {
          arrayPush(result, value);
        }
      } else {
        result[result.length] = value;
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.map` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function baseMap(collection, iteratee) {
    var index = -1,
        result = isArrayLike(collection) ? Array(collection.length) : [];

    baseEach(collection, function(value, key, collection) {
      result[++index] = iteratee(value, key, collection);
    });
    return result;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * Compares values to sort them in ascending order.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function compareAscending(value, other) {
    if (value !== other) {
      var valIsDefined = value !== undefined,
          valIsNull = value === null,
          valIsReflexive = value === value,
          valIsSymbol = isSymbol(value);

      var othIsDefined = other !== undefined,
          othIsNull = other === null,
          othIsReflexive = other === other,
          othIsSymbol = isSymbol(other);

      if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
          (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
          (valIsNull && othIsDefined && othIsReflexive) ||
          (!valIsDefined && othIsReflexive) ||
          !valIsReflexive) {
        return 1;
      }
      if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
          (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
          (othIsNull && valIsDefined && valIsReflexive) ||
          (!othIsDefined && valIsReflexive) ||
          !othIsReflexive) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * Used by `_.orderBy` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
   * specify an order of "desc" for descending or "asc" for ascending sort order
   * of corresponding values.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]|string[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = compareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * (order == 'desc' ? -1 : 1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * The base implementation of `_.orderBy` without param guards.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
   * @param {string[]} orders The sort orders of `iteratees`.
   * @returns {Array} Returns the new sorted array.
   */
  function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) {
      iteratees = arrayMap(iteratees, function(iteratee) {
        if (isArray(iteratee)) {
          return function(value) {
            return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
          }
        }
        return iteratee;
      });
    } else {
      iteratees = [identity];
    }

    var index = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

    var result = baseMap(collection, function(value, key, collection) {
      var criteria = arrayMap(iteratees, function(iteratee) {
        return iteratee(value);
      });
      return { 'criteria': criteria, 'index': ++index, 'value': value };
    });

    return baseSortBy(result, function(object, other) {
      return compareMultiple(object, other, orders);
    });
  }

  /**
   * Creates an array of elements, sorted in ascending order by the results of
   * running each element in a collection thru each iteratee. This method
   * performs a stable sort, that is, it preserves the original sort order of
   * equal elements. The iteratees are invoked with one argument: (value).
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {...(Function|Function[])} [iteratees=[_.identity]]
   *  The iteratees to sort by.
   * @returns {Array} Returns the new sorted array.
   * @example
   *
   * var users = [
   *   { 'user': 'fred',   'age': 48 },
   *   { 'user': 'barney', 'age': 36 },
   *   { 'user': 'fred',   'age': 30 },
   *   { 'user': 'barney', 'age': 34 }
   * ];
   *
   * _.sortBy(users, [function(o) { return o.user; }]);
   * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
   *
   * _.sortBy(users, ['user', 'age']);
   * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
   */
  var sortBy = baseRest(function(collection, iteratees) {
    if (collection == null) {
      return [];
    }
    var length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
      iteratees = [];
    } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
      iteratees = [iteratees[0]];
    }
    return baseOrderBy(collection, baseFlatten(iteratees), []);
  });

  /** Used for built-in method references. */
  var objectProto$1 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto$1.hasOwnProperty;

  /**
   * Assigns own and inherited enumerable string keyed properties of source
   * objects to the destination object for all destination properties that
   * resolve to `undefined`. Source objects are applied from left to right.
   * Once a property is set, additional values of the same property are ignored.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @see _.defaultsDeep
   * @example
   *
   * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
   * // => { 'a': 1, 'b': 2 }
   */
  var defaults = baseRest(function(object, sources) {
    object = Object(object);

    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      length = 1;
    }

    while (++index < length) {
      var source = sources[index];
      var props = keysIn(source);
      var propsIndex = -1;
      var propsLength = props.length;

      while (++propsIndex < propsLength) {
        var key = props[propsIndex];
        var value = object[key];

        if (value === undefined ||
            (eq(value, objectProto$1[key]) && !hasOwnProperty.call(object, key))) {
          object[key] = source[key];
        }
      }
    }

    return object;
  });

  /** Error message constants. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /**
   * The base implementation of `_.delay` and `_.defer` which accepts `args`
   * to provide to `func`.
   *
   * @private
   * @param {Function} func The function to delay.
   * @param {number} wait The number of milliseconds to delay invocation.
   * @param {Array} args The arguments to provide to `func`.
   * @returns {number|Object} Returns the timer id or timeout object.
   */
  function baseDelay(func, wait, args) {
    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    return setTimeout(function() { func.apply(undefined, args); }, wait);
  }

  /**
   * Defers invoking the `func` until the current call stack has cleared. Any
   * additional arguments are provided to `func` when it's invoked.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to defer.
   * @param {...*} [args] The arguments to invoke `func` with.
   * @returns {number} Returns the timer id.
   * @example
   *
   * _.defer(function(text) {
   *   console.log(text);
   * }, 'deferred');
   * // => Logs 'deferred' after one millisecond.
   */
  var defer = baseRest(function(func, args) {
    return baseDelay(func, 1, args);
  });

  /**
   * The base implementation of `_.invert` and `_.invertBy` which inverts
   * `object` with values transformed by `iteratee` and set by `setter`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform values.
   * @param {Object} accumulator The initial inverted object.
   * @returns {Function} Returns `accumulator`.
   */
  function baseInverter(object, setter, iteratee, accumulator) {
    baseForOwn(object, function(value, key, object) {
      setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
  }

  /**
   * Creates a function like `_.invertBy`.
   *
   * @private
   * @param {Function} setter The function to set accumulator values.
   * @param {Function} toIteratee The function to resolve iteratees.
   * @returns {Function} Returns the new inverter function.
   */
  function createInverter(setter, toIteratee) {
    return function(object, iteratee) {
      return baseInverter(object, setter, toIteratee(iteratee), {});
    };
  }

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /**
   * Creates an object composed of the inverted keys and values of `object`.
   * If `object` contains duplicate values, subsequent values overwrite
   * property assignments of previous values.
   *
   * @static
   * @memberOf _
   * @since 0.7.0
   * @category Object
   * @param {Object} object The object to invert.
   * @returns {Object} Returns the new inverted object.
   * @example
   *
   * var object = { 'a': 1, 'b': 2, 'c': 1 };
   *
   * _.invert(object);
   * // => { '1': 'c', '2': 'b' }
   */
  var invert = createInverter(function(result, value, key) {
    if (value != null &&
        typeof value.toString != 'function') {
      value = nativeObjectToString.call(value);
    }

    result[value] = key;
  }, constant(identity));

  /**
   * Performs a deep comparison between two values to determine if they are
   * equivalent.
   *
   * **Note:** This method supports comparing arrays, array buffers, booleans,
   * date objects, error objects, maps, numbers, `Object` objects, regexes,
   * sets, strings, symbols, and typed arrays. `Object` objects are compared
   * by their own, not inherited, enumerable properties. Functions and DOM
   * nodes are compared by strict equality, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.isEqual(object, other);
   * // => true
   *
   * object === other;
   * // => false
   */
  function isEqual(value, other) {
    return baseIsEqual(value, other);
  }

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG$1 = 1;

  /**
   * Creates a function that invokes `func` with the arguments of the created
   * function. If `func` is a property name, the created function returns the
   * property value for a given element. If `func` is an array or object, the
   * created function returns `true` for elements that contain the equivalent
   * source properties, otherwise it returns `false`.
   *
   * @static
   * @since 4.0.0
   * @memberOf _
   * @category Util
   * @param {*} [func=_.identity] The value to convert to a callback.
   * @returns {Function} Returns the callback.
   * @example
   *
   * var users = [
   *   { 'user': 'barney', 'age': 36, 'active': true },
   *   { 'user': 'fred',   'age': 40, 'active': false }
   * ];
   *
   * // The `_.matches` iteratee shorthand.
   * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
   * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.filter(users, _.iteratee(['user', 'fred']));
   * // => [{ 'user': 'fred', 'age': 40 }]
   *
   * // The `_.property` iteratee shorthand.
   * _.map(users, _.iteratee('user'));
   * // => ['barney', 'fred']
   *
   * // Create custom iteratee shorthands.
   * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
   *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
   *     return func.test(string);
   *   };
   * });
   *
   * _.filter(['abc', 'def'], /ef/);
   * // => ['def']
   */
  function iteratee(func) {
    return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG$1));
  }

  /**
   * Gets the last element of `array`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to query.
   * @returns {*} Returns the last element of `array`.
   * @example
   *
   * _.last([1, 2, 3]);
   * // => 3
   */
  function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
  }

  /**
   * The base implementation of `_.slice` without an iteratee call guard.
   *
   * @private
   * @param {Array} array The array to slice.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the slice of `array`.
   */
  function baseSlice(array, start, end) {
    var index = -1,
        length = array.length;

    if (start < 0) {
      start = -start > length ? 0 : (length + start);
    }
    end = end > length ? length : end;
    if (end < 0) {
      end += length;
    }
    length = start > end ? 0 : ((end - start) >>> 0);
    start >>>= 0;

    var result = Array(length);
    while (++index < length) {
      result[index] = array[index + start];
    }
    return result;
  }

  /**
   * Gets the parent value at `path` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} path The path to get the parent value of.
   * @returns {*} Returns the parent value.
   */
  function parent(object, path) {
    return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
  }

  /**
   * The base implementation of `_.unset`.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {Array|string} path The property path to unset.
   * @returns {boolean} Returns `true` if the property is deleted, else `false`.
   */
  function baseUnset(object, path) {
    path = castPath(path, object);
    object = parent(object, path);
    return object == null || delete object[toKey(last(path))];
  }

  /**
   * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
   * objects.
   *
   * @private
   * @param {*} value The value to inspect.
   * @param {string} key The key of the property to inspect.
   * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
   */
  function customOmitClone(value) {
    return isPlainObject(value) ? undefined : value;
  }

  /**
   * Flattens `array` a single level deep.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to flatten.
   * @returns {Array} Returns the new flattened array.
   * @example
   *
   * _.flatten([1, [2, [3, [4]], 5]]);
   * // => [1, 2, [3, [4]], 5]
   */
  function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array) : [];
  }

  /**
   * A specialized version of `baseRest` which flattens the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @returns {Function} Returns the new function.
   */
  function flatRest(func) {
    return setToString(overRest(func, undefined, flatten), func + '');
  }

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /**
   * The opposite of `_.pick`; this method creates an object composed of the
   * own and inherited enumerable property paths of `object` that are not omitted.
   *
   * **Note:** This method is considerably slower than `_.pick`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The source object.
   * @param {...(string|string[])} [paths] The property paths to omit.
   * @returns {Object} Returns the new object.
   * @example
   *
   * var object = { 'a': 1, 'b': '2', 'c': 3 };
   *
   * _.omit(object, ['a', 'c']);
   * // => { 'b': '2' }
   */
  var omit = flatRest(function(object, paths) {
    var result = {};
    if (object == null) {
      return result;
    }
    var isDeep = false;
    paths = arrayMap(paths, function(path) {
      path = castPath(path, object);
      isDeep || (isDeep = path.length > 1);
      return path;
    });
    copyObject(object, getAllKeysIn(object), result);
    if (isDeep) {
      result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
    }
    var length = paths.length;
    while (length--) {
      baseUnset(result, paths[length]);
    }
    return result;
  });

  /**
   * The base implementation of `_.set`.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {*} value The value to set.
   * @param {Function} [customizer] The function to customize path creation.
   * @returns {Object} Returns `object`.
   */
  function baseSet(object, path, value, customizer) {
    if (!isObject$1(object)) {
      return object;
    }
    path = castPath(path, object);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        nested = object;

    while (nested != null && ++index < length) {
      var key = toKey(path[index]),
          newValue = value;

      if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
        return object;
      }

      if (index != lastIndex) {
        var objValue = nested[key];
        newValue = undefined;
        if (newValue === undefined) {
          newValue = isObject$1(objValue)
            ? objValue
            : (isIndex(path[index + 1]) ? [] : {});
        }
      }
      assignValue(nested, key, newValue);
      nested = nested[key];
    }
    return object;
  }

  /**
   * The base implementation of  `_.pickBy` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The source object.
   * @param {string[]} paths The property paths to pick.
   * @param {Function} predicate The function invoked per property.
   * @returns {Object} Returns the new object.
   */
  function basePickBy(object, paths, predicate) {
    var index = -1,
        length = paths.length,
        result = {};

    while (++index < length) {
      var path = paths[index],
          value = baseGet(object, path);

      if (predicate(value, path)) {
        baseSet(result, castPath(path, object), value);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.pick` without support for individual
   * property identifiers.
   *
   * @private
   * @param {Object} object The source object.
   * @param {string[]} paths The property paths to pick.
   * @returns {Object} Returns the new object.
   */
  function basePick(object, paths) {
    return basePickBy(object, paths, function(value, path) {
      return hasIn(object, path);
    });
  }

  /**
   * Creates an object composed of the picked `object` properties.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The source object.
   * @param {...(string|string[])} [paths] The property paths to pick.
   * @returns {Object} Returns the new object.
   * @example
   *
   * var object = { 'a': 1, 'b': '2', 'c': 3 };
   *
   * _.pick(object, ['a', 'c']);
   * // => { 'a': 1, 'c': 3 }
   */
  var pick = flatRest(function(object, paths) {
    return object == null ? {} : basePick(object, paths);
  });

  /**
   * @public
   * **Models** are the basic data object in the framework --
   * frequently representing a row in a table in a database on your server.
   * A discrete chunk of data and a bunch of useful, related methods for
   * performing computations and transformations on that data.
   */
  class Model extends EventEmitterObject {
      /**
       * Create a new model with the specified attributes. A client id (`cid`)
       * is automatically generated and assigned for you.
       */
      constructor(attributes, options) {
          super();
          this._changing = false;
          this._pending = false;
          this._url = '';
          this.changed = {};
          this.validationError = null;
          let attrs = attributes || {};
          options = options || {};
          this.preinitialize.apply(this, arguments);
          this.cid = uniqueId(this.cidPrefix);
          this.attributes = {};
          if (options.collection)
              this.collection = options.collection;
          if (options.parse)
              attrs = this.parse(attrs, options) || {};
          const default_attrs = result(this, 'defaults');
          attrs = defaults(Object.assign({}, default_attrs, attrs), default_attrs);
          this.set(attrs, options);
          this.initialize.apply(this, arguments);
          // Reset changed after initial set
          this.changed = {};
      }
      set browserStorage(storage) {
          this._browserStorage = storage;
      }
      get browserStorage() {
          return this._browserStorage;
      }
      /**
       * The default name for the JSON `id` attribute is `"id"`. MongoDB and
       * CouchDB users may want to set this to `"_id"` (by overriding this getter
       * in a subclass).
       */
      get idAttribute() {
          return 'id';
      }
      /**
       * The prefix is used to create the client id which is used to identify models locally.
       * You may want to override this if you're experiencing name clashes with model ids.
       */
      get cidPrefix() {
          return 'c';
      }
      /**
       * preinitialize is an empty function by default. You can override it with a function
       * or object.  preinitialize will run before any instantiation logic is run in the Model.
       */
      preinitialize(...args) { }
      /**
       * Initialize is an empty function by default. Override it with your own
       * initialization logic.
       */
      initialize(attrs, options) { }
      validate(attrs, options) {
          return null;
      }
      /**
       * Return a hash of defaults for the model's attributes.
       */
      defaults() {
          return {};
      }
      /**
       * Return a copy of the model's `attributes` object.
       */
      toJSON() {
          return clone(this.attributes);
      }
      /**
       * Override this if you need custom syncing semantics for *this* particular model.
       */
      sync(method, model, options) {
          return getSyncMethod(model)(method, model, options);
      }
      /**
       * Get the value of an attribute.
       */
      get(attr) {
          return this.attributes[attr];
      }
      keys() {
          return Object.keys(this.attributes);
      }
      values() {
          return Object.values(this.attributes);
      }
      pairs() {
          return this.entries();
      }
      entries() {
          return Object.entries(this.attributes);
      }
      invert() {
          return invert(this.attributes);
      }
      pick(...args) {
          if (args.length === 1 && Array.isArray(args[0])) {
              args = args[0];
          }
          return pick(this.attributes, args);
      }
      omit(...args) {
          if (args.length === 1 && Array.isArray(args[0])) {
              args = args[0];
          }
          return omit(this.attributes, args);
      }
      isEmpty() {
          return isEmpty(this.attributes);
      }
      /**
       * Returns `true` if the attribute contains a value that is not null
       * or undefined.
       */
      has(attr) {
          return this.get(attr) != null;
      }
      /**
       * Special-cased proxy to lodash's `matches` method.
       */
      matches(attrs) {
          return !!iteratee(attrs)(this.attributes);
      }
      /**
       * Set a hash of model attributes on the object, firing `"change"`. This is
       * the core primitive operation of a model, updating the data and notifying
       * anyone who needs to know about the change in state. The heart of the beast.
       */
      set(key, val, options) {
          if (key == null)
              return this;
          // Handle both `"key", value` and `{key: value}` -style arguments.
          let attrs;
          if (typeof key === 'object') {
              attrs = key;
              options = val;
          }
          else {
              attrs = {};
              attrs[key] = val;
          }
          options = options || {};
          // Run validation.
          if (!this._validate(attrs, options))
              return null;
          // Extract attributes and options.
          const unset = options.unset;
          const silent = options.silent;
          const changes = [];
          const changing = this._changing;
          this._changing = true;
          if (!changing) {
              this._previousAttributes = clone(this.attributes);
              this.changed = {};
          }
          const current = this.attributes;
          const changed = this.changed;
          const prev = this._previousAttributes;
          // For each `set` attribute, update or delete the current value.
          for (const attr in attrs) {
              val = attrs[attr];
              if (!isEqual(current[attr], val))
                  changes.push(attr);
              if (!isEqual(prev[attr], val)) {
                  changed[attr] = val;
              }
              else {
                  delete changed[attr];
              }
              unset ? delete current[attr] : (current[attr] = val);
          }
          // Update the `id`.
          if (this.idAttribute in attrs)
              this.id = this.get(this.idAttribute);
          // Trigger all relevant attribute changes.
          if (!silent) {
              if (changes.length)
                  this._pending = options;
              for (let i = 0; i < changes.length; i++) {
                  this.trigger('change:' + changes[i], this, current[changes[i]], options);
              }
          }
          if (changing)
              return this;
          if (!silent) {
              // You might be wondering why there's a `while` loop here. Changes can
              // be recursively nested within `"change"` events.
              while (this._pending) {
                  options = this._pending;
                  this._pending = false;
                  this.trigger('change', this, options);
              }
          }
          this._pending = false;
          this._changing = false;
          return this;
      }
      /**
       * Remove an attribute from the model, firing `"change"`. `unset` is a noop
       * if the attribute doesn't exist.
       */
      unset(attr, options) {
          return this.set(attr, undefined, Object.assign({}, options, { unset: true }));
      }
      /**
       * Clear all attributes on the model, firing `"change"`.
       */
      clear(options) {
          const attrs = {};
          for (const key in this.attributes)
              attrs[key] = undefined;
          return this.set(attrs, Object.assign({}, options, { unset: true }));
      }
      /**
       * Determine if the model has changed since the last `"change"` event.
       * If you specify an attribute name, determine if that attribute has changed.
       */
      hasChanged(attr) {
          if (attr == null)
              return !isEmpty(this.changed);
          return has(this.changed, attr);
      }
      /**
       * Return an object containing all the attributes that have changed, or
       * false if there are no changed attributes. Useful for determining what
       * parts of a view need to be updated and/or what attributes need to be
       * persisted to the server. Unset attributes will be set to undefined.
       * You can also pass an attributes object to diff against the model,
       * determining if there *would be* a change.
       */
      changedAttributes(diff) {
          if (!diff) {
              return this.hasChanged() ? clone(this.changed) : false;
          }
          const old = this._changing ? this._previousAttributes : this.attributes;
          const changed = {};
          let hasChanged = false;
          for (const attr in diff) {
              const val = diff[attr];
              if (isEqual(old[attr], val))
                  continue;
              changed[attr] = val;
              hasChanged = true;
          }
          return hasChanged ? changed : false;
      }
      /**
       * Get the previous value of an attribute, recorded at the time the last
       * `"change"` event was fired.
       */
      previous(attr) {
          if (attr == null || !this._previousAttributes)
              return null;
          return this._previousAttributes[attr];
      }
      /**
       * Get all of the attributes of the model at the time of the previous
       * `"change"` event.
       */
      previousAttributes() {
          return this._previousAttributes ? clone(this._previousAttributes) : undefined;
      }
      /**
       * Fetch the model from the server, merging the response with the model's
       * local attributes. Any changed attributes will trigger a "change" event.
       */
      fetch(options = {}) {
          options = Object.assign({ parse: true }, options);
          const success = options.success;
          options.success = (resp) => {
              const serverAttrs = options.parse ? this.parse(resp, options) : resp;
              if (!this.set(serverAttrs, options))
                  return false;
              if (success)
                  success.call(options.context, this, resp, options);
              this.trigger('sync', this, resp, options);
          };
          wrapError(this, options);
          return this.sync('read', this, options);
      }
      /**
       * Set a hash of model attributes, and sync the model to the server.
       * If the server returns an attributes hash that differs, the model's
       * state will be `set` again.
       */
      save(key, val, options) {
          // Handle both `"key", value` and `{key: value}` -style arguments.
          let attrs;
          if (key == null || typeof key === 'object') {
              attrs = key;
              options = val;
          }
          else {
              attrs = {};
              attrs[key] = val;
          }
          options = Object.assign({ validate: true, parse: true }, options);
          const wait = options.wait;
          const return_promise = options.promise;
          const promise = return_promise && getResolveablePromise();
          // If we're not waiting and attributes exist, save acts as
          // `set(attr).save(null, opts)` with validation. Otherwise, check if
          // the model will be valid when the attributes, if any, are set.
          if (attrs && !wait) {
              if (!this.set(attrs, options))
                  return false;
          }
          else if (!this._validate(attrs || {}, options)) {
              return false;
          }
          // After a successful server-side save, the client is (optionally)
          // updated with the server-side state.
          const success = options.success;
          const error = options.error;
          const attributes = this.attributes;
          options.success = (resp) => {
              // Ensure attributes are restored during synchronous saves.
              this.attributes = attributes;
              let serverAttrs = options.parse ? this.parse(resp, options) : resp;
              if (wait)
                  serverAttrs = Object.assign({}, attrs, serverAttrs);
              if (serverAttrs && !this.set(serverAttrs, options))
                  return false;
              if (success)
                  success.call(options.context, this, resp, options);
              this.trigger('sync', this, resp, options);
              return_promise && promise.resolve();
          };
          options.error = (model, e, options) => {
              error && error.call(options.context, model, e, options);
              return_promise && promise.reject(e);
          };
          wrapError(this, options);
          // Set temporary attributes if `{wait: true}` to properly find new ids.
          if (attrs && wait)
              this.attributes = Object.assign({}, attributes, attrs);
          const method = this.isNew() ? 'create' : options.patch ? 'patch' : 'update';
          if (method === 'patch' && !options.attrs)
              options.attrs = attrs;
          const xhr = this.sync(method, this, options);
          // Restore attributes.
          this.attributes = attributes;
          if (return_promise) {
              return promise;
          }
          else {
              return xhr;
          }
      }
      /**
       * Destroy this model on the server if it was already persisted.
       * Optimistically removes the model from its collection, if it has one.
       * If `wait: true` is passed, waits for the server to respond before removal.
       */
      destroy(options) {
          options = options ? clone(options) : {};
          const success = options.success;
          const wait = options.wait;
          const destroy = () => {
              this.stopListening();
              this.trigger('destroy', this, this.collection, options);
          };
          options.success = (resp) => {
              if (wait)
                  destroy();
              if (success)
                  success.call(options.context, this, resp, options);
              if (!this.isNew())
                  this.trigger('sync', this, resp, options);
          };
          let xhr = false;
          if (this.isNew()) {
              defer(options.success);
          }
          else {
              wrapError(this, options);
              xhr = this.sync('delete', this, options);
          }
          if (!wait)
              destroy();
          return xhr;
      }
      get urlRoot() {
          return this._urlRoot;
      }
      set urlRoot(root) {
          this._urlRoot = root;
      }
      /**
       * Default URL for the model's representation on the server -- if you're
       * using Backbone's restful methods, override this to change the endpoint
       * that will be called.
       */
      get url() {
          if (this._url)
              return this._url;
          const base = result(this, 'urlRoot') || result(this.collection, 'url') || urlError();
          if (this.isNew())
              return base;
          const id = this.get(this.idAttribute);
          return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(String(id));
      }
      set url(url) {
          this._url = url;
      }
      /**
       * **parse** converts a response into the hash of attributes to be `set` on
       * the model. The default implementation is just to pass the response along.
       */
      parse(resp, options) {
          return resp;
      }
      /**
       * A model is new if it has never been saved to the server, and lacks an id.
       */
      isNew() {
          return !this.has(this.idAttribute);
      }
      /**
       * Check if the model is currently in a valid state.
       */
      isValid(options) {
          return this._validate({}, Object.assign({}, options, { validate: true }));
      }
      /**
       * Run validation against the next complete set of model attributes,
       * returning `true` if all is well. Otherwise, fire an `"invalid"` event.
       */
      _validate(attrs, options) {
          if (!options?.validate || !this.validate)
              return true;
          attrs = Object.assign({}, this.attributes, attrs);
          const error = (this.validationError = this.validate(attrs, options) || null);
          if (!error)
              return true;
          this.trigger('invalid', this, error, Object.assign(options, { validationError: error }));
          return false;
      }
  }

  var _a;
  // Default options for `Collection#set`.
  const setOptions = { add: true, remove: true, merge: true };
  const addOptions = { add: true, remove: false };
  /**
   * @public
   * If models tend to represent a single row of data, a Collection is
   * more analogous to a table full of data ... or a small slice or page of that
   * table, or a collection of rows that belong together for a particular reason
   * -- all of the messages in this particular folder, all of the documents
   * belonging to this particular author, and so on. Collections maintain
   * indexes of their models, both in order, and for lookup by `id`.
   */
  class Collection extends EventEmitterObject {
      /**
       * Create a new **Collection**, perhaps to contain a specific type of `model`.
       * If a `comparator` is specified, the Collection will maintain
       * its models in sort order, as they're added and removed.
       */
      constructor(models, options) {
          super();
          this._url = '';
          /**
           * @public
           * Enable for...of iteration over the collection.
           */
          this[_a] = this.values;
          options = options || {};
          this.preinitialize.apply(this, arguments);
          if (options.model)
              this._model = options.model;
          if (options.comparator !== undefined)
              this.comparator = options.comparator;
          this._reset();
          this.initialize.apply(this, arguments);
          if (models)
              this.reset(models, Object.assign({ silent: true }, options));
          this[Symbol.iterator] = this.values;
      }
      get comparator() {
          return this._comparator;
      }
      set comparator(c) {
          this._comparator = c;
      }
      set browserStorage(storage) {
          this._browserStorage = storage;
      }
      get browserStorage() {
          return this._browserStorage;
      }
      /**
       * The default model for a collection is just a **Model**.
       * This should be overridden in most cases.
       */
      get model() {
          return this._model ?? Model;
      }
      set model(model) {
          this._model = model;
      }
      get length() {
          return this.models.length;
      }
      get url() {
          return this._url;
      }
      set url(url) {
          this._url = url;
      }
      /**
       * preinitialize is an empty function by default. You can override it with a function
       * or object.  preinitialize will run before any instantiation logic is run in the Collection.
       */
      preinitialize(..._args) { }
      /**
       * Initialize is an empty function by default. Override it with your own
       * initialization logic.
       */
      initialize(..._args) { }
      /**
       * The JSON representation of a Collection is an array of the
       * models' attributes.
       */
      toJSON() {
          return this.map(function (model) {
              return model.toJSON();
          });
      }
      sync(method, model, options) {
          return getSyncMethod(this)(method, model, options);
      }
      /**
       * Add a model, or list of models to the set. `models` may be
       * Models or raw JavaScript objects to be converted to Models, or any
       * combination of the two.
       */
      add(models, options) {
          return this.set(models, Object.assign({ merge: false }, options, addOptions));
      }
      /**
       * Remove a model, or a list of models from the set.
       */
      remove(models, options) {
          options = Object.assign({}, options);
          const singular = !Array.isArray(models);
          const modelsArray = singular ? [models] : models.slice();
          const removed = this._removeModels(modelsArray, options);
          if (!options.silent && removed.length) {
              options.changes = { added: [], merged: [], removed: removed };
              this.trigger('update', this, options);
          }
          return singular ? removed[0] : removed;
      }
      /**
       * Update a collection by `set`-ing a new list of models, adding new ones,
       * removing models that are no longer present, and merging models that
       * already exist in the collection, as necessary. Similar to **Model#set**,
       * the core operation for updating the data contained by the collection.
       */
      set(models, options) {
          if (models == null)
              return;
          options = Object.assign({}, setOptions, options);
          if (options.parse && !this._isModel(models)) {
              models = this.parse(models, options) || [];
          }
          const singular = !Array.isArray(models);
          models = singular ? [models] : models.slice();
          let at = options.at;
          if (at != null)
              at = +at;
          if (at > this.length)
              at = this.length;
          if (at < 0)
              at += this.length + 1;
          const set = [];
          const toAdd = [];
          const toMerge = [];
          const toRemove = [];
          const modelMap = {};
          const add = options.add;
          const merge = options.merge;
          const remove = options.remove;
          let sort = false;
          const sortable = this.comparator && at == null && options.sort !== false;
          const sortAttr = isString(this.comparator) ? this.comparator : null;
          // Turn bare objects into model references, and prevent invalid models
          // from being added.
          let model, i;
          for (i = 0; i < models.length; i++) {
              model = models[i];
              // If a duplicate is found, prevent it from being added and
              // optionally merge it into the existing model.
              const existing = this.get(model);
              if (existing) {
                  if (merge && model !== existing) {
                      let attrs = this._isModel(model) ? model.attributes : model;
                      if (options.parse)
                          attrs = existing.parse(attrs, options);
                      existing.set(attrs, options);
                      toMerge.push(existing);
                      if (sortable && !sort)
                          sort = existing.hasChanged(sortAttr);
                  }
                  if (!modelMap[existing.cid]) {
                      modelMap[existing.cid] = true;
                      set.push(existing);
                  }
                  models[i] = existing;
                  // If this is a new, valid model, push it to the `toAdd` list.
              }
              else if (add) {
                  model = models[i] = this._prepareModel(model, options);
                  if (model) {
                      toAdd.push(model);
                      this._addReference(model, options);
                      modelMap[model.cid] = true;
                      set.push(model);
                  }
              }
          }
          // Remove stale models.
          if (remove) {
              for (i = 0; i < this.length; i++) {
                  model = this.models[i];
                  if (!modelMap[model.cid])
                      toRemove.push(model);
              }
              if (toRemove.length)
                  this._removeModels(toRemove, options);
          }
          // See if sorting is needed, update `length` and splice in new models.
          let orderChanged = false;
          const replace = !sortable && add && remove;
          if (set.length && replace) {
              orderChanged = this.length !== set.length || this.models.some((m, idx) => m !== set[idx]);
              this.models.length = 0;
              this.models.splice(0, 0, ...set);
          }
          else if (toAdd.length) {
              if (sortable)
                  sort = true;
              let idx = at == null ? this.length : at;
              idx = Math.min(Math.max(idx, 0), this.models.length);
              this.models.splice(idx, 0, ...toAdd);
          }
          // Silently sort the collection if appropriate.
          if (sort)
              this.sort({ silent: true });
          // Unless silenced, it's time to fire all appropriate add/sort/update events.
          if (!options.silent) {
              for (i = 0; i < toAdd.length; i++) {
                  if (at != null)
                      options.index = at + i;
                  model = toAdd[i];
                  model.trigger('add', model, this, options);
              }
              if (sort || orderChanged)
                  this.trigger('sort', this, options);
              if (toAdd.length || toRemove.length || toMerge.length) {
                  options.changes = {
                      added: toAdd,
                      removed: toRemove,
                      merged: toMerge,
                  };
                  this.trigger('update', this, options);
              }
          }
          // Return the added (or merged) model (or models).
          return singular ? models[0] : models;
      }
      async clearStore(options = {}, filter = () => true) {
          await Promise.all(this.models.filter(filter).map((m) => {
              return new Promise((resolve) => {
                  m.destroy(Object.assign(options, {
                      'success': resolve,
                      'error': (_m, e) => {
                          console.error(e);
                          resolve();
                      },
                  }));
              });
          }));
          await this.browserStorage?.clear();
          this.reset();
      }
      /**
       * When you have more items than you want to add or remove individually,
       * you can reset the entire set with a new list of models, without firing
       * any granular `add` or `remove` events. Fires `reset` when finished.
       * Useful for bulk operations and optimizations.
       */
      reset(models, options) {
          options = options ? clone(options) : {};
          for (let i = 0; i < this.models.length; i++) {
              this._removeReference(this.models[i], options);
          }
          options.previousModels = this.models;
          this._reset();
          models = this.add(models, Object.assign({ silent: true }, options));
          if (!options.silent)
              this.trigger('reset', this, options);
          return models;
      }
      /**
       * Add a model to the end of the collection.
       */
      push(model, options) {
          return this.add(model, Object.assign({ at: this.length }, options));
      }
      /**
       * Remove a model from the end of the collection.
       */
      pop(options) {
          const model = this.at(this.length - 1);
          return this.remove(model, options);
      }
      /**
       * Add a model to the beginning of the collection.
       */
      unshift(model, options) {
          return this.add(model, Object.assign({ at: 0 }, options));
      }
      /**
       * Remove a model from the beginning of the collection.
       */
      shift(options) {
          const model = this.at(0);
          return this.remove(model, options);
      }
      /** Slice out a sub-array of models from the collection. */
      slice(start, end) {
          return this.models.slice(start, end);
      }
      filter(callback, thisArg) {
          return this.models.filter(isFunction(callback)
              ? callback
              : (m) => m.matches(callback), thisArg);
      }
      every(pred) {
          if (isFunction(pred)) {
              return this.models.map((m) => m.attributes).every(pred);
          }
          else {
              return this.models.every((m) => m.matches(pred));
          }
      }
      difference(values) {
          return this.models.filter((m) => !values.includes(m));
      }
      max() {
          return Math.max.apply(Math, this.models);
      }
      min() {
          return Math.min.apply(Math, this.models);
      }
      drop(n = 1) {
          return this.models.slice(n);
      }
      some(pred) {
          if (isFunction(pred)) {
              return this.models.map((m) => m.attributes).some(pred);
          }
          else {
              return this.models.some((m) => m.matches(pred));
          }
      }
      sortBy(iteratee) {
          return sortBy(this.models, isFunction(iteratee)
              ? iteratee
              : (m) => (isString(iteratee) ? m.get(iteratee) : m.matches(iteratee)));
      }
      isEmpty() {
          return !this.models.length;
      }
      keyBy(iteratee) {
          return keyBy(this.models, iteratee);
      }
      each(callback, thisArg) {
          return this.forEach(callback, thisArg);
      }
      forEach(callback, thisArg) {
          return this.models.forEach(callback, thisArg);
      }
      includes(item) {
          return this.models.includes(item);
      }
      size() {
          return this.models.length;
      }
      countBy(f) {
          return countBy(this.models, isFunction(f) ? f : (m) => (isString(f) ? m.get(f) : m.matches(f)));
      }
      groupBy(pred) {
          return groupBy(this.models, isFunction(pred) ? pred : (m) => (isString(pred) ? m.get(pred) : m.matches(pred)));
      }
      indexOf(model, fromIndex) {
          return this.models.indexOf(model, fromIndex);
      }
      findLastIndex(pred, fromIndex) {
          return this.models.findLastIndex(isFunction(pred)
              ? pred
              : (m) => (isString(pred) ? m.get(pred) : m.matches(pred)), fromIndex);
      }
      lastIndexOf(model, fromIndex) {
          return this.models.lastIndexOf(model, fromIndex);
      }
      findIndex(pred) {
          return this.models.findIndex(isFunction(pred)
              ? pred
              : (m) => (isString(pred) ? m.get(pred) : m.matches(pred)));
      }
      last() {
          const length = this.models == null ? 0 : this.models.length;
          return length ? this.models[length - 1] : undefined;
      }
      head() {
          return this.models[0];
      }
      first() {
          return this.head();
      }
      map(cb, thisArg) {
          return this.models.map(isFunction(cb)
              ? cb
              : (m) => (isString(cb) ? m.get(cb) : m.matches(cb)), thisArg);
      }
      reduce(callback, initialValue) {
          return this.models.reduce(callback, initialValue || this.models[0]);
      }
      reduceRight(callback, initialValue) {
          return this.models.reduceRight(callback, initialValue || this.models[0]);
      }
      toArray() {
          return Array.from(this.models);
      }
      /**
       * Get a model from the set by id, cid, model object with id or cid
       * properties, or an attributes object that is transformed through modelId.
       */
      get(obj) {
          if (obj == null)
              return undefined;
          return (this._byId[obj] ||
              this._byId[this.modelId(this._isModel(obj) ? obj.attributes : obj)] ||
              (obj.cid && this._byId[obj.cid]));
      }
      /**
       * Returns `true` if the model is in the collection.
       */
      has(obj) {
          return this.get(obj) != null;
      }
      /**
       * Get the model at the given index.
       */
      at(index) {
          if (index < 0)
              index += this.length;
          return this.models[index];
      }
      /**
       * Return models with matching attributes. Useful for simple cases of
       * `filter`.
       */
      where(attrs, first) {
          return this[first ? 'find' : 'filter'](attrs);
      }
      /**
       * Return the first model with matching attributes. Useful for simple cases
       * of `find`.
       */
      findWhere(attrs) {
          return this.where(attrs, true);
      }
      find(predicate, fromIndex) {
          const pred = isFunction(predicate)
              ? predicate
              : (m) => m.matches(predicate);
          return this.models.find(pred, fromIndex);
      }
      /**
       * Force the collection to re-sort itself. You don't need to call this under
       * normal circumstances, as the set will maintain sort order as each item
       * is added.
       */
      sort(options) {
          let comparator = this.comparator;
          if (!comparator)
              throw new Error('Cannot sort a set without a comparator');
          options = options || {};
          const length = isFunction(comparator) ? comparator.length : 0;
          if (isFunction(comparator))
              comparator = comparator.bind(this);
          // Run sort based on type of `comparator`.
          if (length === 1 || isString(comparator)) {
              this.models = this.sortBy(comparator);
          }
          else {
              this.models.sort(comparator);
          }
          if (!options.silent)
              this.trigger('sort', this, options);
          return this;
      }
      /**
       * Pluck an attribute from each model in the collection.
       */
      pluck(attr) {
          return this.map(attr + '');
      }
      /**
       * Fetch the default set of models for this collection, resetting the
       * collection when they arrive. If `reset: true` is passed, the response
       * data will be passed through the `reset` method instead of `set`.
       */
      fetch(options) {
          options = Object.assign({ parse: true }, options);
          const success = options.success;
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const collection = this;
          const promise = options.promise && getResolveablePromise();
          options.success = function (resp) {
              const method = options.reset ? 'reset' : 'set';
              collection[method](resp, options);
              if (success)
                  success.call(options.context, collection, resp, options);
              promise && promise.resolve();
              collection.trigger('sync', collection, resp, options);
          };
          wrapError(this, options);
          return promise ? promise : this.sync('read', this, options);
      }
      /**
       * Create a new instance of a model in this collection. Add the model to the
       * collection immediately, unless `wait: true` is passed, in which case we
       * wait for the server to agree.
       */
      create(model, options) {
          options = options ? clone(options) : {};
          const wait = options.wait;
          const return_promise = options.promise;
          const promise = return_promise && getResolveablePromise();
          const preparedModel = this._prepareModel(model, options);
          if (!preparedModel)
              return null;
          if (!wait)
              this.add(preparedModel, options);
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const collection = this;
          const success = options.success;
          const error = options.error;
          options.success = function (m, resp, callbackOpts) {
              if (wait) {
                  collection.add(m, callbackOpts);
              }
              if (success) {
                  success.call(callbackOpts.context, m, resp, callbackOpts);
              }
              if (return_promise) {
                  promise.resolve(m);
              }
          };
          options.error = function (model, e, options) {
              error && error.call(options.context, model, e, options);
              return_promise && promise.reject(e);
          };
          preparedModel.save(null, Object.assign(options, { 'promise': false }));
          if (return_promise) {
              return promise;
          }
          else {
              return preparedModel;
          }
      }
      /**
       * **parse** converts a response into a list of models to be added to the
       * collection. The default implementation is just to pass it through.
       */
      parse(resp, _options) {
          return resp;
      }
      /**
       * Define how to uniquely identify models in the collection.
       */
      modelId(attrs) {
          return attrs[this.model.prototype?.idAttribute || 'id'];
      }
      /** Get an iterator of all models in this collection. */
      values() {
          return new CollectionIterator(this, ITERATOR_VALUES);
      }
      /** Get an iterator of all model IDs in this collection. */
      keys() {
          return new CollectionIterator(this, ITERATOR_KEYS);
      }
      /** Get an iterator of all [ID, model] tuples in this collection. */
      entries() {
          return new CollectionIterator(this, ITERATOR_KEYSVALUES);
      }
      /**
       * Private method to reset all internal state. Called when the collection
       * is first initialized or reset.
       */
      _reset() {
          this.models = [];
          this._byId = {};
      }
      createModel(attrs, options) {
          const Klass = this.model;
          return new Klass(attrs, options);
      }
      /**
       * Prepare a hash of attributes (or other model) to be added to this
       * collection.
       */
      _prepareModel(attrs, options) {
          if (this._isModel(attrs)) {
              if (!attrs.collection)
                  attrs.collection = this;
              return attrs;
          }
          options = options ? clone(options) : {};
          options.collection = this;
          const model = this.createModel(attrs, options);
          if (!model.validationError)
              return model;
          this.trigger('invalid', this, model.validationError, options);
          return null;
      }
      /**
       * Internal method called by both remove and set.
       */
      _removeModels(models, options) {
          const removed = [];
          for (let i = 0; i < models.length; i++) {
              const model = this.get(models[i]);
              if (!model)
                  continue;
              const index = this.indexOf(model);
              this.models.splice(index, 1);
              // Remove references before triggering 'remove' event to prevent an
              // infinite loop. #3693
              delete this._byId[model.cid];
              const id = this.modelId(model.attributes);
              if (id != null)
                  delete this._byId[id];
              if (!options?.silent) {
                  options = options || {};
                  options.index = index;
                  model.trigger('remove', model, this, options);
              }
              removed.push(model);
              this._removeReference(model, options);
          }
          return removed;
      }
      /**
       * Method for checking whether an object should be considered a model for
       * the purposes of adding to the collection.
       */
      _isModel(model) {
          return model instanceof Model;
      }
      /**
       * Internal method to create a model's ties to a collection.
       */
      _addReference(model, _options) {
          this._byId[model.cid] = model;
          const id = this.modelId(model.attributes);
          if (id != null)
              this._byId[id] = model;
          model.on('all', this._onModelEvent, this);
      }
      /**
       * Internal method to sever a model's ties to a collection.
       */
      _removeReference(model, _options) {
          delete this._byId[model.cid];
          const id = this.modelId(model.attributes);
          if (id != null)
              delete this._byId[id];
          if (this === model.collection)
              delete model.collection;
          model.off('all', this._onModelEvent, this);
      }
      /**
       * Internal method called every time a model in the set fires an event.
       * Sets need to update their indexes when models change ids. All other
       * events simply proxy through. "add" and "remove" events that originate
       * in other collections are ignored.
       */
      _onModelEvent(event, model, collection, options) {
          if (model) {
              if ((event === 'add' || event === 'remove') && collection !== this)
                  return;
              if (event === 'destroy')
                  this.remove(model, options);
              if (event === 'change') {
                  const prevId = this.modelId(model.previousAttributes());
                  const id = this.modelId(model.attributes);
                  if (prevId !== id) {
                      if (prevId != null)
                          delete this._byId[prevId];
                      if (id != null)
                          this._byId[id] = model;
                  }
              }
          }
          this.trigger.apply(this, arguments);
      }
  }
  _a = Symbol.iterator;
  // This "enum" defines the three possible kinds of values which can be emitted
  // by a CollectionIterator that correspond to the values(), keys() and entries()
  // methods on Collection, respectively.
  const ITERATOR_VALUES = 1;
  const ITERATOR_KEYS = 2;
  const ITERATOR_KEYSVALUES = 3;
  /**
   * @public
   */
  class CollectionIterator {
      /**
       * A CollectionIterator implements JavaScript's Iterator protocol, allowing the
       * use of `for of` loops in modern browsers and interoperation between
       * Collection and other JavaScript functions and third-party libraries
       * which can operate on Iterables.
       */
      constructor(collection, kind) {
          this._collection = collection;
          this._kind = kind;
          this._index = 0;
      }
      next() {
          if (this._collection) {
              // Only continue iterating if the iterated collection is long enough.
              if (this._index < this._collection.length) {
                  const model = this._collection.at(this._index);
                  this._index++;
                  if (!model) {
                      return { value: undefined, done: true };
                  }
                  // Construct a value depending on what kind of values should be iterated.
                  let value;
                  if (this._kind === ITERATOR_VALUES) {
                      value = model;
                  }
                  else {
                      const id = this._collection.modelId(model.attributes);
                      if (this._kind === ITERATOR_KEYS) {
                          value = id;
                      }
                      else {
                          // ITERATOR_KEYSVALUES
                          value = [id, model];
                      }
                  }
                  return { value, done: false };
              }
              // Once exhausted, remove the reference to the collection so future
              // calls to the next method always return done.
              this._collection = undefined;
          }
          return { value: undefined, done: true };
      }
      [Symbol.iterator]() {
          return this;
      }
  }

  /* global global */
  /**
   * @public
   */
  const skeletor = {
      Collection,
      EventEmitter,
      Model,
      sync,
  };
  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
  // We use `self` instead of `window` for `WebWorker` support.
  const root = (typeof self == 'object' && self.self === self && self) ||
      (typeof __webpack_require__.g == 'object' && __webpack_require__.g.global === __webpack_require__.g && __webpack_require__.g);
  // Current version of the library. Keep in sync with `package.json`.
  skeletor.VERSION = '0.0.1';
  // Save the previous value of the `Skeletor` variable, so that it can be
  // restored later on, if `noConflict` is used.
  const previousSkeletor = root.Skeletor;
  // Runs Skeletor.js in *noConflict* mode, returning the `Skeletor` variable
  // to its previous owner. Returns a reference to this Skeletor object.
  /**
   * @public
   */
  function noConflict() {
      root.Skeletor = previousSkeletor;
      return this;
  }
  skeletor.noConflict = noConflict;
  root.Skeletor = skeletor;

  exports.BrowserStorage = BrowserStorage;
  exports.Collection = Collection;
  exports.EventEmitter = EventEmitter;
  exports.Model = Model;
  exports.default = skeletor;
  exports.noConflict = noConflict;
  exports.sync = sync;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=skeletor.js.map


},
353(module) {
!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));

},
375(module) {
!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";return function(e,t){var r=t.prototype,n=r.format;r.format=function(e){var t=this,r=this.$locale();if(!this.isValid())return n.bind(this)(e);var s=this.$utils(),a=(e||"YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g,(function(e){switch(e){case"Q":return Math.ceil((t.$M+1)/3);case"Do":return r.ordinal(t.$D);case"gggg":return t.weekYear();case"GGGG":return t.isoWeekYear();case"wo":return r.ordinal(t.week(),"W");case"w":case"ww":return s.s(t.week(),"w"===e?1:2,"0");case"W":case"WW":return s.s(t.isoWeek(),"W"===e?1:2,"0");case"k":case"kk":return s.s(String(0===t.$H?24:t.$H),"k"===e?1:2,"0");case"X":return Math.floor(t.$d.getTime()/1e3);case"x":return t.$d.getTime();case"z":return"["+t.offsetName()+"]";case"zzz":return"["+t.offsetName("long")+"]";default:return e}}));return n.bind(this)(a)}}}));

},
750(module) {
!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"};return function(t,o,n){var r=o.prototype,i=r.format;n.en.formats=e,r.format=function(t){void 0===t&&(t="YYYY-MM-DDTHH:mm:ssZ");var o=this.$locale().formats,n=function(t,o){return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var i=r&&r.toUpperCase();return n||o[r]||e[r]||o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,o){return t||o.slice(1)}))}))}(t,void 0===o?{}:o);return i.call(this,n)}}}));

},
204(__unused_rspack_module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(994);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createDriver;

var _regenerator = _interopRequireDefault(__webpack_require__(756));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(693));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(293));

var _utils = __webpack_require__(281);

function createDriver(name, property) {
  var storage = (0, _utils.getStorage)();
  var support = !!(storage && storage[property]);
  var driver = support ? storage[property] : {
    clear: function clear() {},
    get: function get() {},
    remove: function remove() {},
    set: function set() {}
  };

  var _clear = driver.clear.bind(driver);

  var get = driver.get.bind(driver);
  var remove = driver.remove.bind(driver);
  var set = driver.set.bind(driver);
  return {
    _driver: name,
    _support: support,
    // eslint-disable-next-line no-underscore-dangle
    _initStorage: function _initStorage() {
      return Promise.resolve();
    },
    clear: function clear(callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _clear();

                if (callback) callback();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    iterate: function iterate(iterator, callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var items, keys;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _utils.usePromise)(get, null);

              case 2:
                items = _context2.sent;
                keys = Object.keys(items);
                keys.forEach(function (key, i) {
                  return iterator(items[key], key, i);
                });
                if (callback) callback();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getItem: function getItem(key, callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return (0, _utils.usePromise)(get, key);

              case 3:
                result = _context3.sent;
                result = typeof key === 'string' ? result[key] : result;
                result = result === undefined ? null : result;
                if (callback) callback(null, result);
                return _context3.abrupt("return", result);

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);
                if (callback) callback(_context3.t0);
                throw _context3.t0;

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 10]]);
      }))();
    },
    key: function key(n, callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var results, key;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _utils.usePromise)(get, null);

              case 2:
                results = _context4.sent;
                key = Object.keys(results)[n];
                if (callback) callback(key);
                return _context4.abrupt("return", key);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    keys: function keys(callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var results, keys;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (0, _utils.usePromise)(get, null);

              case 2:
                results = _context5.sent;
                keys = Object.keys(results);
                if (callback) callback(keys);
                return _context5.abrupt("return", keys);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    length: function length(callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var results, _Object$keys, length;

        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return (0, _utils.usePromise)(get, null);

              case 2:
                results = _context6.sent;
                _Object$keys = Object.keys(results), length = _Object$keys.length;
                if (callback) callback(length);
                return _context6.abrupt("return", length);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    removeItem: function removeItem(key, callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return (0, _utils.usePromise)(remove, key);

              case 2:
                if (callback) callback();

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    setItem: function setItem(key, value, callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return (0, _utils.usePromise)(set, (0, _defineProperty2["default"])({}, key, value));

              case 2:
                if (callback) callback();

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    }
  };
}

},
735(__unused_rspack_module, exports, __webpack_require__) {
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(994);

__webpack_unused_export__ = ({
  value: true
});
exports["default"] = void 0;

var _driver = _interopRequireDefault(__webpack_require__(204));

var _default = (0, _driver["default"])('webExtensionLocalStorage', 'local');

exports["default"] = _default;

},
685(__unused_rspack_module, exports, __webpack_require__) {
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(994);

__webpack_unused_export__ = ({
  value: true
});
exports["default"] = void 0;

var _driver = _interopRequireDefault(__webpack_require__(204));

var _default = (0, _driver["default"])('webExtensionSyncStorage', 'sync');

exports["default"] = _default;

},
281(__unused_rspack_module, exports) {


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getStorage = getStorage;
exports.usePromise = usePromise;

/**
 * Need to invoke a function at runtime instead of import-time to make tests
 * pass with mocked browser and chrome objects
 */
function getStorage() {
  return typeof browser !== 'undefined' && browser.storage || typeof chrome !== 'undefined' && chrome.storage;
}
/**
 * Need to invoke a function at runtime instead of import-time to make tests
 * pass with mocked browser and chrome objects
 */


function usesPromises() {
  var storage = getStorage();

  try {
    return storage && storage.local.get && storage.local.get() && typeof storage.local.get().then === 'function';
  } catch (e) {
    return false;
  }
}
/**
 * Converts a callback-based API to a promise based API.
 * For now we assume that there is only one arg in addition to the callback
 */


function usePromise(fn, arg) {
  if (usesPromises()) {
    return fn(arg);
  }

  return new Promise(function (resolve) {
    fn(arg, function () {
      resolve.apply(void 0, arguments);
    });
  });
}

},
56(module) {
/*!
 * Sizzle CSS Selector Engine v2.3.10
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2023-02-14
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
	// Make sure the the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {

			// Support: IE <9 only
			// IE doesn't have `contains` on `document` so we need to check for
			// `documentElement` presence.
			// We need to fall back to `a` when `documentElement` is missing
			// as `ownerDocument` of elements within `<template/>` may have
			// a null one - a default behavior of all modern browsers.
			var adown = a.nodeType === 9 && a.documentElement || a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

// EXPOSE
var _sizzle = window.Sizzle;

Sizzle.noConflict = function() {
	if ( window.Sizzle === Sizzle ) {
		window.Sizzle = _sizzle;
	}

	return Sizzle;
};

if ( typeof define === "function" && define.amd ) {
	define( function() {
		return Sizzle;
	} );

// Sizzle requires that there be a global window in Common-JS like environments
} else if (  true && module.exports ) {
	module.exports = Sizzle;
} else {
	window.Sizzle = Sizzle;
}

// EXPOSE

} )( window );


},
604(__unused_rspack_module, exports) {
var __webpack_unused_export__;
/* global window, exports, define */

!function() {
    'use strict'

    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    }

    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments)
    }

    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []))
    }

    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
        for (i = 0; i < tree_length; i++) {
            if (typeof parse_tree[i] === 'string') {
                output += parse_tree[i]
            }
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i] // convenience purposes only
                if (ph.keys) { // keyword argument
                    arg = argv[cursor]
                    for (k = 0; k < ph.keys.length; k++) {
                        if (arg == undefined) {
                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
                        }
                        arg = arg[ph.keys[k]]
                    }
                }
                else if (ph.param_no) { // positional argument (explicit)
                    arg = argv[ph.param_no]
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++]
                }

                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
                    arg = arg()
                }

                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
                }

                if (re.number.test(ph.type)) {
                    is_positive = arg >= 0
                }

                switch (ph.type) {
                    case 'b':
                        arg = parseInt(arg, 10).toString(2)
                        break
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10))
                        break
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10)
                        break
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
                        break
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
                        break
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
                        break
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
                        break
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8)
                        break
                    case 's':
                        arg = String(arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 't':
                        arg = String(!!arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0
                        break
                    case 'v':
                        arg = arg.valueOf()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16)
                        break
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
                        break
                }
                if (re.json.test(ph.type)) {
                    output += arg
                }
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-'
                        arg = arg.toString().replace(re.sign, '')
                    }
                    else {
                        sign = ''
                    }
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
                    pad_length = ph.width - (sign + arg).length
                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
                }
            }
        }
        return output
    }

    var sprintf_cache = Object.create(null)

    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
            return sprintf_cache[fmt]
        }

        var _fmt = fmt, match, parse_tree = [], arg_names = 0
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree.push(match[0])
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree.push('%')
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1
                    var field_list = [], replacement_field = match[2], field_match = []
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1])
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else {
                                throw new SyntaxError('[sprintf] failed to parse named argument key')
                            }
                        }
                    }
                    else {
                        throw new SyntaxError('[sprintf] failed to parse named argument key')
                    }
                    match[2] = field_list
                }
                else {
                    arg_names |= 2
                }
                if (arg_names === 3) {
                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
                }

                parse_tree.push(
                    {
                        placeholder: match[0],
                        param_no:    match[1],
                        keys:        match[2],
                        sign:        match[3],
                        pad_char:    match[4],
                        align:       match[5],
                        width:       match[6],
                        precision:   match[7],
                        type:        match[8]
                    }
                )
            }
            else {
                throw new SyntaxError('[sprintf] unexpected placeholder')
            }
            _fmt = _fmt.substring(match[0].length)
        }
        return sprintf_cache[fmt] = parse_tree
    }

    /**
     * export to either browser or node.js
     */
    /* eslint-disable quote-props */
    if (true) {
        exports.sprintf = sprintf
        __webpack_unused_export__ = vsprintf
    }
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf
        window['vsprintf'] = vsprintf

        if (typeof define === 'function' && define['amd']) {
            define(function() {
                return {
                    'sprintf': sprintf,
                    'vsprintf': vsprintf
                }
            })
        }
    }
    /* eslint-enable quote-props */
}(); // eslint-disable-line


},
172(module) {
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
293(module) {
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
693(module, __unused_rspack_exports, __webpack_require__) {
var toPropertyKey = __webpack_require__(736);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
994(module) {
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
993(module, __unused_rspack_exports, __webpack_require__) {
var regeneratorDefine = __webpack_require__(546);
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), regeneratorDefine(u), regeneratorDefine(u, o, "Generator"), regeneratorDefine(u, n, function () {
    return this;
  }), regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (module.exports = _regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
869(module, __unused_rspack_exports, __webpack_require__) {
var regeneratorAsyncGen = __webpack_require__(887);
function _regeneratorAsync(n, e, r, t, o) {
  var a = regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
module.exports = _regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
887(module, __unused_rspack_exports, __webpack_require__) {
var regenerator = __webpack_require__(993);
var regeneratorAsyncIterator = __webpack_require__(791);
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new regeneratorAsyncIterator(regenerator().w(r, e, t, o), n || Promise);
}
module.exports = _regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
791(module, __unused_rspack_exports, __webpack_require__) {
var OverloadYield = __webpack_require__(172);
var regeneratorDefine = __webpack_require__(546);
function AsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (regeneratorDefine(AsyncIterator.prototype), regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), regeneratorDefine(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
module.exports = AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
546(module) {
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  module.exports = _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _regeneratorDefine(e, r, n, t);
}
module.exports = _regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
373(module) {
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
module.exports = _regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
633(module, __unused_rspack_exports, __webpack_require__) {
var OverloadYield = __webpack_require__(172);
var regenerator = __webpack_require__(993);
var regeneratorAsync = __webpack_require__(869);
var regeneratorAsyncGen = __webpack_require__(887);
var regeneratorAsyncIterator = __webpack_require__(791);
var regeneratorKeys = __webpack_require__(373);
var regeneratorValues = __webpack_require__(579);
function _regeneratorRuntime() {
  "use strict";

  var r = regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    "throw": 1,
    "return": 2,
    "break": 3,
    "continue": 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        "catch": function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new OverloadYield(r, e);
      },
      AsyncIterator: regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? regeneratorAsyncGen : regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: regeneratorKeys,
      values: regeneratorValues
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
579(module, __unused_rspack_exports, __webpack_require__) {
var _typeof = (__webpack_require__(738)/* ["default"] */["default"]);
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
module.exports = _regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
45(module, __unused_rspack_exports, __webpack_require__) {
var _typeof = (__webpack_require__(738)/* ["default"] */["default"]);
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
736(module, __unused_rspack_exports, __webpack_require__) {
var _typeof = (__webpack_require__(738)/* ["default"] */["default"]);
var toPrimitive = __webpack_require__(45);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
738(module) {
function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
756(module, __unused_rspack_exports, __webpack_require__) {
// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(633)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


},

});
// The module cache
var __webpack_module_cache__ = {};

// The require function
function __webpack_require__(moduleId) {

// Check if module is in cache
var cachedModule = __webpack_module_cache__[moduleId];
if (cachedModule !== undefined) {
return cachedModule.exports;
}
// Create a new module (and put it into the cache)
var module = (__webpack_module_cache__[moduleId] = {
id: moduleId,
loaded: false,
exports: {}
});
// Execute the module function
__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);

// Flag the module as loaded
module.loaded = true;
// Return the exports of the module
return module.exports;

}

// webpack/runtime/compat_get_default_export
(() => {
// getDefaultExport function for compatibility with non-ESM modules
__webpack_require__.n = (module) => {
	var getter = module && module.__esModule ?
		() => (module['default']) :
		() => (module);
	__webpack_require__.d(getter, { a: getter });
	return getter;
};

})();
// webpack/runtime/define_property_getters
(() => {
__webpack_require__.d = (exports, definition) => {
	for(var key in definition) {
        if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
            Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
        }
    }
};
})();
// webpack/runtime/global
(() => {
__webpack_require__.g = (() => {
	if (typeof globalThis === 'object') return globalThis;
	try {
		return this || new Function('return this')();
	} catch (e) {
		if (typeof window === 'object') return window;
	}
})();
})();
// webpack/runtime/has_own_property
(() => {
__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
})();
// webpack/runtime/make_namespace_object
(() => {
// define __esModule on exports
__webpack_require__.r = (exports) => {
	if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	}
	Object.defineProperty(exports, '__esModule', { value: true });
};
})();
// webpack/runtime/node_module_decorator
(() => {
__webpack_require__.nmd = (module) => {
  module.paths = [];
  if (!module.children) module.children = [];
  return module;
};
})();
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Xh: () => (/* reexport */ bookmarks_model),
  sB: () => (/* reexport */ chat_model),
  pM: () => (/* reexport */ skeletor.Collection),
  u: () => (/* reexport */ headless_utils),
  bk: () => (/* reexport */ skeletor.EventEmitter),
  mu: () => (/* reexport */ muc_muc),
  Q1: () => (/* reexport */ muc_messages),
  Kx: () => (/* reexport */ skeletor.Model),
  uk: () => (/* reexport */ omemo_devices),
  WV: () => (/* reexport */ Profile),
  yp: () => (/* reexport */ MAMPlaceholderMessage),
  K2: () => (/* reexport */ vcard_vcards),
  pJ: () => (/* reexport */ muc_message),
  XQ: () => (/* reexport */ shared_message),
  w: () => (/* reexport */ model_with_messages_ModelWithMessages),
  JR: () => (/* reexport */ shared_converse),
  AA: () => (/* binding */ constants),
  QB: () => (/* reexport */ chat_message),
  T7: () => (/* reexport */ roster_presences),
  yP: () => (/* reexport */ contacts),
  T_: () => (/* reexport */ parsers_namespaceObject),
  _r: () => (/* reexport */ bookmarks_collection),
  B2: () => (/* reexport */ chat_messages),
  Jn: () => (/* reexport */ vcard_vcard),
  C7: () => (/* reexport */ roster_contact),
  PW: () => (/* reexport */ muc_occupant),
  K_: () => (/* reexport */ omemo_devicelists),
  G2: () => (/* reexport */ RosterFilter),
  Ay: () => (/* binding */ headless),
  Rm: () => (/* reexport */ src_log),
  pF: () => (/* reexport */ omemo_device),
  pP: () => (/* reexport */ picker),
  Cq: () => (/* reexport */ roster_presence),
  sO: () => (/* reexport */ errors_namespaceObject),
  FH: () => (/* reexport */ shared_api),
  fs: () => (/* reexport */ omemo_devicelist),
  M$: () => (/* reexport */ Builder),
  Ru: () => (/* reexport */ i18n),
  iq: () => (/* reexport */ api_public),
  O0: () => (/* reexport */ occupants),
  Qd: () => (/* reexport */ Stanza)
});
// NAMESPACE OBJECT: ./src/headless/utils/html.js
var html_namespaceObject = {};
__webpack_require__.r(html_namespaceObject);
__webpack_require__.d(html_namespaceObject, { 
  decodeHTMLEntities: () => (decodeHTMLEntities),
  isElement: () => (isElement),
  isEqualNode: () => (isEqualNode),
  isTagEqual: () => (html_isTagEqual),
  queryChildren: () => (queryChildren),
  siblingIndex: () => (siblingIndex),
  stringToElement: () => (stringToElement),
  unescapeHTML: () => (unescapeHTML) });

// NAMESPACE OBJECT: ./src/headless/utils/stanza.js
var stanza_namespaceObject = {};
__webpack_require__.r(stanza_namespaceObject);
__webpack_require__.d(stanza_namespaceObject, { 
  getAttributes: () => (getAttributes),
  isErrorStanza: () => (isErrorStanza),
  isForbiddenError: () => (isForbiddenError),
  isServiceUnavailableError: () => (isServiceUnavailableError),
  toStanza: () => (toStanza) });

// NAMESPACE OBJECT: ./src/headless/utils/object.js
var object_namespaceObject = {};
__webpack_require__.r(object_namespaceObject);
__webpack_require__.d(object_namespaceObject, { 
  isEmpty: () => (isEmpty),
  isError: () => (isError),
  isErrorObject: () => (isErrorObject),
  isFunction: () => (object_isFunction),
  isPersistableModel: () => (isPersistableModel),
  isUndefined: () => (isUndefined),
  merge: () => (merge) });

// NAMESPACE OBJECT: ./src/headless/utils/session.js
var session_namespaceObject = {};
__webpack_require__.r(session_namespaceObject);
__webpack_require__.d(session_namespaceObject, { 
  clearSession: () => (clearSession),
  getUnloadEvent: () => (getUnloadEvent),
  isTestEnv: () => (isTestEnv),
  isUniView: () => (isUniView),
  replacePromise: () => (replacePromise),
  shouldClearCache: () => (shouldClearCache),
  tearDown: () => (tearDown) });

// NAMESPACE OBJECT: ./src/headless/shared/constants.js
var shared_constants_namespaceObject = {};
__webpack_require__.r(shared_constants_namespaceObject);
__webpack_require__.d(shared_constants_namespaceObject, { 
  ACTIVE: () => (ACTIVE),
  ANONYMOUS: () => (ANONYMOUS),
  BOSH_WAIT: () => (BOSH_WAIT),
  CHATROOMS_TYPE: () => (CHATROOMS_TYPE),
  CHAT_STATES: () => (CHAT_STATES),
  CLOSED: () => (CLOSED),
  COMPOSING: () => (COMPOSING),
  CONNECTION_STATUS: () => (CONNECTION_STATUS),
  CONTROLBOX_TYPE: () => (CONTROLBOX_TYPE),
  CORE_PLUGINS: () => (CORE_PLUGINS),
  EXTERNAL: () => (EXTERNAL),
  FAILURE: () => (FAILURE),
  GONE: () => (GONE),
  HEADLINES_TYPE: () => (HEADLINES_TYPE),
  INACTIVE: () => (INACTIVE),
  KEYCODES: () => (KEYCODES),
  LOGIN: () => (LOGIN),
  LOGOUT: () => (LOGOUT),
  MARKER_TYPES: () => (MARKER_TYPES),
  METADATA_ATTRIBUTES: () => (METADATA_ATTRIBUTES),
  OPENED: () => (OPENED),
  PAUSED: () => (PAUSED),
  PREBIND: () => (PREBIND),
  PRES_SHOW_VALUES: () => (PRES_SHOW_VALUES),
  PRES_TYPE_VALUES: () => (PRES_TYPE_VALUES),
  PRIVATE_CHAT_TYPE: () => (PRIVATE_CHAT_TYPE),
  STATUS_WEIGHTS: () => (STATUS_WEIGHTS),
  SUCCESS: () => (SUCCESS),
  VERSION_NAME: () => (VERSION_NAME),
  XFORM_TYPE_MAP: () => (XFORM_TYPE_MAP),
  XFORM_VALIDATE_TYPE_MAP: () => (XFORM_VALIDATE_TYPE_MAP) });

// NAMESPACE OBJECT: ./src/headless/utils/storage.js
var storage_namespaceObject = {};
__webpack_require__.r(storage_namespaceObject);
__webpack_require__.d(storage_namespaceObject, { 
  createStore: () => (createStore),
  getDefaultStorageType: () => (getDefaultStorageType),
  initStorage: () => (initStorage) });

// NAMESPACE OBJECT: ./src/headless/utils/jid.js
var jid_namespaceObject = {};
__webpack_require__.r(jid_namespaceObject);
__webpack_require__.d(jid_namespaceObject, { 
  getJIDFromURI: () => (getJIDFromURI),
  isOwnJID: () => (isOwnJID),
  isSameBareJID: () => (isSameBareJID),
  isSameDomain: () => (isSameDomain),
  isValidJID: () => (isValidJID),
  isValidMUCJID: () => (isValidMUCJID),
  maybeAppendDomain: () => (maybeAppendDomain) });

// NAMESPACE OBJECT: ./src/headless/utils/init.js
var init_namespaceObject = {};
__webpack_require__.r(init_namespaceObject);
__webpack_require__.d(init_namespaceObject, { 
  attemptNonPreboundSession: () => (attemptNonPreboundSession),
  cleanup: () => (cleanup),
  initClientConfig: () => (initClientConfig),
  initPersistentStorage: () => (initPersistentStorage),
  initPlugins: () => (initPlugins),
  initSession: () => (initSession),
  initSessionStorage: () => (initSessionStorage),
  registerGlobalEventHandlers: () => (registerGlobalEventHandlers),
  safeSave: () => (safeSave),
  savedLoginInfo: () => (savedLoginInfo),
  setUserJID: () => (setUserJID) });

// NAMESPACE OBJECT: ./src/headless/utils/promise.js
var promise_namespaceObject = {};
__webpack_require__.r(promise_namespaceObject);
__webpack_require__.d(promise_namespaceObject, { 
  debounce: () => (promise_debounce),
  getOpenPromise: () => (getOpenPromise),
  waitUntil: () => (waitUntil) });

// NAMESPACE OBJECT: ./src/headless/shared/errors.js
var errors_namespaceObject = {};
__webpack_require__.r(errors_namespaceObject);
__webpack_require__.d(errors_namespaceObject, { 
  BadRequestError: () => (BadRequestError),
  ConflictError: () => (ConflictError),
  FeatureNotImplementedError: () => (FeatureNotImplementedError),
  ForbiddenError: () => (ForbiddenError),
  GoneError: () => (GoneError),
  IQError: () => (IQError),
  InternalServerError: () => (InternalServerError),
  ItemNotFoundError: () => (ItemNotFoundError),
  JIDMalformedError: () => (JIDMalformedError),
  MethodNotImplementedError: () => (MethodNotImplementedError),
  NotAcceptableError: () => (NotAcceptableError),
  NotAllowedError: () => (NotAllowedError),
  NotAuthorizedError: () => (NotAuthorizedError),
  PaymentRequiredError: () => (PaymentRequiredError),
  RecipientUnavailableError: () => (RecipientUnavailableError),
  RedirectError: () => (RedirectError),
  RegistrationRequiredError: () => (RegistrationRequiredError),
  RemoteServerNotFoundError: () => (RemoteServerNotFoundError),
  RemoteServerTimeoutError: () => (RemoteServerTimeoutError),
  ResourceConstraintError: () => (ResourceConstraintError),
  ServiceUnavailableError: () => (ServiceUnavailableError),
  StanzaError: () => (StanzaError),
  StanzaParseError: () => (StanzaParseError),
  SubscriptionRequiredError: () => (SubscriptionRequiredError),
  TimeoutError: () => (TimeoutError),
  UndefinedConditionError: () => (UndefinedConditionError),
  UnexpectedRequestError: () => (UnexpectedRequestError),
  UserFacingError: () => (UserFacingError) });

// NAMESPACE OBJECT: ./src/headless/utils/array.js
var array_namespaceObject = {};
__webpack_require__.r(array_namespaceObject);
__webpack_require__.d(array_namespaceObject, { 
  unique: () => (array_unique) });

// NAMESPACE OBJECT: ./src/headless/utils/arraybuffer.js
var arraybuffer_namespaceObject = {};
__webpack_require__.r(arraybuffer_namespaceObject);
__webpack_require__.d(arraybuffer_namespaceObject, { 
  appendArrayBuffer: () => (appendArrayBuffer),
  arrayBufferToBase64: () => (arrayBufferToBase64),
  arrayBufferToHex: () => (arrayBufferToHex),
  arrayBufferToString: () => (arrayBufferToString),
  base64ToArrayBuffer: () => (base64ToArrayBuffer),
  hexToArrayBuffer: () => (hexToArrayBuffer),
  stringToArrayBuffer: () => (stringToArrayBuffer) });

// NAMESPACE OBJECT: ./src/headless/utils/color.js
var color_namespaceObject = {};
__webpack_require__.r(color_namespaceObject);
__webpack_require__.d(color_namespaceObject, { 
  colorize: () => (colorize) });

// NAMESPACE OBJECT: ./src/headless/utils/text.js
var text_namespaceObject = {};
__webpack_require__.r(text_namespaceObject);
__webpack_require__.d(text_namespaceObject, { 
  firstCharToUpperCase: () => (firstCharToUpperCase),
  getLongestSubstring: () => (getLongestSubstring),
  isString: () => (isString) });

// NAMESPACE OBJECT: ./src/headless/utils/url.js
var url_namespaceObject = {};
__webpack_require__.r(url_namespaceObject);
__webpack_require__.d(url_namespaceObject, { 
  addMediaURLsOffset: () => (addMediaURLsOffset),
  checkFileTypes: () => (checkFileTypes),
  getHeaders: () => (getHeaders),
  getMediaURLs: () => (getMediaURLs),
  getMediaURLsMetadata: () => (getMediaURLsMetadata),
  getMetadataForURL: () => (getMetadataForURL),
  getURL: () => (getURL),
  isAudioURL: () => (isAudioURL),
  isEncryptedFileURL: () => (isEncryptedFileURL),
  isGIFURL: () => (isGIFURL),
  isImageURL: () => (isImageURL),
  isURLWithImageExtension: () => (isURLWithImageExtension),
  isValidURL: () => (isValidURL),
  isVideoURL: () => (isVideoURL),
  withinString: () => (withinString) });

// NAMESPACE OBJECT: ./src/headless/shared/parsers.js
var parsers_namespaceObject = {};
__webpack_require__.r(parsers_namespaceObject);
__webpack_require__.d(parsers_namespaceObject, { 
  getChatMarker: () => (getChatMarker),
  getChatState: () => (getChatState),
  getCorrectionAttributes: () => (getCorrectionAttributes),
  getDeprecatedRetractionAttributes: () => (getDeprecatedRetractionAttributes),
  getEncryptionAttributes: () => (getEncryptionAttributes),
  getErrorAttributes: () => (getErrorAttributes),
  getInputType: () => (getInputType),
  getOpenGraphMetadata: () => (getOpenGraphMetadata),
  getOutOfBandAttributes: () => (getOutOfBandAttributes),
  getReceiptId: () => (getReceiptId),
  getReferences: () => (getReferences),
  getReplyAttributes: () => (getReplyAttributes),
  getRetractionAttributes: () => (getRetractionAttributes),
  getSpoilerAttributes: () => (getSpoilerAttributes),
  getStanzaIDs: () => (getStanzaIDs),
  isArchived: () => (isArchived),
  isCarbon: () => (isCarbon),
  isHeadline: () => (isHeadline),
  isMUCPrivateMessage: () => (isMUCPrivateMessage),
  isServerMessage: () => (isServerMessage),
  isValidReceiptRequest: () => (isValidReceiptRequest),
  parseErrorStanza: () => (parseErrorStanza),
  parseXForm: () => (parseXForm),
  throwErrorIfInvalidForward: () => (throwErrorIfInvalidForward) });

// NAMESPACE OBJECT: ./src/headless/plugins/muc/constants.js
var muc_constants_namespaceObject = {};
__webpack_require__.r(muc_constants_namespaceObject);
__webpack_require__.d(muc_constants_namespaceObject, { 
  ACTION_INFO_CODES: () => (ACTION_INFO_CODES),
  ADMIN_COMMANDS: () => (ADMIN_COMMANDS),
  AFFILIATIONS: () => (AFFILIATIONS),
  AFFILIATION_CHANGES: () => (AFFILIATION_CHANGES),
  AFFILIATION_CHANGES_LIST: () => (AFFILIATION_CHANGES_LIST),
  DISCONNECT_CODES: () => (DISCONNECT_CODES),
  INFO_CODES: () => (INFO_CODES),
  MODERATOR_COMMANDS: () => (MODERATOR_COMMANDS),
  MUC_NICK_CHANGED_CODE: () => (MUC_NICK_CHANGED_CODE),
  MUC_ROLE_CHANGES: () => (MUC_ROLE_CHANGES),
  MUC_ROLE_CHANGES_LIST: () => (MUC_ROLE_CHANGES_LIST),
  MUC_ROLE_WEIGHTS: () => (MUC_ROLE_WEIGHTS),
  MUC_TRAFFIC_STATES: () => (MUC_TRAFFIC_STATES),
  MUC_TRAFFIC_STATES_LIST: () => (MUC_TRAFFIC_STATES_LIST),
  NEW_NICK_CODES: () => (NEW_NICK_CODES),
  OWNER_COMMANDS: () => (OWNER_COMMANDS),
  ROLES: () => (ROLES),
  ROOMSTATUS: () => (ROOMSTATUS),
  ROOM_FEATURES: () => (ROOM_FEATURES),
  STATUS_CODE_STANZAS: () => (STATUS_CODE_STANZAS),
  VISITOR_COMMANDS: () => (VISITOR_COMMANDS) });

// NAMESPACE OBJECT: ./src/headless/plugins/omemo/constants.js
var omemo_constants_namespaceObject = {};
__webpack_require__.r(omemo_constants_namespaceObject);
__webpack_require__.d(omemo_constants_namespaceObject, { 
  KEY_ALGO: () => (KEY_ALGO),
  TAG_LENGTH: () => (TAG_LENGTH),
  TRUSTED: () => (TRUSTED),
  UNDECIDED: () => (UNDECIDED),
  UNTRUSTED: () => (UNTRUSTED) });


;// CONCATENATED MODULE: ./src/log/index.js
/**
 * @type {Object.<string, number>}
 */
const LEVELS = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
    fatal: 4,
};

/**
 * Logs messages to the console.
 * Available loglevels are:
 *      - 0: 'debug'
 *      - 1: 'info'
 *      - 2: 'warn',
 *      - 3: 'error'
 *      - 4: 'fatal'.
 * @namespace log
 */
const log = {
    /** @type {keyof LEVELS} The current log level */
    loglevel: 'info',

    /**
     * Sets the current log level which determines which messages are logged
     * @param {keyof LEVELS} level - The log level to set
     * @throws {Error} If an invalid log level is provided
     */
    setLogLevel(level) {
        if (!['debug', 'info', 'warn', 'error', 'fatal'].includes(/** @type {string} */ (level))) {
            throw new Error(`Invalid loglevel: ${level}`);
        }
        this.loglevel = level;
    },

    /**
     * Logs a message at the specified level.
     * Accepts the same arguments as the corresponding console method.
     * @param {keyof LEVELS} level - The log level to use
     * @param  {...any} args - Arguments passed through to the console method
     */
    log(level, ...args) {
        if (LEVELS[level] < LEVELS[this.loglevel]) {
            return;
        }

        const [msg, ...rest] = args;
        let formattedMsg = msg;
        if (msg instanceof Error) {
            formattedMsg = msg.stack;
        } else if (typeof Element !== 'undefined' && msg instanceof Element) {
            formattedMsg = msg.outerHTML;
        }

        const method = level === 'fatal' ? 'error' : level;
        console[method](formattedMsg, ...rest);
    },

    /**
     * @param  {...any} args - Arguments passed through to console.debug
     */
    debug(...args) {
        this.log('debug', ...args);
    },

    /**
     * @param  {...any} args - Arguments passed through to console.error
     */
    error(...args) {
        this.log('error', ...args);
    },

    /**
     * @param  {...any} args - Arguments passed through to console.info
     */
    info(...args) {
        this.log('info', ...args);
    },

    /**
     * @param  {...any} args - Arguments passed through to console.warn
     */
    warn(...args) {
        this.log('warn', ...args);
    },

    /**
     * @param  {...any} args - Arguments passed through to console.error
     */
    fatal(...args) {
        this.log('fatal', ...args);
    },
};

/* export default */ const src_log = (log);

// EXTERNAL MODULE: ./node_modules/sizzle/dist/sizzle.js
var sizzle = __webpack_require__(56);
var sizzle_default = /*#__PURE__*/__webpack_require__.n(sizzle);
;// CONCATENATED MODULE: ./node_modules/strophe.js/dist/strophe.browser.esm.js
/**
 * Common namespace constants from the XMPP RFCs and XEPs.
 *
 * @typedef { Object } NS
 * @property {string} NS.HTTPBIND - HTTP BIND namespace from XEP 124.
 * @property {string} NS.BOSH - BOSH namespace from XEP 206.
 * @property {string} NS.CLIENT - Main XMPP client namespace.
 * @property {string} NS.AUTH - Legacy authentication namespace.
 * @property {string} NS.ROSTER - Roster operations namespace.
 * @property {string} NS.PROFILE - Profile namespace.
 * @property {string} NS.DISCO_INFO - Service discovery info namespace from XEP 30.
 * @property {string} NS.DISCO_ITEMS - Service discovery items namespace from XEP 30.
 * @property {string} NS.MUC - Multi-User Chat namespace from XEP 45.
 * @property {string} NS.SASL - XMPP SASL namespace from RFC 3920.
 * @property {string} NS.STREAM - XMPP Streams namespace from RFC 3920.
 * @property {string} NS.BIND - XMPP Binding namespace from RFC 3920 and RFC 6120.
 * @property {string} NS.SESSION - XMPP Session namespace from RFC 3920.
 * @property {string} NS.XHTML_IM - XHTML-IM namespace from XEP 71.
 * @property {string} NS.XHTML - XHTML body namespace from XEP 71.
 * @property {string} NS.STANZAS
 * @property {string} NS.FRAMING
 */
const NS = {
  HTTPBIND: 'http://jabber.org/protocol/httpbind',
  BOSH: 'urn:xmpp:xbosh',
  CLIENT: 'jabber:client',
  SERVER: 'jabber:server',
  AUTH: 'jabber:iq:auth',
  ROSTER: 'jabber:iq:roster',
  PROFILE: 'jabber:iq:profile',
  DISCO_INFO: 'http://jabber.org/protocol/disco#info',
  DISCO_ITEMS: 'http://jabber.org/protocol/disco#items',
  MUC: 'http://jabber.org/protocol/muc',
  SASL: 'urn:ietf:params:xml:ns:xmpp-sasl',
  STREAM: 'http://etherx.jabber.org/streams',
  FRAMING: 'urn:ietf:params:xml:ns:xmpp-framing',
  BIND: 'urn:ietf:params:xml:ns:xmpp-bind',
  SESSION: 'urn:ietf:params:xml:ns:xmpp-session',
  VERSION: 'jabber:iq:version',
  STANZAS: 'urn:ietf:params:xml:ns:xmpp-stanzas',
  XHTML_IM: 'http://jabber.org/protocol/xhtml-im',
  XHTML: 'http://www.w3.org/1999/xhtml'
};
const PARSE_ERROR_NS = 'http://www.w3.org/1999/xhtml';

/**
 * Contains allowed tags, tag attributes, and css properties.
 * Used in the {@link Strophe.createHtml} function to filter incoming html into the allowed XHTML-IM subset.
 * See [XEP-0071](http://xmpp.org/extensions/xep-0071.html#profile-summary) for the list of recommended
 * allowed tags and their attributes.
 */
const XHTML = {
  tags: ['a', 'blockquote', 'br', 'cite', 'em', 'img', 'li', 'ol', 'p', 'span', 'strong', 'ul', 'body'],
  attributes: {
    'a': ['href'],
    'blockquote': ['style'],
    /** @type {never[]} */
    'br': [],
    'cite': ['style'],
    /** @type {never[]} */
    'em': [],
    'img': ['src', 'alt', 'style', 'height', 'width'],
    'li': ['style'],
    'ol': ['style'],
    'p': ['style'],
    'span': ['style'],
    /** @type {never[]} */
    'strong': [],
    'ul': ['style'],
    /** @type {never[]} */
    'body': []
  },
  css: ['background-color', 'color', 'font-family', 'font-size', 'font-style', 'font-weight', 'margin-left', 'margin-right', 'text-align', 'text-decoration']
};

/** @typedef {number} connstatus */

/**
 * Connection status constants for use by the connection handler
 * callback.
 *
 * @typedef {Object} Status
 * @property {connstatus} Status.ERROR - An error has occurred
 * @property {connstatus} Status.CONNECTING - The connection is currently being made
 * @property {connstatus} Status.CONNFAIL - The connection attempt failed
 * @property {connstatus} Status.AUTHENTICATING - The connection is authenticating
 * @property {connstatus} Status.AUTHFAIL - The authentication attempt failed
 * @property {connstatus} Status.CONNECTED - The connection has succeeded
 * @property {connstatus} Status.DISCONNECTED - The connection has been terminated
 * @property {connstatus} Status.DISCONNECTING - The connection is currently being terminated
 * @property {connstatus} Status.ATTACHED - The connection has been attached
 * @property {connstatus} Status.REDIRECT - The connection has been redirected
 * @property {connstatus} Status.CONNTIMEOUT - The connection has timed out
 * @property {connstatus} Status.BINDREQUIRED - The JID resource needs to be bound for this session
 * @property {connstatus} Status.ATTACHFAIL - Failed to attach to a pre-existing session
 * @property {connstatus} Status.RECONNECTING - Not used by Strophe, but added for integrators
 */
const Status = {
  ERROR: 0,
  CONNECTING: 1,
  CONNFAIL: 2,
  AUTHENTICATING: 3,
  AUTHFAIL: 4,
  CONNECTED: 5,
  DISCONNECTED: 6,
  DISCONNECTING: 7,
  ATTACHED: 8,
  REDIRECT: 9,
  CONNTIMEOUT: 10,
  BINDREQUIRED: 11,
  ATTACHFAIL: 12,
  RECONNECTING: 13
};
const ErrorCondition = {
  BAD_FORMAT: 'bad-format',
  CONFLICT: 'conflict',
  MISSING_JID_NODE: 'x-strophe-bad-non-anon-jid',
  NO_AUTH_MECH: 'no-auth-mech',
  UNKNOWN_REASON: 'unknown'
};

/**
 * Logging level indicators.
 * @typedef {0|1|2|3|4} LogLevel
 * @typedef {'DEBUG'|'INFO'|'WARN'|'ERROR'|'FATAL'} LogLevelName
 * @typedef {Record<LogLevelName, LogLevel>} LogLevels
 */
const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  FATAL: 4
};

/**
 * DOM element types.
 *
 * - ElementType.NORMAL - Normal element.
 * - ElementType.TEXT - Text data element.
 * - ElementType.FRAGMENT - XHTML fragment element.
 */
const ElementType = {
  NORMAL: 1,
  TEXT: 3,
  CDATA: 4,
  FRAGMENT: 11
};

/**
 * @typedef {import('./constants').LogLevel} LogLevel
 */
let logLevel = LOG_LEVELS.DEBUG;
const strophe_browser_esm_log = {
  /**
   * Library consumers can use this function to set the log level of Strophe.
   * The default log level is Strophe.LogLevel.INFO.
   * @param {LogLevel} level
   * @example Strophe.setLogLevel(Strophe.LogLevel.DEBUG);
   */
  setLogLevel(level) {
    if (level < LOG_LEVELS.DEBUG || level > LOG_LEVELS.FATAL) {
      throw new Error("Invalid log level supplied to setLogLevel");
    }
    logLevel = level;
  },
  /**
   *
   * Please note that data sent and received over the wire is logged
   * via {@link Strophe.Connection#rawInput|Strophe.Connection.rawInput()}
   * and {@link Strophe.Connection#rawOutput|Strophe.Connection.rawOutput()}.
   *
   * The different levels and their meanings are
   *
   *   DEBUG - Messages useful for debugging purposes.
   *   INFO - Informational messages.  This is mostly information like
   *     'disconnect was called' or 'SASL auth succeeded'.
   *   WARN - Warnings about potential problems.  This is mostly used
   *     to report transient connection errors like request timeouts.
   *   ERROR - Some error occurred.
   *   FATAL - A non-recoverable fatal error occurred.
   *
   * @param {number} level - The log level of the log message.
   *     This will be one of the values in Strophe.LOG_LEVELS.
   * @param {string} msg - The log message.
   */
  log(level, msg) {
    if (level < logLevel) {
      return;
    }
    if (level >= LOG_LEVELS.ERROR) {
      var _console;
      (_console = console) === null || _console === void 0 ? void 0 : _console.error(msg);
    } else if (level === LOG_LEVELS.INFO) {
      var _console2;
      (_console2 = console) === null || _console2 === void 0 ? void 0 : _console2.info(msg);
    } else if (level === LOG_LEVELS.WARN) {
      var _console3;
      (_console3 = console) === null || _console3 === void 0 ? void 0 : _console3.warn(msg);
    } else if (level === LOG_LEVELS.DEBUG) {
      var _console4;
      (_console4 = console) === null || _console4 === void 0 ? void 0 : _console4.debug(msg);
    }
  },
  /**
   * Log a message at the Strophe.LOG_LEVELS.DEBUG level.
   * @param {string} msg - The log message.
   */
  debug(msg) {
    this.log(LOG_LEVELS.DEBUG, msg);
  },
  /**
   * Log a message at the Strophe.LOG_LEVELS.INFO level.
   * @param {string} msg - The log message.
   */
  info(msg) {
    this.log(LOG_LEVELS.INFO, msg);
  },
  /**
   * Log a message at the Strophe.LOG_LEVELS.WARN level.
   * @param {string} msg - The log message.
   */
  warn(msg) {
    this.log(LOG_LEVELS.WARN, msg);
  },
  /**
   * Log a message at the Strophe.LOG_LEVELS.ERROR level.
   * @param {string} msg - The log message.
   */
  error(msg) {
    this.log(LOG_LEVELS.ERROR, msg);
  },
  /**
   * Log a message at the Strophe.LOG_LEVELS.FATAL level.
   * @param {string} msg - The log message.
   */
  fatal(msg) {
    this.log(LOG_LEVELS.FATAL, msg);
  }
};

/* global btoa */

/**
 * Takes a string and turns it into an XML Element.
 * @param {string} string
 * @param {boolean} [throwErrorIfInvalidNS]
 * @returns {Element}
 */
function toElement(string, throwErrorIfInvalidNS) {
  const doc = strophe_browser_esm_xmlHtmlNode(string);
  const parserError = getParserError(doc);
  if (parserError) {
    throw new Error(`Parser Error: ${parserError}`);
  }
  const node = getFirstElementChild(doc);
  if (['message', 'iq', 'presence'].includes(node.nodeName.toLowerCase()) && node.namespaceURI !== 'jabber:client' && node.namespaceURI !== 'jabber:server') {
    const err_msg = `Invalid namespaceURI ${node.namespaceURI}`;
    if (throwErrorIfInvalidNS) {
      throw new Error(err_msg);
    } else {
      strophe_browser_esm_log.error(err_msg);
    }
  }
  return node;
}

/**
 * Properly logs an error to the console
 * @param {Error} e
 */
function handleError(e) {
  if (typeof e.stack !== 'undefined') {
    strophe_browser_esm_log.fatal(e.stack);
  }
  strophe_browser_esm_log.fatal('error: ' + e.message);
}

/**
 * @param {string} str
 * @return {string}
 */
function utf16to8(str) {
  let out = '';
  const len = str.length;
  for (let i = 0; i < len; i++) {
    const c = str.charCodeAt(i);
    if (c >= 0x0000 && c <= 0x007f) {
      out += str.charAt(i);
    } else if (c > 0x07ff) {
      out += String.fromCharCode(0xe0 | c >> 12 & 0x0f);
      out += String.fromCharCode(0x80 | c >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3f);
    } else {
      out += String.fromCharCode(0xc0 | c >> 6 & 0x1f);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3f);
    }
  }
  return out;
}

/**
 * @param {ArrayBufferLike} x
 * @param {ArrayBufferLike} y
 */
function xorArrayBuffers(x, y) {
  const xIntArray = new Uint8Array(x);
  const yIntArray = new Uint8Array(y);
  const zIntArray = new Uint8Array(x.byteLength);
  for (let i = 0; i < x.byteLength; i++) {
    zIntArray[i] = xIntArray[i] ^ yIntArray[i];
  }
  return zIntArray.buffer;
}

/**
 * @param {ArrayBufferLike} buffer
 * @return {string}
 */
function arrayBufToBase64(buffer) {
  // This function is due to mobz (https://stackoverflow.com/users/1234628/mobz)
  // and Emmanuel (https://stackoverflow.com/users/288564/emmanuel)
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

/**
 * @param {string} str
 * @return {ArrayBufferLike}
 */
function base64ToArrayBuf(str) {
  var _Uint8Array$from;
  return (_Uint8Array$from = Uint8Array.from(atob(str), c => c.charCodeAt(0))) === null || _Uint8Array$from === void 0 ? void 0 : _Uint8Array$from.buffer;
}

/**
 * @param {string} str
 * @return {ArrayBufferLike}
 */
function stringToArrayBuf(str) {
  const bytes = new TextEncoder().encode(str);
  return bytes.buffer;
}

/**
 * @param {Cookies} cookies
 */
function addCookies(cookies) {
  if (typeof document === 'undefined') {
    strophe_browser_esm_log.error(`addCookies: not adding any cookies, since there's no document object`);
  }

  /**
   * @typedef {Object.<string, string>} Cookie
   *
   * A map of cookie names to string values or to maps of cookie values.
   * @typedef {Cookie|Object.<string, Cookie>} Cookies
   *
   * For example:
   * { "myCookie": "1234" }
   *
   * or:
   * { "myCookie": {
   *    "value": "1234",
   *    "domain": ".example.org",
   *    "path": "/",
   *    "expires": expirationDate
   *    }
   * }
   *
   * These values get passed to {@link Strophe.Connection} via options.cookies
   */
  cookies = cookies || {};
  for (const cookieName in cookies) {
    if (Object.prototype.hasOwnProperty.call(cookies, cookieName)) {
      let expires = '';
      let domain = '';
      let path = '';
      const cookieObj = cookies[cookieName];
      const isObj = typeof cookieObj === 'object';
      const cookieValue = escape(unescape(isObj ? cookieObj.value : cookieObj));
      if (isObj) {
        expires = cookieObj.expires ? ';expires=' + cookieObj.expires : '';
        domain = cookieObj.domain ? ';domain=' + cookieObj.domain : '';
        path = cookieObj.path ? ';path=' + cookieObj.path : '';
      }
      document.cookie = cookieName + '=' + cookieValue + expires + domain + path;
    }
  }
}

/** @type {Document} */
let _xmlGenerator = null;

/**
 * Get the DOM document to generate elements.
 * @return {Document} - The currently used DOM document.
 */
function xmlGenerator() {
  if (!_xmlGenerator) {
    _xmlGenerator = document.implementation.createDocument('jabber:client', 'strophe', null);
  }
  return _xmlGenerator;
}

/**
 * Creates an XML DOM text node.
 * Provides a cross implementation version of document.createTextNode.
 * @param {string} text - The content of the text node.
 * @return {Text} - A new XML DOM text node.
 */
function xmlTextNode(text) {
  return xmlGenerator().createTextNode(text);
}

/**
 * @param {Element} stanza
 * @return {Element}
 */
function stripWhitespace(stanza) {
  const childNodes = Array.from(stanza.childNodes);
  if (childNodes.length === 1 && childNodes[0].nodeType === ElementType.TEXT) {
    // If the element has only one child and it's a text node, we assume
    // it's significant and don't remove it, even if it's only whitespace.
    return stanza;
  }
  childNodes.forEach(node => {
    if (node.nodeName.toLowerCase() === 'body') {
      // We don't remove anything inside <body> elements
      return;
    }
    if (node.nodeType === ElementType.TEXT && !/\S/.test(node.nodeValue)) {
      stanza.removeChild(node);
    } else if (node.nodeType === ElementType.NORMAL) {
      stripWhitespace(/** @type {Element} */node);
    }
  });
  return stanza;
}

/**
 * Creates an XML DOM node.
 * @param {string} text - The contents of the XML element.
 * @return {XMLDocument}
 */
function strophe_browser_esm_xmlHtmlNode(text) {
  const parser = new DOMParser();
  return parser.parseFromString(text, 'text/xml');
}

/**
 * @param {XMLDocument} doc
 * @returns {string|null}
 */
function getParserError(doc) {
  var _doc$firstElementChil;
  const el = ((_doc$firstElementChil = doc.firstElementChild) === null || _doc$firstElementChil === void 0 ? void 0 : _doc$firstElementChil.nodeName) === 'parsererror' ? doc.firstElementChild : doc.getElementsByTagNameNS(PARSE_ERROR_NS, 'parsererror')[0];
  return (el === null || el === void 0 ? void 0 : el.nodeName) === 'parsererror' ? el === null || el === void 0 ? void 0 : el.textContent : null;
}

/**
 * @param {XMLDocument} el
 * @returns {Element}
 */
function getFirstElementChild(el) {
  if (el.firstElementChild) return el.firstElementChild;
  let node,
    i = 0;
  const nodes = el.childNodes;
  while (node = nodes[i++]) {
    if (node.nodeType === 1) return /** @type {Element} */node;
  }
  return null;
}

/**
 * Create an XML DOM element.
 *
 * This function creates an XML DOM element correctly across all
 * implementations. Note that these are not HTML DOM elements, which
 * aren't appropriate for XMPP stanzas.
 *
 * @param {string} name - The name for the element.
 * @param {Array<Array<string>>|Object.<string,string|number>|string|number} [attrs]
 *    An optional array or object containing
 *    key/value pairs to use as element attributes.
 *    The object should be in the format `{'key': 'value'}`.
 *    The array should have the format `[['key1', 'value1'], ['key2', 'value2']]`.
 * @param {string|number} [text] - The text child data for the element.
 *
 * @return {Element} A new XML DOM element.
 */
function xmlElement(name, attrs, text) {
  if (!name) return null;
  const node = xmlGenerator().createElement(name);
  if (text && (typeof text === 'string' || typeof text === 'number')) {
    node.appendChild(xmlTextNode(text.toString()));
  } else if (typeof attrs === 'string' || typeof attrs === 'number') {
    node.appendChild(xmlTextNode(/** @type {number|string} */attrs.toString()));
    return node;
  }
  if (!attrs) {
    return node;
  } else if (Array.isArray(attrs)) {
    for (const attr of attrs) {
      if (Array.isArray(attr)) {
        // eslint-disable-next-line no-eq-null
        if (attr[0] != null && attr[1] != null) {
          node.setAttribute(attr[0], attr[1]);
        }
      }
    }
  } else if (typeof attrs === 'object') {
    for (const k of Object.keys(attrs)) {
      // eslint-disable-next-line no-eq-null
      if (k && attrs[k] != null) {
        node.setAttribute(k, attrs[k].toString());
      }
    }
  }
  return node;
}

/**
 * Utility method to determine whether a tag is allowed
 * in the XHTML_IM namespace.
 *
 * XHTML tag names are case sensitive and must be lower case.
 * @method Strophe.XHTML.validTag
 * @param {string} tag
 */
function validTag(tag) {
  for (let i = 0; i < XHTML.tags.length; i++) {
    if (tag === XHTML.tags[i]) {
      return true;
    }
  }
  return false;
}

/**
 * @typedef {'a'|'blockquote'|'br'|'cite'|'em'|'img'|'li'|'ol'|'p'|'span'|'strong'|'ul'|'body'} XHTMLAttrs
 */

/**
 * Utility method to determine whether an attribute is allowed
 * as recommended per XEP-0071
 *
 * XHTML attribute names are case sensitive and must be lower case.
 * @method Strophe.XHTML.validAttribute
 * @param {string} tag
 * @param {string} attribute
 */
function validAttribute(tag, attribute) {
  const attrs = XHTML.attributes[(/** @type {XHTMLAttrs} */tag)];
  if ((attrs === null || attrs === void 0 ? void 0 : attrs.length) > 0) {
    for (let i = 0; i < attrs.length; i++) {
      if (attribute === attrs[i]) {
        return true;
      }
    }
  }
  return false;
}

/**
 * @method Strophe.XHTML.validCSS
 * @param {string} style
 */
function validCSS(style) {
  for (let i = 0; i < XHTML.css.length; i++) {
    if (style === XHTML.css[i]) {
      return true;
    }
  }
  return false;
}

/**
 * Copy an HTML DOM Element into an XML DOM.
 * This function copies a DOM element and all its descendants and returns
 * the new copy.
 * @param {HTMLElement} elem - A DOM element.
 * @return {Node} - A new, copied DOM element tree.
 */
function createFromHtmlElement(elem) {
  let el;
  const tag = elem.nodeName.toLowerCase(); // XHTML tags must be lower case.
  if (validTag(tag)) {
    try {
      el = xmlElement(tag);
      if (tag in XHTML.attributes) {
        const attrs = XHTML.attributes[(/** @type {XHTMLAttrs} */tag)];
        for (let i = 0; i < attrs.length; i++) {
          const attribute = attrs[i];
          let value = elem.getAttribute(attribute);
          if (typeof value === 'undefined' || value === null || value === '') {
            continue;
          }
          if (attribute === 'style' && typeof value === 'object') {
            var _value$cssText;
            value = /** @type {Object.<'csstext',string>} */(_value$cssText = value.cssText) !== null && _value$cssText !== void 0 ? _value$cssText : value; // we're dealing with IE, need to get CSS out
          }

          // filter out invalid css styles
          if (attribute === 'style') {
            const css = [];
            const cssAttrs = value.split(';');
            for (let j = 0; j < cssAttrs.length; j++) {
              const attr = cssAttrs[j].split(':');
              const cssName = attr[0].replace(/^\s*/, '').replace(/\s*$/, '').toLowerCase();
              if (validCSS(cssName)) {
                const cssValue = attr[1].replace(/^\s*/, '').replace(/\s*$/, '');
                css.push(cssName + ': ' + cssValue);
              }
            }
            if (css.length > 0) {
              value = css.join('; ');
              el.setAttribute(attribute, value);
            }
          } else {
            el.setAttribute(attribute, value);
          }
        }
        for (let i = 0; i < elem.childNodes.length; i++) {
          el.appendChild(createHtml(elem.childNodes[i]));
        }
      }
    } catch (_e) {
      // invalid elements
      el = xmlTextNode('');
    }
  } else {
    el = xmlGenerator().createDocumentFragment();
    for (let i = 0; i < elem.childNodes.length; i++) {
      el.appendChild(createHtml(elem.childNodes[i]));
    }
  }
  return el;
}

/**
 * Copy an HTML DOM Node into an XML DOM.
 * This function copies a DOM element and all its descendants and returns
 * the new copy.
 * @method Strophe.createHtml
 * @param {Node} node - A DOM element.
 * @return {Node} - A new, copied DOM element tree.
 */
function createHtml(node) {
  if (node.nodeType === ElementType.NORMAL) {
    return createFromHtmlElement(/** @type {HTMLElement} */node);
  } else if (node.nodeType === ElementType.FRAGMENT) {
    const el = xmlGenerator().createDocumentFragment();
    for (let i = 0; i < node.childNodes.length; i++) {
      el.appendChild(createHtml(node.childNodes[i]));
    }
    return el;
  } else if (node.nodeType === ElementType.TEXT) {
    return xmlTextNode(node.nodeValue);
  }
}

/**
 * Copy an XML DOM element.
 *
 * This function copies a DOM element and all its descendants and returns
 * the new copy.
 * @method Strophe.copyElement
 * @param {Node} node - A DOM element.
 * @return {Element|Text} - A new, copied DOM element tree.
 */
function copyElement(node) {
  let out;
  if (node.nodeType === ElementType.NORMAL) {
    const el = /** @type {Element} */node;
    out = xmlElement(el.tagName);
    for (let i = 0; i < el.attributes.length; i++) {
      out.setAttribute(el.attributes[i].nodeName, el.attributes[i].value);
    }
    for (let i = 0; i < el.childNodes.length; i++) {
      out.appendChild(copyElement(el.childNodes[i]));
    }
  } else if (node.nodeType === ElementType.TEXT) {
    out = xmlGenerator().createTextNode(node.nodeValue);
  }
  return out;
}

/**
 * Excapes invalid xml characters.
 * @method Strophe.xmlescape
 * @param {string} text - text to escape.
 * @return {string} - Escaped text.
 */
function xmlescape(text) {
  text = text.replace(/\&/g, '&amp;');
  text = text.replace(/</g, '&lt;');
  text = text.replace(/>/g, '&gt;');
  text = text.replace(/'/g, '&apos;');
  text = text.replace(/"/g, '&quot;');
  return text;
}

/**
 * Unexcapes invalid xml characters.
 * @method Strophe.xmlunescape
 * @param {string} text - text to unescape.
 * @return {string} - Unescaped text.
 */
function xmlunescape(text) {
  text = text.replace(/\&amp;/g, '&');
  text = text.replace(/&lt;/g, '<');
  text = text.replace(/&gt;/g, '>');
  text = text.replace(/&apos;/g, "'");
  text = text.replace(/&quot;/g, '"');
  return text;
}

/**
 * Map a function over some or all child elements of a given element.
 *
 * This is a small convenience function for mapping a function over
 * some or all of the children of an element.  If elemName is null, all
 * children will be passed to the function, otherwise only children
 * whose tag names match elemName will be passed.
 *
 * @method Strophe.forEachChild
 * @param {Element} elem - The element to operate on.
 * @param {string} elemName - The child element tag name filter.
 * @param {Function} func - The function to apply to each child.  This
 *    function should take a single argument, a DOM element.
 */
function forEachChild(elem, elemName, func) {
  for (let i = 0; i < elem.childNodes.length; i++) {
    const childNode = elem.childNodes[i];
    if (childNode.nodeType === ElementType.NORMAL && (!elemName || this.isTagEqual(childNode, elemName))) {
      func(childNode);
    }
  }
}

/**
 * Compare an element's tag name with a string.
 * This function is case sensitive.
 * @method Strophe.isTagEqual
 * @param {Element} el - A DOM element.
 * @param {string} name - The element name.
 * @return {boolean}
 *  true if the element's tag name matches _el_, and false
 *  otherwise.
 */
function isTagEqual(el, name) {
  return el.tagName === name;
}

/**
 * Get the concatenation of all text children of an element.
 * @method Strophe.getText
 * @param {Element} elem - A DOM element.
 * @return {string} - A String with the concatenated text of all text element children.
 */
function getText(elem) {
  if (!elem) return null;
  let str = '';
  if (!elem.childNodes.length && elem.nodeType === ElementType.TEXT) {
    str += elem.nodeValue;
  }
  for (const child of elem.childNodes) {
    if (child.nodeType === ElementType.TEXT) {
      str += child.nodeValue;
    }
  }
  return xmlescape(str);
}

/**
 * Escape the node part (also called local part) of a JID.
 * @method Strophe.escapeNode
 * @param {string} node - A node (or local part).
 * @return {string} An escaped node (or local part).
 */
function escapeNode(node) {
  if (typeof node !== 'string') {
    return node;
  }
  return node.replace(/^\s+|\s+$/g, '').replace(/\\/g, '\\5c').replace(/ /g, '\\20').replace(/\"/g, '\\22').replace(/\&/g, '\\26').replace(/\'/g, '\\27').replace(/\//g, '\\2f').replace(/:/g, '\\3a').replace(/</g, '\\3c').replace(/>/g, '\\3e').replace(/@/g, '\\40');
}

/**
 * Unescape a node part (also called local part) of a JID.
 * @method Strophe.unescapeNode
 * @param {string} node - A node (or local part).
 * @return {string} An unescaped node (or local part).
 */
function unescapeNode(node) {
  if (typeof node !== 'string') {
    return node;
  }
  return node.replace(/\\20/g, ' ').replace(/\\22/g, '"').replace(/\\26/g, '&').replace(/\\27/g, "'").replace(/\\2f/g, '/').replace(/\\3a/g, ':').replace(/\\3c/g, '<').replace(/\\3e/g, '>').replace(/\\40/g, '@').replace(/\\5c/g, '\\');
}

/**
 * Get the node portion of a JID String.
 * @method Strophe.getNodeFromJid
 * @param {string} jid - A JID.
 * @return {string} - A String containing the node.
 */
function getNodeFromJid(jid) {
  if (jid.indexOf('@') < 0) {
    return null;
  }
  return jid.split('@')[0];
}

/**
 * Get the domain portion of a JID String.
 * @method Strophe.getDomainFromJid
 * @param {string} jid - A JID.
 * @return {string} - A String containing the domain.
 */
function getDomainFromJid(jid) {
  const bare = getBareJidFromJid(jid);
  if (bare.indexOf('@') < 0) {
    return bare;
  } else {
    const parts = bare.split('@');
    parts.splice(0, 1);
    return parts.join('@');
  }
}

/**
 * Get the resource portion of a JID String.
 * @method Strophe.getResourceFromJid
 * @param {string} jid - A JID.
 * @return {string} - A String containing the resource.
 */
function getResourceFromJid(jid) {
  if (!jid) {
    return null;
  }
  const s = jid.split('/');
  if (s.length < 2) {
    return null;
  }
  s.splice(0, 1);
  return s.join('/');
}

/**
 * Get the bare JID from a JID String.
 * @method Strophe.getBareJidFromJid
 * @param {string} jid - A JID.
 * @return {string} - A String containing the bare JID.
 */
function getBareJidFromJid(jid) {
  return jid ? jid.split('/')[0] : null;
}
const utils = {
  utf16to8,
  xorArrayBuffers,
  arrayBufToBase64,
  base64ToArrayBuf,
  stringToArrayBuf,
  addCookies
};

var utils$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    toElement: toElement,
    handleError: handleError,
    utf16to8: utf16to8,
    xorArrayBuffers: xorArrayBuffers,
    arrayBufToBase64: arrayBufToBase64,
    base64ToArrayBuf: base64ToArrayBuf,
    stringToArrayBuf: stringToArrayBuf,
    addCookies: addCookies,
    xmlGenerator: xmlGenerator,
    xmlTextNode: xmlTextNode,
    stripWhitespace: stripWhitespace,
    xmlHtmlNode: strophe_browser_esm_xmlHtmlNode,
    getParserError: getParserError,
    getFirstElementChild: getFirstElementChild,
    xmlElement: xmlElement,
    validTag: validTag,
    validAttribute: validAttribute,
    validCSS: validCSS,
    createHtml: createHtml,
    copyElement: copyElement,
    xmlescape: xmlescape,
    xmlunescape: xmlunescape,
    forEachChild: forEachChild,
    isTagEqual: isTagEqual,
    getText: getText,
    escapeNode: escapeNode,
    unescapeNode: unescapeNode,
    getNodeFromJid: getNodeFromJid,
    getDomainFromJid: getDomainFromJid,
    getResourceFromJid: getResourceFromJid,
    getBareJidFromJid: getBareJidFromJid,
    'default': utils
});

/**
 * Create a {@link Strophe.Builder}
 * This is an alias for `new Strophe.Builder(name, attrs)`.
 * @param {string} name - The root element name.
 * @param {Object.<string,string|number>} [attrs] - The attributes for the root element in object notation.
 * @return {Builder} A new Strophe.Builder object.
 */
function $build(name, attrs) {
  return new Builder(name, attrs);
}

/**
 * Create a {@link Strophe.Builder} with a `<message/>` element as the root.
 * @param {Object.<string,string>} [attrs] - The <message/> element attributes in object notation.
 * @return {Builder} A new Strophe.Builder object.
 */
function $msg(attrs) {
  return new Builder('message', attrs);
}

/**
 * Create a {@link Strophe.Builder} with an `<iq/>` element as the root.
 * @param {Object.<string,string>} [attrs] - The <iq/> element attributes in object notation.
 * @return {Builder} A new Strophe.Builder object.
 */
function $iq(attrs) {
  return new Builder('iq', attrs);
}

/**
 * Create a {@link Strophe.Builder} with a `<presence/>` element as the root.
 * @param {Object.<string,string>} [attrs] - The <presence/> element attributes in object notation.
 * @return {Builder} A new Strophe.Builder object.
 */
function $pres(attrs) {
  return new Builder('presence', attrs);
}

/**
 * This class provides an interface similar to JQuery but for building
 * DOM elements easily and rapidly.  All the functions except for `toString()`
 * and tree() return the object, so calls can be chained.
 *
 * The corresponding DOM manipulations to get a similar fragment would be
 * a lot more tedious and probably involve several helper variables.
 *
 * Since adding children makes new operations operate on the child, up()
 * is provided to traverse up the tree.  To add two children, do
 * > builder.c('child1', ...).up().c('child2', ...)
 *
 * The next operation on the Builder will be relative to the second child.
 *
 * @example
 *  // Here's an example using the $iq() builder helper.
 *  $iq({to: 'you', from: 'me', type: 'get', id: '1'})
 *      .c('query', {xmlns: 'strophe:example'})
 *      .c('example')
 *      .toString()
 *
 *  // The above generates this XML fragment
 *  //  <iq to='you' from='me' type='get' id='1'>
 *  //    <query xmlns='strophe:example'>
 *  //      <example/>
 *  //    </query>
 *  //  </iq>
 */
class Builder {
  /**
   * @typedef {Object.<string, string|number>} StanzaAttrs
   * @property {string} [StanzaAttrs.xmlns]
   */

  /** @type {Element} */
  #nodeTree;
  /** @type {Element} */
  #node;
  /** @type {string} */
  #name;
  /** @type {StanzaAttrs} */
  #attrs;

  /**
   * The attributes should be passed in object notation.
   * @param {string} name - The name of the root element.
   * @param {StanzaAttrs} [attrs] - The attributes for the root element in object notation.
   * @example const b = new Builder('message', {to: 'you', from: 'me'});
   * @example const b = new Builder('messsage', {'xml:lang': 'en'});
   */
  constructor(name, attrs) {
    // Set correct namespace for jabber:client elements
    if (name === 'presence' || name === 'message' || name === 'iq') {
      if (attrs && !attrs.xmlns) {
        attrs.xmlns = NS.CLIENT;
      } else if (!attrs) {
        attrs = {
          xmlns: NS.CLIENT
        };
      }
    }
    this.#name = name;
    this.#attrs = attrs;
  }

  /**
   * Creates a new Builder object from an XML string.
   * @param {string} str
   * @returns {Builder}
   * @example const stanza = Builder.fromString('<presence from="juliet@example.com/chamber"></presence>');
   */
  static fromString(str) {
    const el = toElement(str, true);
    const b = new Builder('');
    b.#nodeTree = el;
    return b;
  }
  buildTree() {
    return xmlElement(this.#name, this.#attrs);
  }

  /** @return {Element} */
  get nodeTree() {
    if (!this.#nodeTree) {
      // Holds the tree being built.
      this.#nodeTree = this.buildTree();
    }
    return this.#nodeTree;
  }

  /** @return {Element} */
  get node() {
    if (!this.#node) {
      this.#node = this.tree();
    }
    return this.#node;
  }

  /** @param {Element} el */
  set node(el) {
    this.#node = el;
  }

  /**
   * Render a DOM element and all descendants to a String.
   * @param {Element|Builder} elem - A DOM element.
   * @return {string} - The serialized element tree as a String.
   */
  static serialize(elem) {
    if (!elem) return null;
    const el = elem instanceof Builder ? elem.tree() : elem;
    const names = [...Array(el.attributes.length).keys()].map(i => el.attributes[i].nodeName);
    names.sort();
    let result = names.reduce((a, n) => `${a} ${n}="${xmlescape(el.attributes.getNamedItem(n).value)}"`, `<${el.nodeName}`);
    if (el.childNodes.length > 0) {
      result += '>';
      for (let i = 0; i < el.childNodes.length; i++) {
        const child = el.childNodes[i];
        switch (child.nodeType) {
          case ElementType.NORMAL:
            // normal element, so recurse
            result += Builder.serialize(/** @type {Element} */child);
            break;
          case ElementType.TEXT:
            // text element to escape values
            result += xmlescape(child.nodeValue);
            break;
          case ElementType.CDATA:
            // cdata section so don't escape values
            result += '<![CDATA[' + child.nodeValue + ']]>';
        }
      }
      result += '</' + el.nodeName + '>';
    } else {
      result += '/>';
    }
    return result;
  }

  /**
   * Return the DOM tree.
   *
   * This function returns the current DOM tree as an element object.  This
   * is suitable for passing to functions like Strophe.Connection.send().
   *
   * @return {Element} The DOM tree as a element object.
   */
  tree() {
    return this.nodeTree;
  }

  /**
   * Serialize the DOM tree to a String.
   *
   * This function returns a string serialization of the current DOM
   * tree.  It is often used internally to pass data to a
   * Strophe.Request object.
   *
   * @return {string} The serialized DOM tree in a String.
   */
  toString() {
    return Builder.serialize(this.tree());
  }

  /**
   * Make the current parent element the new current element.
   * This function is often used after c() to traverse back up the tree.
   *
   * @example
   *  // For example, to add two children to the same element
   *  builder.c('child1', {}).up().c('child2', {});
   *
   * @return {Builder} The Strophe.Builder object.
   */
  up() {
    // Depending on context, parentElement is not always available
    this.node = this.node.parentElement ? this.node.parentElement : (/** @type {Element} */this.node.parentNode);
    return this;
  }

  /**
   * Make the root element the new current element.
   *
   * When at a deeply nested element in the tree, this function can be used
   * to jump back to the root of the tree, instead of having to repeatedly
   * call up().
   *
   * @return {Builder} The Strophe.Builder object.
   */
  root() {
    this.node = this.tree();
    return this;
  }

  /**
   * Add or modify attributes of the current element.
   *
   * The attributes should be passed in object notation.
   * This function does not move the current element pointer.
   * @param {Object.<string, string|number|null>} moreattrs - The attributes to add/modify in object notation.
   *  If an attribute is set to `null` or `undefined`, it will be removed.
   * @return {Builder} The Strophe.Builder object.
   */
  attrs(moreattrs) {
    for (const k in moreattrs) {
      if (Object.prototype.hasOwnProperty.call(moreattrs, k)) {
        // eslint-disable-next-line no-eq-null
        if (moreattrs[k] != null) {
          this.node.setAttribute(k, moreattrs[k].toString());
        } else {
          this.node.removeAttribute(k);
        }
      }
    }
    return this;
  }

  /**
   * Add a child to the current element and make it the new current
   * element.
   *
   * This function moves the current element pointer to the child,
   * unless text is provided.  If you need to add another child, it
   * is necessary to use up() to go back to the parent in the tree.
   *
   * @param {string} name - The name of the child.
   * @param {Object.<string, string>|string} [attrs] - The attributes of the child in object notation.
   * @param {string} [text] - The text to add to the child.
   *
   * @return {Builder} The Strophe.Builder object.
   */
  c(name, attrs, text) {
    const child = xmlElement(name, attrs, text);
    this.node.appendChild(child);
    if (typeof text !== 'string' && typeof text !== 'number') {
      this.node = child;
    }
    return this;
  }

  /**
   * Add a child to the current element and make it the new current
   * element.
   *
   * This function is the same as c() except that instead of using a
   * name and an attributes object to create the child it uses an
   * existing DOM element object.
   *
   * @param {Element|Builder} elem - A DOM element.
   * @return {Builder} The Strophe.Builder object.
   */
  cnode(elem) {
    if (elem instanceof Builder) {
      elem = elem.tree();
    }
    let impNode;
    const xmlGen = xmlGenerator();
    try {
      impNode = xmlGen.importNode !== undefined;
    } catch (_e) {
      impNode = false;
    }
    const newElem = impNode ? xmlGen.importNode(elem, true) : copyElement(elem);
    this.node.appendChild(newElem);
    this.node = /** @type {Element} */newElem;
    return this;
  }

  /**
   * Add a child text element.
   *
   * This *does not* make the child the new current element since there
   * are no children of text elements.
   *
   * @param {string} text - The text data to append to the current element.
   * @return {Builder} The Strophe.Builder object.
   */
  t(text) {
    const child = xmlTextNode(text);
    this.node.appendChild(child);
    return this;
  }

  /**
   * Replace current element contents with the HTML passed in.
   *
   * This *does not* make the child the new current element
   *
   * @param {string} html - The html to insert as contents of current element.
   * @return {Builder} The Strophe.Builder object.
   */
  h(html) {
    const fragment = xmlGenerator().createElement('body');
    // force the browser to try and fix any invalid HTML tags
    fragment.innerHTML = html;
    // copy cleaned html into an xml dom
    const xhtml = createHtml(fragment);
    while (xhtml.childNodes.length > 0) {
      this.node.appendChild(xhtml.childNodes[0]);
    }
    return this;
  }
}

/**
 * _Private_ variable that keeps track of the request ids for connections.
 */
let _requestId = 0;

/**
 * Helper class that provides a cross implementation abstraction
 * for a BOSH related XMLHttpRequest.
 *
 * The Request class is used internally to encapsulate BOSH request
 * information.  It is not meant to be used from user's code.
 *
 * @property {number} id
 * @property {number} sends
 * @property {XMLHttpRequest} xhr
 */
class Request {
  /**
   * Create and initialize a new Request object.
   *
   * @param {Element} elem - The XML data to be sent in the request.
   * @param {Function} func - The function that will be called when the
   *     XMLHttpRequest readyState changes.
   * @param {number} rid - The BOSH rid attribute associated with this request.
   * @param {number} [sends=0] - The number of times this same request has been sent.
   */
  constructor(elem, func, rid, sends = 0) {
    this.id = ++_requestId;
    this.xmlData = elem;
    this.data = Builder.serialize(elem);
    // save original function in case we need to make a new request
    // from this one.
    this.origFunc = func;
    this.func = func;
    this.rid = rid;
    this.date = NaN;
    this.sends = sends;
    this.abort = false;
    this.dead = null;
    this.age = () => this.date ? (new Date().valueOf() - this.date.valueOf()) / 1000 : 0;
    this.timeDead = () => this.dead ? (new Date().valueOf() - this.dead.valueOf()) / 1000 : 0;
    this.xhr = this._newXHR();
  }

  /**
   * Get a response from the underlying XMLHttpRequest.
   * This function attempts to get a response from the request and checks
   * for errors.
   * @throws "parsererror" - A parser error occured.
   * @throws "bad-format" - The entity has sent XML that cannot be processed.
   * @return {Element} - The DOM element tree of the response.
   */
  getResponse() {
    var _this$xhr$responseXML;
    const node = (_this$xhr$responseXML = this.xhr.responseXML) === null || _this$xhr$responseXML === void 0 ? void 0 : _this$xhr$responseXML.documentElement;
    if (node) {
      if (node.tagName === 'parsererror') {
        strophe_browser_esm_log.error('invalid response received');
        strophe_browser_esm_log.error('responseText: ' + this.xhr.responseText);
        strophe_browser_esm_log.error('responseXML: ' + Builder.serialize(node));
        throw new Error('parsererror');
      }
    } else if (this.xhr.responseText) {
      // In Node (with xhr2) or React Native, we may get responseText but no responseXML.
      // We can try to parse it manually.
      strophe_browser_esm_log.debug('Got responseText but no responseXML; attempting to parse it with DOMParser...');
      const doc = strophe_browser_esm_xmlHtmlNode(this.xhr.responseText);
      const parserError = getParserError(doc);
      if (!doc || parserError) {
        if (parserError) {
          strophe_browser_esm_log.error('invalid response received: ' + parserError);
          strophe_browser_esm_log.error('responseText: ' + this.xhr.responseText);
        }
        const error = new Error();
        error.name = ErrorCondition.BAD_FORMAT;
        throw error;
      }
    }
    return node;
  }

  /**
   * _Private_ helper function to create XMLHttpRequests.
   * This function creates XMLHttpRequests across all implementations.
   * @private
   * @return {XMLHttpRequest}
   */
  _newXHR() {
    const xhr = new XMLHttpRequest();
    if (xhr.overrideMimeType) {
      xhr.overrideMimeType('text/xml; charset=utf-8');
    }
    // use Function.bind() to prepend ourselves as an argument
    xhr.onreadystatechange = this.func.bind(null, this);
    return xhr;
  }
}

/**
 * A JavaScript library to enable BOSH in Strophejs.
 *
 * this library uses Bidirectional-streams Over Synchronous HTTP (BOSH)
 * to emulate a persistent, stateful, two-way connection to an XMPP server.
 * More information on BOSH can be found in XEP 124.
 */
let timeoutMultiplier = 1.1;
let secondaryTimeoutMultiplier = 0.1;

/**
 * _Private_ helper class that handles BOSH Connections
 * The Bosh class is used internally by Connection
 * to encapsulate BOSH sessions. It is not meant to be used from user's code.
 */
class Bosh {
  /**
   * @param {Connection} connection - The Connection that will use BOSH.
   */
  constructor(connection) {
    var _Bosh$prototype$strip;
    this._conn = connection;
    /* request id for body tags */
    this.rid = Math.floor(Math.random() * 4294967295);
    /* The current session ID. */
    this.sid = null;

    // default BOSH values
    this.hold = 1;
    this.wait = 60;
    this.window = 5;
    this.errors = 0;
    this.inactivity = null;

    /**
     * BOSH-Connections will have all stanzas wrapped in a <body> tag when
     * passed to {@link Connection#xmlInput|xmlInput()} or {@link Connection#xmlOutput|xmlOutput()}.
     * To strip this tag, User code can set {@link Bosh#strip|strip} to `true`:
     *
     * > // You can set `strip` on the prototype
     * > Bosh.prototype.strip = true;
     *
     * > // Or you can set it on the Bosh instance (which is `._proto` on the connection instance.
     * > const conn = new Connection();
     * > conn._proto.strip = true;
     *
     * This will enable stripping of the body tag in both
     * {@link Connection#xmlInput|xmlInput} and {@link Connection#xmlOutput|xmlOutput}.
     *
     * @property {boolean} [strip=false]
     */
    this.strip = (_Bosh$prototype$strip = Bosh.prototype.strip) !== null && _Bosh$prototype$strip !== void 0 ? _Bosh$prototype$strip : false;
    this.lastResponseHeaders = null;
    /** @type {Request[]} */
    this._requests = [];
  }

  /**
   * @param {number} m
   */
  static setTimeoutMultiplier(m) {
    timeoutMultiplier = m;
  }

  /**
   * @returns {number}
   */
  static getTimeoutMultplier() {
    return timeoutMultiplier;
  }

  /**
   * @param {number} m
   */
  static setSecondaryTimeoutMultiplier(m) {
    secondaryTimeoutMultiplier = m;
  }

  /**
   * @returns {number}
   */
  static getSecondaryTimeoutMultplier() {
    return secondaryTimeoutMultiplier;
  }

  /**
   * _Private_ helper function to generate the <body/> wrapper for BOSH.
   * @private
   * @return {Builder} - A Builder with a <body/> element.
   */
  _buildBody() {
    const bodyWrap = $build('body', {
      'rid': this.rid++,
      'xmlns': NS.HTTPBIND
    });
    if (this.sid !== null) {
      bodyWrap.attrs({
        'sid': this.sid
      });
    }
    if (this._conn.options.keepalive && this._conn._sessionCachingSupported()) {
      this._cacheSession();
    }
    return bodyWrap;
  }

  /**
   * Reset the connection.
   * This function is called by the reset function of the Connection
   */
  _reset() {
    this.rid = Math.floor(Math.random() * 4294967295);
    this.sid = null;
    this.errors = 0;
    if (this._conn._sessionCachingSupported()) {
      sessionStorage.removeItem('strophe-bosh-session');
    }
    this._conn.nextValidRid(this.rid);
  }

  /**
   * _Private_ function that initializes the BOSH connection.
   * Creates and sends the Request that initializes the BOSH connection.
   * @param {number} wait - The optional HTTPBIND wait value.  This is the
   *     time the server will wait before returning an empty result for
   *     a request.  The default setting of 60 seconds is recommended.
   *     Other settings will require tweaks to the Strophe.TIMEOUT value.
   * @param {number} hold - The optional HTTPBIND hold value.  This is the
   *     number of connections the server will hold at one time.  This
   *     should almost always be set to 1 (the default).
   * @param {string} route
   */
  _connect(wait, hold, route) {
    this.wait = wait || this.wait;
    this.hold = hold || this.hold;
    this.errors = 0;
    const body = this._buildBody().attrs({
      'to': this._conn.domain,
      'xml:lang': 'en',
      'wait': this.wait,
      'hold': this.hold,
      'content': 'text/xml; charset=utf-8',
      'ver': '1.6',
      'xmpp:version': '1.0',
      'xmlns:xmpp': NS.BOSH
    });
    if (route) {
      body.attrs({
        route
      });
    }
    const _connect_cb = this._conn._connect_cb;
    this._requests.push(new Request(body.tree(), this._onRequestStateChange.bind(this, _connect_cb.bind(this._conn)), Number(body.tree().getAttribute('rid'))));
    this._throttledRequestHandler();
  }

  /**
   * Attach to an already created and authenticated BOSH session.
   *
   * This function is provided to allow Strophe to attach to BOSH
   * sessions which have been created externally, perhaps by a Web
   * application.  This is often used to support auto-login type features
   * without putting user credentials into the page.
   *
   * @param {string} jid - The full JID that is bound by the session.
   * @param {string} sid - The SID of the BOSH session.
   * @param {number} rid - The current RID of the BOSH session.  This RID
   *     will be used by the next request.
   * @param {Function} callback The connect callback function.
   * @param {number} wait - The optional HTTPBIND wait value.  This is the
   *     time the server will wait before returning an empty result for
   *     a request.  The default setting of 60 seconds is recommended.
   *     Other settings will require tweaks to the Strophe.TIMEOUT value.
   * @param {number} hold - The optional HTTPBIND hold value.  This is the
   *     number of connections the server will hold at one time.  This
   *     should almost always be set to 1 (the default).
   * @param {number} wind - The optional HTTBIND window value.  This is the
   *     allowed range of request ids that are valid.  The default is 5.
   */
  _attach(jid, sid, rid, callback, wait, hold, wind) {
    this._conn.jid = jid;
    this.sid = sid;
    this.rid = rid;
    this._conn.connect_callback = callback;
    this._conn.domain = getDomainFromJid(this._conn.jid);
    this._conn.authenticated = true;
    this._conn.connected = true;
    this.wait = wait || this.wait;
    this.hold = hold || this.hold;
    this.window = wind || this.window;
    this._conn._changeConnectStatus(Status.ATTACHED, null);
  }

  /**
   * Attempt to restore a cached BOSH session
   *
   * @param {string} jid - The full JID that is bound by the session.
   *     This parameter is optional but recommended, specifically in cases
   *     where prebinded BOSH sessions are used where it's important to know
   *     that the right session is being restored.
   * @param {Function} callback The connect callback function.
   * @param {number} wait - The optional HTTPBIND wait value.  This is the
   *     time the server will wait before returning an empty result for
   *     a request.  The default setting of 60 seconds is recommended.
   *     Other settings will require tweaks to the Strophe.TIMEOUT value.
   * @param {number} hold - The optional HTTPBIND hold value.  This is the
   *     number of connections the server will hold at one time.  This
   *     should almost always be set to 1 (the default).
   * @param {number} wind - The optional HTTBIND window value.  This is the
   *     allowed range of request ids that are valid.  The default is 5.
   */
  _restore(jid, callback, wait, hold, wind) {
    const session = JSON.parse(sessionStorage.getItem('strophe-bosh-session'));
    if (typeof session !== 'undefined' && session !== null && session.rid && session.sid && session.jid && (typeof jid === 'undefined' || jid === null || getBareJidFromJid(session.jid) === getBareJidFromJid(jid) ||
    // If authcid is null, then it's an anonymous login, so
    // we compare only the domains:
    getNodeFromJid(jid) === null && getDomainFromJid(session.jid) === jid)) {
      this._conn.restored = true;
      this._attach(session.jid, session.sid, session.rid, callback, wait, hold, wind);
    } else {
      const error = new Error('_restore: no restoreable session.');
      error.name = 'StropheSessionError';
      throw error;
    }
  }

  /**
   * _Private_ handler for the beforeunload event.
   * This handler is used to process the Bosh-part of the initial request.
   * @private
   */
  _cacheSession() {
    if (this._conn.authenticated) {
      if (this._conn.jid && this.rid && this.sid) {
        sessionStorage.setItem('strophe-bosh-session', JSON.stringify({
          'jid': this._conn.jid,
          'rid': this.rid,
          'sid': this.sid
        }));
      }
    } else {
      sessionStorage.removeItem('strophe-bosh-session');
    }
  }

  /**
   * _Private_ handler for initial connection request.
   * This handler is used to process the Bosh-part of the initial request.
   * @param {Element} bodyWrap - The received stanza.
   */
  _connect_cb(bodyWrap) {
    const typ = bodyWrap.getAttribute('type');
    if (typ !== null && typ === 'terminate') {
      // an error occurred
      let cond = bodyWrap.getAttribute('condition');
      strophe_browser_esm_log.error('BOSH-Connection failed: ' + cond);
      const conflict = bodyWrap.getElementsByTagName('conflict');
      if (cond !== null) {
        if (cond === 'remote-stream-error' && conflict.length > 0) {
          cond = 'conflict';
        }
        this._conn._changeConnectStatus(Status.CONNFAIL, cond);
      } else {
        this._conn._changeConnectStatus(Status.CONNFAIL, 'unknown');
      }
      this._conn._doDisconnect(cond);
      return Status.CONNFAIL;
    }

    // check to make sure we don't overwrite these if _connect_cb is
    // called multiple times in the case of missing stream:features
    if (!this.sid) {
      this.sid = bodyWrap.getAttribute('sid');
    }
    const wind = bodyWrap.getAttribute('requests');
    if (wind) {
      this.window = parseInt(wind, 10);
    }
    const hold = bodyWrap.getAttribute('hold');
    if (hold) {
      this.hold = parseInt(hold, 10);
    }
    const wait = bodyWrap.getAttribute('wait');
    if (wait) {
      this.wait = parseInt(wait, 10);
    }
    const inactivity = bodyWrap.getAttribute('inactivity');
    if (inactivity) {
      this.inactivity = parseInt(inactivity, 10);
    }
  }

  /**
   * _Private_ part of Connection.disconnect for Bosh
   * @param {Element|Builder} pres - This stanza will be sent before disconnecting.
   */
  _disconnect(pres) {
    this._sendTerminate(pres);
  }

  /**
   * _Private_ function to disconnect.
   * Resets the SID and RID.
   */
  _doDisconnect() {
    this.sid = null;
    this.rid = Math.floor(Math.random() * 4294967295);
    if (this._conn._sessionCachingSupported()) {
      sessionStorage.removeItem('strophe-bosh-session');
    }
    this._conn.nextValidRid(this.rid);
  }

  /**
   * _Private_ function to check if the Request queue is empty.
   * @return {boolean} - True, if there are no Requests queued, False otherwise.
   */
  _emptyQueue() {
    return this._requests.length === 0;
  }

  /**
   * _Private_ function to call error handlers registered for HTTP errors.
   * @private
   * @param {Request} req - The request that is changing readyState.
   */
  _callProtocolErrorHandlers(req) {
    const reqStatus = Bosh._getRequestStatus(req);
    const err_callback = this._conn.protocolErrorHandlers.HTTP[reqStatus];
    if (err_callback) {
      err_callback.call(this, reqStatus);
    }
  }

  /**
   * _Private_ function to handle the error count.
   *
   * Requests are resent automatically until their error count reaches
   * 5.  Each time an error is encountered, this function is called to
   * increment the count and disconnect if the count is too high.
   * @private
   * @param {number} reqStatus - The request status.
   */
  _hitError(reqStatus) {
    this.errors++;
    strophe_browser_esm_log.warn('request errored, status: ' + reqStatus + ', number of errors: ' + this.errors);
    if (this.errors > 4) {
      this._conn._onDisconnectTimeout();
    }
  }

  /**
   * @callback connectionCallback
   * @param {Connection} connection
   */

  /**
   * Called on stream start/restart when no stream:features
   * has been received and sends a blank poll request.
   * @param {connectionCallback} callback
   */
  _no_auth_received(callback) {
    strophe_browser_esm_log.warn('Server did not yet offer a supported authentication ' + 'mechanism. Sending a blank poll request.');
    if (callback) {
      callback = callback.bind(this._conn);
    } else {
      callback = this._conn._connect_cb.bind(this._conn);
    }
    const body = this._buildBody();
    this._requests.push(new Request(body.tree(), this._onRequestStateChange.bind(this, callback), Number(body.tree().getAttribute('rid'))));
    this._throttledRequestHandler();
  }

  /**
   * _Private_ timeout handler for handling non-graceful disconnection.
   * Cancels all remaining Requests and clears the queue.
   */
  _onDisconnectTimeout() {
    this._abortAllRequests();
  }

  /**
   * _Private_ helper function that makes sure all pending requests are aborted.
   */
  _abortAllRequests() {
    while (this._requests.length > 0) {
      const req = this._requests.pop();
      req.abort = true;
      req.xhr.abort();
      req.xhr.onreadystatechange = function () {};
    }
  }

  /**
   * _Private_ handler called by {@link Connection#_onIdle|Connection._onIdle()}.
   * Sends all queued Requests or polls with empty Request if there are none.
   */
  _onIdle() {
    const data = this._conn._data;
    // if no requests are in progress, poll
    if (this._conn.authenticated && this._requests.length === 0 && data.length === 0 && !this._conn.disconnecting) {
      strophe_browser_esm_log.debug('no requests during idle cycle, sending blank request');
      data.push(null);
    }
    if (this._conn.paused) {
      return;
    }
    if (this._requests.length < 2 && data.length > 0) {
      const body = this._buildBody();
      for (let i = 0; i < data.length; i++) {
        if (data[i] !== null) {
          if (data[i] === 'restart') {
            body.attrs({
              'to': this._conn.domain,
              'xml:lang': 'en',
              'xmpp:restart': 'true',
              'xmlns:xmpp': NS.BOSH
            });
          } else {
            body.cnode(/** @type {Element} */data[i]).up();
          }
        }
      }
      delete this._conn._data;
      this._conn._data = [];
      this._requests.push(new Request(body.tree(), this._onRequestStateChange.bind(this, this._conn._dataRecv.bind(this._conn)), Number(body.tree().getAttribute('rid'))));
      this._throttledRequestHandler();
    }
    if (this._requests.length > 0) {
      const time_elapsed = this._requests[0].age();
      if (this._requests[0].dead !== null) {
        if (this._requests[0].timeDead() > Math.floor(timeoutMultiplier * this.wait)) {
          this._throttledRequestHandler();
        }
      }
      if (time_elapsed > Math.floor(timeoutMultiplier * this.wait)) {
        strophe_browser_esm_log.warn('Request ' + this._requests[0].id + ' timed out, over ' + Math.floor(timeoutMultiplier * this.wait) + ' seconds since last activity');
        this._throttledRequestHandler();
      }
    }
  }

  /**
   * Returns the HTTP status code from a {@link Request}
   * @private
   * @param {Request} req - The {@link Request} instance.
   * @param {number} [def] - The default value that should be returned if no status value was found.
   */
  static _getRequestStatus(req, def) {
    let reqStatus;
    if (req.xhr.readyState === 4) {
      try {
        reqStatus = req.xhr.status;
      } catch (e) {
        // ignore errors from undefined status attribute. Works
        // around a browser bug
        strophe_browser_esm_log.error(`Caught an error while retrieving a request's status, reqStatus: ${reqStatus}, message: ${e.message}`);
      }
    }
    if (typeof reqStatus === 'undefined') {
      reqStatus = typeof def === 'number' ? def : 0;
    }
    return reqStatus;
  }

  /**
   * _Private_ handler for {@link Request} state changes.
   *
   * This function is called when the XMLHttpRequest readyState changes.
   * It contains a lot of error handling logic for the many ways that
   * requests can fail, and calls the request callback when requests
   * succeed.
   * @private
   *
   * @param {Function} func - The handler for the request.
   * @param {Request} req - The request that is changing readyState.
   */
  _onRequestStateChange(func, req) {
    strophe_browser_esm_log.debug('request id ' + req.id + '.' + req.sends + ' state changed to ' + req.xhr.readyState);
    if (req.abort) {
      req.abort = false;
      return;
    }
    if (req.xhr.readyState !== 4) {
      // The request is not yet complete
      return;
    }
    const reqStatus = Bosh._getRequestStatus(req);
    this.lastResponseHeaders = req.xhr.getAllResponseHeaders();
    if (this._conn.disconnecting && reqStatus >= 400) {
      this._hitError(reqStatus);
      this._callProtocolErrorHandlers(req);
      return;
    }
    const reqIs0 = this._requests[0] === req;
    const reqIs1 = this._requests[1] === req;
    const valid_request = reqStatus > 0 && reqStatus < 500;
    const too_many_retries = req.sends > this._conn.maxRetries;
    if (valid_request || too_many_retries) {
      // remove from internal queue
      this._removeRequest(req);
      strophe_browser_esm_log.debug('request id ' + req.id + ' should now be removed');
    }
    if (reqStatus === 200) {
      // request succeeded
      // if request 1 finished, or request 0 finished and request
      // 1 is over _TIMEOUT seconds old, we need to
      // restart the other - both will be in the first spot, as the
      // completed request has been removed from the queue already
      if (reqIs1 || reqIs0 && this._requests.length > 0 && this._requests[0].age() > Math.floor(timeoutMultiplier * this.wait)) {
        this._restartRequest(0);
      }
      this._conn.nextValidRid(req.rid + 1);
      strophe_browser_esm_log.debug('request id ' + req.id + '.' + req.sends + ' got 200');
      func(req); // call handler
      this.errors = 0;
    } else if (reqStatus === 0 || reqStatus >= 400 && reqStatus < 600 || reqStatus >= 12000) {
      // request failed
      strophe_browser_esm_log.error('request id ' + req.id + '.' + req.sends + ' error ' + reqStatus + ' happened');
      this._hitError(reqStatus);
      this._callProtocolErrorHandlers(req);
      if (reqStatus >= 400 && reqStatus < 500) {
        this._conn._changeConnectStatus(Status.DISCONNECTING, null);
        this._conn._doDisconnect();
      }
    } else {
      strophe_browser_esm_log.error('request id ' + req.id + '.' + req.sends + ' error ' + reqStatus + ' happened');
    }
    if (!valid_request && !too_many_retries) {
      this._throttledRequestHandler();
    } else if (too_many_retries && !this._conn.connected) {
      this._conn._changeConnectStatus(Status.CONNFAIL, 'giving-up');
    }
  }

  /**
   * _Private_ function to process a request in the queue.
   *
   * This function takes requests off the queue and sends them and
   * restarts dead requests.
   * @private
   *
   * @param {number} i - The index of the request in the queue.
   */
  _processRequest(i) {
    let req = this._requests[i];
    const reqStatus = Bosh._getRequestStatus(req, -1);

    // make sure we limit the number of retries
    if (req.sends > this._conn.maxRetries) {
      this._conn._onDisconnectTimeout();
      return;
    }
    const time_elapsed = req.age();
    const primary_timeout = !isNaN(time_elapsed) && time_elapsed > Math.floor(timeoutMultiplier * this.wait);
    const secondary_timeout = req.dead !== null && req.timeDead() > Math.floor(secondaryTimeoutMultiplier * this.wait);
    const server_error = req.xhr.readyState === 4 && (reqStatus < 1 || reqStatus >= 500);
    if (primary_timeout || secondary_timeout || server_error) {
      if (secondary_timeout) {
        strophe_browser_esm_log.error(`Request ${this._requests[i].id} timed out (secondary), restarting`);
      }
      req.abort = true;
      req.xhr.abort();
      // setting to null fails on IE6, so set to empty function
      req.xhr.onreadystatechange = function () {};
      this._requests[i] = new Request(req.xmlData, req.origFunc, req.rid, req.sends);
      req = this._requests[i];
    }
    if (req.xhr.readyState === 0) {
      var _this$_conn$rawOutput, _this$_conn3;
      strophe_browser_esm_log.debug('request id ' + req.id + '.' + req.sends + ' posting');
      try {
        const content_type = this._conn.options.contentType || 'text/xml; charset=utf-8';
        req.xhr.open('POST', this._conn.service, this._conn.options.sync ? false : true);
        if (typeof req.xhr.setRequestHeader !== 'undefined') {
          // IE9 doesn't have setRequestHeader
          req.xhr.setRequestHeader('Content-Type', content_type);
        }
        if (this._conn.options.withCredentials) {
          req.xhr.withCredentials = true;
        }
      } catch (e2) {
        strophe_browser_esm_log.error('XHR open failed: ' + e2.toString());
        if (!this._conn.connected) {
          this._conn._changeConnectStatus(Status.CONNFAIL, 'bad-service');
        }
        this._conn.disconnect();
        return;
      }

      // Fires the XHR request -- may be invoked immediately
      // or on a gradually expanding retry window for reconnects
      const sendFunc = () => {
        req.date = new Date().valueOf();
        if (this._conn.options.customHeaders) {
          const headers = this._conn.options.customHeaders;
          for (const header in headers) {
            if (Object.prototype.hasOwnProperty.call(headers, header)) {
              req.xhr.setRequestHeader(header, headers[header]);
            }
          }
        }
        req.xhr.send(req.data);
      };

      // Implement progressive backoff for reconnects --
      // First retry (send === 1) should also be instantaneous
      if (req.sends > 1) {
        // Using a cube of the retry number creates a nicely
        // expanding retry window
        const backoff = Math.min(Math.floor(timeoutMultiplier * this.wait), Math.pow(req.sends, 3)) * 1000;
        setTimeout(function () {
          // XXX: setTimeout should be called only with function expressions (23974bc1)
          sendFunc();
        }, backoff);
      } else {
        sendFunc();
      }
      req.sends++;
      if (this.strip && req.xmlData.nodeName === 'body' && req.xmlData.childNodes.length) {
        var _this$_conn$xmlOutput, _this$_conn;
        (_this$_conn$xmlOutput = (_this$_conn = this._conn).xmlOutput) === null || _this$_conn$xmlOutput === void 0 ? void 0 : _this$_conn$xmlOutput.call(_this$_conn, req.xmlData.children[0]);
      } else {
        var _this$_conn$xmlOutput2, _this$_conn2;
        (_this$_conn$xmlOutput2 = (_this$_conn2 = this._conn).xmlOutput) === null || _this$_conn$xmlOutput2 === void 0 ? void 0 : _this$_conn$xmlOutput2.call(_this$_conn2, req.xmlData);
      }
      (_this$_conn$rawOutput = (_this$_conn3 = this._conn).rawOutput) === null || _this$_conn$rawOutput === void 0 ? void 0 : _this$_conn$rawOutput.call(_this$_conn3, req.data);
    } else {
      strophe_browser_esm_log.debug('_processRequest: ' + (i === 0 ? 'first' : 'second') + ' request has readyState of ' + req.xhr.readyState);
    }
  }

  /**
   * _Private_ function to remove a request from the queue.
   * @private
   * @param {Request} req - The request to remove.
   */
  _removeRequest(req) {
    strophe_browser_esm_log.debug('removing request');
    for (let i = this._requests.length - 1; i >= 0; i--) {
      if (req === this._requests[i]) {
        this._requests.splice(i, 1);
      }
    }
    // IE6 fails on setting to null, so set to empty function
    req.xhr.onreadystatechange = function () {};
    this._throttledRequestHandler();
  }

  /**
   * _Private_ function to restart a request that is presumed dead.
   * @private
   *
   * @param {number} i - The index of the request in the queue.
   */
  _restartRequest(i) {
    const req = this._requests[i];
    if (req.dead === null) {
      req.dead = new Date();
    }
    this._processRequest(i);
  }

  /**
   * _Private_ function to get a stanza out of a request.
   * Tries to extract a stanza out of a Request Object.
   * When this fails the current connection will be disconnected.
   *
   * @param {Request} req - The Request.
   * @return {Element} - The stanza that was passed.
   */
  _reqToData(req) {
    try {
      return req.getResponse();
    } catch (e) {
      if (e.message !== 'parsererror') {
        throw e;
      }
      this._conn.disconnect('strophe-parsererror');
    }
  }

  /**
   * _Private_ function to send initial disconnect sequence.
   *
   * This is the first step in a graceful disconnect.  It sends
   * the BOSH server a terminate body and includes an unavailable
   * presence if authentication has completed.
   * @private
   * @param {Element|Builder} [pres]
   */
  _sendTerminate(pres) {
    strophe_browser_esm_log.debug('_sendTerminate was called');
    const body = this._buildBody().attrs({
      type: 'terminate'
    });
    const el = pres instanceof Builder ? pres.tree() : pres;
    if (pres) {
      body.cnode(el);
    }
    const req = new Request(body.tree(), this._onRequestStateChange.bind(this, this._conn._dataRecv.bind(this._conn)), Number(body.tree().getAttribute('rid')));
    this._requests.push(req);
    this._throttledRequestHandler();
  }

  /**
   * _Private_ part of the Connection.send function for BOSH
   * Just triggers the RequestHandler to send the messages that are in the queue
   */
  _send() {
    clearTimeout(this._conn._idleTimeout);
    this._throttledRequestHandler();
    this._conn._idleTimeout = setTimeout(() => this._conn._onIdle(), 100);
  }

  /**
   * Send an xmpp:restart stanza.
   */
  _sendRestart() {
    this._throttledRequestHandler();
    clearTimeout(this._conn._idleTimeout);
  }

  /**
   * _Private_ function to throttle requests to the connection window.
   *
   * This function makes sure we don't send requests so fast that the
   * request ids overflow the connection window in the case that one
   * request died.
   * @private
   */
  _throttledRequestHandler() {
    if (!this._requests) {
      strophe_browser_esm_log.debug('_throttledRequestHandler called with ' + 'undefined requests');
    } else {
      strophe_browser_esm_log.debug('_throttledRequestHandler called with ' + this._requests.length + ' requests');
    }
    if (!this._requests || this._requests.length === 0) {
      return;
    }
    if (this._requests.length > 0) {
      this._processRequest(0);
    }
    if (this._requests.length > 1 && Math.abs(this._requests[0].rid - this._requests[1].rid) < this.window) {
      this._processRequest(1);
    }
  }
}

/**
 * _Private_ helper class for managing stanza handlers.
 *
 * A Handler encapsulates a user provided callback function to be
 * executed when matching stanzas are received by the connection.
 * Handlers can be either one-off or persistant depending on their
 * return value. Returning true will cause a Handler to remain active, and
 * returning false will remove the Handler.
 *
 * Users will not use Handler objects directly, but instead they
 * will use {@link Connection.addHandler} and
 * {@link Connection.deleteHandler}.
 */
class Handler {
  /**
   * @typedef {Object} HandlerOptions
   * @property {boolean} [HandlerOptions.matchBareFromJid]
   * @property {boolean} [HandlerOptions.ignoreNamespaceFragment]
   */

  /**
   * Create and initialize a new Handler.
   *
   * @param {Function} handler - A function to be executed when the handler is run.
   * @param {string} ns - The namespace to match.
   * @param {string} name - The element name to match.
   * @param {string|string[]} type - The stanza type (or types if an array) to match.
   * @param {string} [id] - The element id attribute to match.
   * @param {string} [from] - The element from attribute to match.
   * @param {HandlerOptions} [options] - Handler options
   */
  constructor(handler, ns, name, type, id, from, options) {
    this.handler = handler;
    this.ns = ns;
    this.name = name;
    this.type = type;
    this.id = id;
    this.options = options || {
      'matchBareFromJid': false,
      'ignoreNamespaceFragment': false
    };
    if (this.options.matchBareFromJid) {
      this.from = from ? getBareJidFromJid(from) : null;
    } else {
      this.from = from;
    }
    // whether the handler is a user handler or a system handler
    this.user = true;
  }

  /**
   * Returns the XML namespace attribute on an element.
   * If `ignoreNamespaceFragment` was passed in for this handler, then the
   * URL fragment will be stripped.
   * @param {Element} elem - The XML element with the namespace.
   * @return {string} - The namespace, with optionally the fragment stripped.
   */
  getNamespace(elem) {
    let elNamespace = elem.getAttribute('xmlns');
    if (elNamespace && this.options.ignoreNamespaceFragment) {
      elNamespace = elNamespace.split('#')[0];
    }
    return elNamespace;
  }

  /**
   * Tests if a stanza element (or any of its children) matches the
   * namespace set for this Handler.
   * @param {Element} elem - The XML element to test.
   * @return {boolean} - true if the stanza matches and false otherwise.
   */
  namespaceMatch(elem) {
    if (!this.ns || this.getNamespace(elem) === this.ns) {
      return true;
    }
    for (const child of (_elem$children = elem.children) !== null && _elem$children !== void 0 ? _elem$children : []) {
      var _elem$children;
      if (this.getNamespace(child) === this.ns) {
        return true;
      } else if (this.namespaceMatch(child)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Tests if a stanza matches the Handler.
   * @param {Element} elem - The XML element to test.
   * @return {boolean} - true if the stanza matches and false otherwise.
   */
  isMatch(elem) {
    let from = elem.getAttribute('from');
    if (this.options.matchBareFromJid) {
      from = getBareJidFromJid(from);
    }
    const elem_type = elem.getAttribute('type');
    if (this.namespaceMatch(elem) && (!this.name || isTagEqual(elem, this.name)) && (!this.type || (Array.isArray(this.type) ? this.type.indexOf(elem_type) !== -1 : elem_type === this.type)) && (!this.id || elem.getAttribute('id') === this.id) && (!this.from || from === this.from)) {
      return true;
    }
    return false;
  }

  /**
   * Run the callback on a matching stanza.
   * @param {Element} elem - The DOM element that triggered the Handler.
   * @return {boolean} - A boolean indicating if the handler should remain active.
   */
  run(elem) {
    let result = null;
    try {
      result = this.handler(elem);
    } catch (e) {
      handleError(e);
      throw e;
    }
    return result;
  }

  /**
   * Get a String representation of the Handler object.
   * @return {string}
   */
  toString() {
    return '{Handler: ' + this.handler + '(' + this.name + ',' + this.id + ',' + this.ns + ')}';
  }
}

/**
 * _Private_ helper class for managing timed handlers.
 *
 * A Strophe.TimedHandler encapsulates a user provided callback that
 * should be called after a certain period of time or at regular
 * intervals.  The return value of the callback determines whether the
 * Strophe.TimedHandler will continue to fire.
 *
 * Users will not use Strophe.TimedHandler objects directly, but instead
 * they will use {@link Strophe.Connection#addTimedHandler|addTimedHandler()} and
 * {@link Strophe.Connection#deleteTimedHandler|deleteTimedHandler()}.
 *
 * @memberof Strophe
 */
class TimedHandler {
  /**
   * Create and initialize a new Strophe.TimedHandler object.
   * @param {number} period - The number of milliseconds to wait before the
   *     handler is called.
   * @param {Function} handler - The callback to run when the handler fires.  This
   *     function should take no arguments.
   */
  constructor(period, handler) {
    this.period = period;
    this.handler = handler;
    this.lastCalled = new Date().getTime();
    this.user = true;
  }

  /**
   * Run the callback for the Strophe.TimedHandler.
   *
   * @return {boolean} Returns the result of running the handler,
   *  which is `true` if the Strophe.TimedHandler should be called again,
   *  and `false` otherwise.
   */
  run() {
    this.lastCalled = new Date().getTime();
    return this.handler();
  }

  /**
   * Reset the last called time for the Strophe.TimedHandler.
   */
  reset() {
    this.lastCalled = new Date().getTime();
  }

  /**
   * Get a string representation of the Strophe.TimedHandler object.
   * @return {string}
   */
  toString() {
    return '{TimedHandler: ' + this.handler + '(' + this.period + ')}';
  }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */

/**
 * Encapsulates an SASL authentication mechanism.
 *
 * User code may override the priority for each mechanism or disable it completely.
 * See <priority> for information about changing priority and <test> for informatian on
 * how to disable a mechanism.
 *
 * By default, all mechanisms are enabled and t_he priorities are
 *
 *     SCRAM-SHA-512 - 72
 *     SCRAM-SHA-384 - 71
 *     SCRAM-SHA-256 - 70
 *     SCRAM-SHA-1   - 60
 *     PLAIN         - 50
 *     OAUTHBEARER   - 40
 *     X-OAUTH2      - 30
 *     ANONYMOUS     - 20
 *     EXTERNAL      - 10
 *
 * See: {@link Strophe.Connection#registerSASLMechanisms}
 */
class SASLMechanism {
  /**
   * PrivateConstructor: Strophe.SASLMechanism
   * SASL auth mechanism abstraction.
   * @param {String} [name] - SASL Mechanism name.
   * @param {Boolean} [isClientFirst] - If client should send response first without challenge.
   * @param {Number} [priority] - Priority.
   */
  constructor(name, isClientFirst, priority) {
    /** Mechanism name. */
    this.mechname = name;

    /**
     * If client sends response without initial server challenge.
     */
    this.isClientFirst = isClientFirst;

    /**
     * Determines which {@link SASLMechanism} is chosen for authentication (Higher is better).
     * Users may override this to prioritize mechanisms differently.
     *
     * Example: (This will cause Strophe to choose the mechanism that the server sent first)
     *
     * > Strophe.SASLPlain.priority = Strophe.SASLSHA1.priority;
     *
     * See <SASL mechanisms> for a list of available mechanisms.
     */
    this.priority = priority;
  }

  /**
   * Checks if mechanism able to run.
   * To disable a mechanism, make this return false;
   *
   * To disable plain authentication run
   * > Strophe.SASLPlain.test = function() {
   * >   return false;
   * > }
   *
   * See <SASL mechanisms> for a list of available mechanisms.
   * @param {Connection} _connection - Target Connection.
   * @return {boolean} If mechanism was able to run.
   */
  test(_connection) {
    return true;
  }

  /**
   * Called before starting mechanism on some connection.
   * @param {Connection} connection - Target Connection.
   */
  onStart(connection) {
    this._connection = connection;
  }

  /**
   * Called by protocol implementation on incoming challenge.
   *
   * By deafult, if the client is expected to send data first (isClientFirst === true),
   * this method is called with `challenge` as null on the first call,
   * unless `clientChallenge` is overridden in the relevant subclass.
   * @param {Connection} _connection - Target Connection.
   * @param {string} [_challenge] - current challenge to handle.
   * @return {string|Promise<string|false>} Mechanism response.
   */
  onChallenge(_connection, _challenge) {
    throw new Error('You should implement challenge handling!');
  }

  /**
   * Called by the protocol implementation if the client is expected to send
   * data first in the authentication exchange (i.e. isClientFirst === true).
   * @param {Connection} connection - Target Connection.
   * @return {string|Promise<string|false>} Mechanism response.
   */
  clientChallenge(connection) {
    if (!this.isClientFirst) {
      throw new Error('clientChallenge should not be called if isClientFirst is false!');
    }
    return this.onChallenge(connection);
  }

  /**
   * Protocol informs mechanism implementation about SASL failure.
   */
  onFailure() {
    this._connection = null;
  }

  /**
   * Protocol informs mechanism implementation about SASL success.
   */
  onSuccess() {
    this._connection = null;
  }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */
class SASLAnonymous extends SASLMechanism {
  /**
   * SASL ANONYMOUS authentication.
   */
  constructor(mechname = 'ANONYMOUS', isClientFirst = false, priority = 20) {
    super(mechname, isClientFirst, priority);
  }

  /**
   * @param {Connection} connection
   */
  test(connection) {
    return connection.authcid === null;
  }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */
class SASLExternal extends SASLMechanism {
  /**
   * SASL EXTERNAL authentication.
   *
   * The EXTERNAL mechanism allows a client to request the server to use
   * credentials established by means external to the mechanism to
   * authenticate the client. The external means may be, for instance,
   * TLS services.
   */
  constructor(mechname = 'EXTERNAL', isClientFirst = true, priority = 10) {
    super(mechname, isClientFirst, priority);
  }

  /**
   * @param {Connection} connection
   */
  onChallenge(connection) {
    /* According to XEP-178, an authzid SHOULD NOT be presented when the
     * authcid contained or implied in the client certificate is the JID (i.e.
     * authzid) with which the user wants to log in as.
     *
     * To NOT send the authzid, the user should therefore set the authcid equal
     * to the JID when instantiating a new Strophe.Connection object.
     */
    return connection.authcid === connection.authzid ? '' : connection.authzid;
  }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */
class SASLOAuthBearer extends SASLMechanism {
  /**
   * SASL OAuth Bearer authentication.
   */
  constructor(mechname = 'OAUTHBEARER', isClientFirst = true, priority = 40) {
    super(mechname, isClientFirst, priority);
  }

  /**
   * @param {Connection} connection
   */
  test(connection) {
    return connection.pass !== null;
  }

  /**
   * @param {Connection} connection
   */
  onChallenge(connection) {
    let auth_str = 'n,';
    if (connection.authcid !== null) {
      auth_str = auth_str + 'a=' + connection.authzid;
    }
    auth_str = auth_str + ',';
    auth_str = auth_str + '\u0001';
    auth_str = auth_str + 'auth=Bearer ';
    auth_str = auth_str + connection.pass;
    auth_str = auth_str + '\u0001';
    auth_str = auth_str + '\u0001';
    return utils.utf16to8(auth_str);
  }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */
class SASLPlain extends SASLMechanism {
  /**
   * SASL PLAIN authentication.
   */
  constructor(mechname = 'PLAIN', isClientFirst = true, priority = 50) {
    super(mechname, isClientFirst, priority);
  }

  /**
   * @param {Connection} connection
   */
  test(connection) {
    return connection.authcid !== null;
  }

  /**
   * @param {Connection} connection
   */
  onChallenge(connection) {
    const {
      authcid,
      authzid,
      domain,
      pass
    } = connection;
    if (!domain) {
      throw new Error('SASLPlain onChallenge: domain is not defined!');
    }
    // Only include authzid if it differs from authcid.
    // See: https://tools.ietf.org/html/rfc6120#section-6.3.8
    let auth_str = authzid !== `${authcid}@${domain}` ? authzid : '';
    auth_str = auth_str + '\u0000';
    auth_str = auth_str + authcid;
    auth_str = auth_str + '\u0000';
    auth_str = auth_str + pass;
    return utils.utf16to8(auth_str);
  }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */

/**
 * @param {string} authMessage
 * @param {ArrayBufferLike} clientKey
 * @param {string} hashName
 */
async function scramClientProof(authMessage, clientKey, hashName) {
  const storedKey = await crypto.subtle.importKey('raw', await crypto.subtle.digest(hashName, clientKey), {
    'name': 'HMAC',
    'hash': hashName
  }, false, ['sign']);
  const clientSignature = await crypto.subtle.sign('HMAC', storedKey, utils.stringToArrayBuf(authMessage));
  return utils.xorArrayBuffers(clientKey, clientSignature);
}

/**
 * This function parses the information in a SASL SCRAM challenge response,
 * into an object of the form
 * { nonce: String,
 *   salt:  ArrayBuffer,
 *   iter:  Int
 * }
 * Returns undefined on failure.
 * @param {string} challenge
 */
function scramParseChallenge(challenge) {
  let nonce, salt, iter;
  const attribMatch = /([a-z]+)=([^,]+)(,|$)/;
  while (challenge.match(attribMatch)) {
    const matches = challenge.match(attribMatch);
    challenge = challenge.replace(matches[0], '');
    switch (matches[1]) {
      case 'r':
        nonce = matches[2];
        break;
      case 's':
        salt = utils.base64ToArrayBuf(matches[2]);
        break;
      case 'i':
        iter = parseInt(matches[2], 10);
        break;
      case 'm':
        // Mandatory but unknown extension, per RFC 5802 we should abort
        return undefined;
    }
  }

  // Consider iteration counts less than 4096 insecure, as reccommended by
  // RFC 5802
  if (isNaN(iter) || iter < 4096) {
    strophe_browser_esm_log.warn('Failing SCRAM authentication because server supplied iteration count < 4096.');
    return undefined;
  }
  if (!salt) {
    strophe_browser_esm_log.warn('Failing SCRAM authentication because server supplied incorrect salt.');
    return undefined;
  }
  return {
    'nonce': nonce,
    'salt': salt,
    'iter': iter
  };
}

/**
 * Derive the client and server keys given a string password,
 * a hash name, and a bit length.
 * Returns an object of the following form:
 * { ck: ArrayBuffer, the client key
 *   sk: ArrayBuffer, the server key
 * }
 * @param {string} password
 * @param {BufferSource} salt
 * @param {number} iter
 * @param {string} hashName
 * @param {number} hashBits
 */
async function scramDeriveKeys(password, salt, iter, hashName, hashBits) {
  const saltedPasswordBits = await crypto.subtle.deriveBits({
    'name': 'PBKDF2',
    'salt': salt,
    'iterations': iter,
    'hash': {
      'name': hashName
    }
  }, await crypto.subtle.importKey('raw', utils.stringToArrayBuf(password), 'PBKDF2', false, ['deriveBits']), hashBits);
  const saltedPassword = await crypto.subtle.importKey('raw', saltedPasswordBits, {
    'name': 'HMAC',
    'hash': hashName
  }, false, ['sign']);
  return {
    'ck': await crypto.subtle.sign('HMAC', saltedPassword, utils.stringToArrayBuf('Client Key')),
    'sk': await crypto.subtle.sign('HMAC', saltedPassword, utils.stringToArrayBuf('Server Key'))
  };
}

/**
 * @param {string} authMessage
 * @param {BufferSource} sk
 * @param {string} hashName
 */
async function scramServerSign(authMessage, sk, hashName) {
  const serverKey = await crypto.subtle.importKey('raw', sk, {
    'name': 'HMAC',
    'hash': hashName
  }, false, ['sign']);
  return crypto.subtle.sign('HMAC', serverKey, utils.stringToArrayBuf(authMessage));
}

/**
 * Generate an ASCII nonce (not containing the ',' character)
 * @return {string}
 */
function generate_cnonce() {
  // generate 16 random bytes of nonce, base64 encoded
  const bytes = new Uint8Array(16);
  return utils.arrayBufToBase64(crypto.getRandomValues(bytes).buffer);
}

/**
 * @typedef {Object} Password
 * @property {string} Password.name
 * @property {string} Password.ck
 * @property {string} Password.sk
 * @property {number} Password.iter
 * @property {string} salt
 */

const scram = {
  /**
   * On success, sets
   * connection_sasl_data["server-signature"]
   * and
   * connection._sasl_data.keys
   *
   * The server signature should be verified after this function completes..
   *
   * On failure, returns connection._sasl_failure_cb();
   * @param {Connection} connection
   * @param {string} challenge
   * @param {string} hashName
   * @param {number} hashBits
   */
  async scramResponse(connection, challenge, hashName, hashBits) {
    const cnonce = connection._sasl_data.cnonce;
    const challengeData = scramParseChallenge(challenge);

    // The RFC requires that we verify the (server) nonce has the client
    // nonce as an initial substring.
    if (!challengeData && (challengeData === null || challengeData === void 0 ? void 0 : challengeData.nonce.slice(0, cnonce.length)) !== cnonce) {
      strophe_browser_esm_log.warn('Failing SCRAM authentication because server supplied incorrect nonce.');
      connection._sasl_data = {};
      return connection._sasl_failure_cb();
    }
    let clientKey, serverKey;
    const {
      pass
    } = connection;
    if (typeof connection.pass === 'string' || connection.pass instanceof String) {
      const keys = await scramDeriveKeys(/** @type {string} */pass, challengeData.salt, challengeData.iter, hashName, hashBits);
      clientKey = keys.ck;
      serverKey = keys.sk;
    } else if (
    // Either restore the client key and server key passed in, or derive new ones
    /** @type {Password} */
    (pass === null || pass === void 0 ? void 0 : pass.name) === hashName && /** @type {Password} */(pass === null || pass === void 0 ? void 0 : pass.salt) === utils.arrayBufToBase64(challengeData.salt) && /** @type {Password} */(pass === null || pass === void 0 ? void 0 : pass.iter) === challengeData.iter) {
      const {
        ck,
        sk
      } = /** @type {Password} */pass;
      clientKey = utils.base64ToArrayBuf(ck);
      serverKey = utils.base64ToArrayBuf(sk);
    } else {
      return connection._sasl_failure_cb();
    }
    const clientFirstMessageBare = connection._sasl_data['client-first-message-bare'];
    const serverFirstMessage = challenge;
    const clientFinalMessageBare = `c=biws,r=${challengeData.nonce}`;
    const authMessage = `${clientFirstMessageBare},${serverFirstMessage},${clientFinalMessageBare}`;
    const clientProof = await scramClientProof(authMessage, clientKey, hashName);
    const serverSignature = await scramServerSign(authMessage, serverKey, hashName);
    connection._sasl_data['server-signature'] = utils.arrayBufToBase64(serverSignature);
    connection._sasl_data.keys = {
      'name': hashName,
      'iter': challengeData.iter,
      'salt': utils.arrayBufToBase64(challengeData.salt),
      'ck': utils.arrayBufToBase64(clientKey),
      'sk': utils.arrayBufToBase64(serverKey)
    };
    return `${clientFinalMessageBare},p=${utils.arrayBufToBase64(clientProof)}`;
  },
  /**
   * Returns a string containing the client first message
   * @param {Connection} connection
   * @param {string} test_cnonce
   */
  clientChallenge(connection, test_cnonce) {
    const cnonce = test_cnonce || generate_cnonce();
    const client_first_message_bare = `n=${connection.authcid},r=${cnonce}`;
    connection._sasl_data.cnonce = cnonce;
    connection._sasl_data['client-first-message-bare'] = client_first_message_bare;
    return `n,,${client_first_message_bare}`;
  }
};

/**
 * @typedef {import("./connection.js").default} Connection
 */
class SASLSHA1 extends SASLMechanism {
  /**
   * SASL SCRAM SHA 1 authentication.
   */
  constructor(mechname = 'SCRAM-SHA-1', isClientFirst = true, priority = 60) {
    super(mechname, isClientFirst, priority);
  }

  /**
   * @param {Connection} connection
   */
  test(connection) {
    return connection.authcid !== null;
  }

  /**
   * @param {Connection} connection
   * @param {string} [challenge]
   * @return {Promise<string|false>} Mechanism response.
   */
  async onChallenge(connection, challenge) {
    return await scram.scramResponse(connection, challenge, 'SHA-1', 160);
  }

  /**
   * @param {Connection} connection
   * @param {string} [test_cnonce]
   */
  clientChallenge(connection, test_cnonce) {
    return scram.clientChallenge(connection, test_cnonce);
  }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */
class SASLSHA256 extends SASLMechanism {
  /**
   * SASL SCRAM SHA 256 authentication.
   */
  constructor(mechname = 'SCRAM-SHA-256', isClientFirst = true, priority = 70) {
    super(mechname, isClientFirst, priority);
  }

  /**
   * @param {Connection} connection
   */
  test(connection) {
    return connection.authcid !== null;
  }

  /**
   * @param {Connection} connection
   * @param {string} [challenge]
   */
  async onChallenge(connection, challenge) {
    return await scram.scramResponse(connection, challenge, 'SHA-256', 256);
  }

  /**
   * @param {Connection} connection
   * @param {string} [test_cnonce]
   */
  clientChallenge(connection, test_cnonce) {
    return scram.clientChallenge(connection, test_cnonce);
  }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */
class SASLSHA384 extends SASLMechanism {
  /**
   * SASL SCRAM SHA 384 authentication.
   */
  constructor(mechname = 'SCRAM-SHA-384', isClientFirst = true, priority = 71) {
    super(mechname, isClientFirst, priority);
  }

  /**
   * @param {Connection} connection
   */
  test(connection) {
    return connection.authcid !== null;
  }

  /**
   * @param {Connection} connection
   * @param {string} [challenge]
   */
  async onChallenge(connection, challenge) {
    return await scram.scramResponse(connection, challenge, 'SHA-384', 384);
  }

  /**
   * @param {Connection} connection
   * @param {string} [test_cnonce]
   */
  clientChallenge(connection, test_cnonce) {
    return scram.clientChallenge(connection, test_cnonce);
  }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */
class SASLSHA512 extends SASLMechanism {
  /**
   * SASL SCRAM SHA 512 authentication.
   */
  constructor(mechname = 'SCRAM-SHA-512', isClientFirst = true, priority = 72) {
    super(mechname, isClientFirst, priority);
  }

  /**
   * @param {Connection} connection
   */
  test(connection) {
    return connection.authcid !== null;
  }

  /**
   * @param {Connection} connection
   * @param {string} [challenge]
   */
  async onChallenge(connection, challenge) {
    return await scram.scramResponse(connection, challenge, 'SHA-512', 512);
  }

  /**
   * @param {Connection} connection
   * @param {string} [test_cnonce]
   */
  clientChallenge(connection, test_cnonce) {
    return scram.clientChallenge(connection, test_cnonce);
  }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */

class SASLXOAuth2 extends SASLMechanism {
  /**
   * SASL X-OAuth2 authentication.
   */
  constructor(mechname = 'X-OAUTH2', isClientFirst = true, priority = 30) {
    super(mechname, isClientFirst, priority);
  }

  /**
   * @param {Connection} connection
   */
  test(connection) {
    return connection.pass !== null;
  }

  /**
   * @param {Connection} connection
   */
  onChallenge(connection) {
    let auth_str = '\u0000';
    if (connection.authcid !== null) {
      auth_str = auth_str + connection.authzid;
    }
    auth_str = auth_str + '\u0000';
    auth_str = auth_str + connection.pass;
    return utils.utf16to8(auth_str);
  }
}

class SessionError extends Error {
  /**
   * @param {string} message
   */
  constructor(message) {
    super(message);
    this.name = 'StropheSessionError';
  }
}

/**
 * A JavaScript library to enable XMPP over Websocket in Strophejs.
 *
 * This file implements XMPP over WebSockets for Strophejs.
 * If a Connection is established with a Websocket url (ws://...)
 * Strophe will use WebSockets.
 * For more information on XMPP-over-WebSocket see RFC 7395:
 * http://tools.ietf.org/html/rfc7395
 *
 * WebSocket support implemented by Andreas Guth (andreas.guth@rwth-aachen.de)
 */

/**
 * Helper class that handles WebSocket Connections
 *
 * The WebSocket class is used internally by Connection
 * to encapsulate WebSocket sessions. It is not meant to be used from user's code.
 */
class Websocket {
  /**
   * Create and initialize a WebSocket object.
   * Currently only sets the connection Object.
   * @param {Connection} connection - The Connection that will use WebSockets.
   */
  constructor(connection) {
    this._conn = connection;
    this.strip = 'wrapper';
    const service = connection.service;
    if (service.indexOf('ws:') !== 0 && service.indexOf('wss:') !== 0) {
      // If the service is not an absolute URL, assume it is a path and put the absolute
      // URL together from options, current URL and the path.
      let new_service = '';
      if (connection.options.protocol === 'ws' && location.protocol !== 'https:') {
        new_service += 'ws';
      } else {
        new_service += 'wss';
      }
      new_service += '://' + location.host;
      if (service.indexOf('/') !== 0) {
        new_service += location.pathname + service;
      } else {
        new_service += service;
      }
      connection.service = new_service;
    }
  }

  /**
   * _Private_ helper function to generate the <stream> start tag for WebSockets
   * @private
   * @return {Builder} - A Builder with a <stream> element.
   */
  _buildStream() {
    return $build('open', {
      'xmlns': NS.FRAMING,
      'to': this._conn.domain,
      'version': '1.0'
    });
  }

  /**
   * _Private_ checks a message for stream:error
   * @private
   * @param {Element} bodyWrap - The received stanza.
   * @param {number} connectstatus - The ConnectStatus that will be set on error.
   * @return {boolean} - true if there was a streamerror, false otherwise.
   */
  _checkStreamError(bodyWrap, connectstatus) {
    let errors;
    if (bodyWrap.getElementsByTagNameNS) {
      errors = bodyWrap.getElementsByTagNameNS(NS.STREAM, 'error');
    } else {
      errors = bodyWrap.getElementsByTagName('stream:error');
    }
    if (errors.length === 0) {
      return false;
    }
    const error = errors[0];
    let condition = '';
    let text = '';
    const ns = 'urn:ietf:params:xml:ns:xmpp-streams';
    for (let i = 0; i < error.childNodes.length; i++) {
      const e = error.childNodes[i];
      if (e.nodeType === e.ELEMENT_NODE) {
        /** @type {Element} */
        const el = /** @type {any} */e;
        if (el.getAttribute('xmlns') !== ns) {
          break;
        }
      }
      if (e.nodeName === 'text') {
        text = e.textContent;
      } else {
        condition = e.nodeName;
      }
    }
    let errorString = 'WebSocket stream error: ';
    if (condition) {
      errorString += condition;
    } else {
      errorString += 'unknown';
    }
    if (text) {
      errorString += ' - ' + text;
    }
    strophe_browser_esm_log.error(errorString);

    // close the connection on stream_error
    this._conn._changeConnectStatus(connectstatus, condition);
    this._conn._doDisconnect();
    return true;
  }

  /**
   * Reset the connection.
   *
   * This function is called by the reset function of the Strophe Connection.
   * Is not needed by WebSockets.
   */
  _reset() {
    return;
  }

  /**
   * _Private_ function called by Connection.connect
   *
   * Creates a WebSocket for a connection and assigns Callbacks to it.
   * Does nothing if there already is a WebSocket.
   */
  _connect() {
    // Ensure that there is no open WebSocket from a previous Connection.
    this._closeSocket();

    /**
     * @typedef {Object} WebsocketLike
     * @property {(str: string) => void} WebsocketLike.send
     * @property {function(): void} WebsocketLike.close
     * @property {function(): void} WebsocketLike.onopen
     * @property {(e: ErrorEvent) => void} WebsocketLike.onerror
     * @property {(e: CloseEvent) => void} WebsocketLike.onclose
     * @property {(message: MessageEvent) => void} WebsocketLike.onmessage
     * @property {string} WebsocketLike.readyState
     */

    /** @type {import('ws')|WebSocket|WebsocketLike} */
    this.socket = new WebSocket(this._conn.service, 'xmpp');
    this.socket.onopen = () => this._onOpen();
    /** @param {ErrorEvent} e */
    this.socket.onerror = e => this._onError(e);
    /** @param {CloseEvent} e */
    this.socket.onclose = e => this._onClose(e);
    /**
     * Gets replaced with this._onMessage once _onInitialMessage is called
     * @param {MessageEvent} message
     */
    this.socket.onmessage = message => this._onInitialMessage(message);
  }

  /**
   * _Private_ function called by Connection._connect_cb
   * checks for stream:error
   * @param {Element} bodyWrap - The received stanza.
   */
  _connect_cb(bodyWrap) {
    const error = this._checkStreamError(bodyWrap, Status.CONNFAIL);
    if (error) {
      return Status.CONNFAIL;
    }
  }

  /**
   * _Private_ function that checks the opening <open /> tag for errors.
   *
   * Disconnects if there is an error and returns false, true otherwise.
   * @private
   * @param {Element} message - Stanza containing the <open /> tag.
   */
  _handleStreamStart(message) {
    let error = null;

    // Check for errors in the <open /> tag
    const ns = message.getAttribute('xmlns');
    if (typeof ns !== 'string') {
      error = 'Missing xmlns in <open />';
    } else if (ns !== NS.FRAMING) {
      error = 'Wrong xmlns in <open />: ' + ns;
    }
    const ver = message.getAttribute('version');
    if (typeof ver !== 'string') {
      error = 'Missing version in <open />';
    } else if (ver !== '1.0') {
      error = 'Wrong version in <open />: ' + ver;
    }
    if (error) {
      this._conn._changeConnectStatus(Status.CONNFAIL, error);
      this._conn._doDisconnect();
      return false;
    }
    return true;
  }

  /**
   * _Private_ function that handles the first connection messages.
   *
   * On receiving an opening stream tag this callback replaces itself with the real
   * message handler. On receiving a stream error the connection is terminated.
   * @param {MessageEvent} message
   */
  _onInitialMessage(message) {
    if (message.data.indexOf('<open ') === 0 || message.data.indexOf('<?xml') === 0) {
      // Strip the XML Declaration, if there is one
      const data = message.data.replace(/^(<\?.*?\?>\s*)*/, '');
      if (data === '') return;
      const streamStart = new DOMParser().parseFromString(data, 'text/xml').documentElement;
      this._conn.xmlInput(streamStart);
      this._conn.rawInput(message.data);

      //_handleStreamSteart will check for XML errors and disconnect on error
      if (this._handleStreamStart(streamStart)) {
        //_connect_cb will check for stream:error and disconnect on error
        this._connect_cb(streamStart);
      }
    } else if (message.data.indexOf('<close ') === 0) {
      // <close xmlns="urn:ietf:params:xml:ns:xmpp-framing />
      // Parse the raw string to an XML element
      const parsedMessage = new DOMParser().parseFromString(message.data, 'text/xml').documentElement;
      // Report this input to the raw and xml handlers
      this._conn.xmlInput(parsedMessage);
      this._conn.rawInput(message.data);
      const see_uri = parsedMessage.getAttribute('see-other-uri');
      if (see_uri) {
        const service = this._conn.service;
        // Valid scenarios: WSS->WSS, WS->ANY
        const isSecureRedirect = service.indexOf('wss:') >= 0 && see_uri.indexOf('wss:') >= 0 || service.indexOf('ws:') >= 0;
        if (isSecureRedirect) {
          this._conn._changeConnectStatus(Status.REDIRECT, 'Received see-other-uri, resetting connection');
          this._conn.reset();
          this._conn.service = see_uri;
          this._connect();
        }
      } else {
        this._conn._changeConnectStatus(Status.CONNFAIL, 'Received closing stream');
        this._conn._doDisconnect();
      }
    } else {
      this._replaceMessageHandler();
      const string = this._streamWrap(message.data);
      const elem = new DOMParser().parseFromString(string, 'text/xml').documentElement;
      this._conn._connect_cb(elem, null, message.data);
    }
  }

  /**
   * Called by _onInitialMessage in order to replace itself with the general message handler.
   * This method is overridden by WorkerWebsocket, which manages a
   * websocket connection via a service worker and doesn't have direct access
   * to the socket.
   */
  _replaceMessageHandler() {
    /** @param {MessageEvent} m */
    this.socket.onmessage = m => this._onMessage(m);
  }

  /**
   * _Private_ function called by Connection.disconnect
   * Disconnects and sends a last stanza if one is given
   * @param {Element|Builder} [pres] - This stanza will be sent before disconnecting.
   */
  _disconnect(pres) {
    if (this.socket && this.socket.readyState !== WebSocket.CLOSED) {
      if (pres) {
        this._conn.send(pres);
      }
      const close = $build('close', {
        'xmlns': NS.FRAMING
      });
      this._conn.xmlOutput(close.tree());
      const closeString = Builder.serialize(close);
      this._conn.rawOutput(closeString);
      try {
        this.socket.send(closeString);
      } catch (e) {
        strophe_browser_esm_log.warn(`Couldn't send <close /> tag. "${e.message}"`);
      }
    }
    setTimeout(() => this._conn._doDisconnect(), 0);
  }

  /**
   * _Private_ function to disconnect.
   * Just closes the Socket for WebSockets
   */
  _doDisconnect() {
    strophe_browser_esm_log.debug('WebSockets _doDisconnect was called');
    this._closeSocket();
  }

  /**
   * PrivateFunction _streamWrap
   * _Private_ helper function to wrap a stanza in a <stream> tag.
   * This is used so Strophe can process stanzas from WebSockets like BOSH
   * @param {string} stanza
   */
  _streamWrap(stanza) {
    return '<wrapper>' + stanza + '</wrapper>';
  }

  /**
   * _Private_ function to close the WebSocket.
   *
   * Closes the socket if it is still open and deletes it
   */
  _closeSocket() {
    if (this.socket) {
      try {
        this.socket.onclose = null;
        this.socket.onerror = null;
        this.socket.onmessage = null;
        this.socket.close();
      } catch (e) {
        strophe_browser_esm_log.debug(e.message);
      }
    }
    this.socket = null;
  }

  /**
   * _Private_ function to check if the message queue is empty.
   * @return {true} - True, because WebSocket messages are send immediately after queueing.
   */
  _emptyQueue() {
    return true;
  }

  /**
   * _Private_ function to handle websockets closing.
   * @param {CloseEvent} [e]
   */
  _onClose(e) {
    if (this._conn.connected && !this._conn.disconnecting) {
      strophe_browser_esm_log.error('Websocket closed unexpectedly');
      this._conn._doDisconnect();
    } else if (e && e.code === 1006 && !this._conn.connected && this.socket) {
      // in case the onError callback was not called (Safari 10 does not
      // call onerror when the initial connection fails) we need to
      // dispatch a CONNFAIL status update to be consistent with the
      // behavior on other browsers.
      strophe_browser_esm_log.error('Websocket closed unexcectedly');
      this._conn._changeConnectStatus(Status.CONNFAIL, 'The WebSocket connection could not be established or was disconnected.');
      this._conn._doDisconnect();
    } else {
      strophe_browser_esm_log.debug('Websocket closed');
    }
  }

  /**
   * @callback connectionCallback
   * @param {Connection} connection
   */

  /**
   * Called on stream start/restart when no stream:features
   * has been received.
   * @param {connectionCallback} callback
   */
  _no_auth_received(callback) {
    strophe_browser_esm_log.error('Server did not offer a supported authentication mechanism');
    this._conn._changeConnectStatus(Status.CONNFAIL, ErrorCondition.NO_AUTH_MECH);
    callback === null || callback === void 0 ? void 0 : callback.call(this._conn);
    this._conn._doDisconnect();
  }

  /**
   * _Private_ timeout handler for handling non-graceful disconnection.
   *
   * This does nothing for WebSockets
   */
  _onDisconnectTimeout() {}

  /**
   * _Private_ helper function that makes sure all pending requests are aborted.
   */
  _abortAllRequests() {}

  /**
   * _Private_ function to handle websockets errors.
   * @param {Object} error - The websocket error.
   */
  _onError(error) {
    strophe_browser_esm_log.error('Websocket error ' + JSON.stringify(error));
    this._conn._changeConnectStatus(Status.CONNFAIL, 'The WebSocket connection could not be established or was disconnected.');
    this._disconnect();
  }

  /**
   * _Private_ function called by Connection._onIdle
   * sends all queued stanzas
   */
  _onIdle() {
    const data = this._conn._data;
    if (data.length > 0 && !this._conn.paused) {
      for (let i = 0; i < data.length; i++) {
        if (data[i] !== null) {
          const stanza = data[i] === 'restart' ? this._buildStream().tree() : data[i];
          if (stanza === 'restart') throw new Error('Wrong type for stanza'); // Shut up tsc
          const rawStanza = Builder.serialize(stanza);
          this._conn.xmlOutput(stanza);
          this._conn.rawOutput(rawStanza);
          this.socket.send(rawStanza);
        }
      }
      this._conn._data = [];
    }
  }

  /**
   * _Private_ function to handle websockets messages.
   *
   * This function parses each of the messages as if they are full documents.
   * [TODO : We may actually want to use a SAX Push parser].
   *
   * Since all XMPP traffic starts with
   * <stream:stream version='1.0'
   *                xml:lang='en'
   *                xmlns='jabber:client'
   *                xmlns:stream='http://etherx.jabber.org/streams'
   *                id='3697395463'
   *                from='SERVER'>
   *
   * The first stanza will always fail to be parsed.
   *
   * Additionally, the seconds stanza will always be <stream:features> with
   * the stream NS defined in the previous stanza, so we need to 'force'
   * the inclusion of the NS in this stanza.
   *
   * @param {MessageEvent} message - The websocket message event
   */
  _onMessage(message) {
    let elem;
    // check for closing stream
    const close = '<close xmlns="urn:ietf:params:xml:ns:xmpp-framing" />';
    if (message.data === close) {
      this._conn.rawInput(close);
      this._conn.xmlInput(message);
      if (!this._conn.disconnecting) {
        this._conn._doDisconnect();
      }
      return;
    } else if (message.data.search('<open ') === 0) {
      // This handles stream restarts
      elem = new DOMParser().parseFromString(message.data, 'text/xml').documentElement;
      if (!this._handleStreamStart(elem)) {
        return;
      }
    } else {
      const data = this._streamWrap(message.data);
      elem = new DOMParser().parseFromString(data, 'text/xml').documentElement;
    }
    if (this._checkStreamError(elem, Status.ERROR)) {
      return;
    }

    //handle unavailable presence stanza before disconnecting
    if (this._conn.disconnecting && elem.firstElementChild.nodeName === 'presence' && elem.firstElementChild.getAttribute('type') === 'unavailable') {
      this._conn.xmlInput(elem);
      this._conn.rawInput(Builder.serialize(elem));
      // if we are already disconnecting we will ignore the unavailable stanza and
      // wait for the </stream:stream> tag before we close the connection
      return;
    }
    this._conn._dataRecv(elem, message.data);
  }

  /**
   * _Private_ function to handle websockets connection setup.
   * The opening stream tag is sent here.
   * @private
   */
  _onOpen() {
    strophe_browser_esm_log.debug('Websocket open');
    const start = this._buildStream();
    this._conn.xmlOutput(start.tree());
    const startString = Builder.serialize(start);
    this._conn.rawOutput(startString);
    this.socket.send(startString);
  }

  /**
   * _Private_ part of the Connection.send function for WebSocket
   * Just flushes the messages that are in the queue
   */
  _send() {
    this._conn.flush();
  }

  /**
   * Send an xmpp:restart stanza.
   */
  _sendRestart() {
    clearTimeout(this._conn._idleTimeout);
    this._conn._onIdle.bind(this._conn)();
  }
}

/**
 * @license MIT
 * @copyright JC Brand
 */

/**
 * Helper class that handles a websocket connection inside a shared worker.
 */
class WorkerWebsocket extends Websocket {
  /**
   * @typedef {import("./connection.js").default} Connection
   */

  /**
   * Create and initialize a WorkerWebsocket object.
   * @param {Connection} connection - The Connection
   */
  constructor(connection) {
    super(connection);
    this._conn = connection;
    this.worker = new SharedWorker(this._conn.options.worker, 'Strophe XMPP Connection');
    this.worker.onerror = e => {
      var _console;
      (_console = console) === null || _console === void 0 ? void 0 : _console.error(e);
      strophe_browser_esm_log.error(`Shared Worker Error: ${e}`);
    };
  }

  /**
   * @private
   */
  _setSocket() {
    this.socket = {
      /** @param {string} str */
      send: str => this.worker.port.postMessage(['send', str]),
      close: () => this.worker.port.postMessage(['_closeSocket']),
      onopen: () => {},
      /** @param {ErrorEvent} e */
      onerror: e => this._onError(e),
      /** @param {CloseEvent} e */
      onclose: e => this._onClose(e),
      onmessage: () => {},
      readyState: null
    };
  }
  _connect() {
    this._setSocket();
    /** @param {MessageEvent} m */
    this._messageHandler = m => this._onInitialMessage(m);
    this.worker.port.start();
    this.worker.port.onmessage = ev => this._onWorkerMessage(ev);
    this.worker.port.postMessage(['_connect', this._conn.service, this._conn.jid]);
  }

  /**
   * @param {Function} callback
   */
  _attach(callback) {
    this._setSocket();
    /** @param {MessageEvent} m */
    this._messageHandler = m => this._onMessage(m);
    this._conn.connect_callback = callback;
    this.worker.port.start();
    this.worker.port.onmessage = ev => this._onWorkerMessage(ev);
    this.worker.port.postMessage(['_attach', this._conn.service]);
  }

  /**
   * @param {number} status
   * @param {string} jid
   */
  _attachCallback(status, jid) {
    if (status === Status.ATTACHED) {
      this._conn.jid = jid;
      this._conn.authenticated = true;
      this._conn.connected = true;
      this._conn.restored = true;
      this._conn._changeConnectStatus(Status.ATTACHED);
    } else if (status === Status.ATTACHFAIL) {
      this._conn.authenticated = false;
      this._conn.connected = false;
      this._conn.restored = false;
      this._conn._changeConnectStatus(Status.ATTACHFAIL);
    }
  }

  /**
   * @param {Element|Builder} pres - This stanza will be sent before disconnecting.
   */
  _disconnect(pres) {
    pres && this._conn.send(pres);
    const close = $build('close', {
      'xmlns': NS.FRAMING
    });
    this._conn.xmlOutput(close.tree());
    const closeString = Builder.serialize(close);
    this._conn.rawOutput(closeString);
    this.worker.port.postMessage(['send', closeString]);
    this._conn._doDisconnect();
  }
  _closeSocket() {
    this.socket.close();
  }

  /**
   * Called by _onInitialMessage in order to replace itself with the general message handler.
   * This method is overridden by WorkerWebsocket, which manages a
   * websocket connection via a service worker and doesn't have direct access
   * to the socket.
   */
  _replaceMessageHandler() {
    /** @param {MessageEvent} m */
    this._messageHandler = m => this._onMessage(m);
  }

  /**
   * function that handles messages received from the service worker
   * @private
   * @param {MessageEvent} ev
   */
  _onWorkerMessage(ev) {
    const {
      data
    } = ev;
    const method_name = data[0];
    if (method_name === '_onMessage') {
      this._messageHandler(data[1]);
    } else if (method_name in this) {
      try {
        this[(/** @type {'_attachCallback'|'_onOpen'|'_onClose'|'_onError'} */
        method_name)].apply(this, ev.data.slice(1));
      } catch (e) {
        strophe_browser_esm_log.error(e);
      }
    } else if (method_name === 'log') {
      /** @type {Object.<string, number>} */
      const lmap = {
        debug: LOG_LEVELS.DEBUG,
        info: LOG_LEVELS.INFO,
        warn: LOG_LEVELS.WARN,
        error: LOG_LEVELS.ERROR,
        fatal: LOG_LEVELS.FATAL
      };
      const level = data[1];
      const msg = data[2];
      strophe_browser_esm_log.log(lmap[level], msg);
    } else {
      strophe_browser_esm_log.error(`Found unhandled service worker message: ${data}`);
    }
  }
}

/**
 * @typedef {import("./sasl.js").default} SASLMechanism
 * @typedef {import("./request.js").default} Request
 *
 * @typedef {Object} ConnectionOptions
 * @property {Cookies} [cookies]
 *  Allows you to pass in cookies that will be included in HTTP requests.
 *  Relevant to both the BOSH and Websocket transports.
 *
 *  The passed in value must be a map of cookie names and string values.
 *
 *  > { "myCookie": {
 *  >     "value": "1234",
 *  >     "domain": ".example.org",
 *  >     "path": "/",
 *  >     "expires": expirationDate
 *  >     }
 *  > }
 *
 *  Note that cookies can't be set in this way for domains other than the one
 *  that's hosting Strophe (i.e. cross-domain).
 *  Those cookies need to be set under those domains, for example they can be
 *  set server-side by making a XHR call to that domain to ask it to set any
 *  necessary cookies.
 * @property {SASLMechanism[]} [mechanisms]
 *  Allows you to specify the SASL authentication mechanisms that this
 *  instance of Connection (and therefore your XMPP client) will support.
 *
 *  The value must be an array of objects with {@link SASLMechanism}
 *  prototypes.
 *
 *  If nothing is specified, then the following mechanisms (and their
 *  priorities) are registered:
 *
 *      Mechanism       Priority
 *      ------------------------
 *      SCRAM-SHA-512   72
 *      SCRAM-SHA-384   71
 *      SCRAM-SHA-256   70
 *      SCRAM-SHA-1     60
 *      PLAIN           50
 *      OAUTHBEARER     40
 *      X-OAUTH2        30
 *      ANONYMOUS       20
 *      EXTERNAL        10
 *
 * @property {boolean} [explicitResourceBinding]
 *  If `explicitResourceBinding` is set to `true`, then the XMPP client
 *  needs to explicitly call {@link Connection.bind} once the XMPP
 *  server has advertised the `urn:ietf:propertys:xml:ns:xmpp-bind` feature.
 *
 *  Making this step explicit allows client authors to first finish other
 *  stream related tasks, such as setting up an XEP-0198 Stream Management
 *  session, before binding the JID resource for this session.
 *
 * @property {'ws'|'wss'} [protocol]
 *  _Note: This option is only relevant to Websocket connections, and not BOSH_
 *
 *  If you want to connect to the current host with a WebSocket connection you
 *  can tell Strophe to use WebSockets through the "protocol" option.
 *  Valid values are `ws` for WebSocket and `wss` for Secure WebSocket.
 *  So to connect to "wss://CURRENT_HOSTNAME/xmpp-websocket" you would call
 *
 *      const conn = new Strophe.Connection(
 *          "/xmpp-websocket/",
 *          {protocol: "wss"}
 *      );
 *
 *  Note that relative URLs _NOT_ starting with a "/" will also include the path
 *  of the current site.
 *
 *  Also because downgrading security is not permitted by browsers, when using
 *  relative URLs both BOSH and WebSocket connections will use their secure
 *  variants if the current connection to the site is also secure (https).
 *
 * @property {string} [worker]
 *  _Note: This option is only relevant to Websocket connections, and not BOSH_
 *
 *  Set this option to URL from where the shared worker script should be loaded.
 *
 *  To run the websocket connection inside a shared worker.
 *  This allows you to share a single websocket-based connection between
 *  multiple Connection instances, for example one per browser tab.
 *
 *  The script to use is the one in `src/shared-connection-worker.js`.
 *
 * @property {boolean} [sync]
 *  Used to control whether BOSH HTTP requests will be made synchronously or not.
 *  The default behaviour is asynchronous. If you want to make requests
 *  synchronous, make "sync" evaluate to true.
 *
 *  > const conn = new Strophe.Connection("/http-bind/", {sync: true});
 *
 *  You can also toggle this on an already established connection.
 *
 *  > conn.options.sync = true;
 *
 * @property {string[]} [customHeaders]
 *  Used to provide custom HTTP headers to be included in the BOSH HTTP requests.
 *
 * @property {boolean} [keepalive]
 *  Used to instruct Strophe to maintain the current BOSH session across
 *  interruptions such as webpage reloads.
 *
 *  It will do this by caching the sessions tokens in sessionStorage, and when
 *  "restore" is called it will check whether there are cached tokens with
 *  which it can resume an existing session.
 *
 * @property {boolean} [withCredentials]
 *  Used to indicate wether cookies should be included in HTTP requests (by default
 *  they're not).
 *  Set this value to `true` if you are connecting to a BOSH service
 *  and for some reason need to send cookies to it.
 *  In order for this to work cross-domain, the server must also enable
 *  credentials by setting the `Access-Control-Allow-Credentials` response header
 *  to "true". For most usecases however this setting should be false (which
 *  is the default).
 *  Additionally, when using `Access-Control-Allow-Credentials`, the
 *  `Access-Control-Allow-Origin` header can't be set to the wildcard "*", but
 *  instead must be restricted to actual domains.
 *
 * @property {string} [contentType]
 *  Used to change the default Content-Type, which is "text/xml; charset=utf-8".
 *  Can be useful to reduce the amount of CORS preflight requests that are sent
 *  to the server.
 */

/**
 * _Private_ variable Used to store plugin names that need
 * initialization during Connection construction.
 * @type {Object.<string, Object>}
 */
const connectionPlugins = {};

/**
 * **XMPP Connection manager**
 *
 * This class is the main part of Strophe.  It manages a BOSH or websocket
 * connection to an XMPP server and dispatches events to the user callbacks
 * as data arrives.
 *
 * It supports various authentication mechanisms (e.g. SASL PLAIN, SASL SCRAM),
 * and more can be added via
 * {@link Connection#registerSASLMechanisms|registerSASLMechanisms()}.
 *
 * After creating a Connection object, the user will typically
 * call {@link Connection#connect|connect()} with a user supplied callback
 * to handle connection level events like authentication failure,
 * disconnection, or connection complete.
 *
 * The user will also have several event handlers defined by using
 * {@link Connection#addHandler|addHandler()} and
 * {@link Connection#addTimedHandler|addTimedHandler()}.
 * These will allow the user code to respond to interesting stanzas or do
 * something periodically with the connection. These handlers will be active
 * once authentication is finished.
 *
 * To send data to the connection, use {@link Connection#send|send()}.
 *
 * @memberof Strophe
 */
class Connection {
  /**
   * @typedef {Object.<string, string>} Cookie
   * @typedef {Cookie|Object.<string, Cookie>} Cookies
   */

  /**
   * Create and initialize a {@link Connection} object.
   *
   * The transport-protocol for this connection will be chosen automatically
   * based on the given service parameter. URLs starting with "ws://" or
   * "wss://" will use WebSockets, URLs starting with "http://", "https://"
   * or without a protocol will use [BOSH](https://xmpp.org/extensions/xep-0124.html).
   *
   * To make Strophe connect to the current host you can leave out the protocol
   * and host part and just pass the path:
   *
   *  const conn = new Strophe.Connection("/http-bind/");
   *
   * @param {string} service - The BOSH or WebSocket service URL.
   * @param {ConnectionOptions} options - A object containing configuration options
   */
  constructor(service, options = {}) {
    // The service URL
    this.service = service;
    // Configuration options
    this.options = options;
    this.setProtocol();

    /* The connected JID. */
    this.jid = '';
    /* the JIDs domain */
    this.domain = null;
    /* stream:features */
    this.features = null;

    // SASL
    /**
     * @typedef {Object.<string, any>} SASLData
     * @property {Object} [SASLData.keys]
     */

    /** @type {SASLData} */
    this._sasl_data = {};
    this.do_bind = false;
    this.do_session = false;

    /** @type {Object.<string, SASLMechanism>} */
    this.mechanisms = {};

    /** @type {TimedHandler[]} */
    this.timedHandlers = [];

    /** @type {Handler[]} */
    this.handlers = [];

    /** @type {TimedHandler[]} */
    this.removeTimeds = [];

    /** @type {Handler[]} */
    this.removeHandlers = [];

    /** @type {TimedHandler[]} */
    this.addTimeds = [];

    /** @type {Handler[]} */
    this.addHandlers = [];
    this.protocolErrorHandlers = {
      /** @type {Object.<number, Function>} */
      'HTTP': {},
      /** @type {Object.<number, Function>} */
      'websocket': {}
    };
    this._idleTimeout = null;
    this._disconnectTimeout = null;
    this.authenticated = false;
    this.connected = false;
    this.disconnecting = false;
    this.do_authentication = true;
    this.paused = false;
    this.restored = false;

    /** @type {(Element|'restart')[]} */
    this._data = [];
    this._uniqueId = 0;
    this._sasl_success_handler = null;
    this._sasl_failure_handler = null;
    this._sasl_challenge_handler = null;

    // Max retries before disconnecting
    this.maxRetries = 5;

    // Call onIdle callback every 1/10th of a second
    this._idleTimeout = setTimeout(() => this._onIdle(), 100);
    addCookies(this.options.cookies);
    this.registerSASLMechanisms(this.options.mechanisms);

    // A client must always respond to incoming IQ "set" and "get" stanzas.
    // See https://datatracker.ietf.org/doc/html/rfc6120#section-8.2.3
    //
    // This is a fallback handler which gets called when no other handler
    // was called for a received IQ "set" or "get".
    this.iqFallbackHandler = new Handler(
    /**
     * @param {Element} iq
     */
    iq => this.send($iq({
      type: 'error',
      id: iq.getAttribute('id')
    }).c('error', {
      'type': 'cancel'
    }).c('service-unavailable', {
      'xmlns': NS.STANZAS
    })), null, 'iq', ['get', 'set']);

    // initialize plugins
    for (const k in connectionPlugins) {
      if (Object.prototype.hasOwnProperty.call(connectionPlugins, k)) {
        const F = function () {};
        F.prototype = connectionPlugins[k];
        // @ts-ignore
        this[k] = new F();
        // @ts-ignore
        this[k].init(this);
      }
    }
  }

  /**
   * Extends the Connection object with the given plugin.
   * @param {string} name - The name of the extension.
   * @param {Object} ptype - The plugin's prototype.
   */
  static addConnectionPlugin(name, ptype) {
    connectionPlugins[name] = ptype;
  }

  /**
   * Select protocal based on this.options or this.service
   */
  setProtocol() {
    const proto = this.options.protocol || '';
    if (this.options.worker) {
      this._proto = new WorkerWebsocket(this);
    } else if (this.service.indexOf('ws:') === 0 || this.service.indexOf('wss:') === 0 || proto.indexOf('ws') === 0) {
      this._proto = new Websocket(this);
    } else {
      this._proto = new Bosh(this);
    }
  }

  /**
   * Reset the connection.
   *
   * This function should be called after a connection is disconnected
   * before that connection is reused.
   */
  reset() {
    this._proto._reset();

    // SASL
    this.do_session = false;
    this.do_bind = false;

    // handler lists
    this.timedHandlers = [];
    this.handlers = [];
    this.removeTimeds = [];
    this.removeHandlers = [];
    this.addTimeds = [];
    this.addHandlers = [];
    this.authenticated = false;
    this.connected = false;
    this.disconnecting = false;
    this.restored = false;
    this._data = [];
    /** @type {Request[]} */
    this._requests = [];
    this._uniqueId = 0;
  }

  /**
   * Pause the request manager.
   *
   * This will prevent Strophe from sending any more requests to the
   * server.  This is very useful for temporarily pausing
   * BOSH-Connections while a lot of send() calls are happening quickly.
   * This causes Strophe to send the data in a single request, saving
   * many request trips.
   */
  pause() {
    this.paused = true;
  }

  /**
   * Resume the request manager.
   *
   * This resumes after pause() has been called.
   */
  resume() {
    this.paused = false;
  }

  /**
   * Generate a unique ID for use in <iq/> elements.
   *
   * All <iq/> stanzas are required to have unique id attributes.  This
   * function makes creating these easy.  Each connection instance has
   * a counter which starts from zero, and the value of this counter
   * plus a colon followed by the suffix becomes the unique id. If no
   * suffix is supplied, the counter is used as the unique id.
   *
   * Suffixes are used to make debugging easier when reading the stream
   * data, and their use is recommended.  The counter resets to 0 for
   * every new connection for the same reason.  For connections to the
   * same server that authenticate the same way, all the ids should be
   * the same, which makes it easy to see changes.  This is useful for
   * automated testing as well.
   *
   * @param {string} suffix - A optional suffix to append to the id.
   * @returns {string} A unique string to be used for the id attribute.
   */
  getUniqueId(suffix) {
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
    if (typeof suffix === 'string' || typeof suffix === 'number') {
      return uuid + ':' + suffix;
    } else {
      return uuid + '';
    }
  }

  /**
   * Register a handler function for when a protocol (websocker or HTTP)
   * error occurs.
   *
   * NOTE: Currently only HTTP errors for BOSH requests are handled.
   * Patches that handle websocket errors would be very welcome.
   *
   * @example
   *  function onError(err_code){
   *    //do stuff
   *  }
   *
   *  const conn = Strophe.connect('http://example.com/http-bind');
   *  conn.addProtocolErrorHandler('HTTP', 500, onError);
   *  // Triggers HTTP 500 error and onError handler will be called
   *  conn.connect('user_jid@incorrect_jabber_host', 'secret', onConnect);
   *
   * @param {'HTTP'|'websocket'} protocol - 'HTTP' or 'websocket'
   * @param {number} status_code - Error status code (e.g 500, 400 or 404)
   * @param {Function} callback - Function that will fire on Http error
   */
  addProtocolErrorHandler(protocol, status_code, callback) {
    this.protocolErrorHandlers[protocol][status_code] = callback;
  }

  /**
   * @typedef {Object} Password
   * @property {string} Password.name
   * @property {string} Password.ck
   * @property {string} Password.sk
   * @property {number} Password.iter
   * @property {string} Password.salt
   */

  /**
   * Starts the connection process.
   *
   * As the connection process proceeds, the user supplied callback will
   * be triggered multiple times with status updates.  The callback
   * should take two arguments - the status code and the error condition.
   *
   * The status code will be one of the values in the Strophe.Status
   * constants.  The error condition will be one of the conditions
   * defined in RFC 3920 or the condition 'strophe-parsererror'.
   *
   * The Parameters _wait_, _hold_ and _route_ are optional and only relevant
   * for BOSH connections. Please see XEP 124 for a more detailed explanation
   * of the optional parameters.
   *
   * @param {string} jid - The user's JID.  This may be a bare JID,
   *     or a full JID.  If a node is not supplied, SASL OAUTHBEARER or
   *     SASL ANONYMOUS authentication will be attempted (OAUTHBEARER will
   *     process the provided password value as an access token).
   *   (String or Object) pass - The user's password, or an object containing
   *     the users SCRAM client and server keys, in a fashion described as follows:
   *
   *     { name: String, representing the hash used (eg. SHA-1),
   *       salt: String, base64 encoded salt used to derive the client key,
   *       iter: Int,    the iteration count used to derive the client key,
   *       ck:   String, the base64 encoding of the SCRAM client key
   *       sk:   String, the base64 encoding of the SCRAM server key
   *     }
   * @param {string|Password} pass - The user password
   * @param {Function} callback - The connect callback function.
   * @param {number} [wait] - The optional HTTPBIND wait value.  This is the
   *     time the server will wait before returning an empty result for
   *     a request.  The default setting of 60 seconds is recommended.
   * @param {number} [hold] - The optional HTTPBIND hold value.  This is the
   *     number of connections the server will hold at one time.  This
   *     should almost always be set to 1 (the default).
   * @param {string} [route] - The optional route value.
   * @param {string} [authcid] - The optional alternative authentication identity
   *     (username) if intending to impersonate another user.
   *     When using the SASL-EXTERNAL authentication mechanism, for example
   *     with client certificates, then the authcid value is used to
   *     determine whether an authorization JID (authzid) should be sent to
   *     the server. The authzid should NOT be sent to the server if the
   *     authzid and authcid are the same. So to prevent it from being sent
   *     (for example when the JID is already contained in the client
   *     certificate), set authcid to that same JID. See XEP-178 for more
   *     details.
   *  @param {number} [disconnection_timeout=3000] - The optional disconnection timeout
   *     in milliseconds before _doDisconnect will be called.
   */
  connect(jid, pass, callback, wait, hold, route, authcid, disconnection_timeout = 3000) {
    this.jid = jid;
    /** Authorization identity */
    this.authzid = getBareJidFromJid(this.jid);
    /** Authentication identity (User name) */
    this.authcid = authcid || getNodeFromJid(this.jid);
    /** Authentication identity (User password) */
    this.pass = pass;

    /**
     * The SASL SCRAM client and server keys. This variable will be populated with a non-null
     * object of the above described form after a successful SCRAM connection
     */
    this.scram_keys = null;
    this.connect_callback = callback;
    this.disconnecting = false;
    this.connected = false;
    this.authenticated = false;
    this.restored = false;
    this.disconnection_timeout = disconnection_timeout;

    // parse jid for domain
    this.domain = getDomainFromJid(this.jid);
    this._changeConnectStatus(Status.CONNECTING, null);
    this._proto._connect(wait, hold, route);
  }

  /**
   * Attach to an already created and authenticated BOSH session.
   *
   * This function is provided to allow Strophe to attach to BOSH
   * sessions which have been created externally, perhaps by a Web
   * application.  This is often used to support auto-login type features
   * without putting user credentials into the page.
   *
   * @param {string|Function} jid - The full JID that is bound by the session.
   * @param {string} [sid] - The SID of the BOSH session.
   * @param {number} [rid] - The current RID of the BOSH session.  This RID
   *     will be used by the next request.
   * @param {Function} [callback] - The connect callback function.
   * @param {number} [wait] - The optional HTTPBIND wait value.  This is the
   *     time the server will wait before returning an empty result for
   *     a request.  The default setting of 60 seconds is recommended.
   *     Other settings will require tweaks to the Strophe.TIMEOUT value.
   * @param {number} [hold] - The optional HTTPBIND hold value.  This is the
   *     number of connections the server will hold at one time.  This
   *     should almost always be set to 1 (the default).
   * @param {number} [wind] - The optional HTTBIND window value.  This is the
   *     allowed range of request ids that are valid.  The default is 5.
   */
  attach(jid, sid, rid, callback, wait, hold, wind) {
    if (this._proto instanceof Bosh && typeof jid === 'string') {
      return this._proto._attach(jid, sid, rid, callback, wait, hold, wind);
    } else if (this._proto instanceof WorkerWebsocket && typeof jid === 'function') {
      const callback = jid;
      return this._proto._attach(callback);
    } else {
      throw new SessionError('The "attach" method is not available for your connection protocol');
    }
  }

  /**
   * Attempt to restore a cached BOSH session.
   *
   * This function is only useful in conjunction with providing the
   * "keepalive":true option when instantiating a new {@link Connection}.
   *
   * When "keepalive" is set to true, Strophe will cache the BOSH tokens
   * RID (Request ID) and SID (Session ID) and then when this function is
   * called, it will attempt to restore the session from those cached
   * tokens.
   *
   * This function must therefore be called instead of connect or attach.
   *
   * For an example on how to use it, please see examples/restore.js
   *
   * @param {string} jid - The user's JID.  This may be a bare JID or a full JID.
   * @param {Function} callback - The connect callback function.
   * @param {number} [wait] - The optional HTTPBIND wait value.  This is the
   *     time the server will wait before returning an empty result for
   *     a request.  The default setting of 60 seconds is recommended.
   * @param {number} [hold] - The optional HTTPBIND hold value.  This is the
   *     number of connections the server will hold at one time.  This
   *     should almost always be set to 1 (the default).
   * @param {number} [wind] - The optional HTTBIND window value.  This is the
   *     allowed range of request ids that are valid.  The default is 5.
   */
  restore(jid, callback, wait, hold, wind) {
    if (!(this._proto instanceof Bosh) || !this._sessionCachingSupported()) {
      throw new SessionError('The "restore" method can only be used with a BOSH connection.');
    }
    if (this._sessionCachingSupported()) {
      this._proto._restore(jid, callback, wait, hold, wind);
    }
  }

  /**
   * Checks whether sessionStorage and JSON are supported and whether we're
   * using BOSH.
   */
  _sessionCachingSupported() {
    if (this._proto instanceof Bosh) {
      if (!JSON) {
        return false;
      }
      try {
        sessionStorage.setItem('_strophe_', '_strophe_');
        sessionStorage.removeItem('_strophe_');
      } catch (_e) {
        return false;
      }
      return true;
    }
    return false;
  }

  /**
   * User overrideable function that receives XML data coming into the
   * connection.
   *
   * The default function does nothing.  User code can override this with
   * > Connection.xmlInput = function (elem) {
   * >   (user code)
   * > };
   *
   * Due to limitations of current Browsers' XML-Parsers the opening and closing
   * <stream> tag for WebSocket-Connoctions will be passed as selfclosing here.
   *
   * BOSH-Connections will have all stanzas wrapped in a <body> tag. See
   * <Bosh.strip> if you want to strip this tag.
   *
   * @param {Node|MessageEvent} _elem - The XML data received by the connection.
   */
  xmlInput(_elem) {
    return;
  }

  /**
   * User overrideable function that receives XML data sent to the
   * connection.
   *
   * The default function does nothing.  User code can override this with
   * > Connection.xmlOutput = function (elem) {
   * >   (user code)
   * > };
   *
   * Due to limitations of current Browsers' XML-Parsers the opening and closing
   * <stream> tag for WebSocket-Connoctions will be passed as selfclosing here.
   *
   * BOSH-Connections will have all stanzas wrapped in a <body> tag. See
   * <Bosh.strip> if you want to strip this tag.
   *
   * @param {Element} _elem - The XMLdata sent by the connection.
   */
  xmlOutput(_elem) {
    return;
  }

  /**
   * User overrideable function that receives raw data coming into the
   * connection.
   *
   * The default function does nothing.  User code can override this with
   * > Connection.rawInput = function (data) {
   * >   (user code)
   * > };
   *
   * @param {string} _data - The data received by the connection.
   */
  rawInput(_data) {
    return;
  }

  /**
   * User overrideable function that receives raw data sent to the
   * connection.
   *
   * The default function does nothing.  User code can override this with
   * > Connection.rawOutput = function (data) {
   * >   (user code)
   * > };
   *
   * @param {string} _data - The data sent by the connection.
   */
  rawOutput(_data) {
    return;
  }

  /**
   * User overrideable function that receives the new valid rid.
   *
   * The default function does nothing. User code can override this with
   * > Connection.nextValidRid = function (rid) {
   * >    (user code)
   * > };
   *
   * @param {number} _rid - The next valid rid
   */
  nextValidRid(_rid) {
    return;
  }

  /**
   * Send a stanza.
   *
   * This function is called to push data onto the send queue to
   * go out over the wire.  Whenever a request is sent to the BOSH
   * server, all pending data is sent and the queue is flushed.
   *
   * @param {Element|Builder|Element[]|Builder[]} stanza - The stanza to send
   */
  send(stanza) {
    if (stanza === null) return;
    if (Array.isArray(stanza)) {
      stanza.forEach(s => this._queueData(s instanceof Builder ? s.tree() : s));
    } else {
      const el = stanza instanceof Builder ? stanza.tree() : stanza;
      this._queueData(el);
    }
    this._proto._send();
  }

  /**
   * Immediately send any pending outgoing data.
   *
   * Normally send() queues outgoing data until the next idle period
   * (100ms), which optimizes network use in the common cases when
   * several send()s are called in succession. flush() can be used to
   * immediately send all pending data.
   */
  flush() {
    // cancel the pending idle period and run the idle function
    // immediately
    clearTimeout(this._idleTimeout);
    this._onIdle();
  }

  /**
   * Helper function to send presence stanzas. The main benefit is for
   * sending presence stanzas for which you expect a responding presence
   * stanza with the same id (for example when leaving a chat room).
   *
   * @param {Element} stanza - The stanza to send.
   * @param {Function} [callback] - The callback function for a successful request.
   * @param {Function} [errback] - The callback function for a failed or timed
   *    out request.  On timeout, the stanza will be null.
   * @param {number} [timeout] - The time specified in milliseconds for a
   *    timeout to occur.
   * @return {string} The id used to send the presence.
   */
  sendPresence(stanza, callback, errback, timeout) {
    /** @type {TimedHandler} */
    let timeoutHandler = null;
    const el = stanza instanceof Builder ? stanza.tree() : stanza;
    let id = el.getAttribute('id');
    if (!id) {
      // inject id if not found
      id = this.getUniqueId('sendPresence');
      el.setAttribute('id', id);
    }
    if (typeof callback === 'function' || typeof errback === 'function') {
      const handler = this.addHandler(/** @param {Element} stanza */
      stanza => {
        // remove timeout handler if there is one
        if (timeoutHandler) this.deleteTimedHandler(timeoutHandler);
        if (stanza.getAttribute('type') === 'error') {
          errback === null || errback === void 0 ? void 0 : errback(stanza);
        } else if (callback) {
          callback(stanza);
        }
      }, null, 'presence', null, id);

      // if timeout specified, set up a timeout handler.
      if (timeout) {
        timeoutHandler = this.addTimedHandler(timeout, () => {
          // get rid of normal handler
          this.deleteHandler(handler);
          // call errback on timeout with null stanza
          errback === null || errback === void 0 ? void 0 : errback(null);
          return false;
        });
      }
    }
    this.send(el);
    return id;
  }

  /**
   * Helper function to send IQ stanzas.
   *
   * @param {Element|Builder} stanza - The stanza to send.
   * @param {Function} [callback] - The callback function for a successful request.
   * @param {Function} [errback] - The callback function for a failed or timed
   *     out request.  On timeout, the stanza will be null.
   * @param {number} [timeout] - The time specified in milliseconds for a
   *     timeout to occur.
   * @return {string} The id used to send the IQ.
   */
  sendIQ(stanza, callback, errback, timeout) {
    /** @type {TimedHandler} */
    let timeoutHandler = null;
    const el = stanza instanceof Builder ? stanza.tree() : stanza;
    let id = el.getAttribute('id');
    if (!id) {
      // inject id if not found
      id = this.getUniqueId('sendIQ');
      el.setAttribute('id', id);
    }
    if (typeof callback === 'function' || typeof errback === 'function') {
      const handler = this.addHandler(/** @param {Element} stanza */
      stanza => {
        // remove timeout handler if there is one
        if (timeoutHandler) this.deleteTimedHandler(timeoutHandler);
        const iqtype = stanza.getAttribute('type');
        if (iqtype === 'result') {
          callback === null || callback === void 0 ? void 0 : callback(stanza);
        } else if (iqtype === 'error') {
          errback === null || errback === void 0 ? void 0 : errback(stanza);
        } else {
          const error = new Error(`Got bad IQ type of ${iqtype}`);
          error.name = 'StropheError';
          throw error;
        }
      }, null, 'iq', ['error', 'result'], id);

      // if timeout specified, set up a timeout handler.
      if (timeout) {
        timeoutHandler = this.addTimedHandler(timeout, () => {
          // get rid of normal handler
          this.deleteHandler(handler);
          // call errback on timeout with null stanza
          errback === null || errback === void 0 ? void 0 : errback(null);
          return false;
        });
      }
    }
    this.send(el);
    return id;
  }

  /**
   * Queue outgoing data for later sending.  Also ensures that the data
   * is a DOMElement.
   * @private
   * @param {Element} element
   */
  _queueData(element) {
    if (element === null || !element.tagName || !element.childNodes) {
      const error = new Error('Cannot queue non-DOMElement.');
      error.name = 'StropheError';
      throw error;
    }
    this._data.push(element);
  }

  /**
   * Send an xmpp:restart stanza.
   * @private
   */
  _sendRestart() {
    this._data.push('restart');
    this._proto._sendRestart();
    this._idleTimeout = setTimeout(() => this._onIdle(), 100);
  }

  /**
   * Add a timed handler to the connection.
   *
   * This function adds a timed handler.  The provided handler will
   * be called every period milliseconds until it returns false,
   * the connection is terminated, or the handler is removed.  Handlers
   * that wish to continue being invoked should return true.
   *
   * Because of method binding it is necessary to save the result of
   * this function if you wish to remove a handler with
   * deleteTimedHandler().
   *
   * Note that user handlers are not active until authentication is
   * successful.
   *
   * @param {number} period - The period of the handler.
   * @param {Function} handler - The callback function.
   * @return {TimedHandler} A reference to the handler that can be used to remove it.
   */
  addTimedHandler(period, handler) {
    const thand = new TimedHandler(period, handler);
    this.addTimeds.push(thand);
    return thand;
  }

  /**
   * Delete a timed handler for a connection.
   *
   * This function removes a timed handler from the connection.  The
   * handRef parameter is *not* the function passed to addTimedHandler(),
   * but is the reference returned from addTimedHandler().
   * @param {TimedHandler} handRef - The handler reference.
   */
  deleteTimedHandler(handRef) {
    // this must be done in the Idle loop so that we don't change
    // the handlers during iteration
    this.removeTimeds.push(handRef);
  }

  /**
   * @typedef {Object} HandlerOptions
   * @property {boolean} [HandlerOptions.matchBareFromJid]
   * @property {boolean} [HandlerOptions.ignoreNamespaceFragment]
   */

  /**
   * Add a stanza handler for the connection.
   *
   * This function adds a stanza handler to the connection.  The
   * handler callback will be called for any stanza that matches
   * the parameters.  Note that if multiple parameters are supplied,
   * they must all match for the handler to be invoked.
   *
   * The handler will receive the stanza that triggered it as its argument.
   * *The handler should return true if it is to be invoked again;
   * returning false will remove the handler after it returns.*
   *
   * As a convenience, the ns parameters applies to the top level element
   * and also any of its immediate children.  This is primarily to make
   * matching /iq/query elements easy.
   *
   * ### Options
   *
   * With the options argument, you can specify boolean flags that affect how
   * matches are being done.
   *
   * Currently two flags exist:
   *
   * * *matchBareFromJid*:
   *     When set to true, the from parameter and the
   *     from attribute on the stanza will be matched as bare JIDs instead
   *     of full JIDs. To use this, pass {matchBareFromJid: true} as the
   *     value of options. The default value for matchBareFromJid is false.
   *
   * * *ignoreNamespaceFragment*:
   *     When set to true, a fragment specified on the stanza's namespace
   *     URL will be ignored when it's matched with the one configured for
   *     the handler.
   *
   *     This means that if you register like this:
   *
   *     >   connection.addHandler(
   *     >       handler,
   *     >       'http://jabber.org/protocol/muc',
   *     >       null, null, null, null,
   *     >       {'ignoreNamespaceFragment': true}
   *     >   );
   *
   *     Then a stanza with XML namespace of
   *     'http://jabber.org/protocol/muc#user' will also be matched. If
   *     'ignoreNamespaceFragment' is false, then only stanzas with
   *     'http://jabber.org/protocol/muc' will be matched.
   *
   * ### Deleting the handler
   *
   * The return value should be saved if you wish to remove the handler
   * with `deleteHandler()`.
   *
   * @param {Function} handler - The user callback.
   * @param {string} ns - The namespace to match.
   * @param {string} name - The stanza name to match.
   * @param {string|string[]} type - The stanza type (or types if an array) to match.
   * @param {string} [id] - The stanza id attribute to match.
   * @param {string} [from] - The stanza from attribute to match.
   * @param {HandlerOptions} [options] - The handler options
   * @return {Handler} A reference to the handler that can be used to remove it.
   */
  addHandler(handler, ns, name, type, id, from, options) {
    const hand = new Handler(handler, ns, name, type, id, from, options);
    this.addHandlers.push(hand);
    return hand;
  }

  /**
   * Delete a stanza handler for a connection.
   *
   * This function removes a stanza handler from the connection.  The
   * handRef parameter is *not* the function passed to addHandler(),
   * but is the reference returned from addHandler().
   *
   * @param {Handler} handRef - The handler reference.
   */
  deleteHandler(handRef) {
    // this must be done in the Idle loop so that we don't change
    // the handlers during iteration
    this.removeHandlers.push(handRef);
    // If a handler is being deleted while it is being added,
    // prevent it from getting added
    const i = this.addHandlers.indexOf(handRef);
    if (i >= 0) {
      this.addHandlers.splice(i, 1);
    }
  }

  /**
   * Register the SASL mechanisms which will be supported by this instance of
   * Connection (i.e. which this XMPP client will support).
   * @param {SASLMechanism[]} mechanisms - Array of objects with SASLMechanism prototypes
   */
  registerSASLMechanisms(mechanisms) {
    this.mechanisms = {};
    (mechanisms || [SASLAnonymous, SASLExternal, SASLOAuthBearer, SASLXOAuth2, SASLPlain, SASLSHA1, SASLSHA256, SASLSHA384, SASLSHA512]).forEach(m => this.registerSASLMechanism(m));
  }

  /**
   * Register a single SASL mechanism, to be supported by this client.
   * @param {any} Mechanism - Object with a Strophe.SASLMechanism prototype
   */
  registerSASLMechanism(Mechanism) {
    const mechanism = new Mechanism();
    this.mechanisms[mechanism.mechname] = mechanism;
  }

  /**
   * Start the graceful disconnection process.
   *
   * This function starts the disconnection process.  This process starts
   * by sending unavailable presence and sending BOSH body of type
   * terminate.  A timeout handler makes sure that disconnection happens
   * even if the BOSH server does not respond.
   * If the Connection object isn't connected, at least tries to abort all pending requests
   * so the connection object won't generate successful requests (which were already opened).
   *
   * The user supplied connection callback will be notified of the
   * progress as this process happens.
   *
   * @param {string} [reason] - The reason the disconnect is occuring.
   */
  disconnect(reason) {
    this._changeConnectStatus(Status.DISCONNECTING, reason);
    if (reason) {
      strophe_browser_esm_log.info('Disconnect was called because: ' + reason);
    } else {
      strophe_browser_esm_log.debug('Disconnect was called');
    }
    if (this.connected) {
      let pres = null;
      this.disconnecting = true;
      if (this.authenticated) {
        pres = $pres({
          'xmlns': NS.CLIENT,
          'type': 'unavailable'
        });
      }
      // setup timeout handler
      this._disconnectTimeout = this._addSysTimedHandler(this.disconnection_timeout, this._onDisconnectTimeout.bind(this));
      this._proto._disconnect(pres);
    } else {
      strophe_browser_esm_log.debug('Disconnect was called before Strophe connected to the server');
      this._proto._abortAllRequests();
      this._doDisconnect();
    }
  }

  /**
   * _Private_ helper function that makes sure plugins and the user's
   * callback are notified of connection status changes.
   * @param {number} status - the new connection status, one of the values
   *     in Strophe.Status
   * @param {string|null} [condition] - the error condition
   * @param {Element} [elem] - The triggering stanza.
   */
  _changeConnectStatus(status, condition, elem) {
    // notify all plugins listening for status changes
    for (const k in connectionPlugins) {
      if (Object.prototype.hasOwnProperty.call(connectionPlugins, k)) {
        // @ts-ignore
        const plugin = this[k];
        if (plugin.statusChanged) {
          try {
            plugin.statusChanged(status, condition);
          } catch (err) {
            strophe_browser_esm_log.error(`${k} plugin caused an exception changing status: ${err}`);
          }
        }
      }
    }
    // notify the user's callback
    if (this.connect_callback) {
      try {
        this.connect_callback(status, condition, elem);
      } catch (e) {
        handleError(e);
        strophe_browser_esm_log.error(`User connection callback caused an exception: ${e}`);
      }
    }
  }

  /**
   * _Private_ function to disconnect.
   *
   * This is the last piece of the disconnection logic.  This resets the
   * connection and alerts the user's connection callback.
   * @param {string|null} [condition] - the error condition
   */
  _doDisconnect(condition) {
    if (typeof this._idleTimeout === 'number') {
      clearTimeout(this._idleTimeout);
    }

    // Cancel Disconnect Timeout
    if (this._disconnectTimeout !== null) {
      this.deleteTimedHandler(this._disconnectTimeout);
      this._disconnectTimeout = null;
    }
    strophe_browser_esm_log.debug('_doDisconnect was called');
    this._proto._doDisconnect();
    this.authenticated = false;
    this.disconnecting = false;
    this.restored = false;

    // delete handlers
    this.handlers = [];
    this.timedHandlers = [];
    this.removeTimeds = [];
    this.removeHandlers = [];
    this.addTimeds = [];
    this.addHandlers = [];

    // tell the parent we disconnected
    this._changeConnectStatus(Status.DISCONNECTED, condition);
    this.connected = false;
  }

  /**
   * _Private_ handler to processes incoming data from the the connection.
   *
   * Except for _connect_cb handling the initial connection request,
   * this function handles the incoming data for all requests.  This
   * function also fires stanza handlers that match each incoming
   * stanza.
   * @param {Element | Request} req - The request that has data ready.
   * @param {string} [raw] - The stanza as raw string.
   */
  _dataRecv(req, raw) {
    const elem = /** @type {Element} */
    '_reqToData' in this._proto ? this._proto._reqToData(/** @type {Request} */req) : req;
    if (elem === null) {
      return;
    }
    if (this.xmlInput !== Connection.prototype.xmlInput) {
      if (elem.nodeName === this._proto.strip && elem.childNodes.length) {
        this.xmlInput(elem.childNodes[0]);
      } else {
        this.xmlInput(elem);
      }
    }
    if (this.rawInput !== Connection.prototype.rawInput) {
      if (raw) {
        this.rawInput(raw);
      } else {
        this.rawInput(Builder.serialize(elem));
      }
    }

    // remove handlers scheduled for deletion
    while (this.removeHandlers.length > 0) {
      const hand = this.removeHandlers.pop();
      const i = this.handlers.indexOf(hand);
      if (i >= 0) {
        this.handlers.splice(i, 1);
      }
    }

    // add handlers scheduled for addition
    while (this.addHandlers.length > 0) {
      this.handlers.push(this.addHandlers.pop());
    }

    // handle graceful disconnect
    if (this.disconnecting && this._proto._emptyQueue()) {
      this._doDisconnect();
      return;
    }
    const type = elem.getAttribute('type');
    if (type !== null && type === 'terminate') {
      // Don't process stanzas that come in after disconnect
      if (this.disconnecting) {
        return;
      }
      // an error occurred
      let cond = elem.getAttribute('condition');
      const conflict = elem.getElementsByTagName('conflict');
      if (cond !== null) {
        if (cond === 'remote-stream-error' && conflict.length > 0) {
          cond = 'conflict';
        }
        this._changeConnectStatus(Status.CONNFAIL, cond);
      } else {
        this._changeConnectStatus(Status.CONNFAIL, ErrorCondition.UNKNOWN_REASON);
      }
      this._doDisconnect(cond);
      return;
    }

    // send each incoming stanza through the handler chain
    forEachChild(elem, null, /** @param {Element} child */
    child => {
      const matches = [];
      this.handlers = this.handlers.reduce((handlers, handler) => {
        try {
          if (handler.isMatch(child) && (this.authenticated || !handler.user)) {
            if (handler.run(child)) {
              handlers.push(handler);
            }
            matches.push(handler);
          } else {
            handlers.push(handler);
          }
        } catch (e) {
          // if the handler throws an exception, we consider it as false
          strophe_browser_esm_log.warn('Removing Strophe handlers due to uncaught exception: ' + e.message);
        }
        return handlers;
      }, []);

      // If no handler was fired for an incoming IQ with type="set",
      // then we return an IQ error stanza with service-unavailable.
      if (!matches.length && this.iqFallbackHandler.isMatch(child)) {
        this.iqFallbackHandler.run(child);
      }
    });
  }

  /**
   * @callback connectionCallback
   * @param {Connection} connection
   */

  /**
   * _Private_ handler for initial connection request.
   *
   * This handler is used to process the initial connection request
   * response from the BOSH server. It is used to set up authentication
   * handlers and start the authentication process.
   *
   * SASL authentication will be attempted if available, otherwise
   * the code will fall back to legacy authentication.
   *
   * @param {Element | Request} req - The current request.
   * @param {connectionCallback} _callback - low level (xmpp) connect callback function.
   *     Useful for plugins with their own xmpp connect callback (when they
   *     want to do something special).
   * @param {string} [raw] - The stanza as raw string.
   */
  _connect_cb(req, _callback, raw) {
    strophe_browser_esm_log.debug('_connect_cb was called');
    this.connected = true;
    let bodyWrap;
    try {
      bodyWrap = /** @type {Element} */
      '_reqToData' in this._proto ? this._proto._reqToData(/** @type {Request} */req) : req;
    } catch (e) {
      if (e.name !== ErrorCondition.BAD_FORMAT) {
        throw e;
      }
      this._changeConnectStatus(Status.CONNFAIL, ErrorCondition.BAD_FORMAT);
      this._doDisconnect(ErrorCondition.BAD_FORMAT);
    }
    if (!bodyWrap) {
      return;
    }
    if (this.xmlInput !== Connection.prototype.xmlInput) {
      if (bodyWrap.nodeName === this._proto.strip && bodyWrap.childNodes.length) {
        this.xmlInput(bodyWrap.childNodes[0]);
      } else {
        this.xmlInput(bodyWrap);
      }
    }
    if (this.rawInput !== Connection.prototype.rawInput) {
      if (raw) {
        this.rawInput(raw);
      } else {
        this.rawInput(Builder.serialize(bodyWrap));
      }
    }
    const conncheck = this._proto._connect_cb(bodyWrap);
    if (conncheck === Status.CONNFAIL) {
      return;
    }

    // Check for the stream:features tag
    let hasFeatures;
    if (bodyWrap.getElementsByTagNameNS) {
      hasFeatures = bodyWrap.getElementsByTagNameNS(NS.STREAM, 'features').length > 0;
    } else {
      hasFeatures = bodyWrap.getElementsByTagName('stream:features').length > 0 || bodyWrap.getElementsByTagName('features').length > 0;
    }
    if (!hasFeatures) {
      this._proto._no_auth_received(_callback);
      return;
    }
    const matched = Array.from(bodyWrap.getElementsByTagName('mechanism')).map(m => this.mechanisms[m.textContent]).filter(m => m);
    if (matched.length === 0) {
      if (bodyWrap.getElementsByTagName('auth').length === 0) {
        // There are no matching SASL mechanisms and also no legacy
        // auth available.
        this._proto._no_auth_received(_callback);
        return;
      }
    }
    if (this.do_authentication !== false) {
      this.authenticate(matched);
    }
  }

  /**
   * Sorts an array of objects with prototype SASLMechanism according to
   * their priorities.
   * @param {SASLMechanism[]} mechanisms - Array of SASL mechanisms.
   */
  sortMechanismsByPriority(mechanisms) {
    // Sorting mechanisms according to priority.
    for (let i = 0; i < mechanisms.length - 1; ++i) {
      let higher = i;
      for (let j = i + 1; j < mechanisms.length; ++j) {
        if (mechanisms[j].priority > mechanisms[higher].priority) {
          higher = j;
        }
      }
      if (higher !== i) {
        const swap = mechanisms[i];
        mechanisms[i] = mechanisms[higher];
        mechanisms[higher] = swap;
      }
    }
    return mechanisms;
  }

  /**
   * Set up authentication
   *
   * Continues the initial connection request by setting up authentication
   * handlers and starting the authentication process.
   *
   * SASL authentication will be attempted if available, otherwise
   * the code will fall back to legacy authentication.
   *
   * @param {SASLMechanism[]} matched - Array of SASL mechanisms supported.
   */
  authenticate(matched) {
    if (!this._attemptSASLAuth(matched)) {
      this._attemptLegacyAuth();
    }
  }

  /**
   * Iterate through an array of SASL mechanisms and attempt authentication
   * with the highest priority (enabled) mechanism.
   *
   * @private
   * @param {SASLMechanism[]} mechanisms - Array of SASL mechanisms.
   * @return {Boolean} mechanism_found - true or false, depending on whether a
   *  valid SASL mechanism was found with which authentication could be started.
   */
  _attemptSASLAuth(mechanisms) {
    mechanisms = this.sortMechanismsByPriority(mechanisms || []);
    let mechanism_found = false;
    for (let i = 0; i < mechanisms.length; ++i) {
      if (!mechanisms[i].test(this)) {
        continue;
      }
      this._sasl_success_handler = this._addSysHandler(this._sasl_success_cb.bind(this), null, 'success', null, null);
      this._sasl_failure_handler = this._addSysHandler(this._sasl_failure_cb.bind(this), null, 'failure', null, null);
      this._sasl_challenge_handler = this._addSysHandler(this._sasl_challenge_cb.bind(this), null, 'challenge', null, null);
      this._sasl_mechanism = mechanisms[i];
      this._sasl_mechanism.onStart(this);
      const request_auth_exchange = $build('auth', {
        'xmlns': NS.SASL,
        'mechanism': this._sasl_mechanism.mechname
      });
      if (this._sasl_mechanism.isClientFirst) {
        const response = this._sasl_mechanism.clientChallenge(this);
        request_auth_exchange.t(btoa(/** @type {string} */response));
      }
      this.send(request_auth_exchange.tree());
      mechanism_found = true;
      break;
    }
    return mechanism_found;
  }

  /**
   * _Private_ handler for the SASL challenge
   * @private
   * @param {Element} elem
   */
  async _sasl_challenge_cb(elem) {
    const challenge = atob(getText(elem));
    const response = await this._sasl_mechanism.onChallenge(this, challenge);
    const stanza = $build('response', {
      'xmlns': NS.SASL
    });
    if (response) stanza.t(btoa(response));
    this.send(stanza.tree());
    return true;
  }

  /**
   * Attempt legacy (i.e. non-SASL) authentication.
   * @private
   */
  _attemptLegacyAuth() {
    if (getNodeFromJid(this.jid) === null) {
      // we don't have a node, which is required for non-anonymous
      // client connections
      this._changeConnectStatus(Status.CONNFAIL, ErrorCondition.MISSING_JID_NODE);
      this.disconnect(ErrorCondition.MISSING_JID_NODE);
    } else {
      // Fall back to legacy authentication
      this._changeConnectStatus(Status.AUTHENTICATING, null);
      this._addSysHandler(this._onLegacyAuthIQResult.bind(this), null, null, null, '_auth_1');
      this.send($iq({
        'type': 'get',
        'to': this.domain,
        'id': '_auth_1'
      }).c('query', {
        xmlns: NS.AUTH
      }).c('username', {}).t(getNodeFromJid(this.jid)).tree());
    }
  }

  /**
   * _Private_ handler for legacy authentication.
   *
   * This handler is called in response to the initial <iq type='get'/>
   * for legacy authentication.  It builds an authentication <iq/> and
   * sends it, creating a handler (calling back to _auth2_cb()) to
   * handle the result
   * @private
   * @return {false} `false` to remove the handler.
   */
  _onLegacyAuthIQResult() {
    const pass = typeof this.pass === 'string' ? this.pass : '';

    // build plaintext auth iq
    const iq = $iq({
      type: 'set',
      id: '_auth_2'
    }).c('query', {
      xmlns: NS.AUTH
    }).c('username', {}).t(getNodeFromJid(this.jid)).up().c('password').t(pass);
    if (!getResourceFromJid(this.jid)) {
      // since the user has not supplied a resource, we pick
      // a default one here.  unlike other auth methods, the server
      // cannot do this for us.
      this.jid = getBareJidFromJid(this.jid) + '/strophe';
    }
    iq.up().c('resource', {}).t(getResourceFromJid(this.jid));
    this._addSysHandler(this._auth2_cb.bind(this), null, null, null, '_auth_2');
    this.send(iq.tree());
    return false;
  }

  /**
   * _Private_ handler for succesful SASL authentication.
   * @private
   * @param {Element} elem - The matching stanza.
   * @return {false} `false` to remove the handler.
   */
  _sasl_success_cb(elem) {
    if (this._sasl_data['server-signature']) {
      let serverSignature;
      const success = atob(getText(elem));
      const attribMatch = /([a-z]+)=([^,]+)(,|$)/;
      const matches = success.match(attribMatch);
      if (matches[1] === 'v') {
        serverSignature = matches[2];
      }
      if (serverSignature !== this._sasl_data['server-signature']) {
        // remove old handlers
        this.deleteHandler(this._sasl_failure_handler);
        this._sasl_failure_handler = null;
        if (this._sasl_challenge_handler) {
          this.deleteHandler(this._sasl_challenge_handler);
          this._sasl_challenge_handler = null;
        }
        this._sasl_data = {};
        return this._sasl_failure_cb(null);
      }
    }
    strophe_browser_esm_log.info('SASL authentication succeeded.');
    if (this._sasl_data.keys) {
      this.scram_keys = this._sasl_data.keys;
    }
    if (this._sasl_mechanism) {
      this._sasl_mechanism.onSuccess();
    }
    // remove old handlers
    this.deleteHandler(this._sasl_failure_handler);
    this._sasl_failure_handler = null;
    if (this._sasl_challenge_handler) {
      this.deleteHandler(this._sasl_challenge_handler);
      this._sasl_challenge_handler = null;
    }
    /** @type {Handler[]} */
    const streamfeature_handlers = [];

    /**
     * @param {Handler[]} handlers
     * @param {Element} elem
     */
    const wrapper = (handlers, elem) => {
      while (handlers.length) {
        this.deleteHandler(handlers.pop());
      }
      this._onStreamFeaturesAfterSASL(elem);
      return false;
    };
    streamfeature_handlers.push(this._addSysHandler(/** @param {Element} elem */
    elem => wrapper(streamfeature_handlers, elem), null, 'stream:features', null, null));
    streamfeature_handlers.push(this._addSysHandler(/** @param {Element} elem */
    elem => wrapper(streamfeature_handlers, elem), NS.STREAM, 'features', null, null));

    // we must send an xmpp:restart now
    this._sendRestart();
    return false;
  }

  /**
   * @private
   * @param {Element} elem - The matching stanza.
   * @return {false} `false` to remove the handler.
   */
  _onStreamFeaturesAfterSASL(elem) {
    // save stream:features for future usage
    this.features = elem;
    for (let i = 0; i < elem.childNodes.length; i++) {
      const child = elem.childNodes[i];
      if (child.nodeName === 'bind') {
        this.do_bind = true;
      }
      if (child.nodeName === 'session') {
        this.do_session = true;
      }
    }
    if (!this.do_bind) {
      this._changeConnectStatus(Status.AUTHFAIL, null);
      return false;
    } else if (!this.options.explicitResourceBinding) {
      this.bind();
    } else {
      this._changeConnectStatus(Status.BINDREQUIRED, null);
    }
    return false;
  }

  /**
   * Sends an IQ to the XMPP server to bind a JID resource for this session.
   *
   * https://tools.ietf.org/html/rfc6120#section-7.5
   *
   * If `explicitResourceBinding` was set to a truthy value in the options
   * passed to the Connection constructor, then this function needs
   * to be called explicitly by the client author.
   *
   * Otherwise it'll be called automatically as soon as the XMPP server
   * advertises the "urn:ietf:params:xml:ns:xmpp-bind" stream feature.
   */
  bind() {
    if (!this.do_bind) {
      strophe_browser_esm_log.info(`Connection.prototype.bind called but "do_bind" is false`);
      return;
    }
    this._addSysHandler(this._onResourceBindResultIQ.bind(this), null, null, null, '_bind_auth_2');
    const resource = getResourceFromJid(this.jid);
    if (resource) {
      this.send($iq({
        type: 'set',
        id: '_bind_auth_2'
      }).c('bind', {
        xmlns: NS.BIND
      }).c('resource', {}).t(resource).tree());
    } else {
      this.send($iq({
        type: 'set',
        id: '_bind_auth_2'
      }).c('bind', {
        xmlns: NS.BIND
      }).tree());
    }
  }

  /**
   * _Private_ handler for binding result and session start.
   * @private
   * @param {Element} elem - The matching stanza.
   * @return {false} `false` to remove the handler.
   */
  _onResourceBindResultIQ(elem) {
    if (elem.getAttribute('type') === 'error') {
      strophe_browser_esm_log.warn('Resource binding failed.');
      const conflict = elem.getElementsByTagName('conflict');
      let condition;
      if (conflict.length > 0) {
        condition = ErrorCondition.CONFLICT;
      }
      this._changeConnectStatus(Status.AUTHFAIL, condition, elem);
      return false;
    }
    // TODO - need to grab errors
    const bind = elem.getElementsByTagName('bind');
    if (bind.length > 0) {
      const jidNode = bind[0].getElementsByTagName('jid');
      if (jidNode.length > 0) {
        this.authenticated = true;
        this.jid = getText(jidNode[0]);
        if (this.do_session) {
          this._establishSession();
        } else {
          this._changeConnectStatus(Status.CONNECTED, null);
        }
      }
    } else {
      strophe_browser_esm_log.warn('Resource binding failed.');
      this._changeConnectStatus(Status.AUTHFAIL, null, elem);
      return false;
    }
  }

  /**
   * Send IQ request to establish a session with the XMPP server.
   *
   * See https://xmpp.org/rfcs/rfc3921.html#session
   *
   * Note: The protocol for session establishment has been determined as
   * unnecessary and removed in RFC-6121.
   * @private
   */
  _establishSession() {
    if (!this.do_session) {
      throw new Error(`Connection.prototype._establishSession ` + `called but apparently ${NS.SESSION} wasn't advertised by the server`);
    }
    this._addSysHandler(this._onSessionResultIQ.bind(this), null, null, null, '_session_auth_2');
    this.send($iq({
      type: 'set',
      id: '_session_auth_2'
    }).c('session', {
      xmlns: NS.SESSION
    }).tree());
  }

  /**
   * _Private_ handler for the server's IQ response to a client's session
   * request.
   *
   * This sets Connection.authenticated to true on success, which
   * starts the processing of user handlers.
   *
   * See https://xmpp.org/rfcs/rfc3921.html#session
   *
   * Note: The protocol for session establishment has been determined as
   * unnecessary and removed in RFC-6121.
   * @private
   * @param {Element} elem - The matching stanza.
   * @return {false} `false` to remove the handler.
   */
  _onSessionResultIQ(elem) {
    if (elem.getAttribute('type') === 'result') {
      this.authenticated = true;
      this._changeConnectStatus(Status.CONNECTED, null);
    } else if (elem.getAttribute('type') === 'error') {
      this.authenticated = false;
      strophe_browser_esm_log.warn('Session creation failed.');
      this._changeConnectStatus(Status.AUTHFAIL, null, elem);
      return false;
    }
    return false;
  }

  /**
   * _Private_ handler for SASL authentication failure.
   * @param {Element} [elem] - The matching stanza.
   * @return {false} `false` to remove the handler.
   */
  _sasl_failure_cb(elem) {
    // delete unneeded handlers
    if (this._sasl_success_handler) {
      this.deleteHandler(this._sasl_success_handler);
      this._sasl_success_handler = null;
    }
    if (this._sasl_challenge_handler) {
      this.deleteHandler(this._sasl_challenge_handler);
      this._sasl_challenge_handler = null;
    }
    if (this._sasl_mechanism) this._sasl_mechanism.onFailure();
    this._changeConnectStatus(Status.AUTHFAIL, null, elem);
    return false;
  }

  /**
   * _Private_ handler to finish legacy authentication.
   *
   * This handler is called when the result from the jabber:iq:auth
   * <iq/> stanza is returned.
   * @private
   * @param {Element} elem - The stanza that triggered the callback.
   * @return {false} `false` to remove the handler.
   */
  _auth2_cb(elem) {
    if (elem.getAttribute('type') === 'result') {
      this.authenticated = true;
      this._changeConnectStatus(Status.CONNECTED, null);
    } else if (elem.getAttribute('type') === 'error') {
      this._changeConnectStatus(Status.AUTHFAIL, null, elem);
      this.disconnect('authentication failed');
    }
    return false;
  }

  /**
   * _Private_ function to add a system level timed handler.
   *
   * This function is used to add a TimedHandler for the
   * library code.  System timed handlers are allowed to run before
   * authentication is complete.
   * @param {number} period - The period of the handler.
   * @param {Function} handler - The callback function.
   */
  _addSysTimedHandler(period, handler) {
    const thand = new TimedHandler(period, handler);
    thand.user = false;
    this.addTimeds.push(thand);
    return thand;
  }

  /**
   * _Private_ function to add a system level stanza handler.
   *
   * This function is used to add a Handler for the
   * library code.  System stanza handlers are allowed to run before
   * authentication is complete.
   * @param {Function} handler - The callback function.
   * @param {string} ns - The namespace to match.
   * @param {string} name - The stanza name to match.
   * @param {string} type - The stanza type attribute to match.
   * @param {string} id - The stanza id attribute to match.
   */
  _addSysHandler(handler, ns, name, type, id) {
    const hand = new Handler(handler, ns, name, type, id);
    hand.user = false;
    this.addHandlers.push(hand);
    return hand;
  }

  /**
   * _Private_ timeout handler for handling non-graceful disconnection.
   *
   * If the graceful disconnect process does not complete within the
   * time allotted, this handler finishes the disconnect anyway.
   * @return {false} `false` to remove the handler.
   */
  _onDisconnectTimeout() {
    strophe_browser_esm_log.debug('_onDisconnectTimeout was called');
    this._changeConnectStatus(Status.CONNTIMEOUT, null);
    this._proto._onDisconnectTimeout();
    // actually disconnect
    this._doDisconnect();
    return false;
  }

  /**
   * _Private_ handler to process events during idle cycle.
   *
   * This handler is called every 100ms to fire timed handlers that
   * are ready and keep poll requests going.
   */
  _onIdle() {
    // add timed handlers scheduled for addition
    // NOTE: we add before remove in the case a timed handler is
    // added and then deleted before the next _onIdle() call.
    while (this.addTimeds.length > 0) {
      this.timedHandlers.push(this.addTimeds.pop());
    }

    // remove timed handlers that have been scheduled for deletion
    while (this.removeTimeds.length > 0) {
      const thand = this.removeTimeds.pop();
      const i = this.timedHandlers.indexOf(thand);
      if (i >= 0) {
        this.timedHandlers.splice(i, 1);
      }
    }

    // call ready timed handlers
    const now = new Date().getTime();
    const newList = [];
    for (let i = 0; i < this.timedHandlers.length; i++) {
      const thand = this.timedHandlers[i];
      if (this.authenticated || !thand.user) {
        const since = thand.lastCalled + thand.period;
        if (since - now <= 0) {
          if (thand.run()) {
            newList.push(thand);
          }
        } else {
          newList.push(thand);
        }
      }
    }
    this.timedHandlers = newList;
    clearTimeout(this._idleTimeout);
    this._proto._onIdle();

    // reactivate the timer only if connected
    if (this.connected) {
      this._idleTimeout = setTimeout(() => this._onIdle(), 100);
    }
  }
}

class UnsafeXML extends String {}

/**
 * A Stanza represents a XML element used in XMPP (commonly referred to as stanzas).
 */
class Stanza extends Builder {
  /** @type {string} */
  #string;
  /** @type {Array<string>} */
  #strings;
  /**
   * @typedef {Array<string|Stanza|Builder>} StanzaValue
   * @type {StanzaValue|Array<StanzaValue>}
   */
  #values;

  /**
   * @param {string[]} strings
   * @param {any[]} values
   */
  constructor(strings, values) {
    super('stanza');
    this.#strings = strings;
    this.#values = values;
  }

  /**
   * A directive which can be used to pass a string of XML as a value to the
   * stx tagged template literal.
   *
   * It's considered "unsafe" because it can pose a security risk if used with
   * untrusted input.
   *
   * @param {string} string
   * @returns {UnsafeXML}
   * @example
   *    const status = '<status>I am busy!</status>';
   *    const pres = stx`
   *       <presence from='juliet@example.com/chamber' id='pres1'>
   *           <show>dnd</show>
   *           ${unsafeXML(status)}
   *       </presence>`;
   *    connection.send(pres);
   */
  static unsafeXML(string) {
    return new UnsafeXML(string);
  }

  /**
   * Turns the passed-in string into an XML Element.
   * @param {string} string
   * @param {boolean} [throwErrorIfInvalidNS]
   * @returns {Element}
   */
  static toElement(string, throwErrorIfInvalidNS) {
    const doc = strophe_browser_esm_xmlHtmlNode(string);
    const parserError = getParserError(doc);
    if (parserError) {
      throw new Error(`Parser Error: ${parserError}`);
    }
    const node = stripWhitespace(getFirstElementChild(doc));
    if (['message', 'iq', 'presence'].includes(node.nodeName.toLowerCase()) && node.namespaceURI !== 'jabber:client' && node.namespaceURI !== 'jabber:server') {
      const err_msg = `Invalid namespaceURI ${node.namespaceURI}`;
      if (throwErrorIfInvalidNS) {
        throw new Error(err_msg);
      } else {
        strophe_browser_esm_log.error(err_msg);
      }
    }
    return node;
  }
  buildTree() {
    return Stanza.toElement(this.toString(), true);
  }

  /**
   * @return {string}
   */
  toString() {
    this.#string = this.#string || this.#strings.reduce((acc, str, idx) => {
      const value = this.#values.length > idx ? this.#values[idx] : '';
      return acc + str + (Array.isArray(value) ? value.map(v => v instanceof UnsafeXML || v instanceof Builder ? v : xmlescape(v.toString())).join('') : value instanceof UnsafeXML || value instanceof Builder ? value : xmlescape((value !== null && value !== void 0 ? value : '').toString()));
    }, '').trim();
    return this.#string;
  }
}

/**
 * Tagged template literal function which generates {@link Stanza} objects
 *
 * @example
 *      const pres = stx`<presence type="${type}" xmlns="jabber:client"><show>${show}</show></presence>`
 *
 *      connection.send(msg);
 *
 * @example
 *      const msg = stx`<message
 *          from='sender@example.org'
 *          id='hgn27af1'
 *          to='recipient@example.org'
 *          type='chat'>
 *          <body>Hello world</body>
 *      </message>`;
 *
 *      connection.send(msg);
 *
 * @param {string[]} strings
 * @param {...any} values
 * @returns {Stanza}
 */
function stx(strings, ...values) {
  return new Stanza(strings, values);
}

/*global globalThis */

/**
 * A container for all Strophe library functions.
 *
 * This object is a container for all the objects and constants
 * used in the library.  It is not meant to be instantiated, but to
 * provide a namespace for library objects, constants, and functions.
 *
 * @namespace Strophe
 * @property {Handler} Handler
 * @property {Builder} Builder
 * @property {Request} Request Represents HTTP Requests made for a BOSH connection
 * @property {Bosh} Bosh Support for XMPP-over-HTTP via XEP-0124 (BOSH)
 * @property {Websocket} Websocket Support for XMPP over websocket
 * @property {WorkerWebsocket} WorkerWebsocket Support for XMPP over websocket in a shared worker
 * @property {number} TIMEOUT=1.1 Timeout multiplier. A waiting BOSH HTTP request
 *  will be considered failed after Math.floor(TIMEOUT * wait) seconds have elapsed.
 *  This defaults to 1.1, and with default wait, 66 seconds.
 * @property {number} SECONDARY_TIMEOUT=0.1 Secondary timeout multiplier.
 *  In cases where Strophe can detect early failure, it will consider the request
 *  failed if it doesn't return after `Math.floor(SECONDARY_TIMEOUT * wait)`
 *  seconds have elapsed. This defaults to 0.1, and with default wait, 6 seconds.
 * @property {SASLAnonymous} SASLAnonymous SASL ANONYMOUS authentication.
 * @property {SASLPlain} SASLPlain SASL PLAIN authentication
 * @property {SASLSHA1} SASLSHA1 SASL SCRAM-SHA-1 authentication
 * @property {SASLSHA256} SASLSHA256 SASL SCRAM-SHA-256 authentication
 * @property {SASLSHA384} SASLSHA384 SASL SCRAM-SHA-384 authentication
 * @property {SASLSHA512} SASLSHA512 SASL SCRAM-SHA-512 authentication
 * @property {SASLOAuthBearer} SASLOAuthBearer SASL OAuth Bearer authentication
 * @property {SASLExternal} SASLExternal SASL EXTERNAL authentication
 * @property {SASLXOAuth2} SASLXOAuth2 SASL X-OAuth2 authentication
 * @property {Status} Status
 * @property {Object.<string, string>} NS
 * @property {XHTML} XHTML
 */
const Strophe = {
  /** @constant: VERSION */
  VERSION: '3.0.0',
  /**
   * @returns {number}
   */
  get TIMEOUT() {
    return Bosh.getTimeoutMultplier();
  },
  /**
   * @param {number} n
   */
  set TIMEOUT(n) {
    Bosh.setTimeoutMultiplier(n);
  },
  /**
   * @returns {number}
   */
  get SECONDARY_TIMEOUT() {
    return Bosh.getSecondaryTimeoutMultplier();
  },
  /**
   * @param {number} n
   */
  set SECONDARY_TIMEOUT(n) {
    Bosh.setSecondaryTimeoutMultiplier(n);
  },
  ...utils$1,
  ...strophe_browser_esm_log,
  Request,
  // Transports
  Bosh,
  Websocket,
  WorkerWebsocket,
  Connection,
  Handler,
  // Available authentication mechanisms
  SASLAnonymous,
  SASLPlain,
  SASLSHA1,
  SASLSHA256,
  SASLSHA384,
  SASLSHA512,
  SASLOAuthBearer,
  SASLExternal,
  SASLXOAuth2,
  Stanza,
  Builder,
  ElementType,
  ErrorCondition,
  LogLevel: LOG_LEVELS,
  /** @type {Object.<string, string>} */
  NS,
  SASLMechanism,
  /** @type {Status} */
  Status,
  TimedHandler,
  XHTML: {
    ...XHTML,
    validTag: validTag,
    validCSS: validCSS,
    validAttribute: validAttribute
  },
  /**
   * Render a DOM element and all descendants to a String.
   * @method Strophe.serialize
   * @param {Element|Builder} elem - A DOM element.
   * @return {string} - The serialized element tree as a String.
   */
  serialize(elem) {
    return Builder.serialize(elem);
  },
  /**
   * @typedef {import('./constants').LogLevel} LogLevel
   *
   * Library consumers can use this function to set the log level of Strophe.
   * The default log level is Strophe.LogLevel.INFO.
   * @param {LogLevel} level
   * @example Strophe.setLogLevel(Strophe.LogLevel.DEBUG);
   */
  setLogLevel(level) {
    strophe_browser_esm_log.setLogLevel(level);
  },
  /**
   * This function is used to extend the current namespaces in
   * Strophe.NS. It takes a key and a value with the key being the
   * name of the new namespace, with its actual value.
   * @example: Strophe.addNamespace('PUBSUB', "http://jabber.org/protocol/pubsub");
   *
   * @param {string} name - The name under which the namespace will be
   *     referenced under Strophe.NS
   * @param {string} value - The actual namespace.
   */
  addNamespace(name, value) {
    Strophe.NS[name] = value;
  },
  /**
   * Extends the Strophe.Connection object with the given plugin.
   * @param {string} name - The name of the extension.
   * @param {Object} ptype - The plugin's prototype.
   */
  addConnectionPlugin(name, ptype) {
    Connection.addConnectionPlugin(name, ptype);
  }
};
globalThis.$build = $build;
globalThis.$iq = $iq;
globalThis.$msg = $msg;
globalThis.$pres = $pres;
globalThis.Strophe = Strophe;
globalThis.stx = stx;
const toStanza = Stanza.toElement;
globalThis.toStanza = Stanza.toElement; // Deprecated



;// CONCATENATED MODULE: ./node_modules/dompurify/dist/purify.es.mjs
/*! @license DOMPurify 3.4.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.5/LICENSE */

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = true,
      o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = true, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

const purify_es_entries = Object.entries,
  setPrototypeOf = Object.setPrototypeOf,
  isFrozen = Object.isFrozen,
  getPrototypeOf = Object.getPrototypeOf,
  getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
let purify_es_freeze = Object.freeze,
  purify_es_seal = Object.seal,
  purify_es_create = Object.create; // eslint-disable-line import/no-mutable-exports
let _ref = typeof Reflect !== 'undefined' && Reflect,
  purify_es_apply = _ref.apply,
  purify_es_construct = _ref.construct;
if (!purify_es_freeze) {
  purify_es_freeze = function freeze(x) {
    return x;
  };
}
if (!purify_es_seal) {
  purify_es_seal = function seal(x) {
    return x;
  };
}
if (!purify_es_apply) {
  purify_es_apply = function apply(func, thisArg) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    return func.apply(thisArg, args);
  };
}
if (!purify_es_construct) {
  purify_es_construct = function construct(Func) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return new Func(...args);
  };
}
const arrayForEach = unapply(Array.prototype.forEach);
const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
const arrayPop = unapply(Array.prototype.pop);
const arrayPush = unapply(Array.prototype.push);
const arraySplice = unapply(Array.prototype.splice);
const arrayIsArray = Array.isArray;
const stringToLowerCase = unapply(String.prototype.toLowerCase);
const stringToString = unapply(String.prototype.toString);
const stringMatch = unapply(String.prototype.match);
const stringReplace = unapply(String.prototype.replace);
const stringIndexOf = unapply(String.prototype.indexOf);
const stringTrim = unapply(String.prototype.trim);
const numberToString = unapply(Number.prototype.toString);
const booleanToString = unapply(Boolean.prototype.toString);
const bigintToString = typeof BigInt === 'undefined' ? null : unapply(BigInt.prototype.toString);
const symbolToString = typeof Symbol === 'undefined' ? null : unapply(Symbol.prototype.toString);
const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
const objectToString = unapply(Object.prototype.toString);
const regExpTest = unapply(RegExp.prototype.test);
const typeErrorCreate = unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */
function unapply(func) {
  return function (thisArg) {
    if (thisArg instanceof RegExp) {
      thisArg.lastIndex = 0;
    }
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    return purify_es_apply(func, thisArg, args);
  };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */
function unconstruct(Func) {
  return function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return purify_es_construct(Func, args);
  };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */
function addToSet(set, array) {
  let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
  if (setPrototypeOf) {
    // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    setPrototypeOf(set, null);
  }
  if (!arrayIsArray(array)) {
    return set;
  }
  let l = array.length;
  while (l--) {
    let element = array[l];
    if (typeof element === 'string') {
      const lcElement = transformCaseFunc(element);
      if (lcElement !== element) {
        // Config presets (e.g. tags.js, attrs.js) are immutable.
        if (!isFrozen(array)) {
          array[l] = lcElement;
        }
        element = lcElement;
      }
    }
    set[element] = true;
  }
  return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */
function cleanArray(array) {
  for (let index = 0; index < array.length; index++) {
    const isPropertyExist = objectHasOwnProperty(array, index);
    if (!isPropertyExist) {
      array[index] = null;
    }
  }
  return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */
function clone(object) {
  const newObject = purify_es_create(null);
  for (const _ref2 of purify_es_entries(object)) {
    var _ref3 = _slicedToArray(_ref2, 2);
    const property = _ref3[0];
    const value = _ref3[1];
    const isPropertyExist = objectHasOwnProperty(object, property);
    if (isPropertyExist) {
      if (arrayIsArray(value)) {
        newObject[property] = cleanArray(value);
      } else if (value && typeof value === 'object' && value.constructor === Object) {
        newObject[property] = clone(value);
      } else {
        newObject[property] = value;
      }
    }
  }
  return newObject;
}
/**
 * Convert non-node values into strings without depending on direct property access.
 *
 * @param value - The value to stringify.
 * @returns A string representation of the provided value.
 */
function stringifyValue(value) {
  switch (typeof value) {
    case 'string':
      {
        return value;
      }
    case 'number':
      {
        return numberToString(value);
      }
    case 'boolean':
      {
        return booleanToString(value);
      }
    case 'bigint':
      {
        return bigintToString ? bigintToString(value) : '0';
      }
    case 'symbol':
      {
        return symbolToString ? symbolToString(value) : 'Symbol()';
      }
    case 'undefined':
      {
        return objectToString(value);
      }
    case 'function':
    case 'object':
      {
        if (value === null) {
          return objectToString(value);
        }
        const valueAsRecord = value;
        const valueToString = lookupGetter(valueAsRecord, 'toString');
        if (typeof valueToString === 'function') {
          const stringified = valueToString(valueAsRecord);
          return typeof stringified === 'string' ? stringified : objectToString(stringified);
        }
        return objectToString(value);
      }
    default:
      {
        return objectToString(value);
      }
  }
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */
function lookupGetter(object, prop) {
  while (object !== null) {
    const desc = getOwnPropertyDescriptor(object, prop);
    if (desc) {
      if (desc.get) {
        return unapply(desc.get);
      }
      if (typeof desc.value === 'function') {
        return unapply(desc.value);
      }
    }
    object = getPrototypeOf(object);
  }
  function fallbackValue() {
    return null;
  }
  return fallbackValue;
}
function isRegex(value) {
  try {
    regExpTest(value, '');
    return true;
  } catch (_unused) {
    return false;
  }
}

const html$1 = purify_es_freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'search', 'section', 'select', 'shadow', 'slot', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);
const svg$1 = purify_es_freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'enterkeyhint', 'exportparts', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'inputmode', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'part', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
const svgFilters = purify_es_freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const svgDisallowed = purify_es_freeze(['animate', 'color-profile', 'cursor', 'discard', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
const mathMl$1 = purify_es_freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover', 'mprescripts']);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const mathMlDisallowed = purify_es_freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
const purify_es_text = purify_es_freeze(['#text']);

const purify_es_html = purify_es_freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'command', 'commandfor', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'exportparts', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inert', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'part', 'pattern', 'placeholder', 'playsinline', 'popover', 'popovertarget', 'popovertargetaction', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'slot', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'wrap', 'xmlns']);
const svg = purify_es_freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'amplitude', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'exponent', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'mask-type', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'slope', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'tablevalues', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
const mathMl = purify_es_freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnalign', 'columnlines', 'columnspacing', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lquote', 'lspace', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
const purify_es_xml = purify_es_freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

const MUSTACHE_EXPR = purify_es_seal(/{{[\w\W]*|^[\w\W]*}}/g);
const ERB_EXPR = purify_es_seal(/<%[\w\W]*|^[\w\W]*%>/g);
const TMPLIT_EXPR = purify_es_seal(/\${[\w\W]*/g);
const DATA_ATTR = purify_es_seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
const ARIA_ATTR = purify_es_seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const IS_ALLOWED_URI = purify_es_seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const IS_SCRIPT_OR_DATA = purify_es_seal(/^(?:\w+script|data):/i);
const ATTR_WHITESPACE = purify_es_seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const DOCTYPE_NAME = purify_es_seal(/^html$/i);
const CUSTOM_ELEMENT = purify_es_seal(/^[a-z][.\w]*(-[.\w]+)+$/i);

/* eslint-disable @typescript-eslint/indent */
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const NODE_TYPE = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9};
const purify_es_getGlobal = function getGlobal() {
  return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */
const purify_es_createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
  if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
    return null;
  }
  // Allow the callers to control the unique policy name
  // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
  // Policy creation with duplicate names throws in Trusted Types.
  let suffix = null;
  const ATTR_NAME = 'data-tt-policy-suffix';
  if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
    suffix = purifyHostElement.getAttribute(ATTR_NAME);
  }
  const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML(html) {
        return html;
      },
      createScriptURL(scriptUrl) {
        return scriptUrl;
      }
    });
  } catch (_) {
    // Policy creation failed (most likely another DOMPurify script has
    // already run). Skip creating the policy, as this will only cause errors
    // if TT are enforced.
    console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
    return null;
  }
};
const purify_es_createHooksMap = function _createHooksMap() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function createDOMPurify() {
  let window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : purify_es_getGlobal();
  const DOMPurify = root => createDOMPurify(root);
  DOMPurify.version = '3.4.5';
  DOMPurify.removed = [];
  if (!window || !window.document || window.document.nodeType !== NODE_TYPE.document || !window.Element) {
    // Not running in a browser, provide a factory function
    // so that you can pass your own Window
    DOMPurify.isSupported = false;
    return DOMPurify;
  }
  let document = window.document;
  const originalDocument = document;
  const currentScript = originalDocument.currentScript;
  const DocumentFragment = window.DocumentFragment,
    HTMLTemplateElement = window.HTMLTemplateElement,
    Node = window.Node,
    Element = window.Element,
    NodeFilter = window.NodeFilter,
    _window$NamedNodeMap = window.NamedNodeMap,
    NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
    HTMLFormElement = window.HTMLFormElement,
    DOMParser = window.DOMParser,
    trustedTypes = window.trustedTypes;
  const ElementPrototype = Element.prototype;
  const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
  const remove = lookupGetter(ElementPrototype, 'remove');
  const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
  const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
  const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
  const getNodeType = Node && Node.prototype ? lookupGetter(Node.prototype, 'nodeType') : null;
  // As per issue #47, the web-components registry is inherited by a
  // new document created via createHTMLDocument. As per the spec
  // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
  // a new empty registry is used when creating a template contents owner
  // document, so we use that as our parent document to ensure nothing
  // is inherited.
  if (typeof HTMLTemplateElement === 'function') {
    const template = document.createElement('template');
    if (template.content && template.content.ownerDocument) {
      document = template.content.ownerDocument;
    }
  }
  let trustedTypesPolicy;
  let emptyHTML = '';
  const _document = document,
    implementation = _document.implementation,
    createNodeIterator = _document.createNodeIterator,
    createDocumentFragment = _document.createDocumentFragment,
    getElementsByTagName = _document.getElementsByTagName;
  const importNode = originalDocument.importNode;
  let hooks = purify_es_createHooksMap();
  /**
   * Expose whether this browser supports running the full DOMPurify.
   */
  DOMPurify.isSupported = typeof purify_es_entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
  const MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
    ERB_EXPR$1 = ERB_EXPR,
    TMPLIT_EXPR$1 = TMPLIT_EXPR,
    DATA_ATTR$1 = DATA_ATTR,
    ARIA_ATTR$1 = ARIA_ATTR,
    IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
    ATTR_WHITESPACE$1 = ATTR_WHITESPACE,
    CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
  let IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
  /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */
  /* allowed element names */
  let ALLOWED_TAGS = null;
  const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...purify_es_text]);
  /* Allowed attribute names */
  let ALLOWED_ATTR = null;
  const DEFAULT_ALLOWED_ATTR = addToSet({}, [...purify_es_html, ...svg, ...mathMl, ...purify_es_xml]);
  /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */
  let CUSTOM_ELEMENT_HANDLING = Object.seal(purify_es_create(null, {
    tagNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: false
    }
  }));
  /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
  let FORBID_TAGS = null;
  /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
  let FORBID_ATTR = null;
  /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */
  const EXTRA_ELEMENT_HANDLING = Object.seal(purify_es_create(null, {
    tagCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    }
  }));
  /* Decide if ARIA attributes are okay */
  let ALLOW_ARIA_ATTR = true;
  /* Decide if custom data attributes are okay */
  let ALLOW_DATA_ATTR = true;
  /* Decide if unknown protocols are okay */
  let ALLOW_UNKNOWN_PROTOCOLS = false;
  /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */
  let ALLOW_SELF_CLOSE_IN_ATTR = true;
  /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */
  let SAFE_FOR_TEMPLATES = false;
  /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */
  let SAFE_FOR_XML = true;
  /* Decide if document with <html>... should be returned */
  let WHOLE_DOCUMENT = false;
  /* Track whether config is already set on this instance of DOMPurify. */
  let SET_CONFIG = false;
  /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */
  let FORCE_BODY = false;
  /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */
  let RETURN_DOM = false;
  /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */
  let RETURN_DOM_FRAGMENT = false;
  /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */
  let RETURN_TRUSTED_TYPE = false;
  /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */
  let SANITIZE_DOM = true;
  /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */
  let SANITIZE_NAMED_PROPS = false;
  const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
  /* Keep element content when removing element? */
  let KEEP_CONTENT = true;
  /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */
  let IN_PLACE = false;
  /* Allow usage of profiles like html, svg and mathMl */
  let USE_PROFILES = {};
  /* Tags to ignore content of when KEEP_CONTENT is true */
  let FORBID_CONTENTS = null;
  const DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
  /* Tags that are safe for data: URIs */
  let DATA_URI_TAGS = null;
  const DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
  /* Attributes safe for values like "javascript:" */
  let URI_SAFE_ATTRIBUTES = null;
  const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
  const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
  const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
  const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
  /* Document namespace */
  let NAMESPACE = HTML_NAMESPACE;
  let IS_EMPTY_INPUT = false;
  /* Allowed XHTML+XML namespaces */
  let ALLOWED_NAMESPACES = null;
  const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
  let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
  let HTML_INTEGRATION_POINTS = addToSet({}, ['annotation-xml']);
  // Certain elements are allowed in both SVG and HTML
  // namespace. We need to specify them explicitly
  // so that they don't get erroneously deleted from
  // HTML namespace.
  const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
  /* Parsing of strict XHTML documents */
  let PARSER_MEDIA_TYPE = null;
  const SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
  const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
  let transformCaseFunc = null;
  /* Keep a reference to config to pass to hooks */
  let CONFIG = null;
  /* Ideally, do not touch anything below this line */
  /* ______________________________________________ */
  const formElement = document.createElement('form');
  const isRegexOrFunction = function isRegexOrFunction(testValue) {
    return testValue instanceof RegExp || testValue instanceof Function;
  };
  /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */
  // eslint-disable-next-line complexity
  const _parseConfig = function _parseConfig() {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (CONFIG && CONFIG === cfg) {
      return;
    }
    /* Shield configuration object from tampering */
    if (!cfg || typeof cfg !== 'object') {
      cfg = {};
    }
    /* Shield configuration object from prototype pollution */
    cfg = clone(cfg);
    PARSER_MEDIA_TYPE =
    // eslint-disable-next-line unicorn/prefer-includes
    SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
    // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
    transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
    /* Set configuration parameters */
    ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') && arrayIsArray(cfg.ALLOWED_TAGS) ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') && arrayIsArray(cfg.ALLOWED_ATTR) ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
    ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') && arrayIsArray(cfg.ALLOWED_NAMESPACES) ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
    URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && arrayIsArray(cfg.ADD_URI_SAFE_ATTR) ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
    DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') && arrayIsArray(cfg.ADD_DATA_URI_TAGS) ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
    FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && arrayIsArray(cfg.FORBID_CONTENTS) ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
    FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') && arrayIsArray(cfg.FORBID_TAGS) ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
    FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') && arrayIsArray(cfg.FORBID_ATTR) ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
    USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === 'object' ? clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
    ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
    SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
    RETURN_DOM = cfg.RETURN_DOM || false; // Default false
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
    FORCE_BODY = cfg.FORCE_BODY || false; // Default false
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
    SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
    IN_PLACE = cfg.IN_PLACE || false; // Default false
    IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI; // Default regexp
    NAMESPACE = typeof cfg.NAMESPACE === 'string' ? cfg.NAMESPACE : HTML_NAMESPACE; // Default HTML namespace
    MATHML_TEXT_INTEGRATION_POINTS = objectHasOwnProperty(cfg, 'MATHML_TEXT_INTEGRATION_POINTS') && cfg.MATHML_TEXT_INTEGRATION_POINTS && typeof cfg.MATHML_TEXT_INTEGRATION_POINTS === 'object' ? clone(cfg.MATHML_TEXT_INTEGRATION_POINTS) : addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']); // Default built-in map
    HTML_INTEGRATION_POINTS = objectHasOwnProperty(cfg, 'HTML_INTEGRATION_POINTS') && cfg.HTML_INTEGRATION_POINTS && typeof cfg.HTML_INTEGRATION_POINTS === 'object' ? clone(cfg.HTML_INTEGRATION_POINTS) : addToSet({}, ['annotation-xml']); // Default built-in map
    const customElementHandling = objectHasOwnProperty(cfg, 'CUSTOM_ELEMENT_HANDLING') && cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING === 'object' ? clone(cfg.CUSTOM_ELEMENT_HANDLING) : purify_es_create(null);
    CUSTOM_ELEMENT_HANDLING = purify_es_create(null);
    if (objectHasOwnProperty(customElementHandling, 'tagNameCheck') && isRegexOrFunction(customElementHandling.tagNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck; // Default undefined
    }
    if (objectHasOwnProperty(customElementHandling, 'attributeNameCheck') && isRegexOrFunction(customElementHandling.attributeNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck; // Default undefined
    }
    if (objectHasOwnProperty(customElementHandling, 'allowCustomizedBuiltInElements') && typeof customElementHandling.allowCustomizedBuiltInElements === 'boolean') {
      CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements; // Default undefined
    }
    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }
    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }
    /* Parse profile info */
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, purify_es_text);
      ALLOWED_ATTR = purify_es_create(null);
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html$1);
        addToSet(ALLOWED_ATTR, purify_es_html);
      }
      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg$1);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, purify_es_xml);
      }
      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, purify_es_xml);
      }
      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl$1);
        addToSet(ALLOWED_ATTR, mathMl);
        addToSet(ALLOWED_ATTR, purify_es_xml);
      }
    }
    /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
     * leaking across calls when switching from function to array config */
    EXTRA_ELEMENT_HANDLING.tagCheck = null;
    EXTRA_ELEMENT_HANDLING.attributeCheck = null;
    /* Merge configuration parameters */
    if (objectHasOwnProperty(cfg, 'ADD_TAGS')) {
      if (typeof cfg.ADD_TAGS === 'function') {
        EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
      } else if (arrayIsArray(cfg.ADD_TAGS)) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }
        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }
    }
    if (objectHasOwnProperty(cfg, 'ADD_ATTR')) {
      if (typeof cfg.ADD_ATTR === 'function') {
        EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
      } else if (arrayIsArray(cfg.ADD_ATTR)) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }
        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }
    }
    if (objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && arrayIsArray(cfg.ADD_URI_SAFE_ATTR)) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
    }
    if (objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && arrayIsArray(cfg.FORBID_CONTENTS)) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = clone(FORBID_CONTENTS);
      }
      addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
    }
    if (objectHasOwnProperty(cfg, 'ADD_FORBID_CONTENTS') && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = clone(FORBID_CONTENTS);
      }
      addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
    }
    /* Add #text in case KEEP_CONTENT is set to true */
    if (KEEP_CONTENT) {
      ALLOWED_TAGS['#text'] = true;
    }
    /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
    }
    /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ['tbody']);
      delete FORBID_TAGS.tbody;
    }
    if (cfg.TRUSTED_TYPES_POLICY) {
      if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      }
      if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      }
      // Overwrite existing TrustedTypes policy.
      trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
      // Sign local variables required by `sanitize`.
      emptyHTML = trustedTypesPolicy.createHTML('');
    } else {
      // Uninitialized policy, attempt to initialize the internal dompurify policy.
      if (trustedTypesPolicy === undefined) {
        trustedTypesPolicy = purify_es_createTrustedTypesPolicy(trustedTypes, currentScript);
      }
      // If creating the internal policy succeeded sign internal variables.
      if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') {
        emptyHTML = trustedTypesPolicy.createHTML('');
      }
    }
    // Prevent further manipulation of configuration.
    // Not available in IE8, Safari 5, etc.
    if (purify_es_freeze) {
      purify_es_freeze(cfg);
    }
    CONFIG = cfg;
  };
  /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */
  const ALL_SVG_TAGS = addToSet({}, [...svg$1, ...svgFilters, ...svgDisallowed]);
  const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
  /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */
  const _checkValidNamespace = function _checkValidNamespace(element) {
    let parent = getParentNode(element);
    // In JSDOM, if we're inside shadow DOM, then parentNode
    // can be null. We just simulate parent in this case.
    if (!parent || !parent.tagName) {
      parent = {
        namespaceURI: NAMESPACE,
        tagName: 'template'
      };
    }
    const tagName = stringToLowerCase(element.tagName);
    const parentTagName = stringToLowerCase(parent.tagName);
    if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
      return false;
    }
    if (element.namespaceURI === SVG_NAMESPACE) {
      // The only way to switch from HTML namespace to SVG
      // is via <svg>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'svg';
      }
      // The only way to switch from MathML to SVG is via`
      // svg if parent is either <annotation-xml> or MathML
      // text integration points.
      if (parent.namespaceURI === MATHML_NAMESPACE) {
        return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
      }
      // We only allow elements that are defined in SVG
      // spec. All others are disallowed in SVG namespace.
      return Boolean(ALL_SVG_TAGS[tagName]);
    }
    if (element.namespaceURI === MATHML_NAMESPACE) {
      // The only way to switch from HTML namespace to MathML
      // is via <math>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'math';
      }
      // The only way to switch from SVG to MathML is via
      // <math> and HTML integration points
      if (parent.namespaceURI === SVG_NAMESPACE) {
        return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
      }
      // We only allow elements that are defined in MathML
      // spec. All others are disallowed in MathML namespace.
      return Boolean(ALL_MATHML_TAGS[tagName]);
    }
    if (element.namespaceURI === HTML_NAMESPACE) {
      // The only way to switch from SVG to HTML is via
      // HTML integration points, and from MathML to HTML
      // is via MathML text integration points
      if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      // We disallow tags that are specific for MathML
      // or SVG and should never appear in HTML namespace
      return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    }
    // For XHTML and XML documents that support custom namespaces
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
      return true;
    }
    // The code should never reach this place (this means
    // that the element somehow got namespace that is not
    // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
    // Return false just in case.
    return false;
  };
  /**
   * _forceRemove
   *
   * @param node a DOM node
   */
  const _forceRemove = function _forceRemove(node) {
    arrayPush(DOMPurify.removed, {
      element: node
    });
    try {
      // eslint-disable-next-line unicorn/prefer-dom-node-remove
      getParentNode(node).removeChild(node);
    } catch (_) {
      remove(node);
    }
  };
  /**
   * _removeAttribute
   *
   * @param name an Attribute name
   * @param element a DOM node
   */
  const _removeAttribute = function _removeAttribute(name, element) {
    try {
      arrayPush(DOMPurify.removed, {
        attribute: element.getAttributeNode(name),
        from: element
      });
    } catch (_) {
      arrayPush(DOMPurify.removed, {
        attribute: null,
        from: element
      });
    }
    element.removeAttribute(name);
    // We void attribute values for unremovable "is" attributes
    if (name === 'is') {
      if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
        try {
          _forceRemove(element);
        } catch (_) {}
      } else {
        try {
          element.setAttribute(name, '');
        } catch (_) {}
      }
    }
  };
  /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */
  const _initDocument = function _initDocument(dirty) {
    /* Create a HTML document */
    let doc = null;
    let leadingWhitespace = null;
    if (FORCE_BODY) {
      dirty = '<remove></remove>' + dirty;
    } else {
      /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
      const matches = stringMatch(dirty, /^[\r\n\t ]+/);
      leadingWhitespace = matches && matches[0];
    }
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
      // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
      dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
    }
    const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
    /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */
    if (NAMESPACE === HTML_NAMESPACE) {
      try {
        doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
      } catch (_) {}
    }
    /* Use createHTMLDocument in case DOMParser is not available */
    if (!doc || !doc.documentElement) {
      doc = implementation.createDocument(NAMESPACE, 'template', null);
      try {
        doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
      } catch (_) {
        // Syntax error if dirtyPayload is invalid xml
      }
    }
    const body = doc.body || doc.documentElement;
    if (dirty && leadingWhitespace) {
      body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
    }
    /* Work on whole document or just its body */
    if (NAMESPACE === HTML_NAMESPACE) {
      return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
    }
    return WHOLE_DOCUMENT ? doc.documentElement : body;
  };
  /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */
  const _createNodeIterator = function _createNodeIterator(root) {
    return createNodeIterator.call(root.ownerDocument || root, root,
    // eslint-disable-next-line no-bitwise
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
  };
  /**
   * Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
   * character data of an element subtree. Used as the final safety net for
   * SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
   * which only form after text-node normalization (e.g. fragments split across
   * stripped elements) cannot survive into a template-evaluating framework.
   *
   * Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
   * in place rather than round-tripping through innerHTML. This preserves
   * descendant node references (important for IN_PLACE callers), avoids a
   * serialize/reparse cycle, and reads literal character data — which means
   * `<%...%>` in text content matches the ERB regex against its real bytes
   * instead of the HTML-entity-escaped form innerHTML would produce.
   *
   * Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
   * attributes is performed during the per-node `_sanitizeAttributes` pass.
   *
   * @param node The root element whose character data should be scrubbed.
   */
  const _scrubTemplateExpressions = function _scrubTemplateExpressions(node) {
    node.normalize();
    const walker = createNodeIterator.call(node.ownerDocument || node, node,
    // eslint-disable-next-line no-bitwise
    NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
    let currentNode = walker.nextNode();
    while (currentNode) {
      let data = currentNode.data;
      arrayForEach([MUSTACHE_EXPR$1, ERB_EXPR$1, TMPLIT_EXPR$1], expr => {
        data = stringReplace(data, expr, ' ');
      });
      currentNode.data = data;
      currentNode = walker.nextNode();
    }
  };
  /**
   * _isClobbered
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */
  const _isClobbered = function _isClobbered(element) {
    return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
  };
  /**
   * Checks whether the given object is a DOM node, including nodes that
   * originate from a different window/realm (e.g. an iframe's
   * contentDocument). The previous `value instanceof Node` check was
   * realm-bound: nodes from a different window failed it, causing
   * sanitize() to silently stringify them and reset IN_PLACE to false,
   * returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
   *
   * Implementation: call the cached `nodeType` getter from Node.prototype
   * directly on the value. This bypasses any clobbered instance property
   * (e.g. a child element named "nodeType") and works across realms
   * because the WebIDL `nodeType` getter reads an internal slot that
   * every real Node has, regardless of which window minted it.
   *
   * @param value object to check whether it's a DOM node
   * @return true if value is a DOM node from any realm
   */
  const _isNode = function _isNode(value) {
    if (!getNodeType || typeof value !== 'object' || value === null) {
      return false;
    }
    try {
      return typeof getNodeType(value) === 'number';
    } catch (_) {
      return false;
    }
  };
  function _executeHooks(hooks, currentNode, data) {
    arrayForEach(hooks, hook => {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  }
  /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */
  const _sanitizeElements = function _sanitizeElements(currentNode) {
    let content = null;
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
    /* Check if element is clobbered or can clobber */
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Now let's check the element's type and name */
    const tagName = transformCaseFunc(currentNode.nodeName);
    /* Execute a hook if present */
    _executeHooks(hooks.uponSanitizeElement, currentNode, {
      tagName,
      allowedTags: ALLOWED_TAGS
    });
    /* Detect mXSS attempts abusing namespace confusion */
    if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove risky CSS construction leading to mXSS */
    if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && tagName === 'style' && _isNode(currentNode.firstElementChild)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove any occurrence of processing instructions */
    if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove any kind of possibly harmful comments */
    if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove element if anything forbids its presence */
    if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
      /* Check if we have a custom element to handle */
      if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) {
          return false;
        }
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) {
          return false;
        }
      }
      /* Keep content except for bad-listed elements */
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
        const parentNode = getParentNode(currentNode) || currentNode.parentNode;
        const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
        if (childNodes && parentNode) {
          const childCount = childNodes.length;
          for (let i = childCount - 1; i >= 0; --i) {
            const childClone = cloneNode(childNodes[i], true);
            parentNode.insertBefore(childClone, getNextSibling(currentNode));
          }
        }
      }
      _forceRemove(currentNode);
      return true;
    }
    /* Check whether element has a valid namespace */
    if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Make sure that older browsers don't get fallback-tag mXSS */
    if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Sanitize element content to be template-safe */
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
      /* Get the element's text content */
      content = currentNode.textContent;
      arrayForEach([MUSTACHE_EXPR$1, ERB_EXPR$1, TMPLIT_EXPR$1], expr => {
        content = stringReplace(content, expr, ' ');
      });
      if (currentNode.textContent !== content) {
        arrayPush(DOMPurify.removed, {
          element: currentNode.cloneNode()
        });
        currentNode.textContent = content;
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeElements, currentNode, null);
    return false;
  };
  /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */
  // eslint-disable-next-line complexity
  const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
    /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */
    if (FORBID_ATTR[lcName]) {
      return false;
    }
    /* Make sure attribute cannot clobber */
    if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
      return false;
    }
    const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
    /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */
    if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!nameIsPermitted || FORBID_ATTR[lcName]) {
      if (
      // First condition does a very basic check if a) it's basically a valid custom element tagname AND
      // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
      _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) ||
      // Alternative, second condition checks if it's an `is`-attribute, AND
      // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
        return false;
      }
      /* Check value is safe. First, is attr inert? If so, is safe */
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (value) {
      return false;
    } else ;
    return true;
  };
  /* Names the HTML spec reserves from valid-custom-element-name; these must
   * never be treated as basic custom elements even when a permissive
   * CUSTOM_ELEMENT_HANDLING.tagNameCheck is configured. */
  const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, ['annotation-xml', 'color-profile', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'missing-glyph']);
  /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */
  const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
    return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT$1, tagName);
  };
  /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */
  const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
    const attributes = currentNode.attributes;
    /* Check if we have attributes; if not we might have a text node */
    if (!attributes || _isClobbered(currentNode)) {
      return;
    }
    const hookEvent = {
      attrName: '',
      attrValue: '',
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR,
      forceKeepAttr: undefined
    };
    let l = attributes.length;
    /* Go backwards over all attributes; safely remove bad ones */
    while (l--) {
      const attr = attributes[l];
      const name = attr.name,
        namespaceURI = attr.namespaceURI,
        attrValue = attr.value;
      const lcName = transformCaseFunc(name);
      const initValue = attrValue;
      let value = name === 'value' ? initValue : stringTrim(initValue);
      /* Execute a hook if present */
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
      _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
      value = hookEvent.attrValue;
      /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */
      if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name') && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
        // Remove the attribute with this value
        _removeAttribute(name, currentNode);
        // Prefix the value and later re-create the attribute with the sanitized value
        value = SANITIZE_NAMED_PROPS_PREFIX + value;
      }
      // Else: already prefixed, leave the attribute alone — the prefix is
      // itself the clobbering protection, and re-applying it is incorrect.
      /* Work around a security issue with comments inside attributes */
      if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Make sure we cannot easily use animated hrefs, even if animations are allowed */
      if (lcName === 'attributename' && stringMatch(value, 'href')) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Did the hooks approve of the attribute? */
      if (hookEvent.forceKeepAttr) {
        continue;
      }
      /* Did the hooks approve of the attribute? */
      if (!hookEvent.keepAttr) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Work around a security issue in jQuery 3.0 */
      if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Sanitize attribute content to be template-safe */
      if (SAFE_FOR_TEMPLATES) {
        arrayForEach([MUSTACHE_EXPR$1, ERB_EXPR$1, TMPLIT_EXPR$1], expr => {
          value = stringReplace(value, expr, ' ');
        });
      }
      /* Is `value` valid for this attribute? */
      const lcTag = transformCaseFunc(currentNode.nodeName);
      if (!_isValidAttribute(lcTag, lcName, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Handle attributes that require Trusted Types */
      if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
        if (namespaceURI) ; else {
          switch (trustedTypes.getAttributeType(lcTag, lcName)) {
            case 'TrustedHTML':
              {
                value = trustedTypesPolicy.createHTML(value);
                break;
              }
            case 'TrustedScriptURL':
              {
                value = trustedTypesPolicy.createScriptURL(value);
                break;
              }
          }
        }
      }
      /* Handle invalid data-* attribute set by try-catching it */
      if (value !== initValue) {
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }
          if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
          } else {
            arrayPop(DOMPurify.removed);
          }
        } catch (_) {
          _removeAttribute(name, currentNode);
        }
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
  };
  /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */
  const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
    let shadowNode = null;
    const shadowIterator = _createNodeIterator(fragment);
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
    while (shadowNode = shadowIterator.nextNode()) {
      /* Execute a hook if present */
      _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
      /* Sanitize tags and elements */
      _sanitizeElements(shadowNode);
      /* Check attributes next */
      _sanitizeAttributes(shadowNode);
      /* Deep shadow DOM detected */
      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM2(shadowNode.content);
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
  };
  /**
   * _sanitizeAttachedShadowRoots
   *
   * Walks `root` and feeds every attached shadow root we encounter into
   * the existing _sanitizeShadowDOM pipeline. The default node iterator
   * does not descend into shadow trees, so nodes inside an attached
   * shadow root would otherwise be skipped entirely.
   *
   * Two real input paths put attached shadow roots in front of us:
   *   1. IN_PLACE on a DOM node that already has shadow roots attached.
   *   2. DOM-node input where importNode(dirty, true) deep-clones the
   *      shadow root because it was created with `clonable: true`.
   *
   * This pass runs once, up front, so the main iteration loop (and the
   * existing _sanitizeShadowDOM template-content recursion) stay
   * untouched — string-input paths are not affected.
   *
   * @param root the subtree root to walk for attached shadow roots
   */
  const _sanitizeAttachedShadowRoots2 = function _sanitizeAttachedShadowRoots(root) {
    if (root.nodeType === NODE_TYPE.element && root.shadowRoot instanceof DocumentFragment) {
      const sr = root.shadowRoot;
      // Recurse first so that nested shadow roots are reached even if
      // _sanitizeShadowDOM removes hosts at this level.
      _sanitizeAttachedShadowRoots2(sr);
      _sanitizeShadowDOM2(sr);
    }
    // Snapshot children before recursing. Sanitization of one subtree
    // (e.g. via an uponSanitizeShadowNode hook) may detach siblings,
    // and naive nextSibling traversal would silently skip the rest of
    // the list once a node is detached.
    const childNodes = root.childNodes;
    if (!childNodes) {
      return;
    }
    const snapshot = [];
    arrayForEach(childNodes, child => {
      arrayPush(snapshot, child);
    });
    for (const child of snapshot) {
      _sanitizeAttachedShadowRoots2(child);
    }
  };
  // eslint-disable-next-line complexity
  DOMPurify.sanitize = function (dirty) {
    let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let body = null;
    let importedNode = null;
    let currentNode = null;
    let returnNode = null;
    /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */
    IS_EMPTY_INPUT = !dirty;
    if (IS_EMPTY_INPUT) {
      dirty = '<!-->';
    }
    /* Stringify, in case dirty is an object */
    if (typeof dirty !== 'string' && !_isNode(dirty)) {
      dirty = stringifyValue(dirty);
      if (typeof dirty !== 'string') {
        throw typeErrorCreate('dirty is not a string, aborting');
      }
    }
    /* Return dirty HTML if DOMPurify cannot run */
    if (!DOMPurify.isSupported) {
      return dirty;
    }
    /* Assign config vars */
    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }
    /* Clean up removed elements */
    DOMPurify.removed = [];
    /* Check if dirty is correctly typed for IN_PLACE */
    if (typeof dirty === 'string') {
      IN_PLACE = false;
    }
    if (IN_PLACE) {
      /* Do some early pre-sanitization to avoid unsafe root nodes */
      const nn = dirty.nodeName;
      if (typeof nn === 'string') {
        const tagName = transformCaseFunc(nn);
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
        }
      }
      /* Sanitize attached shadow roots before the main iterator runs.
         The iterator does not descend into shadow trees. */
      _sanitizeAttachedShadowRoots2(dirty);
    } else if (_isNode(dirty)) {
      /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */
      body = _initDocument('<!---->');
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') {
        /* Node is already a body, use as is */
        body = importedNode;
      } else if (importedNode.nodeName === 'HTML') {
        body = importedNode;
      } else {
        // eslint-disable-next-line unicorn/prefer-dom-node-append
        body.appendChild(importedNode);
      }
      /* Clonable shadow roots are deep-cloned by importNode(); sanitize
         them before the main iterator runs, since the iterator does not
         descend into shadow trees. */
      _sanitizeAttachedShadowRoots2(importedNode);
    } else {
      /* Exit directly if we have nothing to do */
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
      // eslint-disable-next-line unicorn/prefer-includes
      dirty.indexOf('<') === -1) {
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
      }
      /* Initialize the document to work on */
      body = _initDocument(dirty);
      /* Check we have a DOM node from the data */
      if (!body) {
        return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
      }
    }
    /* Remove first element node (ours) if FORCE_BODY is set */
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }
    /* Get node iterator */
    const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
    /* Now start iterating over the created document */
    while (currentNode = nodeIterator.nextNode()) {
      /* Sanitize tags and elements */
      _sanitizeElements(currentNode);
      /* Check attributes next */
      _sanitizeAttributes(currentNode);
      /* Shadow DOM detected, sanitize it */
      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM2(currentNode.content);
      }
    }
    /* If we sanitized `dirty` in-place, return it. */
    if (IN_PLACE) {
      if (SAFE_FOR_TEMPLATES) {
        _scrubTemplateExpressions(dirty);
      }
      return dirty;
    }
    /* Return sanitized string or DOM */
    if (RETURN_DOM) {
      if (SAFE_FOR_TEMPLATES) {
        _scrubTemplateExpressions(body);
      }
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);
        while (body.firstChild) {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }
      if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
        /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */
        returnNode = importNode.call(originalDocument, returnNode, true);
      }
      return returnNode;
    }
    let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    /* Serialize doctype if allowed */
    if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
      serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
    }
    /* Sanitize final string template-safe */
    if (SAFE_FOR_TEMPLATES) {
      arrayForEach([MUSTACHE_EXPR$1, ERB_EXPR$1, TMPLIT_EXPR$1], expr => {
        serializedHTML = stringReplace(serializedHTML, expr, ' ');
      });
    }
    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
  };
  DOMPurify.setConfig = function () {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _parseConfig(cfg);
    SET_CONFIG = true;
  };
  DOMPurify.clearConfig = function () {
    CONFIG = null;
    SET_CONFIG = false;
  };
  DOMPurify.isValidAttribute = function (tag, attr, value) {
    /* Initialize shared config vars if necessary. */
    if (!CONFIG) {
      _parseConfig({});
    }
    const lcTag = transformCaseFunc(tag);
    const lcName = transformCaseFunc(attr);
    return _isValidAttribute(lcTag, lcName, value);
  };
  DOMPurify.addHook = function (entryPoint, hookFunction) {
    if (typeof hookFunction !== 'function') {
      return;
    }
    arrayPush(hooks[entryPoint], hookFunction);
  };
  DOMPurify.removeHook = function (entryPoint, hookFunction) {
    if (hookFunction !== undefined) {
      const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
      return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
    }
    return arrayPop(hooks[entryPoint]);
  };
  DOMPurify.removeHooks = function (entryPoint) {
    hooks[entryPoint] = [];
  };
  DOMPurify.removeAllHooks = function () {
    hooks = purify_es_createHooksMap();
  };
  return DOMPurify;
}
var purify = createDOMPurify();


//# sourceMappingURL=purify.es.mjs.map

;// CONCATENATED MODULE: ./src/headless/utils/html.js



/**
 * @param {unknown} el
 * @returns {boolean}
 */
function isElement(el) {
    return el instanceof Element || el instanceof HTMLDocument;
}

const EMPTY_TEXT_REGEX = /\s*\n\s*/;

/**
 * @param {Element|Builder|Stanza} el
 */
function stripEmptyTextNodes(el) {
    if (el instanceof Builder || el instanceof Stanza) {
        el = el.tree();
    }

    let n;
    const text_nodes = [];
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, (node) => {
        if (node.parentElement.nodeName.toLowerCase() === 'body') {
            return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
    });
    while ((n = walker.nextNode())) text_nodes.push(n);
    text_nodes.forEach((n) => EMPTY_TEXT_REGEX.test(/** @type {Text} */ (n).data) && n.parentElement.removeChild(n));

    return el;
}

/**
 * Given two XML or HTML elements, determine if they're equal
 * @param {Element} actual
 * @param {Element} expected
 * @returns {Boolean}
 */
function isEqualNode(actual, expected) {
    if (!isElement(actual)) {
        if (actual instanceof Strophe.Builder) {
            actual = actual.tree();
        } else {
            throw new Error('Element being compared must be an Element!');
        }
    }

    expected = stripEmptyTextNodes(expected);
    actual = stripEmptyTextNodes(actual);

    let isEqual = actual.isEqualNode(expected);

    if (!isEqual) {
        // XXX: This is a hack.
        // When creating two XML elements, one via DOMParser, and one via
        // createElementNS (or createElement), then "isEqualNode" doesn't match.
        //
        // For example, in the following code `isEqual` is false:
        // ------------------------------------------------------
        // const a = document.createElementNS('foo', 'div');
        // a.setAttribute('xmlns', 'foo');
        //
        // const b = (new DOMParser()).parseFromString('<div xmlns="foo"></div>', 'text/xml').firstElementChild;
        // const isEqual = a.isEqualNode(div); //  false
        //
        // The workaround here is to serialize both elements to string and then use
        // DOMParser again for both (via xmlHtmlNode).
        //
        // This is not efficient, but currently this is only being used in tests.
        //
        const { xmlHtmlNode } = Strophe;
        const actual_string = Strophe.serialize(actual);
        const expected_string = Strophe.serialize(expected);
        isEqual =
            actual_string === expected_string || xmlHtmlNode(actual_string).isEqualNode(xmlHtmlNode(expected_string));
    }
    return isEqual;
}

/**
 * @param {Element | typeof Strophe.Builder} stanza
 * @param {string} name
 * @returns {boolean}
 */
function html_isTagEqual(stanza, name) {
    if (stanza instanceof Strophe.Builder) {
        return html_isTagEqual(stanza.tree(), name);
    } else if (!(stanza instanceof Element)) {
        throw Error("isTagEqual called with value which isn't " + 'an element or Strophe.Builder instance');
    } else {
        return Strophe.isTagEqual(stanza, name);
    }
}

/**
 * Converts an HTML string into a DOM element.
 * Expects that the HTML string has only one top-level element,
 * i.e. not multiple ones.
 * @method u#stringToElement
 * @param {string} s - The HTML string
 */
function stringToElement(s) {
    var div = document.createElement('div');
    div.innerHTML = s;
    return div.firstElementChild;
}

/**
 * Returns a list of children of the DOM element that match the selector.
 * @method u#queryChildren
 * @param {HTMLElement} el - the DOM element
 * @param {string} selector - the selector they should be matched against
 */
function queryChildren(el, selector) {
    return Array.from(el.childNodes).filter((el) => el instanceof Element && el.matches(selector));
}

/**
 * @param {Element} el - the DOM element
 * @return {number}
 */
function siblingIndex(el) {
    /* eslint-disable no-cond-assign */
    for (var i = 0; (el = el.previousElementSibling); i++);
    return i;
}

const html_element = document.createElement('div');

/**
 * @param {string} str
 * @return {string}
 */
function decodeHTMLEntities(str) {
    if (str && typeof str === 'string') {
        html_element.innerHTML = purify.sanitize(str);
        str = html_element.textContent;
        html_element.textContent = '';
    }
    return str;
}

/**
 * Helper method that replace HTML-escaped symbols with equivalent characters
 * (e.g. transform occurrences of '&amp;' to '&')
 * @param {string} string - a String containing the HTML-escaped symbols.
 * @return {string}
 */
function unescapeHTML (string) {
    var div = document.createElement('div');
    div.innerHTML = string;
    return div.innerText;
}

;// CONCATENATED MODULE: ./src/headless/utils/stanza.js







/**
 * @param {Element} stanza
 * @returns {boolean}
 */
function isErrorStanza (stanza) {
    if (!isElement(stanza)) {
        return false;
    }
    return stanza.getAttribute('type') === 'error';
}

/**
 * @param {Element} stanza
 * @returns {boolean}
 */
function isForbiddenError (stanza) {
    if (!isElement(stanza)) {
        return false;
    }
    return sizzle_default()(`error[type="auth"] forbidden[xmlns="${Strophe.NS.STANZAS}"]`, stanza).length > 0;
}

/**
 * @param {Element} stanza
 * @returns {boolean}
 */
function isServiceUnavailableError (stanza) {
    if (!isElement(stanza)) {
        return false;
    }
    return sizzle_default()(`error[type="cancel"] service-unavailable[xmlns="${Strophe.NS.STANZAS}"]`, stanza).length > 0;
}

/**
 * Returns an object containing all attribute names and values for a particular element.
 * @param {Element} stanza
 * @returns {object}
 */
function getAttributes (stanza) {
    return stanza.getAttributeNames().reduce((acc, name) => {
        acc[name] = Strophe.xmlunescape(stanza.getAttribute(name));
        return acc;
    }, {});
}

// EXTERNAL MODULE: ./node_modules/sprintf-js/src/sprintf.js
var sprintf = __webpack_require__(604);
;// CONCATENATED MODULE: ./src/headless/shared/i18n.js


/**
 * @namespace i18n
 */
const i18nStub = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    async initialize () {},

    /**
     * Overridable string wrapper method which can be used to provide i18n
     * support.
     *
     * The default implementation in @converse/headless simply calls sprintf
     * with the passed in arguments.
     *
     * If you install the full version of Converse, then this method gets
     * overwritten in src/i18n/index.js to return a translated string.
     * @method __
     * @private
     * @memberOf i18n
     */
    __ (...args) {
        return (0,sprintf.sprintf)(...args);
    }
};

/* export default */ const i18n = (i18nStub);

;// CONCATENATED MODULE: ./node_modules/pluggable.js/src/pluggable.js
/*
       ____  __                        __    __         _
      / __ \/ /_  __ ___   ___  ____ _/ /_  / /__      (_)____
     / /_/ / / / / / __ \/ __ \/ __/ / __ \/ / _ \    / / ___/
    / ____/ / /_/ / /_/ / /_/ / /_/ / /_/ / /  __/   / (__  )
   /_/   /_/\__,_/\__, /\__, /\__/_/_.___/_/\___(_)_/ /____/
                 /____//____/                    /___/
 */

// Pluggable.js lets you to make your Javascript code pluggable while still
// keeping sensitive objects and data private through closures.


// `wrappedOverride` creates a partially applied wrapper function
// that makes sure to set the proper super method when the
// overriding method is called. This is done to enable
// chaining of plugin methods, all the way up to the
// original method.
function wrappedOverride (key, value, super_method, default_super, ...args) {
    if (typeof super_method === "function") {
        if (typeof this.__super__ === "undefined") {
            /* We're not on the context of the plugged object.
             * This can happen when the overridden method is called via
             * an event handler or when it's a constructor.
             *
             * In this case, we simply tack on the  __super__ obj.
             */
            this.__super__ = default_super;
        }
        this.__super__[key] = super_method.bind(this);
    }
    return value.apply(this, args);
}


// The `PluginSocket` class contains the plugin architecture, and gets
// created whenever `pluggable.enable(obj);` is called on the object
// that you want to make pluggable.
// You can also see it as the thing into which the plugins are plugged.
// It takes two parameters, first, the object being made pluggable, and
// then the name by which the pluggable object may be referenced on the
// __super__ object (inside overrides).
class PluginSocket {

    constructor (plugged, name) {
        this.name = name;
        this.plugged = plugged;
        if (typeof this.plugged.__super__ === 'undefined') {
            this.plugged.__super__ = {};
        } else if (typeof this.plugged.__super__ === 'string') {
            this.plugged.__super__ = { '__string__': this.plugged.__super__ };
        }
        this.plugged.__super__[name] = this.plugged;
        this.plugins = {};
        this.initialized_plugins = [];
    }

    // `_overrideAttribute` overrides an attribute on the original object
    // (the thing being plugged into).
    //
    // If the attribute being overridden is a function, then the original
    // function will still be available via the `__super__` attribute.
    //
    // If the same function is being overridden multiple times, then
    // the original function will be available at the end of a chain of
    // functions, starting from the most recent override, all the way
    // back to the original function, each being referenced by the
    // previous' __super__ attribute.
    //
    // For example:
    //
    // `plugin2.MyFunc.__super__.myFunc => plugin1.MyFunc.__super__.myFunc => original.myFunc`
    _overrideAttribute (key, plugin) {
        const value = plugin.overrides[key];
        if (typeof value === "function") {
            const default_super = {};
            default_super[this.name] = this.plugged;
            const super_method = this.plugged[key];
            this.plugged[key] = function (...args) {
                return wrappedOverride.apply(this, [key, value, super_method,  default_super, ...args]);
            }
        } else {
            this.plugged[key] = value;
        }
    }

    _extendObject (obj, attributes) {
        if (!obj.prototype.__super__) {
            obj.prototype.__super__ = {};
            obj.prototype.__super__[this.name] = this.plugged;
        }
        for (const [key, value] of Object.entries(attributes)) {
            if (key === 'events') {
                obj.prototype[key] = Object.assign(value, obj.prototype[key]);
            } else if (typeof value === 'function') {
                // We create a partially applied wrapper function, that
                // makes sure to set the proper super method when the
                // overriding method is called. This is done to enable
                // chaining of plugin methods, all the way up to the
                // original method.
                const default_super = {};
                default_super[this.name] = this.plugged;
                const super_method = obj.prototype[key];
                obj.prototype[key] = function (...args) {
                    return wrappedOverride.apply(this, [key, value, super_method, default_super, ...args]);
                }
            } else {
                obj.prototype[key] = value;
            }
        }
    }

    // Plugins can specify dependencies (by means of the
    // `dependencies` list attribute) which refers to dependencies
    // which will be initialized first, before the plugin itself gets initialized.
    //
    // If `strict_plugin_dependencies` is set to `false` (on the object being
    // made pluggable), then no error will be thrown if any of these plugins aren't
    // available.
    loadPluginDependencies (plugin) {
        plugin.dependencies?.forEach(name => {
            const dep = this.plugins[name];
            if (dep) {
                if (dep.dependencies?.includes(plugin.__name__)) {
                    /* FIXME: circular dependency checking is only one level deep. */
                    throw "Found a circular dependency between the plugins \""+
                        plugin.__name__+"\" and \""+name+"\"";
                }
                this.initializePlugin(dep);
            } else {
                this.throwUndefinedDependencyError(
                    "Could not find dependency \""+name+"\" "+
                    "for the plugin \""+plugin.__name__+"\". "+
                    "If it's needed, make sure it's loaded by require.js");
            }
        });
    }

    throwUndefinedDependencyError (msg) {
        if (this.plugged.strict_plugin_dependencies) {
            throw msg;
        } else {
            if (console.warn) {
                console.warn(msg);
            } else {
                console.log(msg);
            }
        }
    }

    // `applyOverrides` is called by initializePlugin. It applies any
    // and all overrides of methods or Backbone views and models that
    // are defined on any of the plugins.
    applyOverrides (plugin) {
        Object.keys(plugin.overrides || {}).forEach(key => {
            const override = plugin.overrides[key];
            if (typeof override === "object") {
                if (typeof this.plugged[key] === 'undefined') {
                    this.throwUndefinedDependencyError(
                        `Plugin "${plugin.__name__}" tried to override "${key}" but it's not found.`);
                } else {
                    this._extendObject(this.plugged[key], override);
                }
            } else {
                this._overrideAttribute(key, plugin);
            }
        });
    }

    // `initializePlugin` applies the overrides (if any) defined on all
    // the registered plugins and then calls the initialize method of the plugin
    initializePlugin (plugin) {
        if (!Object.keys(this.allowed_plugins).includes(plugin.__name__)) {
            /* Don't initialize disallowed plugins. */
            return;
        }
        if (this.initialized_plugins.includes(plugin.__name__)) {
            /* Don't initialize plugins twice, otherwise we get
            * infinite recursion in overridden methods.
            */
            return;
        }
        if (typeof plugin.enabled === 'boolean' && plugin.enabled ||
            plugin.enabled?.(this.plugged) ||
            plugin.enabled == null) { // isNil

            Object.assign(plugin, this.properties);
            if (plugin.dependencies) {
                this.loadPluginDependencies(plugin);
            }
            this.applyOverrides(plugin);
            if (typeof plugin.initialize === "function") {
                plugin.initialize.bind(plugin)(this);
            }
            this.initialized_plugins.push(plugin.__name__);
        }
    }

    // `registerPlugin` registers (or inserts, if you'd like) a plugin,
    // by adding it to the `plugins` map on the PluginSocket instance.
    registerPlugin (name, plugin) {
        if (name in this.plugins) {
            throw new Error('Error: Plugin name '+name+' is already taken');
        }
        plugin.__name__ = name;
        this.plugins[name] = plugin;
    }

    // `initializePlugins` should get called once all plugins have been
    // registered. It will then iterate through all the plugins, calling
    // `initializePlugin` for each.
    // The passed in  properties variable is an object with attributes and methods
    // which will be attached to the plugins.
    initializePlugins (properties={}, whitelist=[], blacklist=[]) {
        if (!Object.keys(this.plugins).length) {
            return;
        }
        this.properties = properties;
        this.allowed_plugins = {};

        for (const [key, plugin] of Object.entries(this.plugins)) {
            if ((!whitelist.length || whitelist.includes(key)) && !blacklist.includes(key)) {
                this.allowed_plugins[key] = plugin;
            }
        }
        Object.values(this.allowed_plugins).forEach(o => this.initializePlugin(o));
    }
}

function enable (object, name, attrname) {
    // Call the `enable` method to make an object pluggable
    //
    // It takes three parameters:
    // - `object`: The object that gets made pluggable.
    // - `name`: The string name by which the now pluggable object
    //     may be referenced on the __super__ obj (in overrides).
    //     The default value is "plugged".
    // - `attrname`: The string name of the attribute on the now
    //     pluggable object, which refers to the PluginSocket instance
    //     that gets created.
    if (typeof attrname === "undefined") {
        attrname = "pluginSocket";
    }
    if (typeof name === 'undefined') {
        name = 'plugged';
    }
    object[attrname] = new PluginSocket(object, name);
    return object;
}


/* export default */ const src_pluggable = ({
    enable
});

// EXTERNAL MODULE: ./node_modules/@converse/skeletor/dist/skeletor.js
var skeletor = __webpack_require__(154);
;// CONCATENATED MODULE: ./node_modules/@converse/openpromise/dist/openpromise.js
function getOpenPromise() {
    const wrapper = {
        isResolved: false,
        isPending: true,
        isRejected: false
    };
    let promise;
    let resolve = () => { };
    let reject = () => { };
    if (typeof Promise.withResolvers === 'function') {
        const { promise: p, resolve: r, reject: j } = Promise.withResolvers();
        promise = p;
        resolve = r;
        reject = j;
    }
    else {
        promise = new Promise((r, j) => {
            resolve = r;
            reject = j;
        });
    }
    Object.assign(promise, {
        ...wrapper,
        resolve,
        reject
    });
    promise.then((v) => {
        promise.isResolved = true;
        promise.isPending = false;
        promise.isRejected = false;
        return v;
    }, (e) => {
        promise.isResolved = false;
        promise.isPending = false;
        promise.isRejected = true;
        throw e;
    });
    return promise;
}
//# sourceMappingURL=openpromise.js.map
;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* export default */ const _listCacheClear = (listCacheClear);

;// CONCATENATED MODULE: ./node_modules/lodash-es/eq.js
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* export default */ const lodash_es_eq = (eq);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (lodash_es_eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* export default */ const _assocIndexOf = (assocIndexOf);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* export default */ const _listCacheDelete = (listCacheDelete);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* export default */ const _listCacheGet = (listCacheGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* export default */ const _listCacheHas = (listCacheHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* export default */ const _listCacheSet = (listCacheSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

/* export default */ const _ListCache = (ListCache);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackClear.js


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

/* export default */ const _stackClear = (stackClear);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackDelete.js
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* export default */ const _stackDelete = (stackDelete);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackGet.js
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* export default */ const _stackGet = (stackGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackHas.js
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* export default */ const _stackHas = (stackHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_freeGlobal.js
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* export default */ const _freeGlobal = (freeGlobal);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_root.js


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var _root_root = _freeGlobal || freeSelf || Function('return this')();

/* export default */ const _root = (_root_root);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var _Symbol_Symbol = _root.Symbol;

/* export default */ const _Symbol = (_Symbol_Symbol);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* export default */ const _getRawTag = (getRawTag);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function _objectToString_objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* export default */ const _objectToString = (_objectToString_objectToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* export default */ const _baseGetTag = (baseGetTag);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isObject.js
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* export default */ const lodash_es_isObject = (isObject);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isFunction.js



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!lodash_es_isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* export default */ const lodash_es_isFunction = (isFunction);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_coreJsData.js


/** Used to detect overreaching core-js shims. */
var coreJsData = _root["__core-js_shared__"];

/* export default */ const _coreJsData = (coreJsData);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isMasked.js


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* export default */ const _isMasked = (isMasked);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_toSource.js
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* export default */ const _toSource = (toSource);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsNative.js





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var _baseIsNative_funcProto = Function.prototype,
    _baseIsNative_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var _baseIsNative_funcToString = _baseIsNative_funcProto.toString;

/** Used to check objects for own properties. */
var _baseIsNative_hasOwnProperty = _baseIsNative_objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  _baseIsNative_funcToString.call(_baseIsNative_hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!lodash_es_isObject(value) || _isMasked(value)) {
    return false;
  }
  var pattern = lodash_es_isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

/* export default */ const _baseIsNative = (baseIsNative);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getValue.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* export default */ const _getValue = (getValue);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getNative.js



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

/* export default */ const _getNative = (getNative);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Map.js



/* Built-in method references that are verified to be native. */
var _Map_Map = _getNative(_root, 'Map');

/* export default */ const _Map = (_Map_Map);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

/* export default */ const _nativeCreate = (nativeCreate);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* export default */ const _hashClear = (hashClear);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* export default */ const _hashDelete = (hashDelete);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var _hashGet_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = _hashGet_objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* export default */ const _hashGet = (hashGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : _hashHas_hasOwnProperty.call(data, key);
}

/* export default */ const _hashHas = (hashHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* export default */ const _hashSet = (hashSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

/* export default */ const _Hash = (Hash);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

/* export default */ const _mapCacheClear = (mapCacheClear);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* export default */ const _isKeyable = (isKeyable);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* export default */ const _getMapData = (getMapData);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* export default */ const _mapCacheDelete = (mapCacheDelete);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* export default */ const _mapCacheGet = (mapCacheGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* export default */ const _mapCacheHas = (mapCacheHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* export default */ const _mapCacheSet = (mapCacheSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

/* export default */ const _MapCache = (MapCache);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackSet.js




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* export default */ const _stackSet = (stackSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Stack.js







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

/* export default */ const _Stack = (Stack);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_setCacheAdd.js
/** Used to stand-in for `undefined` hash values. */
var _setCacheAdd_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, _setCacheAdd_HASH_UNDEFINED);
  return this;
}

/* export default */ const _setCacheAdd = (setCacheAdd);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_setCacheHas.js
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* export default */ const _setCacheHas = (setCacheHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_SetCache.js




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

/* export default */ const _SetCache = (SetCache);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arraySome.js
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* export default */ const _arraySome = (arraySome);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_cacheHas.js
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* export default */ const _cacheHas = (cacheHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_equalArrays.js




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* export default */ const _equalArrays = (equalArrays);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Uint8Array.js


/** Built-in value references. */
var _Uint8Array_Uint8Array = _root.Uint8Array;

/* export default */ const _Uint8Array = (_Uint8Array_Uint8Array);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapToArray.js
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* export default */ const _mapToArray = (mapToArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_setToArray.js
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* export default */ const _setToArray = (setToArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_equalByTag.js







/** Used to compose bitmasks for value comparisons. */
var _equalByTag_COMPARE_PARTIAL_FLAG = 1,
    _equalByTag_COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return lodash_es_eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = _mapToArray;

    case setTag:
      var isPartial = bitmask & _equalByTag_COMPARE_PARTIAL_FLAG;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= _equalByTag_COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* export default */ const _equalByTag = (equalByTag);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayPush.js
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function _arrayPush_arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* export default */ const _arrayPush = (_arrayPush_arrayPush);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isArray.js
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* export default */ const lodash_es_isArray = (isArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetAllKeys.js



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return lodash_es_isArray(object) ? result : _arrayPush(result, symbolsFunc(object));
}

/* export default */ const _baseGetAllKeys = (baseGetAllKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayFilter.js
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* export default */ const _arrayFilter = (arrayFilter);

;// CONCATENATED MODULE: ./node_modules/lodash-es/stubArray.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* export default */ const lodash_es_stubArray = (stubArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getSymbols.js



/** Used for built-in method references. */
var _getSymbols_objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = _getSymbols_objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? lodash_es_stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* export default */ const _getSymbols = (getSymbols);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseTimes.js
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* export default */ const _baseTimes = (baseTimes);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* export default */ const lodash_es_isObjectLike = (isObjectLike);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsArguments.js



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return lodash_es_isObjectLike(value) && _baseGetTag(value) == argsTag;
}

/* export default */ const _baseIsArguments = (baseIsArguments);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isArguments.js



/** Used for built-in method references. */
var isArguments_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isArguments_hasOwnProperty = isArguments_objectProto.hasOwnProperty;

/** Built-in value references. */
var isArguments_propertyIsEnumerable = isArguments_objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return lodash_es_isObjectLike(value) && isArguments_hasOwnProperty.call(value, 'callee') &&
    !isArguments_propertyIsEnumerable.call(value, 'callee');
};

/* export default */ const lodash_es_isArguments = (isArguments);

;// CONCATENATED MODULE: ./node_modules/lodash-es/stubFalse.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* export default */ const lodash_es_stubFalse = (stubFalse);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isBuffer.js



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || lodash_es_stubFalse;

/* export default */ const lodash_es_isBuffer = (isBuffer);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isIndex.js
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* export default */ const _isIndex = (isIndex);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isLength.js
/** Used as references for various `Number` constants. */
var isLength_MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= isLength_MAX_SAFE_INTEGER;
}

/* export default */ const lodash_es_isLength = (isLength);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsTypedArray.js




/** `Object#toString` result references. */
var _baseIsTypedArray_argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    _baseIsTypedArray_boolTag = '[object Boolean]',
    _baseIsTypedArray_dateTag = '[object Date]',
    _baseIsTypedArray_errorTag = '[object Error]',
    _baseIsTypedArray_funcTag = '[object Function]',
    _baseIsTypedArray_mapTag = '[object Map]',
    _baseIsTypedArray_numberTag = '[object Number]',
    objectTag = '[object Object]',
    _baseIsTypedArray_regexpTag = '[object RegExp]',
    _baseIsTypedArray_setTag = '[object Set]',
    _baseIsTypedArray_stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var _baseIsTypedArray_arrayBufferTag = '[object ArrayBuffer]',
    _baseIsTypedArray_dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[_baseIsTypedArray_argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[_baseIsTypedArray_arrayBufferTag] = typedArrayTags[_baseIsTypedArray_boolTag] =
typedArrayTags[_baseIsTypedArray_dataViewTag] = typedArrayTags[_baseIsTypedArray_dateTag] =
typedArrayTags[_baseIsTypedArray_errorTag] = typedArrayTags[_baseIsTypedArray_funcTag] =
typedArrayTags[_baseIsTypedArray_mapTag] = typedArrayTags[_baseIsTypedArray_numberTag] =
typedArrayTags[objectTag] = typedArrayTags[_baseIsTypedArray_regexpTag] =
typedArrayTags[_baseIsTypedArray_setTag] = typedArrayTags[_baseIsTypedArray_stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return lodash_es_isObjectLike(value) &&
    lodash_es_isLength(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

/* export default */ const _baseIsTypedArray = (baseIsTypedArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseUnary.js
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* export default */ const _baseUnary = (baseUnary);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_nodeUtil.js


/** Detect free variable `exports`. */
var _nodeUtil_freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var _nodeUtil_freeModule = _nodeUtil_freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var _nodeUtil_moduleExports = _nodeUtil_freeModule && _nodeUtil_freeModule.exports === _nodeUtil_freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = _nodeUtil_moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = _nodeUtil_freeModule && _nodeUtil_freeModule.require && _nodeUtil_freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* export default */ const _nodeUtil = (nodeUtil);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isTypedArray.js




/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

/* export default */ const lodash_es_isTypedArray = (isTypedArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayLikeKeys.js







/** Used for built-in method references. */
var _arrayLikeKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _arrayLikeKeys_hasOwnProperty = _arrayLikeKeys_objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = lodash_es_isArray(value),
      isArg = !isArr && lodash_es_isArguments(value),
      isBuff = !isArr && !isArg && lodash_es_isBuffer(value),
      isType = !isArr && !isArg && !isBuff && lodash_es_isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || _arrayLikeKeys_hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* export default */ const _arrayLikeKeys = (arrayLikeKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isPrototype.js
/** Used for built-in method references. */
var _isPrototype_objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || _isPrototype_objectProto;

  return value === proto;
}

/* export default */ const _isPrototype = (isPrototype);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* export default */ const _overArg = (overArg);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

/* export default */ const _nativeKeys = (nativeKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseKeys.js



/** Used for built-in method references. */
var _baseKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeys_hasOwnProperty = _baseKeys_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (_baseKeys_hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* export default */ const _baseKeys = (baseKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isArrayLike.js



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && lodash_es_isLength(value.length) && !lodash_es_isFunction(value);
}

/* export default */ const lodash_es_isArrayLike = (isArrayLike);

;// CONCATENATED MODULE: ./node_modules/lodash-es/keys.js




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys_keys(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

/* export default */ const lodash_es_keys = (keys_keys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getAllKeys.js




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, lodash_es_keys, _getSymbols);
}

/* export default */ const _getAllKeys = (getAllKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_equalObjects.js


/** Used to compose bitmasks for value comparisons. */
var _equalObjects_COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var _equalObjects_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _equalObjects_hasOwnProperty = _equalObjects_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & _equalObjects_COMPARE_PARTIAL_FLAG,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : _equalObjects_hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* export default */ const _equalObjects = (equalObjects);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_DataView.js



/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

/* export default */ const _DataView = (DataView);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Promise.js



/* Built-in method references that are verified to be native. */
var _Promise_Promise = _getNative(_root, 'Promise');

/* export default */ const _Promise = (_Promise_Promise);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Set.js



/* Built-in method references that are verified to be native. */
var _Set_Set = _getNative(_root, 'Set');

/* export default */ const _Set = (_Set_Set);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_WeakMap.js



/* Built-in method references that are verified to be native. */
var _WeakMap_WeakMap = _getNative(_root, 'WeakMap');

/* export default */ const _WeakMap = (_WeakMap_WeakMap);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getTag.js








/** `Object#toString` result references. */
var _getTag_mapTag = '[object Map]',
    _getTag_objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    _getTag_setTag = '[object Set]',
    _getTag_weakMapTag = '[object WeakMap]';

var _getTag_dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != _getTag_dataViewTag) ||
    (_Map && getTag(new _Map) != _getTag_mapTag) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != _getTag_setTag) ||
    (_WeakMap && getTag(new _WeakMap) != _getTag_weakMapTag)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == _getTag_objectTag ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return _getTag_dataViewTag;
        case mapCtorString: return _getTag_mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return _getTag_setTag;
        case weakMapCtorString: return _getTag_weakMapTag;
      }
    }
    return result;
  };
}

/* export default */ const _getTag = (getTag);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsEqualDeep.js









/** Used to compose bitmasks for value comparisons. */
var _baseIsEqualDeep_COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var _baseIsEqualDeep_argsTag = '[object Arguments]',
    _baseIsEqualDeep_arrayTag = '[object Array]',
    _baseIsEqualDeep_objectTag = '[object Object]';

/** Used for built-in method references. */
var _baseIsEqualDeep_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseIsEqualDeep_hasOwnProperty = _baseIsEqualDeep_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = lodash_es_isArray(object),
      othIsArr = lodash_es_isArray(other),
      objTag = objIsArr ? _baseIsEqualDeep_arrayTag : _getTag(object),
      othTag = othIsArr ? _baseIsEqualDeep_arrayTag : _getTag(other);

  objTag = objTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : objTag;
  othTag = othTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : othTag;

  var objIsObj = objTag == _baseIsEqualDeep_objectTag,
      othIsObj = othTag == _baseIsEqualDeep_objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && lodash_es_isBuffer(object)) {
    if (!lodash_es_isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || lodash_es_isTypedArray(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & _baseIsEqualDeep_COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && _baseIsEqualDeep_hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && _baseIsEqualDeep_hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/* export default */ const _baseIsEqualDeep = (baseIsEqualDeep);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsEqual.js



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!lodash_es_isObjectLike(value) && !lodash_es_isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* export default */ const _baseIsEqual = (baseIsEqual);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isEqual.js


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual_isEqual(value, other) {
  return _baseIsEqual(value, other);
}

/* export default */ const lodash_es_isEqual = (isEqual_isEqual);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isSymbol.js



/** `Object#toString` result references. */
var isSymbol_symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (lodash_es_isObjectLike(value) && _baseGetTag(value) == isSymbol_symbolTag);
}

/* export default */ const lodash_es_isSymbol = (isSymbol);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isKey.js



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (lodash_es_isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || lodash_es_isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* export default */ const _isKey = (isKey);

;// CONCATENATED MODULE: ./node_modules/lodash-es/memoize.js


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

/* export default */ const lodash_es_memoize = (memoize);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = lodash_es_memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* export default */ const _memoizeCapped = (memoizeCapped);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* export default */ const _stringToPath = (stringToPath);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayMap.js
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* export default */ const _arrayMap = (arrayMap);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseToString.js





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var _baseToString_symbolProto = _Symbol ? _Symbol.prototype : undefined,
    _baseToString_symbolToString = _baseToString_symbolProto ? _baseToString_symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (lodash_es_isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (lodash_es_isSymbol(value)) {
    return _baseToString_symbolToString ? _baseToString_symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* export default */ const _baseToString = (baseToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/toString.js


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString_toString(value) {
  return value == null ? '' : _baseToString(value);
}

/* export default */ const lodash_es_toString = (toString_toString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_castPath.js





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (lodash_es_isArray(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(lodash_es_toString(value));
}

/* export default */ const _castPath = (castPath);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_toKey.js


/** Used as references for various `Number` constants. */
var _toKey_INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || lodash_es_isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -_toKey_INFINITY) ? '-0' : result;
}

/* export default */ const _toKey = (toKey);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGet.js



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* export default */ const _baseGet = (baseGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_defineProperty.js


var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* export default */ const _defineProperty = (defineProperty);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAssignValue.js


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* export default */ const _baseAssignValue = (baseAssignValue);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_assignValue.js



/** Used for built-in method references. */
var _assignValue_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _assignValue_hasOwnProperty = _assignValue_objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(_assignValue_hasOwnProperty.call(object, key) && lodash_es_eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* export default */ const _assignValue = (assignValue);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSet.js






/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!lodash_es_isObject(object)) {
    return object;
  }
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = _toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = lodash_es_isObject(objValue)
          ? objValue
          : (_isIndex(path[index + 1]) ? [] : {});
      }
    }
    _assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/* export default */ const _baseSet = (baseSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_basePickBy.js




/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = _baseGet(object, path);

    if (predicate(value, path)) {
      _baseSet(result, _castPath(path, object), value);
    }
  }
  return result;
}

/* export default */ const _basePickBy = (basePickBy);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseHasIn.js
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* export default */ const _baseHasIn = (baseHasIn);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hasPath.js







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && lodash_es_isLength(length) && _isIndex(key, length) &&
    (lodash_es_isArray(object) || lodash_es_isArguments(object));
}

/* export default */ const _hasPath = (hasPath);

;// CONCATENATED MODULE: ./node_modules/lodash-es/hasIn.js



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

/* export default */ const lodash_es_hasIn = (hasIn);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_basePick.js



/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return _basePickBy(object, paths, function(value, path) {
    return lodash_es_hasIn(object, path);
  });
}

/* export default */ const _basePick = (basePick);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isFlattenable.js




/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return lodash_es_isArray(value) || lodash_es_isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/* export default */ const _isFlattenable = (isFlattenable);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFlatten.js



/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = _isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        _arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/* export default */ const _baseFlatten = (baseFlatten);

;// CONCATENATED MODULE: ./node_modules/lodash-es/flatten.js


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, 1) : [];
}

/* export default */ const lodash_es_flatten = (flatten);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_apply.js
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function _apply_apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* export default */ const _apply = (_apply_apply);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_overRest.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

/* export default */ const _overRest = (overRest);

;// CONCATENATED MODULE: ./node_modules/lodash-es/constant.js
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* export default */ const lodash_es_constant = (constant);

;// CONCATENATED MODULE: ./node_modules/lodash-es/identity.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity_identity(value) {
  return value;
}

/* export default */ const lodash_es_identity = (identity_identity);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSetToString.js




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty ? lodash_es_identity : function(func, string) {
  return _defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': lodash_es_constant(string),
    'writable': true
  });
};

/* export default */ const _baseSetToString = (baseSetToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_shortOut.js
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* export default */ const _shortOut = (shortOut);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_setToString.js



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

/* export default */ const _setToString = (setToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_flatRest.js




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return _setToString(_overRest(func, undefined, lodash_es_flatten), func + '');
}

/* export default */ const _flatRest = (flatRest);

;// CONCATENATED MODULE: ./node_modules/lodash-es/pick.js



/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = _flatRest(function(object, paths) {
  return object == null ? {} : _basePick(object, paths);
});

/* export default */ const lodash_es_pick = (pick);

;// CONCATENATED MODULE: ./src/headless/shared/settings/constants.js
/**
 * @typedef {Object } ConfigurationSettings
 * Converse's core configuration values
 * @property {Boolean} [allow_non_roster_messaging=false]
 * @property {Boolean} [allow_url_history_change=true]
 * @property {String} [assets_path='/dist']
 * @property {('login'|'prebind'|'anonymous'|'external')} [authentication='login']
 * @property {Boolean} [auto_login=false] - Currently only used in connection with anonymous login
 * @property {Boolean} [reuse_scram_keys=true] - Save SCRAM keys after login to allow for future auto login
 * @property {Boolean} [auto_reconnect=true]
 * @property {Array<String>} [blacklisted_plugins]
 * @property {Boolean} [clear_cache_on_logout=false]
 * @property {Object} [connection_options]
 * @property {String} [credentials_url] - URL from where login credentials can be fetched
 * @property {Boolean} [discover_connection_methods=true]
 * @property {RegExp} [geouri_regex]
 * @property {RegExp} [geouri_replacement='https://www.openstreetmap.org/?mlat=$1&mlon=$2#map=18/$1/$2']
 * @property {String} [i18n]
 * @property {String} [jid]
 * @property {Boolean} [keepalive=true]
 * @property {('debug'|'info'|'eror')} [loglevel='info']
 * @property {Array<String>} [locales]
 * @property {String} [nickname]
 * @property {String} [password]
 * @property {('IndexedDB'|'localStorage')} [persistent_store='IndexedDB']
 * @property {String} [rid]
 * @property {Element} [root=window.document]
 * @property {String} [sid]
 * @property {Boolean} [singleton=false]
 * @property {Boolean} [strict_plugin_dependencies=false]
 * @property {('fullscreen'|'embedded'|'overlayed')} [view_mode='fullscreen']
 * @property {String} [websocket_url]
 * @property {Array<String>} [whitelisted_plugins]
 */
const DEFAULT_SETTINGS = {
    allow_non_roster_messaging: true,
    allow_url_history_change: true,
    assets_path: '/dist',
    authentication: 'login', // Available values are "login", "prebind", "anonymous" and "external".
    auto_login: false, // Currently only used in connection with anonymous login
    auto_reconnect: true,
    blacklisted_plugins: [],
    clear_cache_on_logout: false,
    connection_options: {},
    credentials_url: null, // URL from where login credentials can be fetched
    disable_effects: false, // Disabled UI transition effects. Mainly used for tests.
    discover_connection_methods: true,
    embed_3rd_party_media_players: true,
    geouri_regex: /https\:\/\/www.openstreetmap.org\/.*#map=[0-9]+\/([\-0-9.]+)\/([\-0-9.]+)\S*/g,
    geouri_replacement: 'https://www.openstreetmap.org/?mlat=$1&mlon=$2#map=18/$1/$2',
    i18n: undefined,
    jid: undefined,
    reuse_scram_keys: true,
    keepalive: true,
    loglevel: 'info',
    locales: [
        'af',
        'ar',
        'bg',
        'ca',
        'cs',
        'da',
        'de',
        'el',
        'en',
        'eo',
        'es',
        'eu',
        'fa',
        'fi',
        'fr',
        'gl',
        'he',
        'hi',
        'hu',
        'id',
        'it',
        'ja',
        'lt',
        'mn',
        'mr',
        'nb',
        'nl',
        'oc',
        'pl',
        'pt',
        'pt_BR',
        'ro',
        'ru',
        'sv',
        'ta',
        'th',
        'tr',
        'ug',
        'uk',
        'vi',
        'zh_CN',
        'zh_TW',
    ],
    nickname: undefined,
    password: undefined,
    persistent_store: 'IndexedDB',
    rid: undefined,
    root: window.document,
    sid: undefined,
    singleton: false,
    strict_plugin_dependencies: false,
    stanza_timeout: 60000,
    view_mode: 'fullscreen',
    websocket_url: undefined,
    whitelisted_plugins: [],
};

;// CONCATENATED MODULE: ./src/headless/utils/object.js
/**
 * Merge the second object into the first one.
 * @param {Object} dst
 * @param {Object} src
 */
function merge(dst, src) {
    for (const k in src) {
        if (!Object.prototype.hasOwnProperty.call(src, k)) continue;
        if (k === "__proto__" || k === "constructor") continue;

        if (dst[k] instanceof Object) {
            merge(dst[k], src[k]);
        } else {
            dst[k] = src[k];
        }
    }
}

/**
 * @param {unknown} obj - The object to check.
 * @returns {boolean} True if the object is an Error, false otherwise.
 */
function isError(obj) {
    return Object.prototype.toString.call(obj) === "[object Error]";
}

/**
 * @param {unknown} val - The value to check.
 * @returns {boolean} True if the value is a function, false otherwise.
 */
function object_isFunction(val) {
    return typeof val === "function";
}

/**
 * @param {unknown} x - The value to check.
 * @returns {boolean} True if the value is undefined, false otherwise.
 */
function isUndefined(x) {
    return typeof x === "undefined";
}

/**
 * @param {unknown} o - The value to check.
 * @returns {boolean} True if the value is an Error
 */
function isErrorObject(o) {
    return o instanceof Error;
}

/**
 * @param {import('@converse/skeletor').Model} model
 * @returns {import('@converse/skeletor').BrowserStorage}
 */
function isPersistableModel(model) {
    return model.browserStorage || model.collection?.browserStorage;
}

/**
 * Check if an object is empty (null, undefined, not an object, or has no own keys).
 * @param {Object|undefined|null} obj
 * @returns {boolean} True if the object is empty.
 */
function isEmpty(obj) {
    return obj === null || obj === undefined || typeof obj !== 'object' || Object.keys(obj).length === 0;
}

;// CONCATENATED MODULE: ./src/headless/shared/settings/utils.js






let app_settings;
let init_settings = {}; // Container for settings passed in via converse.initialize

class AppSettings extends (0,skeletor.EventEmitter)(Object) {}

function getAppSettings() {
    return app_settings;
}

function initAppSettings(settings) {
    init_settings = settings;

    app_settings = new AppSettings();

    // Allow only whitelisted settings to be overwritten via converse.initialize
    const allowed_settings = lodash_es_pick(settings, Object.keys(DEFAULT_SETTINGS));
    Object.assign(app_settings, DEFAULT_SETTINGS, allowed_settings);
}

function getInitSettings() {
    return init_settings;
}

function getAppSetting(key) {
    if (Object.keys(DEFAULT_SETTINGS).includes(key)) {
        return app_settings[key];
    }
}

function extendAppSettings(settings) {
    merge(DEFAULT_SETTINGS, settings);
    // When updating the settings, we need to avoid overwriting the
    // initialization_settings (i.e. the settings passed in via converse.initialize).
    const allowed_keys = Object.keys(settings).filter((k) => k in DEFAULT_SETTINGS);
    const allowed_site_settings = lodash_es_pick(init_settings, allowed_keys);
    const updated_settings = Object.assign(lodash_es_pick(settings, allowed_keys), allowed_site_settings);
    merge(app_settings, updated_settings);
}

/**
 * @param {string} name
 * @param {Function} func
 * @param {any} context
 */
function registerListener(name, func, context) {
    app_settings.on(name, func, context);
}

/**
 * @param {string} name
 * @param {Function} func
 */
function unregisterListener(name, func) {
    app_settings.off(name, func);
}

/**
 * @param {Object|string} key An object containing config settings or alternatively a string key
 * @param {string} [val] The value, if the previous parameter is a key
 */
function updateAppSettings(key, val) {
    if (key == null) return this; // eslint-disable-line no-eq-null

    let attrs;
    if (key instanceof Object) {
        attrs = key;
    } else if (typeof key === 'string') {
        attrs = {};
        attrs[key] = val;
    }

    const allowed_keys = Object.keys(attrs).filter((k) => k in DEFAULT_SETTINGS);
    const changed = {};
    allowed_keys.forEach((k) => {
        const val = attrs[k];
        if (!lodash_es_isEqual(app_settings[k], val)) {
            changed[k] = val;
            app_settings[k] = val;
        }
    });
    Object.keys(changed).forEach((k) => app_settings.trigger('change:' + k, changed[k]));
    app_settings.trigger('change', changed);
}

;// CONCATENATED MODULE: ./src/headless/shared/settings/api.js
/**
 * @typedef {import('@converse/skeletor').Model} Model
 */


/**
 * This grouping allows access to the
 * [configuration settings](/docs/configuration/#configuration-settings)
 * of Converse.
 *
 * @namespace _converse.api.settings
 * @memberOf _converse.api
 */
const settings_api = {
    /**
     * Allows new configuration settings to be specified, or new default values for
     * existing configuration settings to be specified.
     *
     * Note, calling this method *after* converse.initialize has been
     * called will *not* change the initialization settings provided via
     * `converse.initialize`.
     *
     * @method api.settings.extend
     * @param {object} settings The configuration settings
     * @example
     * api.settings.extend({
     *    'enable_foo': true
     * });
     *
     * // The user can then override the default value of the configuration setting when
     * // calling `converse.initialize`.
     * converse.initialize({
     *     'enable_foo': false
     * });
     */
    extend (settings) {
        return extendAppSettings(settings);
    },

    /**
     * @method _converse.api.settings.get
     * @param {string} [key]
     * @returns {*} Value of the particular configuration setting, or all
     *  settings if no key was specified.
     * @example api.settings.get("play_sounds");
     */
    get (key) {
        return key ? getAppSetting(key) : getAppSettings();
    },

    /**
     * Set one or many configuration settings.
     *
     * Note, this is not an alternative to calling {@link converse.initialize}, which still needs
     * to be called. Generally, you'd use this method after Converse is already
     * running and you want to change the configuration on-the-fly.
     *
     * @method _converse.api.settings.set
     * @param { Object | string } [settings_or_key]
     *  An object containing configuration settings.
     *  Alternatively to passing in an object, you can pass in a key and a value.
     * @param { string } [value]
     * @example api.settings.set("play_sounds", true);
     * @example
     * api.settings.set({
     *     "play_sounds": true,
     *     "hide_offline_users": true
     * });
     */
    set (settings_or_key, value) {
        updateAppSettings(settings_or_key, value);
    },

    /**
     * The `listen` namespace exposes methods for creating event listeners
     * (aka handlers) for events related to settings.
     *
     * @namespace _converse.api.settings.listen
     * @memberOf _converse.api.settings
     */
    listen: {
        /**
         * Register an event listener for the passed in event.
         * @method _converse.api.settings.listen.on
         * @param { ('change') } name - The name of the event to listen for.
         *  Currently there is only the 'change' event.
         * @param { Function } handler - The event handler function
         * @param { Object } [context] - The context of the `this` attribute of the
         *  handler function.
         * @example api.settings.listen.on('change', callback);
         */
        on (name, handler, context) {
            registerListener(name, handler, context);
        },

        /**
         * To stop listening to an event, you can use the `not` method.
         * @method _converse.api.settings.listen.not
         * @param { String } name The event's name
         * @param { Function } handler The callback method that is to no longer be called when the event fires
         * @example api.settings.listen.not('change', callback);
         */
        not (name, handler) {
            unregisterListener(name, handler);
        }
    }
};

;// CONCATENATED MODULE: ./src/headless/utils/session.js
/**
 * @typedef {module:shared-api-public.ConversePrivateGlobal} ConversePrivateGlobal
 */





const session_settings = settings_api;

/**
 * We distinguish between UniView and MultiView instances.
 *
 * UniView means that only one chat is visible, even though there might be multiple ongoing chats.
 * MultiView means that multiple chats may be visible simultaneously.
 */
function isUniView () {
    return ['fullscreen', 'embedded'].includes(session_settings.get("view_mode"));
}

function isTestEnv () {
    return getInitSettings()['bosh_service_url'] === 'montague.lit/http-bind';
}

function getUnloadEvent () {
    if ('onpagehide' in window) {
        // Pagehide gets thrown in more cases than unload. Specifically it
        // gets thrown when the page is cached and not just
        // closed/destroyed. It's the only viable event on mobile Safari.
        // https://www.webkit.org/blog/516/webkit-page-cache-ii-the-unload-event/
        return 'pagehide';
    } else if ('onbeforeunload' in window) {
        return 'beforeunload';
    }
    return 'unload';
}

/**
 * @param {ConversePrivateGlobal} _converse
 * @param {string} name
 */
function replacePromise (_converse, name) {
    const existing_promise = _converse.promises[name];
    if (!existing_promise) {
        throw new Error(`Tried to replace non-existing promise: ${name}`);
    }
    if (existing_promise.replace) {
        /** @type {import('../shared/types').ReplaceableOpenPromise} */
        const promise = getOpenPromise();
        promise.replace = existing_promise.replace;
        _converse.promises[name] = promise;
    } else {
        src_log.debug(`Not replacing promise "${name}"`);
    }
}

/**
 * @param {ConversePrivateGlobal} _converse
 * @returns {boolean}
 */
function shouldClearCache (_converse) {
    const { api } = _converse;
    return !_converse.state.config.get('trusted') ||
        api.settings.get('clear_cache_on_logout') ||
        isTestEnv();
}

/**
 * @param {ConversePrivateGlobal} _converse
 */
async function tearDown (_converse) {
    const { api } = _converse;
    await api.trigger('beforeTearDown', {'synchronous': true});
    api.trigger('afterTearDown');
    return _converse;
}

/**
 * @param {ConversePrivateGlobal} _converse
 */
function clearSession (_converse) {
    if (shouldClearCache(_converse)) {
        _converse.api.user.settings.clear();
        _converse.state.login_info?.destroy();
    }
    _converse.initSession();
    /**
     * Synchronouse event triggered once the user session has been cleared,
     * for example when the user has logged out or when Converse has
     * disconnected for some other reason.
     * @event _converse#clearSession
     */
    return _converse.api.trigger('clearSession', {'synchronous': true});
}

;// CONCATENATED MODULE: ./src/headless/shared/constants.js


const BOSH_WAIT = 59;
const VERSION_NAME = "v13.0.0";

const PRES_SHOW_VALUES = ['chat', 'dnd', 'away', 'xa'];
const PRES_TYPE_VALUES = [
    'available',
    'unavailable',
    'error',
    'probe',
    'subscribe',
    'subscribed',
    'unsubscribe',
    'unsubscribed',
];

const STATUS_WEIGHTS = {
    offline: 6,
    unavailable: 5,
    xa: 4,
    away: 3,
    dnd: 2,
    chat: 1, // We don't differentiate between "chat" and "online"
    online: 1,
};

const METADATA_ATTRIBUTES = [
    "og:article:author",
    "og:article:published_time",
    "og:description",
    "og:image",
    "og:image:height",
    "og:image:width",
    "og:site_name",
    "og:title",
    "og:type",
    "og:url",
    "og:video:height",
    "og:video:secure_url",
    "og:video:tag",
    "og:video:type",
    "og:video:url",
    "og:video:width"
];

const ANONYMOUS = 'anonymous';
const CLOSED = 'closed';
const EXTERNAL = 'external';
const LOGIN = 'login';
const LOGOUT = 'logout';
const OPENED = 'opened';
const PREBIND = 'prebind';
const SUCCESS = 'success';
const FAILURE = 'failure';

// XEP-0085 Chat states
// https =//xmpp.org/extensions/xep-0085.html
const INACTIVE = 'inactive';
const ACTIVE = 'active';
const COMPOSING = 'composing';
const PAUSED = 'paused';
const GONE = 'gone';

// Chat types
const PRIVATE_CHAT_TYPE = 'chatbox';
const CHATROOMS_TYPE = 'chatroom';
const HEADLINES_TYPE = 'headline';
const CONTROLBOX_TYPE = 'controlbox';

const CONNECTION_STATUS = {};
CONNECTION_STATUS[Strophe.Status.ATTACHED] = 'ATTACHED';
CONNECTION_STATUS[Strophe.Status.AUTHENTICATING] = 'AUTHENTICATING';
CONNECTION_STATUS[Strophe.Status.AUTHFAIL] = 'AUTHFAIL';
CONNECTION_STATUS[Strophe.Status.CONNECTED] = 'CONNECTED';
CONNECTION_STATUS[Strophe.Status.CONNECTING] = 'CONNECTING';
CONNECTION_STATUS[Strophe.Status.CONNFAIL] = 'CONNFAIL';
CONNECTION_STATUS[Strophe.Status.DISCONNECTED] = 'DISCONNECTED';
CONNECTION_STATUS[Strophe.Status.DISCONNECTING] = 'DISCONNECTING';
CONNECTION_STATUS[Strophe.Status.ERROR] = 'ERROR';
CONNECTION_STATUS[Strophe.Status.RECONNECTING] = 'RECONNECTING';
CONNECTION_STATUS[Strophe.Status.REDIRECT] = 'REDIRECT';

// Add Strophe Namespaces
Strophe.addNamespace('ACTIVITY', 'http://jabber.org/protocol/activity');
Strophe.addNamespace('CARBONS', 'urn:xmpp:carbons:2');
Strophe.addNamespace('CHATSTATES', 'http://jabber.org/protocol/chatstates');
Strophe.addNamespace('CSI', 'urn:xmpp:csi:0');
Strophe.addNamespace('DELAY', 'urn:xmpp:delay');
Strophe.addNamespace('EME', 'urn:xmpp:eme:0');
Strophe.addNamespace('FALLBACK', 'urn:xmpp:fallback:0');
Strophe.addNamespace('FASTEN', 'urn:xmpp:fasten:0');
Strophe.addNamespace('FORWARD', 'urn:xmpp:forward:0');
Strophe.addNamespace('HINTS', 'urn:xmpp:hints');
Strophe.addNamespace('HTTPUPLOAD', 'urn:xmpp:http:upload:0');
Strophe.addNamespace('MAM', 'urn:xmpp:mam:2');
Strophe.addNamespace('MARKERS', 'urn:xmpp:chat-markers:0');
Strophe.addNamespace('MENTIONS', 'urn:xmpp:mmn:0');
Strophe.addNamespace('MESSAGE_CORRECT', 'urn:xmpp:message-correct:0');
Strophe.addNamespace('MODERATE', 'urn:xmpp:message-moderate:1');
Strophe.addNamespace('MODERATE0', 'urn:xmpp:message-moderate:0');
Strophe.addNamespace('NICK', 'http://jabber.org/protocol/nick');
Strophe.addNamespace('OCCUPANTID', 'urn:xmpp:occupant-id:0');
Strophe.addNamespace('OMEMO', 'eu.siacs.conversations.axolotl');
Strophe.addNamespace('OUTOFBAND', 'jabber:x:oob');
Strophe.addNamespace('PUBSUB', 'http://jabber.org/protocol/pubsub');
Strophe.addNamespace('RAI', 'urn:xmpp:rai:0');
Strophe.addNamespace('RECEIPTS', 'urn:xmpp:receipts');
Strophe.addNamespace('REFERENCE', 'urn:xmpp:reference:0');
Strophe.addNamespace('REGISTER', 'jabber:iq:register');
Strophe.addNamespace('REPLY', 'urn:xmpp:reply:0');
Strophe.addNamespace('RETRACT', 'urn:xmpp:message-retract:1');
Strophe.addNamespace('RETRACT0', 'urn:xmpp:message-retract:0');
Strophe.addNamespace('ROSTERX', 'http://jabber.org/protocol/rosterx');
Strophe.addNamespace('RSM', 'http://jabber.org/protocol/rsm');
Strophe.addNamespace('SID', 'urn:xmpp:sid:0');
Strophe.addNamespace('SPOILER', 'urn:xmpp:spoiler:0');
Strophe.addNamespace('STANZAS', 'urn:ietf:params:xml:ns:xmpp-stanzas');
Strophe.addNamespace('STYLING', 'urn:xmpp:styling:0');
Strophe.addNamespace('VCARD', 'vcard-temp');
Strophe.addNamespace('VCARDUPDATE', 'vcard-temp:x:update');
Strophe.addNamespace('XFORM', 'jabber:x:data');
Strophe.addNamespace('XHTML', 'http://www.w3.org/1999/xhtml');

// Core plugins are whitelisted automatically
// These are just the @converse/headless plugins, for the full converse,
// the other plugins are whitelisted in src/consts.js
const CORE_PLUGINS = [
    'converse-adhoc',
    'converse-bookmarks',
    'converse-blocklist',
    'converse-bosh',
    'converse-caps',
    'converse-chat',
    'converse-chatboxes',
    'converse-disco',
    'converse-emoji',
    'converse-headlines',
    'converse-mam',
    'converse-muc',
    'converse-ping',
    'converse-pubsub',
    'converse-reactions',
    'converse-roster',
    'converse-smacks',
    'converse-status',
    'converse-vcard',
    'converse-omemo',
];

const CHAT_STATES = ['active', 'composing', 'gone', 'inactive', 'paused'];
const MARKER_TYPES = ['displayed', 'received', 'acknowledged'];

const KEYCODES = {
    TAB: "Tab",
    ENTER: "Enter",
    SHIFT: "Shift",
    CTRL: "Control",
    ALT: "Alt",
    ESCAPE: "Escape",
    LEFT_ARROW: "ArrowLeft",
    UP_ARROW: "ArrowUp",
    RIGHT_ARROW: "ArrowRight",
    DOWN_ARROW: "ArrowDown",
    FORWARD_SLASH: "Divide",
    AT: "Alt",
    META: "Meta",
};

const XFORM_TYPE_MAP = {
    'text-multi': 'textarea',
    'text-private': 'password',
    'text-single': 'text',
    'fixed': 'label',
    'boolean': 'checkbox',
    'hidden': 'hidden',
    'jid-multi': 'textarea',
    'list-single': 'dropdown',
    'list-multi': 'dropdown'
};

const XFORM_VALIDATE_TYPE_MAP = {
    'xs:anyURI': 'url',
    'xs:byte': 'number',
    'xs:date': 'date',
    'xs:dateTime': 'datetime',
    'xs:int': 'number',
    'xs:integer': 'number',
    'xs:time': 'time',
};

;// CONCATENATED MODULE: ./src/headless/shared/_converse.js
/**
 * @module:shared.converse
 * @typedef {import('@converse/skeletor').BrowserStorage} BrowserStorage
 * @typedef {import('@converse/skeletor').Collection} Collection
 * @typedef {import('../plugins/disco/index').DiscoState} DiscoState
 * @typedef {import('../plugins/status/profile').default} Profile
 * @typedef {import('../plugins/vcard/vcard').default} VCards
 */










const DEPRECATED_ATTRS = {
    chatboxes: null,
    bookmarks: null,

    ANONYMOUS: ANONYMOUS,
    CLOSED: CLOSED,
    EXTERNAL: EXTERNAL,
    LOGIN: LOGIN,
    LOGOUT: LOGOUT,
    OPENED: OPENED,
    PREBIND: PREBIND,
    SUCCESS: SUCCESS,
    FAILURE: FAILURE,
    INACTIVE: INACTIVE,
    ACTIVE: ACTIVE,
    COMPOSING: COMPOSING,
    PAUSED: PAUSED,
    GONE: GONE,
}


/**
 * A private, closured namespace containing the private api (via {@link _converse.api})
 * as well as private methods and internal data-structures.
 * @global
 * @namespace _converse
 */
class ConversePrivateGlobal extends (0,skeletor.EventEmitter)(Object) {

    constructor () {
        super();
        const proxy = new Proxy(this, {
            get: (target, key) => {
                if (!isTestEnv() && typeof key === 'string') {
                    if (Object.keys(DEPRECATED_ATTRS).includes(key)) {
                        src_log.warn(`Accessing ${key} on _converse is DEPRECATED`);
                    }
                }
                return Reflect.get(target, key)
            }
        });
        proxy.initialize();
        return proxy;
    }

    initialize () {
        this.VERSION_NAME = VERSION_NAME;

        this.strict_plugin_dependencies = false;

        this.pluggable = null;

        this.templates = {};

        this.storage = /** @type {Record<string, BrowserStorage.LocalForage>} */{};

        this.promises = {
            initialized: getOpenPromise(),
        };

        this.NUM_PREKEYS = 100; // DEPRECATED. Set here so that tests can override

        // Set as module attr so that we can override in tests.
        // TODO: replace with config settings
        this.TIMEOUTS =  {
            PAUSED: 10000,
            INACTIVE: 90000
        };

        Object.assign(this, DEPRECATED_ATTRS);

        this.api = /** @type {module:shared-api.APIEndpoint} */ null;

        /**
         * Namespace for storing translated strings.
         *
         * @typedef {Record<string, string>} UserMessage
         * @typedef {Record<string, string|UserMessage>} UserMessages
         */
        this.labels = /** @type {UserMessages} */({});

        /**
         * Namespace for storing code that might be useful to 3rd party
         * plugins. We want to make it possible for 3rd party plugins to have
         * access to code (e.g. classes) from converse.js without having to add
         * converse.js as a dependency.
         */
        this.exports = /** @type {Record<string, Object>} */({});

        /**
         * Provides a way for 3rd party plugins to access constants used by
         * Converse.
         */
        this.constants = /** @type {Record<string, string|Object>} */({});

        /**
         * Utility methods and globals from bundled 3rd party libraries.
         */
        this.env = /** @type {import("./api/types.js").ConverseEnv} */ ({});

        /**
         * Namespace for storing the state, as represented by instances of
         * Models and Collections.
         *
         * @typedef {Object & Record<string, Collection|Model|VCards|Profile|DiscoState>} ConverseState
         * @property {VCards} [vcards]
         * @property {Profile} profile
         * @property {DiscoState} disco
         */
        this.state = /** @type {ConverseState} */({});

        this.initSession();
    }

    initSession () {
        this.state.session?.destroy();
        this.state.session = new skeletor.Model();

        // XXX DEPRECATED
        this.session = this.state.session;
        Object.assign(
            this, {
                jid: undefined,
                bare_jid: undefined,
                domain: undefined,
                resource: undefined
            }
        );
    }

    /**
     * Translate the given string based on the current locale.
     * @method __
     * @memberOf _converse
     * @param {...String} args
     */
    __ (...args) {
        return i18n.__(...args);
    }

    /**
     * A no-op method which is used to signal to gettext that the passed in string
     * should be included in the pot translation file.
     *
     * In contrast to the double-underscore method, the triple underscore method
     * doesn't actually translate the strings.
     *
     * One reason for this method might be because we're using strings we cannot
     * send to the translation function because they require variable interpolation
     * and we don't yet have the variables at scan time.
     *
     * @method ___
     * @memberOf _converse
     * @param {String} str
     */
    ___ (str) {
        return str;
    }
}

const _converse_converse = new ConversePrivateGlobal();

// Make _converse pluggable
src_pluggable.enable(_converse_converse, '_converse', 'pluggable');

/* export default */ const shared_converse = (_converse_converse);

;// CONCATENATED MODULE: ./src/headless/shared/api/events.js




/* export default */ const api_events = ({
    /**
     * Lets you trigger events, which can be listened to via
     * {@link _converse.api.listen.on} or {@link _converse.api.listen.once}
     *
     * Some events also double as promises and can be waited on via {@link _converse.api.waitUntil}.
     *
     * @typedef {object} Options
     * @property {boolean} [Options.synchronous] - Whether the event is synchronous or not.
     *  When a synchronous event is fired, a promise will be returned
     *  by {@link _converse.api.trigger} which resolves once all the
     *  event handlers' promises have been resolved.
     *
     * @method _converse.api.trigger
     * @param {string} name - The event name
     */
    async trigger (name) {
        if (!shared_converse._events) {
            return;
        }
        const args = Array.from(arguments);
        const options = /** @type {Options} */(args.pop());
        if (options && options.synchronous) {
            const events = shared_converse._events[name] || [];
            const event_args = args.splice(1);
            await Promise.all(events.map(e => e.callback.apply(e.ctx, event_args)));
        } else {
            shared_converse.trigger.apply(shared_converse, arguments);
        }
        const promise = shared_converse.promises[name];
        if (promise !== undefined) {
            promise.resolve(arguments[1]);
        }
    },

    /**
     * Triggers a hook which can be intercepted by registered listeners via
     * {@link _converse.api.listen.on} or {@link _converse.api.listen.once}.
     *
     * A hook is a special kind of event which allows you to intercept a data
     * structure in order to modify it, before passing it back.
     * @async
     * @param {string} name - The hook name
     * @param {...any} context - The context to which the hook applies
     *  (could be for example, a {@link _converse.ChatBox}).
     * @param {...any} data - The data structure to be intercepted and modified by the hook listeners.
     * @param {...any} extra_args - Additional passthrough arguments for hook listeners.
     * @returns {Promise<any>} - A promise that resolves with the modified data structure.
     */
    hook (name, context, data, ...extra_args) {
        const events = shared_converse._events[name] || [];
        if (events.length) {
            // Create a chain of promises, with each one feeding its output to
            // the next. The first input is a promise with the original data
            // sent to this hook.
            return events.reduce((o, e) => o.then(d => e.callback(context, d, ...extra_args)), Promise.resolve(data));
        } else {
            return data;
        }
    },

    /**
     * Converse emits events to which you can subscribe to.
     *
     * The `listen` namespace exposes methods for creating event listeners
     * (aka handlers) for these events.
     *
     * @namespace _converse.api.listen
     * @memberOf _converse
     */
    listen: {
        /**
         * Lets you listen to an event exactly once.
         * @method _converse.api.listen.once
         * @param {string} name The event's name
         * @param {function} callback The callback method to be called when the event is emitted.
         * @param {object} [context] The value of the `this` parameter for the callback.
         * @example _converse.api.listen.once('message', function (messageXML) { ... });
         */
        once: shared_converse.once.bind(shared_converse),

        /**
         * Lets you subscribe to an event.
         * Every time the event fires, the callback method specified by `callback` will be called.
         * @method _converse.api.listen.on
         * @param {string} name The event's name
         * @param {function} callback The callback method to be called when the event is emitted.
         * @param {object} [context] The value of the `this` parameter for the callback.
         * @example _converse.api.listen.on('message', function (messageXML) { ... });
         */
        on: shared_converse.on.bind(shared_converse),

        /**
         * To stop listening to an event, you can use the `not` method.
         * @method _converse.api.listen.not
         * @param {string} name The event's name
         * @param {function} callback The callback method that is to no longer be called when the event fires
         * @example _converse.api.listen.not('message', function (messageXML);
         */
        not: shared_converse.off.bind(shared_converse),

        /**
         * An options object which lets you set filter criteria for matching
         * against stanzas.
         * @typedef {object} MatchingOptions
         * @property {string} [ns] - The namespace to match against
         * @property {string} [type] - The stanza type to match against
         * @property {string} [id] - The stanza id to match against
         * @property {string} [from] - The stanza sender to match against
         */

        /**
         * Subscribe to an incoming stanza
         * Every a matched stanza is received, the callback method specified by
         * `callback` will be called.
         * @method _converse.api.listen.stanza
         * @param {string} name The stanza's name
         * @param {MatchingOptions|Function} options Matching options or callback
         * @param {function} handler The callback method to be called when the stanza appears
         */
        stanza (name, options, handler) {
            if (object_isFunction(options)) {
                handler = /** @type {Function} */(options);
                options = {};
            } else {
                options = options || {};
            }
            shared_converse.api.connection.get().addHandler(
                handler,
                options.ns,
                name,
                options.type,
                options.id,
                options.from,
                options
            );
        }
    },
});

;// CONCATENATED MODULE: ./node_modules/lodash-es/now.js


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now_now = function() {
  return _root.Date.now();
};

/* export default */ const lodash_es_now = (now_now);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_trimmedEndIndex.js
/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/* export default */ const _trimmedEndIndex = (trimmedEndIndex);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseTrim.js


/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

/* export default */ const _baseTrim = (baseTrim);

;// CONCATENATED MODULE: ./node_modules/lodash-es/toNumber.js




/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (lodash_es_isSymbol(value)) {
    return NAN;
  }
  if (lodash_es_isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = lodash_es_isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = _baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* export default */ const lodash_es_toNumber = (toNumber);

;// CONCATENATED MODULE: ./node_modules/lodash-es/debounce.js




/** Error message constants. */
var debounce_FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var debounce_nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(debounce_FUNC_ERROR_TEXT);
  }
  wait = lodash_es_toNumber(wait) || 0;
  if (lodash_es_isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? debounce_nativeMax(lodash_es_toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = lodash_es_now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(lodash_es_now());
  }

  function debounced() {
    var time = lodash_es_now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* export default */ const lodash_es_debounce = (debounce);

// EXTERNAL MODULE: ./node_modules/localforage-webextensionstorage-driver/local.js
var local = __webpack_require__(735);
// EXTERNAL MODULE: ./node_modules/localforage-webextensionstorage-driver/sync.js
var sync = __webpack_require__(685);
;// CONCATENATED MODULE: ./src/headless/utils/storage.js





const storage_settings = settings_api;

/**
 * @returns {import('./types').StorageType}
 */
function getDefaultStorageType() {
    if (shared_converse.state.config.get('trusted')) {
        const is_non_persistent = storage_settings.get('persistent_store') === 'sessionStorage';
        return is_non_persistent ? 'session' : 'persistent';
    } else {
        return 'session';
    }
}

/**
 * @param {import('./types').StorageType} type
 */
function storeUsesIndexedDB(type) {
    return type === 'persistent' && storage_settings.get('persistent_store') === 'IndexedDB';
}

/**
 * @param {string} id
 * @param {import('./types').StorageType} type
 * @returns {BrowserStorage}
 */
function createStore(id, type) {
    const name = type || getDefaultStorageType();
    const s = shared_converse.storage[name];
    if (typeof s === 'undefined') {
        throw new TypeError(`createStore: Could not find store for ${id}`);
    }
    return new skeletor.BrowserStorage(id, s, storeUsesIndexedDB(type));
}

/**
 * @param {import('./types').StorageModel} model
 * @param {string} id
 * @param {import('./types').StorageType} [type]
 */
function initStorage(model, id, type) {
    type = type || getDefaultStorageType();
    model.browserStorage = createStore(id, type);
    if (storeUsesIndexedDB(type)) {
        const flush = () => model.browserStorage.flush();
        const unloadevent = getUnloadEvent();
        window.addEventListener(unloadevent, flush);
        model.on('destroy', () => window.removeEventListener(unloadevent, flush));
        model.listenTo(shared_converse, 'beforeLogout', flush);
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/connection/utils.js




function generateResource () {
    return `/converse.js-${Math.floor(Math.random() * 139749528).toString()}`;
}

function setStropheLogLevel () {
    const level = settings_api.get('loglevel');
    Strophe.setLogLevel(Strophe.LogLevel[level.toUpperCase()]);

    const lmap = {};
    lmap[Strophe.LogLevel.DEBUG] = 'debug';
    lmap[Strophe.LogLevel.INFO] = 'info';
    lmap[Strophe.LogLevel.WARN] = 'warn';
    lmap[Strophe.LogLevel.ERROR] = 'error';
    lmap[Strophe.LogLevel.FATAL] = 'fatal';

    Strophe.log = (l, msg) => src_log.log(msg, lmap[l]);
    Strophe.error = (msg) => src_log.error(msg);
}

function getConnectionServiceURL () {
    if (('WebSocket' in window || 'MozWebSocket' in window) && settings_api.get('websocket_url')) {
        return settings_api.get('websocket_url');
    } else if (settings_api.get('bosh_service_url')) {
        return settings_api.get('bosh_service_url');
    }
    return '';
}

;// CONCATENATED MODULE: ./src/headless/utils/jid.js




/**
 * @param {string|null} [jid]
 * @returns {boolean}
 */
function isValidJID(jid) {
    if (!(typeof jid === 'string')) {
        return false;
    }

    const num_slashes = jid.split('/').length - 1;
    if (num_slashes > 1) {
        return false;
    }

    return jid.split('@').filter((s) => !!s).length === 2 && !jid.startsWith('@') && !jid.endsWith('@');
}

/**
 * @param {string} jid
 * @returns {boolean}
 */
function isValidMUCJID(jid) {
    return !jid.startsWith('@') && !jid.endsWith('@');
}

/**
 * @param {string} jid1
 * @param {string} jid2
 * @returns {boolean}
 */
function isSameBareJID(jid1, jid2) {
    if (typeof jid1 !== 'string' || typeof jid2 !== 'string') {
        return false;
    }
    return Strophe.getBareJidFromJid(jid1).toLowerCase() === Strophe.getBareJidFromJid(jid2).toLowerCase();
}

/**
 * @param {string} jid1
 * @param {string} jid2
 * @returns {boolean}
 */
function isSameDomain(jid1, jid2) {
    if (typeof jid1 !== 'string' || typeof jid2 !== 'string') {
        return false;
    }
    return Strophe.getDomainFromJid(jid1).toLowerCase() === Strophe.getDomainFromJid(jid2).toLowerCase();
}

/**
 * @param {string} jid
 */
function getJIDFromURI(jid) {
    return jid.startsWith('xmpp:') && jid.endsWith('?join') ? jid.replace(/^xmpp:/, '').replace(/\?join$/, '') : jid;
}

/**
 * @param {string} jid
 * @param {boolean} [include_resource=false]
 * @returns {boolean}
 */
function isOwnJID(jid, include_resource = false) {
    if (include_resource) {
        return jid === shared_converse.session.get('full_jid');
    }
    return Strophe.getBareJidFromJid(jid) === shared_converse.session.get('bare_jid');
}

/**
 * Appends locked_domain or default_domain to a JID if configured.
 * When locked_domain is set, it will:
 * - Strip the locked_domain if already present in the input
 * - Escape the username part using Strophe.escapeNode()
 * - Append the locked_domain
 * When default_domain is set and the input is not already a valid JID:
 * - Escape the username part using Strophe.escapeNode()
 * - Append the default_domain
 * @param {string} jid - The JID or username to process
 * @returns {string} The full JID with domain appended if applicable
 */
function maybeAppendDomain(jid) {
    const locked_domain = settings_api.get('locked_domain');
    const default_domain = settings_api.get('default_domain');

    if (locked_domain) {
        const last_part = '@' + locked_domain;
        if (jid.endsWith(last_part)) {
            jid = jid.substring(0, jid.length - last_part.length);
        }
        jid = Strophe.escapeNode(jid) + last_part;
    } else if (default_domain && !isValidJID(jid)) {
        jid = Strophe.escapeNode(jid) + '@' + default_domain;
    }

    return jid;
}


;// CONCATENATED MODULE: ./src/headless/utils/init.js
/**
 * @typedef {module:shared.converse.ConversePrivateGlobal} ConversePrivateGlobal
 */















/**
 * Initializes the plugins for the Converse instance.
 * @param {ConversePrivateGlobal} _converse
 * @fires _converse#pluginsInitialized - Triggered once all plugins have been initialized.
 * @memberOf _converse
 */
function initPlugins(_converse) {
    // If initialize gets called a second time (e.g. during tests), then we
    // need to re-apply all plugins (for a new converse instance), and we
    // therefore need to clear this array that prevents plugins from being
    // initialized twice.
    // If initialize is called for the first time, then this array is empty
    // in any case.
    _converse.pluggable.initialized_plugins = [];
    const whitelist = CORE_PLUGINS.concat(_converse.api.settings.get("whitelisted_plugins"));

    if (_converse.api.settings.get("singleton")) {
        ["converse-bookmarks", "converse-controlbox", "converse-headline", "converse-register"].forEach((name) =>
            _converse.api.settings.get("blacklisted_plugins").push(name)
        );
    }

    _converse.pluggable.initializePlugins({ _converse }, whitelist, _converse.api.settings.get("blacklisted_plugins"));

    /**
     * Triggered once all plugins have been initialized. This is a useful event if you want to
     * register event handlers but would like your own handlers to be overridable by
     * plugins. In that case, you need to first wait until all plugins have been
     * initialized, so that their overrides are active. One example where this is used
     * is in [converse-notifications.js](https://github.com/jcbrand/converse.js/blob/master/src/converse-notification.js)`.
     *
     * Also available as an [ES2015 Promise](http://es6-features.org/#PromiseUsage)
     * which can be listened to with `_converse.api.waitUntil`.
     *
     * @event _converse#pluginsInitialized
     * @memberOf _converse
     * @example _converse.api.listen.on('pluginsInitialized', () => { ... });
     */
    _converse.api.trigger("pluginsInitialized");
}

/**
 * @param {ConversePrivateGlobal} _converse
 */
async function initClientConfig(_converse) {
    /* The client config refers to configuration of the client which is
     * independent of any particular user.
     * What this means is that config values need to persist across
     * user sessions.
     */
    const id = "converse.client-config";
    const config = new skeletor.Model({ id, "trusted": true });
    config.browserStorage = createStore(id, "session");

    Object.assign(_converse, { config }); // XXX DEPRECATED
    Object.assign(_converse.state, { config });

    await new Promise((r) => config.fetch({ "success": r, "error": r }));
    /**
     * Triggered once the XMPP-client configuration has been initialized.
     * The client configuration is independent of any particular and its values
     * persist across user sessions.
     *
     * @event _converse#clientConfigInitialized
     * @example
     * _converse.api.listen.on('clientConfigInitialized', () => { ... });
     */
    _converse.api.trigger("clientConfigInitialized");
}

/**
 * @param {ConversePrivateGlobal} _converse
 */
async function initSessionStorage(_converse) {
    await skeletor.BrowserStorage.sessionStorageInitialized;
    _converse.storage["session"] = skeletor.BrowserStorage.localForage.createInstance({
        name: isTestEnv() ? "converse-test-session" : "converse-session",
        description: "sessionStorage instance",
        driver: ["sessionStorageWrapper"],
    });
}

/**
 * Initializes persistent storage
 * @param {ConversePrivateGlobal} _converse
 * @param {string} store_name - The name of the store.
 * @param {string} [key="persistent"] - The key for `_converse.storage`.
 */
function initPersistentStorage(_converse, store_name, key="persistent") {
    const { api } = _converse;
    if (api.settings.get("persistent_store") === "sessionStorage") {
        _converse.storage[key] = _converse.storage["session"];
        return;
    } else if (api.settings.get("persistent_store") === "BrowserExtLocal") {
        skeletor.BrowserStorage.localForage.defineDriver(local["default"])
            .then(() => skeletor.BrowserStorage.localForage.setDriver("webExtensionLocalStorage"));
        _converse.storage[key] = skeletor.BrowserStorage.localForage;
        return;
    } else if (api.settings.get("persistent_store") === "BrowserExtSync") {
        skeletor.BrowserStorage.localForage.defineDriver(sync["default"])
            .then(() => skeletor.BrowserStorage.localForage.setDriver("webExtensionSyncStorage"));
        _converse.storage[key] = skeletor.BrowserStorage.localForage;
        return;
    }

    const config = {
        name: isTestEnv() ? "converse-test-persistent" : "converse-persistent",
        storeName: store_name,
    };
    if (api.settings.get("persistent_store") === "localStorage") {
        config["description"] = "localStorage instance";
        config["driver"] = [skeletor.BrowserStorage.localForage.LOCALSTORAGE];
    } else if (api.settings.get("persistent_store") === "IndexedDB") {
        config["description"] = "indexedDB instance";
        config["driver"] = [skeletor.BrowserStorage.localForage.INDEXEDDB];
    }
    _converse.storage[key] = skeletor.BrowserStorage.localForage.createInstance(config);
}

/**
 * @param {ConversePrivateGlobal} _converse
 * @param {string} jid
 */
function saveJIDtoSession(_converse, jid) {
    const { api, session } = _converse;

    if (api.settings.get("authentication") !== ANONYMOUS && !Strophe.getResourceFromJid(jid)) {
        jid = jid.toLowerCase() + generateResource();
    }

    const bare_jid = Strophe.getBareJidFromJid(jid);
    const resource = Strophe.getResourceFromJid(jid);
    const domain = Strophe.getDomainFromJid(jid);

    // TODO: Storing directly on _converse is deprecated
    Object.assign(_converse, { jid, bare_jid, resource, domain });

    session.save({
        jid,
        bare_jid,
        resource,
        domain,
        // We use the `active` flag to determine whether we should use the values from sessionStorage.
        // When "cloning" a tab (e.g. via middle-click), the `active` flag will be set and we'll create
        // a new empty user session, otherwise it'll be false and we can reuse the user session.
        // When the tab is reloaded, the `active` flag is set to `false`.
        "active": true,
    });
    // Set JID on the connection object so that when we call `connection.bind`
    // the new resource is found by Strophe.js and sent to the XMPP server.
    api.connection.get().jid = jid;
}

/**
 * Stores the passed in JID for the current user, potentially creating a
 * resource if the JID is bare.
 *
 * Given that we can only create an XMPP connection if we know the domain of
 * the server connect to and we only know this once we know the JID, we also
 * call {@link api.connection.init} (if necessary) to make sure that the
 * connection is set up.
 *
 * @emits _converse#setUserJID
 * @param {string} jid
 */
async function setUserJID(jid) {
    await initSession(shared_converse, jid);

    /**
     * Triggered whenever the user's JID has been updated
     * @event _converse#setUserJID
     */
    shared_converse.api.trigger("setUserJID");
    return jid;
}

/**
 * @param {ConversePrivateGlobal} _converse
 * @param {string} jid
 */
async function initSession(_converse, jid) {
    const is_shared_session = _converse.api.settings.get("connection_options").worker;

    const bare_jid = Strophe.getBareJidFromJid(jid).toLowerCase();
    const id = `converse.session-${bare_jid}`;
    if (_converse.session?.get("id") !== id) {
        initPersistentStorage(_converse, bare_jid);

        _converse.session.set({ id });
        initStorage(_converse.session, id, is_shared_session ? "persistent" : "session");
        await new Promise((r) => _converse.session.fetch({ success: r, error: r }));

        if (!is_shared_session && _converse.session.get("active")) {
            // If the `active` flag is set, it means this tab was cloned from
            // another (e.g. via middle-click), and its session data was copied over.
            _converse.session.clear();
            _converse.session.save({ id });
        }
        saveJIDtoSession(_converse, jid);

        // Set `active` flag to false when the tab gets reloaded
        window.addEventListener(getUnloadEvent(), () => safeSave(_converse.session, { active: false }));

        /**
         * Triggered once the user's session has been initialized. The session is a
         * cache which stores information about the user's current session.
         * @event _converse#userSessionInitialized
         * @memberOf _converse
         */
        _converse.api.trigger("userSessionInitialized");
    } else {
        saveJIDtoSession(_converse, jid);
    }
}

/**
 * @param {ConversePrivateGlobal} _converse
 */
function registerGlobalEventHandlers(_converse) {
    /**
     * Plugins can listen to this event as cue to register their
     * global event handlers.
     * @event _converse#registeredGlobalEventHandlers
     * @example _converse.api.listen.on('registeredGlobalEventHandlers', () => { ... });
     */
    _converse.api.trigger("registeredGlobalEventHandlers");
}

/**
 * @param {ConversePrivateGlobal} _converse
 */
function unregisterGlobalEventHandlers(_converse) {
    _converse.api.trigger("unregisteredGlobalEventHandlers");
}

/**
 * Make sure everything is reset in case this is a subsequent call to
 * converse.initialize (happens during tests).
 * @param {ConversePrivateGlobal} _converse
 */
async function cleanup(_converse) {
    const { api } = _converse;
    await api.trigger("cleanup", { "synchronous": true });
    unregisterGlobalEventHandlers(_converse);
    api.connection.get()?.reset();
    _converse.stopListening();
    _converse.off();
    if (_converse.promises["initialized"].isResolved) {
        api.promises.add("initialized");
    }
}

/**
 * Fetches login credentials from the server.
 * @param {number} [wait=0]
 *  The time to wait and debounce subsequent calls to this function before making the request.
 * @returns {Promise<import('./types').Credentials>}
 *  A promise that resolves with the provided login credentials (JID and password).
 * @throws {Error} If the request fails or returns an error status.
 */
function fetchLoginCredentials(wait = 0) {
    return new Promise(
        lodash_es_debounce(async (resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open("GET", shared_converse.api.settings.get("credentials_url"), true);
            xhr.setRequestHeader("Accept", "application/json, text/javascript");
            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 400) {
                    const data = JSON.parse(xhr.responseText);
                    setUserJID(data.jid).then(() => {
                        resolve({
                            jid: data.jid,
                            password: data.password,
                        });
                    });
                } else {
                    reject(new Error(`${xhr.status}: ${xhr.responseText}`));
                }
            };
            xhr.onerror = reject;
            /**
             * *Hook* which allows modifying the server request
             * @event _converse#beforeFetchLoginCredentials
             */
            xhr = await shared_converse.api.hook("beforeFetchLoginCredentials", this, xhr);
            xhr.send();
        }, wait)
    );
}

/**
 * @returns {Promise<import('./types').Credentials>}
 */
async function getLoginCredentialsFromURL() {
    let credentials;
    let wait = 0;
    while (!credentials) {
        try {
            credentials = await fetchLoginCredentials(wait); // eslint-disable-line no-await-in-loop
        } catch (e) {
            src_log.error("Could not fetch login credentials");
            src_log.error(e);
        }
        // If unsuccessful, we wait 2 seconds between subsequent attempts to
        // fetch the credentials.
        wait = 2000;
    }
    return credentials;
}

async function getLoginCredentialsFromBrowser() {
    const jid = localStorage.getItem("conversejs-session-jid");
    if (!jid) return null;

    try {
        const creds = await navigator.credentials.get({ password: true });
        if (creds && creds.type == "password" && isValidJID(creds.id)) {
            // XXX: We don't actually compare `creds.id` with `jid` because
            // the user might have been presented a list of credentials with
            // which to log in, and we want to respect their wish.
            await setUserJID(creds.id);
            return { "jid": creds.id, "password": creds.password };
        }
    } catch (e) {
        src_log.error(e);
        return null;
    }
}

async function getLoginCredentialsFromSCRAMKeys() {
    const jid = localStorage.getItem("conversejs-session-jid");
    if (!jid) return null;

    await setUserJID(jid);

    const login_info = await savedLoginInfo(jid);
    const scram_keys = login_info.get("scram_keys");
    return scram_keys ? { jid, password: scram_keys } : null;
}

/**
 * @param {import('./types').Credentials} [credentials]
 * @param {boolean} [automatic]
 */
async function attemptNonPreboundSession(credentials, automatic) {
    const { api } = shared_converse;
    /**
     * *Hook* to allow 3rd party plugins to provide their own login credentials.
     * @event _converse#beforeAttemptNonPreboundSession
     */
    const { credentials: new_creds } = await api.hook("beforeAttemptNonPreboundSession", this, {
        credentials,
        automatic,
    });
    if (new_creds) return connect(new_creds);

    if (api.settings.get("authentication") === LOGIN) {
        const jid = shared_converse.session.get("jid");
        // XXX: If EITHER ``keepalive`` or ``auto_login`` is ``true`` and
        // ``authentication`` is set to ``login``, then Converse will try to log the user in,
        // since we don't have a way to distinguish between whether we're
        // restoring a previous session (``keepalive``) or whether we're
        // automatically setting up a new session (``auto_login``).
        // So we can't do the check (!automatic || _converse.api.settings.get("auto_login")) here.
        if (credentials) {
            return connect(credentials);
        } else if (api.settings.get("credentials_url")) {
            // We give credentials_url preference, because
            // connection.pass might be an expired token.
            return connect(await getLoginCredentialsFromURL());
        } else if (jid && (api.settings.get("password") || api.connection.get().pass)) {
            return connect();
        }

        if (api.settings.get("reuse_scram_keys")) {
            const credentials = await getLoginCredentialsFromSCRAMKeys();
            if (credentials) return connect(credentials);
        }

        if (!isTestEnv() && "credentials" in navigator) {
            const credentials = await getLoginCredentialsFromBrowser();
            if (credentials) return connect(credentials);
        }

        if (!isTestEnv()) src_log.debug("attemptNonPreboundSession: Couldn't find credentials to log in with");
    } else if (
        [ANONYMOUS, EXTERNAL].includes(api.settings.get("authentication")) &&
        (!automatic || api.settings.get("auto_login"))
    ) {
        connect();
    }
}

/**
 * Fetch the stored SCRAM keys for the given JID, if available.
 *
 * The user's plaintext password is not stored, nor any material from which
 * the user's plaintext password could be recovered.
 *
 * @param {String} jid - The XMPP address for which to fetch the SCRAM keys
 * @returns {Promise<Model>} A promise which resolves once we've fetched the previously
 *  used login keys.
 */
async function savedLoginInfo(jid) {
    const id = `converse.scram-keys-${Strophe.getBareJidFromJid(jid)}`;
    if (shared_converse.state.login_info?.get("id") === id) {
        return shared_converse.state.login_info;
    }
    const login_info = /** @type {Model} */ (new skeletor.Model({ id }));
    shared_converse.state.login_info = login_info;
    initStorage(login_info, id, "persistent");
    await new Promise((f) => login_info.fetch({ "success": f, "error": f }));
    return login_info;
}

/**
 * @param {Object} [credentials]
 * @param {string} credentials.password
 * @param {Object} credentials.password
 * @param {string} credentials.password.ck
 * @returns {Promise<void>}
 */
async function connect(credentials) {
    const { api } = shared_converse;
    const jid = shared_converse.session.get("jid");
    const connection = api.connection.get();
    if ([ANONYMOUS, EXTERNAL].includes(api.settings.get("authentication"))) {
        if (!jid) {
            throw new Error(
                "Config Error: when using anonymous login " +
                    "you need to provide the server's domain via the 'jid' option. " +
                    "Either when calling converse.initialize, or when calling " +
                    "_converse.api.user.login."
            );
        }
        if (!connection.reconnecting) {
            connection.reset();
        }
        connection.connect(jid.toLowerCase());
    } else if (api.settings.get("authentication") === LOGIN) {
        const password = credentials?.password ?? (connection?.pass || api.settings.get("password"));
        if (!password) {
            if (api.settings.get("auto_login")) {
                throw new Error(
                    "autoLogin: If you use auto_login and " +
                        "authentication='login' then you also need to provide a password."
                );
            }
            connection.setDisconnectionCause(Strophe.Status.AUTHFAIL, undefined, true);
            api.connection.disconnect();
            return;
        }
        if (!connection.reconnecting) {
            connection.reset();
            connection.service = getConnectionServiceURL();
        }

        let callback;
        // Save the SCRAM data if we're not already logged in with SCRAM
        if (shared_converse.state.config.get("trusted") && jid && api.settings.get("reuse_scram_keys") && !password?.ck) {
            // Store scram keys in scram storage
            const login_info = await savedLoginInfo(jid);
            callback =
                /**
                 * @param {string} status
                 * @param {string} message
                 */
                (status, message) => {
                    const { scram_keys } = connection;
                    if (scram_keys) login_info.save({ scram_keys });
                    connection.onConnectStatusChanged(status, message);
                };
        }
        connection.connect(jid, password, callback);
    }
}

/**
 * @param {Model} model
 * @param {Object} attributes
 * @param {Object} options
 */
function safeSave(model, attributes, options) {
    if (isPersistableModel(model)) {
        model.save(attributes, options);
    } else {
        model.set(attributes, options);
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/connection/index.js











const connection_i = Object.keys(Strophe.Status).reduce((max, k) => Math.max(max, Strophe.Status[k]), 0);
Strophe.Status.RECONNECTING = connection_i + 1;


/**
 * The Connection class manages the connection to the XMPP server. It's
 * agnostic concerning the underlying protocol (i.e. websocket, long-polling
 * via BOSH or websocket inside a shared worker).
 */
class connection_Connection extends Strophe.Connection {

    constructor (service, options) {
        super(service, options);
        // For new sessions, we need to send out a presence stanza to notify
        // the server/network that we're online.
        // When re-attaching to an existing session we don't need to again send out a presence stanza,
        // because it's as if "we never left" (see onConnectStatusChanged).
        this.send_initial_presence = true;
        this.debouncedReconnect = lodash_es_debounce(this.reconnect, 3000);
    }

    /** @param {Element} body */
    xmlInput(body) {
        src_log.debug('%c%s', 'color: darkgoldenrod', body.outerHTML);
    }

    /** @param {Element} body */
    xmlOutput(body) {
        src_log.debug('%c%s', 'color: darkcyan', body.outerHTML);
    }

    async bind () {
        const { api } = shared_converse;
        /**
         * Synchronous event triggered before we send an IQ to bind the user's
         * JID resource for this session.
         * @event _converse#beforeResourceBinding
         */
        await api.trigger('beforeResourceBinding', {'synchronous': true});
        super.bind();
    }

    async onDomainDiscovered (response) {
        const { api } = shared_converse;
        const text = await response.text();
        const xrd = (new DOMParser()).parseFromString(text, "text/xml").firstElementChild;
        if (xrd.nodeName != "XRD" || xrd.namespaceURI != "http://docs.oasis-open.org/ns/xri/xrd-1.0") {
            return src_log.info("Could not discover XEP-0156 connection methods");
        }
        const bosh_links = sizzle_default()(`Link[rel="urn:xmpp:alt-connections:xbosh"]`, xrd);
        const ws_links = sizzle_default()(`Link[rel="urn:xmpp:alt-connections:websocket"]`, xrd);
        const bosh_methods = bosh_links.map(el => el.getAttribute('href')).filter(uri => uri.startsWith('https:'));
        const ws_methods = ws_links.map(el => el.getAttribute('href')).filter(uri => uri.startsWith('wss:'));
        if (bosh_methods.length === 0 && ws_methods.length === 0) {
            src_log.info("Neither BOSH nor WebSocket connection methods have been specified with XEP-0156.");
        } else {
            // TODO: support multiple endpoints
            api.settings.set("websocket_url", ws_methods.pop());
            api.settings.set('bosh_service_url', bosh_methods.pop());
            this.service = api.settings.get("websocket_url") || api.settings.get('bosh_service_url');
            this.setProtocol();
        }
    }

    /**
     * Adds support for XEP-0156 by querying the XMPP server for alternate
     * connection methods. This allows users to use the websocket or BOSH
     * connection of their own XMPP server instead of a proxy provided by the
     * host of Converse.js.
     * @method Connection.discoverConnectionMethods
     * @param {string} domain
     */
    async discoverConnectionMethods (domain) {
        // Use XEP-0156 to check whether this host advertises websocket or BOSH connection methods.
        const options = {
            mode: /** @type {RequestMode} */('cors'),
            headers: {
                Accept: 'application/xrd+xml, text/xml'
            }
        };
        const url = `https://${domain}/.well-known/host-meta`;
        let response;
        try {
            response = await fetch(url, options);
        } catch (e) {
            src_log.info(`Failed to discover alternative connection methods at ${url}`);
            src_log.error(e);
            return;
        }
        if (response.status >= 200 && response.status < 400) {
            await this.onDomainDiscovered(response);
        } else {
            src_log.info("Could not discover XEP-0156 connection methods");
        }
    }

    /**
     * Establish a new XMPP session by logging in with the supplied JID and
     * password.
     * @param {String} jid
     * @param {String} password
     * @param {Function} callback
     */
    async connect (jid, password, callback) {
        const { __, api } = shared_converse;

        if (api.settings.get("discover_connection_methods")) {
            const domain = Strophe.getDomainFromJid(jid);
            await this.discoverConnectionMethods(domain);
        }
        if (!api.settings.get('bosh_service_url') && !api.settings.get("websocket_url")) {
            // If we don't have a connection URL, we show an input for the user
            // to manually provide it.
            api.settings.set('show_connection_url_input', true);
            (callback || this.onConnectStatusChanged.bind(this))(
                Strophe.Status.DISCONNECTED,
                __('Could not automatically determine a connection URL')
            );
            return;
        }
        super.connect(jid, password, callback || this.onConnectStatusChanged, BOSH_WAIT);
    }

    /**
     * @param {string} reason
     */
    disconnect(reason) {
        super.disconnect(reason);
        this.send_initial_presence = true;
    }

    /**
     * Switch to a different transport if a service URL is available for it.
     *
     * When reconnecting with a new transport, we call setUserJID
     * so that a new resource is generated, to avoid multiple
     * server-side sessions with the same resource.
     *
     * We also call `_proto._doDisconnect` so that connection event handlers
     * for the old transport are removed.
     */
    async switchTransport () {
        const { api } = shared_converse;

        const bare_jid = shared_converse.session.get('bare_jid');
        if (api.connection.isType('websocket') && api.settings.get('bosh_service_url')) {
            await setUserJID(bare_jid);
            this._proto._doDisconnect();
            this._proto = new Strophe.Bosh(this);
            this.service = api.settings.get('bosh_service_url');
        } else if (api.connection.isType('bosh') && api.settings.get("websocket_url")) {
            if (api.settings.get("authentication") === ANONYMOUS) {
                // When reconnecting anonymously, we need to connect with only
                // the domain, not the full JID that we had in our previous
                // (now failed) session.
                await setUserJID(api.settings.get("jid"));
            } else {
                await setUserJID(bare_jid);
            }
            this._proto._doDisconnect();
            this._proto = new Strophe.Websocket(this);
            this.service = api.settings.get("websocket_url");
        }
    }

    async reconnect () {
        const { api } = shared_converse;

        src_log.debug('RECONNECTING: the connection has dropped, attempting to reconnect.');
        this.reconnecting = true;
        await tearDown(shared_converse);

        const conn_status = shared_converse.state.connfeedback.get('connection_status');
        if (conn_status === Strophe.Status.CONNFAIL) {
            this.switchTransport();
        } else if (conn_status === Strophe.Status.AUTHFAIL && api.settings.get("authentication") === ANONYMOUS) {
            // When reconnecting anonymously, we need to connect with only
            // the domain, not the full JID that we had in our previous
            // (now failed) session.
            await setUserJID(api.settings.get("jid"));
        }

        /**
         * Triggered when the connection has dropped, but Converse will attempt
         * to reconnect again.
         * @event _converse#will-reconnect
         */
        api.trigger('will-reconnect');

        if (api.settings.get("authentication") === ANONYMOUS) {
            await clearSession(shared_converse);
        }
        const jid = shared_converse.session.get('jid');
        return api.user.login(jid);
    }

    /**
     * Called as soon as a new connection has been established, either
     * by logging in or by attaching to an existing BOSH session.
     * @method Connection.onConnected
     * @param {Boolean} [reconnecting] - Whether Converse.js reconnected from an earlier dropped session.
     */
    async onConnected (reconnecting) {
        const { api } = shared_converse;

        delete this.reconnecting;
        if (this.isType('bosh')) {
            // Solves problem of returned PubSub BOSH response not received by browser
            this.flush();
        }

        await setUserJID(this.jid);

        // Save the current JID in persistent storage so that we can attempt to
        // recreate the session from SCRAM keys
        if (shared_converse.state.config.get('trusted')) {
            const bare_jid = shared_converse.session.get('bare_jid');
            localStorage.setItem('conversejs-session-jid', bare_jid);
        }

        /**
         * Synchronous event triggered after we've sent an IQ to bind the
         * user's JID resource for this session.
         * @event _converse#afterResourceBinding
         */
        await api.trigger('afterResourceBinding', reconnecting, {'synchronous': true});

        if (reconnecting) {
            /**
             * After the connection has dropped and converse.js has reconnected.
             * Any Strophe stanza handlers (as registered via `converse.listen.stanza`) will
             * have to be registered anew.
             * @event _converse#reconnected
             * @example _converse.api.listen.on('reconnected', () => { ... });
             */
            api.trigger('reconnected');
        } else {
            /**
             * Triggered after the connection has been established and Converse
             * has got all its ducks in a row.
             * @event _converse#initialized
             */
            api.trigger('connected');
        }
    }

    /**
     * Used to keep track of why we got disconnected, so that we can
     * decide on what the next appropriate action is (in onDisconnected)
     * @param {Number|'logout'} [cause] - The status number as received from Strophe.
     * @param {String} [reason] - An optional user-facing message as to why
     *  there was a disconnection.
     * @param {Boolean} [override] - An optional flag to replace any previous
     *  disconnection cause and reason.
     */
    setDisconnectionCause (cause, reason, override) {
        if (cause === undefined) {
            delete this.disconnection_cause;
            delete this.disconnection_reason;
        } else if (this.disconnection_cause === undefined || override) {
            this.disconnection_cause = cause;
            this.disconnection_reason = reason;
        }
    }

    /**
     * @param {Number} [status] - The status number as received from Strophe.
     * @param {String} [message] - An optional user-facing message
     */
    setConnectionStatus (status, message) {
        this.status = status;
        shared_converse.state.connfeedback.set({ connection_status: status, message });
    }

    async finishDisconnection () {
        this.setConnectionStatus(Strophe.Status.DISCONNECTED, this.disconnection_reason);
        const { api } = shared_converse;
        // Properly tear down the session so that it's possible to manually connect again.
        src_log.debug('DISCONNECTED');
        delete this.reconnecting;
        this.reset();
        tearDown(shared_converse);
        await clearSession(shared_converse);
        api.connection.destroy();

        /**
        * Triggered after converse.js has disconnected from the XMPP server.
        * @event _converse#disconnected
        * @memberOf _converse
        * @example _converse.api.listen.on('disconnected', () => { ... });
        */
        api.trigger('disconnected');
    }

    /**
     * Gets called once strophe's status reaches Strophe.Status.DISCONNECTED.
     * Will either start a teardown process for converse.js or attempt
     * to reconnect.
     * @method onDisconnected
     */
    onDisconnected () {
        const { api } = shared_converse;
        if (api.settings.get("auto_reconnect")) {
            const reason = this.disconnection_reason;
            if (this.disconnection_cause === Strophe.Status.AUTHFAIL) {
                if (api.settings.get("credentials_url") || api.settings.get("authentication") === ANONYMOUS) {
                    // If `credentials_url` is set, we reconnect, because we might
                    // be receiving expirable tokens from the credentials_url.
                    //
                    // If `authentication` is anonymous, we reconnect because we
                    // might have tried to attach with stale BOSH session tokens
                    // or with a cached JID and password
                    return api.connection.reconnect();
                } else {
                    return this.finishDisconnection();
                }
            } else if (this.status === Strophe.Status.CONNECTING) {
                // Don't try to reconnect if we were never connected to begin
                // with, otherwise an infinite loop can occur (e.g. when the
                // BOSH service URL returns a 404).
                const { __ } = shared_converse;
                this.setConnectionStatus(
                    Strophe.Status.CONNFAIL,
                    __('An error occurred while connecting to the chat server.')
                );
                return this.finishDisconnection();
            } else if (
                this.disconnection_cause === LOGOUT ||
                reason === Strophe.ErrorCondition.NO_AUTH_MECH ||
                reason === "host-unknown" ||
                reason === "remote-connection-failed" ||
                reason === "not-well-formed"
            ) {
                return this.finishDisconnection();
            }
            api.connection.reconnect();
        } else {
            return this.finishDisconnection();
        }
    }

    /**
     * Callback method called by Strophe as the Connection goes
     * through various states while establishing or tearing down a
     * connection.
     * @param {Number} status
     * @param {String} [condition]
     */
    onConnectStatusChanged (status, condition) {
        const { __ } = shared_converse;
        src_log.debug(`Status changed to: ${CONNECTION_STATUS[status]}`);
        if (status === Strophe.Status.ATTACHFAIL) {
            this.setConnectionStatus(status);
            this.worker_attach_promise?.resolve(false);

        } else if (status === Strophe.Status.CONNECTED || status === Strophe.Status.ATTACHED) {
            if (this.worker_attach_promise?.isResolved && this.status === Strophe.Status.ATTACHED) {
                // A different tab must have attached, so nothing to do for us here.
                return;
            }
            this.setConnectionStatus(status);
            this.worker_attach_promise?.resolve(true);

            this.setDisconnectionCause();
            if (this.restored) {
                // No need to send an initial presence stanza when
                // we're restoring an existing session (e.g. via SMACKS resume).
                this.send_initial_presence = false;
            }
            if (this.reconnecting) {
                src_log.debug(status === Strophe.Status.CONNECTED ? 'Reconnected' : 'Reattached');
                this.onConnected(true);
            } else {
                src_log.debug(status === Strophe.Status.CONNECTED ? 'Connected' : 'Attached');
                this.onConnected();
            }
        } else if (status === Strophe.Status.DISCONNECTED) {
            this.setDisconnectionCause(status, condition);
            this.onDisconnected();
        } else if (status === Strophe.Status.BINDREQUIRED) {
            this.bind();
        } else if (status === Strophe.Status.ERROR) {
            this.setConnectionStatus(
                status,
                __('An error occurred while connecting to the chat server.')
            );

        } else if (status === Strophe.Status.CONNECTING) {
            this.setConnectionStatus(status);
        } else if (status === Strophe.Status.AUTHENTICATING) {
            this.setConnectionStatus(status);
        } else if (status === Strophe.Status.AUTHFAIL) {
            if (!condition) {
                condition = __('Your XMPP address and/or password is incorrect. Please try again.');
            }
            this.setConnectionStatus(status, condition);
            this.setDisconnectionCause(status, condition, true);
            this.onDisconnected();

        } else if (status === Strophe.Status.CONNFAIL) {
            let feedback = condition;
            if (condition === "host-unknown" || condition == "remote-connection-failed") {
                feedback = __("We could not connect to %1$s, is your XMPP address correct?",
                    Strophe.getDomainFromJid(this.jid));
            } else if (condition === 'policy-violation') {
                feedback = __("The XMPP server rejected the connection because of a policy violation");
            } else if (condition !== undefined && condition === Strophe?.ErrorCondition?.NO_AUTH_MECH) {
                feedback = __("The XMPP server did not offer a supported authentication mechanism");
            }
            this.setConnectionStatus(status, feedback);
            this.setDisconnectionCause(status, condition);

        } else if (status === Strophe.Status.DISCONNECTING) {
            this.setConnectionStatus(status);
            this.setDisconnectionCause(status, condition);
        }
    }

    /**
     * @param {string} type
     */
    isType (type) {
        if (type.toLowerCase() === 'websocket') {
            return this._proto instanceof Strophe.Websocket;
        } else if (type.toLowerCase() === 'bosh') {
            return Strophe.Bosh && this._proto instanceof Strophe.Bosh;
        }
    }

    hasResumed () {
        const { api } = shared_converse;
        if (api.settings.get("connection_options")?.worker || this.isType('bosh')) {
            return shared_converse.state.connfeedback.get('connection_status') === Strophe.Status.ATTACHED;
        } else {
            // Not binding means that the session was resumed.
            return !this.do_bind;
        }
    }

    restoreWorkerSession () {
        this.attach(this.onConnectStatusChanged);
        this.worker_attach_promise = getOpenPromise();
        return this.worker_attach_promise;
    }
}


/**
 * The MockConnection class is used during testing, to mock an XMPP connection.
 */
class MockConnection extends connection_Connection {

    /**
     * @param {string} service - The BOSH or WebSocket service URL.
     * @param {import('strophe.js/src/types/connection').ConnectionOptions} options - The configuration options
     */
    constructor (service, options) {
        super(service, options);

        this.sent_stanzas = [];
        this.IQ_stanzas = [];
        this.IQ_ids = [];

        this.features = Strophe.xmlHtmlNode(
            '<stream:features xmlns:stream="http://etherx.jabber.org/streams" xmlns="jabber:client">'+
                '<ver xmlns="urn:xmpp:features:rosterver"/>'+
                '<csi xmlns="urn:xmpp:csi:0"/>'+
                '<this xmlns="http://jabber.org/protocol/caps" ver="UwBpfJpEt3IoLYfWma/o/p3FFRo=" hash="sha-1" node="http://prosody.im"/>'+
                '<bind xmlns="urn:ietf:params:xml:ns:xmpp-bind">'+
                    '<required/>'+
                '</bind>'+
                `<sm xmlns='urn:xmpp:sm:3'/>`+
                '<session xmlns="urn:ietf:params:xml:ns:xmpp-session">'+
                    '<optional/>'+
                '</session>'+
            '</stream:features>').firstElementChild;

        // @ts-ignore
        this._proto._processRequest = () => {};
        this._proto._disconnect = () => this._onDisconnectTimeout();
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this._proto._onDisconnectTimeout = () => {};
        this._proto._connect = () => {
            this.connected = true;
            this.mock = true;
            this.jid = 'romeo@montague.lit/orchard';
            this._changeConnectStatus(Strophe.Status.BINDREQUIRED);
        }
    }

    // @ts-ignore
    get _sasl_mechanism () {
        return new Strophe.SASLSHA256();
    }

    _processRequest () { // eslint-disable-line class-methods-use-this
        // Don't attempt to send out stanzas
    }

    sendIQ (iq, callback, errback) {
        iq = iq.tree?.() ?? iq;

        this.IQ_stanzas.push(iq);
        const id = super.sendIQ(iq, callback, errback);
        this.IQ_ids.push(id);
        return id;
    }

    send (stanza) {
        stanza = stanza.tree?.() ?? stanza;
        this.sent_stanzas.push(stanza);
        return super.send(stanza);
    }

    async bind () {
        const { api } = shared_converse;
        await api.trigger('beforeResourceBinding', {'synchronous': true});
        this.authenticated = true;
        this._changeConnectStatus(Strophe.Status.CONNECTED);
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/connection/api.js









let api_connection;

const default_connection_options = { 'explicitResourceBinding': true };


/**
 * This grouping collects API functions related to the XMPP connection.
 *
 * @namespace api.connection
 * @memberOf api
 */
/* export default */ const connection_api = ({
    /**
     * @method api.connection.init
     * @memberOf api.connection
     * @param {string} [jid]
     * @return {Connection|MockConnection}
     */
    init (jid) {
        if (jid && api_connection?.jid && isSameDomain(api_connection.jid, jid)) return api_connection;

        if (!settings_api.get('bosh_service_url') && settings_api.get('authentication') === PREBIND) {
            throw new Error("authentication is set to 'prebind' but we don't have a BOSH connection");
        }

        const XMPPConnection = isTestEnv() ? MockConnection : connection_Connection;
        api_connection = new XMPPConnection(
            getConnectionServiceURL(),
            Object.assign(default_connection_options, settings_api.get('connection_options'), {
                'keepalive': settings_api.get('keepalive'),
            })
        );

        setStropheLogLevel();
        /**
         * Triggered once the `Connection` constructor has been initialized, which
         * will be responsible for managing the connection to the XMPP server.
         *
         * @event connectionInitialized
         */
        api_events.trigger('connectionInitialized');

        return api_connection;
    },

    get () {
        return api_connection;
    },

    destroy () {
        this.disconnect();
        api_connection?.disconnect();
        api_connection = undefined;
    },

    /**
     * @method api.connection.authenticated
     * @memberOf api.connection
     * @returns {boolean} Whether we're authenticated to the XMPP server or not
     */
    authenticated () {
        return api_connection?.authenticated && true;
    },

    /**
     * @method api.connection.connected
     * @memberOf api.connection
     * @returns {boolean} Whether there is an established connection or not.
     */
    connected () {
        return api_connection?.connected && true;
    },

    /**
     * Terminates the connection.
     *
     * @method api.connection.disconnect
     * @memberOf api.connection
     */
    disconnect () {
        api_connection?.disconnect();
    },

    /**
     * Can be called once the XMPP connection has dropped and we want
     * to attempt reconnection.
     * Only needs to be called once, if reconnect fails Converse will
     * attempt to reconnect every two seconds, alternating between BOSH and
     * Websocket if URLs for both were provided.
     * @method reconnect
     * @memberOf api.connection
     */
    reconnect () {
        api_connection.setConnectionStatus(
            Strophe.Status.RECONNECTING,
            'The connection has dropped, attempting to reconnect.'
        );
        if (api_connection?.reconnecting) {
            return api_connection.debouncedReconnect();
        } else {
            return api_connection.reconnect();
        }
    },

    /**
     * Utility method to determine the type of connection we have
     * @method isType
     * @memberOf api.connection
     * @returns {boolean}
     */
    isType (type) {
        return api_connection.isType(type);
    },
});

;// CONCATENATED MODULE: ./src/headless/utils/promise.js





/**
 * Debounces a function by waiting for the timeout period before calling it.
 * If the function gets called again, the timeout period resets.
 * The returned function has a `.flush()` method to invoke immediately.
 * @param {Function} func
 * @param {number} timeout
 */
function promise_debounce(func, timeout) {
    let timer;
    let lastArgs = [];
    let lastThis;

    function debounced(...args) {
        lastArgs = args;
        lastThis = this;
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(lastThis, lastArgs);
        }, timeout);
    }

    debounced.flush = function () {
        clearTimeout(timer);
        func.apply(lastThis, lastArgs);
    };

    return debounced;
}

/**
 * Clears the specified timeout and interval.
 * @method u#clearTimers
 * @param {ReturnType<typeof setTimeout>} timeout - Id if the timeout to clear.
 * @param {ReturnType<typeof setInterval>} interval - Id of the interval to clear.
 * @copyright Simen Bekkhus 2016
 * @license MIT
 */
function clearTimers(timeout, interval) {
    clearTimeout(timeout);
    clearInterval(interval);
}

/**
 * Creates a {@link Promise} that resolves if the passed in function returns a truthy value.
 * Rejects if it throws or does not return truthy within the given max_wait.
 * @param { Function } func - The function called every check_delay,
 *  and the result of which is the resolved value of the promise.
 * @param { number } [max_wait=300] - The time to wait before rejecting the promise.
 * @param { number } [check_delay=3] - The time to wait before each invocation of {func}.
 * @returns {Promise} A promise resolved with the value of func,
 *  or rejected with the exception thrown by it or it times out.
 * @copyright Simen Bekkhus 2016
 * @license MIT
 */
function waitUntil(func, max_wait = 300, check_delay = 3) {
    // Run the function once without setting up any listeners in case it's already true
    try {
        const result = func();
        if (result) {
            return Promise.resolve(result);
        }
    } catch (e) {
        return Promise.reject(e);
    }

    const promise = getOpenPromise();
    const timeout_err = new Error();

    function checker() {
        try {
            const result = func();
            if (result) {
                clearTimers(max_wait_timeout, interval);
                promise.resolve(result);
            }
        } catch (e) {
            clearTimers(max_wait_timeout, interval);
            promise.reject(e);
        }
    }

    const interval = setInterval(checker, check_delay);

    function handler() {
        clearTimers(max_wait_timeout, interval);
        const err_msg = `Wait until promise timed out: \n\n${timeout_err.stack}`;
        console.trace();
        src_log.error(err_msg);
        promise.reject(new Error(err_msg));
    }

    const max_wait_timeout = setTimeout(handler, max_wait);

    return promise;
}

;// CONCATENATED MODULE: ./src/headless/shared/api/promise.js





/* export default */ const api_promise = ({
    /**
     * Converse and its plugins trigger various events which you can listen to via the
     * {@link _converse.api.listen} namespace.
     *
     * Some of these events are also available as Promises although not all of them could
     * logically act as promises, since some events might be fired multiple times whereas
     * promises are to be resolved (or rejected) only once.
     *
     * Events which are also promises include:
     *
     * * cachedRoster
     * * chatBoxesFetched
     * * pluginsInitialized
     * * roster
     * * rosterContactsFetched
     * * rosterGroupsFetched
     * * rosterInitialized
     *
     * The various plugins might also provide promises, and they do this by using the
     * `promises.add` api method.
     *
     * @namespace _converse.api.promises
     * @memberOf _converse.api
     */
    promises: {
        /**
         * By calling `promises.add`, a new [Promise](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise)
         * is made available for other code or plugins to depend on via the
         * {@link _converse.api.waitUntil} method.
         *
         * Generally, it's the responsibility of the plugin which adds the promise to
         * also resolve it.
         *
         * This is done by calling {@link _converse.api.trigger}, which not only resolves the
         * promise, but also emits an event with the same name (which can be listened to
         * via {@link _converse.api.listen}).
         *
         * @method _converse.api.promises.add
         * @param {string|array} [promises] The name or an array of names for the promise(s) to be added
         * @param {boolean} [replace=true] Whether this promise should be replaced with a new one when the user logs out.
         * @example _converse.api.promises.add('foo-completed');
         */
        add(promises, replace = true) {
            promises = Array.isArray(promises) ? promises : [promises];
            promises.forEach((name) => {
                /** @type {import('../types').ReplaceableOpenPromise} */
                const promise = getOpenPromise();
                promise.replace = replace;
                shared_converse.promises[name] = promise;
            });
        },
    },

    /**
     * Wait until a promise is resolved or until the passed in function returns
     * a truthy value.
     * @method _converse.api.waitUntil
     * @param {string|function} condition - The name of the promise to wait for,
     * or a function which should eventually return a truthy value.
     * @returns {Promise}
     */
    waitUntil(condition) {
        if (object_isFunction(condition)) {
            return waitUntil(/** @type {Function} */ (condition));
        } else {
            const promise = shared_converse.promises[condition];
            if (promise === undefined) {
                return null;
            }
            return promise;
        }
    },
});

;// CONCATENATED MODULE: ./src/headless/shared/errors.js
class MethodNotImplementedError extends Error {}

class UserFacingError extends Error {
    /**
     * @param {string} message
     */
    constructor (message) {
        super(message);
        this.name = 'UserFacingError';
        this.user_facing = true;
    }
}

class IQError extends Error {
    /**
     * @param {string} message
     * @param {Element} iq
     */
    constructor (message, iq) {
        super(message);
        this.name = 'IQError';
        this.iq = iq;
    }
}

/**
 * Custom error for indicating timeouts
 * @namespace converse.env
 */
class TimeoutError extends Error {
    /**
     * @param  {string} message
     */
    constructor(message) {
        super(message);
        this.retry_event_id = null;
    }
}

class StanzaError extends Error {
    /**
     * @typedef {import("./types").ErrorName} ErrorName
     * @typedef {import("./types").ErrorType} ErrorType
     * @typedef {import("./types").ErrorExtra} ErrorExtra
     */

    /**
     * @param {ErrorName|'unknown'} name
     * @param {Element} e - The <error> element from a stanza
     * @param {Object} extra - Extra properties from plugin parsers
     */
    constructor(name, e, extra) {
        super(e.querySelector('text')?.textContent ?? '');
        /** @type {ErrorName} */
        this.name = name
        /** @type {string} */
        this.message = name;
        /** @type {ErrorType} */
        this.type = /** @type {ErrorType} */ (e.getAttribute('type'));
        /** @type {Element} */
        this.el = e;
        /** @type {ErrorExtra} */
        this.extra = extra;
    }
}

class StanzaParseError extends Error {
    /**
     * @param {Element} stanza
     * @param {string} [message]
     */
    constructor(stanza, message) {
        super(message);
        this.name = 'StanzaParseError';
        this.stanza = stanza;
    }
}

class BadRequestError extends StanzaError {}
class ConflictError extends StanzaError {}
class FeatureNotImplementedError extends StanzaError {}
class ForbiddenError extends StanzaError {}
class GoneError extends StanzaError {}
class InternalServerError extends StanzaError {}
class ItemNotFoundError extends StanzaError {}
class JIDMalformedError extends StanzaError {}
class NotAcceptableError extends StanzaError {}
class NotAllowedError extends StanzaError {}
class NotAuthorizedError extends StanzaError {}
class PaymentRequiredError extends StanzaError {}
class RecipientUnavailableError extends StanzaError {}
class RedirectError extends StanzaError {}
class RegistrationRequiredError extends StanzaError {}
class RemoteServerNotFoundError extends StanzaError {}
class RemoteServerTimeoutError extends StanzaError {}
class ResourceConstraintError extends StanzaError {}
class ServiceUnavailableError extends StanzaError {}
class SubscriptionRequiredError extends StanzaError {}
class UndefinedConditionError extends StanzaError {}
class UnexpectedRequestError extends StanzaError {}

;// CONCATENATED MODULE: ./src/headless/shared/api/send.js





/* export default */ const send = ({
    /**
     * @typedef {import('strophe.js').Builder} Builder
     *
     * Allows you to send XML stanzas.
     * @method _converse.api.send
     * @param {Element|Builder} stanza
     * @returns {void}
     * @example
     *     const { stx } = _converse.env;
     *     const msg = stx`<message from="juliet@example.com/balcony" to="romeo@example.net" type="chat"/>`;
     *     _converse.api.send(msg);
     */
    send(stanza) {
        const { api } = shared_converse;
        if (!api.connection.connected()) {
            // TODO: queue unsent messages and send once we're connected again
            src_log.warn("Not sending stanza because we're not connected!");
            src_log.warn(stanza);
            return;
        }
        const el = stanza instanceof Element ? stanza : stanza.tree();
        if (el.tagName === 'iq') {
            return api.sendIQ(el);
        } else {
            api.connection.get().send(el);
            api.trigger('send', el);
        }
    },

    /**
     * Send an IQ stanza
     * @method _converse.api.sendIQ
     * @param {Element|Builder} stanza
     * @param {number} [timeout] - The default timeout value is taken from
     *  the `stanza_timeout` configuration setting.
     * @param {boolean} [reject=true] - Whether an error IQ should cause the promise
     *  to be rejected. If `false`, the promise will resolve instead of being rejected.
     * @returns {Promise} A promise which resolves (or potentially rejected) once we
     *  receive a `result` or `error` stanza or once a timeout is reached.
     *  If the IQ stanza being sent is of type `result` or `error`, there's
     *  nothing to wait for, so an already resolved promise is returned.
     */
    sendIQ(stanza, timeout, reject = true) {
        const { api } = shared_converse;
        if (!api.connection.connected()) {
            throw new Error("Not sending IQ stanza because we're not connected!");
        }

        const connection = api.connection.get();

        let promise;
        const el = stanza instanceof Element ? stanza : stanza.tree();
        if (['get', 'set'].includes(el.getAttribute('type'))) {
            timeout = timeout || api.settings.get('stanza_timeout');
            if (reject) {
                promise = new Promise((resolve, reject) => connection.sendIQ(el, resolve, reject, timeout));
                promise.catch((e) => {
                    if (e === null) {
                        src_log.error(el);
                        throw new TimeoutError(`Timeout error after ${timeout}ms for IQ stanza`);
                    }
                });
            } else {
                promise = new Promise((resolve) => connection.sendIQ(el, resolve, resolve, timeout));
            }
        } else {
            connection.sendIQ(el);
            promise = Promise.resolve();
        }
        api.trigger('send', el);
        return promise;
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/chatboxes/utils.js
/**
 * @typedef {import('../chat/model.js').default} ChatBox
 */






async function onClearSession() {
    if (shouldClearCache(shared_converse)) {
        const { chatboxes } = shared_converse.state;
        await Promise.all(chatboxes.map(/** @param {ChatBox} c */ (c) => c.messages?.clearStore({ 'silent': true })));
        chatboxes.clearStore(
            { silent: true },
            /** @param {import('../../shared/chatbox').default} o */ (o) => o.get('type') !== CONTROLBOX_TYPE
        );
    }
}

/**
 * @param {string} jid
 * @param {object} attrs
 * @param {new (attrs: object, options: object) => ChatBox} Model
 */
async function createChatBox(jid, attrs, Model) {
    jid = Strophe.getBareJidFromJid(jid.toLowerCase());
    Object.assign(attrs, { 'jid': jid, 'id': jid });
    let chatbox;
    try {
        chatbox = new Model(attrs, { 'collection': shared_converse.state.chatboxes });
    } catch (e) {
        src_log.error(e);
        return null;
    }
    await chatbox.initialized;
    if (!chatbox.isValid()) {
        chatbox.destroy();
        return null;
    }
    shared_converse.state.chatboxes.add(chatbox);
    return chatbox;
}

;// CONCATENATED MODULE: ./src/headless/plugins/chatboxes/api.js
/**
 * @typedef {import('@converse/skeletor').Model} Model
 * @typedef {import('../chat/model.js').default} ChatBox
 */




const { waitUntil: api_waitUntil } = api_promise;
const _chatBoxTypes = {};

/**
 * The "chatboxes" namespace.
 *
 * @namespace api.chatboxes
 * @memberOf api
 */
/* export default */ const chatboxes_api = ({
    /**
     * @typedef {new (attrs: object, options: object) => ChatBox} ModelClass
     */

    /**
     * @method api.chatboxes.create
     * @param {string|string[]} jids - A JID or array of JIDs
     * @param {Object} attrs An object containing configuration attributes
     * @param {ModelClass} model - The type of chatbox that should be created
     */
    async create (jids=[], attrs={}, model) {
        await api_waitUntil('chatBoxesFetched');
        if (typeof jids === 'string') {
            return createChatBox(jids, attrs, model);
        } else {
            return Promise.all(jids.map(jid => createChatBox(jid, attrs, model)));
        }
    },

    /**
     * @method api.chatboxes.get
     * @param {string|string[]} [jids] - A JID or array of JIDs
     */
    async get (jids) {
        await api_waitUntil('chatBoxesFetched');
        const { chatboxes } = shared_converse.state;
        if (jids === undefined) {
            return chatboxes.models;
        } else if (typeof jids === 'string') {
            return chatboxes.get(jids.toLowerCase());
        } else {
            jids = jids.map(j => j.toLowerCase());
            return chatboxes.models.filter(m => jids.includes(m.get('jid')));
        }
    },

    /**
     * The "chatboxes" registry.
     * Allows you to register more chatbox types that can be created via
     * `api.chatboxes.create`.
     * @namespace api.chatboxes.registry
     * @memberOf api.chatboxes
     */
    registry: {

        /**
         * @method api.chatboxes.registry.add
         * Add another type of chatbox that can be added to this collection.
         * This is used in the `createModel` function to determine what type of
         * chatbox class to instantiate (e.g. ChatBox, MUC, Feed etc.) based on the
         * passed in attributes.
         * @param {string} type - The type name
         * @param {ModelClass} model - The model which will be instantiated for the given type name.
         */
        add(type, model) {
            _chatBoxTypes[type] = model;
        },

        /**
         * @method api.chatboxes.registry.get
         * @param {string} type - The type name
         * @return {ModelClass} model - The model which will be instantiated for the given type name.
         */
        get(type) {
            return _chatBoxTypes[type];
        }
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/muc/api.js
/**
 * @typedef {import('./muc.js').default} MUC
 */









const { waitUntil: muc_api_waitUntil } = api_promise;

/**
 * The "rooms" namespace groups methods relevant to chatrooms
 * (aka groupchats).
 *
 * @namespace api.rooms
 * @memberOf api
 */
const api_rooms = {
    /**
     * Creates a new MUC chatroom (aka groupchat)
     *
     * Similar to {@link api.rooms.open}, but creates
     * the chatroom in the background (i.e. doesn't cause a view to open).
     *
     * @method api.rooms.create
     * @param {(string[]|string)} jids The JID or array of
     *     JIDs of the chatroom(s) to create
     * @param {object} [attrs] attrs The room attributes
     * @returns {Promise<MUC[]|MUC>} Promise which resolves with the Model representing the chat.
     */
    create(jids, attrs = {}) {
        attrs = typeof attrs === 'string' ? { 'nick': attrs } : attrs || {};
        if (!attrs.nick && settings_api.get('muc_nickname_from_jid')) {
            const bare_jid = shared_converse.session.get('bare_jid');
            attrs.nick = Strophe.getNodeFromJid(bare_jid);
        }
        if (jids === undefined) {
            throw new TypeError('rooms.create: You need to provide at least one JID');
        } else if (typeof jids === 'string') {
            return api_rooms.get(getJIDFromURI(jids), attrs, true);
        }
        return Promise.all(jids.map((jid) => /** @type {Promise<MUC>} */ (api_rooms.get(getJIDFromURI(jid), attrs, true))));
    },

    /**
     * Opens a MUC chatroom (aka groupchat)
     *
     * Similar to {@link api.chats.open}, but for groupchats.
     *
     * @method api.rooms.open
     * @param {string|string[]} jids The room JID or JIDs (if not specified, all
     *     currently open rooms will be returned).
     * @param {object} attrs A map  containing any extra room attributes.
     * @param {string} [attrs.nick] The current user's nickname for the MUC
     * @param {boolean} [attrs.hidden]
     * @param {boolean} [attrs.auto_configure] A boolean, indicating
     *     whether the room should be configured automatically or not.
     *     If set to `true`, then it makes sense to pass in configuration settings.
     * @param {object} [attrs.roomconfig] A map of configuration settings to be used when the room gets
     *     configured automatically. Currently it doesn't make sense to specify
     *     `roomconfig` values if `auto_configure` is set to `false`.
     *     For a list of configuration values that can be passed in, refer to these values
     *     in the [XEP-0045 MUC specification](https://xmpp.org/extensions/xep-0045.html#registrar-formtype-owner).
     *     The values should be named without the `muc#roomconfig_` prefix.
     * @param {boolean} [attrs.minimized] A boolean, indicating whether the room should be opened minimized or not.
     * @param {boolean} [force=false] - By default, a minimized
     *   room won't be maximized (in `overlayed` view mode) and in
     *   `fullscreen` view mode a newly opened room won't replace
     *   another chat already in the foreground.
     *   Set `force` to `true` if you want to force the room to be
     *   maximized or shown.
     * @returns {Promise<MUC[]|MUC>} Promise which resolves with the Model representing the chat.
     *
     * @example
     * api.rooms.open('group@muc.example.com')
     *
     * @example
     * // To return an array of rooms, provide an array of room JIDs:
     * api.rooms.open(['group1@muc.example.com', 'group2@muc.example.com'])
     *
     * @example
     * // To setup a custom nickname when joining the room, provide the optional nick argument:
     * api.rooms.open('group@muc.example.com', {'nick': 'mycustomnick'})
     *
     * @example
     * // For example, opening a room with a specific default configuration:
     * api.rooms.open(
     *     'myroom@conference.example.org',
     *     { 'nick': 'coolguy69',
     *       'auto_configure': true,
     *       'roomconfig': {
     *           'changesubject': false,
     *           'membersonly': true,
     *           'persistentroom': true,
     *           'publicroom': true,
     *           'roomdesc': 'Comfy room for hanging out',
     *           'whois': 'anyone'
     *       }
     *     }
     * );
     */
    async open(jids, attrs = {}, force = false) {
        await muc_api_waitUntil('chatBoxesFetched');
        if (jids === undefined) {
            const err_msg = 'rooms.open: You need to provide at least one JID';
            src_log.error(err_msg);
            throw new TypeError(err_msg);
        } else if (typeof jids === 'string') {
            const room = /** @type {MUC} */ (await api_rooms.get(jids, attrs, true));
            !attrs.hidden && room?.maybeShow(force);
            return room;
        } else {
            const rooms = await Promise.all(jids.map((jid) => rooms.get(jid, attrs, true)));
            rooms.forEach((r) => !attrs.hidden && r.maybeShow(force));
            return rooms;
        }
    },

    /**
     * Fetches the object representing a MUC chatroom (aka groupchat)
     *
     * @method api.rooms.get
     * @param {string|string[]} [jids] The room JID (if not specified, all rooms will be returned).
     * @param {object} [attrs] A map containing any extra room attributes
     *  to be set if `create` is set to `true`
     * @param {string} [attrs.nick] Specify the nickname
     * @param {string} [attrs.password ] Specify a password if needed to enter a new room
     * @param {boolean} create A boolean indicating whether the room should be created
     *     if not found (default: `false`)
     * @returns {Promise<MUC[]|MUC>}
     * @example
     * api.waitUntil('roomsAutoJoined').then(() => {
     *     const create_if_not_found = true;
     *     api.rooms.get(
     *         'group@muc.example.com',
     *         {'nick': 'dread-pirate-roberts', 'password': 'secret'},
     *         create_if_not_found
     *     )
     * });
     */
    async get(jids, attrs = {}, create = false) {
        await muc_api_waitUntil('chatBoxesFetched');

        /** @param {string} jid */
        async function _get(jid) {
            jid = getJIDFromURI(jid);
            let model = await chatboxes_api.get(jid);
            if (!model && create) {
                model = await chatboxes_api.create(jid, attrs, shared_converse.exports.MUC);
            } else {
                model = model && model.get('type') === CHATROOMS_TYPE ? model : null;
                if (model && Object.keys(attrs).length) {
                    model.save(attrs);
                }
            }
            return model;
        }
        if (jids === undefined) {
            const chats = await chatboxes_api.get();
            return chats?.filter((c) => c.get('type') === CHATROOMS_TYPE) ?? [];
        } else if (typeof jids === 'string') {
            return _get(jids);
        }
        return Promise.all(jids.map((jid) => _get(jid)));
    },
};

const rooms_api = { rooms: api_rooms };

/* export default */ const muc_api = (rooms_api);

;// CONCATENATED MODULE: ./src/headless/shared/api/presence.js
/**
 * @typedef {import('strophe.js').Builder} Builder
 * @typedef {import('../../plugins/status/profile').default} Profile
 * @typedef {import('../../plugins/muc/muc.js').default} MUC
 */





const { waitUntil: presence_waitUntil } = api_promise;
const { send: presence_send } = send;
const { rooms: presence_rooms } = muc_api;

/* export default */ const api_presence = ({
    /**
     * @namespace _converse.api.user.presence
     * @memberOf _converse.api.user
     */
    presence: {
        /**
         * Send out a presence stanza
         * @method _converse.api.user.presence.send
         * @param {import('../../plugins/status/types').PresenceAttrs} [attrs]
         * @param {Array<Element>|Array<Builder>|Element|Builder} [nodes]
         *  Nodes(s) to be added as child nodes of the `presence` XML element.
         */
        async send(attrs, nodes) {
            await presence_waitUntil('statusInitialized');

            let children = [];
            if (nodes) {
                children = Array.isArray(nodes) ? nodes : [nodes];
            }

            const model = /** @type {Profile} */ (shared_converse.state.profile);
            const presence = await model.constructPresence(attrs);
            children.map((c) => c?.tree() ?? c).forEach((c) => presence.cnode(c).up());
            presence_send(presence);

            const { show, type } = attrs || {};
            if (show || !type) {
                const mucs = /** @type {MUC[]} */ (await presence_rooms.get());
                mucs.forEach((muc) => muc.sendStatusPresence(attrs, children));
            }
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/shared/settings/user/utils.js





let utils_user_settings; // User settings, populated via api.users.settings

/**
 * @returns {Promise<void>|void} A promise when the user settings object
 *  is created anew and it's contents fetched from storage.
 */
function initUserSettings () {
    const bare_jid = shared_converse.session.get('bare_jid');
    if (!bare_jid) {
        const msg = "No JID to fetch user settings for";
        src_log.error(msg);
        throw Error(msg);
    }
    const id = `converse.user-settings.${bare_jid}`;
    if (utils_user_settings?.get('id') !== id) {
        utils_user_settings = new skeletor.Model({id});
        initStorage(utils_user_settings, id);
        return utils_user_settings.fetch({'promise': true});
    }
}

async function getUserSettings () {
    await initUserSettings();
    return utils_user_settings;
}

async function updateUserSettings (data, options) {
    await initUserSettings();
    return utils_user_settings.save(data, options);
}

async function clearUserSettings () {
    const bare_jid = shared_converse.session.get('bare_jid');
    if (bare_jid) {
        await initUserSettings();
        return utils_user_settings.clear();
    }
    utils_user_settings = undefined;
}

;// CONCATENATED MODULE: ./src/headless/shared/settings/user/api.js
/**
 * @typedef {import('@converse/skeletor').Model} Model
 */


/**
 * API for accessing and setting user settings. User settings are
 * different from the application settings from {@link _converse.api.settings}
 * because they are per-user and set via user action.
 * @namespace _converse.api.user.settings
 * @memberOf _converse.api.user
 */
const user_settings_api = {
    /**
     * Returns the user settings model. Useful when you want to listen for change events.
     * @async
     * @method _converse.api.user.settings.getModel
     * @returns {Promise<Model>}
     * @example const settings = await api.user.settings.getModel();
     */
    getModel () {
        return getUserSettings();
    },

    /**
     * Get the value of a particular user setting.
     * @method _converse.api.user.settings.get
     * @param {string} key - The setting name
     * @param {*} [fallback] - An optional fallback value if the user setting is undefined
     * @returns {Promise} Promise which resolves with the value of the particular configuration setting.
     * @example api.user.settings.get("foo");
     */
    async get (key, fallback) {
        const user_settings = await getUserSettings();
        return user_settings.get(key) === undefined ? fallback : user_settings.get(key);
    },

    /**
     * Set one or many user settings.
     * @async
     * @method _converse.api.user.settings.set
     * @param {Object|string} key An object containing config settings or alternatively a string key
     * @param {string} [val] The value, if the previous parameter is a key
     * @example api.user.settings.set("foo", "bar");
     * @example
     * api.user.settings.set({
     *     "foo": "bar",
     *     "baz": "buz"
     * });
     */
    set (key, val) {
        if (key instanceof Object) {
            return updateUserSettings(key, {'promise': true});
        } else {
            const o = {};
            o[key] = val;
            return updateUserSettings(o, {'promise': true});
        }
    },

    /**
     * Clears all the user settings
     * @async
     * @method api.user.settings.clear
     */
    clear () {
        return clearUserSettings();
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/api/user.js
/**
 * @module:shared.api.user
 */









const user_api = {
    /**
     * This grouping collects API functions related to the current logged in user.
     *
     * @namespace _converse.api.user
     * @memberOf _converse.api
     */
    user: {
        settings: user_settings_api,
        ...api_presence,

        /**
         * @method _converse.api.user.jid
         * @returns {string} The current user's full JID (Jabber ID)
         * @example _converse.api.user.jid())
         */
        jid() {
            return connection_api.get()?.jid;
        },

        /**
         * Logs the user in.
         *
         * If called without any parameters, Converse will try
         * to log the user in by calling the `prebind_url` or `credentials_url` depending
         * on whether prebinding is used or not.
         *
         * @method _converse.api.user.login
         * @param { string } [jid]
         * @param { string } [password]
         * @param { boolean } [automatic=false] - An internally used flag that indicates whether
         *  this method was called automatically once the connection has been
         *  initialized. It's used together with the `auto_login` configuration flag
         *  to determine whether Converse should try to log the user in if it
         *  fails to restore a previous auth'd session.
         *  @returns  { Promise<void> }
         */
        async login(jid, password, automatic = false) {
            const { api } = shared_converse;
            jid = jid || api.settings.get('jid');

            const connection = connection_api.init(jid);

            if (api.settings.get('connection_options')?.worker && (await connection.restoreWorkerSession())) {
                return;
            }
            if (jid) {
                jid = await setUserJID(jid);
            }

            /**
             * *Hook* which allows 3rd party code to attempt logging in before
             * the core code attempts it.
             *
             * Note: If the hook handler has logged the user in, it should set the
             * `success` flag on the payload to `true`.
             *
             * @typedef {Object} LoginHookPayload
             * @property {string} jid
             * @property {string} password
             * @property {boolean} [automatic] - An internally used flag that indicates whether
             *  this method was called automatically once the connection has been initialized.
             * @property {boolean} [success] - A flag which indicates whether
             * login has succeeded. If a hook handler receives a payload with
             * this flag, it should NOT attempt to log in.
             * If a handler has successfully logged in, it should return the
             * payload with this flag set to true.
             *
             * @event _converse#login
             * @param {typeof api.user} context
             * @param {LoginHookPayload} payload
             */
            const { success } = await shared_converse.api.hook('login', this, { jid, password, automatic });
            if (success) return;

            password = password || api.settings.get('password');
            const credentials = jid && password ? { jid, password } : null;
            await attemptNonPreboundSession(credentials, automatic);
        },

        /**
         * Logs the user out of the current XMPP session.
         * @method _converse.api.user.logout
         * @example _converse.api.user.logout();
         */
        async logout() {
            const { api } = shared_converse;
            /**
             * Triggered before the user is logged out
             * @event _converse#beforeLogout
             */
            await api.trigger('beforeLogout', { 'synchronous': true });

            const promise = getOpenPromise();
            const complete = () => {
                // Recreate all the promises
                Object.keys(shared_converse.promises).forEach((p) => replacePromise(shared_converse, p));

                // Remove the session JID, otherwise the user would just be logged
                // in again upon reload. See #2759
                localStorage.removeItem('conversejs-session-jid');

                /**
                 * Triggered once the user has logged out.
                 * @event _converse#logout
                 */
                api.trigger('logout');
                promise.resolve();
            };

            const connection = connection_api.get();
            if (connection) {
                connection.setDisconnectionCause(LOGOUT, undefined, true);
                api.listen.once('disconnected', () => complete());
                connection.disconnect();
            } else {
                complete();
            }
            return promise;
        },
    },
};

/* export default */ const user = (user_api);

;// CONCATENATED MODULE: ./src/headless/shared/api/index.js
/**
 * @typedef {import('../_converse.js').default} _converse
 * @typedef {module:shared-api.APIEndpoint} APIEndpoint
 */







/**
 * ### The private API
 *
 * The private API methods are only accessible via the closured {@link _converse}
 * object, which is only available to plugins.
 *
 * These methods are kept private (i.e. not global) because they may return
 * sensitive data which should be kept off-limits to other 3rd-party scripts
 * that might be running in the page.
 *
 * @memberOf _converse
 * @namespace api
 * @typedef {Record<string, Function>} module:shared-api.APIEndpoint
 * @typedef {Record<string, APIEndpoint|Function>} APINamespace
 * @typedef {Record<string, APINamespace|APIEndpoint|Function>} API
 * @type {API}
 */
const api_api = {
    connection: connection_api,
    settings: settings_api,
    ...send,
    ...user,
    ...api_events,
    ...api_promise,

    disco: null,
    elements: null,
    contacts: null,
};

/* export default */ const shared_api = (api_api);

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(353);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/advancedFormat.js
var advancedFormat = __webpack_require__(375);
var advancedFormat_default = /*#__PURE__*/__webpack_require__.n(advancedFormat);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/localizedFormat.js
var localizedFormat = __webpack_require__(750);
var localizedFormat_default = /*#__PURE__*/__webpack_require__.n(localizedFormat);
;// CONCATENATED MODULE: ./node_modules/filesize/dist/filesize.js
/**
 * filesize
 *
 * @copyright 2026 Jason Mulligan <jason.mulligan@avoidwork.com>
 * @license BSD-3-Clause
 * @version 11.0.17
 */
// Error Messages
const INVALID_NUMBER = "Invalid number";
const INVALID_ROUND = "Invalid rounding method";

// Standard Types
const IEC = "iec";
const JEDEC = "jedec";
const SI = "si";

// Unit Types
const BIT = "bit";
const BITS = "bits";
const BYTE = "byte";
const BYTES = "bytes";
const SI_KBIT = "kbit";
const SI_KBYTE = "kB";

// Output Format Types
const ARRAY = "array";
const FUNCTION = "function";
const OBJECT = "object";
const STRING = "string";

// Processing Constants
const EXPONENT = "exponent";
const ROUND = "round";

// Special Characters and Values
const E = "e";
const EMPTY = "";
const PERIOD = ".";
const filesize_S = "s";
const SPACE = " ";
const ZERO = "0";

// Data Structures
const STRINGS = {
	symbol: {
		iec: {
			bits: ["bit", "Kibit", "Mibit", "Gibit", "Tibit", "Pibit", "Eibit", "Zibit", "Yibit"],
			bytes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"],
		},
		jedec: {
			bits: ["bit", "Kbit", "Mbit", "Gbit", "Tbit", "Pbit", "Ebit", "Zbit", "Ybit"],
			bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
		},
	},
	fullform: {
		iec: ["", "kibi", "mebi", "gibi", "tebi", "pebi", "exbi", "zebi", "yobi"],
		jedec: ["", "kilo", "mega", "giga", "tera", "peta", "exa", "zetta", "yotta"],
	},
};

// Pre-computed lookup tables for performance optimization
const BINARY_POWERS = [
	1, // 2^0
	1024, // 2^10
	1048576, // 2^20
	1073741824, // 2^30
	1099511627776, // 2^40
	1125899906842624, // 2^50
	1152921504606846976, // 2^60
	1180591620717411303424, // 2^70
	1208925819614629174706176, // 2^80
];

const DECIMAL_POWERS = [
	1, // 10^0
	1000, // 10^3
	1000000, // 10^6
	1000000000, // 10^9
	1000000000000, // 10^12
	1000000000000000, // 10^15
	1000000000000000000, // 10^18
	1000000000000000000000, // 10^21
	1000000000000000000000000, // 10^24
];

// Pre-computed log values for faster exponent calculation
const LOG_2_1024 = Math.log(1024);
const LOG_10_1000 = Math.log(1000);// Cached configuration lookup for better performance
const STANDARD_CONFIGS = {
	[SI]: { isDecimal: true, ceil: 1000, actualStandard: JEDEC },
	[IEC]: { isDecimal: false, ceil: 1024, actualStandard: IEC },
	[JEDEC]: { isDecimal: false, ceil: 1024, actualStandard: JEDEC },
};

/**
 * Optimized base configuration lookup
 * @param {string} standard - Standard type
 * @param {number} base - Base number
 * @returns {Object} Configuration object
 */
function getBaseConfiguration(standard, base) {
	// Use cached lookup table for better performance
	if (STANDARD_CONFIGS[standard]) {
		return STANDARD_CONFIGS[standard];
	}

	// Base override
	if (base === 2) {
		return { isDecimal: false, ceil: 1024, actualStandard: IEC };
	}

	// Default
	return { isDecimal: true, ceil: 1000, actualStandard: JEDEC };
}

/**
 * Optimized zero value handling
 * @param {number} precision - Precision value
 * @param {string} actualStandard - Standard to use
 * @param {boolean} bits - Whether to use bits
 * @param {Object} symbols - Custom symbols
 * @param {boolean} full - Whether to use full form
 * @param {Array} fullforms - Custom full forms
 * @param {string} output - Output format
 * @param {string} spacer - Spacer character
 * @param {string} [symbol] - Symbol to use (defaults based on bits/standard)
 * @returns {string|Array|Object|number} Formatted result
 */
function handleZeroValue(
	precision,
	actualStandard,
	bits,
	symbols,
	full,
	fullforms,
	output,
	spacer,
	symbol,
) {
	let value;
	if (precision > 0) {
		value = (0).toPrecision(precision);
	} else {
		value = 0;
	}

	if (output === EXPONENT) {
		return 0;
	}

	// Set default symbol if not provided
	if (!symbol) {
		symbol = bits
			? STRINGS.symbol[actualStandard].bits[0]
			: STRINGS.symbol[actualStandard].bytes[0];
	}

	// Apply symbol customization
	if (symbols[symbol]) {
		symbol = symbols[symbol];
	}

	// Apply full form
	if (full) {
		if (fullforms[0]) {
			symbol = fullforms[0];
		} else {
			symbol = STRINGS.fullform[actualStandard][0];
			if (bits) {
				symbol += BIT;
			} else {
				symbol += BYTE;
			}
		}
	}

	// Return in requested format
	if (output === ARRAY) {
		return [value, symbol];
	}

	if (output === OBJECT) {
		return { value, symbol, exponent: 0, unit: symbol };
	}

	return value + spacer + symbol;
}

/**
 * Optimized value calculation with bits handling
 * @param {number} num - Input number
 * @param {number} e - Exponent
 * @param {boolean} isDecimal - Whether to use decimal powers
 * @param {boolean} bits - Whether to calculate bits
 * @param {number} ceil - Ceiling value for auto-increment
 * @param {boolean} autoExponent - Whether exponent is auto (-1 or NaN)
 * @returns {Object} Object with result and e properties
 */
function calculateOptimizedValue(num, e, isDecimal, bits, ceil, autoExponent = true) {
	let d;
	if (isDecimal) {
		d = DECIMAL_POWERS[e];
	} else {
		d = BINARY_POWERS[e];
	}
	let result = num / d;

	if (bits) {
		result *= 8;
		// Handle auto-increment for bits (only when exponent is auto)
		if (autoExponent && result >= ceil && e < 8) {
			result /= ceil;
			e++;
		}
	}

	return { result, e };
}

/**
 * Optimized precision handling with scientific notation correction
 * @param {number} value - Current value
 * @param {number} precision - Precision to apply
 * @param {number} e - Current exponent
 * @param {number} num - Original number
 * @param {boolean} isDecimal - Whether using decimal base
 * @param {boolean} bits - Whether calculating bits
 * @param {number} ceil - Ceiling value
 * @param {Function} roundingFunc - Rounding function
 * @param {number} round - Round value
 * @param {number} exponent - Forced exponent (-1 for auto)
 * @returns {Object} Object with value and e properties
 */
function applyPrecisionHandling(
	value,
	precision,
	e,
	num,
	isDecimal,
	bits,
	ceil,
	roundingFunc,
	round,
	exponent,
) {
	if (typeof value === "string") {
		value = parseFloat(value);
	}

	let result = value.toPrecision(precision);

	const autoExponent = exponent === -1 || isNaN(exponent);

	// Handle scientific notation by recalculating with incremented exponent
	if (result.includes(E) && e < 8 && autoExponent) {
		e++;
		const { result: valueResult } = calculateOptimizedValue(num, e, isDecimal, bits, ceil);
		let p;
		if (round > 0) {
			p = Math.pow(10, round);
		} else {
			p = 1;
		}
		let computed;
		if (p === 1) {
			computed = roundingFunc(valueResult);
		} else {
			computed = roundingFunc(valueResult * p) / p;
		}
		result = computed.toPrecision(precision);
	}

	return { value: result, e };
}

/**
 * Optimized number formatting with locale, separator, and padding
 * @param {number|string} value - Value to format
 * @param {string|boolean} locale - Locale setting
 * @param {Object} localeOptions - Locale options
 * @param {string} separator - Custom separator
 * @param {boolean} pad - Whether to pad
 * @param {number} round - Round value
 * @returns {string|number} Formatted value
 */
function applyNumberFormatting(value, locale, localeOptions, separator, pad, round) {
	let result = value;

	// Apply locale formatting
	if (locale === true) {
		result = result.toLocaleString();
	} else if (locale.length > 0) {
		result = result.toLocaleString(locale, localeOptions);
	} else if (separator.length > 0) {
		result = result.toString().replace(PERIOD, separator);
	}

	// Apply padding
	if (pad && round > 0) {
		const resultStr = result.toString();
		const x = separator || (resultStr.slice(1).match(/[.,]/g) || []).pop() || PERIOD;
		const tmp = resultStr.split(x);
		const s = tmp[1] || EMPTY;

		const l = s.length;
		const n = round - l;

		result = `${tmp[0]}${x}${s.padEnd(l + n, ZERO)}`;
	}

	return result;
}

/**
 * Calculates exponent from the input value using pre-computed log values and clamps to supported range
 * Also adjusts precision when exponent exceeds the lookup table bounds
 * @param {number} num - Input file size in bytes
 * @param {number} e - Current exponent value
 * @param {number} exponent - Original user-provided exponent option (-1 for auto)
 * @param {boolean} isDecimal - Whether to use decimal (SI) base
 * @param {number} precision - Current precision value (modified when e > 8)
 * @returns {Object} Object with computed e value and possibly adjusted precision
 */
function calculateExponent(num, e, exponent, isDecimal, precision) {
	if (e === -1 || isNaN(e)) {
		if (isDecimal) {
			e = Math.floor(Math.log(num) / LOG_10_1000);
		} else {
			e = Math.floor(Math.log(num) / LOG_2_1024);
		}
		if (e < 0) {
			e = 0;
		}
	}

	if (e > 8) {
		if (precision > 0) {
			precision += 8 - e;
		}
		return { e: 8, precision };
	}

	return { e, precision };
}

/**
 * Applies rounding to the raw calculated value and handles auto-increment ceiling
 * @param {number} val - Raw value before rounding
 * @param {number} ceil - Ceiling threshold (1000 for SI, 1024 for IEC)
 * @param {number} e - Current exponent value
 * @param {number} round - Number of decimal places
 * @param {Function} roundingFunc - Rounding method (Math.round, Math.floor, Math.ceil)
 * @param {boolean} autoExponent - Whether exponent is auto-calculated (-1 or NaN)
 * @returns {Object} Object with rounded value and possibly incremented exponent
 */
function applyRounding(val, ceil, e, round, roundingFunc, autoExponent) {
	let p;
	if (e > 0 && round > 0) {
		p = Math.pow(10, round);
	} else {
		p = 1;
	}
	let r;
	if (p === 1) {
		r = roundingFunc(val);
	} else {
		r = roundingFunc(val * p) / p;
	}

	if (r === ceil && e < 8 && autoExponent) {
		r = 1;
		e++;
	}

	return { value: r, e };
}

/**
 * Resolves the unit symbol for the given standard, bits mode, and exponent
 * Handles SI standard special case where exponent 1 always uses "kB" or "kbit"
 * @param {string} actualStandard - The resolved standard (iec, jedec)
 * @param {boolean} bits - Whether formatting bit values
 * @param {number} e - Current exponent index
 * @param {boolean} isDecimal - Whether using decimal (SI) base
 * @returns {string} The resolved unit symbol string
 */
function resolveSymbol(actualStandard, bits, e, isDecimal) {
	const symbolTable = STRINGS.symbol[actualStandard][bits ? BITS : BYTES];
	let result;
	if (isDecimal && e === 1) {
		if (bits) {
			result = SI_KBIT;
		} else {
			result = SI_KBYTE;
		}
	} else {
		result = symbolTable[e];
	}
	return result;
}

/**
 * Decorates the result: applies negation, custom symbols, number formatting, and full form names
 * Mutates the result array in-place for both value (index 0) and symbol (index 1)
 * @param {Array} result - Result array with numeric value at [0] and string symbol at [1]
 * @param {boolean} neg - Whether the original input was negative
 * @param {Object} symbols - Custom symbol override map
 * @param {string|boolean} locale - Locale string for formatting
 * @param {Object} localeOptions - Additional locale formatting options
 * @param {string} separator - Custom decimal separator
 * @param {boolean} pad - Whether zero-pad decimals
 * @param {number} round - Target decimal count for padding
 * @param {boolean} full - Whether to use full unit names
 * @param {Array} fullforms - Custom full unit name overrides
 * @param {string} actualStandard - Unit standard for full form lookup
 * @param {number} e - Current exponent index
 * @param {boolean} bits - Whether formatting bit values
 * @returns {void} Mutates result array in place
 */
function decorateResult(
	result,
	neg,
	symbols,
	locale,
	localeOptions,
	separator,
	pad,
	round,
	full,
	fullforms,
	actualStandard,
	e,
	bits,
) {
	if (neg) {
		result[0] = -result[0];
	}

	if (symbols[result[1]]) {
		result[1] = symbols[result[1]];
	}

	result[0] = applyNumberFormatting(result[0], locale, localeOptions, separator, pad, round);

	if (full) {
		let unit;
		if (bits) {
			unit = BIT;
		} else {
			unit = BYTE;
		}
		let val;
		if (typeof result[0] === "string") {
			val = parseFloat(result[0]);
		} else {
			val = result[0];
		}
		// Determine singular/plural suffix
		let suffix;
		if (val === 1) {
			suffix = EMPTY;
		} else {
			suffix = filesize_S;
		}
		// Determine symbol — custom fullforms are the complete name, defaults get unit+suffix
		if (fullforms[e]) {
			result[1] = fullforms[e];
		} else {
			result[1] = STRINGS.fullform[actualStandard][e] + unit + suffix;
		}
	}
}

/**
 * Formats the computed result array into the requested output type
 * @param {Array} result - Result array with formatted value at [0] and symbol at [1]
 * @param {number} e - Current exponent
 * @param {string} u - Original resolved symbol (before custom override)
 * @param {string} output - Output type (ARRAY, OBJECT, STRING)
 * @param {string} spacer - String separator between value and unit
 * @returns {string|Array|Object|number} Formatted result in requested type
 */
function formatOutput(result, e, u, output, spacer) {
	if (output === ARRAY) {
		return result;
	}

	if (output === OBJECT) {
		return {
			value: result[0],
			symbol: result[1],
			exponent: e,
			unit: u,
		};
	}

	let formatted;
	if (spacer === SPACE) {
		formatted = `${result[0]} ${result[1]}`;
	} else {
		formatted = result.join(spacer);
	}
	return formatted;
}/**
 * Converts a file size in bytes to a human-readable string with appropriate units
 * @param {number|string|bigint} arg - The file size in bytes to convert
 * @param {Object} [options={}] - Configuration options for formatting
 * @param {boolean} [options.bits=false] - If true, calculates bits instead of bytes
 * @param {boolean} [options.pad=false] - If true, pads decimal places to match round parameter
 * @param {number} [options.base=-1] - Number base (2 for binary, 10 for decimal, -1 for auto)
 * @param {number} [options.round=2] - Number of decimal places to round to
 * @param {string|boolean} [options.locale=""] - Locale for number formatting, true for system locale
 * @param {Object} [options.localeOptions={}] - Additional options for locale formatting
 * @param {string} [options.separator=""] - Custom decimal separator
 * @param {string} [options.spacer=" "] - String to separate value and unit
 * @param {Object} [options.symbols={}] - Custom unit symbols
 * @param {string} [options.standard=""] - Unit standard to use (SI, IEC, JEDEC)
 * @param {string} [options.output="string"] - Output format: "string", "array", "object", or "exponent"
 * @param {boolean} [options.fullform=false] - If true, uses full unit names instead of abbreviations
 * @param {Array} [options.fullforms=[]] - Custom full unit names
 * @param {number} [options.exponent=-1] - Force specific exponent (-1 for auto)
 * @param {string} [options.roundingMethod="round"] - Math rounding method to use
 * @param {number} [options.precision=0] - Number of significant digits (0 for auto)
 * @returns {string|Array|Object|number} Formatted file size based on output option
 * @throws {TypeError} When arg is not a valid number or roundingMethod is invalid
 * @example
 * filesize(1024) // "1.02 kB"
 * filesize(1024, {bits: true}) // "8.19 kbit"
 * filesize(1024, {output: "object"}) // {value: 1.02, symbol: "kB", exponent: 1, unit: "kB"}
 */
function filesize(
	arg,
	{
		bits = false,
		pad = false,
		base = -1,
		round = 2,
		locale = EMPTY,
		localeOptions = {},
		separator = EMPTY,
		spacer = SPACE,
		symbols = {},
		standard = EMPTY,
		output = STRING,
		fullform = false,
		fullforms = [],
		exponent = -1,
		roundingMethod = ROUND,
		precision = 0,
	} = {},
) {
	let e = exponent,
		num,
		result = [],
		val = 0,
		u = EMPTY;

	if (typeof arg === "bigint") {
		num = Number(arg);
	} else {
		num = Number(arg);

		if (isNaN(arg)) {
			throw new TypeError(INVALID_NUMBER);
		}

		if (!isFinite(num)) {
			throw new TypeError(INVALID_NUMBER);
		}
	}

	const { isDecimal, ceil, actualStandard } = getBaseConfiguration(standard, base);

	const full = fullform === true,
		neg = num < 0,
		roundingFunc = Math[roundingMethod];

	if (typeof roundingFunc !== FUNCTION) {
		throw new TypeError(INVALID_ROUND);
	}

	if (neg) {
		num = -num;
	}

	if (num === 0) {
		return handleZeroValue(
			precision,
			actualStandard,
			bits,
			symbols,
			full,
			fullforms,
			output,
			spacer,
		);
	}

	// Exponent calculation + clamp + precision adjustment
	const { e: calculatedE, precision: precisionAdjusted } = calculateExponent(
		num,
		e,
		exponent,
		isDecimal,
		precision,
	);
	e = calculatedE;
	const autoExponent = exponent === -1 || isNaN(exponent);

	if (output === EXPONENT) {
		return e;
	}

	const { result: valueResult, e: valueExponent } = calculateOptimizedValue(
		num,
		e,
		isDecimal,
		bits,
		ceil,
		autoExponent,
	);
	val = valueResult;
	e = valueExponent;

	// Rounding + auto-increment ceiling
	const rounded = applyRounding(val, ceil, e, round, roundingFunc, autoExponent);
	result[0] = rounded.value;
	e = rounded.e;

	// Precision handling
	if (precisionAdjusted > 0) {
		const precisionResult = applyPrecisionHandling(
			result[0],
			precisionAdjusted,
			e,
			num,
			isDecimal,
			bits,
			ceil,
			roundingFunc,
			round,
			exponent,
		);
		result[0] = precisionResult.value;
		e = precisionResult.e;
	}

	u = resolveSymbol(actualStandard, bits, e, isDecimal);
	result[1] = u;

	decorateResult(
		result,
		neg,
		symbols,
		locale,
		localeOptions,
		separator,
		pad,
		round,
		full,
		fullforms,
		actualStandard,
		e,
		bits,
	);

	return formatOutput(result, e, u, output, spacer);
}

/**
 * Creates a partially applied version of filesize with preset options
 * @param {Object} [options={}] - Configuration options (same as filesize)
 * @param {boolean} [options.bits=false] - If true, calculates bits instead of bytes
 * @param {boolean} [options.pad=false] - If true, pads decimal places to match round parameter
 * @param {number} [options.base=-1] - Number base (2 for binary, 10 for decimal, -1 for auto)
 * @param {number} [options.round=2] - Number of decimal places to round to
 * @param {string|boolean} [options.locale=""] - Locale for number formatting, true for system locale
 * @param {Object} [options.localeOptions={}] - Additional options for locale formatting
 * @param {string} [options.separator=""] - Custom decimal separator
 * @param {string} [options.spacer=" "] - String to separate value and unit
 * @param {Object} [options.symbols={}] - Custom unit symbols
 * @param {string} [options.standard=""] - Unit standard to use (SI, IEC, JEDEC)
 * @param {string} [options.output="string"] - Output format: "string", "array", "object", or "exponent"
 * @param {boolean} [options.fullform=false] - If true, uses full unit names instead of abbreviations
 * @param {Array} [options.fullforms=[]] - Custom full unit names
 * @param {number} [options.exponent=-1] - Force specific exponent (-1 for auto)
 * @param {string} [options.roundingMethod="round"] - Math rounding method to use
 * @param {number} [options.precision=0] - Number of significant digits (0 for auto)
 * @returns {Function} A function that takes a file size and returns formatted output
 * @example
 * const formatBytes = partial({round: 1, standard: "iec"});
 * formatBytes(1024) // "1 KiB"
 * formatBytes(2048) // "2 KiB"
 * formatBytes(1536) // "1.5 KiB"
 */
function partial({
	bits = false,
	pad = false,
	base = -1,
	round = 2,
	locale = EMPTY,
	separator = EMPTY,
	spacer = SPACE,
	standard = EMPTY,
	output = STRING,
	fullform = false,
	exponent = -1,
	roundingMethod = ROUND,
	precision = 0,
	localeOptions = {},
	symbols = {},
	fullforms = [],
} = {}) {
	const cloned = {
		localeOptions: JSON.parse(JSON.stringify(localeOptions)),
		symbols: JSON.parse(JSON.stringify(symbols)),
		fullforms: JSON.parse(JSON.stringify(fullforms)),
	};

	return (arg) =>
		filesize(arg, {
			bits,
			pad,
			base,
			round,
			locale,
			localeOptions: cloned.localeOptions,
			separator,
			spacer,
			symbols: cloned.symbols,
			standard,
			output,
			fullform,
			fullforms: cloned.fullforms,
			exponent,
			roundingMethod,
			precision,
		});
}

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/css-tag.js
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const css_tag_t=globalThis,css_tag_e=css_tag_t.ShadowRoot&&(void 0===css_tag_t.ShadyCSS||css_tag_t.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,css_tag_s=Symbol(),css_tag_o=new WeakMap;class css_tag_n{constructor(t,e,o){if(this._$cssResult$=!0,o!==css_tag_s)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e}get styleSheet(){let t=this.o;const s=this.t;if(css_tag_e&&void 0===t){const e=void 0!==s&&1===s.length;e&&(t=css_tag_o.get(s)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),e&&css_tag_o.set(s,t))}return t}toString(){return this.cssText}}const css_tag_r=t=>new css_tag_n("string"==typeof t?t:t+"",void 0,css_tag_s),css_tag_i=(t,...e)=>{const o=1===t.length?t[0]:e.reduce((e,s,o)=>e+(t=>{if(!0===t._$cssResult$)return t.cssText;if("number"==typeof t)return t;throw Error("Value passed to 'css' function must be a 'css' function result: "+t+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(s)+t[o+1],t[0]);return new css_tag_n(o,t,css_tag_s)},css_tag_S=(s,o)=>{if(css_tag_e)s.adoptedStyleSheets=o.map(t=>t instanceof CSSStyleSheet?t:t.styleSheet);else for(const e of o){const o=document.createElement("style"),n=css_tag_t.litNonce;void 0!==n&&o.setAttribute("nonce",n),o.textContent=e.cssText,s.appendChild(o)}},css_tag_c=css_tag_e?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const s of t.cssRules)e+=s.cssText;return css_tag_r(e)})(t):t;
//# sourceMappingURL=css-tag.js.map

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/reactive-element.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const{is:reactive_element_i,defineProperty:reactive_element_e,getOwnPropertyDescriptor:reactive_element_h,getOwnPropertyNames:reactive_element_r,getOwnPropertySymbols:reactive_element_o,getPrototypeOf:reactive_element_n}=Object,reactive_element_a=globalThis,reactive_element_c=reactive_element_a.trustedTypes,reactive_element_l=reactive_element_c?reactive_element_c.emptyScript:"",reactive_element_p=reactive_element_a.reactiveElementPolyfillSupport,reactive_element_d=(t,s)=>t,reactive_element_u={toAttribute(t,s){switch(s){case Boolean:t=t?reactive_element_l:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t)}return t},fromAttribute(t,s){let i=t;switch(s){case Boolean:i=null!==t;break;case Number:i=null===t?null:Number(t);break;case Object:case Array:try{i=JSON.parse(t)}catch(t){i=null}}return i}},reactive_element_f=(t,s)=>!reactive_element_i(t,s),reactive_element_b={attribute:!0,type:String,converter:reactive_element_u,reflect:!1,useDefault:!1,hasChanged:reactive_element_f};Symbol.metadata??=Symbol("metadata"),reactive_element_a.litPropertyMetadata??=new WeakMap;class reactive_element_y extends HTMLElement{static addInitializer(t){this._$Ei(),(this.l??=[]).push(t)}static get observedAttributes(){return this.finalize(),this._$Eh&&[...this._$Eh.keys()]}static createProperty(t,s=reactive_element_b){if(s.state&&(s.attribute=!1),this._$Ei(),this.prototype.hasOwnProperty(t)&&((s=Object.create(s)).wrapped=!0),this.elementProperties.set(t,s),!s.noAccessor){const i=Symbol(),h=this.getPropertyDescriptor(t,i,s);void 0!==h&&reactive_element_e(this.prototype,t,h)}}static getPropertyDescriptor(t,s,i){const{get:e,set:r}=reactive_element_h(this.prototype,t)??{get(){return this[s]},set(t){this[s]=t}};return{get:e,set(s){const h=e?.call(this);r?.call(this,s),this.requestUpdate(t,h,i)},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)??reactive_element_b}static _$Ei(){if(this.hasOwnProperty(reactive_element_d("elementProperties")))return;const t=reactive_element_n(this);t.finalize(),void 0!==t.l&&(this.l=[...t.l]),this.elementProperties=new Map(t.elementProperties)}static finalize(){if(this.hasOwnProperty(reactive_element_d("finalized")))return;if(this.finalized=!0,this._$Ei(),this.hasOwnProperty(reactive_element_d("properties"))){const t=this.properties,s=[...reactive_element_r(t),...reactive_element_o(t)];for(const i of s)this.createProperty(i,t[i])}const t=this[Symbol.metadata];if(null!==t){const s=litPropertyMetadata.get(t);if(void 0!==s)for(const[t,i]of s)this.elementProperties.set(t,i)}this._$Eh=new Map;for(const[t,s]of this.elementProperties){const i=this._$Eu(t,s);void 0!==i&&this._$Eh.set(i,t)}this.elementStyles=this.finalizeStyles(this.styles)}static finalizeStyles(s){const i=[];if(Array.isArray(s)){const e=new Set(s.flat(1/0).reverse());for(const s of e)i.unshift(css_tag_c(s))}else void 0!==s&&i.push(css_tag_c(s));return i}static _$Eu(t,s){const i=s.attribute;return!1===i?void 0:"string"==typeof i?i:"string"==typeof t?t.toLowerCase():void 0}constructor(){super(),this._$Ep=void 0,this.isUpdatePending=!1,this.hasUpdated=!1,this._$Em=null,this._$Ev()}_$Ev(){this._$ES=new Promise(t=>this.enableUpdating=t),this._$AL=new Map,this._$E_(),this.requestUpdate(),this.constructor.l?.forEach(t=>t(this))}addController(t){(this._$EO??=new Set).add(t),void 0!==this.renderRoot&&this.isConnected&&t.hostConnected?.()}removeController(t){this._$EO?.delete(t)}_$E_(){const t=new Map,s=this.constructor.elementProperties;for(const i of s.keys())this.hasOwnProperty(i)&&(t.set(i,this[i]),delete this[i]);t.size>0&&(this._$Ep=t)}createRenderRoot(){const t=this.shadowRoot??this.attachShadow(this.constructor.shadowRootOptions);return css_tag_S(t,this.constructor.elementStyles),t}connectedCallback(){this.renderRoot??=this.createRenderRoot(),this.enableUpdating(!0),this._$EO?.forEach(t=>t.hostConnected?.())}enableUpdating(t){}disconnectedCallback(){this._$EO?.forEach(t=>t.hostDisconnected?.())}attributeChangedCallback(t,s,i){this._$AK(t,i)}_$ET(t,s){const i=this.constructor.elementProperties.get(t),e=this.constructor._$Eu(t,i);if(void 0!==e&&!0===i.reflect){const h=(void 0!==i.converter?.toAttribute?i.converter:reactive_element_u).toAttribute(s,i.type);this._$Em=t,null==h?this.removeAttribute(e):this.setAttribute(e,h),this._$Em=null}}_$AK(t,s){const i=this.constructor,e=i._$Eh.get(t);if(void 0!==e&&this._$Em!==e){const t=i.getPropertyOptions(e),h="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==t.converter?.fromAttribute?t.converter:reactive_element_u;this._$Em=e;const r=h.fromAttribute(s,t.type);this[e]=r??this._$Ej?.get(e)??r,this._$Em=null}}requestUpdate(t,s,i,e=!1,h){if(void 0!==t){const r=this.constructor;if(!1===e&&(h=this[t]),i??=r.getPropertyOptions(t),!((i.hasChanged??reactive_element_f)(h,s)||i.useDefault&&i.reflect&&h===this._$Ej?.get(t)&&!this.hasAttribute(r._$Eu(t,i))))return;this.C(t,s,i)}!1===this.isUpdatePending&&(this._$ES=this._$EP())}C(t,s,{useDefault:i,reflect:e,wrapped:h},r){i&&!(this._$Ej??=new Map).has(t)&&(this._$Ej.set(t,r??s??this[t]),!0!==h||void 0!==r)||(this._$AL.has(t)||(this.hasUpdated||i||(s=void 0),this._$AL.set(t,s)),!0===e&&this._$Em!==t&&(this._$Eq??=new Set).add(t))}async _$EP(){this.isUpdatePending=!0;try{await this._$ES}catch(t){Promise.reject(t)}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){if(!this.isUpdatePending)return;if(!this.hasUpdated){if(this.renderRoot??=this.createRenderRoot(),this._$Ep){for(const[t,s]of this._$Ep)this[t]=s;this._$Ep=void 0}const t=this.constructor.elementProperties;if(t.size>0)for(const[s,i]of t){const{wrapped:t}=i,e=this[s];!0!==t||this._$AL.has(s)||void 0===e||this.C(s,void 0,i,e)}}let t=!1;const s=this._$AL;try{t=this.shouldUpdate(s),t?(this.willUpdate(s),this._$EO?.forEach(t=>t.hostUpdate?.()),this.update(s)):this._$EM()}catch(s){throw t=!1,this._$EM(),s}t&&this._$AE(s)}willUpdate(t){}_$AE(t){this._$EO?.forEach(t=>t.hostUpdated?.()),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t)}_$EM(){this._$AL=new Map,this.isUpdatePending=!1}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$ES}shouldUpdate(t){return!0}update(t){this._$Eq&&=this._$Eq.forEach(t=>this._$ET(t,this[t])),this._$EM()}updated(t){}firstUpdated(t){}}reactive_element_y.elementStyles=[],reactive_element_y.shadowRootOptions={mode:"open"},reactive_element_y[reactive_element_d("elementProperties")]=new Map,reactive_element_y[reactive_element_d("finalized")]=new Map,reactive_element_p?.({ReactiveElement:reactive_element_y}),(reactive_element_a.reactiveElementVersions??=[]).push("2.1.2");
//# sourceMappingURL=reactive-element.js.map

;// CONCATENATED MODULE: ./node_modules/lit-html/lit-html.js
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const lit_html_t=globalThis,lit_html_i=t=>t,lit_html_s=lit_html_t.trustedTypes,lit_html_e=lit_html_s?lit_html_s.createPolicy("lit-html",{createHTML:t=>t}):void 0,lit_html_h="$lit$",lit_html_o=`lit$${Math.random().toFixed(9).slice(2)}$`,lit_html_n="?"+lit_html_o,lit_html_r=`<${lit_html_n}>`,lit_html_l=document,lit_html_c=()=>lit_html_l.createComment(""),lit_html_a=t=>null===t||"object"!=typeof t&&"function"!=typeof t,lit_html_u=Array.isArray,lit_html_d=t=>lit_html_u(t)||"function"==typeof t?.[Symbol.iterator],lit_html_f="[ \t\n\f\r]",lit_html_v=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,lit_html_=/-->/g,lit_html_m=/>/g,lit_html_p=RegExp(`>|${lit_html_f}(?:([^\\s"'>=/]+)(${lit_html_f}*=${lit_html_f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`,"g"),lit_html_g=/'/g,$=/"/g,lit_html_y=/^(?:script|style|textarea|title)$/i,lit_html_x=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),lit_html_b=lit_html_x(1),w=lit_html_x(2),T=lit_html_x(3),lit_html_E=Symbol.for("lit-noChange"),A=Symbol.for("lit-nothing"),C=new WeakMap,P=lit_html_l.createTreeWalker(lit_html_l,129);function V(t,i){if(!lit_html_u(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return void 0!==lit_html_e?lit_html_e.createHTML(i):i}const N=(t,i)=>{const s=t.length-1,e=[];let n,l=2===i?"<svg>":3===i?"<math>":"",c=lit_html_v;for(let i=0;i<s;i++){const s=t[i];let a,u,d=-1,f=0;for(;f<s.length&&(c.lastIndex=f,u=c.exec(s),null!==u);)f=c.lastIndex,c===lit_html_v?"!--"===u[1]?c=lit_html_:void 0!==u[1]?c=lit_html_m:void 0!==u[2]?(lit_html_y.test(u[2])&&(n=RegExp("</"+u[2],"g")),c=lit_html_p):void 0!==u[3]&&(c=lit_html_p):c===lit_html_p?">"===u[0]?(c=n??lit_html_v,d=-1):void 0===u[1]?d=-2:(d=c.lastIndex-u[2].length,a=u[1],c=void 0===u[3]?lit_html_p:'"'===u[3]?$:lit_html_g):c===$||c===lit_html_g?c=lit_html_p:c===lit_html_||c===lit_html_m?c=lit_html_v:(c=lit_html_p,n=void 0);const x=c===lit_html_p&&t[i+1].startsWith("/>")?" ":"";l+=c===lit_html_v?s+lit_html_r:d>=0?(e.push(a),s.slice(0,d)+lit_html_h+s.slice(d)+lit_html_o+x):s+lit_html_o+(-2===d?i:x)}return[V(t,l+(t[s]||"<?>")+(2===i?"</svg>":3===i?"</math>":"")),e]};class lit_html_S{constructor({strings:t,_$litType$:i},e){let r;this.parts=[];let l=0,a=0;const u=t.length-1,d=this.parts,[f,v]=N(t,i);if(this.el=lit_html_S.createElement(f,e),P.currentNode=this.el.content,2===i||3===i){const t=this.el.content.firstChild;t.replaceWith(...t.childNodes)}for(;null!==(r=P.nextNode())&&d.length<u;){if(1===r.nodeType){if(r.hasAttributes())for(const t of r.getAttributeNames())if(t.endsWith(lit_html_h)){const i=v[a++],s=r.getAttribute(t).split(lit_html_o),e=/([.?@])?(.*)/.exec(i);d.push({type:1,index:l,name:e[2],strings:s,ctor:"."===e[1]?I:"?"===e[1]?lit_html_L:"@"===e[1]?z:H}),r.removeAttribute(t)}else t.startsWith(lit_html_o)&&(d.push({type:6,index:l}),r.removeAttribute(t));if(lit_html_y.test(r.tagName)){const t=r.textContent.split(lit_html_o),i=t.length-1;if(i>0){r.textContent=lit_html_s?lit_html_s.emptyScript:"";for(let s=0;s<i;s++)r.append(t[s],lit_html_c()),P.nextNode(),d.push({type:2,index:++l});r.append(t[i],lit_html_c())}}}else if(8===r.nodeType)if(r.data===lit_html_n)d.push({type:2,index:l});else{let t=-1;for(;-1!==(t=r.data.indexOf(lit_html_o,t+1));)d.push({type:7,index:l}),t+=lit_html_o.length-1}l++}}static createElement(t,i){const s=lit_html_l.createElement("template");return s.innerHTML=t,s}}function M(t,i,s=t,e){if(i===lit_html_E)return i;let h=void 0!==e?s._$Co?.[e]:s._$Cl;const o=lit_html_a(i)?void 0:i._$litDirective$;return h?.constructor!==o&&(h?._$AO?.(!1),void 0===o?h=void 0:(h=new o(t),h._$AT(t,s,e)),void 0!==e?(s._$Co??=[])[e]=h:s._$Cl=h),void 0!==h&&(i=M(t,h._$AS(t,i.values),h,e)),i}class R{constructor(t,i){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=i}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){const{el:{content:i},parts:s}=this._$AD,e=(t?.creationScope??lit_html_l).importNode(i,!0);P.currentNode=e;let h=P.nextNode(),o=0,n=0,r=s[0];for(;void 0!==r;){if(o===r.index){let i;2===r.type?i=new lit_html_k(h,h.nextSibling,this,t):1===r.type?i=new r.ctor(h,r.name,r.strings,this,t):6===r.type&&(i=new Z(h,this,t)),this._$AV.push(i),r=s[++n]}o!==r?.index&&(h=P.nextNode(),o++)}return P.currentNode=lit_html_l,e}p(t){let i=0;for(const s of this._$AV)void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++}}class lit_html_k{get _$AU(){return this._$AM?._$AU??this._$Cv}constructor(t,i,s,e){this.type=2,this._$AH=A,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cv=e?.isConnected??!0}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===t?.nodeType&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=M(this,t,i),lit_html_a(t)?t===A||null==t||""===t?(this._$AH!==A&&this._$AR(),this._$AH=A):t!==this._$AH&&t!==lit_html_E&&this._(t):void 0!==t._$litType$?this.$(t):void 0!==t.nodeType?this.T(t):lit_html_d(t)?this.k(t):this._(t)}O(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}T(t){this._$AH!==t&&(this._$AR(),this._$AH=this.O(t))}_(t){this._$AH!==A&&lit_html_a(this._$AH)?this._$AA.nextSibling.data=t:this.T(lit_html_l.createTextNode(t)),this._$AH=t}$(t){const{values:i,_$litType$:s}=t,e="number"==typeof s?this._$AC(t):(void 0===s.el&&(s.el=lit_html_S.createElement(V(s.h,s.h[0]),this.options)),s);if(this._$AH?._$AD===e)this._$AH.p(i);else{const t=new R(e,this),s=t.u(this.options);t.p(i),this.T(s),this._$AH=t}}_$AC(t){let i=C.get(t.strings);return void 0===i&&C.set(t.strings,i=new lit_html_S(t)),i}k(t){lit_html_u(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const h of t)e===i.length?i.push(s=new lit_html_k(this.O(lit_html_c()),this.O(lit_html_c()),this,this.options)):s=i[e],s._$AI(h),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e)}_$AR(t=this._$AA.nextSibling,s){for(this._$AP?.(!1,!0,s);t!==this._$AB;){const s=lit_html_i(t).nextSibling;lit_html_i(t).remove(),t=s}}setConnected(t){void 0===this._$AM&&(this._$Cv=t,this._$AP?.(t))}}class H{get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}constructor(t,i,s,e,h){this.type=1,this._$AH=A,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=h,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=A}_$AI(t,i=this,s,e){const h=this.strings;let o=!1;if(void 0===h)t=M(this,t,i,0),o=!lit_html_a(t)||t!==this._$AH&&t!==lit_html_E,o&&(this._$AH=t);else{const e=t;let n,r;for(t=h[0],n=0;n<h.length-1;n++)r=M(this,e[s+n],i,n),r===lit_html_E&&(r=this._$AH[n]),o||=!lit_html_a(r)||r!==this._$AH[n],r===A?t=A:t!==A&&(t+=(r??"")+h[n+1]),this._$AH[n]=r}o&&!e&&this.j(t)}j(t){t===A?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,t??"")}}class I extends H{constructor(){super(...arguments),this.type=3}j(t){this.element[this.name]=t===A?void 0:t}}class lit_html_L extends H{constructor(){super(...arguments),this.type=4}j(t){this.element.toggleAttribute(this.name,!!t&&t!==A)}}class z extends H{constructor(t,i,s,e,h){super(t,i,s,e,h),this.type=5}_$AI(t,i=this){if((t=M(this,t,i,0)??A)===lit_html_E)return;const s=this._$AH,e=t===A&&s!==A||t.capture!==s.capture||t.once!==s.once||t.passive!==s.passive,h=t!==A&&(s===A||e);e&&this.element.removeEventListener(this.name,this,s),h&&this.element.addEventListener(this.name,this,t),this._$AH=t}handleEvent(t){"function"==typeof this._$AH?this._$AH.call(this.options?.host??this.element,t):this._$AH.handleEvent(t)}}class Z{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s}get _$AU(){return this._$AM._$AU}_$AI(t){M(this,t)}}const lit_html_j=(/* unused pure expression or super */ null && ({M:lit_html_h,P:lit_html_o,A:lit_html_n,C:1,L:N,R,D:lit_html_d,V:M,I:lit_html_k,H,N:lit_html_L,U:z,B:I,F:Z})),B=lit_html_t.litHtmlPolyfillSupport;B?.(lit_html_S,lit_html_k),(lit_html_t.litHtmlVersions??=[]).push("3.3.3");const D=(t,i,s)=>{const e=s?.renderBefore??i;let h=e._$litPart$;if(void 0===h){const t=s?.renderBefore??null;e._$litPart$=h=new lit_html_k(i.insertBefore(lit_html_c(),t),t,void 0,s??{})}return h._$AI(t),h};
//# sourceMappingURL=lit-html.js.map

;// CONCATENATED MODULE: ./node_modules/lit-element/lit-element.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const lit_element_s=globalThis;class lit_element_i extends reactive_element_y{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0}createRenderRoot(){const t=super.createRenderRoot();return this.renderOptions.renderBefore??=t.firstChild,t}update(t){const r=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=D(r,this.renderRoot,this.renderOptions)}connectedCallback(){super.connectedCallback(),this._$Do?.setConnected(!0)}disconnectedCallback(){super.disconnectedCallback(),this._$Do?.setConnected(!1)}render(){return lit_html_E}}lit_element_i._$litElement$=!0,lit_element_i["finalized"]=!0,lit_element_s.litElementHydrateSupport?.({LitElement:lit_element_i});const lit_element_o=lit_element_s.litElementPolyfillSupport;lit_element_o?.({LitElement:lit_element_i});const lit_element_n=(/* unused pure expression or super */ null && ({_$AK:(t,e,r)=>{t._$AK(e,r)},_$AL:t=>t._$AL}));(lit_element_s.litElementVersions??=[]).push("4.2.2");
//# sourceMappingURL=lit-element.js.map

;// CONCATENATED MODULE: ./node_modules/lit/index.js

//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./src/headless/shared/connection/feedback.js





class Feedback extends skeletor.Model {

    defaults () {
        return {
            'connection_status': Strophe.Status.DISCONNECTED,
            'message': '',
        }
    }

    initialize () {
        super.initialize();
        const { api } = shared_converse;
        this.on('change', () => api.trigger('connfeedback', shared_converse.state.connfeedback));
    }
}

/* export default */ const connection_feedback = (Feedback);

;// CONCATENATED MODULE: ./src/headless/utils/array.js
/**
 * @template {any} T
 * @param {Array<T>} arr
 * @returns {Array<T>} A new array containing only unique elements from the input array.
 */
function array_unique (arr) {
    return [...new Set(arr)];
}

;// CONCATENATED MODULE: ./src/headless/utils/arraybuffer.js
function appendArrayBuffer (buffer1, buffer2) {
    const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
    tmp.set(new Uint8Array(buffer1), 0);
    tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
    return tmp.buffer;
}

function arrayBufferToHex (ab) {
    // https://stackoverflow.com/questions/40031688/javascript-arraybuffer-to-hex#40031979
    return Array.prototype.map.call(new Uint8Array(ab), x => ('00' + x.toString(16)).slice(-2)).join('');
}

function arrayBufferToString (ab) {
    return new TextDecoder("utf-8").decode(ab);
}

function stringToArrayBuffer (string) {
    const bytes = new TextEncoder().encode(string);
    return bytes.buffer;
}

function arrayBufferToBase64 (ab) {
    return btoa((new Uint8Array(ab)).reduce((data, byte) => data + String.fromCharCode(byte), ''));
}

function base64ToArrayBuffer (b64) {
    const binary_string = atob(b64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i)
    }
    return bytes.buffer
}

function hexToArrayBuffer (hex) {
    const typedArray = new Uint8Array(hex.match(/[\da-f]{2}/gi).map(h => parseInt(h, 16)))
    return typedArray.buffer
}

;// CONCATENATED MODULE: ./node_modules/hsluv/dist/hsluv.mjs
class Hsluv {
    constructor() {
        // RGB
        this.hex = '#000000';
        this.rgb_r = 0;
        this.rgb_g = 0;
        this.rgb_b = 0;
        // CIE XYZ
        this.xyz_x = 0;
        this.xyz_y = 0;
        this.xyz_z = 0;
        // CIE LUV
        this.luv_l = 0;
        this.luv_u = 0;
        this.luv_v = 0;
        // CIE LUV LCh
        this.lch_l = 0;
        this.lch_c = 0;
        this.lch_h = 0;
        // HSLuv
        this.hsluv_h = 0;
        this.hsluv_s = 0;
        this.hsluv_l = 0;
        // HPLuv
        this.hpluv_h = 0;
        this.hpluv_p = 0;
        this.hpluv_l = 0;
        // 6 lines in slope-intercept format: R < 0, R > 1, G < 0, G > 1, B < 0, B > 1
        this.r0s = 0;
        this.r0i = 0;
        this.r1s = 0;
        this.r1i = 0;
        this.g0s = 0;
        this.g0i = 0;
        this.g1s = 0;
        this.g1i = 0;
        this.b0s = 0;
        this.b0i = 0;
        this.b1s = 0;
        this.b1i = 0;
    }
    static fromLinear(c) {
        if (c <= 0.0031308) {
            return 12.92 * c;
        }
        else {
            return 1.055 * Math.pow(c, 1 / 2.4) - 0.055;
        }
    }
    static toLinear(c) {
        if (c > 0.04045) {
            return Math.pow((c + 0.055) / 1.055, 2.4);
        }
        else {
            return c / 12.92;
        }
    }
    static yToL(Y) {
        if (Y <= Hsluv.epsilon) {
            return Y / Hsluv.refY * Hsluv.kappa;
        }
        else {
            return 116 * Math.pow(Y / Hsluv.refY, 1 / 3) - 16;
        }
    }
    static lToY(L) {
        if (L <= 8) {
            return Hsluv.refY * L / Hsluv.kappa;
        }
        else {
            return Hsluv.refY * Math.pow((L + 16) / 116, 3);
        }
    }
    static rgbChannelToHex(chan) {
        const c = Math.round(chan * 255);
        const digit2 = c % 16;
        const digit1 = (c - digit2) / 16 | 0;
        return Hsluv.hexChars.charAt(digit1) + Hsluv.hexChars.charAt(digit2);
    }
    static hexToRgbChannel(hex, offset) {
        const digit1 = Hsluv.hexChars.indexOf(hex.charAt(offset));
        const digit2 = Hsluv.hexChars.indexOf(hex.charAt(offset + 1));
        const n = digit1 * 16 + digit2;
        return n / 255.0;
    }
    static distanceFromOriginAngle(slope, intercept, angle) {
        const d = intercept / (Math.sin(angle) - slope * Math.cos(angle));
        if (d < 0) {
            return Infinity;
        }
        else {
            return d;
        }
    }
    static distanceFromOrigin(slope, intercept) {
        return Math.abs(intercept) / Math.sqrt(Math.pow(slope, 2) + 1);
    }
    static min6(f1, f2, f3, f4, f5, f6) {
        return Math.min(f1, Math.min(f2, Math.min(f3, Math.min(f4, Math.min(f5, f6)))));
    }
    rgbToHex() {
        this.hex = "#";
        this.hex += Hsluv.rgbChannelToHex(this.rgb_r);
        this.hex += Hsluv.rgbChannelToHex(this.rgb_g);
        this.hex += Hsluv.rgbChannelToHex(this.rgb_b);
    }
    hexToRgb() {
        this.hex = this.hex.toLowerCase();
        this.rgb_r = Hsluv.hexToRgbChannel(this.hex, 1);
        this.rgb_g = Hsluv.hexToRgbChannel(this.hex, 3);
        this.rgb_b = Hsluv.hexToRgbChannel(this.hex, 5);
    }
    xyzToRgb() {
        this.rgb_r = Hsluv.fromLinear(Hsluv.m_r0 * this.xyz_x + Hsluv.m_r1 * this.xyz_y + Hsluv.m_r2 * this.xyz_z);
        this.rgb_g = Hsluv.fromLinear(Hsluv.m_g0 * this.xyz_x + Hsluv.m_g1 * this.xyz_y + Hsluv.m_g2 * this.xyz_z);
        this.rgb_b = Hsluv.fromLinear(Hsluv.m_b0 * this.xyz_x + Hsluv.m_b1 * this.xyz_y + Hsluv.m_b2 * this.xyz_z);
    }
    rgbToXyz() {
        const lr = Hsluv.toLinear(this.rgb_r);
        const lg = Hsluv.toLinear(this.rgb_g);
        const lb = Hsluv.toLinear(this.rgb_b);
        this.xyz_x = 0.41239079926595 * lr + 0.35758433938387 * lg + 0.18048078840183 * lb;
        this.xyz_y = 0.21263900587151 * lr + 0.71516867876775 * lg + 0.072192315360733 * lb;
        this.xyz_z = 0.019330818715591 * lr + 0.11919477979462 * lg + 0.95053215224966 * lb;
    }
    xyzToLuv() {
        const divider = this.xyz_x + 15 * this.xyz_y + 3 * this.xyz_z;
        let varU = 4 * this.xyz_x;
        let varV = 9 * this.xyz_y;
        if (divider !== 0) {
            varU /= divider;
            varV /= divider;
        }
        else {
            varU = NaN;
            varV = NaN;
        }
        this.luv_l = Hsluv.yToL(this.xyz_y);
        if (this.luv_l === 0) {
            this.luv_u = 0;
            this.luv_v = 0;
        }
        else {
            this.luv_u = 13 * this.luv_l * (varU - Hsluv.refU);
            this.luv_v = 13 * this.luv_l * (varV - Hsluv.refV);
        }
    }
    luvToXyz() {
        if (this.luv_l === 0) {
            this.xyz_x = 0;
            this.xyz_y = 0;
            this.xyz_z = 0;
            return;
        }
        const varU = this.luv_u / (13 * this.luv_l) + Hsluv.refU;
        const varV = this.luv_v / (13 * this.luv_l) + Hsluv.refV;
        this.xyz_y = Hsluv.lToY(this.luv_l);
        this.xyz_x = 0 - 9 * this.xyz_y * varU / ((varU - 4) * varV - varU * varV);
        this.xyz_z = (9 * this.xyz_y - 15 * varV * this.xyz_y - varV * this.xyz_x) / (3 * varV);
    }
    luvToLch() {
        this.lch_l = this.luv_l;
        this.lch_c = Math.sqrt(this.luv_u * this.luv_u + this.luv_v * this.luv_v);
        if (this.lch_c < 0.00000001) {
            this.lch_h = 0;
        }
        else {
            const hrad = Math.atan2(this.luv_v, this.luv_u);
            this.lch_h = hrad * 180.0 / Math.PI;
            if (this.lch_h < 0) {
                this.lch_h = 360 + this.lch_h;
            }
        }
    }
    lchToLuv() {
        const hrad = this.lch_h / 180.0 * Math.PI;
        this.luv_l = this.lch_l;
        this.luv_u = Math.cos(hrad) * this.lch_c;
        this.luv_v = Math.sin(hrad) * this.lch_c;
    }
    calculateBoundingLines(l) {
        const sub1 = Math.pow(l + 16, 3) / 1560896;
        const sub2 = sub1 > Hsluv.epsilon ? sub1 : l / Hsluv.kappa;
        const s1r = sub2 * (284517 * Hsluv.m_r0 - 94839 * Hsluv.m_r2);
        const s2r = sub2 * (838422 * Hsluv.m_r2 + 769860 * Hsluv.m_r1 + 731718 * Hsluv.m_r0);
        const s3r = sub2 * (632260 * Hsluv.m_r2 - 126452 * Hsluv.m_r1);
        const s1g = sub2 * (284517 * Hsluv.m_g0 - 94839 * Hsluv.m_g2);
        const s2g = sub2 * (838422 * Hsluv.m_g2 + 769860 * Hsluv.m_g1 + 731718 * Hsluv.m_g0);
        const s3g = sub2 * (632260 * Hsluv.m_g2 - 126452 * Hsluv.m_g1);
        const s1b = sub2 * (284517 * Hsluv.m_b0 - 94839 * Hsluv.m_b2);
        const s2b = sub2 * (838422 * Hsluv.m_b2 + 769860 * Hsluv.m_b1 + 731718 * Hsluv.m_b0);
        const s3b = sub2 * (632260 * Hsluv.m_b2 - 126452 * Hsluv.m_b1);
        this.r0s = s1r / s3r;
        this.r0i = s2r * l / s3r;
        this.r1s = s1r / (s3r + 126452);
        this.r1i = (s2r - 769860) * l / (s3r + 126452);
        this.g0s = s1g / s3g;
        this.g0i = s2g * l / s3g;
        this.g1s = s1g / (s3g + 126452);
        this.g1i = (s2g - 769860) * l / (s3g + 126452);
        this.b0s = s1b / s3b;
        this.b0i = s2b * l / s3b;
        this.b1s = s1b / (s3b + 126452);
        this.b1i = (s2b - 769860) * l / (s3b + 126452);
    }
    calcMaxChromaHpluv() {
        const r0 = Hsluv.distanceFromOrigin(this.r0s, this.r0i);
        const r1 = Hsluv.distanceFromOrigin(this.r1s, this.r1i);
        const g0 = Hsluv.distanceFromOrigin(this.g0s, this.g0i);
        const g1 = Hsluv.distanceFromOrigin(this.g1s, this.g1i);
        const b0 = Hsluv.distanceFromOrigin(this.b0s, this.b0i);
        const b1 = Hsluv.distanceFromOrigin(this.b1s, this.b1i);
        return Hsluv.min6(r0, r1, g0, g1, b0, b1);
    }
    calcMaxChromaHsluv(h) {
        const hueRad = h / 360 * Math.PI * 2;
        const r0 = Hsluv.distanceFromOriginAngle(this.r0s, this.r0i, hueRad);
        const r1 = Hsluv.distanceFromOriginAngle(this.r1s, this.r1i, hueRad);
        const g0 = Hsluv.distanceFromOriginAngle(this.g0s, this.g0i, hueRad);
        const g1 = Hsluv.distanceFromOriginAngle(this.g1s, this.g1i, hueRad);
        const b0 = Hsluv.distanceFromOriginAngle(this.b0s, this.b0i, hueRad);
        const b1 = Hsluv.distanceFromOriginAngle(this.b1s, this.b1i, hueRad);
        return Hsluv.min6(r0, r1, g0, g1, b0, b1);
    }
    hsluvToLch() {
        if (this.hsluv_l > 99.9999999) {
            this.lch_l = 100;
            this.lch_c = 0;
        }
        else if (this.hsluv_l < 0.00000001) {
            this.lch_l = 0;
            this.lch_c = 0;
        }
        else {
            this.lch_l = this.hsluv_l;
            this.calculateBoundingLines(this.hsluv_l);
            const max = this.calcMaxChromaHsluv(this.hsluv_h);
            this.lch_c = max / 100 * this.hsluv_s;
        }
        this.lch_h = this.hsluv_h;
    }
    lchToHsluv() {
        if (this.lch_l > 99.9999999) {
            this.hsluv_s = 0;
            this.hsluv_l = 100;
        }
        else if (this.lch_l < 0.00000001) {
            this.hsluv_s = 0;
            this.hsluv_l = 0;
        }
        else {
            this.calculateBoundingLines(this.lch_l);
            const max = this.calcMaxChromaHsluv(this.lch_h);
            this.hsluv_s = this.lch_c / max * 100;
            this.hsluv_l = this.lch_l;
        }
        this.hsluv_h = this.lch_h;
    }
    hpluvToLch() {
        if (this.hpluv_l > 99.9999999) {
            this.lch_l = 100;
            this.lch_c = 0;
        }
        else if (this.hpluv_l < 0.00000001) {
            this.lch_l = 0;
            this.lch_c = 0;
        }
        else {
            this.lch_l = this.hpluv_l;
            this.calculateBoundingLines(this.hpluv_l);
            const max = this.calcMaxChromaHpluv();
            this.lch_c = max / 100 * this.hpluv_p;
        }
        this.lch_h = this.hpluv_h;
    }
    lchToHpluv() {
        if (this.lch_l > 99.9999999) {
            this.hpluv_p = 0;
            this.hpluv_l = 100;
        }
        else if (this.lch_l < 0.00000001) {
            this.hpluv_p = 0;
            this.hpluv_l = 0;
        }
        else {
            this.calculateBoundingLines(this.lch_l);
            const max = this.calcMaxChromaHpluv();
            this.hpluv_p = this.lch_c / max * 100;
            this.hpluv_l = this.lch_l;
        }
        this.hpluv_h = this.lch_h;
    }
    hsluvToRgb() {
        this.hsluvToLch();
        this.lchToLuv();
        this.luvToXyz();
        this.xyzToRgb();
    }
    hpluvToRgb() {
        this.hpluvToLch();
        this.lchToLuv();
        this.luvToXyz();
        this.xyzToRgb();
    }
    hsluvToHex() {
        this.hsluvToRgb();
        this.rgbToHex();
    }
    hpluvToHex() {
        this.hpluvToRgb();
        this.rgbToHex();
    }
    rgbToHsluv() {
        this.rgbToXyz();
        this.xyzToLuv();
        this.luvToLch();
        this.lchToHpluv();
        this.lchToHsluv();
    }
    rgbToHpluv() {
        this.rgbToXyz();
        this.xyzToLuv();
        this.luvToLch();
        this.lchToHpluv();
        this.lchToHpluv();
    }
    hexToHsluv() {
        this.hexToRgb();
        this.rgbToHsluv();
    }
    hexToHpluv() {
        this.hexToRgb();
        this.rgbToHpluv();
    }
}
Hsluv.hexChars = "0123456789abcdef";
Hsluv.refY = 1.0;
Hsluv.refU = 0.19783000664283;
Hsluv.refV = 0.46831999493879;
Hsluv.kappa = 903.2962962;
Hsluv.epsilon = 0.0088564516;
Hsluv.m_r0 = 3.240969941904521;
Hsluv.m_r1 = -1.537383177570093;
Hsluv.m_r2 = -0.498610760293;
Hsluv.m_g0 = -0.96924363628087;
Hsluv.m_g1 = 1.87596750150772;
Hsluv.m_g2 = 0.041555057407175;
Hsluv.m_b0 = 0.055630079696993;
Hsluv.m_b1 = -0.20397695888897;
Hsluv.m_b2 = 1.056971514242878;

;// CONCATENATED MODULE: ./src/headless/utils/color.js


const color_cache = new Map();

/**
 * Computes an RGB color as specified in XEP-0392
 * https://xmpp.org/extensions/xep-0392.html
 *
 * @param {string} s JID or nickname to colorize
 * @returns {Promise<string>}
 */
async function colorize(s) {
    // We cache results in `cache`, to avoid unnecessary computing (as it can be called very often)
    const v = color_cache.get(s);
    if (v) return v;

    // Run the input through SHA-1
    const digest = Array.from(new Uint8Array(await crypto.subtle.digest('SHA-1', new TextEncoder().encode(s))));

    // Treat the output as little endian and extract the least-significant 16 bits.
    // (These are the first two bytes of the output, with the second byte being the most significant one.)
    // Divide the value by 65536 (use float division) and multiply it by 360 (to map it to degrees in a full circle).
    const angle = ((digest[0] + digest[1] * 256) / 65536.0) * 360;

    // Convert HSLuv angle to RGB Hex notation
    const hsluv = new Hsluv();
    hsluv.hsluv_h = angle;
    hsluv.hsluv_s = 100;
    hsluv.hsluv_l = 50;
    hsluv.hsluvToHex();

    color_cache.set(s, hsluv.hex);
    return hsluv.hex;
}

;// CONCATENATED MODULE: ./src/headless/utils/text.js
/**
 * @param {string} text
 * @returns {string}
 */
function firstCharToUpperCase(text) {
    if (!text) {
        return '';
    }

    if ('\uD83D\uDE00'.length === 1) {
        return text.charAt(0).toLocaleUpperCase() + text.substring(1);
    }

    const firstChar = text.codePointAt(0);
    const index = firstChar > 0xffff ? 2 : 1;

    return String.fromCodePoint(firstChar).toLocaleUpperCase() + text.substring(index);
}

/**
 * @param {string} string
 * @param {string[]} candidates
 * @returns {string}
 */
function getLongestSubstring(string, candidates) {
    /**
     * @param {string} accumulator
     * @param {string} current_value
     * @returns {string}
     */
    function reducer(accumulator, current_value) {
        if (string.startsWith(current_value)) {
            if (current_value.length > accumulator.length) {
                return current_value;
            } else {
                return accumulator;
            }
        } else {
            return accumulator;
        }
    }
    return candidates.reduce(reducer, '');
}

/**
 * @param {any} s
 * @returns {boolean}
 */
function isString(s) {
    return typeof s === 'string' || s instanceof String;
}

;// CONCATENATED MODULE: ./src/headless/utils/url.js



const url_settings = settings_api;

const URL_REGEXES = {
    // valid "scheme://" or "www."
    start: /(\b|_)(?:([a-z][a-z0-9.+-]*:\/\/)|xmpp:|mailto:|www\.)/gi,
    // everything up to the next whitespace
    end: /[\s\r\n]|$/,
    // trim trailing punctuation captured by end RegExp
    trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
    // balanced parens inclusion (), [], {}, <>
    parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g,
};

/**
 * Will return false if URL is malformed or contains disallowed characters
 * @param {string} text
 * @returns {boolean}
 */
function isValidURL(text) {
    try {
        if (text.startsWith("www.")) {
            return !!getURL(`http://${text}`);
        }
        return !!getURL(text);
    } catch {
        return false;
    }
}

/**
 * @param {string|URL} url
 * @returns {URL}
 */
function getURL(url) {
    if (url instanceof URL) {
        return url;
    }
    return url.toLowerCase().startsWith("www.") ? getURL(`http://${url}`) : new URL(url);
}

/**
 * Given the an array of file extensions, check whether a URL points to a file
 * ending in one of them.
 * @param {string[]} types - An array of file extensions
 * @param {string|URL} url
 * @returns {boolean}
 * @example
 *  checkFileTypes(['.gif'], 'https://conversejs.org/cat.gif?foo=bar');
 */
function checkFileTypes(types, url) {
    let parsed_url;
    try {
        parsed_url = getURL(url);
    } catch (error) {
        throw new Error(`checkFileTypes: could not parse url ${url}`);
    }
    const filename = parsed_url.pathname.split("/").pop().toLowerCase();
    return !!types.filter((ext) => filename.endsWith(ext)).length;
}

/**
 * @param {string|URL} url
 * @returns {boolean}
 */
function isURLWithImageExtension(url) {
    return checkFileTypes([".jpg", ".jpeg", ".png", ".gif", ".bmp", ".tiff", ".svg"], url);
}

/**
 * @param {string|URL} url
 */
function isGIFURL(url) {
    return checkFileTypes([".gif"], url);
}

/**
 * @param {string|URL} url
 * @param {Headers} [headers]
 */
function isAudioURL(url, headers) {
    if (headers?.get("content-type")?.startsWith("audio")) {
        return true;
    }
    return checkFileTypes([".ogg", ".mp3", ".m4a"], url);
}

/**
 * @param {string|URL} url
 * @param {Headers} [headers]
 */
function isVideoURL(url, headers) {
    if (headers?.get("content-type")?.startsWith("video")) {
        return true;
    }
    return checkFileTypes([".mp4", ".webm"], url);
}

/**
 * @param {string|URL} url
 * @param {Headers} [headers]
 * @returns {boolean}
 */
function isImageURL(url, headers) {
    if (headers?.get("content-type")?.startsWith("video")) {
        return true;
    }
    const regex = url_settings.get("image_urls_regex");
    return regex?.test(url) || isURLWithImageExtension(url);
}

/**
 * @param {string|URL} url
 */
function isEncryptedFileURL(url) {
    return getURL(url).href.startsWith("aesgcm://");
}

/**
 * Processes a string to find and manipulate substrings based on a callback function.
 * This function searches for patterns defined by the provided start and end regular expressions,
 * and applies the callback to each matched substring, allowing for modifications
 * @copyright Copyright (c) 2011 Rodney Rehm
 *
 * @param {string} string - The input string to be processed.
 * @param {function} callback - A function that takes the matched substring and its start and end indices,
 *                              and returns a modified substring or undefined to skip modification.
 * @param {import("./types").ProcessStringOptions} [options]
 * @returns {string} The modified string after processing all matches.
 */
function withinString(string, callback, options) {
    options = options || {};
    const _start = options.start || URL_REGEXES.start;
    const _end = options.end || URL_REGEXES.end;
    const _trim = options.trim || URL_REGEXES.trim;
    const _parens = options.parens || URL_REGEXES.parens;
    const _attributeOpen = /[a-z0-9-]=["']?$/i;

    _start.lastIndex = 0;
    while (true) {
        const match = _start.exec(string);
        if (!match) break;

        let start = match.index;
        if (options.ignoreHtml) {
            const attributeOpen = string.slice(Math.max(start - 3, 0), start);
            if (attributeOpen && _attributeOpen.test(attributeOpen)) {
                continue;
            }
        }

        let end = start + string.slice(start).search(_end);
        let slice = string.slice(start, end);
        let parensEnd = -1;
        while (true) {
            const parensMatch = _parens.exec(slice);
            if (!parensMatch) break;

            const parensMatchEnd = parensMatch.index + parensMatch[0].length;
            parensEnd = Math.max(parensEnd, parensMatchEnd);
        }

        if (parensEnd > -1) {
            slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, "");
        } else {
            slice = slice.replace(_trim, "");
        }

        if (slice.length <= match[0].length) continue;
        if (options.ignore && options.ignore.test(slice)) continue;

        end = start + slice.length;
        const result = callback(slice, start, end);
        if (result === undefined) {
            _start.lastIndex = end;
            continue;
        }

        string = string.slice(0, start) + String(result) + string.slice(end);
        _start.lastIndex = start + String(result).length;
    }

    _start.lastIndex = 0;
    return string;
}

/**
 * @param {string} url
 * @returns {Promise<Headers>}
 */
async function getHeaders(url) {
    try {
        const response = await fetch(url, { method: "HEAD" });
        return response.headers;
    } catch (e) {
        console.debug(`Error calling HEAD on url ${url}: ${e}`);
        return null;
    }
}

/**
 * @param {import("./types").MediaURLIndexes} o
 * @returns {Promise<import("./types").MediaURLMetadata>}
 */
async function getMetadataForURL(o) {
    const fetch_headers = settings_api.get("fetch_url_headers");
    const headers = fetch_headers ? await getHeaders(o.url) : null;
    return {
        ...o,
        is_gif: isGIFURL(o.url),
        is_audio: isAudioURL(o.url, headers),
        is_image: isImageURL(o.url, headers),
        is_video: isVideoURL(o.url, headers),
        is_encrypted: isEncryptedFileURL(o.url),
    };
}

/**
 * @param {string} text
 * @param {number} offset
 * @returns {Promise<{media_urls?: import("./types").MediaURLMetadata[]}>}
 */
async function getMediaURLsMetadata(text, offset = 0) {
    const objs = [];
    if (!text) {
        return {};
    }
    try {
        withinString(
            text,
            /**
             * @param {string} url
             * @param {number} start
             * @param {number} end
             * @returns {string|undefined}
             */
            (url, start, end) => {
                if (url.startsWith("_")) {
                    url = url.slice(1);
                    start += 1;
                }
                if (url.endsWith("_")) {
                    url = url.slice(0, url.length - 1);
                    end -= 1;
                }

                if (isValidURL(url)) {
                    objs.push({ url, start: start + offset, end: end + offset });
                }
                return url;
            }
        );
    } catch (error) {
        src_log.debug(error);
    }

    const media_urls = await Promise.all(objs.map(getMetadataForURL));
    return media_urls.length ? { media_urls } : {};
}

/**
 * @param {Array<import("./types").MediaURLMetadata>} arr
 * @param {string} text
 * @returns {import("./types").MediaURLMetadata[]}
 */
function getMediaURLs(arr, text) {
    return arr
        .map((o) => {
            if (o.start < 0 || o.start >= text.length) {
                return null;
            }
            const url = text.substring(o.start, o.end);
            return {
                ...o,
                url,
            };
        })
        .filter((o) => o);
}

/**
 * @param {Array<import("./types").MediaURLMetadata>} arr
 * @param {string} text
 * @returns {import("./types").MediaURLMetadata[]}
 */
function addMediaURLsOffset(arr, text, offset = 0) {
    return arr
        .map((o) => {
            const start = o.start - offset;
            const end = o.end - offset;
            if (start < 0 || start >= text.length) {
                return null;
            }
            return Object.assign({}, o, {
                start,
                end,
                url: text.substring(o.start-offset, o.end-offset), // BBB
            });
        })
        .filter((o) => o);
}

;// CONCATENATED MODULE: ./src/headless/utils/index.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description This is the core utilities module.
 */
















/**
 * The utils object
 * @namespace u
 * @type {import('./types').CommonUtils & import('./types').PluginUtils}
 */
const utils_u = {
    bookmarks: null,
    emojis: null,
    mam: null,
    muc: null,
    omemo: null,
    reactions: null,
    roster: null,
};

/**
 * @param {Event} [event]
 */
function setLogLevelFromRoute(event) {
    if (location.hash.startsWith('#converse?loglevel=')) {
        event?.preventDefault();
        const level = location.hash.split('=').pop();
        if (Object.keys(LEVELS).includes(level)) {
            src_log.setLogLevel(/** @type {keyof LEVELS} */ (level));
        } else {
            src_log.error(`Could not set loglevel of ${level}`);
        }
    }
}

function isEmptyMessage(attrs) {
    if (attrs instanceof skeletor.Model) {
        attrs = attrs.attributes;
    }
    return (
        !attrs['oob_url'] &&
        !attrs['file'] &&
        !(attrs['is_encrypted'] && attrs['plaintext']) &&
        !attrs['message'] &&
        !attrs['body']
    );
}

/**
 * Given a message object, return its text with @ chars
 * inserted before the mentioned nicknames.
 * @param {import('../shared/message').default} message
 */
function prefixMentions(message) {
    let text = message.getMessageText();
    (message.get('references') || [])
        .sort((a, b) => b.begin - a.begin)
        .forEach((ref) => {
            text = `${text.slice(0, ref.begin)}@${text.slice(ref.begin)}`;
        });
    return text;
}

function shouldCreateMessage(attrs) {
    return (
        attrs['retracted'] || // Retraction received *before* the message
        !isEmptyMessage(attrs)
    );
}

/**
 * Call the callback once all the events have been triggered
 * @param { Array } events: An array of objects, with keys `object` and
 *   `event`, representing the event name and the object it's triggered upon.
 * @param { Function } callback: The function to call once all events have
 *    been triggered.
 */
function onMultipleEvents(events = [], callback) {
    let triggered = [];

    function handler(result) {
        triggered.push(result);
        if (events.length === triggered.length) {
            callback(triggered);
            triggered = [];
        }
    }
    events.forEach((e) => e.object.on(e.event, handler));
}

/**
 * @param {Element} el
 * @param {string} name
 * @param {string} [type]
 * @param {boolean} [bubbles]
 * @param {boolean} [cancelable]
 */
function triggerEvent(el, name, type = 'Event', bubbles = true, cancelable = true) {
    const evt = document.createEvent(type);
    evt.initEvent(name, bubbles, cancelable);
    el.dispatchEvent(evt);
}

function getRandomInt(max) {
    return (Math.random() * max) | 0;
}

/**
 * @param {string} [suffix]
 * @return {string}
 */
function getUniqueId(suffix) {
    const uuid =
        crypto.randomUUID?.() ??
        'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = getRandomInt(16);
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    if (typeof suffix === 'string' || typeof suffix === 'number') {
        return uuid + ':' + suffix;
    } else {
        return uuid;
    }
}

/* export default */ const headless_utils = (Object.assign(
    {
        ...array_namespaceObject,
        ...arraybuffer_namespaceObject,
        ...color_namespaceObject,
        ...html_namespaceObject,
        ...init_namespaceObject,
        ...jid_namespaceObject,
        ...object_namespaceObject,
        ...promise_namespaceObject,
        ...session_namespaceObject,
        ...stanza_namespaceObject,
        ...storage_namespaceObject,
        ...text_namespaceObject,
        ...url_namespaceObject,
        getRandomInt,
        getUniqueId,
        isEmptyMessage,
        onMultipleEvents,
        prefixMentions,
        shouldCreateMessage,
        triggerEvent,
    },
    utils_u
));

;// CONCATENATED MODULE: ./src/headless/shared/api/public.js
/**
 * @typedef {module:shared-api-public.ConversePrivateGlobal} ConversePrivateGlobal
 */























shared_converse.api = shared_api;

dayjs_min_default().extend((advancedFormat_default()));
dayjs_min_default().extend((localizedFormat_default()));

const env = /** @type {import('./types').ConverseEnv} */ {
    $build: $build,
    $iq: $iq,
    $msg: $msg,
    $pres: $pres,
    Collection: skeletor.Collection,
    Model: skeletor.Model,
    Stanza: Stanza,
    Strophe: Strophe,
    TimeoutError: TimeoutError,
    VERSION_NAME: VERSION_NAME,
    css: css_tag_i,
    dayjs: (dayjs_min_default()),
    errors: errors_namespaceObject,
    filesize: filesize,
    html: lit_html_b,
    log: src_log,
    nothing: A,
    render: D,
    sizzle: (sizzle_default()),
    sprintf: sprintf.sprintf,
    stx: stx,
    u: headless_utils,
    utils: headless_utils,
}

/**
 * @typedef {Window & {converse: ConversePrivateGlobal} } window
 *
 * ### The Public API
 *
 * This namespace contains public API methods which are are
 * accessible on the global `converse` object.
 * They are public, because any JavaScript in the
 * page can call them. Public methods therefore don’t expose any sensitive
 * or closured data. To do that, you’ll need to create a plugin, which has
 * access to the private API method.
 *
 * @global
 * @namespace converse
 */
const converse = Object.assign(/** @type {ConversePrivateGlobal} */(window).converse || {}, {

    CHAT_STATES: CHAT_STATES,

    keycodes: KEYCODES,

    /**
     * Public API method which initializes Converse.
     * This method must always be called when using Converse.
     * @async
     * @memberOf converse
     * @method initialize
     * @param { object } settings A map of [configuration-settings](https://conversejs.org/docs/configuration/#configuration-settings).
     * @example
     * converse.initialize({
     *     auto_list_rooms: false,
     *     auto_subscribe: false,
     *     bosh_service_url: 'https://bind.example.com',
     *     hide_muc_server: false,
     *     i18n: 'en',
     *     play_sounds: true,
     *     show_controlbox_by_default: true,
     *     debug: false,
     *     roster_groups: true
     * });
     */
    async initialize (settings) {
        const { api } = shared_converse;
        await cleanup(shared_converse);

        initAppSettings(settings);
        shared_converse.strict_plugin_dependencies = settings.strict_plugin_dependencies; // Needed by pluggable.js
        src_log.setLogLevel(api.settings.get("loglevel"));

        if (api.settings.get("authentication") === ANONYMOUS) {
            if (api.settings.get("auto_login") && !api.settings.get('jid')) {
                throw new Error("Config Error: you need to provide the server's " +
                      "domain via the 'jid' option when using anonymous " +
                      "authentication with auto_login.");
            }
        }

        setLogLevelFromRoute();
        addEventListener('hashchange', setLogLevelFromRoute);

        const connfeedback = new connection_feedback();
        Object.assign(shared_converse, { connfeedback }); // XXX: DEPRECATED
        Object.assign(shared_converse.state, { connfeedback });
        shared_converse.env = env;

        await initSessionStorage(shared_converse);
        await initClientConfig(shared_converse);
        await i18n.initialize();
        initPlugins(shared_converse);

        // Register all custom elements
        // XXX: api.elements is defined in the UI part of Converse, outside of @converse/headless.
        // This line should probably be moved to the UI code as part of a larger refactoring.
        api.elements?.register();

        registerGlobalEventHandlers(shared_converse);

        const plugins = shared_converse.pluggable.plugins
        if (api.settings.get("auto_login") || api.settings.get("keepalive") && plugins['converse-bosh']?.enabled()) {
            await api.user.login(null, null, true);
        }

        /**
         * Triggered once converse.initialize has finished.
         * @event _converse#initialized
         */
        api.trigger('initialized');

        if (isTestEnv()) {
            return shared_converse;
        }
    },

    /**
     * Exposes methods for adding and removing plugins. You'll need to write a plugin
     * if you want to have access to the private API methods defined further down below.
     *
     * For more information on plugins, read the documentation on
     * [writing a plugin](https://conversejs.org/docs/development/plugin-development/).
     * @namespace plugins
     * @memberOf converse
     */
    plugins: {
        /**
         * Registers a new plugin.
         * @method converse.plugins.add
         * @param { string } name The name of the plugin
         * @param { object } plugin The plugin object
         * @example
         *  const plugin = {
         *      initialize: function () {
         *          // Gets called as soon as the plugin has been loaded.
         *
         *          // Inside this method, you have access to the private
         *          // API via `_covnerse.api`.
         *
         *          // The private _converse object contains the core logic
         *          // and data-structures of Converse.
         *      }
         *  }
         *  converse.plugins.add('myplugin', plugin);
         */
        add (name, plugin) {
            plugin.__name__ = name;
            if (shared_converse.pluggable.plugins[name] !== undefined) {
                throw new TypeError(
                    `Error: plugin with name "${name}" has already been ` + 'registered!'
                );
            } else {
                shared_converse.pluggable.plugins[name] = plugin;
            }
        }

    },
    env,
});

/* export default */ const api_public = (converse);

;// CONCATENATED MODULE: ./src/headless/shared/actions.js






const { u: actions_u, stx: actions_stx, Stanza: actions_Stanza } = api_public.env;

/**
 * Reject an incoming message by replying with an error message of type "cancel".
 * @param {Element} stanza
 * @param {string} text
 * @return void
 */
function rejectMessage(stanza, text) {
    shared_api.send(
        actions_stx`<message to="${stanza.getAttribute('from')}"
                    type="error"
                    id="${stanza.getAttribute('id')}"
                    xmlns="jabber:client">
                <error type="cancel">
                    <not-allowed xmlns="${Strophe.NS.STANZAS}"/>
                    <text xmlns="${Strophe.NS.STANZAS}">${text}</text>
                </error>
            </message>`
    );
    src_log.warn(`Rejecting message stanza with the following reason: ${text}`);
    src_log.warn(stanza);
}

/**
 * Send out a XEP-0333 chat marker
 * @param {string} to_jid
 * @param {string} id - The id of the message being marked
 * @param {import("./types").MessageMarkerType} type - The marker type
 * @param {string} [msg_type]
 * @return void
 */
function sendMarker(to_jid, id, type, msg_type) {
    if (!MARKER_TYPES.includes(type)) {
        src_log.error(`Invalid marker type: ${type}`);
        return;
    }
    const stanza = actions_stx`
        <message from="${shared_api.connection.get().jid}"
                id="${actions_u.getUniqueId()}"
                to="${to_jid}"
                type="${msg_type ? msg_type : 'chat'}"
                xmlns="jabber:client">
            <${actions_Stanza.unsafeXML(type)} xmlns="${Strophe.NS.MARKERS}" id="${id}"/>
        </message>`;
    shared_api.send(stanza);
}

/**
 * @param {string} to_jid
 * @param {string} id
 * @return void
 */
function sendReceiptStanza(to_jid, id) {
    const receipt_stanza = actions_stx`
        <message from="${shared_api.connection.get().jid}"
                id="${actions_u.getUniqueId()}"
                to="${to_jid}"
                type="chat"
                xmlns="jabber:client">
            <received xmlns="${Strophe.NS.RECEIPTS}" id="${id}"/>
            <store xmlns="${Strophe.NS.HINTS}"/>
        </message>`;
    shared_api.send(receipt_stanza);
}

/**
 * Sends a message with the given XEP-0085 chat state.
 * @param {string} jid
 * @param {import("./types").ChatStateType} chat_state
 */
function sendChatState(jid, chat_state) {
    if (!jid) {
        src_log.error(`sendChatState called with no JID`);
        return;
    } else if (!CHAT_STATES.includes(chat_state)) {
        src_log.error(`Invalid chat state: ${chat_state}`);
        return;
    }

    if (shared_api.settings.get('send_chat_state_notifications') && chat_state) {
        const allowed = shared_api.settings.get('send_chat_state_notifications');
        if (Array.isArray(allowed) && !allowed.includes(chat_state)) {
            return;
        }
        shared_api.send(
            actions_stx`<message id="${actions_u.getUniqueId()}" to="${jid}" type="chat" xmlns="jabber:client">
                <${actions_Stanza.unsafeXML(chat_state)} xmlns="${Strophe.NS.CHATSTATES}"/>
                <no-store xmlns="${Strophe.NS.HINTS}"/>
                <no-permanent-store xmlns="${Strophe.NS.HINTS}"/>
            </message>`
        );
    }
}

/**
 * Sends a message stanza to retract a message in this chat
 * @param {string} jid
 * @param {import('../shared/message').default} message - The message which we're retracting.
 * @param {string} retraction_id - Unique ID for the retraction message
 */
function sendRetractionMessage(jid, message, retraction_id) {
    const origin_id = message.get('origin_id');
    if (!origin_id) {
        throw new Error("Can't retract message without a XEP-0359 Origin ID");
    }
    const stanza = actions_stx`
        <message id="${retraction_id}"
                 to="${jid}"
                 type="chat"
                 xmlns="jabber:client">
            <retract id="${origin_id}" xmlns="${Strophe.NS.RETRACT}"/>
            <body>/me retracted a message</body>
            <store xmlns="${Strophe.NS.HINTS}"/>
            <fallback xmlns="${Strophe.NS.FALLBACK}" for="${Strophe.NS.RETRACT}" />
        </message>`;
    return shared_api.connection.get().send(stanza);
}

;// CONCATENATED MODULE: ./src/headless/shared/parsers.js
/**
 * @module:headless-shared-parsers
 */












const { dayjs } = api_public.env;
const { NS: parsers_NS } = Strophe;

/**
 * @param {Element|Error|null} stanza - The stanza to be parsed. As a convenience,
 * an Error element can be passed in as well, so that this function can be
 * called in a catch block without first checking if a stanza or Error
 * element was received.
 * @returns {Promise<Error|errors.StanzaError|null>}
 */
async function parseErrorStanza(stanza) {
    if (stanza === null) return null;
    if (stanza instanceof Error) return stanza;
    if (stanza.getAttribute('type') !== 'error') return null;

    const error = stanza.querySelector('error');
    if (!error) return null;

    const els = sizzle_default()(`[xmlns="${Strophe.NS.STANZAS}"]`, error);
    const name = els.filter((el) => el.nodeName && el.nodeName !== 'text').pop()?.nodeName;

    /**
     * *Hook* which allows plugins to add application-specific error parsing
     * @event _converse#parseErrorStanza
     */
    const extra = await shared_api.hook('parseErrorStanza', stanza, {});

    if (name === 'bad-request') {
        return new BadRequestError(name, error, extra);
    } else if (name === 'conflict') {
        return new ConflictError(name, error, extra);
    } else if (name === 'feature-not-implemented') {
        return new FeatureNotImplementedError(name, error, extra);
    } else if (name === 'forbidden') {
        return new ForbiddenError(name, error, extra);
    } else if (name === 'gone') {
        return new GoneError(name, error, extra);
    } else if (name === 'internal-server-error') {
        return new InternalServerError(name, error, extra);
    } else if (name === 'item-not-found') {
        return new ItemNotFoundError(name, error, extra);
    } else if (name === 'jid-malformed') {
        return new JIDMalformedError(name, error, extra);
    } else if (name === 'not-acceptable') {
        return new NotAcceptableError(name, error, extra);
    } else if (name === 'not-allowed') {
        return new NotAllowedError(name, error, extra);
    } else if (name === 'not-authorized') {
        return new NotAuthorizedError(name, error, extra);
    } else if (name === 'payment-required') {
        return new PaymentRequiredError(name, error, extra);
    } else if (name === 'recipient-unavailable') {
        return new RecipientUnavailableError(name, error, extra);
    } else if (name === 'redirect') {
        return new RedirectError(name, error, extra);
    } else if (name === 'registration-required') {
        return new RegistrationRequiredError(name, error, extra);
    } else if (name === 'remote-server-not-found') {
        return new RemoteServerNotFoundError(name, error, extra);
    } else if (name === 'remote-server-timeout') {
        return new RemoteServerTimeoutError(name, error, extra);
    } else if (name === 'resource-constraint') {
        return new ResourceConstraintError(name, error, extra);
    } else if (name === 'service-unavailable') {
        return new ServiceUnavailableError(name, error, extra);
    } else if (name === 'subscription-required') {
        return new SubscriptionRequiredError(name, error, extra);
    } else if (name === 'undefined-condition') {
        return new UndefinedConditionError(name, error, extra);
    } else if (name === 'unexpected-request') {
        return new UnexpectedRequestError(name, error, extra);
    }
    return new StanzaError('unknown', error);
}

/**
 * Extract the XEP-0359 stanza IDs from the passed in stanza
 * and return a map containing them.
 * @param {Element} stanza - The message stanza
 * @param {Element} original_stanza - The encapsulating stanza which contains
 *      the message stanza.
 * @returns {Object}
 */
function getStanzaIDs (stanza, original_stanza) {
    // Generic stanza ids
    const sids = sizzle_default()(`stanza-id[xmlns="${Strophe.NS.SID}"]`, stanza);
    const sid_attrs = sids.reduce((acc, s) => {
        acc[`stanza_id ${s.getAttribute('by')}`] = s.getAttribute('id');
        return acc;
    }, {});

    // Origin id
    const origin_id = sizzle_default()(`origin-id[xmlns="${Strophe.NS.SID}"]`, stanza).pop()?.getAttribute('id');

    const attrs = {
        origin_id,
        msgid: stanza.getAttribute('id') || original_stanza.getAttribute('id'),
        ...sid_attrs,
    };

    // Store the archive id
    const result = sizzle_default()(`message > result[xmlns="${Strophe.NS.MAM}"]`, original_stanza).pop();
    if (result) {
        const bare_jid = shared_converse.session.get('bare_jid');
        const by_jid = original_stanza.getAttribute('from') || bare_jid;
        attrs[`stanza_id ${by_jid}`] = result.getAttribute('id');
    }

    return attrs;
}

/**
 * @param {Element} stanza
 * @returns {import('./types').EncryptionAttrs}
 */
function getEncryptionAttributes (stanza) {
    const eme_tag = sizzle_default()(`encryption[xmlns="${Strophe.NS.EME}"]`, stanza).pop();
    const namespace = eme_tag?.getAttribute('namespace');
    const attrs = {};
    if (namespace) {
        attrs.is_encrypted = true;
        attrs.encryption_namespace = namespace;
    } else if (sizzle_default()(`encrypted[xmlns="${Strophe.NS.OMEMO}"]`, stanza).pop()) {
        attrs.is_encrypted = true;
        attrs.encryption_namespace = Strophe.NS.OMEMO;
    }
    return attrs;
}

/**
 * @param {Element} stanza - The message stanza
 * @param {Element} original_stanza - The original stanza, that contains the
 *  message stanza, if it was contained, otherwise it's the message stanza itself.
 * @returns {import('./types').RetractionAttrs | {}}
 */
function getDeprecatedRetractionAttributes (stanza, original_stanza) {
    const fastening = sizzle_default()(`> apply-to[xmlns="${Strophe.NS.FASTEN}"]`, stanza).pop();
    if (fastening) {
        const applies_to_id = fastening.getAttribute('id');
        const retracted = sizzle_default()(`> retract[xmlns="${Strophe.NS.RETRACT0}"]`, fastening).pop();
        if (retracted) {
            const delay = sizzle_default()(`delay[xmlns="${Strophe.NS.DELAY}"]`, original_stanza).pop();
            const time = delay ? dayjs(delay.getAttribute('stamp')).toISOString() : new Date().toISOString();
            return {
                editable: false,
                retracted: time,
                retracted_id: applies_to_id
            };
        }
    }
    return {};
}

/**
 * @param {Element} stanza - The message stanza
 * @param {Element} original_stanza - The original stanza, that contains the
 *  message stanza, if it was contained, otherwise it's the message stanza itself.
 * @returns {import('./types').RetractionAttrs | {}}
 */
function getRetractionAttributes (stanza, original_stanza) {
    const retraction = sizzle_default()(`> retract[xmlns="${Strophe.NS.RETRACT}"]`, stanza).pop();
    if (retraction) {
        const delay = sizzle_default()(`> delay[xmlns="${Strophe.NS.DELAY}"]`, original_stanza).pop();
        const time = delay ? dayjs(delay.getAttribute('stamp')).toISOString() : new Date().toISOString();
        return {
            editable: false,
            retracted: time,
            retracted_id: retraction.getAttribute('id')
        };
    } else {
        const tombstone =
            sizzle_default()(`> retracted[xmlns="${Strophe.NS.RETRACT}"]`, stanza).pop() ||
            sizzle_default()(`> retracted[xmlns="${Strophe.NS.RETRACT0}"]`, stanza).pop();
        if (tombstone) {
            return {
                editable: false,
                is_tombstone: true,
                retracted: tombstone.getAttribute('stamp'),
                retraction_id: tombstone.getAttribute('id')
            };
        }
    }
    return getDeprecatedRetractionAttributes(stanza, original_stanza);
}

/**
 * @param {Element} stanza
 * @param {Element} original_stanza
 */
function getCorrectionAttributes (stanza, original_stanza) {
    const el = sizzle_default()(`replace[xmlns="${Strophe.NS.MESSAGE_CORRECT}"]`, stanza).pop();
    if (el) {
        const replace_id = el.getAttribute('id');
        if (replace_id) {
            const delay = sizzle_default()(`delay[xmlns="${Strophe.NS.DELAY}"]`, original_stanza).pop();
            const time = delay ? dayjs(delay.getAttribute('stamp')).toISOString() : new Date().toISOString();
            return {
                replace_id,
                'edited': time
            };
        }
    }
    return {};
}

/**
 * @param {Element} stanza
 */
function getOpenGraphMetadata (stanza) {
    const fastening = sizzle_default()(`> apply-to[xmlns="${Strophe.NS.FASTEN}"]`, stanza).pop();
    if (fastening) {
        const applies_to_id = fastening.getAttribute('id');
        const meta = sizzle_default()(`> meta[xmlns="${Strophe.NS.XHTML}"]`, fastening);
        if (meta.length) {
            const msg_limit = shared_api.settings.get('message_limit');
            const data = meta.reduce((acc, el) => {
                const property = el.getAttribute('property');
                if (property) {
                    let value = decodeHTMLEntities(el.getAttribute('content') || '');
                    if (msg_limit && property === 'og:description' && value.length >= msg_limit) {
                        value = `${value.slice(0, msg_limit)}${decodeHTMLEntities('&#8230;')}`;
                    }
                    acc[property] = value;
                }
                return acc;
            }, {
                ogp_for_id: applies_to_id,
            });

            const url = data['og:url'];
            if (url?.startsWith('/') && data['og:site_name']?.toLowerCase() === 'github') {
                data['og:url'] = `https://github.com${url}`;
            }

            if ("og:description" in data || "og:title" in data || "og:image" in data) {
                return data;
            }
        }
    }
    return {};
}


/**
 * @param {Element} stanza
 */
function getSpoilerAttributes (stanza) {
    const spoiler = sizzle_default()(`spoiler[xmlns="${Strophe.NS.SPOILER}"]`, stanza).pop();
    return {
        'is_spoiler': !!spoiler,
        'spoiler_hint': spoiler?.textContent
    };
}

/**
 * @param {Element} stanza
 */
function getOutOfBandAttributes (stanza) {
    const xform = sizzle_default()(`x[xmlns="${Strophe.NS.OUTOFBAND}"]`, stanza).pop();
    if (xform) {
        return {
            'oob_url': xform.querySelector('url')?.textContent,
            'oob_desc': xform.querySelector('desc')?.textContent
        };
    }
    return {};
}

/**
 * Returns the human readable error message contained in a `groupchat` message stanza of type `error`.
 * @param {Element} stanza - The message stanza
 */
function getErrorAttributes (stanza) {
    if (stanza.getAttribute('type') === 'error') {
        const error = stanza.querySelector('error');
        const text = sizzle_default()(`text[xmlns="${Strophe.NS.STANZAS}"]`, error).pop();
        return {
            is_error: true,
            error_text: text?.textContent,
            error_type: error.getAttribute('type'),
            error_condition: error.firstElementChild.nodeName,
            errors: Array.from(error.children).map((e) => ({ name: e.nodeName, xmlns: e.getAttribute('xmlns') })),
        };
    }
    return {};
}

/**
 * Given a message stanza, extract XEP-0461 reply attributes
 * @param {Element} stanza - The message stanza
 * @returns {Object} An object containing reply_to_id and reply_to if present
 */
function getReplyAttributes (stanza) {
    const reply = sizzle_default()(`reply[xmlns="${Strophe.NS.REPLY}"]`, stanza).pop();
    if (reply) {
        return {
            reply_to_id: reply.getAttribute('id'),
            reply_to: reply.getAttribute('to')
        };
    }
    return {};
}

/**
 * Given a message stanza, find and return any XEP-0372 references
 * @param {Element} stanza - The message stanza
 * @returns {import('./types').XEP372Reference[]}
 */
function getReferences (stanza) {
    return sizzle_default()(`reference[xmlns="${Strophe.NS.REFERENCE}"]`, stanza).map(ref => {
        const anchor = ref.getAttribute('anchor');
        const text = stanza.querySelector(anchor ? `#${anchor}` : 'body')?.textContent;
        if (!text) {
            src_log.warn(`Could not find referenced text for ${ref}`);
            return null;
        }
        const begin = Number(ref.getAttribute('begin'));
        const end = Number(ref.getAttribute('end'));
        return {
            begin, end,
            type: ref.getAttribute('type'),
            value: text.slice(begin, end),
            uri: ref.getAttribute('uri')
        };
    }).filter(r => r);
}

/**
 * @param {Element} stanza
 */
function getReceiptId (stanza) {
    const receipt = sizzle_default()(`received[xmlns="${Strophe.NS.RECEIPTS}"]`, stanza).pop();
    return receipt?.getAttribute('id');
}

/**
 * Determines whether the passed in stanza is a XEP-0280 Carbon
 * @param {Element} stanza - The message stanza
 * @returns {Boolean}
 */
function isCarbon (stanza) {
    const xmlns = Strophe.NS.CARBONS;
    return (
        sizzle_default()(`message > received[xmlns="${xmlns}"]`, stanza).length > 0 ||
        sizzle_default()(`message > sent[xmlns="${xmlns}"]`, stanza).length > 0
    );
}

/**
 * Returns the XEP-0085 chat state contained in a message stanza
 * @param {Element} stanza - The message stanza
 */
function getChatState (stanza) {
    return sizzle_default()(
        `
        composing[xmlns="${parsers_NS.CHATSTATES}"],
        paused[xmlns="${parsers_NS.CHATSTATES}"],
        inactive[xmlns="${parsers_NS.CHATSTATES}"],
        active[xmlns="${parsers_NS.CHATSTATES}"],
        gone[xmlns="${parsers_NS.CHATSTATES}"]`,
        stanza
    ).pop()?.nodeName;
}

/**
 * @param {Element} stanza
 * @param {Object} attrs
 */
function isValidReceiptRequest (stanza, attrs) {
    return (
        attrs.sender !== 'me' &&
        !attrs.is_carbon &&
        !attrs.is_archived &&
        sizzle_default()(`request[xmlns="${Strophe.NS.RECEIPTS}"]`, stanza).length
    );
}

/**
 * Check whether the passed-in stanza is a forwarded message that is "bare",
 * i.e. it's not forwarded as part of a larger protocol, like MAM.
 * @param { Element } stanza
 */
function throwErrorIfInvalidForward (stanza) {
    const bare_forward = sizzle_default()(`message > forwarded[xmlns="${Strophe.NS.FORWARD}"]`, stanza).length;
    if (bare_forward) {
        rejectMessage(stanza, 'Forwarded messages not part of an encapsulating protocol are not supported');
        const from_jid = stanza.getAttribute('from');
        throw new StanzaParseError(stanza, `Ignoring unencapsulated forwarded message from ${from_jid}`);
    }
}

/**
 * Determines whether the passed in stanza is a XEP-0333 Chat Marker
 * @method getChatMarker
 * @param {Element} stanza - The message stanza
 * @returns {Element}
 */
function getChatMarker (stanza) {
    // If we receive more than one marker (which shouldn't happen), we take
    // the highest level of acknowledgement.
    return sizzle_default()(`
        acknowledged[xmlns="${Strophe.NS.MARKERS}"],
        displayed[xmlns="${Strophe.NS.MARKERS}"],
        received[xmlns="${Strophe.NS.MARKERS}"]`,
        stanza
    ).pop();
}

/**
 * @param {Element} stanza
 * @returns {boolean}
 */
function isHeadline (stanza) {
    return stanza.getAttribute('type') === 'headline';
}

/**
 * @param {Element} stanza
 * @returns {Promise<boolean>}
 */
async function isMUCPrivateMessage (stanza) {
    const bare_jid = Strophe.getBareJidFromJid(stanza.getAttribute('from'));
    return !!(await shared_api.rooms.get(bare_jid));
}

/**
 * @param {Element} stanza
 * @returns {boolean}
 */
function isServerMessage (stanza) {
    if (sizzle_default()(`mentions[xmlns="${Strophe.NS.MENTIONS}"]`, stanza).pop()) {
        return false;
    }
    const from_jid = stanza.getAttribute('from');
    if (stanza.getAttribute('type') !== 'error' && from_jid && !from_jid.includes('@')) {
        // Some servers (e.g. Prosody) don't set the stanza
        // type to "headline" when sending server messages.
        // For now we check if an @ signal is included, and if not,
        // we assume it's a headline stanza.
        return true;
    }
    return false;
}

/**
 * Determines whether the passed in stanza is a XEP-0313 MAM stanza
 * @method isArchived
 * @param {Element} original_stanza - The message stanza
 * @returns {boolean}
 */
function isArchived (original_stanza) {
    return !!sizzle_default()(`message > result[xmlns="${Strophe.NS.MAM}"]`, original_stanza).pop();
}

/**
 * @param {Element} field
 * @param {boolean} readonly
 * @param {Element} stanza
 * @return {import('./types').XFormField}
 */
function parseXFormField(field, readonly, stanza) {
    const v = field.getAttribute('var');
    const label = field.getAttribute('label') || '';
    const type = field.getAttribute('type');
    const desc = field.querySelector('desc')?.textContent;
    const result = { readonly, desc };

    if (type === 'list-single' || type === 'list-multi') {
        const values = Array.from(field.querySelectorAll(':scope > value')).map((el) => el?.textContent);
        const options = Array.from(field.querySelectorAll(':scope > option')).map(
            (/** @type {HTMLElement} */ option) => {
                const value = option.querySelector('value')?.textContent;
                return {
                    value,
                    label: option.getAttribute('label'),
                    selected: values.includes(value),
                    required: !!field.querySelector('required'),
                    ...result,
                };
            }
        );
        return {
            type,
            options,
            label: field.getAttribute('label'),
            var: v,
            required: !!field.querySelector('required'),
            ...result,
        };
    } else if (type === 'fixed') {
        const text = field.querySelector('value')?.textContent;
        return { text, label, type, var: v, ...result };
    } else if (type === 'jid-multi' || type === 'text-multi') {
        const values = Array.from(field.querySelectorAll(':scope > value')).map((el) => el?.textContent);
        return {
            type,
            var: v,
            label,
            values,
            required: !!field.querySelector('required'),
            ...result,
        };
    } else if (type === 'boolean') {
        const value = field.querySelector('value')?.textContent;
        return {
            type,
            var: v,
            label,
            checked: ((value === '1' || value === 'true') && true) || false,
            ...result,
        };
    } else if (v === 'url') {
        return {
            var: v,
            label,
            value: field.querySelector('value')?.textContent,
            ...result,
        };
    } else if (v === 'username') {
        return {
            var: v,
            label,
            value: field.querySelector('value')?.textContent,
            required: !!field.querySelector('required'),
            type: getInputType(field),
            ...result,
        };
    } else if (v === 'password') {
        return {
            var: v,
            label,
            value: field.querySelector('value')?.textContent,
            required: !!field.querySelector('required'),
            ...result,
        };
    } else if (v === 'ocr') { // Captcha
        const uri = field.querySelector('uri');
        const el = sizzle_default()('data[cid="' + uri.textContent.replace(/^cid:/, '') + '"]', stanza)[0];
        return {
            label: field.getAttribute('label'),
            var: v,
            uri: {
                type: uri.getAttribute('type'),
                data: el?.textContent,
            },
            required: !!field.querySelector('required'),
            ...result,
        };
    } else {
        return {
            label,
            var: v,
            required: !!field.querySelector('required'),
            value: field.querySelector('value')?.textContent,
            type: getInputType(field),
            ...result,
        };
    }
}

/**
 * @param {Element} field
 */
function getInputType(field) {
    const type = XFORM_TYPE_MAP[field.getAttribute('type')]
    if (type == 'text') {
        const datatypes = field.getElementsByTagNameNS("http://jabber.org/protocol/xdata-validate", "validate");
        if (datatypes.length === 1) {
            const datatype = datatypes[0].getAttribute("datatype");
            return XFORM_VALIDATE_TYPE_MAP[datatype] || type;
        }
    }
    return type;
}

/**
 * @param {Element} stanza
 * @returns {import('./types').XForm}
 */
function parseXForm(stanza) {
    const xs = sizzle_default()(`x[xmlns="${Strophe.NS.XFORM}"]`, stanza);
    if (xs.length > 1) {
        src_log.error(stanza);
        throw new Error('Invalid stanza');
    } else if (xs.length === 0) {
        return null;
    }

    const x = xs[0];
    const type = /** @type {import('./types').XFormResponseType} */ (x.getAttribute('type'));
    const result = {
        type,
        title: x.querySelector('title')?.textContent,
    };

    if (type === 'result') {
        const reported = x.querySelector(':scope > reported');
        if (reported) {
            const reported_fields = reported ? Array.from(reported.querySelectorAll(':scope > field')) : [];
            const items = Array.from(x.querySelectorAll(':scope > item'));
            return /** @type {import('./types').XForm} */({
                ...result,
                reported: /** @type {import('./types').XFormReportedField[]} */ (reported_fields.map(getAttributes)),
                items: items.map((item) => {
                    return Array.from(item.querySelectorAll('field')).map((field) => {
                        return /** @type {import('./types').XFormResultItemField} */ ({
                            ...getAttributes(field),
                            value: field.querySelector('value')?.textContent ?? '',
                        });
                    });
                }),
            });
        }
        return {
            ...result,
            fields: Array.from(x.querySelectorAll('field')).map((field) => parseXFormField(field, true, stanza)),
        };
    } else if (type === 'form') {
        return {
            ...result,
            instructions: x.querySelector('instructions')?.textContent,
            fields: Array.from(x.querySelectorAll('field')).map((field) => parseXFormField(field, false, stanza)),
        };
    } else {
        throw new Error(`Invalid type in XForm response stanza: ${type}`);
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/index.js









;// CONCATENATED MODULE: ./src/headless/shared/color.js



const { safeSave: color_safeSave, colorize: color_colorize } = headless_utils;

/**
 * @template {import('./types').ModelExtender} T
 * @param {T} BaseModel
 */
function color_ColorAwareModel(BaseModel) {

    return class ColorAwareModel extends BaseModel {
        async setColor() {
            const color = await color_colorize(this.getIdentifier());
            color_safeSave(this, { color });
        }

        getIdentifier() {
            if (this.get('type') === CHATROOMS_TYPE) {
                return this.get('jid');
            } else if (this.get('type') === 'groupchat') {
                return this.get('from_real_jid') || this.get('from');
            } else {
                return this.get('occupant_id') || this.get('jid') || this.get('from') || this.get('nick');
            }
        }

        /**
        * @returns {Promise<string>}
        */
        async getColor() {
            if (!this.get('color')) {
                await this.setColor();
            }
            return this.get('color');
        }

        /**
        * @param {string} append_style
        * @returns {Promise<string>}
        */
        async getAvatarStyle(append_style = '') {
            try {
                const color = await this.getColor();
                return `background-color: ${color} !important; ${append_style}`;
            } catch {
                return `background-color: gray !important; ${append_style}`;
            }
        }
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/model-with-contact.js







/**
 * @template {import('./types').ModelExtender} T
 * @param {T} BaseModel
 */
function model_with_contact_ModelWithContact(BaseModel) {
    return class ModelWithContact extends BaseModel {
        /**
         * @typedef {import('../plugins/roster/contact').default} RosterContact
         * @typedef {import('./_converse.js').Profile} Profile
         */

        initialize() {
            super.initialize();

            this.on('change:num_unread', () => this.updateContactUnreadCounter());
            this.on('contact:add', () => this.updateContactUnreadCounter());

            this.rosterContactAdded = getOpenPromise();
            this.onClosedChanged = () => this.setModelContact(this.get('jid'));
            /**
             * @public
             * @type {RosterContact|Profile}
             */
            this.contact = null;
        }

        updateContactUnreadCounter() {
            if (this.contact && this.get('type') === PRIVATE_CHAT_TYPE) {
                headless_utils.safeSave(this.contact, { num_unread: this.get('num_unread') });
            }
        }

        /**
         * @param {string} jid
         */
        async setModelContact(jid) {
            if (this.contact?.get('jid') === jid) return;

            if (this.get('type') === PRIVATE_CHAT_TYPE && this.get('closed')) {
                this.off('change:closed', this.onClosedChanged);
                this.on('change:closed', this.onClosedChanged);
                return;
            }

            const { session, state } = shared_converse;

            let contact;
            if (Strophe.getBareJidFromJid(jid) === session.get('bare_jid')) {
                contact = state.profile;
            } else {
                contact = await shared_api.contacts.get(jid);
                if (!contact && !(await shared_api.blocklist.get()).get(jid)) {
                    contact = await shared_api.contacts.add({ jid }, false, false);
                }
            }

            if (contact) {
                this.contact = contact;
                this.set('nickname', contact.get('nickname'));

                this.listenTo(this.contact, 'vcard:add', (changed) => {
                    this.trigger('contact:change', changed);
                });

                this.listenTo(this.contact, 'vcard:change', (changed) => {
                    this.trigger('contact:change', changed);
                });

                this.listenTo(this.contact, 'change', (changed) => {
                    if (changed.nickname) {
                        this.set('nickname', changed.nickname);
                    }
                    this.trigger('contact:change', changed);
                });

                this.listenTo(this.contact, 'destroy', () => {
                    delete this.contact;
                    this.trigger('contact:destroy');
                });

                this.rosterContactAdded.resolve();
                this.trigger('contact:add', this.contact);
            }
        }
    };
}

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/parsers.js


const { u: parsers_u } = api_public.env;

/**
 * @param {Element} iq
 * @returns {Promise<import("./types").VCardResult>}
 */
async function parseVCardResultStanza(iq) {
    const result = {
        email: iq.querySelector(':scope > vCard EMAIL USERID')?.textContent,
        fullname: iq.querySelector(':scope > vCard FN')?.textContent,
        image: iq.querySelector(':scope > vCard PHOTO BINVAL')?.textContent,
        image_type: iq.querySelector(':scope > vCard PHOTO TYPE')?.textContent,
        nickname: iq.querySelector(':scope > vCard NICKNAME')?.textContent,
        role: iq.querySelector(':scope > vCard ROLE')?.textContent,
        stanza: iq, // TODO: remove?
        url: iq.querySelector(':scope > vCard URL')?.textContent,
        vcard_updated: new Date().toISOString(),
        error: undefined,
        vcard_error: undefined,
        image_hash: undefined,
    };
    if (result.image) {
        const buffer = parsers_u.base64ToArrayBuffer(result.image);
        const ab = await crypto.subtle.digest('SHA-1', buffer);
        result['image_hash'] = parsers_u.arrayBufferToHex(ab);
    }
    return result;
}

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/utils.js
/**
 * @typedef {import('../../plugins/muc/message').default} MUCMessage
 * @typedef {import('../../plugins/status/profile').default} Profile
 * @typedef {import('../../plugins/vcard/vcards').default} VCards
 * @typedef {import('../../plugins/vcard/vcard').default} VCard
 * @typedef {import('../../shared/model-with-contact.js').default} ModelWithContact
 * @typedef {import('../muc/occupant.js').default} MUCOccupant
 * @typedef {import('@converse/skeletor').Model} Model
 */









const { Stanza: utils_Stanza, Strophe: utils_Strophe, sizzle: utils_sizzle, stx: utils_stx } = api_public.env;

utils_Strophe.addNamespace('VCARD_UPDATE', 'vcard-temp:x:update');

/**
 * @param {"get"|"set"|"result"} type
 * @param {string} jid
 * @param {Element} [vcard_el]
 */
function createStanza(type, jid, vcard_el) {
    const iq = utils_stx`
        <iq type="${type}"
            ${jid ? utils_Stanza.unsafeXML(`to="${jid}"`) : ''}
            xmlns="jabber:client">
            ${vcard_el ? '' : utils_stx`<vCard xmlns="${utils_Strophe.NS.VCARD}"></vCard>`}
        </iq>`;

    if (vcard_el) iq.cnode(vcard_el);

    return iq;
}

/**
 * @param {MUCOccupant} occupant
 */
function onOccupantAvatarChanged(occupant) {
    const hash = occupant.get('image_hash');
    const vcards = [];
    if (occupant.get('jid')) {
        vcards.push(shared_converse.state.vcards.get(occupant.get('jid')));
    }
    vcards.push(shared_converse.state.vcards.get(occupant.get('from')));
    vcards.forEach((v) => hash && v && v?.get('image_hash') !== hash && shared_api.vcard.update(v, true));
}

/**
 * @param {Model|MUCOccupant|MUCMessage} model
 * @param {boolean} [lazy_load=false]
 * @returns {Promise<VCard|null>}
 */
async function getVCardForModel(model, lazy_load = false) {
    await shared_api.waitUntil('VCardsInitialized');

    let vcard;
    if (model instanceof shared_converse.exports.MUCOccupant) {
        vcard = await getVCardForOccupant(/** @type {MUCOccupant} */ (model), lazy_load);
    } else if (model instanceof shared_converse.exports.MUCMessage) {
        vcard = await getVCardForMUCMessage(/** @type {MUCMessage} */ (model), lazy_load);
    } else {
        let jid;
        if (model instanceof shared_converse.exports.Message) {
            if (['error', 'info'].includes(model.get('type'))) {
                return;
            }
            jid = utils_Strophe.getBareJidFromJid(model.get('from'));
        } else {
            jid = model.get('jid');
        }

        if (!jid) {
            src_log.warn(`Could not set VCard on model because no JID found!`);
            return null;
        }
        const { vcards } = shared_converse.state;
        vcard = vcards.get(jid) || vcards.create({ jid }, { lazy_load });
    }

    if (vcard) {
        vcard.on('change', () => model.trigger('vcard:change'));
    }
    return vcard;
}

/**
 * @param {MUCOccupant} occupant
 * @param {boolean} [lazy_load=false]
 * @returns {Promise<VCard|null>}
 */
async function getVCardForOccupant(occupant, lazy_load = true) {
    await shared_api.waitUntil('VCardsInitialized');

    const { vcards, profile } = shared_converse.state;
    const muc = occupant?.collection?.chatroom;
    const nick = occupant.get('nick');

    if (nick && muc?.get('nick') === nick) {
        return profile.vcard;
    } else {
        const jid = occupant.get('jid') || occupant.get('from');
        if (jid) {
            return vcards.get(jid) || vcards.create({ jid }, { lazy_load });
        } else {
            src_log.debug(`Could not get VCard for occupant because no JID found!`);
            return null;
        }
    }
}

/**
 * @param {MUCMessage} message
 * @param {boolean} [lazy_load=true]
 * @returns {Promise<VCard|null>}
 */
async function getVCardForMUCMessage(message, lazy_load = true) {
    if (['error', 'info'].includes(message.get('type'))) return;

    await shared_api.waitUntil('VCardsInitialized');
    const { vcards, profile } = shared_converse.state;
    const muc = message?.collection?.chatbox;
    const nick = utils_Strophe.getResourceFromJid(message.get('from'));

    if (nick && muc?.get('nick') === nick) {
        return profile.vcard;
    } else {
        const jid = message.occupant?.get('jid') || message.get('from');
        if (jid) {
            return vcards.get(jid) || vcards.create({ jid }, { lazy_load });
        } else {
            src_log.warn(`Could not get VCard for message because no JID found! msgid: ${message.get('msgid')}`);
            return null;
        }
    }
}

function clearVCardsSession() {
    if (shouldClearCache(shared_converse)) {
        shared_api.promises.add('VCardsInitialized');
        if (shared_converse.state.vcards) {
            shared_converse.state.vcards.clearStore();
            Object.assign(shared_converse, { vcards: undefined }); // XXX DEPRECATED
            delete shared_converse.state.vcards;
        }
    }
}

/**
 * @param {string} jid
 */
async function fetchVCard(jid) {
    const bare_jid = shared_converse.session.get('bare_jid');
    const to = utils_Strophe.getBareJidFromJid(jid) === bare_jid ? null : jid;
    let iq;
    try {
        iq = await shared_api.sendIQ(createStanza('get', to));
    } catch (error) {
        const parsed_error = isElement(error) ? await parseErrorStanza(error) : error;
        const error_msg = parsed_error?.message;
        return {
            jid,
            stanza: isElement(error) ? error : null, // TODO: remove?
            error: error_msg,
            vcard_error: new Date().toISOString(),
        };
    }
    return parseVCardResultStanza(iq);
}

/**
 * @param {Element} pres
 */
async function handleVCardUpdatePresence(pres) {
    await shared_api.waitUntil('VCardsInitialized');
    const photo = utils_sizzle(`x[xmlns="${utils_Strophe.NS.VCARD_UPDATE}"] photo`, pres).pop();
    if (photo) {
        const avatar_hash = photo.textContent;
        const from_jid = utils_Strophe.getBareJidFromJid(pres.getAttribute('from'));
        const vcard = await shared_converse.state.vcards.get(from_jid);
        if (vcard?.get('image_hash') !== avatar_hash) {
            shared_api.vcard.update(from_jid, true).catch((e) => src_log.error(e));
        }
    }
}

let presence_ref;

function unregisterPresenceHandler() {
    if (presence_ref) {
        const connection = shared_api.connection.get();
        connection.deleteHandler(presence_ref);
        presence_ref = null;
    }
}

function registerPresenceHandler() {
    unregisterPresenceHandler();
    const connection = shared_api.connection.get();
    presence_ref = connection.addHandler(
        /** @param {Element} pres */
        (pres) => {
            try {
                handleVCardUpdatePresence(pres);
            } catch (e) {
                src_log.error(e);
            }
            return true;
        },
        null,
        'presence',
        null,
    );
}

/**
 * @param {import('strophe.js').Builder} stanza
 */
function updatePresence(stanza) {
    if (utils_sizzle(`x[xmlns=${utils_Strophe.NS.VCARD_UPDATE}"]`, stanza.root()).length === 0) {
        const node = utils_stx`<x xmlns="${utils_Strophe.NS.VCARD_UPDATE}"></x>`;
        stanza.root().cnode(node).up();
    }
    return stanza;
}

;// CONCATENATED MODULE: ./src/headless/shared/model-with-vcard.js



/**
 * @template {import('./types').ModelExtender} T
 * @param {T} BaseModel
 */
function model_with_vcard_ModelWithVCard(BaseModel) {
    /**
     * @typedef {import('../plugins/vcard/vcard').default} VCard
     */

    return class ModelWithVCard extends BaseModel {
        /**
         * @param {any[]} args
         */
        constructor(...args) {
            super(...args);
            this._vcard = null;
            this.lazy_load_vcard = false;
        }

        initialize() {
            super.initialize();
            this.getVCard();
        }

        get vcard() {
            return this._vcard;
        }

        /**
         * @returns {Promise<VCard|null>}
         */
        async getVCard() {
            const { pluggable } = shared_converse;
            if (!pluggable.plugins["converse-vcard"]?.enabled(shared_converse)) return null;

            if (this._vcard) return this._vcard;

            this._vcard = await getVCardForModel(this, this.lazy_load_vcard);
            this.trigger("vcard:add", { vcard: this._vcard });

            return this._vcard;
        }
    };
}

;// CONCATENATED MODULE: ./src/headless/shared/message.js













const { dayjs: message_dayjs, stx: message_stx } = api_public.env;

/**
 * @extends {Model}
 */
class BaseMessage extends model_with_vcard_ModelWithVCard(model_with_contact_ModelWithContact(color_ColorAwareModel(skeletor.Model))) {
    defaults() {
        return {
            msgid: getUniqueId(),
            time: new Date().toISOString(),
            is_ephemeral: false,
        };
    }

    /**
     * @param {Model[]} [models]
     * @param {object} [options]
     */
    constructor(models, options) {
        super(models, options);
        this.file = null;

        /** @type {import('./types').MessageAttributes} */
        this.attributes;
    }

    initialize() {
        this.lazy_load_vcard = true;
        super.initialize();

        this.chatbox = this.collection?.chatbox;
        if (!this.checkValidity()) return;

        if (this.get('file')) {
            this.on('change:put', () => this.uploadFile());
        }
        this.on('change:is_ephemeral', () => this.setTimerForEphemeralMessage());
        this.setTimerForEphemeralMessage();
    }

    checkValidity() {
        if (Object.keys(this.attributes).length === 3) {
            // XXX: This is an empty message with only the 3 default values.
            // This seems to happen when saving a newly created message
            // fails for some reason.
            // TODO: This is likely fixable by setting `wait` when
            // creating messages. See the wait-for-messages branch.
            this.validationError = 'Empty message';
            this.safeDestroy();
            return false;
        }
        return true;
    }

    safeDestroy() {
        try {
            this.destroy();
        } catch (e) {
            src_log.warn(`safeDestroy: ${e}`);
        }
    }

    /**
     * Sets an auto-destruct timer for this message, if it's is_ephemeral.
     */
    setTimerForEphemeralMessage() {
        if (this.ephemeral_timer) {
            clearTimeout(this.ephemeral_timer);
        }
        const is_ephemeral = this.isEphemeral();
        if (is_ephemeral) {
            const timeout = typeof is_ephemeral === 'number' ? is_ephemeral : 10000;
            this.ephemeral_timer = setTimeout(() => this.safeDestroy(), timeout);
        }
    }

    /**
     * Returns a boolean indicating whether this message is ephemeral,
     * meaning it will get automatically removed after ten seconds.
     * @returns {boolean}
     */
    isEphemeral() {
        return this.get('is_ephemeral');
    }

    /**
     * Returns a boolean indicating whether this message is a XEP-0245 /me command.
     * @returns {boolean}
     */
    isMeCommand() {
        const text = this.getMessageText();
        if (!text) {
            return false;
        }
        return text.startsWith('/me ');
    }

    /**
     * @returns {boolean}
     */
    isRetracted() {
        return this.get('retracted') || this.get('moderated') === 'retracted';
    }

    /**
     * Returns a boolean indicating whether this message is considered a followup
     * message from the previous one. Followup messages are shown grouped together
     * under one author heading.
     * A message is considered a followup of it's predecessor when it's a chat
     * message from the same author, within 10 minutes.
     * @returns {boolean}
     */
    isFollowup() {
        const messages = this.collection?.models;
        if (!messages) {
            // Happens during tests
            return false;
        }
        const idx = messages.indexOf(this);
        const prev_model = idx ? messages[idx - 1] : null;
        if (prev_model === null) {
            return false;
        }
        const date = message_dayjs(this.get('time'));
        return (
            this.get('from') === prev_model.get('from') &&
            !this.isRetracted() &&
            !prev_model.isRetracted() &&
            !this.isMeCommand() &&
            !prev_model.isMeCommand() &&
            !!this.get('is_encrypted') === !!prev_model.get('is_encrypted') &&
            this.get('type') === prev_model.get('type') &&
            this.get('type') !== 'info' &&
            date.isBefore(message_dayjs(prev_model.get('time')).add(10, 'minutes')) &&
            (this.get('type') === 'groupchat' ? this.get('occupant_id') === prev_model.get('occupant_id') : true)
        );
    }

    /**
     * Determines whether this message may be retracted by the current user.
     * @returns { Boolean }
     */
    mayBeRetracted() {
        const is_own_message = this.get('sender') === 'me';
        const not_canceled = this.get('error_type') !== 'cancel';
        return is_own_message && not_canceled && ['all', 'own'].includes(shared_api.settings.get('allow_message_retraction'));
    }

    getMessageText() {
        if (this.get('is_encrypted')) {
            const { __ } = shared_converse;
            return this.get('plaintext') || this.get('body') || __('Undecryptable OMEMO message');
        } else if (['groupchat', 'chat', 'normal'].includes(this.get('type'))) {
            return this.get('body');
        } else {
            return this.get('message');
        }
    }

    /**
     * Send out an IQ stanza to request a file upload slot.
     * https://xmpp.org/extensions/xep-0363.html#request
     */
    sendSlotRequestStanza() {
        if (!this.file) return Promise.reject(new Error('file is undefined'));

        const iq = message_stx`
            <iq from="${shared_converse.session.get('jid')}"
                to="${this.get('slot_request_url')}"
                type="get"
                xmlns="jabber:client">
                <request xmlns="${Strophe.NS.HTTPUPLOAD}"
                         filename="${this.file.name}"
                         size="${this.file.size}"
                         content-type="${this.file.type}">
                </request>
            </iq>`;
        return shared_api.sendIQ(iq);
    }

    /**
     * @param {Element} stanza
     */
    getUploadRequestMetadata(stanza) {
        const headers = sizzle_default()(`slot[xmlns="${Strophe.NS.HTTPUPLOAD}"] put header`, stanza);
        // https://xmpp.org/extensions/xep-0363.html#request
        // TODO: Can't set the Cookie header in JavaScript, instead cookies need
        // to be manually set via document.cookie, so we're leaving it out here.
        return {
            headers: headers
                .map((h) => ({ 'name': h.getAttribute('name'), 'value': h.textContent }))
                .filter((h) => ['Authorization', 'Expires'].includes(h.name)),
        };
    }

    async getRequestSlotURL() {
        const { __ } = shared_converse;
        let stanza;
        try {
            stanza = await this.sendSlotRequestStanza();
        } catch (e) {
            src_log.error(e);
            return this.save({
                is_ephemeral: true,
                message: __('Sorry, could not determine upload URL.'),
                type: 'error',
            });
        }
        const slot = sizzle_default()(`slot[xmlns="${Strophe.NS.HTTPUPLOAD}"]`, stanza).pop();
        if (slot) {
            this.upload_metadata = this.getUploadRequestMetadata(stanza);
            this.save({
                get: slot.querySelector('get').getAttribute('url'),
                put: slot.querySelector('put').getAttribute('url'),
            });
        } else {
            return this.save({
                is_ephemeral: true,
                message: __('Sorry, could not determine file upload URL.'),
                type: 'error',
            });
        }
    }

    uploadFile() {
        const xhr = new XMLHttpRequest();

        xhr.onreadystatechange = async (event) => {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                src_log.info('Status: ' + xhr.status);
                if (xhr.status === 200 || xhr.status === 201) {
                    let attrs = {
                        body: this.get('get'),
                        message: this.get('get'),
                        oob_url: this.get('get'),
                        upload: SUCCESS,
                    };
                    /**
                     * *Hook* which allows plugins to change the attributes
                     * saved on the message once a file has been uploaded.
                     * @event _converse#afterFileUploaded
                     */
                    attrs = await shared_api.hook('afterFileUploaded', this, attrs);
                    this.save(attrs);
                } else {
                    src_log.error(event);
                    xhr.onerror(new ProgressEvent(`Response status: ${xhr.status}`));
                }
            }
        };

        xhr.upload.addEventListener(
            'progress',
            (evt) => {
                if (evt.lengthComputable) {
                    this.set('progress', evt.loaded / evt.total);
                }
            },
            false
        );

        xhr.onerror = () => {
            const { __ } = shared_converse;
            let message;
            if (xhr.responseText) {
                message = __(
                    'Sorry, could not successfully upload your file. Your server’s response: "%1$s"',
                    xhr.responseText
                );
            } else {
                message = __('Sorry, could not successfully upload your file.');
            }
            this.save({
                is_ephemeral: true,
                message,
                type: 'error',
                upload: FAILURE,
            });
        };
        xhr.open('PUT', this.get('put'), true);
        xhr.setRequestHeader('Content-type', this.file.type);
        this.upload_metadata.headers?.forEach((h) => xhr.setRequestHeader(h.name, h.value));
        xhr.send(this.file);
    }
}

/* export default */ const shared_message = (BaseMessage);

;// CONCATENATED MODULE: ./src/headless/plugins/chat/parsers.js
/**
 * @module:plugin-chat-parsers
 */









const { Strophe: parsers_Strophe, dayjs: parsers_dayjs, sizzle: parsers_sizzle } = api_public.env;

/**
 * Parses a passed in message stanza and returns an object of attributes.
 * @param {Element} stanza - The message stanza
 * @returns {Promise<import('../../shared/types.ts').MessageAttributes|StanzaParseError>}
 */
async function parseMessage (stanza) {
    throwErrorIfInvalidForward(stanza);

    let to_jid = stanza.getAttribute('to');
    const to_resource = parsers_Strophe.getResourceFromJid(to_jid);
    const resource = shared_converse.session.get('resource');
    if (shared_api.settings.get('filter_by_resource') && to_resource && to_resource !== resource) {
        return new StanzaParseError(
            stanza,
            `Ignoring incoming message intended for a different resource: ${to_jid}`,
        );
    }

    const bare_jid = shared_converse.session.get('bare_jid');
    const original_stanza = stanza;
    let from_jid = stanza.getAttribute('from') || bare_jid;
    if (isCarbon(stanza)) {
        if (from_jid === bare_jid) {
            const selector = `[xmlns="${parsers_Strophe.NS.CARBONS}"] > forwarded[xmlns="${parsers_Strophe.NS.FORWARD}"] > message`;
            stanza = parsers_sizzle(selector, stanza).pop();
            to_jid = stanza.getAttribute('to');
            from_jid = stanza.getAttribute('from');
        } else {
            // Prevent message forging via carbons: https://xmpp.org/extensions/xep-0280.html#security
            rejectMessage(stanza, 'Rejecting carbon from invalid JID');
            return new StanzaParseError(stanza, `Rejecting carbon from invalid JID ${to_jid}`);
        }
    }

    const is_archived = isArchived(stanza);
    if (is_archived) {
        if (from_jid === bare_jid) {
            const selector = `[xmlns="${parsers_Strophe.NS.MAM}"] > forwarded[xmlns="${parsers_Strophe.NS.FORWARD}"] > message`;
            stanza = parsers_sizzle(selector, stanza).pop();
            to_jid = stanza.getAttribute('to');
            from_jid = stanza.getAttribute('from');
        } else {
            return new StanzaParseError(
                stanza,
                `Invalid Stanza: alleged MAM message from ${stanza.getAttribute('from')}`,
            );
        }
    }

    const from_bare_jid = parsers_Strophe.getBareJidFromJid(from_jid);
    const is_me = from_bare_jid === bare_jid;
    if (is_me && to_jid === null) {
        return new StanzaParseError(
            stanza,
            `Don't know how to handle message stanza without 'to' attribute. ${stanza.outerHTML}`,
        );
    }

    const is_headline = isHeadline(stanza);
    const is_server_message = isServerMessage(stanza);
    let contact, contact_jid;
    if (!is_headline && !is_server_message) {
        contact_jid = is_me ? parsers_Strophe.getBareJidFromJid(to_jid) : from_bare_jid;
        contact = await shared_api.contacts.get(contact_jid);
        if (contact === undefined && !shared_api.settings.get('allow_non_roster_messaging')) {
            src_log.error(stanza);
            return new StanzaParseError(
                stanza,
                `Blocking messaging with a JID not in our roster because allow_non_roster_messaging is false.`,
            );
        }
    }
    const delay = parsers_sizzle(`delay[xmlns="${parsers_Strophe.NS.DELAY}"]`, original_stanza).pop();
    const marker = getChatMarker(stanza);
    const now = new Date().toISOString();
    let attrs = Object.assign(
        {
            contact_jid,
            is_archived,
            is_headline,
            is_server_message,
            'body': stanza.querySelector('body')?.textContent?.trim(),
            'chat_state': getChatState(stanza),
            'from': stanza.getAttribute('from'),
            'is_carbon': isCarbon(original_stanza),
            'is_delayed': !!delay,
            'is_markable': !!parsers_sizzle(`markable[xmlns="${parsers_Strophe.NS.MARKERS}"]`, stanza).length,
            'is_marker': !!marker,
            'is_unstyled': !!parsers_sizzle(`unstyled[xmlns="${parsers_Strophe.NS.STYLING}"]`, stanza).length,
            'marker_id': marker && marker.getAttribute('id'),
            'nick': contact?.attributes?.nickname,
            'receipt_id': getReceiptId(stanza),
            'received': new Date().toISOString(),
            'references': getReferences(stanza),
            'sender': is_me ? 'me' : 'them',
            'subject': stanza.querySelector('subject')?.textContent,
            'thread': stanza.querySelector('thread')?.textContent,
            'time': delay ? parsers_dayjs(delay.getAttribute('stamp')).toISOString() : now,
            'to': stanza.getAttribute('to'),
            'type': stanza.getAttribute('type') || 'normal'
        },
        getErrorAttributes(stanza),
        getOutOfBandAttributes(stanza),
        getSpoilerAttributes(stanza),
        getCorrectionAttributes(stanza, original_stanza),
        getStanzaIDs(stanza, original_stanza),
        getRetractionAttributes(stanza, original_stanza),
        getEncryptionAttributes(stanza),
        getReplyAttributes(stanza)
    );

    if (attrs.is_archived) {
        const from = original_stanza.getAttribute('from');
        if (from && from !== bare_jid) {
            return new StanzaParseError(stanza, `Invalid Stanza: Forged MAM message from ${from}`);
        }
    }
    attrs = Object.assign(
        {
            'message': attrs.body || attrs.error, // TODO: Remove and use body and error attributes instead
            'is_valid_receipt_request': isValidReceiptRequest(stanza, attrs)
        },
        attrs
    );

    // We prefer to use one of the XEP-0359 unique and stable stanza IDs
    // as the Model id, to avoid duplicates.
    attrs['id'] = attrs['origin_id'] || attrs[`stanza_id ${attrs.from}`] || headless_utils.getUniqueId();

    /**
     * *Hook* which allows plugins to add additional parsing
     * @event _converse#parseMessage
     */
    attrs = await shared_api.hook('parseMessage', stanza, attrs);

    // We call this after the hook, to allow plugins (like omemo) to decrypt encrypted
    // messages, since we need to parse the message text to determine whether
    // there are media urls.
    const metadata = await headless_utils.getMediaURLsMetadata(attrs.is_encrypted ? attrs.plaintext : attrs.body);
    return Object.assign(attrs, metadata);
}

;// CONCATENATED MODULE: ./src/headless/plugins/chat/utils.js
/**
 * @module:headless-plugins-chat-utils
 * @typedef {import('./model.js').default} ChatBox
 * @typedef {import('../../shared/types.ts').MessageAttributes} MessageAttributes
 * @typedef {import('../../shared/errors').StanzaParseError} StanzaParseError
 * @typedef {import('strophe.js').Builder} Builder
 */










const { Strophe: chat_utils_Strophe, u: chat_utils_u } = api_public.env;

function routeToChat (event) {
    if (!location.hash.startsWith('#converse/chat?jid=')) {
        return;
    }
    event?.preventDefault();
    const jid = location.hash.split('=').pop();
    if (!chat_utils_u.isValidJID(jid)) {
        return src_log.warn(`Invalid JID "${jid}" provided in URL fragment`);
    }
    shared_api.chats.open(jid);
}

/**
 * Given a stanza, determine whether it's a new
 * message, i.e. not a MAM archived one.
 * @param {Element|Model|object} message
 */
function isNewMessage (message) {
    if (message instanceof Element) {
        return !(
            sizzle_default()(`result[xmlns="${chat_utils_Strophe.NS.MAM}"]`, message).length &&
            sizzle_default()(`delay[xmlns="${chat_utils_Strophe.NS.DELAY}"]`, message).length
        );
    } else if (message instanceof skeletor.Model) {
        message = message.attributes;
    }
    return !(message['is_delayed'] && message['is_archived']);
}

/**
 * @param {Element} stanza
 */
async function handleErrorMessage (stanza) {
    const from_jid = chat_utils_Strophe.getBareJidFromJid(stanza.getAttribute('from'));
    const bare_jid = shared_converse.session.get('bare_jid');
    if (chat_utils_u.isSameBareJID(from_jid, bare_jid)) {
        return;
    }
    const chatbox = await shared_api.chatboxes.get(from_jid);
    if (chatbox?.get('type') === PRIVATE_CHAT_TYPE) {
        chatbox?.handleErrorMessageStanza(stanza);
    }
}

function autoJoinChats () {
    // Automatically join private chats, based on the
    // "auto_join_private_chats" configuration setting.
    shared_api.settings.get('auto_join_private_chats').forEach(/** @param {string} jid */(jid) => {
        if (shared_converse.state.chatboxes.where({ 'jid': jid }).length) {
            return;
        }
        if (typeof jid === 'string') {
            shared_api.chats.open(jid);
        } else {
            src_log.error('Invalid jid criteria specified for "auto_join_private_chats"');
        }
    });
    /**
     * Triggered once any private chats have been automatically joined as
     * specified by the `auto_join_private_chats` setting.
     * See: https://conversejs.org/docs/configuration/#auto-join-private-chats
     *
     * @event _converse#privateChatsAutoJoined
     * @example _converse.api.listen.on('privateChatsAutoJoined', () => { ... });
     * @example _converse.api.waitUntil('privateChatsAutoJoined').then(() => { ... });
     */
    shared_api.trigger('privateChatsAutoJoined');
}

function registerMessageHandlers () {
    shared_api.connection.get().addHandler(
        /** @param {Element} stanza */
        (stanza) => {
            if (
                ['groupchat', 'error'].includes(stanza.getAttribute('type')) ||
                isHeadline(stanza) ||
                isServerMessage(stanza) ||
                isArchived(stanza)
            ) {
                return true;
            }
            return shared_converse.exports.handleMessageStanza(stanza) || true;
        },
        null,
        'message',
    );

    shared_api.connection.get().addHandler(
        /** @param {Element} stanza */
        (stanza) => {
            handleErrorMessage(stanza);
            return true;
        },
        null,
        'message',
        'error'
    );
}


/**
 * Handler method for all incoming single-user chat "message" stanzas.
 * @param {Element|Builder} stanza
 */
async function handleMessageStanza (stanza) {
    stanza = (stanza instanceof Element) ? stanza : stanza.tree();

    if (isServerMessage(stanza)) {
        // Prosody sends headline messages with type `chat`, so we need to filter them out here.
        const from = stanza.getAttribute('from');
        return src_log.info(`handleMessageStanza: Ignoring incoming server message from JID: ${from}`);
    }
    if (await isMUCPrivateMessage(stanza)) {
        return true;
    }

    let attrs;
    try {
        attrs = await parseMessage(stanza);
    } catch (e) {
        return src_log.error(e);
    }
    if (chat_utils_u.isErrorObject(attrs)) {
        const { stanza, message } = /** @type {StanzaParseError} */(attrs);
        if (stanza) src_log.error(stanza);
        return src_log.error(message);
    }

    const { body, plaintext, contact_jid, nick } = /** @type {MessageAttributes} */(attrs);

    // XXX: Need to take XEP-428 <fallback> into consideration
    const has_body = !!(body || plaintext);
    const chatbox = await shared_api.chats.get(contact_jid, { nickname: nick }, has_body);
    await chatbox?.queueMessage(attrs);
    /**
     * @typedef {Object} MessageData
     * An object containing the original message stanza, as well as the
     * parsed attributes.
     * @property {Element} stanza
     * @property {MessageAttributes} stanza
     * @property {ChatBox} chatbox
     */
    const data = { stanza, attrs, chatbox };
    /**
     * Triggered when a message stanza is been received and processed.
     * @event _converse#message
     * @type {MessageData} data
     */
    shared_api.trigger('message', data);
}

/**
 * Ask the XMPP server to enable Message Carbons
 * See [XEP-0280](https://xmpp.org/extensions/xep-0280.html#enabling)
 */
async function enableCarbons () {
    const bare_jid = shared_converse.session.get('bare_jid');
    const domain = chat_utils_Strophe.getDomainFromJid(bare_jid);
    const supported = await shared_api.disco.supports(chat_utils_Strophe.NS.CARBONS, domain);

    if (!supported) {
        src_log.warn("Not enabling carbons because it's not supported!");
        return;
    }

    const iq = new chat_utils_Strophe.Builder('iq', {
        'from': shared_api.connection.get().jid,
        'type': 'set'
    }).c('enable', {xmlns: chat_utils_Strophe.NS.CARBONS});

    const result = await shared_api.sendIQ(iq, null, false);
    if (result === null) {
        src_log.warn(`A timeout occurred while trying to enable carbons`);
    } else if (chat_utils_u.isErrorStanza(result)) {
        src_log.warn('An error occurred while trying to enable message carbons.');
        src_log.error(result);
    } else {
        src_log.debug('Message carbons have been enabled.');
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/model-with-messages.js
















const { Strophe: model_with_messages_Strophe, stx: model_with_messages_stx, u: model_with_messages_u } = api_public.env;

/**
 * Adds a messages collection to a model and various methods related to sending
 * and receiving chat messages.
 *
 * This model should be UX-agnostic, except when it comes to the rendering of
 * messages. So there's no assumption of uniformity with regards to UI elements
 * represented by this object.
 *
 * @template {import('./types').ModelExtender} T
 * @param {T} BaseModel
 */
function model_with_messages_ModelWithMessages(BaseModel) {
    /**
     * @typedef {import('../plugins/chat/model').default} ChatBox
     * @typedef {import('../plugins/muc/muc').default} MUC
     * @typedef {import('../plugins/muc/parsers').MUCMessageAttributes} MUCMessageAttributes
     * @typedef {import('../shared/types').MessageAttributes} MessageAttributes
     * @typedef {import('./message').default} BaseMessage
     */

    return class ModelWithMessages extends BaseModel {
        /** @param {...any} args */
        constructor(...args) {
            super(args[0], args[1]);
            this.disable_mam = false;
        }

        async initialize() {
            super.initialize();

            this.initUI();
            this.initMessages();
            this.initNotifications();

            this.ui.on('change:scrolled', () => this.onScrolledChanged());
        }

        initNotifications() {
            this.notifications = new skeletor.Model();
        }

        initUI() {
            this.ui = new skeletor.Model();
        }

        /**
         * @returns {string}
         */
        getDisplayName() {
            return this.get('jid');
        }

        canPostMessages() {
            // Can be overridden in subclasses.
            return true;
        }

        /**
         * Queue the creation of a message, to make sure that we don't run
         * into a race condition whereby we're creating a new message
         * before the collection has been fetched.
         * @param {Object} attrs
         * @param {Object} options
         */
        async createMessage(attrs, options) {
            attrs.time = attrs.time || new Date().toISOString();
            await this.messages.fetched;
            return this.messages.create(attrs, options);
        }

        getMessagesCacheKey() {
            return `converse.messages-${this.get('jid')}-${shared_converse.session.get('bare_jid')}`;
        }

        getMessagesCollection() {
            return new shared_converse.exports.Messages();
        }

        getNotificationsText() {
            const { __ } = shared_converse;
            if (this.notifications?.get('chat_state') === COMPOSING) {
                return __('%1$s is typing', this.getDisplayName());
            } else if (this.notifications?.get('chat_state') === PAUSED) {
                return __('%1$s has stopped typing', this.getDisplayName());
            } else if (this.notifications?.get('chat_state') === GONE) {
                return __('%1$s has gone away', this.getDisplayName());
            } else {
                return '';
            }
        }

        initMessages() {
            this.messages = this.getMessagesCollection();
            this.messages.fetched = getOpenPromise();
            this.messages.chatbox = this;
            initStorage(this.messages, this.getMessagesCacheKey());

            this.listenTo(this.messages, 'add', (m) => this.onMessageAdded(m));
            this.listenTo(this.messages, 'change:upload', (m) => this.onMessageUploadChanged(m));
            this.listenTo(this.messages, 'change:correcting', (m) => this.onMessageCorrecting(m));
        }

        fetchMessages() {
            if (this.messages.fetched_flag) {
                src_log.info(`Not re-fetching messages for ${this.get('jid')}`);
                return;
            }
            this.messages.fetched_flag = true;
            const resolve = this.messages.fetched.resolve;
            this.messages.fetch({
                add: true,
                success: () => {
                    this.afterMessagesFetched();
                    resolve();
                },
                error: () => {
                    this.afterMessagesFetched();
                    resolve();
                },
            });
            return this.messages.fetched;
        }

        afterMessagesFetched() {
            this.pruneHistoryWhenScrolledDown();
            /**
             * Triggered whenever a {@link ModelWithMessages}
             * has fetched its messages from the local cache.
             * @event _converse#afterMessagesFetched
             * @type {ModelWithMessages}
             * @example _converse.api.listen.on('afterMessagesFetched', (model) => { ... });
             */
            shared_api.trigger('afterMessagesFetched', this);
        }

        /**
         * @param {MessageAttributes|Error} _attrs_or_error
         */
        async onMessage(_attrs_or_error) {
            throw new MethodNotImplementedError('onMessage is not implemented');
        }

        /**
         * @param {BaseMessage} message
         * @param {MessageAttributes} attrs
         * @returns {Promise<object>}
         */
        async getUpdatedMessageAttributes(message, attrs) {
            let new_attrs;
            if (!attrs.error_type && message.get('error_type') === 'Decryption') {
                // Looks like we have a failed decrypted message stored, and now
                // we have a properly decrypted version of the same message.
                // See issue: https://github.com/conversejs/converse.js/issues/2733#issuecomment-1035493594
                new_attrs = Object.assign({}, attrs, {
                    error_condition: undefined,
                    error_message: undefined,
                    error_text: undefined,
                    error_type: undefined,
                    is_archived: attrs.is_archived,
                    is_ephemeral: false,
                    is_error: false,
                });
            } else {
                new_attrs = {
                    is_archived: attrs.is_archived,
                    ...(attrs.is_archived && attrs.time && { time: attrs.time }),
                };
            }

            /**
             * *Hook* which allows plugins to update the attributes that will be
             * set on an existing message when new attributes are received.
             * @event _converse#getUpdatedMessageAttributes
             */
            return await shared_api.hook('getUpdatedMessageAttributes', message, new_attrs, attrs);
        }

        /**
         * @param {BaseMessage} message
         * @param {MessageAttributes} attrs
         */
        async updateMessage(message, attrs) {
            const new_attrs = await this.getUpdatedMessageAttributes(message, attrs);
            new_attrs && message.save(new_attrs);
        }

        /**
         * Determines whether the given attributes of an incoming message
         * represent a XEP-0308 correction and, if so, handles it appropriately.
         * @param {MessageAttributes|MUCMessageAttributes} attrs - Attributes representing a received
         *  message, as returned by {@link parseMessage}
         * @returns {Promise<BaseMessage|void>} Returns the corrected
         *  message or `undefined` if not applicable.
         */
        async handleCorrection(attrs) {
            if (!attrs.replace_id || !attrs.from) {
                return;
            }

            let query;
            if (attrs.type === 'groupchat') {
                const { occupant_id, replace_id } = /** @type {MUCMessageAttributes} */ (attrs);
                query = occupant_id
                    ? ({ attributes: m }) => m.msgid === replace_id && m.occupant_id == occupant_id
                    : ({ attributes: m }) =>
                          m.msgid === attrs.replace_id && m.from === attrs.from && m.occupant_id == null;
            } else {
                query = ({ attributes: m }) =>
                    m.msgid === attrs.replace_id && m.from === attrs.from && m.occupant_id == null;
            }

            const message = this.messages.models.find(query);
            if (!message) {
                attrs['older_versions'] = {};
                return await this.createMessage(attrs); // eslint-disable-line no-return-await
            }

            const older_versions = message.get('older_versions') || {};
            if (attrs.time < message.get('time') && message.get('edited')) {
                // This is an older message which has been corrected afterwards
                older_versions[attrs.time] = attrs['message'];
                message.save({ older_versions });
            } else {
                // This is a correction of an earlier message we already received
                if (Object.keys(older_versions).length) {
                    older_versions[message.get('edited')] = message.getMessageText();
                } else {
                    older_versions[message.get('time')] = message.getMessageText();
                }
                attrs = Object.assign(attrs, { older_versions });
                delete attrs['msgid']; // We want to keep the msgid of the original message
                delete attrs['id']; // Delete id, otherwise a new cache entry gets created
                attrs['time'] = message.get('time');
                message.save(attrs);
            }
            return message;
        }

        /**
         * Queue an incoming `chat` message stanza for processing.
         * @param {MessageAttributes} attrs - A promise which resolves to the message attributes
         */
        queueMessage(attrs) {
            this.msg_chain = (this.msg_chain || this.messages.fetched)
                .then(() => this.onMessage(attrs))
                .catch((e) => src_log.error(e));
            return this.msg_chain;
        }

        /**
         * @param {MessageAttributes} [_attrs]
         * @return {Promise<MessageAttributes>}
         */
        async getOutgoingMessageAttributes(_attrs) {
            throw new MethodNotImplementedError('getOutgoingMessageAttributes is not implemented');
        }

        /**
         * Responsible for sending off a text message inside an ongoing chat conversation.
         * @param {Object} [attrs] - A map of attributes to be saved on the message
         * @returns {Promise<BaseMessage>}
         * @example
         *  const chat = api.chats.get('buddy1@example.org');
         *  chat.sendMessage({'body': 'hello world'});
         */
        async sendMessage(attrs) {
            await shared_api.emojis.initialize();

            if (!this.canPostMessages()) {
                src_log.warn('sendMessage was called but canPostMessages is false');
                return;
            }

            attrs = await this.getOutgoingMessageAttributes(attrs);
            let message = this.messages.findWhere('correcting');
            if (message) {
                const older_versions = message.get('older_versions') || {};
                const edited_time = message.get('edited') || message.get('time');
                older_versions[edited_time] = message.getMessageText();

                message.save({
                    ...['body', 'is_only_emojis', 'media_urls', 'references', 'is_encrypted'].reduce((obj, k) => {
                        if (attrs.hasOwnProperty(k)) obj[k] = attrs[k];
                        return obj;
                    }, {}),
                    ...{
                        correcting: false,
                        edited: new Date().toISOString(),
                        message: attrs.body,
                        ogp_metadata: [],
                        older_versions,
                        origin_id: model_with_messages_u.getUniqueId(),
                        plaintext: attrs.is_encrypted ? attrs.message : undefined,
                        received: undefined,
                    },
                });
            } else {
                this.setEditable(attrs, new Date().toISOString());
                message = await this.createMessage(attrs);
            }

            try {
                const stanza = await this.createMessageStanza(message);
                shared_api.send(stanza);
            } catch (e) {
                message.destroy();
                src_log.error(e);
                return;
            }

            /**
             * Triggered when a message is being sent out
             * @event _converse#sendMessage
             * @type {Object}
             * @param {Object} data
             * @property {(ChatBox|MUC)} data.chatbox
             * @property {(BaseMessage)} data.message
             */
            shared_api.trigger('sendMessage', { chatbox: this, message });
            return message;
        }

        /**
         * Retract one of your messages in this chat
         * @param {BaseMessage} message - The message which we're retracting.
         */
        retractOwnMessage(message) {
            const retraction_id = model_with_messages_u.getUniqueId();
            sendRetractionMessage(this.get('jid'), message, retraction_id);
            message.save({
                'retracted': new Date().toISOString(),
                'retracted_id': message.get('origin_id'),
                'retraction_id': retraction_id,
                'is_ephemeral': true,
                'editable': false,
            });
        }

        /**
         * @param {File[]} files'
         */
        async sendFiles(files) {
            const { __, session } = shared_converse;
            const result = await shared_api.disco.features.get(model_with_messages_Strophe.NS.HTTPUPLOAD, session.get('domain'));
            const item = result.pop();
            if (!item) {
                this.createMessage({
                    'message': __('Sorry, looks like file upload is not supported by your server.'),
                    'type': 'error',
                    'is_ephemeral': true,
                });
                return;
            }
            const data = item.dataforms
                .where({ 'FORM_TYPE': { 'value': model_with_messages_Strophe.NS.HTTPUPLOAD, 'type': 'hidden' } })
                .pop();
            const max_file_size = parseInt((data?.attributes || {})['max-file-size']?.value, 10);
            const slot_request_url = item?.id;

            if (!slot_request_url) {
                this.createMessage({
                    'message': __('Sorry, looks like file upload is not supported by your server.'),
                    'type': 'error',
                    'is_ephemeral': true,
                });
                return;
            }
            Array.from(files).forEach(async (file) => {
                /**
                 * *Hook* which allows plugins to transform files before they'll be
                 * uploaded. The main use-case is to encrypt the files.
                 * @event _converse#beforeFileUpload
                 * @param {ChatBox|MUC} chat - The chat from which this file will be uploaded.
                 * @param {File} file - The file that will be uploaded
                 */
                file = await shared_api.hook('beforeFileUpload', this, file);

                if (!isNaN(max_file_size) && file.size > max_file_size) {
                    const size = filesize(max_file_size);
                    const message = Array.isArray(size)
                        ? __('The size of your file, %1$s, exceeds the maximum allowed by your server.', file.name)
                        : __(
                              'The size of your file, %1$s, exceeds the maximum allowed by your server, which is %2$s.',
                              file.name,
                              size,
                          );
                    return this.createMessage({
                        message,
                        type: 'error',
                        is_ephemeral: true,
                    });
                } else {
                    const initial_attrs = await this.getOutgoingMessageAttributes();
                    const attrs = Object.assign(initial_attrs, {
                        'file': true,
                        'progress': 0,
                        'slot_request_url': slot_request_url,
                    });
                    this.setEditable(attrs, new Date().toISOString());
                    const message = await this.createMessage(attrs, { 'silent': true });
                    message.file = file;
                    this.messages.trigger('add', message);
                    message.getRequestSlotURL();
                }
            });
        }

        /**
         * Responsible for setting the editable attribute of messages.
         * If api.settings.get('allow_message_corrections') is "last", then only the last
         * message sent from me will be editable. If set to "all" all messages
         * will be editable. Otherwise no messages will be editable.
         * @param {Object} attrs An object containing message attributes.
         * @param {String} send_time - time when the message was sent
         */
        setEditable(attrs, send_time) {
            if (attrs.is_headline || model_with_messages_u.isEmptyMessage(attrs) || attrs.sender !== 'me') {
                return;
            }
            if (shared_api.settings.get('allow_message_corrections') === 'all') {
                attrs.editable = !(attrs.file || attrs.retracted || 'oob_url' in attrs);
            } else if (shared_api.settings.get('allow_message_corrections') === 'last' && send_time > this.get('time_sent')) {
                this.set({ 'time_sent': send_time });
                this.messages.findWhere({ 'editable': true })?.save({ 'editable': false });
                attrs.editable = !(attrs.file || attrs.retracted || 'oob_url' in attrs);
            }
        }

        /**
         * Mutator for setting the chat state of this chat session.
         * Handles clearing of any chat state notification timeouts and
         * setting new ones if necessary.
         * Timeouts are set when the  state being set is COMPOSING or PAUSED.
         * After the timeout, COMPOSING will become PAUSED and PAUSED will become INACTIVE.
         * See XEP-0085 Chat State Notifications.
         * @param {string} state - The chat state (consts ACTIVE, COMPOSING, PAUSED, INACTIVE, GONE)
         * @param {object} [options]
         */
        setChatState(state, options) {
            if (this.chat_state_timeout !== undefined) {
                clearTimeout(this.chat_state_timeout);
                delete this.chat_state_timeout;
            }
            if (state === COMPOSING) {
                this.chat_state_timeout = setTimeout(
                    this.setChatState.bind(this),
                    shared_converse.TIMEOUTS.PAUSED,
                    PAUSED,
                );
            } else if (state === PAUSED) {
                this.chat_state_timeout = setTimeout(
                    this.setChatState.bind(this),
                    shared_converse.TIMEOUTS.INACTIVE,
                    INACTIVE,
                );
            }
            this.set('chat_state', state, options);
            return this;
        }

        /**
         * @param {BaseMessage} message
         */
        onMessageAdded(message) {
            if (
                shared_api.settings.get('prune_messages_above') &&
                (shared_api.settings.get('pruning_behavior') === 'scrolled' || !this.ui.get('scrolled')) &&
                !model_with_messages_u.isEmptyMessage(message)
            ) {
                this.debouncedPruneHistory();
            }
        }

        /**
         * @param {BaseMessage} message
         */
        async onMessageUploadChanged(message) {
            if (message.get('upload') === SUCCESS) {
                const attrs = {
                    'body': message.get('body'),
                    'spoiler_hint': message.get('spoiler_hint'),
                    'oob_url': message.get('oob_url'),
                };
                await this.sendMessage(attrs);
                message.destroy();
            }
        }

        /**
         * @param {BaseMessage} message
         */
        onMessageCorrecting(message) {
            if (message.get('correcting')) {
                this.save({ correcting: message.get('id'), draft: model_with_messages_u.prefixMentions(message) });
            } else {
                this.save({ correcting: undefined, draft: undefined });
            }
        }

        onScrolledChanged() {
            if (!this.ui.get('scrolled')) {
                this.clearUnreadMsgCounter();
                this.pruneHistoryWhenScrolledDown();
            }
        }

        pruneHistoryWhenScrolledDown() {
            if (
                shared_api.settings.get('prune_messages_above') &&
                shared_api.settings.get('pruning_behavior') === 'unscrolled' &&
                !this.ui.get('scrolled')
            ) {
                this.debouncedPruneHistory();
            }
        }

        /**
         * @param {MessageAttributes} attrs
         * @returns {Promise<boolean>}
         */
        shouldShowErrorMessage(attrs) {
            const msg = this.getMessageReferencedByError(attrs);
            if (!msg && attrs.chat_state) {
                // If the error refers to a message not included in our store,
                // and it has a chat state tag, we assume that this was a
                // CSI message (which we don't store).
                // See https://github.com/conversejs/converse.js/issues/1317
                return;
            }
            // Gets overridden
            // Return promise because subclasses need to return promises
            return Promise.resolve(true);
        }

        async clearMessages() {
            try {
                await this.messages.clearStore();
            } catch (e) {
                this.messages.trigger('reset');
                src_log.error(e);
            } finally {
                // No point in fetching messages from the cache if it's been cleared.
                // Make sure to resolve the fetched promise to avoid freezes.
                this.messages.fetched.resolve();
            }
        }

        editEarlierMessage() {
            let message;
            let idx = this.messages.findLastIndex('correcting');
            if (idx >= 0) {
                this.messages.at(idx).save('correcting', false);
                while (idx > 0) {
                    idx -= 1;
                    const candidate = this.messages.at(idx);
                    if (candidate.get('editable')) {
                        message = candidate;
                        break;
                    }
                }
            }
            message =
                message ||
                this.messages
                    .filter({ sender: 'me' })
                    .reverse()
                    .find((m) => m.get('editable'));

            message?.save('correcting', true);
        }

        editLaterMessage() {
            let message;
            let idx = this.messages.findLastIndex('correcting');
            if (idx >= 0) {
                this.messages.at(idx).save('correcting', false);
                while (idx < this.messages.length - 1) {
                    idx += 1;
                    const candidate = this.messages.at(idx);
                    if (candidate.get('editable')) {
                        message = candidate;
                        message.save('correcting', true);
                        break;
                    }
                }
            }
            return message;
        }

        /**
         * Used by sub-classes to indicate whether a message is a chat
         * message, as opposed to error or info messages.
         * @param {BaseMessage} _message
         * @returns {boolean}
         */
        isChatMessage(_message) {
            throw new MethodNotImplementedError();
        }

        /** @returns {BaseMessage} */
        getOldestMessage() {
            for (let i = 0; i < this.messages.length; i++) {
                const message = this.messages.at(i);
                if (this.isChatMessage(message)) {
                    return message;
                }
            }
        }

        /** @returns {BaseMessage} */
        getMostRecentMessage() {
            for (let i = this.messages.length - 1; i >= 0; i--) {
                const message = this.messages.at(i);
                if (this.isChatMessage(message)) {
                    return message;
                }
            }
        }

        /**
         * Given an error `<message>` stanza's attributes, find the saved message model which is
         * referenced by that error.
         * @param {object} attrs
         */
        getMessageReferencedByError(attrs) {
            if (attrs.msgid) {
                return this.messages.models.find((m) =>
                    [m.get('msgid'), m.get('retraction_id'), m.get('origin_id')].includes(attrs.msgid),
                );
            } else if (attrs.reaction_to_id) {
                return this.messages.models.find((m) =>
                    [m.get('msgid'), m.get('origin_id')].includes(attrs.reaction_to_id),
                );
            }
        }

        /**
         * Looks whether we already have a retraction for this
         * incoming message. If so, it's considered "dangling" because it
         * probably hasn't been applied to anything yet, given that the
         * relevant message is only coming in now.
         * @param {object} attrs - Attributes representing a received
         *  message, as returned by {@link parseMessage}
         * @returns {BaseMessage|null}
         */
        findDanglingRetraction(attrs) {
            if (!attrs.origin_id || !this.messages.length) {
                return null;
            }
            // Only look for dangling retractions if there are newer
            // messages than this one, since retractions come after.
            if (this.messages.last().get('time') > attrs.time) {
                // Search from latest backwards
                const messages = Array.from(this.messages.models);
                messages.reverse();
                return messages.find(
                    ({ attributes }) =>
                        attributes.retracted_id === attrs.origin_id &&
                        attributes.from === attrs.from &&
                        !attributes.moderated_by,
                );
            }
            return null;
        }

        /**
         * Returns an already cached message (if it exists) based on the
         * passed in attributes map.
         *
         * @fires getDuplicateMessageQueries
         * @param {object} attrs - Attributes representing a received
         *  message, as returned by {@link parseMessage}
         * @returns {Promise<BaseMessage|undefined>}
         */
        async getDuplicateMessage(attrs) {
            /**
             * Hook to let plugins contribute additional query objects.
             * Each query object is a plain `{ attribute: value }` map;
             * a message matches if every key in the object equals the corresponding
             * attribute on the stored model. The built-in queries cover stanza_id,
             * origin_id, and body deduplication; plugins add their own criteria.
             */
            const extra_queries = await shared_api.hook('getDuplicateMessageQueries', this, [], attrs);

            const queries = [
                ...this.getStanzaIdQueryAttrs(attrs),
                this.getOriginIdQueryAttrs(attrs),
                this.getMessageBodyQueryAttrs(attrs),
                ...extra_queries,
            ].filter((s) => s);

            return this.messages.models.find(
                /** @param {BaseMessage} m */
                (m) => queries.find((q) => Object.keys(q).every((k) => m.get(k) === q[k])),
            );
        }

        /**
         * @param {object} attrs - Attributes representing a received
         */
        getOriginIdQueryAttrs(attrs) {
            return attrs.origin_id && { origin_id: attrs.origin_id, from: attrs.from };
        }

        /**
         * @param {object} attrs - Attributes representing a received
         */
        getStanzaIdQueryAttrs(attrs) {
            const keys = Object.keys(attrs).filter((k) => k.startsWith('stanza_id '));
            return keys.map((key) => {
                const by_jid = key.replace(/^stanza_id /, '');
                const query = {};
                query[`stanza_id ${by_jid}`] = attrs[key];
                return query;
            });
        }

        /**
         * @param {object} attrs - Attributes representing a received
         */
        getMessageBodyQueryAttrs(attrs) {
            if (attrs.msgid) {
                const query = {
                    from: attrs.from,
                    msgid: attrs.msgid,
                };
                // XXX: Need to take XEP-428 <fallback> into consideration
                if (!attrs.is_encrypted && attrs.body) {
                    // We can't match the message if it's a reflected
                    // encrypted message (e.g. via MAM or in a MUC)
                    query['body'] = attrs.body;
                }
                return query;
            }
        }

        /**
         * Given the passed in message object, send a XEP-0333 chat marker.
         * @param {BaseMessage} msg
         * @param {('received'|'displayed'|'acknowledged')} [type='displayed']
         * @param {boolean} [force=false] - Whether a marker should be sent for the
         *  message, even if it didn't include a `markable` element.
         */
        async sendMarkerForMessage(msg, type = 'displayed', force = false) {
            if (!msg || msg?.get('type') === 'groupchat' || !shared_api.settings.get('send_chat_markers').includes(type)) {
                return;
            }

            // Don't send chat markers to contacts that are not subscribed
            // to our presence.
            const contact = await shared_api.contacts.get(this.get('jid'));
            const subscription = contact?.get('subscription');
            if (!contact || subscription === 'none' || subscription === 'to') {
                return;
            }

            if (msg?.get('is_markable') || force) {
                const from_jid = model_with_messages_Strophe.getBareJidFromJid(msg.get('from'));
                sendMarker(from_jid, msg.get('msgid'), type, msg.get('type'));
            }
        }

        /**
         * Given a newly received {@link BaseMessage} instance,
         * update the unread counter if necessary.
         * @param {BaseMessage} message
         */
        handleUnreadMessage(message) {
            if (!message?.get('body')) {
                return;
            }

            if (isNewMessage(message)) {
                if (message.get('sender') === 'me') {
                    // We remove the "scrolled" flag so that the chat area
                    // gets scrolled down. We always want to scroll down
                    // when the user writes a message as opposed to when a
                    // message is received.
                    this.ui.set('scrolled', false);
                } else if (this.isHidden()) {
                    this.incrementUnreadMsgsCounter(message);
                } else {
                    this.sendMarkerForMessage(message);
                }
            }
        }

        /**
         * @param {BaseMessage} message
         * @param {MessageAttributes} attrs
         */
        async getErrorAttributesForMessage(message, attrs) {
            const { __ } = shared_converse;
            const new_attrs = {
                editable: false,
                error: attrs.error,
                error_condition: attrs.error_condition,
                error_text: attrs.error_text,
                error_type: attrs.error_type,
                is_error: true,
            };
            if (attrs.msgid === message.get('retraction_id')) {
                // The error message refers to a retraction
                new_attrs.retraction_id = undefined;
                if (!attrs.error) {
                    if (attrs.error_condition === 'forbidden') {
                        new_attrs.error = __("You're not allowed to retract your message.");
                    } else {
                        new_attrs.error = __('Sorry, an error occurred while trying to retract your message.');
                    }
                }
            } else if (!attrs.error) {
                if (attrs.error_condition === 'forbidden') {
                    new_attrs.error = __("You're not allowed to send a message.");
                } else {
                    new_attrs.error = __('Sorry, an error occurred while trying to send your message.');
                }
            }
            /**
             * *Hook* which allows plugins to add application-specific attributes
             * @event _converse#getErrorAttributesForMessage
             * @param {BaseMessage} message - The message context
             * @param {Object} new_attrs - The newly created error attributes
             * @param {Object} attrs - The original stanza attributes
             */
            return await shared_api.hook('getErrorAttributesForMessage', message, new_attrs, attrs);
        }

        /**
         * @param {Element} stanza
         */
        async handleErrorMessageStanza(stanza) {
            const attrs_or_error = await parseMessage(stanza);
            if (model_with_messages_u.isErrorObject(attrs_or_error)) {
                const { stanza, message } = /** @type {errors.StanzaParseError} */ (attrs_or_error);
                if (stanza) src_log.error(stanza);
                return src_log.error(message);
            }

            const attrs = /** @type {MessageAttributes} */ (attrs_or_error);
            if (!(await this.shouldShowErrorMessage(attrs))) {
                return;
            }

            const message = this.getMessageReferencedByError(attrs);
            if (message) {
                const new_attrs = await this.getErrorAttributesForMessage(message, attrs);
                message.save(new_attrs);
            } else {
                this.createMessage(attrs);
            }
        }

        /**
         * @param {BaseMessage} message
         */
        incrementUnreadMsgsCounter(message) {
            this.save({
                num_unread: this.get('num_unread') + 1,
                ...(this.get('num_unread') === 0 ? { first_unread_id: message.get('id') } : null),
            });
        }

        clearUnreadMsgCounter() {
            if (this.get('num_unread') > 0) {
                this.sendMarkerForMessage(this.messages.last());
                model_with_messages_u.safeSave(this, { num_unread: 0 });
            }
        }

        /**
         * Handles message retraction based on the passed in attributes.
         * @param {MessageAttributes} attrs - Attributes representing a received
         *  message, as returned by {@link parseMessage}
         * @returns {Promise<Boolean>} Returns `true` or `false` depending on
         *  whether a message was retracted or not.
         */
        async handleRetraction(attrs) {
            const RETRACTION_ATTRIBUTES = ['retracted', 'retracted_id', 'editable'];
            if (attrs.retracted) {
                if (attrs.is_tombstone) return false;

                for (const m of this.messages.models) {
                    if (m.get('from') !== attrs.from) continue;
                    if (m.get('origin_id') === attrs.retracted_id || m.get('msgid') === attrs.retracted_id) {
                        m.save(lodash_es_pick(attrs, RETRACTION_ATTRIBUTES));
                        return true;
                    }
                }

                attrs['dangling_retraction'] = true;
                await this.createMessage(attrs);
                return true;
            } else {
                // Check if we have dangling retraction
                const message = this.findDanglingRetraction(attrs);
                if (message) {
                    const retraction_attrs = lodash_es_pick(message.attributes, RETRACTION_ATTRIBUTES);
                    const new_attrs = Object.assign({ dangling_retraction: false }, attrs, retraction_attrs);
                    delete new_attrs['id']; // Delete id, otherwise a new cache entry gets created
                    message.save(new_attrs);
                    return true;
                }
            }
            return false;
        }

        /**
         * @param {MessageAttributes} attrs
         */
        handleReceipt(attrs) {
            if (attrs.sender === 'them') {
                if (attrs.is_valid_receipt_request) {
                    sendReceiptStanza(attrs.from, attrs.msgid);
                } else if (attrs.receipt_id) {
                    const message = this.messages.findWhere({ 'msgid': attrs.receipt_id });
                    if (message && !message.get('received')) {
                        message.save({ 'received': new Date().toISOString() });
                    }
                    return true;
                }
            }
            return false;
        }

        /**
         * Given a {@link BaseMessage} return the XML stanza that represents it.
         * @method ChatBox#createMessageStanza
         * @param {BaseMessage} message - The message object
         */
        async createMessageStanza(message) {
            const {
                body,
                edited,
                is_encrypted,
                is_spoiler,
                msgid,
                oob_url,
                origin_id,
                references,
                reply_to_id,
                reply_to,
                spoiler_hint,
                type,
            } = message.attributes;

            const stanza = model_with_messages_stx`
                <message xmlns="jabber:client"
                        from="${message.get('type') === 'groupchat' ? shared_api.connection.get().jid : message.get('from')}"
                        to="${message.get('to') || this.get('jid')}"
                        type="${this.get('message_type')}"
                        id="${(edited && model_with_messages_u.getUniqueId()) || msgid}">
                    ${body ? model_with_messages_stx`<body>${body}</body>` : ''}
                    <active xmlns="${model_with_messages_Strophe.NS.CHATSTATES}"/>
                    ${type === 'chat' ? model_with_messages_stx`<request xmlns="${model_with_messages_Strophe.NS.RECEIPTS}"></request>` : ''}
                    ${!is_encrypted && oob_url ? model_with_messages_stx`<x xmlns="${model_with_messages_Strophe.NS.OUTOFBAND}"><url>${oob_url}</url></x>` : ''}
                    ${!is_encrypted && is_spoiler ? model_with_messages_stx`<spoiler xmlns="${model_with_messages_Strophe.NS.SPOILER}">${spoiler_hint ?? ''}</spoiler>` : ''}
                    ${
                        !is_encrypted
                            ? references?.map(
                                  (ref) => model_with_messages_stx`<reference xmlns="${model_with_messages_Strophe.NS.REFERENCE}"
                                                begin="${ref.begin}"
                                                end="${ref.end}"
                                                type="${ref.type}"
                                                uri="${ref.uri}"></reference>`,
                              )
                            : ''
                    }
                    ${reply_to_id ? model_with_messages_stx`<reply xmlns="${model_with_messages_Strophe.NS.REPLY}" id="${reply_to_id}" to="${reply_to || ''}"></reply>` : ''}
                    ${edited ? model_with_messages_stx`<replace xmlns="${model_with_messages_Strophe.NS.MESSAGE_CORRECT}" id="${msgid}"></replace>` : ''}
                    ${origin_id ? model_with_messages_stx`<origin-id xmlns="${model_with_messages_Strophe.NS.SID}" id="${origin_id}"></origin-id>` : ''}
                </message>`;

            /**
             * *Hook* which allows plugins to update an outgoing message stanza
             * @event _converse#createMessageStanza
             * @param {ChatBox|MUC} chat - The chat from which this message stanza is being sent.
             * @param {import('./types').MessageAndStanza} data - BaseMessage data
             */
            const data = await shared_api.hook('createMessageStanza', this, { message, stanza });
            return data.stanza;
        }

        /**
         * Prunes the message history to ensure it does not exceed the maximum
         * number of messages specified in the settings.
         */
        pruneHistory() {
            const max_history = shared_api.settings.get('prune_messages_above');
            if (max_history && typeof max_history === 'number') {
                if (this.messages.length > max_history) {
                    const non_empty_messages = this.messages.filter((m) => !model_with_messages_u.isEmptyMessage(m));
                    if (non_empty_messages.length > max_history) {
                        while (non_empty_messages.length > max_history) {
                            non_empty_messages.shift().destroy();
                        }
                        /**
                         * Triggered once the message history has been pruned, i.e.
                         * once older messages have been removed to keep the
                         * number of messages below the value set in `prune_messages_above`.
                         */
                        this.trigger('historyPruned');
                    }
                }
            }
        }
        debouncedPruneHistory = lodash_es_debounce(() => this.pruneHistory(), 500, { maxWait: 2000 });

        isScrolledUp() {
            return this.ui.get('scrolled');
        }

        /**
         * Indicates whether the chat is hidden and therefore
         * whether a newly received message will be visible to the user or not.
         * @returns {boolean}
         */
        isHidden() {
            return this.get('hidden') || this.isScrolledUp() || document.hidden;
        }
    };
}

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/picker.js


/**
 * Model for storing data related to the Emoji picker widget
 */
class EmojiPicker extends skeletor.Model {
    defaults () {
        return {
            'current_category': 'smileys',
            'current_skintone': '',
            'scroll_position': 0
        }
    }
}

/* export default */ const picker = (EmojiPicker);

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/api.js



/**
 * @namespace api.emojis
 * @memberOf api
 */
const api_emojis = {
    /**
     * Initializes Emoji support by downloading the emojis JSON (and any applicable images).
     * @method api.emojis.initialize
     * @returns {Promise}
     */
    async initialize() {
        if (!api_public.emojis.initialized) {
            api_public.emojis.initialized = true;

            let json;
            try {
                const path = shared_api.settings.get('assets_path');
                const response = await fetch(`${path}/emoji.json`);
                if (!response.ok) throw new Error('Failed to fetch emoji.json');
                json = await response.json();
            } catch (e) {
                console.error('Failed to load emoji.json:', e);
                json = {};
            }

            /**
             * *Hook* which allows plugins to modify emojis definition.
             *
             * Note: This hook is only fired one time, when Converse is initialized.
             *
             * @event _converse#loadEmojis
             * @param context
             *      An empty context object.
             * @param json
             *      See {@link src/headless/emojis.json} for more information about the content of
             *      this parameter.
             * @example
             *  api.listen.on('loadEmojis', (context, json) => {
             *      json.custom??= {};
             *      json.custom[":my_emoji"] = {
             *          "sn":":my_emoji:","url":"https://example.com/my_emoji.png","c":"custom"
             *      };
             *      delete json.custom[":converse:"];
             *      return json;
             *  });
             */
            json = await shared_api.hook('loadEmojis', {}, json);
            api_public.emojis.json = json;

            api_public.emojis.by_sn = Object.keys(json).reduce((result, cat) => Object.assign(result, json[cat]), {});
            api_public.emojis.list = Object.values(api_public.emojis.by_sn);
            api_public.emojis.list.sort((a, b) => (a.sn < b.sn ? -1 : a.sn > b.sn ? 1 : 0));
            api_public.emojis.shortnames = api_public.emojis.list.map((m) => m.sn);
            // Sort by length descending for the regex so longer shortnames
            // match before shorter ones (e.g. :test1: before :test:).
            // Fixes https://github.com/conversejs/converse.js/issues/3502
            const getShortNames = () => api_public.emojis.shortnames.map((s) => s.replace(/[+]/g, '\\$&'))
                .sort((a, b) => b.length - a.length)
                .join('|');
            api_public.emojis.shortnames_regex = new RegExp(getShortNames(), 'gi');
            api_public.emojis.initialized_promise.resolve();
        }
        return api_public.emojis.initialized_promise;
    },
};

const emojis_api = { emojis: api_emojis };

/* export default */ const emoji_api = (emojis_api);

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/regexes.js
const ASCII_REGEX = '(\\*\\\\0\\/\\*|\\*\\\\O\\/\\*|\\-___\\-|\\:\'\\-\\)|\'\\:\\-\\)|\'\\:\\-D|\\>\\:\\-\\)|>\\:\\-\\)|\'\\:\\-\\(|\\>\\:\\-\\(|>\\:\\-\\(|\\:\'\\-\\(|O\\:\\-\\)|0\\:\\-3|0\\:\\-\\)|0;\\^\\)|O;\\-\\)|0;\\-\\)|O\\:\\-3|\\-__\\-|\\:\\-Þ|\\:\\-Þ|\\<\\/3|<\\/3|\\:\'\\)|\\:\\-D|\'\\:\\)|\'\\=\\)|\'\\:D|\'\\=D|\\>\\:\\)|>\\:\\)|\\>;\\)|>;\\)|\\>\\=\\)|>\\=\\)|;\\-\\)|\\*\\-\\)|;\\-\\]|;\\^\\)|\'\\:\\(|\'\\=\\(|\\:\\-\\*|\\:\\^\\*|\\>\\:P|>\\:P|X\\-P|\\>\\:\\[|>\\:\\[|\\:\\-\\(|\\:\\-\\[|\\>\\:\\(|>\\:\\(|\\:\'\\(|;\\-\\(|\\>\\.\\<|>\\.<|#\\-\\)|%\\-\\)|X\\-\\)|\\\\0\\/|\\\\O\\/|0\\:3|0\\:\\)|O\\:\\)|O\\=\\)|O\\:3|B\\-\\)|8\\-\\)|B\\-D|8\\-D|\\-_\\-|\\>\\:\\\\|>\\:\\\\|\\>\\:\\/|>\\:\\/|\\:\\-\\/|\\:\\-\\.|\\:\\-P|\\:Þ|\\:Þ|\\:\\-b|\\:\\-O|O_O|\\>\\:O|>\\:O|\\:\\-X|\\:\\-#|\\:\\-\\)|\\(y\\)|\\<3|<3|\\:D|\\=D|;\\)|\\*\\)|;\\]|;D|\\:\\*|\\=\\*|\\:\\(|\\:\\[|\\=\\(|\\:@|;\\(|D\\:|\\:\\$|\\=\\$|#\\)|%\\)|X\\)|B\\)|8\\)|\\:\\/|\\:\\\\|\\=\\/|\\=\\\\|\\:L|\\=L|\\:P|\\=P|\\:b|\\:O|\\:X|\\:#|\\=X|\\=#|\\:\\)|\\=\\]|\\=\\)|\\:\\])';
const ASCII_REPLACE_REGEX = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|((\\s|^)"+ASCII_REGEX+"(?=\\s|$|[!,.?]))", "gi");
const CODEPOINTS_REGEX = /(?:\ud83d\udc68\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc68\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc68\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffe]|\ud83e\uddd1\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\u200d\ud83e\udd1d\u200d\ud83e\uddd1|\ud83d\udc6b\ud83c[\udffb-\udfff]|\ud83d\udc6c\ud83c[\udffb-\udfff]|\ud83d\udc6d\ud83c[\udffb-\udfff]|\ud83d[\udc6b-\udc6d])|(?:\ud83d[\udc68\udc69]|\ud83e\uddd1)(?:\ud83c[\udffb-\udfff])?\u200d(?:\u2695\ufe0f|\u2696\ufe0f|\u2708\ufe0f|\ud83c[\udf3e\udf73\udf93\udfa4\udfa8\udfeb\udfed]|\ud83d[\udcbb\udcbc\udd27\udd2c\ude80\ude92]|\ud83e[\uddaf-\uddb3\uddbc\uddbd])|(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75]|\u26f9)((?:\ud83c[\udffb-\udfff]|\ufe0f)\u200d[\u2640\u2642]\ufe0f)|(?:\ud83c[\udfc3\udfc4\udfca]|\ud83d[\udc6e\udc71\udc73\udc77\udc81\udc82\udc86\udc87\ude45-\ude47\ude4b\ude4d\ude4e\udea3\udeb4-\udeb6]|\ud83e[\udd26\udd35\udd37-\udd39\udd3d\udd3e\uddb8\uddb9\uddcd-\uddcf\uddd6-\udddd])(?:\ud83c[\udffb-\udfff])?\u200d[\u2640\u2642]\ufe0f|(?:\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83c\udff3\ufe0f\u200d\u26a7\ufe0f|\ud83c\udff3\ufe0f\u200d\ud83c\udf08|\ud83c\udff4\u200d\u2620\ufe0f|\ud83d\udc15\u200d\ud83e\uddba|\ud83d\udc41\u200d\ud83d\udde8|\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc6f\u200d\u2640\ufe0f|\ud83d\udc6f\u200d\u2642\ufe0f|\ud83e\udd3c\u200d\u2640\ufe0f|\ud83e\udd3c\u200d\u2642\ufe0f|\ud83e\uddde\u200d\u2640\ufe0f|\ud83e\uddde\u200d\u2642\ufe0f|\ud83e\udddf\u200d\u2640\ufe0f|\ud83e\udddf\u200d\u2642\ufe0f)|[#*0-9]\ufe0f?\u20e3|(?:[©®\u2122\u265f]\ufe0f)|(?:\ud83c[\udc04\udd70\udd71\udd7e\udd7f\ude02\ude1a\ude2f\ude37\udf21\udf24-\udf2c\udf36\udf7d\udf96\udf97\udf99-\udf9b\udf9e\udf9f\udfcd\udfce\udfd4-\udfdf\udff3\udff5\udff7]|\ud83d[\udc3f\udc41\udcfd\udd49\udd4a\udd6f\udd70\udd73\udd76-\udd79\udd87\udd8a-\udd8d\udda5\udda8\uddb1\uddb2\uddbc\uddc2-\uddc4\uddd1-\uddd3\udddc-\uddde\udde1\udde3\udde8\uddef\uddf3\uddfa\udecb\udecd-\udecf\udee0-\udee5\udee9\udef0\udef3]|[\u203c\u2049\u2139\u2194-\u2199\u21a9\u21aa\u231a\u231b\u2328\u23cf\u23ed-\u23ef\u23f1\u23f2\u23f8-\u23fa\u24c2\u25aa\u25ab\u25b6\u25c0\u25fb-\u25fe\u2600-\u2604\u260e\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262a\u262e\u262f\u2638-\u263a\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267b\u267f\u2692-\u2697\u2699\u269b\u269c\u26a0\u26a1\u26a7\u26aa\u26ab\u26b0\u26b1\u26bd\u26be\u26c4\u26c5\u26c8\u26cf\u26d1\u26d3\u26d4\u26e9\u26ea\u26f0-\u26f5\u26f8\u26fa\u26fd\u2702\u2708\u2709\u270f\u2712\u2714\u2716\u271d\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u2764\u27a1\u2934\u2935\u2b05-\u2b07\u2b1b\u2b1c\u2b50\u2b55\u3030\u303d\u3297\u3299])(?:\ufe0f|(?!\ufe0e))|(?:(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75\udd90]|[\u261d\u26f7\u26f9\u270c\u270d])(?:\ufe0f|(?!\ufe0e))|(?:\ud83c[\udf85\udfc2-\udfc4\udfc7\udfca]|\ud83d[\udc42\udc43\udc46-\udc50\udc66-\udc69\udc6e\udc70-\udc78\udc7c\udc81-\udc83\udc85-\udc87\udcaa\udd7a\udd95\udd96\ude45-\ude47\ude4b-\ude4f\udea3\udeb4-\udeb6\udec0\udecc]|\ud83e[\udd0f\udd18-\udd1c\udd1e\udd1f\udd26\udd30-\udd39\udd3d\udd3e\uddb5\uddb6\uddb8\uddb9\uddbb\uddcd-\uddcf\uddd1-\udddd]|[\u270a\u270b]))(?:\ud83c[\udffb-\udfff])?|(?:\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc65\udb40\udc6e\udb40\udc67\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc73\udb40\udc63\udb40\udc74\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc77\udb40\udc6c\udb40\udc73\udb40\udc7f|\ud83c\udde6\ud83c[\udde8-\uddec\uddee\uddf1\uddf2\uddf4\uddf6-\uddfa\uddfc\uddfd\uddff]|\ud83c\udde7\ud83c[\udde6\udde7\udde9-\uddef\uddf1-\uddf4\uddf6-\uddf9\uddfb\uddfc\uddfe\uddff]|\ud83c\udde8\ud83c[\udde6\udde8\udde9\uddeb-\uddee\uddf0-\uddf5\uddf7\uddfa-\uddff]|\ud83c\udde9\ud83c[\uddea\uddec\uddef\uddf0\uddf2\uddf4\uddff]|\ud83c\uddea\ud83c[\udde6\udde8\uddea\uddec\udded\uddf7-\uddfa]|\ud83c\uddeb\ud83c[\uddee-\uddf0\uddf2\uddf4\uddf7]|\ud83c\uddec\ud83c[\udde6\udde7\udde9-\uddee\uddf1-\uddf3\uddf5-\uddfa\uddfc\uddfe]|\ud83c\udded\ud83c[\uddf0\uddf2\uddf3\uddf7\uddf9\uddfa]|\ud83c\uddee\ud83c[\udde8-\uddea\uddf1-\uddf4\uddf6-\uddf9]|\ud83c\uddef\ud83c[\uddea\uddf2\uddf4\uddf5]|\ud83c\uddf0\ud83c[\uddea\uddec-\uddee\uddf2\uddf3\uddf5\uddf7\uddfc\uddfe\uddff]|\ud83c\uddf1\ud83c[\udde6-\udde8\uddee\uddf0\uddf7-\uddfb\uddfe]|\ud83c\uddf2\ud83c[\udde6\udde8-\udded\uddf0-\uddff]|\ud83c\uddf3\ud83c[\udde6\udde8\uddea-\uddec\uddee\uddf1\uddf4\uddf5\uddf7\uddfa\uddff]|\ud83c\uddf4\ud83c\uddf2|\ud83c\uddf5\ud83c[\udde6\uddea-\udded\uddf0-\uddf3\uddf7-\uddf9\uddfc\uddfe]|\ud83c\uddf6\ud83c\udde6|\ud83c\uddf7\ud83c[\uddea\uddf4\uddf8\uddfa\uddfc]|\ud83c\uddf8\ud83c[\udde6-\uddea\uddec-\uddf4\uddf7-\uddf9\uddfb\uddfd-\uddff]|\ud83c\uddf9\ud83c[\udde6\udde8\udde9\uddeb-\udded\uddef-\uddf4\uddf7\uddf9\uddfb\uddfc\uddff]|\ud83c\uddfa\ud83c[\udde6\uddec\uddf2\uddf3\uddf8\uddfe\uddff]|\ud83c\uddfb\ud83c[\udde6\udde8\uddea\uddec\uddee\uddf3\uddfa]|\ud83c\uddfc\ud83c[\uddeb\uddf8]|\ud83c\uddfd\ud83c\uddf0|\ud83c\uddfe\ud83c[\uddea\uddf9]|\ud83c\uddff\ud83c[\udde6\uddf2\uddfc]|\ud83c[\udccf\udd8e\udd91-\udd9a\udde6-\uddff\ude01\ude32-\ude36\ude38-\ude3a\ude50\ude51\udf00-\udf20\udf2d-\udf35\udf37-\udf7c\udf7e-\udf84\udf86-\udf93\udfa0-\udfc1\udfc5\udfc6\udfc8\udfc9\udfcf-\udfd3\udfe0-\udff0\udff4\udff8-\udfff]|\ud83d[\udc00-\udc3e\udc40\udc44\udc45\udc51-\udc65\udc6a\udc6f\udc79-\udc7b\udc7d-\udc80\udc84\udc88-\udca9\udcab-\udcfc\udcff-\udd3d\udd4b-\udd4e\udd50-\udd67\udda4\uddfb-\ude44\ude48-\ude4a\ude80-\udea2\udea4-\udeb3\udeb7-\udebf\udec1-\udec5\uded0-\uded2\uded5\udeeb\udeec\udef4-\udefa\udfe0-\udfeb]|\ud83e[\udd0d\udd0e\udd10-\udd17\udd1d\udd20-\udd25\udd27-\udd2f\udd3a\udd3c\udd3f-\udd45\udd47-\udd71\udd73-\udd76\udd7a-\udda2\udda5-\uddaa\uddae-\uddb4\uddb7\uddba\uddbc-\uddca\uddd0\uddde-\uddff\ude70-\ude73\ude78-\ude7a\ude80-\ude82\ude90-\ude95]|[\u23e9-\u23ec\u23f0\u23f3\u267e\u26ce\u2705\u2728\u274c\u274e\u2753-\u2755\u2795-\u2797\u27b0\u27bf\ue50a])|\ufe0f/g;

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/constants.js

// Regex to detect shortname keys (e.g. ':thumbsup:')
const SHORTNAME_RE = /^:[a-zA-Z0-9_+*-]+:$/;
// How long to debounce/wait before publishing popular emojis
const PUBLISH_DEBOUNCE_MILLIS = 30_000;

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/utils.js






const { u: emoji_utils_u } = api_public.env;

// Closured cache
const emojis_by_attribute = {};

const ASCII_LIST = {
    '*\\0/*': '1f646',
    '*\\O/*': '1f646',
    '-___-': '1f611',
    ":'-)": '1f602',
    "':-)": '1f605',
    "':-D": '1f605',
    '>:-)': '1f606',
    "':-(": '1f613',
    '>:-(': '1f620',
    ":'-(": '1f622',
    'O:-)': '1f607',
    '0:-3': '1f607',
    '0:-)': '1f607',
    '0;^)': '1f607',
    'O;-)': '1f607',
    '0;-)': '1f607',
    'O:-3': '1f607',
    '-__-': '1f611',
    ':-Þ': '1f61b',
    '</3': '1f494',
    ":')": '1f602',
    ':-D': '1f603',
    "':)": '1f605',
    "'=)": '1f605',
    "':D": '1f605',
    "'=D": '1f605',
    '>:)': '1f606',
    '>;)': '1f606',
    '>=)': '1f606',
    ';-)': '1f609',
    '*-)': '1f609',
    ';-]': '1f609',
    ';^)': '1f609',
    "':(": '1f613',
    "'=(": '1f613',
    ':-*': '1f618',
    ':^*': '1f618',
    '>:P': '1f61c',
    'X-P': '1f61c',
    '>:[': '1f61e',
    ':-(': '1f61e',
    ':-[': '1f61e',
    '>:(': '1f620',
    ":'(": '1f622',
    ';-(': '1f622',
    '>.<': '1f623',
    '#-)': '1f635',
    '%-)': '1f635',
    'X-)': '1f635',
    '\\0/': '1f646',
    '\\O/': '1f646',
    '0:3': '1f607',
    '0:)': '1f607',
    'O:)': '1f607',
    'O=)': '1f607',
    'O:3': '1f607',
    'B-)': '1f60e',
    '8-)': '1f60e',
    'B-D': '1f60e',
    '8-D': '1f60e',
    '-_-': '1f611',
    '>:\\': '1f615',
    '>:/': '1f615',
    ':-/': '1f615',
    ':-.': '1f615',
    ':-P': '1f61b',
    ':Þ': '1f61b',
    ':-b': '1f61b',
    ':-O': '1f62e',
    'O_O': '1f62e',
    '>:O': '1f62e',
    ':-X': '1f636',
    ':-#': '1f636',
    ':-)': '1f642',
    '(y)': '1f44d',
    '<3': '2764',
    ':D': '1f603',
    '=D': '1f603',
    ';)': '1f609',
    '*)': '1f609',
    ';]': '1f609',
    ';D': '1f609',
    ':*': '1f618',
    '=*': '1f618',
    ':(': '1f61e',
    ':[': '1f61e',
    '=(': '1f61e',
    ':@': '1f620',
    ';(': '1f622',
    'D:': '1f628',
    ':$': '1f633',
    '=$': '1f633',
    '#)': '1f635',
    '%)': '1f635',
    'X)': '1f635',
    'B)': '1f60e',
    '8)': '1f60e',
    ':/': '1f615',
    ':\\': '1f615',
    '=/': '1f615',
    '=\\': '1f615',
    ':L': '1f615',
    '=L': '1f615',
    ':P': '1f61b',
    '=P': '1f61b',
    ':b': '1f61b',
    ':O': '1f62e',
    ':X': '1f636',
    ':#': '1f636',
    '=X': '1f636',
    '=#': '1f636',
    ':)': '1f642',
    '=]': '1f642',
    '=)': '1f642',
    ':]': '1f642',
};

function toCodePoint(unicode_surrogates) {
    const r = [];
    let p = 0;
    let i = 0;
    while (i < unicode_surrogates.length) {
        const c = unicode_surrogates.charCodeAt(i++);
        if (p) {
            r.push((0x10000 + ((p - 0xd800) << 10) + (c - 0xdc00)).toString(16));
            p = 0;
        } else if (0xd800 <= c && c <= 0xdbff) {
            p = c;
        } else {
            r.push(c.toString(16));
        }
    }
    return r.join('-');
}

/**
 * If it already looks like a shortname, use it directly.
 * Otherwise try to resolve it via codepoint.
 *
 * @param {string} emoji - A unicode emoji or shortname
 */
function emojiToShortname(emoji) {
    if (emoji.match(SHORTNAME_RE)) {
        return emoji;
    } else {
        const by_cp = getEmojisByAttribute('cp');
        const cp = emoji_utils_u.emojis.emojiToCodepointKey(emoji);
        return by_cp[cp]?.sn ?? emoji;
    }
}

/**
 * Convert a unicode emoji string to its codepoint key as used in the emoji data
 * (e.g. '❤️' → '2764-fe0f', '👍' → '1f44d').
 * @param {string} emoji
 * @returns {string}
 */
function emojiToCodepointKey(emoji) {
    return [...emoji].map((c) => c.codePointAt(0).toString(16)).join('-');
}

/**
 * @param {number|string} codepoint
 * @returns {string}
 */
function fromCodePoint(codepoint) {
    let code = typeof codepoint === 'string' ? parseInt(codepoint, 16) : codepoint;
    if (code < 0x10000) {
        return String.fromCharCode(code);
    }
    code -= 0x10000;
    return String.fromCharCode(0xd800 + (code >> 10), 0xdc00 + (code & 0x3ff));
}

/**
 * Converts unicode code points and code pairs to their respective characters
 * @param {string} unicode
 */
function utils_convert(unicode) {
    if (unicode.indexOf('-') > -1) {
        const parts = [];
        const s = unicode.split('-');

        for (let i = 0; i < s.length; i++) {
            const part = parseInt(s[i], 16);
            if (part >= 0x10000 && part <= 0x10ffff) {
                const hi = Math.floor((part - 0x10000) / 0x400) + 0xd800;
                const lo = ((part - 0x10000) % 0x400) + 0xdc00;
                parts.push(String.fromCharCode(hi) + String.fromCharCode(lo));
            } else {
                parts.push(String.fromCharCode(part));
            }
        }
        return parts.join('');
    }
    return fromCodePoint(unicode);
}

/**
 * @param {string} str
 */
function convertASCII2Emoji(str) {
    // Replace ASCII smileys
    return str.replace(ASCII_REPLACE_REGEX, (entire, _, m2, m3) => {
        if (typeof m3 === 'undefined' || m3 === '' || !(unescapeHTML(m3) in ASCII_LIST)) {
            // if the ascii doesn't exist just return the entire match
            return entire;
        }
        m3 = unescapeHTML(m3);
        const unicode = ASCII_LIST[m3].toUpperCase();
        return m2 + utils_convert(unicode);
    });
}

/**
 * @param {string} text
 * @returns {import('./types').EmojiReference[]}
 */
function getShortnameReferences(text) {
    if (!api_public.emojis.initialized) {
        throw new Error(
            'getShortnameReferences called before emojis are initialized. ' +
                'To avoid this problem, first await the converse.emojis.initialized_promise',
        );
    }
    const references = [...text.matchAll(api_public.emojis.shortnames_regex)].filter((ref) => ref[0].length > 0);
    return references.map((ref) => {
        const cp = api_public.emojis.by_sn[ref[0].toLowerCase()]?.cp;
        return {
            cp,
            begin: ref.index,
            end: ref.index + ref[0].length,
            shortname: ref[0],
            emoji: cp ? utils_convert(cp) : null,
        };
    });
}

/**
 * @param {string} str
 * @param {Function} callback
 */
function parseStringForEmojis(str, callback) {
    const UFE0Fg = /\uFE0F/g;
    const U200D = String.fromCharCode(0x200d);
    return String(str).replace(CODEPOINTS_REGEX, (emoji, _, offset) => {
        const icon_id = toCodePoint(emoji.indexOf(U200D) < 0 ? emoji.replace(UFE0Fg, '') : emoji);
        if (icon_id) callback(icon_id, emoji, offset);
        return emoji;
    });
}

/**
 * @param {string} text
 * @returns {import('./types').EmojiReference[]}
 */
function getCodePointReferences(text) {
    const references = [];
    parseStringForEmojis(text, (icon_id, emoji, offset) => {
        references.push({
            begin: offset,
            cp: icon_id,
            emoji: emoji,
            end: offset + emoji.length,
            shortname: getEmojisByAttribute('cp')[icon_id]?.sn || '',
        });
    });
    return references;
}

/**
 * @param {string} text
 * @returns {string[]}
 */
function addEmojisMarkup(text) {
    let list = [text];
    [...getShortnameReferences(text), ...getCodePointReferences(text)]
        .sort((a, b) => b.begin - a.begin)
        .forEach((ref) => {
            const text = list.shift();
            const emoji = ref.emoji || ref.shortname;
            list = [text.slice(0, ref.begin) + emoji + text.slice(ref.end), ...list];
        });
    return list;
}

/**
 * Replaces all shortnames in the passed in string with their
 * unicode (emoji) representation.
 * @param {String} str - String containing the shortname(s)
 * @returns {String}
 */
function shortnamesToUnicode(str) {
    return addEmojisMarkup(convertASCII2Emoji(str)).pop();
}

/**
 * Determines whether the passed in string is just a single emoji shortname;
 * @namespace u
 * @method u.isOnlyEmojis
 * @param {String} text - A string which might be just an emoji shortname
 * @returns {Boolean}
 */
function isOnlyEmojis(text) {
    const words = text.trim().split(/\s+/);
    if (words.length === 0 || words.length > 3) {
        return false;
    }
    const emojis = words.filter((text) => {
        const refs = getCodePointReferences(emoji_utils_u.emojis.shortnamesToUnicode(text));
        return refs.length === 1 && (text.toLowerCase() === refs[0]['shortname'] || text === refs[0]['emoji']);
    });
    return emojis.length === words.length;
}

/**
 * @param { 'category'|'cp'|'sn' } attr
 *  The attribute according to which the returned map should be keyed.
 * @returns { Object }
 *  Map of emojis with the passed in `attr` used as key and a list of emojis as values.
 */
function getEmojisByAttribute(attr) {
    if (emojis_by_attribute[attr]) {
        return emojis_by_attribute[attr];
    }
    if (attr === 'category') {
        return api_public.emojis.json;
    }
    const all_variants = api_public.emojis.list.map((e) => e[attr]).filter((c, i, arr) => arr.indexOf(c) == i);

    emojis_by_attribute[attr] = {};
    all_variants.forEach((v) => (emojis_by_attribute[attr][v] = api_public.emojis.list.find((i) => i[attr] === v)));
    return emojis_by_attribute[attr];
}

Object.assign(emoji_utils_u, {
    emojis: {
        convert: utils_convert,
        convertASCII2Emoji,
        emojiToCodepointKey,
        emojiToShortname,
        getCodePointReferences,
        getEmojisByAttribute,
        getShortnameReferences,
        isOnlyEmojis,
        shortnamesToUnicode,
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/handlers.js





const { Strophe: handlers_Strophe } = api_public.env;

function registerPEPPushHandler() {
    const bare_jid = shared_converse.session.get('bare_jid');
    shared_api.connection.get().addHandler(
        /** @param {Element} stanza */
        (stanza) => {
            const { popular_emojis } = shared_converse.state;
            popular_emojis?.applyPopularEmojisFromStanza(stanza);
            return true;
        },
        handlers_Strophe.NS.REACTIONS_POPULAR,
        'message',
        'headline',
        null,
        bare_jid,
    );
}

/**
 * Given a message, extract emojis from it and use them to update the list of
 * popular emojis.
 * @param {import('../../plugins/reactions/utils').BaseMessage} message
 */
async function updatePopularEmojis(message) {
    const body = message.get('body');
    if (!body) return;

    await shared_api.emojis.initialize();

    const { popular_emojis } = shared_converse.state;
    if (!popular_emojis) return;

    const shortname_refs = new Set(getShortnameReferences(body).map(({ shortname }) => shortname));
    const cp_refs = new Set(getCodePointReferences(body).map(({ emoji }) => emoji));
    const emojis = [...shortname_refs, ...cp_refs];

    if (emojis.length) {
        popular_emojis.recordUsage(emojis);
    }
}

/**
 * @param {import('../../shared/types').MessageAttributes} attrs
 * @param {String} text
 * @returns {Promise<import('../../shared/types').MessageAttributes & { is_only_emojis: boolean }>}
 */
async function handlers_parseMessage(attrs, text) {
    await shared_api.emojis.initialize();
    return {
        ...attrs,
        is_only_emojis: text ? isOnlyEmojis(text) : false,
    };
}

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/popular-emojis.js










const { Strophe: popular_emojis_Strophe, sizzle: popular_emojis_sizzle, stx: popular_emojis_stx, u: popular_emojis_u } = api_public.env;

class PopularEmojis extends skeletor.Model {
    defaults() {
        return {
            // Format: { 'unicode_emoji': 'ISO8601-timestamp', ... }
            timestamps: {},
        };
    }

    initialize() {
        super.initialize();
        const { session } = shared_converse;
        const storage_key = `converse.popular_emojis_frequencies.${session.get('bare_jid')}`;
        const fetched_flag_key = `${storage_key}-fetched`;

        this.fetched_flag = fetched_flag_key;
        this.debouncedPublish = promise_debounce(() => this.publish(), (/* inlined export .PUBLISH_DEBOUNCE_MILLIS */30000));
        popular_emojis_u.initStorage(this, storage_key);
        this.fetchPopularEmojis();
    }

    async fetchPopularEmojis() {
        if (shared_converse.state.session.get(this.fetched_flag)) {
            const deferred = getOpenPromise();
            this.fetch({
                success: () => deferred.resolve(),
                error: () => deferred.resolve(),
            });
            return deferred;
        } else {
            await this.fetchPopularEmojisFromServer();
        }
    }

    /**
     * Fetch the user's stored popular emojis from their PEP node and apply them.
     * If no item is stored, the default `popular_emojis` setting is left unchanged.
     */
    async fetchPopularEmojisFromServer() {
        const bare_jid = shared_converse.state.session.get('bare_jid');
        let iq;
        try {
            iq = await shared_api.sendIQ(
                popular_emojis_stx`<iq type="get" from="${bare_jid}" to="${bare_jid}" xmlns="jabber:client">
                    <pubsub xmlns="${popular_emojis_Strophe.NS.PUBSUB}">
                        <items node="${popular_emojis_Strophe.NS.REACTIONS_POPULAR}" max_items="1"/>
                    </pubsub>
                </iq>`,
            );
            this.applyPopularEmojisFromStanza(iq);
        } catch (e) {
            // item-not-found is expected when the user has never saved a custom list
            if (e?.querySelector?.('item-not-found')) return;
            src_log.warn('fetchPopularEmojisFromServer: could not fetch popular emojis from PubSub');
            src_log.error(e);
            return;
        }
    }

    /**
     * Parse a list of unicode emoji from a popular-reactions PubSub item and
     * merge the received timestamps with local ones, keeping the most recent
     * timestamp per emoji (last-write-wins per slot).
     *
     * @param {Element} stanza - An IQ result or headline message containing the pubsub item
     */
    applyPopularEmojisFromStanza(stanza) {
        const item = popular_emojis_sizzle(`items[node="${popular_emojis_Strophe.NS.REACTIONS_POPULAR}"] item`, stanza).pop();
        if (!item) return;

        const popular_el = item.getElementsByTagNameNS(popular_emojis_Strophe.NS.REACTIONS_POPULAR, 'popular-reactions')[0];
        if (!popular_el) return;

        const reactions = Array.from(popular_el.querySelectorAll('reaction'))
            .map((el) => ({ emoji: el.textContent?.trim(), stamp: el.getAttribute('stamp') }))
            .filter(({ emoji, stamp }) => emoji && stamp);

        if (!reactions.length) return;

        const local_timestamps = { ...(this.get('timestamps') || {}) };

        for (const { emoji, stamp } of reactions) {
            const remote_ms = new Date(stamp).getTime();
            if (isNaN(remote_ms)) continue;

            // Normalise to UTC ISO string so stored values are always comparable
            // as strings, regardless of the timezone used by the sending device.
            const normalised_stamp = new Date(remote_ms).toISOString();

            const local_stamp = local_timestamps[emoji];
            const local_ms = local_stamp ? new Date(local_stamp).getTime() : 0;

            // Keep whichever timestamp is more recent (last-write-wins per emoji)
            if (remote_ms > local_ms) {
                local_timestamps[emoji] = normalised_stamp;
            }
        }

        this.save({ timestamps: local_timestamps });
    }

    /**
     * Record that an emoji was just used, setting its timestamp to now.
     * Accepts unicode emoji or shortnames. Shortnames are converted to unicode
     * before storage to prevent duplicates. Unicode is stored as-is (preserving
     * variation selectors like U+FE0F).
     *
     * @param {string[]} emojis - An array of unicode emojis and/or shortnames
     */
    recordUsage(emojis) {
        const timestamps = { ...(this.get('timestamps') || {}) };
        const by_sn = api_public.emojis.by_sn || {};

        emojis.forEach((emoji) => {
            let unicode;
            if (SHORTNAME_RE.test(emoji)) {
                const emoji_data = by_sn[emoji];
                if (emoji_data?.cp) {
                    unicode = popular_emojis_u.emojis.convert(emoji_data.cp);
                } else {
                    return;
                }
            } else {
                unicode = emoji;
            }
            timestamps[unicode] = new Date().toISOString();
        });
        this.save({ timestamps });
        this.debouncedPublish();
    }

    /**
     * Get emojis sorted by most recently used first.
     * @param {number} [maxLength=5] - Maximum number of emojis to return
     * @returns {string[]} - Array of unicode emoji keys sorted by timestamp descending
     */
    getSortedEmojis(maxLength = 5) {
        const timestamps = this.get('timestamps') || {};
        return Object.entries(timestamps)
            .sort((a, b) => new Date(b[1]).getTime() - new Date(a[1]).getTime() || a[0].localeCompare(b[0]))
            .map((entry) => entry[0])
            .slice(0, maxLength);
    }

    /**
     * @returns {Promise<import('./types').EmojiDataByUnicode>} Map from unicode emoji to data
     */
    async getPopularEmojis() {
        await shared_api.emojis.initialize();

        const result = /** @type{import('./types').EmojiDataByUnicode} */ ({});

        const default_setting = shared_api.settings.get('popular_emojis') ?? [];
        const max = default_setting.length || 5;
        const sorted = this.getSortedEmojis(max);
        const by_cp = popular_emojis_u.emojis.getEmojisByAttribute('cp');

        for (const key of sorted) {
            const emoji_data = by_cp[emojiToCodepointKey(key)];
            if (!emoji_data) continue;

            result[key] = emoji_data;
        }

        if (Object.keys(result).length < max) {
            const by_sn = api_public.emojis.by_sn || {};
            for (const sn of default_setting) {
                if (Object.keys(result).length >= max) break;
                const data = by_sn[sn];
                const unicode = data?.cp ? popular_emojis_u.emojis.convert(data.cp) : null;
                if (unicode && !result[unicode]) {
                    const emoji_data = by_cp[emojiToCodepointKey(unicode)];
                    if (emoji_data) result[unicode] = emoji_data;
                }
            }
        }

        return result;
    }

    async publish() {
        await shared_api.emojis.initialize();

        const default_setting = shared_api.settings.get('popular_emojis') ?? [];
        const max = default_setting.length || 5;
        const sorted = this.getSortedEmojis(max);
        const timestamps = this.get('timestamps') || {};

        const item = popular_emojis_stx`
            <item id="current">
                <popular-reactions xmlns="${popular_emojis_Strophe.NS.REACTIONS_POPULAR}">
                    ${sorted.map((e) => popular_emojis_stx`<reaction stamp="${timestamps[e]}">${e}</reaction>`)}
                </popular-reactions>
            </item>`;

        try {
            await shared_api.pubsub.publish(null, popular_emojis_Strophe.NS.REACTIONS_POPULAR, item, {
                persist_items: 'true',
                access_model: 'whitelist',
            });
        } catch (e) {
            src_log.warn('PopularEmojis#publish: failed to update popular emojis');
            src_log.error(e);
        }
    }
}

/* export default */ const emoji_popular_emojis = (PopularEmojis);

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/plugin.js
/**
 * @module converse-emoji
 * @copyright 2022, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */









const { Strophe: plugin_Strophe } = api_public.env;

plugin_Strophe.addNamespace('REACTIONS_POPULAR', 'urn:xmpp:reactions:popular:0');

api_public.emojis = {
    initialized: false,
    initialized_promise: getOpenPromise(),
};

api_public.plugins.add('converse-emoji', {
    initialize() {
        /* The initialize function gets called as soon as the plugin is
         * loaded by converse.js's plugin machinery.
         */
        const { ___ } = shared_converse;

        shared_api.settings.extend({
            emoji_image_path: 'https://twemoji.maxcdn.com/v/12.1.6/',
            emoji_categories: {
                popular: ':star:',
                smileys: ':grinning:',
                people: ':thumbsup:',
                activity: ':soccer:',
                travel: ':motorcycle:',
                objects: ':bomb:',
                nature: ':rainbow:',
                food: ':hotdog:',
                symbols: ':musical_note:',
                flags: ':flag_ac:',
                custom: null,
            },
            popular_emojis: [':thumbsup:', ':heart:', ':laughing:', ':joy:', ':tada:'],
            // We use the triple-underscore method which doesn't actually
            // translate but does signify to gettext that these strings should
            // go into the POT file. The translation then happens in the
            // template. We do this so that users can pass in their own
            // strings via converse.initialize, which is before __ is
            // available.
            emoji_category_labels: {
                popular: ___('Frequently used'),
                smileys: ___('Smileys and emotions'),
                people: ___('People'),
                activity: ___('Activities'),
                travel: ___('Travel'),
                objects: ___('Objects'),
                nature: ___('Animals and nature'),
                food: ___('Food and drink'),
                symbols: ___('Symbols'),
                flags: ___('Flags'),
                custom: ___('Stickers'),
            },
        });

        const exports = { EmojiPicker: picker };
        Object.assign(shared_converse, exports); // XXX: DEPRECATED
        Object.assign(shared_converse.exports, exports);
        Object.assign(shared_api, emoji_api);

        shared_api.listen.on('connected', () => {
            registerPEPPushHandler();
            if (shared_converse.state.popular_emojis) return;

            const popular_emojis = new emoji_popular_emojis();
            Object.assign(shared_converse.state, { popular_emojis });
        });

        shared_api.listen.on('clearSession', () => {
            shared_converse.state.popular_emojis?.debouncedPublish.flush();
            delete shared_converse.state.popular_emojis;
        });

        shared_api.listen.on('getOutgoingMessageAttributes', async (_chat, attrs) => handlers_parseMessage(attrs, attrs.original_text));
        shared_api.listen.on('parseMUCMessage', (_chat, attrs) => handlers_parseMessage(attrs, attrs.body));
        shared_api.listen.on('parseMessage', (_chat, attrs) => handlers_parseMessage(attrs, attrs.body));
        shared_api.listen.on('sendMessage', async ({ message }) => updatePopularEmojis(message));
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/index.js





;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/model.js



const { Strophe: model_Strophe } = api_public.env;

class Bookmark extends skeletor.Model {
    get idAttribute() {
        return 'jid';
    }

    getDisplayName() {
        return this.get('name') && model_Strophe.xmlunescape(this.get('name')) || this.get('jid');
    }
}

/* export default */ const bookmarks_model = (Bookmark);

;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/parsers.js




const { Strophe: bookmarks_parsers_Strophe, sizzle: bookmarks_parsers_sizzle } = api_public.env;

/**
 * @param {Element} stanza
 * @returns {Promise<Array<import('./types.js').BookmarkAttrs>>}
 */
async function parseStanzaForBookmarks(stanza) {
    let ns;
    let sel;
    const bare_jid = shared_converse.session.get('bare_jid');
    if (await shared_api.disco.supports(`${bookmarks_parsers_Strophe.NS.BOOKMARKS2}#compat`, bare_jid)) {
        ns = bookmarks_parsers_Strophe.NS.BOOKMARKS2;
        sel = `items[node="${ns}"] item conference`;
    } else {
        ns = bookmarks_parsers_Strophe.NS.BOOKMARKS;
        sel = `items[node="${ns}"] item storage[xmlns="${ns}"] conference`;
    }
    return bookmarks_parsers_sizzle(sel, stanza).map(
        /** @param {Element} el */ (el) => {
            const jid = ns === bookmarks_parsers_Strophe.NS.BOOKMARKS2 ? el.parentElement.getAttribute('id') : el.getAttribute('jid');
            return {
                jid,
                name: el.getAttribute('name') || jid,
                autojoin: ['1', 'true'].includes(el.getAttribute('autojoin')),
                nick: el.querySelector('nick')?.textContent ?? '',
                password: el.querySelector('password')?.textContent ?? '',
                extensions: Array.from(el.querySelector('extensions')?.children ?? []).map(c => c.outerHTML),
            };
        }
    );
}

;// CONCATENATED MODULE: ./src/headless/plugins/muc/message.js






class MUCMessage extends shared_message {
    /**
     * @typedef {import('./occupant').default} MUCOccupant
     */
    initialize () {
        super.initialize();

        // If `type` changes from `error` to `groupchat`, we want to set the occupant. See #2733
        this.on('change:type', () => this.setOccupant());
        this.setOccupant();

        /**
         * Triggered once a { @link MUCMessage} has been created and initialized.
         * @event _converse#chatRoomMessageInitialized
         * @type {MUCMessage}
         * @example _converse.api.listen.on('chatRoomMessageInitialized', model => { ... });
         */
        shared_api.trigger('chatRoomMessageInitialized', this);
    }

    get occupants () {
        return (this.get('type') === 'chat') ? this.chatbox.collection : this.chatbox.occupants;
    }

    getDisplayName () {
        return this.occupant?.getDisplayName() || this.get('nick');
    }

    /**
     * Determines whether this message may be moderated,
     * based on configuration settings and server support.
     * @method _converse.ChatRoomMessages#mayBeModerated
     * @returns {Promise<boolean>}
     */
    async mayBeModerated () {
        if (typeof this.get('from_muc')  === 'undefined') {
            // If from_muc is not defined, then this message hasn't been
            // reflected yet, which means we won't have a XEP-0359 stanza id.
            return;
        }
        return (
            ['all', 'moderator'].includes(shared_api.settings.get('allow_message_retraction')) &&
            this.get(`stanza_id ${this.get('from_muc')}`) && await this.chatbox.canModerateMessages()
        );
    }

    checkValidity () {
        const result = super.checkValidity();
        !result && this.chatbox.debouncedRejoin();
        return result;
    }

    onOccupantRemoved () {
        this.stopListening(this.occupant);
        delete this.occupant;
        this.listenTo(this.occupants, 'add', this.onOccupantAdded);
    }

    /**
     * @param {MUCOccupant} [occupant]
     */
    onOccupantAdded (occupant) {
        if (this.get('occupant_id')) {
            if (occupant.get('occupant_id') !== this.get('occupant_id')) {
                return;
            }
        } else if (occupant.get('nick') !== Strophe.getResourceFromJid(this.get('from'))) {
            return;
        }
        this.setOccupant(occupant)
    }

    getOccupant() {
        return this.occupant || this.setOccupant();
    }

    /**
     * @param {MUCOccupant} [occupant]
     * @return {MUCOccupant}
     */
    setOccupant (occupant) {
        if (!['groupchat', 'chat'].includes(this.get('type')) || this.isEphemeral()) {
            return;
        }

        if (occupant) {
            this.occupant = occupant;

        } else if (this.get('type') === 'chat' && this.get('sender') === 'them') {
            this.occupant = this.chatbox;

        } else {
            if (this.occupant) return;

            const nick = Strophe.getResourceFromJid(this.get('from'));
            const occupant_id = this.get('occupant_id');
            this.occupant = nick || occupant_id ? this.occupants.findOccupant({ nick, occupant_id }) : null;

            if (!this.occupant) {
                const jid = this.get('from_real_jid');
                if (!nick && !occupant_id && !jid) {
                    // Tombstones of retracted messages might have no occupant info
                    return;
                }

                this.occupant = this.occupants.create({ nick, occupant_id, jid });

                if (shared_api.settings.get('muc_send_probes')) {
                    const jid = `${this.chatbox.get('jid')}/${nick}`;
                    shared_api.user.presence.send({ to: jid, type: 'probe' });
                }
            }
        }

        if (this.get('from_real_jid') !== this.occupant.get('jid')) {
            this.save('from_real_jid', this.occupant.get('jid'));
        }

        this.trigger('occupant:add');
        this.listenTo(this.occupant, 'change', (changed) => this.trigger('occupant:change', changed));
        this.listenTo(this.occupant, 'vcard:add', (changed) => this.trigger('occupant:change', changed));
        this.listenTo(this.occupant, 'vcard:change', (changed) => this.trigger('occupant:change', changed));
        this.listenTo(this.occupant, 'destroy', this.onOccupantRemoved);
        this.stopListening(this.occupants, 'add', this.onOccupantAdded);

        return this.occupant;
    }
}

/* export default */ const muc_message = (MUCMessage);

;// CONCATENATED MODULE: ./src/headless/plugins/muc/messages.js



/**
 * Collection which stores MUC messages
 * @extends {Collection<MUCMessage>}
 */
class MUCMessages extends skeletor.Collection {

    constructor (attrs, options={}) {
        super(attrs, Object.assign({ comparator: 'time' }, options));
        this.model = muc_message;
        this.fetched = null;
    }
}

/* export default */ const muc_messages = (MUCMessages);

;// CONCATENATED MODULE: ./src/headless/utils/parse-helpers.js
/**
 * @copyright 2022, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description Pure functions to help functionally parse messages.
 * @todo Other parsing helpers can be made more abstract and placed here.
 */
const helpers = {};

const escapeRegexChars = (string, char) => string.replace(RegExp('\\' + char, 'ig'), '\\' + char);

helpers.escapeCharacters = characters => string =>
    characters.split('').reduce(escapeRegexChars, string);

helpers.escapeRegexString = helpers.escapeCharacters('[\\^$.?*+(){}|');

// `for` is ~25% faster than using `Array.find()`
helpers.findFirstMatchInArray = array => text => {
    for (let i = 0; i < array.length; i++) {
        if (text.localeCompare(array[i], undefined, {sensitivity: 'base'}) === 0) {
            return array[i];
        }
    }
    return null;
};

const reduceReferences = ([text, refs], ref, index) => {
    let updated_text = text;
    let { begin, end } = ref;
    const { value } = ref;
    begin = begin - index;
    end = end - index - 1; // -1 to compensate for the removed @
    updated_text = `${updated_text.slice(0, begin)}${value}${updated_text.slice(end + 1)}`;
    return [updated_text, [...refs, { ...ref, begin, end }]]
}

helpers.reduceTextFromReferences = (text, refs) => refs.reduce(reduceReferences, [text, []]);

/* export default */ const parse_helpers = (helpers);

;// CONCATENATED MODULE: ./src/headless/plugins/muc/constants.js
const ACTION_INFO_CODES = ['301', '333', '307', '321', '322'];
const NEW_NICK_CODES = ['210', '303'];
const ADMIN_COMMANDS = ['admin', 'ban', 'deop', 'destroy', 'member', 'op', 'revoke'];
const AFFILIATIONS = ['owner', 'admin', 'member', 'outcast', 'none'];
const DISCONNECT_CODES = ['301', '333', '307', '321', '322', '332'];
const MODERATOR_COMMANDS = ['kick', 'mute', 'voice', 'modtools'];
const OWNER_COMMANDS = ['owner'];
const ROLES = ['moderator', 'participant', 'visitor'];
const VISITOR_COMMANDS = ['nick'];

// Which types of stanzas a status code might appear in.
const STATUS_CODE_STANZAS = {
    '100': ['message', 'presence'],
    '101': ['message'],
    '102': ['message'],
    '103': ['message'],
    '104': ['message'],
    '110': ['presence'],
    '170': ['message', 'presence'],
    '171': ['message'],
    '172': ['message'],
    '173': ['message'],
    '174': ['message'],
    '201': ['presence'],
    '210': ['presence'],
    '301': ['presence'],
    '303': ['presence'],
    '307': ['presence'],
    '321': ['presence'],
    '322': ['presence'],
    '332': ['presence'],
    '333': ['presence'],
};

const MUC_ROLE_WEIGHTS = {
    'moderator': 1,
    'participant': 2,
    'visitor': 3,
    'none': 2,
};

const AFFILIATION_CHANGES = {
    OWNER: 'owner',
    ADMIN: 'admin',
    MEMBER: 'member',
    EXADMIN: 'exadmin',
    EXOWNER: 'exowner',
    EXOUTCAST: 'exoutcast',
    EXMEMBER: 'exmember',
};

const AFFILIATION_CHANGES_LIST = Object.values(AFFILIATION_CHANGES);
const MUC_TRAFFIC_STATES = { ENTERED: 'entered', EXITED: 'exited' };
const MUC_TRAFFIC_STATES_LIST = Object.values(MUC_TRAFFIC_STATES);
const MUC_ROLE_CHANGES = { OP: 'op', DEOP: 'deop', VOICE: 'voice', MUTE: 'mute' };
const MUC_ROLE_CHANGES_LIST = Object.values(MUC_ROLE_CHANGES);

const INFO_CODES = {
    'visibility_changes': ['100', '102', '103', '172', '173', '174'],
    'self': ['110'],
    'non_privacy_changes': ['104', '201'],
    'muc_logging_changes': ['170', '171'],
    'nickname_changes': ['210', '303'],
    'disconnected': ['301', '307', '321', '322', '332', '333'],
    'affiliation_changes': [...AFFILIATION_CHANGES_LIST],
    'join_leave_events': [...MUC_TRAFFIC_STATES_LIST],
    'role_changes': [...MUC_ROLE_CHANGES_LIST],
};

const ROOMSTATUS = {
    CONNECTED: 0,
    CONNECTING: 1,
    NICKNAME_REQUIRED: 2,
    PASSWORD_REQUIRED: 3,
    DISCONNECTED: 4,
    ENTERED: 5,
    DESTROYED: 6,
    BANNED: 7,
    CLOSING: 8,
};

const ROOM_FEATURES = [
    'passwordprotected',
    'unsecured',
    'hidden',
    'publicroom',
    'membersonly',
    'open',
    'persistent',
    'temporary',
    'nonanonymous',
    'semianonymous',
    'moderated',
    'unmoderated',
    'mam_enabled',
    'vcard-temp',
];

const MUC_NICK_CHANGED_CODE = '303';

// No longer used in code, but useful as reference.
//
// const ROOM_FEATURES_MAP = {
//     'passwordprotected': 'unsecured',
//     'unsecured': 'passwordprotected',
//     'hidden': 'publicroom',
//     'publicroom': 'hidden',
//     'membersonly': 'open',
//     'open': 'membersonly',
//     'persistent': 'temporary',
//     'temporary': 'persistent',
//     'nonanonymous': 'semianonymous',
//     'semianonymous': 'nonanonymous',
//     'moderated': 'unmoderated',
//     'unmoderated': 'moderated'
// };

;// CONCATENATED MODULE: ./src/headless/plugins/muc/parsers.js
/**
 * @module:plugin-muc-parsers
 * @typedef {import('../muc/muc.js').default} MUC
 * @typedef {import('./types').MUCMessageAttributes} MUCMessageAttributes
 */







const { Strophe: muc_parsers_Strophe, dayjs: muc_parsers_dayjs, sizzle: muc_parsers_sizzle, u: muc_parsers_u } = api_public.env;
const { NS: muc_parsers_NS } = muc_parsers_Strophe;

/**
 * Parses a message stanza for XEP-0316 MEP notification data
 * @param {Element} stanza - The message stanza
 * @returns {Array} Returns an array of objects representing <activity> elements.
 */
function getMEPActivities(stanza) {
    const items_el = muc_parsers_sizzle(`items[node="${muc_parsers_Strophe.NS.CONFINFO}"]`, stanza).pop();
    if (!items_el) {
        return null;
    }
    const from = stanza.getAttribute('from');
    const msgid = stanza.getAttribute('id');
    const selector =
        `item ` + `conference-info[xmlns="${muc_parsers_Strophe.NS.CONFINFO}"] ` + `activity[xmlns="${muc_parsers_Strophe.NS.ACTIVITY}"]`;
    return muc_parsers_sizzle(selector, items_el).map(
        /** @param {Element} el */ (el) => {
            const message = el.querySelector('text')?.textContent;
            if (message) {
                const references = getReferences(stanza);
                const reason = el.querySelector('reason')?.textContent;
                return { from, msgid, message, reason, references, 'type': 'mep' };
            }
            return {};
        },
    );
}

/**
 * Given a MUC stanza, check whether it has extended message information that
 * includes the sender's real JID, as described here:
 * https://xmpp.org/extensions/xep-0313.html#business-storeret-muc-archives
 *
 * If so, parse and return that data and return the user's JID
 *
 * Note, this function doesn't check whether this is actually a MAM archived stanza.
 *
 * @param {Element} stanza - The message stanza
 * @returns {Object}
 */
function getJIDFromMUCUserData(stanza) {
    const item = muc_parsers_sizzle(`message > x[xmlns="${muc_parsers_Strophe.NS.MUC_USER}"] item`, stanza).pop();
    return item?.getAttribute('jid');
}

/**
 * @param {Element} stanza - The message stanza
 *  message stanza, if it was contained, otherwise it's the message stanza itself.
 * @returns {Object}
 */
function getDeprecatedModerationAttributes(stanza) {
    const fastening = muc_parsers_sizzle(`apply-to[xmlns="${muc_parsers_Strophe.NS.FASTEN}"]`, stanza).pop();
    if (fastening) {
        const applies_to_id = fastening.getAttribute('id');
        const moderated = muc_parsers_sizzle(`moderated[xmlns="${muc_parsers_Strophe.NS.MODERATE0}"]`, fastening).pop();
        if (moderated) {
            const retracted = muc_parsers_sizzle(`retract[xmlns="${muc_parsers_Strophe.NS.RETRACT0}"]`, moderated).pop();
            if (retracted) {
                return {
                    editable: false,
                    moderated: 'retracted',
                    moderated_by: moderated.getAttribute('by'),
                    moderated_id: applies_to_id,
                    moderation_reason: moderated.querySelector('reason')?.textContent,
                };
            }
        }
    } else {
        const tombstone = muc_parsers_sizzle(`> moderated[xmlns="${muc_parsers_Strophe.NS.MODERATE0}"]`, stanza).pop();
        if (tombstone) {
            const retracted = muc_parsers_sizzle(`retracted[xmlns="${muc_parsers_Strophe.NS.RETRACT0}"]`, tombstone).pop();
            if (retracted) {
                return {
                    editable: false,
                    is_tombstone: true,
                    moderated_by: tombstone.getAttribute('by'),
                    retracted: tombstone.getAttribute('stamp'),
                    moderation_reason: tombstone.querySelector('reason')?.textContent,
                };
            }
        }
    }
    return {};
}

/**
 * @param {Element} stanza - The message stanza
 *  message stanza, if it was contained, otherwise it's the message stanza itself.
 * @returns {Object}
 */
function getModerationAttributes(stanza) {
    const retract = muc_parsers_sizzle(`> retract[xmlns="${muc_parsers_Strophe.NS.RETRACT}"]`, stanza).pop();
    if (retract) {
        const moderated = muc_parsers_sizzle(`moderated[xmlns="${muc_parsers_Strophe.NS.MODERATE}"]`, retract).pop();
        if (moderated) {
            return {
                editable: false,
                moderated: 'retracted',
                moderated_by: moderated.getAttribute('by'),
                moderated_by_id: moderated.querySelector('occupant-id')?.getAttribute('id'),
                moderated_id: retract.getAttribute('id'),
                moderation_reason: retract.querySelector('reason')?.textContent,
            };
        }
    } else {
        const tombstone = muc_parsers_sizzle(`retracted[xmlns="${muc_parsers_Strophe.NS.RETRACT}"]`, stanza).pop();
        if (tombstone) {
            return {
                editable: false,
                is_tombstone: true,
                moderated_by: tombstone.getAttribute('by'),
                moderated_by_id: tombstone.querySelector('occupant-id')?.getAttribute('id'),
                retracted: tombstone.getAttribute('stamp'),
                moderation_reason: tombstone.querySelector('reason')?.textContent,
            };
        }
    }
    return getDeprecatedModerationAttributes(stanza);
}

/**
 * @param {Element} stanza
 * @param {'presence'|'message'} type
 * @returns {{codes: Array<import('./types').MUCStatusCode>, is_self: boolean}}
 */
function getStatusCodes(stanza, type) {
    /**
     * @typedef {import('./types').MUCStatusCode} MUCStatusCode
     */
    const codes = muc_parsers_sizzle(`${type} > x[xmlns="${muc_parsers_Strophe.NS.MUC_USER}"] status`, stanza)
        .map(/** @param {Element} s */ (s) => s.getAttribute('code'))
        .filter(
            /** @param {MUCStatusCode} c */
            (c) => STATUS_CODE_STANZAS[c]?.includes(type),
        );

    if (type === 'presence' && codes.includes('333') && codes.includes('307')) {
        // See: https://github.com/xsf/xeps/pull/969/files#diff-ac5113766e59219806793c1f7d967f1bR4966
        codes.splice(codes.indexOf('307'), 1);
    }

    return {
        codes,
        is_self: codes.includes('110'),
    };
}

/**
 * @param {Element} stanza
 * @param {MUC} chatbox
 */
function getOccupantID(stanza, chatbox) {
    if (chatbox.features.get(muc_parsers_Strophe.NS.OCCUPANTID)) {
        return muc_parsers_sizzle(`occupant-id[xmlns="${muc_parsers_Strophe.NS.OCCUPANTID}"]`, stanza).pop()?.getAttribute('id');
    }
}

/**
 * Determines whether the sender of this MUC message is the current user or
 * someone else.
 * @param {MUCMessageAttributes} attrs
 * @param {MUC} chatbox
 * @returns {'me'|'them'}
 */
function getSender(attrs, chatbox) {
    let is_me;
    const own_occupant_id = chatbox.get('occupant_id');

    if (own_occupant_id) {
        is_me = attrs.occupant_id === own_occupant_id;
    } else if (attrs.from_real_jid) {
        const bare_jid = shared_converse.session.get('bare_jid');
        is_me = muc_parsers_Strophe.getBareJidFromJid(attrs.from_real_jid) === bare_jid;
    } else {
        is_me = attrs.nick === chatbox.get('nick');
    }
    return is_me ? 'me' : 'them';
}

/**
 * Parses a passed in message stanza and returns an object of attributes.
 * @param {Element} original_stanza - The message stanza
 * @param {MUC} chatbox
 * @returns {Promise<MUCMessageAttributes|StanzaParseError>}
 */
async function parseMUCMessage(original_stanza, chatbox) {
    throwErrorIfInvalidForward(original_stanza);

    const forwarded_stanza = muc_parsers_sizzle(
        `result[xmlns="${muc_parsers_NS.MAM}"] > forwarded[xmlns="${muc_parsers_NS.FORWARD}"] > message`,
        original_stanza,
    ).pop();

    const stanza = forwarded_stanza || original_stanza;
    if (muc_parsers_sizzle(`message > forwarded[xmlns="${muc_parsers_Strophe.NS.FORWARD}"]`, stanza).length) {
        return new StanzaParseError(
            stanza,
            `Invalid Stanza: Forged MAM groupchat message from ${stanza.getAttribute('from')}`,
        );
    }

    let delay;
    let body;

    if (forwarded_stanza) {
        if (muc_parsers_sizzle(`message > forwarded[xmlns="${muc_parsers_Strophe.NS.FORWARD}"]`, forwarded_stanza).length) {
            return new StanzaParseError(
                original_stanza,
                `Invalid Stanza: Forged MAM groupchat message from ${original_stanza.getAttribute('from')}`,
            );
        }
        delay = muc_parsers_sizzle(`delay[xmlns="${muc_parsers_Strophe.NS.DELAY}"]`, forwarded_stanza.parentElement).pop();
        body = forwarded_stanza.querySelector(':scope > body')?.textContent?.trim();
    } else {
        delay = muc_parsers_sizzle(`message > delay[xmlns="${muc_parsers_Strophe.NS.DELAY}"]`, original_stanza).pop();
        body = original_stanza.querySelector(':scope > body')?.textContent?.trim();
    }

    const from = stanza.getAttribute('from');
    const marker = getChatMarker(stanza);

    let attrs = /** @type {MUCMessageAttributes} */ (
        Object.assign(
            {
                from,
                body,
                'activities': getMEPActivities(stanza),
                'chat_state': getChatState(stanza),
                'from_muc': muc_parsers_Strophe.getBareJidFromJid(from),
                'is_archived': isArchived(original_stanza),
                'is_carbon': isCarbon(original_stanza),
                'is_delayed': !!delay,
                'is_forwarded': !!muc_parsers_sizzle(`message > forwarded[xmlns="${muc_parsers_Strophe.NS.FORWARD}"]`, stanza).length,
                'is_headline': isHeadline(stanza),
                'is_markable': !!muc_parsers_sizzle(`message > markable[xmlns="${muc_parsers_Strophe.NS.MARKERS}"]`, stanza).length,
                'is_marker': !!marker,
                'is_unstyled': !!muc_parsers_sizzle(`message > unstyled[xmlns="${muc_parsers_Strophe.NS.STYLING}"]`, stanza).length,
                'marker_id': marker && marker.getAttribute('id'),
                'nick': muc_parsers_Strophe.unescapeNode(muc_parsers_Strophe.getResourceFromJid(from)),
                'occupant_id': getOccupantID(stanza, chatbox),
                'receipt_id': getReceiptId(stanza),
                'received': new Date().toISOString(),
                'references': getReferences(stanza),
                'subject': stanza.querySelector(':scope > subject')?.textContent,
                'thread': stanza.querySelector(':scope > thread')?.textContent,
                'time': delay ? muc_parsers_dayjs(delay.getAttribute('stamp')).toISOString() : new Date().toISOString(),
                'to': stanza.getAttribute('to'),
                'type': stanza.getAttribute('type'),
            },
            getErrorAttributes(stanza),
            getOutOfBandAttributes(stanza),
            getSpoilerAttributes(stanza),
            getCorrectionAttributes(stanza, original_stanza),
            getStanzaIDs(stanza, original_stanza),
            getOpenGraphMetadata(stanza),
            getRetractionAttributes(stanza, original_stanza),
            getModerationAttributes(stanza),
            getEncryptionAttributes(stanza),
            getReplyAttributes(stanza),
            getStatusCodes(stanza, 'message'),
        )
    );

    attrs.from_real_jid =
        (attrs.is_archived && getJIDFromMUCUserData(stanza)) || chatbox.occupants.findOccupant(attrs)?.get('jid');

    attrs = Object.assign(
        {
            'is_valid_receipt_request': isValidReceiptRequest(stanza, attrs),
            'message': attrs.body || attrs.error, // TODO: Should only be used for error and info messages
            'sender': getSender(attrs, chatbox),
        },
        attrs,
    );

    if (attrs.is_archived && original_stanza.getAttribute('from') !== attrs.from_muc) {
        return new StanzaParseError(
            original_stanza,
            `Invalid Stanza: Forged MAM message from ${original_stanza.getAttribute('from')}`,
        );
    } else if (attrs.is_archived && original_stanza.getAttribute('from') !== chatbox.get('jid')) {
        return new StanzaParseError(
            original_stanza,
            `Invalid Stanza: Forged MAM groupchat message from ${stanza.getAttribute('from')}`,
        );
    } else if (attrs.is_carbon) {
        return new StanzaParseError(
            original_stanza,
            'Invalid Stanza: MUC messages SHOULD NOT be XEP-0280 carbon copied',
        );
    }

    // We prefer to use one of the XEP-0359 unique and stable stanza IDs as the Model id, to avoid duplicates.
    attrs['id'] = attrs['origin_id'] || attrs[`stanza_id ${attrs.from_muc || attrs.from}`] || muc_parsers_u.getUniqueId();

    /**
     * *Hook* which allows plugins to add additional parsing.
     * Listeners receive `(stanza, attrs, chatbox)` — the chatbox is passed as
     * an extra argument so that plugins can inspect room features (e.g.
     * anonymity mode) without having to look it up themselves.
     * @event _converse#parseMUCMessage
     */
    attrs = await shared_api.hook('parseMUCMessage', original_stanza, attrs, chatbox);

    // We call this after the hook, to allow plugins to decrypt encrypted
    // messages, since we need to parse the message text to determine whether
    // there are media urls.
    const metadata = await muc_parsers_u.getMediaURLsMetadata(attrs.is_encrypted ? attrs.plaintext : attrs.body);
    return Object.assign(attrs, metadata);
}

/**
 * Given an IQ stanza with a member list, create an array of objects containing
 * known member data (e.g. jid, nick, role, affiliation).
 *
 * @param {Element} iq
 * @returns {import('./types').MemberListItem[]}
 */
function parseMemberListIQ(iq) {
    return muc_parsers_sizzle(`query[xmlns="${muc_parsers_Strophe.NS.MUC_ADMIN}"] item`, iq).map(
        /** @param {Element} item */ (item) => {
            const data = {
                'affiliation': item.getAttribute('affiliation'),
            };
            const jid = item.getAttribute('jid');
            if (muc_parsers_u.isValidJID(jid)) {
                data['jid'] = jid;
            } else {
                // XXX: Prosody sends nick for the jid attribute value
                // Perhaps for anonymous room?
                data['nick'] = jid;
            }
            const nick = item.getAttribute('nick');
            if (nick) {
                data['nick'] = nick;
            }
            const role = item.getAttribute('role');
            if (role) {
                data['role'] = nick;
            }
            return data;
        },
    );
}

/**
 * @param {Element} stanza - The presence stanza
 * @param {string} nick
 * @returns {import('./types').MUCPresenceItemAttributes}
 */
function parsePresenceUserItem(stanza, nick) {
    /**
     * @typedef {import('./types').MUCAffiliation} MUCAffiliation
     * @typedef {import('./types').MUCRole} MUCRole
     */
    const item = muc_parsers_sizzle(`presence > x[xmlns="${muc_parsers_Strophe.NS.MUC_USER}"] item`, stanza).pop();
    if (item) {
        const actor = item.querySelector('actor');
        return {
            affiliation: /** @type {MUCAffiliation} */ (item.getAttribute('affiliation')),
            role: /** @type {MUCRole} */ (item.getAttribute('role')),
            jid: item.getAttribute('jid'),
            nick: item.getAttribute('nick') || nick,
            ...(actor
                ? {
                      actor: {
                          nick: actor?.getAttribute('nick') ?? null,
                          jid: actor?.getAttribute('jid') ?? null,
                      },
                  }
                : {}),
            reason: item.querySelector('reason')?.textContent ?? null,
        };
    }
}

/**
 * Parses a passed in MUC presence stanza and returns an object of attributes.
 * @param {Element} stanza - The presence stanza
 * @param {MUC} chatbox
 * @returns {Promise<import('./types').MUCPresenceAttributes>}
 */
async function parseMUCPresence(stanza, chatbox) {
    await chatbox.initialized;

    /**
     * @typedef {import('./types').MUCPresenceAttributes} MUCPresenceAttributes
     */
    const from = stanza.getAttribute('from');
    const type = stanza.getAttribute('type');
    const nick = muc_parsers_Strophe.getResourceFromJid(from);
    const attrs = /** @type {MUCPresenceAttributes} */ ({
        from,
        nick,
        type,
        muc_jid: muc_parsers_Strophe.getBareJidFromJid(from),
        occupant_id: getOccupantID(stanza, chatbox),
        status: stanza.querySelector(':scope > status')?.textContent ?? undefined,
        show: stanza.querySelector(':scope > show')?.textContent ?? undefined,
        image_hash: muc_parsers_sizzle(`presence > x[xmlns="${muc_parsers_Strophe.NS.VCARDUPDATE}"] photo`, stanza).pop()?.textContent,
        hats: muc_parsers_sizzle(`presence > hats[xmlns="${muc_parsers_Strophe.NS.MUC_HATS}"] hat`, stanza).map(
            /** @param {Element} h */ (h) => ({
                title: h.getAttribute('title'),
                uri: h.getAttribute('uri'),
            }),
        ),
        ...getStatusCodes(stanza, 'presence'),
        ...parsePresenceUserItem(stanza, nick),
    });

    /**
     * *Hook* which allows plugins to add additional parsing
     * @event _converse#parseMUCPresence
     */
    return /** @type {import('./types').MUCPresenceAttributes}*/ (await shared_api.hook('parseMUCPresence', stanza, attrs));
}

;// CONCATENATED MODULE: ./src/headless/plugins/muc/affiliations/utils.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @module:muc-affiliations-utils
 * @typedef {module:plugin-muc-parsers.MemberListItem} MemberListItem
 * @typedef {module:plugin-muc-affiliations-api.User} User
 * @typedef {import('@converse/skeletor').Model} Model
 * @typedef {import('../constants').AFFILIATIONS} AFFILIATIONS
 */






const { Stanza: affiliations_utils_Stanza, Strophe: affiliations_utils_Strophe, u: affiliations_utils_u, stx: affiliations_utils_stx } = api_public.env;

/**
 * Sends an IQ stanza to the server, asking it for the relevant affiliation list .
 * Returns an array of {@link MemberListItem} objects, representing occupants
 * that have the given affiliation.
 * See: https://xmpp.org/extensions/xep-0045.html#modifymember
 * @param {import('../types').NonOutcastAffiliation} affiliation
 * @param {string} muc_jid - The JID of the MUC for which the affiliation list should be fetched
 * @returns {Promise<MemberListItem[]|Error>}
 */
async function getAffiliationList(affiliation, muc_jid) {
    const iq = affiliations_utils_stx`
        <iq xmlns="jabber:client" to="${muc_jid}" type="get">
            <query xmlns="${affiliations_utils_Strophe.NS.MUC_ADMIN}">
                <item affiliation="${affiliation}"/>
            </query>
        </iq>`;

    const result = await shared_api.sendIQ(iq, null, false);
    if (result === null) {
        const err_msg = `Error: timeout while fetching ${affiliation} list for MUC ${muc_jid}`;
        const err = new Error(err_msg);
        src_log.warn(err_msg);
        return err;
    }
    if (affiliations_utils_u.isErrorStanza(result)) {
        const err_msg = `Error: not allowed to fetch ${affiliation} list for MUC ${muc_jid}`;
        const err = new Error(err_msg);
        src_log.warn(err_msg);
        src_log.warn(result);
        return err;
    }
    return parseMemberListIQ(result)
        .filter((p) => p)
        .sort((a, b) => (a.nick < b.nick ? -1 : a.nick > b.nick ? 1 : 0));
}

/**
 * Send IQ stanzas to the server to modify affiliations for users in this groupchat.
 * See: https://xmpp.org/extensions/xep-0045.html#modifymember
 * @param {String|Array<String>} muc_jid - The JID(s) of the MUCs in which the
 * @param {Array<User>} users
 * @returns {Promise}
 */
function setAffiliations(muc_jid, users) {
    const affiliations = [...new Set(users.map((u) => u.affiliation))];
    return Promise.all(affiliations.map((a) => setAffiliation(a, muc_jid, users)));
}

/**
 * Send IQ stanzas to the server to set an affiliation for
 * the provided JIDs.
 * See: https://xmpp.org/extensions/xep-0045.html#modifymember
 *
 * Prosody doesn't accept multiple JIDs' affiliations
 * being set in one IQ stanza, so as a workaround we send
 * a separate stanza for each JID.
 * Related ticket: https://issues.prosody.im/345
 *
 * @param {AFFILIATIONS[number]} affiliation - The affiliation to be set
 * @param {String|Array<String>} muc_jids - The JID(s) of the MUCs in which the
 *  affiliations need to be set.
 * @param {object} members - A map of jids, affiliations and
 *  optionally reasons. Only those entries with the
 *  same affiliation as being currently set will be considered.
 * @returns {Promise} A promise which resolves and fails depending on the XMPP server response.
 */
function setAffiliation(affiliation, muc_jids, members) {
    if (!Array.isArray(muc_jids)) {
        muc_jids = [muc_jids];
    }
    members = members.filter((m) => [undefined, affiliation].includes(m.affiliation));
    return Promise.all(
        muc_jids.reduce((acc, jid) => [...acc, ...members.map((m) => sendAffiliationIQ(affiliation, jid, m))], []),
    );
}

/**
 * Send an IQ stanza specifying an affiliation change.
 * @param {AFFILIATIONS[number]} affiliation - Affiliation (could also be stored on the member object).
 * @param {string} muc_jid - The JID of the MUC in which the affiliation should be set.
 * @param {object} member - Map containing the member's jid and optionally a reason and affiliation.
 */
function sendAffiliationIQ(affiliation, muc_jid, member) {
    affiliation = member.affiliation || affiliation;
    const iq = affiliations_utils_stx`
        <iq to="${muc_jid}" type="set" xmlns="jabber:client">
            <query xmlns="${affiliations_utils_Strophe.NS.MUC_ADMIN}">
                <item affiliation="${affiliation}"
                      ${affiliation !== 'outcast' && member.nick ? affiliations_utils_Stanza.unsafeXML(`nick="${member.nick}"`) : ''}
                      jid="${member.jid}">
                    ${member.reason ? affiliations_utils_stx`<reason>${member.reason}</reason>` : ''}
                </item>
            </query>
        </iq>`;
    return shared_api.sendIQ(iq);
}

/**
 * Given two lists of objects with 'jid', 'affiliation' and
 * 'reason' properties, return a new list containing
 * those objects that are new, changed or removed
 * (depending on the 'remove_absentees' boolean).
 *
 * The affiliations for new and changed members stay the
 * same, for removed members, the affiliation is set to 'none'.
 *
 * The 'reason' property is not taken into account when
 * comparing whether affiliations have been changed.
 * @param {boolean} exclude_existing - Indicates whether JIDs from
 *      the new list which are also in the old list
 *      (regardless of affiliation) should be excluded
 *      from the delta. One reason to do this
 *      would be when you want to add a JID only if it
 *      doesn't have *any* existing affiliation at all.
 * @param {boolean} remove_absentees - Indicates whether JIDs
 *      from the old list which are not in the new list
 *      should be considered removed and therefore be
 *      included in the delta with affiliation set
 *      to 'none'.
 * @param {array} new_list - Array containing the new affiliations
 * @param {array} old_list - Array containing the old affiliations
 * @returns {array}
 */
function computeAffiliationsDelta(exclude_existing, remove_absentees, new_list, old_list) {
    const new_jids = new_list.map((o) => o.jid);
    const old_jids = old_list.map((o) => o.jid);
    // Get the new affiliations
    let delta = new_jids.filter((jid) => !old_jids.includes(jid)).map((jid) => new_list[new_jids.indexOf(jid)]);
    if (!exclude_existing) {
        // Get the changed affiliations
        delta = delta.concat(
            new_list.filter((item) => {
                const idx = old_jids.indexOf(item.jid);
                return idx >= 0 ? item.affiliation !== old_list[idx].affiliation : false;
            }),
        );
    }
    if (remove_absentees) {
        // Get the removed affiliations
        delta = delta.concat(
            old_jids.filter((jid) => !new_jids.includes(jid)).map((jid) => ({ jid, 'affiliation': 'none' })),
        );
    }
    return delta;
}

;// CONCATENATED MODULE: ./src/headless/shared/chatbox.js








const { u: chatbox_u } = api_public.env;

/**
 * Base class for all chat boxes. Provides common methods.
 */
class ChatBoxBase extends model_with_messages_ModelWithMessages(skeletor.Model) {
    async initialize() {
        await super.initialize();
        const jid = this.get('jid');
        if (!jid) {
            // XXX: The `validate` method will prevent this model
            // from being persisted if there's no jid, but that gets
            // called after model instantiation, so we have to deal
            // with invalid models here also.
            // This happens when the controlbox is in browser storage,
            // but we're in embedded mode.
            return;
        }
        this.set({ 'box_id': `box-${jid}` });
    }

    validate(attrs) {
        if (!attrs.jid) {
            return 'Ignored ChatBox without JID';
        }
        const room_jids = shared_api.settings.get('auto_join_rooms').map((s) => (s instanceof Object ? s.jid : s));
        const auto_join = shared_api.settings.get('auto_join_private_chats').concat(room_jids);
        if (
            shared_api.settings.get('singleton') &&
            !auto_join.includes(attrs.jid) &&
            !shared_api.settings.get('auto_join_on_invite')
        ) {
            const msg = `${attrs.jid} is not allowed because singleton is true and it's not being auto_joined`;
            src_log.warn(msg);
            return msg;
        }
    }

    /**
     * @param {boolean} force
     */
    maybeShow(force) {
        if (isUniView()) {
            const filter = (c) => !c.get('hidden') && c.get('jid') !== this.get('jid') && c.get('id') !== 'controlbox';
            const other_chats = shared_converse.state.chatboxes.filter(filter);
            if (force || other_chats.length === 0) {
                // We only have one chat visible at any one time.
                // So before opening a chat, we make sure all other chats are hidden.
                other_chats.forEach((c) => chatbox_u.safeSave(c, { hidden: true }));
                chatbox_u.safeSave(this, { hidden: false, closed: false });
                this.trigger('show');
            }
            return this;
        }
        // Overlayed view mode
        chatbox_u.safeSave(this, { hidden: false, closed: false });
        this.trigger('show');
        return this;
    }

    async shouldDestroyOnClose() {
        /**
         * *Hook* which allows plugins to determine whether a chat should be destroyed when it's closed.
         * For example, used by the converse-dragresize plugin to prevent resized chats
         * from being destroyed, thereby losing the resize dimensions.
         * @event _converse#shouldDestroyOnClose
         * @param {ChatBoxBase} chatbox
         * @param {boolean} should_destroy
         */
        return await shared_api.hook('shouldDestroyOnClose', this, true);
    }

    /**
     * @param {Object} [_ev]
     */
    async close(_ev) {
        if (await this.shouldDestroyOnClose()) {
            try {
                await new Promise((success, reject) => {
                    return this.destroy({
                        success,
                        error: (_m, e) => reject(e),
                    });
                });
            } catch (e) {
                src_log.debug(e);
            }
        } else {
            chatbox_u.safeSave(this, { closed: true });
        }

        if (shared_api.settings.get('clear_messages_on_reconnection')) {
            await this.clearMessages();
        }
        /**
         * Triggered once a chatbox has been closed.
         * @event _converse#chatBoxClosed
         * @type {ChatBoxBase}
         * @example _converse.api.listen.on('chatBoxClosed', chat => { ... });
         */
        shared_api.trigger('chatBoxClosed', this);
    }

    announceReconnection() {
        /**
         * Triggered whenever a `ChatBox` instance has reconnected after an outage
         * @event _converse#onChatReconnected
         * @type {ChatBoxBase}
         * @example _converse.api.listen.on('onChatReconnected', chat => { ... });
         */
        shared_api.trigger('chatReconnected', this);
    }

    async onReconnection() {
        if (shared_api.settings.get('clear_messages_on_reconnection')) {
            await this.clearMessages();
        }
        this.announceReconnection();
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/muc/utils.js









const { Strophe: muc_utils_Strophe, sizzle: muc_utils_sizzle, u: muc_utils_u } = api_public.env;

/**
 * @returns {Promise<string|undefined>}
 */
async function getDefaultMUCService() {
    let muc_service = shared_api.settings.get('muc_domain') || shared_converse.session.get('default_muc_service');
    if (!muc_service) {
        const domain = shared_converse.session.get('domain');
        const items = await shared_api.disco.entities.items(domain);
        for (const item of items) {
            if (await shared_api.disco.features.has(muc_utils_Strophe.NS.MUC, item.get('jid'))) {
                muc_service = item.get('jid');
                shared_converse.session.save({ default_muc_service: muc_service });
                break;
            }
        }
    }
    return muc_service;
}

/**
 * @param {import('@converse/skeletor').Model} model
 */
function isChatRoom(model) {
    return model?.get('type') === 'chatroom';
}

function shouldCreateGroupchatMessage(attrs) {
    return attrs.nick && (muc_utils_u.shouldCreateMessage(attrs) || attrs.is_tombstone);
}

/**
 * Hook handler for the `getDuplicateMessageQueries` hook.
 *
 * Adds a query object to match MEP (MUC Extended Presence) activity messages
 * by their `msgid`. MEP messages carry an `activities` array and are stored
 * with `type: 'mep'`; the standard stanza_id / origin_id queries in
 * {@link getDuplicateMessage} do not cover this case, so we contribute the
 * extra query here rather than overriding `getDuplicateMessage` in the MUC
 * model.
 *
 * @param {import('../../shared/types').ChatBoxOrMUC} _
 * @param {object[]} queries
 * @param {object} attrs
 * @returns {object[]}
 */
function getMUCDuplicateMessageQueries(_, queries, attrs) {
    if (attrs.activities?.length) {
        return [...queries, { type: 'mep', msgid: attrs.msgid }];
    }
    return queries;
}

/**
 * @param {import('./occupant').default} occupant1
 * @param {import('./occupant').default} occupant2
 */
function occupantsComparator(occupant1, occupant2) {
    const role1 = occupant1.get('role') || 'none';
    const role2 = occupant2.get('role') || 'none';
    if (MUC_ROLE_WEIGHTS[role1] === MUC_ROLE_WEIGHTS[role2]) {
        const nick1 = occupant1.getDisplayName().toLowerCase();
        const nick2 = occupant2.getDisplayName().toLowerCase();
        return nick1 < nick2 ? -1 : nick1 > nick2 ? 1 : 0;
    } else {
        return MUC_ROLE_WEIGHTS[role1] < MUC_ROLE_WEIGHTS[role2] ? -1 : 1;
    }
}

function registerDirectInvitationHandler() {
    shared_api.connection.get().addHandler(
        /** @param {Element} message */
        (message) => {
            shared_converse.exports.onDirectMUCInvitation(message);
            return true;
        },
        'jabber:x:conference',
        'message',
    );
}

function disconnectChatRooms() {
    /* When disconnecting, mark all groupchats as
     * disconnected, so that they will be properly entered again
     * when fetched from session storage.
     */
    return shared_converse.state.chatboxes.filter((m) => m.get('type') === CHATROOMS_TYPE)
        .forEach((m) => m.session.save({ 'connection_status': api_public.ROOMSTATUS.DISCONNECTED }));
}

async function onWindowStateChanged() {
    if (!document.hidden && shared_api.connection.connected()) {
        const rooms = await shared_api.rooms.get();
        rooms.forEach((room) => room.rejoinIfNecessary());
    }
}

/**
 * @param {Event} [event]
 */
async function routeToRoom(event) {
    if (!location.hash.startsWith('#converse/room?jid=')) {
        return;
    }
    event?.preventDefault();
    const jid = location.hash.split('=').pop();
    if (!muc_utils_u.isValidMUCJID(jid)) {
        return src_log.warn(`invalid jid "${jid}" provided in url fragment`);
    }
    await shared_api.waitUntil('roomsAutoJoined');
    if (shared_api.settings.get('allow_bookmarks')) {
        await shared_api.waitUntil('bookmarksInitialized');
    }
    shared_api.rooms.open(jid, {}, true);
}

/**
 * Opens a groupchat, making sure that certain attributes
 * are correct, for example that the "type" is set to
 * "chatroom".
 * @param {string} jid
 * @param {Object} settings
 */
async function openChatRoom(jid, settings) {
    settings.type = CHATROOMS_TYPE;
    settings.id = jid;
    const chatbox = await shared_api.rooms.get(jid, settings, true);
    chatbox.maybeShow(true);
    return chatbox;
}

/**
 * A direct MUC invitation to join a groupchat has been received
 * See XEP-0249: Direct MUC invitations.
 * @method _converse.ChatRoom#onDirectMUCInvitation
 * @param {Element} message - The message stanza containing the invitation.
 */
async function onDirectMUCInvitation(message) {
    const x_el = muc_utils_sizzle('x[xmlns="jabber:x:conference"]', message).pop(),
        from = muc_utils_Strophe.getBareJidFromJid(message.getAttribute('from')),
        room_jid = x_el.getAttribute('jid'),
        reason = x_el.getAttribute('reason');

    let result;

    const { api } = shared_converse;
    const room = await api.rooms.get(room_jid);

    if (room) {
        result = false;
    } else if (api.settings.get('auto_join_on_invite')) {
        result = true;
    } else {
        // Invite request might come from someone not your roster list
        const contact = shared_converse.state.roster.get(from)?.getDisplayName() ?? from;

        /**
         * *Hook* which is used to gather confirmation whether a direct MUC
         * invitation should be accepted or not.
         *
         * It's meant for consumers of `@converse/headless` to subscribe to
         * this hook and then ask the user to confirm.
         *
         * @event _converse#confirmDirectMUCInvitation
         */
        result = await api.hook('confirmDirectMUCInvitation', { contact, reason, jid: room_jid }, false);
    }

    if (result) {
        const chatroom = await openChatRoom(room_jid, { password: x_el.getAttribute('password') });
        if (chatroom.session.get('connection_status') === api_public.ROOMSTATUS.DISCONNECTED) {
            shared_converse.state.chatboxes.get(room_jid).rejoin();
        }
    }
}

function getDefaultMUCNickname() {
    // XXX: if anything changes here, update the docs for the
    // locked_muc_nickname setting.
    const { profile } = shared_converse.state;
    if (!profile) {
        src_log.error('Called getDefaultMUCNickname before statusInitialized has been fired.');
        return '';
    }
    const nick = profile.getNickname();
    if (nick) {
        return nick;
    } else if (shared_api.settings.get('muc_nickname_from_jid')) {
        const bare_jid = shared_converse.session.get('bare_jid');
        return muc_utils_Strophe.unescapeNode(muc_utils_Strophe.getNodeFromJid(bare_jid));
    }
}

/**
 * Determines info message visibility based on
 * muc_show_info_messages configuration setting
 * @param {import('./types').MUCStatusCode} code
 * @memberOf _converse
 */
function isInfoVisible(code) {
    const info_messages = shared_api.settings.get('muc_show_info_messages');
    if (info_messages.includes(code)) {
        return true;
    }
    return false;
}

/**
 * Automatically join groupchats, based on the
 * "auto_join_rooms" configuration setting, which is an array
 * of strings (groupchat JIDs) or objects (with groupchat JID and other settings).
 */
async function autoJoinRooms() {
    await Promise.all(
        shared_api.settings.get('auto_join_rooms').map((muc) => {
            if (typeof muc === 'string') {
                if (shared_converse.state.chatboxes.where({ 'jid': muc }).length) {
                    return Promise.resolve();
                }
                return shared_api.rooms.open(muc);
            } else if (muc instanceof Object) {
                return shared_api.rooms.open(muc.jid, { ...muc });
            } else {
                src_log.error('Invalid muc criteria specified for "auto_join_rooms"');
                return Promise.resolve();
            }
        }),
    );
    /**
     * Triggered once any rooms that have been configured to be automatically joined,
     * specified via the _`auto_join_rooms` setting, have been entered.
     * @event _converse#roomsAutoJoined
     * @example _converse.api.listen.on('roomsAutoJoined', () => { ... });
     * @example _converse.api.waitUntil('roomsAutoJoined').then(() => { ... });
     */
    shared_api.trigger('roomsAutoJoined');
}

function onAddClientFeatures() {
    shared_api.disco.own.features.add(muc_utils_Strophe.NS.MUC);

    if (shared_api.settings.get('allow_muc_invitations')) {
        shared_api.disco.own.features.add('jabber:x:conference'); // Invites
    }
}

function onBeforeTearDown() {
    shared_converse.state.chatboxes.where({ 'type': CHATROOMS_TYPE })
        .forEach((muc) => safeSave(muc.session, { 'connection_status': api_public.ROOMSTATUS.DISCONNECTED }));
}

function onStatusInitialized() {
    window.addEventListener(getUnloadEvent(), () => {
        const using_websocket = shared_api.connection.isType('websocket');
        if (using_websocket && (!shared_api.settings.get('enable_smacks') || !shared_converse.session.get('smacks_stream_id'))) {
            // For non-SMACKS websocket connections, or non-resumeable
            // connections, we disconnect all chatrooms when the page unloads.
            // See issue #1111
            disconnectChatRooms();
        }
    });
}

function onBeforeResourceBinding() {
    shared_api.connection.get().addHandler(
        /** @param {Element} stanza */
        (stanza) => {
            const muc_jid = muc_utils_Strophe.getBareJidFromJid(stanza.getAttribute('from'));
            if (!shared_converse.state.chatboxes.get(muc_jid)) {
                shared_api.waitUntil('chatBoxesFetched').then(async () => {
                    const muc = shared_converse.state.chatboxes.get(muc_jid);
                    if (muc) {
                        await muc.initialized;
                        muc.message_handler.run(stanza);
                    }
                });
            }
            return true;
        },
        null,
        'message',
        'groupchat',
    );
}

;// CONCATENATED MODULE: ./src/headless/plugins/muc/session.js



class MUCSession extends skeletor.Model {
    defaults() {
        return {
            'connection_status': ROOMSTATUS.DISCONNECTED,
        };
    }
}

/* export default */ const muc_session = (MUCSession);

;// CONCATENATED MODULE: ./src/headless/plugins/muc/muc.js
/**
 * @module:headless-plugins-muc-muc
 */





























const { u: muc_u, stx: muc_stx } = api_public.env;

const DISCO_INFO_TIMEOUT_ON_JOIN = 30000;

/**
 * Represents a groupchat conversation.
 */
class MUC extends model_with_vcard_ModelWithVCard(model_with_messages_ModelWithMessages(color_ColorAwareModel(ChatBoxBase))) {
    /**
     * @typedef {import('../../shared/message.js').default} BaseMessage
     * @typedef {import('./message.js').default} MUCMessage
     * @typedef {import('./occupant.js').default} MUCOccupant
     * @typedef {import('./types').NonOutcastAffiliation} NonOutcastAffiliation
     * @typedef {import('./types').MemberListItem} MemberListItem
     * @typedef {import('../../shared/types').MessageAttributes} MessageAttributes
     * @typedef {import('./types').MUCMessageAttributes} MUCMessageAttributes
     * @typedef {import('./types').MUCPresenceAttributes} MUCPresenceAttributes
     * @typedef {module:shared.converse.UserMessage} UserMessage
     * @typedef {import('strophe.js').Builder} Builder
     * @typedef {import('../../shared/errors').StanzaParseError} StanzaParseError
     */
    defaults() {
        /** @type {import('./types').DefaultMUCAttributes} */
        return {
            bookmarked: false,
            chat_state: undefined,
            closed: false,
            has_activity: false, // XEP-437
            hidden: isUniView() && !shared_api.settings.get('singleton'),
            hidden_occupants: !!shared_api.settings.get('hide_muc_participants'),
            message_type: 'groupchat',
            name: '',
            // For group chats, we distinguish between generally unread
            // messages and those ones that specifically mention the
            // user.
            //
            // To keep things simple, we reuse `num_unread` from
            // ChatBox to indicate unread messages which
            // mention the user and `num_unread_general` to indicate
            // generally unread messages (which *includes* mentions!).
            num_unread_general: 0,
            num_unread: 0,
            roomconfig: {},
            time_opened: this.get('time_opened') || new Date().getTime(),
            time_sent: new Date(0).toISOString(),
            type: CHATROOMS_TYPE,
        };
    }

    async initialize() {
        super.initialize();
        this.on('change:closed', () => {
            if (!this.get('closed')) {
                this.initialize();
            }
        });
        if (this.get('closed')) return;

        this.initialized = getOpenPromise();
        this.debouncedRejoin = lodash_es_debounce(this.rejoin, 250);

        this.initOccupants();
        this.initDiscoModels(); // sendChatState depends on this.features
        this.registerHandlers();

        this.on('change:chat_state', this.sendChatState, this);
        this.on('change:hidden', this.onHiddenChange, this);
        this.on('destroy', this.removeHandlers, this);

        await this.restoreSession();
        this.session.on('change:connection_status', this.onConnectionStatusChanged, this);

        this.listenTo(this.occupants, 'add', this.onOccupantAdded);
        this.listenTo(this.occupants, 'remove', this.onOccupantRemoved);
        this.listenTo(this.occupants, 'change:presence', this.onOccupantPresenceChanged);
        this.listenTo(this.occupants, 'change:affiliation', this.createAffiliationChangeMessage);
        this.listenTo(this.occupants, 'change:role', this.createRoleChangeMessage);

        const restored = await this.restoreFromCache();
        if (!restored) {
            await this.join();
        }

        /**
         * Triggered once a {@link MUC} has been created and initialized.
         * @event _converse#chatRoomInitialized
         * @type { MUC }
         * @example _converse.api.listen.on('chatRoomInitialized', model => { ... });
         */
        await shared_api.trigger('chatRoomInitialized', this, { synchronous: true });
        this.initialized.resolve();
    }

    isEntered() {
        return this.session?.get('connection_status') === ROOMSTATUS.ENTERED;
    }

    /**
     * Checks whether this MUC qualifies for subscribing to XEP-0437 Room Activity Indicators (RAI)
     * @returns {Boolean}
     */
    isRAICandidate() {
        return this.get('hidden') && shared_api.settings.get('muc_subscribe_to_rai') && this.getOwnAffiliation() !== 'none';
    }

    /**
     * Checks whether we're still joined and if so, restores the MUC state from cache.
     * @returns {Promise<boolean>} Returns `true` if we're still joined, otherwise returns `false`.
     */
    async restoreFromCache() {
        if (this.isEntered()) {
            await this.fetchOccupants().catch(/** @param {Error} e */ (e) => src_log.error(e));

            if (this.isRAICandidate()) {
                this.session.save('connection_status', ROOMSTATUS.DISCONNECTED);
                this.enableRAI();
                return true;
            } else if (await this.isJoined()) {
                await new Promise((r) => this.config.fetch({ 'success': r, 'error': r }));
                await new Promise((r) => this.features.fetch({ 'success': r, 'error': r }));
                await this.fetchMessages().catch(/** @param {Error} e */ (e) => src_log.error(e));
                return true;
            }
        }
        this.session.save('connection_status', ROOMSTATUS.DISCONNECTED);
        this.clearOccupantsCache();
        return false;
    }

    /**
     * Join the MUC
     * @param {String} [nick] - The user's nickname
     * @param {String} [password] - Optional password, if required by the groupchat.
     *  Will fall back to the `password` value stored in the room
     *  model (if available).
     *  @returns {Promise<void>}
     */
    async join(nick, password) {
        if (this.isEntered()) {
            // We have restored a groupchat from session storage,
            // so we don't send out a presence stanza again.
            return;
        }
        // Set this early, so we don't rejoin in onHiddenChange
        this.session.save('connection_status', ROOMSTATUS.CONNECTING);

        const result = await this.refreshDiscoInfo({ timeout: DISCO_INFO_TIMEOUT_ON_JOIN });
        const is_new = result instanceof ItemNotFoundError;

        nick = await this.getAndPersistNickname(nick);
        if (!nick) {
            safeSave(this.session, { 'connection_status': ROOMSTATUS.NICKNAME_REQUIRED });
            if (!is_new && shared_api.settings.get('muc_show_logs_before_join')) {
                await this.fetchMessages();
            }
            return;
        }
        shared_api.send(await this.constructJoinPresence(password, is_new));
        if (is_new) await this.refreshDiscoInfo();
    }

    /**
     * Clear stale cache and re-join a MUC we've been in before.
     */
    rejoin() {
        this.session.save('connection_status', ROOMSTATUS.DISCONNECTED);
        this.registerHandlers();
        this.clearOccupantsCache();
        return this.join();
    }

    /**
     * @param {string} password
     * @param {boolean} is_new
     */
    async constructJoinPresence(password, is_new) {
        const exclude_maxstanzas = is_new || this.features.get('mam_enabled');
        const maxstanzas = exclude_maxstanzas ? 0 : shared_api.settings.get('muc_history_max_stanzas');
        password = password || this.get('password');

        const { profile } = shared_converse.state;
        const show = profile.get('show');
        const status_message = profile.get('status_message');
        const stanza = muc_stx`
            <presence xmlns="jabber:client"
                      id="${getUniqueId()}"
                      from="${shared_api.connection.get().jid}"
                      to="${this.getRoomJIDAndNick()}">
                <x xmlns="${Strophe.NS.MUC}">
                    <history maxstanzas="${maxstanzas || 0}"/>
                    ${password ? muc_stx`<password>${password}</password>` : ''}
                </x>
                ${PRES_SHOW_VALUES.includes(show) ? muc_stx`<show>${show}</show>` : ''}
                ${status_message ? muc_stx`<status>${status_message}</status>` : ''}
            </presence>`;
        /**
         * *Hook* which allows plugins to update an outgoing MUC join presence stanza
         * @event _converse#constructedMUCPresence
         * @type {Element} The stanza which will be sent out
         */
        return await shared_api.hook('constructedMUCPresence', this, stanza);
    }

    clearOccupantsCache() {
        if (this.occupants.length) {
            // Remove non-members when reconnecting
            this.occupants.filter((o) => !o.isMember()).forEach((o) => o.destroy());
        } else {
            // Looks like we haven't restored occupants from cache, so we clear it.
            this.occupants.clearStore();
        }
    }

    /**
     * Given the passed in MUC message, send a XEP-0333 chat marker.
     * @async
     * @param {BaseMessage} msg
     * @param {('received'|'displayed'|'acknowledged')} [type='displayed']
     * @param {boolean} [force=false] - Whether a marker should be sent for the
     *  message, even if it didn't include a `markable` element.
     */
    sendMarkerForMessage(msg, type = 'displayed', force = false) {
        if (!msg || !shared_api.settings.get('send_chat_markers').includes(type) || msg?.get('type') !== 'groupchat') {
            return;
        }
        if (msg?.get('is_markable') || force) {
            const key = `stanza_id ${this.get('jid')}`;
            const id = msg.get(key);
            if (!id) {
                src_log.error(`Can't send marker for message without stanza ID: ${key}`);
                return Promise.resolve();
            }
            const from_jid = Strophe.getBareJidFromJid(msg.get('from'));
            sendMarker(from_jid, id, type, msg.get('type'));
        }
        return Promise.resolve();
    }

    /**
     * Finds the last eligible message and then sends a XEP-0333 chat marker for it.
     * @param { ('received'|'displayed'|'acknowledged') } [type='displayed']
     * @param {Boolean} force - Whether a marker should be sent for the
     *  message, even if it didn't include a `markable` element.
     */
    sendMarkerForLastMessage(type = 'displayed', force = false) {
        const msgs = Array.from(this.messages.models);
        msgs.reverse();
        const msg = msgs.find((m) => m.get('sender') === 'them' && (force || m.get('is_markable')));
        msg && this.sendMarkerForMessage(msg, type, force);
    }

    /**
     * Ensures that the user is subscribed to XEP-0437 Room Activity Indicators
     * if `muc_subscribe_to_rai` is set to `true`.
     * Only affiliated users can subscribe to RAI, but this method doesn't
     * check whether the current user is affiliated because it's intended to be
     * called after the MUC has been left and we don't have that information anymore.
     */
    enableRAI() {
        if (shared_api.settings.get('muc_subscribe_to_rai')) {
            const muc_domain = Strophe.getDomainFromJid(this.get('jid'));
            shared_api.user.presence.send({ to: muc_domain }, muc_stx`<rai xmlns="${Strophe.NS.RAI}"></rai>`);
        }
    }

    /**
     * Handler that gets called when the 'hidden' flag is toggled.
     */
    async onHiddenChange() {
        const roomstatus = ROOMSTATUS;
        const conn_status = this.session.get('connection_status');
        if (this.get('hidden')) {
            if (conn_status === roomstatus.ENTERED) {
                this.setChatState(INACTIVE);

                if (this.isRAICandidate()) {
                    this.sendMarkerForLastMessage('received', true);
                    await this.leave();
                    this.enableRAI();
                }
            }
        } else {
            await this.initialized;
            if (conn_status === roomstatus.DISCONNECTED) this.rejoin();
            this.clearUnreadMsgCounter();
        }
    }

    /**
     * @param {MUCOccupant} occupant
     */
    onOccupantAdded(occupant) {
        if (
            isInfoVisible(api_public.MUC_TRAFFIC_STATES.ENTERED) &&
            this.session.get('connection_status') === ROOMSTATUS.ENTERED &&
            occupant.get('presence') === 'online'
        ) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_TRAFFIC_STATES.ENTERED);
        }
    }

    /**
     * @param {MUCOccupant} occupant
     */
    onOccupantRemoved(occupant) {
        if (
            isInfoVisible(api_public.MUC_TRAFFIC_STATES.EXITED) &&
            this.isEntered() &&
            occupant.get('presence') === 'online'
        ) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_TRAFFIC_STATES.EXITED);
        }
    }

    /**
     * @param {MUCOccupant} occupant
     */
    onOccupantPresenceChanged(occupant) {
        if (occupant.get('states').includes('303')) {
            return;
        }
        if (occupant.get('presence') === 'offline' && isInfoVisible(api_public.MUC_TRAFFIC_STATES.EXITED)) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_TRAFFIC_STATES.EXITED);
        } else if (occupant.get('presence') === 'online' && isInfoVisible(api_public.MUC_TRAFFIC_STATES.ENTERED)) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_TRAFFIC_STATES.ENTERED);
        }
    }

    async onRoomEntered() {
        await this.occupants.fetchMembers();
        if (shared_api.settings.get('clear_messages_on_reconnection')) {
            await this.clearMessages();
        } else {
            await this.fetchMessages();
        }
        /**
         * Triggered when the user has entered a new MUC
         * @event _converse#enteredNewRoom
         * @type {MUC}
         * @example _converse.api.listen.on('enteredNewRoom', model => { ... });
         */
        shared_api.trigger('enteredNewRoom', this);
        if (
            shared_api.settings.get('auto_register_muc_nickname') &&
            (await shared_api.disco.supports(Strophe.NS.MUC_REGISTER, this.get('jid')))
        ) {
            this.registerNickname();
        }
    }

    async onConnectionStatusChanged() {
        if (this.isEntered()) {
            if (this.isRAICandidate()) {
                try {
                    await this.leave();
                } catch (e) {
                    src_log.error(e);
                }
                this.enableRAI();
            } else {
                await this.onRoomEntered();
            }
        }
    }

    async onReconnection() {
        await this.rejoin();
        this.announceReconnection();
    }

    getMessagesCollection() {
        return new shared_converse.exports.MUCMessages();
    }

    restoreSession() {
        const bare_jid = shared_converse.session.get('bare_jid');
        const id = `muc.session-${bare_jid}-${this.get('jid')}`;
        this.session = new muc_session({ id });
        initStorage(this.session, id, 'session');
        return new Promise((r) => this.session.fetch({ 'success': r, 'error': r }));
    }

    initDiscoModels() {
        const bare_jid = shared_converse.session.get('bare_jid');
        let id = `converse.muc-features-${bare_jid}-${this.get('jid')}`;
        this.features = new skeletor.Model(
            Object.assign(
                { id },
                api_public.ROOM_FEATURES.reduce((acc, feature) => {
                    acc[feature] = false;
                    return acc;
                }, {}),
            ),
        );
        this.features.browserStorage = createStore(id, 'session');
        this.features.listenTo(shared_converse, 'beforeLogout', () => this.features.browserStorage.flush());

        id = `converse.muc-config-${bare_jid}-${this.get('jid')}`;
        this.config = new skeletor.Model(/** @type {import('./types').MUCConfigAttributes} */ ({ id }));
        this.config.browserStorage = createStore(id, 'session');
        this.config.listenTo(shared_converse, 'beforeLogout', () => this.config.browserStorage.flush());
    }

    initOccupants() {
        this.occupants = new shared_converse.exports.MUCOccupants();
        const bare_jid = shared_converse.session.get('bare_jid');
        const id = `converse.occupants-${bare_jid}${this.get('jid')}`;
        this.occupants.browserStorage = createStore(id, 'session');
        this.occupants.chatroom = this;
        this.occupants.listenTo(shared_converse, 'beforeLogout', () => this.occupants.browserStorage.flush());
    }

    fetchOccupants() {
        this.occupants.fetched = new Promise((resolve) => {
            this.occupants.fetch({
                'add': true,
                'silent': true,
                'success': resolve,
                'error': resolve,
            });
        });
        return this.occupants.fetched;
    }

    /**
     * If a user's affiliation has been changed, a <presence> stanza is sent
     * out, but if the user is not in a room, a <message> stanza MAY be sent
     * out. This handler handles such message stanzas. See "Example 176" in
     * XEP-0045.
     * @param {Element} stanza
     * @returns {void}
     */
    handleAffiliationChangedMessage(stanza) {
        if (stanza.querySelector('body')) {
            // If there's a body, we don't treat it as an affiliation change message.
            return;
        }

        const item = sizzle_default()(`x[xmlns="${Strophe.NS.MUC_USER}"] item`, stanza).pop();
        if (item) {
            const from = stanza.getAttribute('from');
            const jid = item.getAttribute('jid');
            const data = {
                from,
                states: [],
                jid: Strophe.getBareJidFromJid(jid),
                resource: Strophe.getResourceFromJid(jid),
            };

            const affiliation = item.getAttribute('affiliation');
            if (affiliation) {
                data.affiliation = affiliation;
            }

            const role = item.getAttribute('role');
            if (role) {
                data.role = role;
            }

            const occupant = this.occupants.findOccupant({ jid: data.jid });
            if (occupant) {
                occupant.save(data);
            } else {
                this.occupants.create(data);
            }
        }
    }

    /**
     * @param {Element} stanza
     */
    async handleErrorMessageStanza(stanza) {
        const { __ } = shared_converse;

        const attrs_or_error = await parseMUCMessage(stanza, this);
        if (muc_u.isErrorObject(attrs_or_error)) {
            const { stanza, message } = /** @type {StanzaParseError} */ (attrs_or_error);
            if (stanza) src_log.error(stanza);
            return src_log.error(message);
        }

        const attrs = /** @type {MessageAttributes} */ (attrs_or_error);

        if (!(await this.shouldShowErrorMessage(attrs))) {
            return;
        }

        const nick = Strophe.getResourceFromJid(attrs.from);
        const occupant = nick ? this.getOccupant(nick) : null;

        const model = occupant ? occupant : this;

        const message = model.getMessageReferencedByError(attrs);
        if (message) {
            const new_attrs = {
                error: attrs.error,
                error_condition: attrs.error_condition,
                error_text: attrs.error_text,
                error_type: attrs.error_type,
                editable: false,
            };
            if (attrs.msgid === message.get('retraction_id')) {
                // The error message refers to a retraction
                new_attrs.retracted = undefined;
                new_attrs.retraction_id = undefined;
                new_attrs.retracted_id = undefined;

                if (!attrs.error) {
                    if (attrs.error_condition === 'forbidden') {
                        new_attrs.error = __("You're not allowed to retract your message.");
                    } else if (attrs.error_condition === 'not-acceptable') {
                        new_attrs.error = __(
                            "Your retraction was not delivered because you're not present in the groupchat.",
                        );
                    } else {
                        new_attrs.error = __('Sorry, an error occurred while trying to retract your message.');
                    }
                }
            } else if (!attrs.error) {
                if (attrs.error_condition === 'forbidden') {
                    new_attrs.error = __("Your message was not delivered because you weren't allowed to send it.");
                } else if (attrs.error_condition === 'not-acceptable') {
                    new_attrs.error = __("Your message was not delivered because you're not present in the groupchat.");
                } else {
                    new_attrs.error = __('Sorry, an error occurred while trying to send your message.');
                }
            }
            message.save(new_attrs);
        } else {
            model.createMessage(attrs);
        }
    }

    /**
     * Handles incoming message stanzas from the service that hosts this MUC
     * @param {Element} stanza
     */
    handleMessageFromMUCHost(stanza) {
        if (this.isEntered()) {
            // We're not interested in activity indicators when already joined to the room
            return;
        }
        const rai = sizzle_default()(`rai[xmlns="${Strophe.NS.RAI}"]`, stanza).pop();
        const active_mucs = Array.from(rai?.querySelectorAll('activity') || []).map((m) => m.textContent);
        if (active_mucs.includes(this.get('jid'))) {
            this.save({
                'has_activity': true,
                'num_unread_general': 0, // Either/or between activity and unreads
            });
        }
    }

    /**
     * Handles XEP-0452 MUC Mention Notification messages
     * @param {Element} stanza
     */
    handleForwardedMentions(stanza) {
        if (this.isEntered()) {
            // Avoid counting mentions twice
            return;
        }
        const msgs = sizzle_default()(
            `mentions[xmlns="${Strophe.NS.MENTIONS}"] forwarded[xmlns="${Strophe.NS.FORWARD}"] message[type="groupchat"]`,
            stanza,
        );
        const muc_jid = this.get('jid');
        const mentions = msgs.filter((m) => Strophe.getBareJidFromJid(m.getAttribute('from')) === muc_jid);
        if (mentions.length) {
            this.save({
                'has_activity': true,
                'num_unread': this.get('num_unread') + mentions.length,
            });
            mentions.forEach(
                /** @param {Element} stanza */ async (stanza) => {
                    const attrs = await parseMUCMessage(stanza, this);
                    const data = { stanza, attrs, 'chatbox': this };
                    shared_api.trigger('message', data);
                },
            );
        }
    }

    /**
     * Parses an incoming message stanza and queues it for processing.
     * @param {Builder|Element} stanza
     */
    async handleMessageStanza(stanza) {
        stanza = /** @type {Builder} */ (stanza).tree?.() ?? /** @type {Element} */ (stanza);

        const type = stanza.getAttribute('type');
        if (type === 'error') {
            return this.handleErrorMessageStanza(stanza);
        }
        if (type === 'groupchat') {
            if (isArchived(stanza)) {
                // MAM messages are handled in converse-mam.
                // We shouldn't get MAM messages here because
                // they shouldn't have a `type` attribute.
                return src_log.warn(`Received a MAM message with type "groupchat"`);
            }
        } else if (!type) {
            return this.handleForwardedMentions(stanza);
        }

        let attrs_or_error;
        try {
            attrs_or_error = await parseMUCMessage(stanza, this);
        } catch (e) {
            return src_log.error(e);
        }

        if (muc_u.isErrorObject(attrs_or_error)) {
            const { stanza, message } = /** @type {StanzaParseError} */ (attrs_or_error);
            if (stanza) src_log.error(stanza);
            return src_log.error(message);
        }

        const attrs = /** @type {MUCMessageAttributes} */ (attrs_or_error);
        if (attrs.type === 'groupchat') {
            attrs.codes.forEach((code) => this.createInfoMessage(code));
            this.fetchFeaturesIfConfigurationChanged(attrs);
        }

        const data = /** @type {import('./types').MUCMessageEventData} */ ({
            stanza,
            attrs,
            chatbox: this,
        });
        /**
         * Triggered when a groupchat message stanza has been received and parsed.
         * @event _converse#message
         * @type {object}
         * @property {import('./types').MUCMessageEventData} data
         */
        shared_api.trigger('message', data);
        return attrs && this.queueMessage(attrs);
    }

    /**
     * Register presence and message handlers relevant to this groupchat
     */
    registerHandlers() {
        const muc_jid = this.get('jid');
        const muc_domain = Strophe.getDomainFromJid(muc_jid);
        this.removeHandlers();
        const connection = shared_api.connection.get();
        this.presence_handler = connection.addHandler(
            /** @param {Element} stanza */ (stanza) => {
                this.onPresence(stanza);
                return true;
            },
            null,
            'presence',
            null,
            null,
            muc_jid,
            { 'ignoreNamespaceFragment': true, 'matchBareFromJid': true },
        );

        this.domain_presence_handler = connection.addHandler(
            /** @param {Element} stanza */ (stanza) => {
                this.onPresenceFromMUCHost(stanza);
                return true;
            },
            null,
            'presence',
            null,
            null,
            muc_domain,
        );

        this.message_handler = connection.addHandler(
            /** @param {Element} stanza */ (stanza) => {
                this.handleMessageStanza(stanza);
                return true;
            },
            null,
            'message',
            null,
            null,
            muc_jid,
            { 'matchBareFromJid': true },
        );

        this.domain_message_handler = connection.addHandler(
            /** @param {Element} stanza */ (stanza) => {
                this.handleMessageFromMUCHost(stanza);
                return true;
            },
            null,
            'message',
            null,
            null,
            muc_domain,
        );

        this.affiliation_message_handler = connection.addHandler(
            /** @param {Element} stanza */
            (stanza) => {
                this.handleAffiliationChangedMessage(stanza);
                return true;
            },
            Strophe.NS.MUC_USER,
            'message',
            null,
            null,
            muc_jid,
        );
    }

    removeHandlers() {
        const connection = shared_api.connection.get();
        // Remove the presence and message handlers that were
        // registered for this groupchat.
        if (this.message_handler) {
            connection?.deleteHandler(this.message_handler);
            delete this.message_handler;
        }
        if (this.domain_message_handler) {
            connection?.deleteHandler(this.domain_message_handler);
            delete this.domain_message_handler;
        }
        if (this.presence_handler) {
            connection?.deleteHandler(this.presence_handler);
            delete this.presence_handler;
        }
        if (this.domain_presence_handler) {
            connection?.deleteHandler(this.domain_presence_handler);
            delete this.domain_presence_handler;
        }
        if (this.affiliation_message_handler) {
            connection?.deleteHandler(this.affiliation_message_handler);
            delete this.affiliation_message_handler;
        }
        return this;
    }

    invitesAllowed() {
        return (
            shared_api.settings.get('allow_muc_invitations') &&
            (this.features.get('open') || this.getOwnAffiliation() === 'owner')
        );
    }

    getDisplayName() {
        const name = this.get('name');
        if (name) {
            return name.trim();
        } else if (shared_api.settings.get('locked_muc_domain') === 'hidden') {
            return Strophe.getNodeFromJid(this.get('jid'));
        } else {
            return this.get('jid');
        }
    }

    /**
     * Sends a message stanza to the XMPP server and expects a reflection
     * or error message within a specific timeout period.
     * @param {Builder|Element } message
     * @returns { Promise<Element>|Promise<TimeoutError> } Returns a promise
     *  which resolves with the reflected message stanza or with an error stanza or
     *  {@link TimeoutError}.
     */
    sendTimedMessage(message) {
        const el = message instanceof Element ? message : message.tree();
        let id = el.getAttribute('id');
        if (!id) {
            // inject id if not found
            id = getUniqueId('sendIQ');
            el.setAttribute('id', id);
        }
        const promise = getOpenPromise();
        const timeout = shared_api.settings.get('stanza_timeout');
        const connection = shared_api.connection.get();
        const timeoutHandler = connection.addTimedHandler(timeout, () => {
            connection.deleteHandler(handler);
            const err = new TimeoutError('Timeout Error: No response from server');
            promise.resolve(err);
            return false;
        });
        const handler = connection.addHandler(
            /** @param {Element} stanza */
            (stanza) => {
                timeoutHandler && connection.deleteTimedHandler(timeoutHandler);
                promise.resolve(stanza);
            },
            null,
            'message',
            ['error', 'groupchat'],
            id,
        );
        shared_api.send(el);
        return promise;
    }

    /**
     * Retract one of your messages in this groupchat
     * @param {BaseMessage} message - The message which we're retracting.
     */
    async retractOwnMessage(message) {
        const __ = shared_converse.__;
        const editable = message.get('editable');
        const retraction_id = getUniqueId();
        const id = message.get('id');

        const stanza = muc_stx`
            <message id="${retraction_id}"
                     to="${this.get('jid')}"
                     type="groupchat"
                     xmlns="jabber:client">
                <retract id="${id}" xmlns="${Strophe.NS.RETRACT}"/>
                <body>/me retracted a message</body>
                <store xmlns="${Strophe.NS.HINTS}"/>
                <fallback xmlns="${Strophe.NS.FALLBACK}" for="${Strophe.NS.RETRACT}" />
            </message>`;

        // Optimistic save
        message.set({
            retracted: new Date().toISOString(),
            retracted_id: id,
            retraction_id: retraction_id,
            editable: false,
        });
        const result = await this.sendTimedMessage(stanza);

        if (muc_u.isErrorStanza(result)) {
            src_log.error(result);
        } else if (result instanceof TimeoutError) {
            src_log.error(result);
            message.save({
                editable,
                error_type: 'timeout',
                error: __('A timeout happened while trying to retract your message.'),
                retracted: undefined,
                retracted_id: undefined,
                retraction_id: undefined,
            });
        }
    }

    /**
     * Retract someone else's message in this groupchat.
     * @param {MUCMessage} message - The message which we're retracting.
     * @param {string} [reason] - The reason for retracting the message.
     * @example
     *  const room = await api.rooms.get(jid);
     *  const message = room.messages.findWhere({'body': 'Get rich quick!'});
     *  room.retractOtherMessage(message, 'spam');
     */
    async retractOtherMessage(message, reason) {
        const editable = message.get('editable');
        const bare_jid = shared_converse.session.get('bare_jid');
        // Optimistic save
        message.save({
            moderated: 'retracted',
            moderated_by: bare_jid,
            moderated_id: message.get('msgid'),
            moderation_reason: reason,
            editable: false,
        });
        const result = await this.sendRetractionIQ(message, reason);
        if (result === null || muc_u.isErrorStanza(result)) {
            // Undo the save if something went wrong
            message.save({
                editable,
                moderated: undefined,
                moderated_by: undefined,
                moderated_id: undefined,
                moderation_reason: undefined,
            });
        }
        return result;
    }

    /**
     * Sends an IQ stanza to the XMPP server to retract a message in this groupchat.
     * @param {MUCMessage} message - The message which we're retracting.
     * @param {string} [reason] - The reason for retracting the message.
     */
    sendRetractionIQ(message, reason) {
        const iq = muc_stx`
            <iq to="${this.get('jid')}" type="set" xmlns="jabber:client">
                <moderate id="${message.get(`stanza_id ${this.get('jid')}`)}" xmlns="${Strophe.NS.MODERATE}">
                    <retract xmlns="${Strophe.NS.RETRACT}"/>
                    ${reason ? muc_stx`<reason>${reason}</reason>` : ''}
                </moderate>
            </iq>`;
        return shared_api.sendIQ(iq, null, false);
    }

    /**
     * Sends an IQ stanza to the XMPP server to destroy this groupchat. Not
     * to be confused with the {@link MUC#destroy}
     * method, which simply removes the room from the local browser storage cache.
     * @param {string} [reason] - The reason for destroying the groupchat.
     * @param {string} [new_jid] - The JID of the new groupchat which replaces this one.
     */
    sendDestroyIQ(reason, new_jid) {
        const iq = muc_stx`
            <iq to="${this.get('jid')}" type="set" xmlns="jabber:client">
                <query xmlns="${Strophe.NS.MUC_OWNER}">
                    <destroy ${new_jid ? Stanza.unsafeXML(`jid="${Strophe.xmlescape(new_jid)}"`) : ''}>
                        ${reason ? muc_stx`<reason>${reason}</reason>` : ''}
                    </destroy>
                </query>
            </iq>`;
        return shared_api.sendIQ(iq);
    }

    /**
     * Leave the groupchat by sending an unavailable presence stanza, and then
     * tear down the features and disco collections so that they'll be
     * recreated if/when we rejoin.
     * @param {string} [exit_msg] - Message to indicate your reason for leaving
     */
    async leave(exit_msg) {
        shared_api.user.presence.send({
            type: 'unavailable',
            to: this.getRoomJIDAndNick(),
            status: exit_msg,
        });

        safeSave(this.session, { connection_status: ROOMSTATUS.DISCONNECTED });

        // Delete the features model
        if (this.features) {
            await new Promise((resolve) =>
                this.features.destroy({
                    success: resolve,
                    error: (_, e) => {
                        src_log.error(e);
                        resolve();
                    },
                }),
            );
        }
        // Delete disco entity
        const disco_entity = shared_converse.state.disco_entities?.get(this.get('jid'));
        if (disco_entity) {
            await new Promise((resolve) =>
                disco_entity.destroy({
                    success: resolve,
                    error: (_, e) => {
                        src_log.error(e);
                        resolve();
                    },
                }),
            );
        }
    }

    /**
     * @typedef {Object} CloseEvent
     * @property {string} name
     * @param {CloseEvent} [ev]
     */
    async close(ev) {
        const { ENTERED, CLOSING } = ROOMSTATUS;
        const was_entered = this.session.get('connection_status') === ENTERED;

        safeSave(this.session, { connection_status: CLOSING });
        was_entered && this.sendMarkerForLastMessage('received', true);
        await this.leave();

        this.occupants.clearStore();

        const is_closed_by_user = ev?.name !== 'closeAllChatBoxes';
        if (is_closed_by_user) {
            await this.unregisterNickname();
            if (shared_api.settings.get('muc_clear_messages_on_leave')) {
                this.clearMessages();
            }
            /**
             * Triggered when the user leaves a MUC
             * @event _converse#leaveRoom
             * @type {MUC}
             * @example _converse.api.listen.on('leaveRoom', model => { ... });
             */
            shared_api.trigger('leaveRoom', this);
        }

        // Delete the session model
        await new Promise((success) =>
            this.session.destroy({
                success,
                error: (_, e) => {
                    src_log.error(e);
                    success();
                },
            }),
        );
        return super.close();
    }

    canModerateMessages() {
        const self = this.getOwnOccupant();
        return self && self.isModerator() && shared_api.disco.supports(Strophe.NS.MODERATE, this.get('jid'));
    }

    canPostMessages() {
        return this.isEntered() && !(this.features.get('moderated') && this.getOwnRole() === 'visitor');
    }

    /**
     * @param {import('../../shared/message').default} message
     */
    isChatMessage(message) {
        return message.get('type') === this.get('message_type');
    }

    /**
     * Return an array of unique nicknames based on all occupants and messages in this MUC.
     * @returns {String[]}
     */
    getAllKnownNicknames() {
        return [
            ...new Set([...this.occupants.map((o) => o.get('nick')), ...this.messages.map((m) => m.get('nick'))]),
        ].filter((n) => n);
    }

    getAllKnownNicknamesRegex() {
        const longNickString = this.getAllKnownNicknames()
            .map((n) => parse_helpers.escapeRegexString(n))
            .join('|');
        return RegExp(`(?:\\p{P}|\\p{Z}|^)@(${longNickString})(?![\\w@-])`, 'uig');
    }

    /**
     * @param {string} jid
     */
    getOccupantByJID(jid) {
        return this.occupants.findOccupant({ jid });
    }

    /**
     * @param {string} nick
     */
    getOccupantByNickname(nick) {
        return this.occupants.findOccupant({ nick });
    }

    /**
     * @param {string} nick
     */
    getReferenceURIFromNickname(nick) {
        const muc_jid = this.get('jid');
        const occupant = this.getOccupant(nick);
        const uri = (this.features.get('nonanonymous') && occupant?.get('jid')) || `${muc_jid}/${nick}`;
        return encodeURI(`xmpp:${uri}`);
    }

    /**
     * Given a text message, look for `@` mentions and turn them into
     * XEP-0372 references
     * @param { String } text
     */
    parseTextForReferences(text) {
        const mentions_regex = /(\p{P}|\p{Z}|^)([@][\w_-]+(?:\.\w+)*)/giu;
        if (!text || !mentions_regex.test(text)) {
            return [text, []];
        }

        const getMatchingNickname = parse_helpers.findFirstMatchInArray(this.getAllKnownNicknames());

        const matchToReference = (match) => {
            let at_sign_index = match[0].indexOf('@');
            if (match[0][at_sign_index + 1] === '@') {
                // edge-case
                at_sign_index += 1;
            }
            const begin = match.index + at_sign_index;
            const end = begin + match[0].length - at_sign_index;
            const value = getMatchingNickname(match[1]);
            const type = 'mention';
            const uri = this.getReferenceURIFromNickname(value);
            return { begin, end, value, type, uri };
        };

        const regex = this.getAllKnownNicknamesRegex();
        const mentions = [...text.matchAll(regex)].filter((m) => !m[0].startsWith('/'));
        const references = mentions.map(matchToReference);

        const [updated_message, updated_references] = parse_helpers.reduceTextFromReferences(text, references);
        return [updated_message, updated_references];
    }

    /**
     * @param {MessageAttributes} [attrs] - A map of attributes to be saved on the message
     */
    async getOutgoingMessageAttributes(attrs) {
        const is_spoiler = this.get('composing_spoiler');
        let text = '',
            references;
        if (attrs?.body) {
            [text, references] = this.parseTextForReferences(attrs.body);
        }
        const origin_id = getUniqueId();
        const body = text ? muc_u.emojis.shortnamesToUnicode(text) : undefined;

        // Get reply attributes from chatbox model if replying to a message
        const reply_to_id = this.get('reply_to_id');
        const reply_to = this.get('reply_to');

        attrs = Object.assign(
            {},
            attrs,
            {
                body,
                is_spoiler,
                origin_id,
                references,
                reply_to_id,
                reply_to,
                id: origin_id,
                msgid: origin_id,
                from: `${this.get('jid')}/${this.get('nick')}`,
                fullname: this.get('nick'),
                message: body,
                nick: this.get('nick'),
                sender: 'me',
                type: 'groupchat',
                original_text: text,
            },
            await muc_u.getMediaURLsMetadata(text),
        );

        // Clear reply state after capturing it
        if (reply_to_id) {
            this.save({ reply_to_id: undefined, reply_to: undefined });
        }

        /**
         * *Hook* which allows plugins to update the attributes of an outgoing
         * message.
         * @event _converse#getOutgoingMessageAttributes
         */
        attrs = await shared_api.hook('getOutgoingMessageAttributes', this, attrs);
        return attrs;
    }

    /**
     * Utility method to construct the JID for the current user as occupant of the groupchat.
     * @returns {string} - The groupchat JID with the user's nickname added at the end.
     * @example groupchat@conference.example.org/nickname
     */
    getRoomJIDAndNick() {
        const nick = this.get('nick');
        const jid = Strophe.getBareJidFromJid(this.get('jid'));
        return jid + (nick !== null ? `/${nick}` : '');
    }

    /**
     * Sends a message with the current XEP-0085 chat state of the user
     * as taken from the `chat_state` attribute of the {@link MUC}.
     */
    sendChatState() {
        if (
            !shared_api.settings.get('send_chat_state_notifications') ||
            !this.get('chat_state') ||
            !this.isEntered() ||
            (this.features.get('moderated') && this.getOwnRole() === 'visitor')
        ) {
            return;
        }
        const allowed = shared_api.settings.get('send_chat_state_notifications');
        if (Array.isArray(allowed) && !allowed.includes(this.get('chat_state'))) {
            return;
        }
        const chat_state = this.get('chat_state');
        if (chat_state === GONE) return; // <gone/> is not applicable within MUC context

        shared_api.send(muc_stx`
            <message to="${this.get('jid')}" type="groupchat" xmlns="jabber:client">
                ${chat_state === INACTIVE ? muc_stx`<inactive xmlns="${Strophe.NS.CHATSTATES}"/>` : ''}
                ${chat_state === ACTIVE ? muc_stx`<active xmlns="${Strophe.NS.CHATSTATES}"/>` : ''}
                ${chat_state === COMPOSING ? muc_stx`<composing xmlns="${Strophe.NS.CHATSTATES}"/>` : ''}
                ${chat_state === PAUSED ? muc_stx`<paused xmlns="${Strophe.NS.CHATSTATES}"/>` : ''}
                <no-store xmlns="${Strophe.NS.HINTS}"/>
                <no-permanent-store xmlns="${Strophe.NS.HINTS}"/>
            </message>`);
    }

    /**
     * Send a direct invitation as per XEP-0249
     * @param {String} recipient - JID of the person being invited
     * @param {String} [reason] - Reason for the invitation
     */
    directInvite(recipient, reason) {
        if (this.features.get('membersonly')) {
            // When inviting to a members-only groupchat, we first add
            // the person to the member list by giving them an
            // affiliation of 'member' otherwise they won't be able to join.
            this.updateMemberLists([{ jid: recipient, affiliation: 'member', reason }]);
        }
        const invitation = muc_stx`
            <message xmlns="jabber:client" to="${recipient}" id="${getUniqueId()}">
                <x xmlns="jabber:x:conference"
                    jid="${this.get('jid')}"
                    ${this.get('password') ? Stanza.unsafeXML(`password="${Strophe.xmlescape(this.get('password'))}"`) : ''}
                    ${reason ? Stanza.unsafeXML(`reason="${Strophe.xmlescape(reason)}"`) : ''} />
            </message>`;
        shared_api.send(invitation);
        /**
         * After the user has sent out a direct invitation (as per XEP-0249),
         * to a roster contact, asking them to join a room.
         * @event _converse#chatBoxMaximized
         * @type {object}
         * @property {MUC} room
         * @property {string} recipient - The JID of the person being invited
         * @property {string} reason - The original reason for the invitation
         * @example _converse.api.listen.on('chatBoxMaximized', view => { ... });
         */
        shared_api.trigger('roomInviteSent', {
            room: this,
            recipient,
            reason,
        });
    }

    /**
     * Refresh the disco identity, features and fields for this {@link MUC}.
     * *features* are stored on the features {@link Model} attribute on this {@link MUC}.
     * *fields* are stored on the config {@link Model} attribute on this {@link MUC}.
     * @param {import('@converse/headless/plugins/disco/types').DiscoInfoOptions} [options]
     * @returns {Promise}
     */
    async refreshDiscoInfo(options) {
        const result = await shared_api.disco.refresh(this.get('jid'), options);
        if (result instanceof StanzaError) {
            return result;
        }
        return this.getDiscoInfo().catch((e) => src_log.error(e));
    }

    /**
     * Fetch the *extended* MUC info from the server and cache it locally
     * https://xmpp.org/extensions/xep-0045.html#disco-roominfo
     * @returns {Promise}
     */
    async getDiscoInfo() {
        const jid = this.get('jid');
        const identity = await shared_api.disco.getIdentity('conference', 'text', jid);
        if (identity?.get('name')) {
            this.save({ name: identity.get('name') });
        } else {
            this.save({ name: Strophe.getNodeFromJid(jid) });
        }
        await this.getDiscoInfoFields();
        await this.getDiscoInfoFeatures();
    }

    /**
     * Fetch the *extended* MUC info fields from the server and store them locally
     * in the `config` {@link Model} attribute.
     * See: https://xmpp.org/extensions/xep-0045.html#disco-roominfo
     * @returns {Promise}
     */
    async getDiscoInfoFields() {
        const fields = await shared_api.disco.getFields(this.get('jid'));

        const config = fields.reduce((config, f) => {
            const name = f.get('var');
            if (name === 'muc#roomconfig_roomname') {
                config['roomname'] = f.get('value');
            }
            if (name?.startsWith('muc#roominfo_')) {
                config[name.replace('muc#roominfo_', '')] = f.get('value');
            }
            return config;
        }, {});

        this.config.save(config);
        if (config['roomname']) this.save({ name: config['roomname'] });
    }

    /**
     * Use converse-disco to populate the features {@link Model} which
     * is stored as an attribute on this {@link MUC}.
     * The results may be cached. If you want to force fetching the features from the
     * server, call {@link MUC#refreshDiscoInfo} instead.
     * @returns {Promise}
     */
    async getDiscoInfoFeatures() {
        const features = await shared_api.disco.getFeatures(this.get('jid'));

        const attrs = api_public.ROOM_FEATURES.reduce(
            (acc, feature) => {
                acc[feature] = false;
                return acc;
            },
            { 'fetched': new Date().toISOString() },
        );

        features.each((feature) => {
            const fieldname = feature.get('var');
            if (!fieldname.startsWith('muc_')) {
                if (fieldname === Strophe.NS.MAM) {
                    attrs.mam_enabled = true;
                } else {
                    attrs[fieldname] = true;
                }
                return;
            }
            attrs[fieldname.replace('muc_', '')] = true;
        });
        this.features.save(attrs);
    }

    /**
     * Given a <field> element, return a copy with a <value> child if
     * we can find a value for it in this rooms config.
     * @param {Element} field
     * @returns {Element}
     */
    addFieldValue(field) {
        const type = field.getAttribute('type');
        if (type === 'fixed') {
            return field;
        }
        const fieldname = field.getAttribute('var').replace('muc#roomconfig_', '');
        const config = this.get('roomconfig');
        if (fieldname in config) {
            let values;
            switch (type) {
                case 'boolean':
                    values = [config[fieldname] ? 1 : 0];
                    break;
                case 'list-multi':
                    values = config[fieldname];
                    break;
                default:
                    values = [config[fieldname]];
            }
            field.innerHTML = values.map((v) => $build('value').t(v)).join('');
        }
        return field;
    }

    /**
     * Automatically configure the groupchat based on this model's
     * 'roomconfig' data.
     * @returns {Promise<Element>}
     * Returns a promise which resolves once a response IQ has
     * been received.
     */
    async autoConfigureChatRoom() {
        const stanza = await this.fetchRoomConfiguration();
        const fields = sizzle_default()('field', stanza);
        const configArray = fields.map((f) => this.addFieldValue(f));
        if (configArray.length) {
            return this.sendConfiguration(configArray);
        }
    }

    /**
     * Send an IQ stanza to fetch the groupchat configuration data.
     * Returns a promise which resolves once the response IQ
     * has been received.
     * @returns {Promise<Element>}
     */
    fetchRoomConfiguration() {
        return shared_api.sendIQ(muc_stx`
            <iq to="${this.get('jid')}" type="get" xmlns="jabber:client">
                <query xmlns="${Strophe.NS.MUC_OWNER}"/>
            </iq>`);
    }

    /**
     * Sends an IQ stanza with the groupchat configuration.
     * @param {Element[]} config - The groupchat configuration
     * @returns {Promise<Element>} - A promise which resolves with
     *  the `result` stanza received from the XMPP server.
     */
    sendConfiguration(config = []) {
        const iq = muc_stx`
            <iq to="${this.get('jid')}" type="set" xmlns="jabber:client">
                <query xmlns="${Strophe.NS.MUC_OWNER}">
                    <x xmlns="${Strophe.NS.XFORM}" type="submit">
                        ${config.map((el) => Strophe.Builder.fromString(el.outerHTML))}
                    </x>
                </query>
            </iq>`;
        return shared_api.sendIQ(iq);
    }

    onCommandError(err) {
        const { __ } = shared_converse;
        src_log.fatal(err);
        const message =
            __('Sorry, an error happened while running the command.') +
            ' ' +
            __("Check your browser's developer console for details.");
        this.createMessage({ message, 'type': 'error' });
    }

    getNickOrJIDFromCommandArgs(args) {
        const { __ } = shared_converse;
        if (muc_u.isValidJID(args.trim())) {
            return args.trim();
        }
        if (!args.startsWith('@')) {
            args = '@' + args;
        }
        const result = this.parseTextForReferences(args);
        const references = result[1];
        if (!references.length) {
            const message = __("Error: couldn't find a groupchat participant based on your arguments");
            this.createMessage({ message, 'type': 'error' });
            return;
        }
        if (references.length > 1) {
            const message = __('Error: found multiple groupchat participant based on your arguments');
            this.createMessage({ message, 'type': 'error' });
            return;
        }
        const nick_or_jid = references.pop().value;
        const reason = args.split(nick_or_jid, 2)[1];
        if (reason && !reason.startsWith(' ')) {
            const message = __("Error: couldn't find a groupchat participant based on your arguments");
            this.createMessage({ message, 'type': 'error' });
            return;
        }
        return nick_or_jid;
    }

    validateRoleOrAffiliationChangeArgs(command, args) {
        const { __ } = shared_converse;
        if (!args) {
            const message = __(
                'Error: the "%1$s" command takes two arguments, the user\'s nickname and optionally a reason.',
                command,
            );
            this.createMessage({ message, 'type': 'error' });
            return false;
        }
        return true;
    }

    getAllowedCommands() {
        let allowed_commands = ['clear', 'help', 'me', 'nick', 'register'];
        if (this.config.get('changesubject') || ['owner', 'admin'].includes(this.getOwnAffiliation())) {
            allowed_commands = [...allowed_commands, ...['subject', 'topic']];
        }
        const bare_jid = shared_converse.session.get('bare_jid');
        const occupant = this.occupants.findWhere({ 'jid': bare_jid });
        if (this.verifyAffiliations(['owner'], occupant, false)) {
            allowed_commands = allowed_commands.concat(OWNER_COMMANDS).concat(ADMIN_COMMANDS);
        } else if (this.verifyAffiliations(['admin'], occupant, false)) {
            allowed_commands = allowed_commands.concat(ADMIN_COMMANDS);
        }
        if (this.verifyRoles(['moderator'], occupant, false)) {
            allowed_commands = allowed_commands.concat(MODERATOR_COMMANDS).concat(VISITOR_COMMANDS);
        } else if (!this.verifyRoles(['visitor', 'participant', 'moderator'], occupant, false)) {
            allowed_commands = allowed_commands.concat(VISITOR_COMMANDS);
        }
        allowed_commands.sort();

        if (Array.isArray(shared_api.settings.get('muc_disable_slash_commands'))) {
            return allowed_commands.filter((c) => !shared_api.settings.get('muc_disable_slash_commands').includes(c));
        } else {
            return allowed_commands;
        }
    }

    verifyAffiliations(affiliations, occupant, show_error = true) {
        const { __ } = shared_converse;
        if (!Array.isArray(affiliations)) {
            throw new TypeError('affiliations must be an Array');
        }
        if (!affiliations.length) {
            return true;
        }
        const bare_jid = shared_converse.session.get('bare_jid');
        occupant = occupant || this.occupants.findWhere({ 'jid': bare_jid });
        if (occupant) {
            const a = occupant.get('affiliation');
            if (affiliations.includes(a)) {
                return true;
            }
        }
        if (show_error) {
            const message = __('Forbidden: you do not have the necessary affiliation in order to do that.');
            this.createMessage({ message, 'type': 'error' });
        }
        return false;
    }

    verifyRoles(roles, occupant, show_error = true) {
        const { __ } = shared_converse;
        if (!Array.isArray(roles)) {
            throw new TypeError('roles must be an Array');
        }
        if (!roles.length) {
            return true;
        }
        const bare_jid = shared_converse.session.get('bare_jid');
        occupant = occupant || this.occupants.findWhere({ 'jid': bare_jid });
        if (occupant) {
            const role = occupant.get('role');
            if (roles.includes(role)) {
                return true;
            }
        }
        if (show_error) {
            const message = __('Forbidden: you do not have the necessary role in order to do that.');
            this.createMessage({ message, 'type': 'error', 'is_ephemeral': 20000 });
        }
        return false;
    }

    /**
     * Returns the `role` which the current user has in this MUC
     * @returns {('none'|'visitor'|'participant'|'moderator')}
     */
    getOwnRole() {
        return this.getOwnOccupant()?.get('role');
    }

    /**
     * Returns the `affiliation` which the current user has in this MUC
     * @returns {('none'|'outcast'|'member'|'admin'|'owner')}
     */
    getOwnAffiliation() {
        return this.getOwnOccupant()?.get('affiliation') || 'none';
    }

    /**
     * Get the {@link MUCOccupant} instance which
     * represents the current user.
     * @returns {MUCOccupant}
     */
    getOwnOccupant() {
        return this.occupants.getOwnOccupant();
    }

    /**
     * Send a presence stanza to update the user's nickname in this MUC.
     * @param {String} nick
     */
    async setNickname(nick) {
        const jid = Strophe.getBareJidFromJid(this.get('jid'));
        shared_api.send(
            muc_stx`<presence xmlns="jabber:client"
                    id="${getUniqueId()}"
                    from="${shared_api.connection.get().jid}"
                    to="${jid}/${nick}"></presence>`,
        );
    }

    /**
     * Send an IQ stanza to modify an occupant's role
     * @param {MUCOccupant} occupant
     * @param {string} role
     * @param {string} reason
     * @param {function} onSuccess - callback for a successful response
     * @param {function} onError - callback for an error response
     */
    setRole(occupant, role, reason, onSuccess, onError) {
        const iq = muc_stx`
            <iq to="${this.get('jid')}" type="set" xmlns="jabber:client">
                <query xmlns="${Strophe.NS.MUC_ADMIN}">
                    <item nick="${occupant.get('nick')}" role="${role}">
                        ${reason !== null ? muc_stx`<reason>${reason}</reason>` : ''}
                    </item>
                </query>
            </iq>`;
        return shared_api.sendIQ(iq).then(onSuccess).catch(onError);
    }

    /**
     * @param {string} nickname_or_jid - The nickname or JID of the occupant to be returned
     * @returns {MUCOccupant}
     */
    getOccupant(nickname_or_jid) {
        return muc_u.isValidJID(nickname_or_jid)
            ? this.getOccupantByJID(nickname_or_jid)
            : this.getOccupantByNickname(nickname_or_jid);
    }

    /**
     * Return an array of occupant models that have the required role
     * @param {string} role
     * @returns {{jid: string, nick: string, role: string}[]}
     */
    getOccupantsWithRole(role) {
        return this.getOccupantsSortedBy('nick')
            .filter((o) => o.get('role') === role)
            .map((item) => {
                return {
                    jid: /** @type {string} */ item.get('jid'),
                    nick: /** @type {string} */ item.get('nick'),
                    role: /** @type {string} */ item.get('role'),
                };
            });
    }

    /**
     * Return an array of occupant models that have the required affiliation
     * @param {string} affiliation
     * @returns {{jid: string, nick: string, affiliation: string}[]}
     */
    getOccupantsWithAffiliation(affiliation) {
        return this.getOccupantsSortedBy('nick')
            .filter((o) => o.get('affiliation') === affiliation)
            .map((item) => {
                return {
                    jid: /** @type {string} */ item.get('jid'),
                    nick: /** @type {string} */ item.get('nick'),
                    affiliation: /** @type {string} */ item.get('affiliation'),
                };
            });
    }

    /**
     * Return an array of occupant models, sorted according to the passed-in attribute.
     * @param {string} attr - The attribute to sort the returned array by
     * @returns {MUCOccupant[]}
     */
    getOccupantsSortedBy(attr) {
        return Array.from(this.occupants.models).sort((a, b) =>
            a.get(attr) < b.get(attr) ? -1 : a.get(attr) > b.get(attr) ? 1 : 0,
        );
    }

    /**
     * Fetch the lists of users with the given affiliations.
     * Then compute the delta between those users and
     * the passed in members, and if it exists, send the delta
     * to the XMPP server to update the member list.
     * @param {object} members - Map of member jids and affiliations.
     * @returns {Promise}
     *  A promise which is resolved once the list has been
     *  updated or once it's been established there's no need
     *  to update the list.
     */
    async updateMemberLists(members) {
        const muc_jid = this.get('jid');
        /** @type {Array<NonOutcastAffiliation>} */
        const all_affiliations = ['member', 'admin', 'owner'];
        const aff_lists = await Promise.all(all_affiliations.map((a) => getAffiliationList(a, muc_jid)));

        const old_members = aff_lists.reduce(
            /**
             * @param {MemberListItem[]} acc
             * @param {MemberListItem[]|Error} val
             * @returns {MemberListItem[]}
             */
            (acc, val) => {
                if (val instanceof Error) {
                    src_log.error(val);
                    return acc;
                }
                return [...val, ...acc];
            },
            [],
        );

        await setAffiliations(
            muc_jid,
            computeAffiliationsDelta(true, false, members, /** @type {MemberListItem[]} */ (old_members)),
        );
        await this.occupants.fetchMembers();
    }

    /**
     * Triggers a hook which gives 3rd party plugins an opportunity to determine
     * the nickname to use.
     * @return {Promise<string>} A promise which resolves with the nickname
     */
    async getNicknameFromHook() {
        /**
         * *Hook* which allows plugins to determine which nickname to use for
         * the given MUC
         * @event _converse#getNicknameForMUC
         * @type {string} The nickname to use
         */
        return await shared_api.hook('getNicknameForMUC', this, null);
    }

    /**
     * Given a nick name, save it to the model state, otherwise, look
     * for a server-side reserved nickname or default configured
     * nickname and if found, persist that to the model state.
     * @param {string} nick
     * @returns {Promise<string>} A promise which resolves with the nickname
     */
    async getAndPersistNickname(nick) {
        nick =
            nick ||
            this.get('nick') ||
            (await this.getReservedNick()) ||
            (await this.getNicknameFromHook()) ||
            shared_converse.exports.getDefaultMUCNickname();

        if (nick) safeSave(this, { nick }, { silent: true });
        return nick;
    }

    /**
     * Use service-discovery to ask the XMPP server whether
     * this user has a reserved nickname for this groupchat.
     * If so, we'll use that, otherwise we render the nickname form.
     * @returns {Promise<string>} A promise which resolves with the reserved nick or null
     */
    async getReservedNick() {
        const stanza = muc_stx`
            <iq to="${this.get('jid')}" type="get" xmlns="jabber:client">
                <query xmlns="${Strophe.NS.DISCO_INFO}" node="x-roomuser-item"/>
            </iq>`;

        const result = await shared_api.sendIQ(stanza, DISCO_INFO_TIMEOUT_ON_JOIN, false);
        if (muc_u.isErrorObject(result)) {
            throw result;
        }
        // Result might be undefined due to a timeout
        const identity_el = result?.querySelector('query[node="x-roomuser-item"] identity');
        return identity_el ? identity_el.getAttribute('name') : null;
    }

    /**
     * Send an IQ stanza to the MUC to register this user's nickname.
     * This sets the user's affiliation to 'member' (if they weren't affiliated
     * before) and reserves the nickname for this user, thereby preventing other
     * users from using it in this MUC.
     * See https://xmpp.org/extensions/xep-0045.html#register
     */
    async registerNickname() {
        const { __ } = shared_converse;
        const nick = this.get('nick');
        const jid = this.get('jid');
        let iq, err_msg;
        try {
            iq = await shared_api.sendIQ(
                muc_stx`<iq to="${jid}" type="get" xmlns="jabber:client">
                    <query xmlns="${Strophe.NS.MUC_REGISTER}"/>
                </iq>`,
            );
        } catch (e) {
            if (sizzle_default()(`not-allowed[xmlns="${Strophe.NS.STANZAS}"]`, e).length) {
                err_msg = __("You're not allowed to register yourself in this groupchat.");
            } else if (sizzle_default()(`registration-required[xmlns="${Strophe.NS.STANZAS}"]`, e).length) {
                err_msg = __("You're not allowed to register in this groupchat because it's members-only.");
            }
            src_log.error(e);
            return err_msg;
        }
        const required_fields = sizzle_default()('field required', iq).map((f) => f.parentElement);
        if (required_fields.length > 1 && required_fields[0].getAttribute('var') !== 'muc#register_roomnick') {
            return src_log.error(`Can't register the user register in the groupchat ${jid} due to the required fields`);
        }
        try {
            await shared_api.sendIQ(
                muc_stx`<iq to="${jid}" type="set" xmlns="jabber:client">
                    <query xmlns="${Strophe.NS.MUC_REGISTER}">
                        <x xmlns="${Strophe.NS.XFORM}" type="submit">
                            <field var="FORM_TYPE">
                                <value>http://jabber.org/protocol/muc#register</value>
                            </field>
                            <field var="muc#register_roomnick">
                                <value>${nick}</value>
                            </field>
                        </x>
                    </query>
                </iq>`,
            );
        } catch (e) {
            const err = await parseErrorStanza(e);
            if (err?.name === 'service-unavailable') {
                src_log.error("Can't register your nickname in this groupchat, it doesn't support registration.");
            } else if (err?.name === 'bad-request') {
                src_log.error("Can't register your nickname in this groupchat, invalid data form supplied.");
            } else {
                src_log.error(e);
            }
            throw err;
        }
    }

    /**
     * Check whether we should unregister the user from this MUC, and if so,
     * call {@link MUC#sendUnregistrationIQ}
     */
    async unregisterNickname() {
        if (shared_api.settings.get('auto_register_muc_nickname') === 'unregister') {
            try {
                if (await shared_api.disco.supports(Strophe.NS.MUC_REGISTER, this.get('jid'))) {
                    await this.sendUnregistrationIQ();
                }
            } catch (e) {
                src_log.error(e);
            }
        }
    }

    /**
     * Send an IQ stanza to the MUC to unregister this user's nickname.
     * If the user had a 'member' affiliation, it'll be removed and their
     * nickname will no longer be reserved and can instead be used (and
     * registered) by other users.
     */
    sendUnregistrationIQ() {
        const iq = muc_stx`
            <iq to="${this.get('jid')}" type="set" xmlns="jabber:client">
                <query xmlns="${Strophe.NS.MUC_REGISTER}">
                    <remove/>
                </query>
            </iq>`;
        return shared_api.sendIQ(iq).catch((e) => src_log.error(e));
    }

    /**
     * Given a presence stanza, update the occupant model based on its contents.
     * @param {MUCPresenceAttributes} attrs - The presence stanza
     */
    updateOccupantsOnPresence(attrs) {
        if (attrs.type === 'error' || (!attrs.jid && !attrs.nick && !attrs.occupant_id)) {
            return true;
        }

        const occupant = this.occupants.findOccupant(attrs);
        // Destroy an unavailable occupant if this isn't a nick change operation and if they're not affiliated
        if (
            attrs.type === 'unavailable' &&
            occupant &&
            !attrs.codes.includes(api_public.MUC_NICK_CHANGED_CODE) &&
            !['admin', 'owner', 'member'].includes(attrs['affiliation'])
        ) {
            // Before destroying we set the new attrs, so that we can show the disconnection message
            occupant.set({
                ...attrs,
                presence: 'offline',
            });
            occupant.destroy();
            return;
        }

        const presence = attrs.type !== 'unavailable' ? 'online' : 'offline';
        const jid = attrs.jid || '';
        const occupant_attrs = {
            ...attrs,
            presence,
            jid: Strophe.getBareJidFromJid(jid) || occupant?.attributes?.jid,
            resource: Strophe.getResourceFromJid(jid) || occupant?.attributes?.resource,
        };

        if (attrs.is_self) {
            let modified = false;
            if (attrs.codes.includes(api_public.MUC_NICK_CHANGED_CODE)) {
                modified = true;
                this.set('nick', attrs.nick);
            }
            if (this.features.get(Strophe.NS.OCCUPANTID) && this.get('occupant-id') !== attrs.occupant_id) {
                modified = true;
                this.set('occupant_id', attrs.occupant_id);
            }
            modified && this.save();
        }

        if (occupant) {
            occupant.save(occupant_attrs);
        } else {
            this.occupants.create(occupant_attrs);
        }
    }

    /**
     * @param {MUCMessageAttributes} attrs
     */
    fetchFeaturesIfConfigurationChanged(attrs) {
        // 104: configuration change
        // 170: logging enabled
        // 171: logging disabled
        // 172: room no longer anonymous
        // 173: room now semi-anonymous
        // 174: room now fully anonymous
        const codes = ['104', '170', '171', '172', '173', '174'];
        if (attrs.codes.filter((code) => codes.includes(code)).length) {
            this.refreshDiscoInfo();
        }
    }

    /**
     * Given two JIDs, which can be either user JIDs or MUC occupant JIDs,
     * determine whether they belong to the same user.
     * @param {String} jid1
     * @param {String} jid2
     * @returns {Boolean}
     */
    isSameUser(jid1, jid2) {
        const bare_jid1 = Strophe.getBareJidFromJid(jid1);
        const bare_jid2 = Strophe.getBareJidFromJid(jid2);
        const resource1 = Strophe.getResourceFromJid(jid1);
        const resource2 = Strophe.getResourceFromJid(jid2);
        if (muc_u.isSameBareJID(jid1, jid2)) {
            if (bare_jid1 === this.get('jid')) {
                // MUC JIDs
                return resource1 === resource2;
            } else {
                return true;
            }
        } else {
            const occupant1 =
                bare_jid1 === this.get('jid')
                    ? this.occupants.findOccupant({ 'nick': resource1 })
                    : this.occupants.findOccupant({ 'jid': bare_jid1 });

            const occupant2 =
                bare_jid2 === this.get('jid')
                    ? this.occupants.findOccupant({ 'nick': resource2 })
                    : this.occupants.findOccupant({ 'jid': bare_jid2 });
            return occupant1 === occupant2;
        }
    }

    async isSubjectHidden() {
        const jids = await shared_api.user.settings.get('mucs_with_hidden_subject', []);
        return jids.includes(this.get('jid'));
    }

    async toggleSubjectHiddenState() {
        const muc_jid = this.get('jid');
        const jids = await shared_api.user.settings.get('mucs_with_hidden_subject', []);
        if (jids.includes(this.get('jid'))) {
            shared_api.user.settings.set(
                'mucs_with_hidden_subject',
                jids.filter((jid) => jid !== muc_jid),
            );
        } else {
            shared_api.user.settings.set('mucs_with_hidden_subject', [...jids, muc_jid]);
        }
    }

    /**
     * Handle a possible subject change and return `true` if so.
     * @param {object} attrs - Attributes representing a received
     *  message, as returned by {@link parseMUCMessage}
     */
    async handleSubjectChange(attrs) {
        const __ = shared_converse.__;
        if (typeof attrs.subject === 'string' && !attrs.thread && !attrs.message) {
            // https://xmpp.org/extensions/xep-0045.html#subject-mod
            // -----------------------------------------------------
            // The subject is changed by sending a message of type "groupchat" to the <room@service>,
            // where the <message/> MUST contain a <subject/> element that specifies the new subject but
            // MUST NOT contain a <body/> element (or a <thread/> element).
            const subject = attrs.subject;
            const author = attrs.nick;
            safeSave(this, { 'subject': { author, 'text': attrs.subject || '' } });
            if (!attrs.is_delayed && author) {
                const message = subject ? __('Topic set by %1$s', author) : __('Topic cleared by %1$s', author);
                const prev_msg = this.messages.last();
                if (
                    prev_msg?.get('nick') !== attrs.nick ||
                    prev_msg?.get('type') !== 'info' ||
                    prev_msg?.get('message') !== message
                ) {
                    this.createMessage({ message, 'nick': attrs.nick, 'type': 'info', 'is_ephemeral': true });
                }
                if (await this.isSubjectHidden()) {
                    this.toggleSubjectHiddenState();
                }
            }
            return true;
        }
        return false;
    }

    /**
     * Set the subject for this {@link MUC}
     * @param {String} value
     */
    setSubject(value = '') {
        shared_api.send(muc_stx`
            <message to="${this.get('jid')}" type="groupchat" xmlns="jabber:client">
                <subject>${value}</subject>
            </message>`);
    }

    /**
     * Is this a chat state notification that can be ignored,
     * because it's old or because it's from us.
     * @param {Object} attrs - The message attributes
     */
    ignorableCSN(attrs) {
        return attrs.chat_state && !attrs.body && (attrs.is_delayed || this.isOwnMessage(attrs));
    }

    /**
     * Determines whether the message is from ourselves by checking
     * the `from` attribute. Doesn't check the `type` attribute.
     * @param {Object|Element|MUCMessage} msg
     * @returns {boolean}
     */
    isOwnMessage(msg) {
        let from;
        if (msg instanceof Element) {
            from = msg.getAttribute('from');
        } else if (msg instanceof shared_converse.exports.MUCMessage) {
            from = msg.get('from');
        } else {
            from = msg.from;
        }
        return Strophe.getResourceFromJid(from) == this.get('nick');
    }

    /**
     * Determines whether the incoming message stanza is a MUC reflection
     * of a message we previously sent. A MUC reflection is the server
     * echoing back our own message with the same `msgid`.
     * @param {MUCMessage} message - The existing cached message model
     * @param {MUCMessageAttributes} attrs - Attributes of the incoming stanza
     * @returns {boolean}
     */
    isMUCReflectedMessage(message, attrs) {
        return this.isOwnMessage(attrs) && attrs.msgid === message.get('msgid');
    }

    /**
     * @param {MUCMessage} message
     * @param {MUCMessageAttributes} attrs
     * @return {Promise<object>}
     */
    async getUpdatedMessageAttributes(message, attrs) {
        const new_attrs = {
            ...(await super.getUpdatedMessageAttributes(message, attrs)),
            ...lodash_es_pick(attrs, ['from_muc', 'occupant_id']),
        };

        if (this.isMUCReflectedMessage(message, attrs)) {
            const stanza_id_keys = Object.keys(attrs).filter((k) => k.startsWith('stanza_id'));
            Object.assign(
                new_attrs,
                { ...lodash_es_pick(attrs, stanza_id_keys) },
                attrs.body !== undefined ? { body: attrs.body } : {},
            );
            if (!message.get('received')) {
                new_attrs.received = new Date().toISOString();
            }
        }
        return new_attrs;
    }

    /**
     * Send a MUC-0410 MUC Self-Ping stanza to room to determine
     * whether we're still joined.
     * @returns {Promise<boolean>}
     */
    async isJoined() {
        if (!this.isEntered()) {
            src_log.info(`isJoined: not pinging MUC ${this.get('jid')} since we're not entered`);
            return false;
        }
        if (!shared_api.connection.connected()) {
            await new Promise((resolve) => shared_api.listen.once('reconnected', resolve));
        }
        return shared_api.ping(`${this.get('jid')}/${this.get('nick')}`);
    }

    /**
     * Sends a status update presence (i.e. based on the `<show>` element)
     * @param {import("../status/types").PresenceAttrs} attrs
     * @param {Element[]|Builder[]|Element|Builder} [child_nodes]
     *  Nodes(s) to be added as child nodes of the `presence` XML element.
     */
    async sendStatusPresence(attrs, child_nodes) {
        if (this.session.get('connection_status') === ROOMSTATUS.ENTERED) {
            const presence = await shared_converse.state.profile.constructPresence(
                {
                    ...attrs,
                    to: `${this.get('jid')}/${this.get('nick')}`,
                },
                /** @type {Element[]|Builder[]} */ (child_nodes)?.map((c) => c?.tree() ?? c),
            );
            shared_api.send(presence);
        }
    }

    /**
     * Check whether we're still joined and re-join if not
     */
    async rejoinIfNecessary() {
        if (this.isRAICandidate()) {
            src_log.debug(`rejoinIfNecessary: not rejoining hidden MUC "${this.get('jid')}" since we're using RAI`);
            return true;
        }

        if (!(await this.isJoined())) {
            this.rejoin();
            return true;
        }
    }

    /**
     * @param {object} attrs
     * @returns {Promise<boolean>}
     */
    async shouldShowErrorMessage(attrs) {
        if (attrs.error_type === 'Decryption') {
            if (attrs.error_message === 'Message key not found. The counter was repeated or the key was not filled.') {
                // OMEMO message which we already decrypted before
                return false;
            } else if (attrs.error_condition === 'not-encrypted-for-this-device') {
                return false;
            }
        } else if (attrs.error_condition === 'not-acceptable' && (await this.rejoinIfNecessary())) {
            return false;
        }
        return super.shouldShowErrorMessage(attrs);
    }

    /**
     * Looks whether we already have a moderation message for this
     * incoming message. If so, it's considered "dangling" because
     * it probably hasn't been applied to anything yet, given that
     * the relevant message is only coming in now.
     * @param {object} attrs - Attributes representing a received
     *  message, as returned by {@link parseMUCMessage}
     * @returns {MUCMessage}
     */
    findDanglingModeration(attrs) {
        if (!this.messages.length) {
            return null;
        }
        // Only look for dangling moderation if there are newer
        // messages than this one, since moderation come after.
        if (this.messages.last().get('time') > attrs.time) {
            // Search from latest backwards
            const messages = Array.from(this.messages.models);
            const stanza_id = attrs[`stanza_id ${this.get('jid')}`];
            if (!stanza_id) {
                return null;
            }
            messages.reverse();
            return messages.find(
                ({ attributes }) =>
                    attributes.moderated === 'retracted' &&
                    attributes.moderated_id === stanza_id &&
                    attributes.moderated_by,
            );
        }
    }

    /**
     * Handles message moderation based on the passed in attributes.
     * @param {object} attrs - Attributes representing a received
     *  message, as returned by {@link parseMUCMessage}
     * @returns {Promise<boolean>} Returns `true` or `false` depending on
     *  whether a message was moderated or not.
     */
    async handleModeration(attrs) {
        const MODERATION_ATTRIBUTES = [
            'editable',
            'moderated',
            'moderated_by',
            'moderated_by_id',
            'moderated_id',
            'moderation_reason',
        ];
        if (attrs.moderated === 'retracted') {
            const query = {};
            const key = `stanza_id ${this.get('jid')}`;
            query[key] = attrs.moderated_id;
            const message = this.messages.findWhere(query);
            if (!message) {
                attrs['dangling_moderation'] = true;
                await this.createMessage(attrs);
                return true;
            }
            message.save(lodash_es_pick(attrs, MODERATION_ATTRIBUTES));
            return true;
        } else {
            // Check if we have dangling moderation message
            const message = this.findDanglingModeration(attrs);
            if (message) {
                const moderation_attrs = lodash_es_pick(message.attributes, MODERATION_ATTRIBUTES);
                const new_attrs = Object.assign({ dangling_moderation: false }, attrs, moderation_attrs);
                delete new_attrs['id']; // Delete id, otherwise a new cache entry gets created
                message.save(new_attrs);
                return true;
            }
        }
        return false;
    }

    getNotificationsText() {
        const { __ } = shared_converse;
        const actors_per_state = this.notifications.toJSON();

        const role_changes = shared_api.settings.get('muc_show_info_messages')
            .filter((role_change) => api_public.MUC_ROLE_CHANGES_LIST.includes(role_change));

        const join_leave_events = shared_api.settings.get('muc_show_info_messages')
            .filter((join_leave_event) => api_public.MUC_TRAFFIC_STATES_LIST.includes(join_leave_event));

        const states = [...api_public.CHAT_STATES, ...join_leave_events, ...role_changes];

        return states.reduce((result, state) => {
            const existing_actors = actors_per_state[state];
            if (!existing_actors?.length) {
                return result;
            }
            const actors = existing_actors.map((a) => this.getOccupant(a)?.getDisplayName() || a);
            if (actors.length === 1) {
                if (state === 'composing') {
                    return `${result}${__('%1$s is typing', actors[0])}\n`;
                } else if (state === 'paused') {
                    return `${result}${__('%1$s has stopped typing', actors[0])}\n`;
                } else if (state === GONE) {
                    return `${result}${__('%1$s has gone away', actors[0])}\n`;
                } else if (state === 'entered') {
                    return `${result}${__('%1$s has entered the groupchat', actors[0])}\n`;
                } else if (state === 'exited') {
                    return `${result}${__('%1$s has left the groupchat', actors[0])}\n`;
                } else if (state === 'op') {
                    return `${result}${__('%1$s is now a moderator', actors[0])}\n`;
                } else if (state === 'deop') {
                    return `${result}${__('%1$s is no longer a moderator', actors[0])}\n`;
                } else if (state === 'voice') {
                    return `${result}${__('%1$s has been given a voice', actors[0])}\n`;
                } else if (state === 'mute') {
                    return `${result}${__('%1$s has been muted', actors[0])}\n`;
                }
            } else if (actors.length > 1) {
                let actors_str;
                if (actors.length > 3) {
                    actors_str = `${Array.from(actors).slice(0, 2).join(', ')} and others`;
                } else {
                    const last_actor = actors.pop();
                    actors_str = __('%1$s and %2$s', actors.join(', '), last_actor);
                }

                if (state === 'composing') {
                    return `${result}${__('%1$s are typing', actors_str)}\n`;
                } else if (state === 'paused') {
                    return `${result}${__('%1$s have stopped typing', actors_str)}\n`;
                } else if (state === GONE) {
                    return `${result}${__('%1$s have gone away', actors_str)}\n`;
                } else if (state === 'entered') {
                    return `${result}${__('%1$s have entered the groupchat', actors_str)}\n`;
                } else if (state === 'exited') {
                    return `${result}${__('%1$s have left the groupchat', actors_str)}\n`;
                } else if (state === 'op') {
                    return `${result}${__('%1$s are now moderators', actors[0])}\n`;
                } else if (state === 'deop') {
                    return `${result}${__('%1$s are no longer moderators', actors[0])}\n`;
                } else if (state === 'voice') {
                    return `${result}${__('%1$s have been given voices', actors[0])}\n`;
                } else if (state === 'mute') {
                    return `${result}${__('%1$s have been muted', actors[0])}\n`;
                }
            }
            return result;
        }, '');
    }

    /**
     * @param { String } actor - The nickname of the actor that caused the notification
     * @param {String|Array<String>} states - The state or states representing the type of notificcation
     */
    removeNotification(actor, states) {
        const actors_per_state = this.notifications.toJSON();
        states = Array.isArray(states) ? states : [states];
        states.forEach((state) => {
            const existing_actors = Array.from(actors_per_state[state] || []);
            if (existing_actors.includes(actor)) {
                const idx = existing_actors.indexOf(actor);
                existing_actors.splice(idx, 1);
                this.notifications.set(state, Array.from(existing_actors));
            }
        });
    }

    /**
     * Update the notifications model by adding the passed in nickname
     * to the array of nicknames that all match a particular state.
     *
     * Removes the nickname from any other states it might be associated with.
     *
     * The state can be a XEP-0085 Chat State or a XEP-0045 join/leave state.
     * @param {String} actor - The nickname of the actor that causes the notification
     * @param {String} state - The state representing the type of notificcation
     */
    updateNotifications(actor, state) {
        const actors_per_state = this.notifications.toJSON();
        const existing_actors = actors_per_state[state] || [];
        if (existing_actors.includes(actor)) {
            return;
        }
        const reducer = (out, s) => {
            if (s === state) {
                out[s] = [...existing_actors, actor];
            } else {
                out[s] = (actors_per_state[s] || []).filter((a) => a !== actor);
            }
            return out;
        };
        const actors_per_chat_state = api_public.CHAT_STATES.reduce(reducer, {});
        const actors_per_traffic_state = api_public.MUC_TRAFFIC_STATES_LIST.reduce(reducer, {});
        const actors_per_role_change = api_public.MUC_ROLE_CHANGES_LIST.reduce(reducer, {});
        this.notifications.set(Object.assign(actors_per_chat_state, actors_per_traffic_state, actors_per_role_change));
        setTimeout(() => this.removeNotification(actor, state), 10000);
    }

    /**
     * @param {MessageAttributes} attrs
     * @returns {boolean}
     */
    handleMUCPrivateMessage(attrs) {
        if (attrs.type === 'chat' || attrs.type === null) {
            const occupant = this.occupants.findOccupant(attrs);
            if (occupant) {
                return occupant.queueMessage(attrs);
            }
            // TODO create occupant?
        }
        return false;
    }

    /**
     * @param {MessageAttributes} attrs
     * @returns {boolean}
     */
    handleMetadataFastening(attrs) {
        if (attrs.ogp_for_id) {
            if (attrs.from !== this.get('jid')) {
                // For now we only allow metadata from the MUC itself and not
                // from individual users who are deemed less trustworthy.
                return false;
            }
            const message = this.messages.findWhere({ 'origin_id': attrs.ogp_for_id });
            if (message) {
                const old_list = message.get('ogp_metadata') || [];
                if (old_list.filter((m) => m['og:url'] === attrs['og:url']).length) {
                    // Don't add metadata for the same URL again
                    return false;
                }
                const list = [...old_list, lodash_es_pick(attrs, METADATA_ATTRIBUTES)];
                message.save('ogp_metadata', list);
                return true;
            }
        }
        return false;
    }

    /**
     * Given {@link MessageAttributes} look for XEP-0316 Room Notifications and create info
     * messages for them.
     * @param {MUCMessageAttributes} attrs
     * @returns {boolean}
     */
    handleMEPNotification(attrs) {
        if (attrs.from !== this.get('jid') || !attrs.activities) {
            return false;
        }
        attrs.activities?.forEach((activity_attrs) => {
            const data = Object.assign(attrs, activity_attrs);
            this.createMessage(data);
            // Trigger so that notifications are shown
            shared_api.trigger('message', { 'attrs': data, 'chatbox': this });
        });
        return !!attrs.activities.length;
    }

    /**
     * Handler for all MUC messages sent to this groupchat. This method
     * shouldn't be called directly, instead {@link MUC#queueMessage}
     * should be called.
     * @param {MUCMessageAttributes|StanzaParseError} attrs_or_error - A promise which resolves to the message attributes.
     */
    async onMessage(attrs_or_error) {
        if (muc_u.isErrorObject(attrs_or_error)) {
            return src_log.error(/** @type {Error} */ (attrs_or_error).message);
        }

        const attrs = /** @type {MUCMessageAttributes} */ (attrs_or_error);
        if (attrs.type === 'error' && !(await this.shouldShowErrorMessage(attrs))) {
            return;
        }

        const message = await this.getDuplicateMessage(attrs);
        if (message) {
            message.get('type') === 'groupchat' && (await this.updateMessage(message, attrs));
            return;
        } else if (attrs.receipt_id || attrs.is_marker || this.ignorableCSN(attrs)) {
            return;
        }

        if (
            this.handleMUCPrivateMessage(attrs) ||
            this.handleMetadataFastening(attrs) ||
            this.handleMEPNotification(attrs) ||
            (await this.handleModeration(attrs)) ||
            (await this.handleRetraction(attrs)) ||
            (await this.handleSubjectChange(attrs))
        ) {
            attrs.nick && this.removeNotification(attrs.nick, ['composing', 'paused']);
            return;
        }

        this.setEditable(attrs, attrs.time);

        if (attrs['chat_state']) {
            this.updateNotifications(attrs.nick, attrs.chat_state);
        }
        /**
         * *Hook* which allows plugins to intercept an incoming MUC message stanza
         * before it is stored as a new message. Plugins can consume the stanza
         * entirely (e.g. to store it as a specialised placeholder) by returning
         * `{ handled: true }`, which prevents normal message creation.
         * @event _converse#beforeMessageCreated
         * @param {MUC} context - The MUC chatroom for which the message was received.
         * @param {MUCMessageAttributes} attrs - Parsed message attributes.
         * @param {{ handled: boolean }} data - Pass `{ handled: true }` to signal
         *   that the stanza has been fully handled and should not be processed further.
         */
        const { handled } = await shared_api.hook('beforeMessageCreated', this, attrs, { handled: false });
        if (handled) return;

        if (shouldCreateGroupchatMessage(attrs)) {
            const msg = (await this.handleCorrection(attrs)) || (await this.createMessage(attrs));
            /**
             * *Hook* which is fired after a new MUC message model has been created
             * and persisted. Plugins can use this to reconcile any state that was
             * stored in anticipation of this message (e.g. dangling reactions or
             * retractions that arrived before the original message).
             * @event _converse#afterMessageCreated
             * @param {MUC} context - The MUC chatroom the message belongs to.
             * @param {MUCMessage} data - The newly created message model.
             */
            if (msg) await shared_api.hook('afterMessageCreated', this, msg);
            this.removeNotification(attrs.nick, ['composing', 'paused']);
            this.handleUnreadMessage(msg);
        }
    }

    /**
     * @param {Element} pres
     */
    handleModifyError(pres) {
        const text = pres.querySelector('error text')?.textContent;
        if (text) {
            if (this.session.get('connection_status') === ROOMSTATUS.CONNECTING) {
                this.setDisconnectionState(text);
            } else {
                const attrs = {
                    'type': 'error',
                    'message': text,
                    'is_ephemeral': true,
                };
                this.createMessage(attrs);
            }
        }
    }

    /**
     * Handle a presence stanza that disconnects the user from the MUC
     * @param {MUCPresenceAttributes} attrs - The stanza
     */
    handleDisconnection(attrs) {
        const { is_self, reason, actor } = attrs;
        const codes = attrs.codes.filter((c) => DISCONNECT_CODES.includes(c));
        const disconnected = is_self && codes.length > 0;
        if (!disconnected) {
            return;
        }
        const { STATUS_CODE_MESSAGES } = /** @type {UserMessage} */ (shared_converse.labels.muc);
        const message = STATUS_CODE_MESSAGES[codes[0]];
        const status = codes.includes('301') ? ROOMSTATUS.BANNED : ROOMSTATUS.DISCONNECTED;
        this.setDisconnectionState(message, reason, actor?.nick, status);
    }

    /**
     * @param {import('./types').MUCStatusCode} code
     * @param {MUCPresenceAttributes} attrs
     */
    getActionInfoMessage(code, attrs) {
        const { nick, actor } = attrs;
        const __ = shared_converse.__;
        if (code === '301') {
            return actor?.nick
                ? __('%1$s has been banned by %2$s', nick, actor.nick)
                : __('%1$s has been banned', nick);
        } else if (code === '303') {
            return __("%1$s's nickname has changed", nick);
        } else if (code === '307') {
            return actor?.nick
                ? __('%1$s has been kicked out by %2$s', nick, actor.nick)
                : __('%1$s has been kicked out', nick);
        } else if (code === '321') {
            return __('%1$s has been removed because of an affiliation change', nick);
        } else if (code === '322') {
            return __('%1$s has been removed for not being a member', nick);
        }
    }

    /**
     * @param {MUCOccupant} occupant
     */
    createAffiliationChangeMessage(occupant) {
        const __ = shared_converse.__;
        const previous_affiliation = occupant._previousAttributes.affiliation;

        if (!previous_affiliation) {
            // If no previous affiliation was set, then we don't
            // interpret this as an affiliation change.
            // For example, if muc_send_probes is true, then occupants
            // are created based on incoming messages, in which case
            // we don't yet know the affiliation
            return;
        }

        const current_affiliation = occupant.get('affiliation');
        if (previous_affiliation === 'admin' && isInfoVisible(api_public.AFFILIATION_CHANGES.EXADMIN)) {
            this.createMessage({
                type: 'info',
                message: __('%1$s is no longer an admin of this groupchat', occupant.get('nick')),
            });
        } else if (previous_affiliation === 'owner' && isInfoVisible(api_public.AFFILIATION_CHANGES.EXOWNER)) {
            this.createMessage({
                type: 'info',
                message: __('%1$s is no longer an owner of this groupchat', occupant.get('nick')),
            });
        } else if (previous_affiliation === 'outcast' && isInfoVisible(api_public.AFFILIATION_CHANGES.EXOUTCAST)) {
            this.createMessage({
                type: 'info',
                message: __('%1$s is no longer banned from this groupchat', occupant.get('nick')),
            });
        }

        if (
            current_affiliation === 'none' &&
            previous_affiliation === 'member' &&
            isInfoVisible(api_public.AFFILIATION_CHANGES.EXMEMBER)
        ) {
            this.createMessage({
                type: 'info',
                message: __('%1$s is no longer a member of this groupchat', occupant.get('nick')),
            });
        }

        if (current_affiliation === 'member' && isInfoVisible(api_public.AFFILIATION_CHANGES.MEMBER)) {
            this.createMessage({
                type: 'info',
                message: __('%1$s is now a member of this groupchat', occupant.get('nick')),
            });
        } else if (
            (current_affiliation === 'admin' && isInfoVisible(api_public.AFFILIATION_CHANGES.ADMIN)) ||
            (current_affiliation == 'owner' && isInfoVisible(api_public.AFFILIATION_CHANGES.OWNER))
        ) {
            // For example: AppleJack is now an (admin|owner) of this groupchat
            this.createMessage({
                type: 'info',
                message: __('%1$s is now an %2$s of this groupchat', occupant.get('nick'), current_affiliation),
            });
        }
    }

    createRoleChangeMessage(occupant, changed) {
        if (changed === 'none' || occupant.changed.affiliation) {
            // We don't inform of role changes if they accompany affiliation changes.
            return;
        }
        const previous_role = occupant._previousAttributes.role;
        if (previous_role === 'moderator' && isInfoVisible(api_public.MUC_ROLE_CHANGES.DEOP)) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_ROLE_CHANGES.DEOP);
        } else if (previous_role === 'visitor' && isInfoVisible(api_public.MUC_ROLE_CHANGES.VOICE)) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_ROLE_CHANGES.VOICE);
        }
        if (occupant.get('role') === 'visitor' && isInfoVisible(api_public.MUC_ROLE_CHANGES.MUTE)) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_ROLE_CHANGES.MUTE);
        } else if (occupant.get('role') === 'moderator') {
            if (
                !['owner', 'admin'].includes(occupant.get('affiliation')) &&
                isInfoVisible(api_public.MUC_ROLE_CHANGES.OP)
            ) {
                // Only show this message if the user isn't already
                // an admin or owner, otherwise this isn't new information.
                this.updateNotifications(occupant.get('nick'), api_public.MUC_ROLE_CHANGES.OP);
            }
        }
    }

    /**
     * Create an info message based on a received MUC status code in a
     * <presence> stanza.
     * @param {import('./types').MUCStatusCode} code
     * @param {MUCPresenceAttributes} attrs - The original stanza
     */
    createInfoMessageFromPresence(code, attrs) {
        const __ = shared_converse.__;
        const is_self = /** @type {MUCPresenceAttributes} */ (attrs).is_self ?? false;

        if (!isInfoVisible || code === '110' || (code === '100' && !is_self)) {
            return;
        }

        const { STATUS_CODE_MESSAGES } = /** @type {UserMessage} */ (shared_converse.labels.muc);
        const message = STATUS_CODE_MESSAGES[code];
        const data = {
            type: 'info',
            is_ephemeral: true,
            message,
            code,
        };

        if (!is_self && ACTION_INFO_CODES.includes(code)) {
            data.message = this.getActionInfoMessage(code, attrs);
            data.reason = attrs.reason;
        } else if (is_self && NEW_NICK_CODES.includes(code)) {
            data.message = attrs.nick ? __(message, attrs.nick) : undefined;
        }

        if (data.message) {
            if (code === '201' && this.messages.findWhere(data)) {
                return;
            }
            this.createMessage(data);
        }
    }

    /**
     * Create an info message based on a received MUC status code in a <message> stanza.
     * @param {import('./types').MUCStatusCode} code
     */
    createInfoMessage(code) {
        if (!isInfoVisible(code) || code === '110') {
            return;
        }

        const { STATUS_CODE_MESSAGES } = /** @type {UserMessage} */ (shared_converse.labels.muc);
        const message = STATUS_CODE_MESSAGES[code];

        if (message) {
            this.createMessage({
                type: 'info',
                is_ephemeral: true,
                message,
                code,
            });
        }
    }

    /**
     * Set parameters regarding disconnection from this room. This helps to
     * communicate to the user why they were disconnected.
     * @param {string} message - The disconnection message, as received from (or
     *  implied by) the server.
     * @param {string} [reason] - The reason provided for the disconnection
     * @param {string} [actor] - The person (if any) responsible for this disconnection
     * @param {number} [status] - The status code (see `ROOMSTATUS`)
     */
    setDisconnectionState(message, reason, actor, status = ROOMSTATUS.DISCONNECTED) {
        this.session.save({
            'connection_status': status,
            'disconnection_actor': actor,
            'disconnection_message': message,
            'disconnection_reason': reason,
        });
    }

    /**
     * @param {Element} presence
     */
    onNicknameClash(presence) {
        const __ = shared_converse.__;
        if (shared_api.settings.get('muc_nickname_from_jid')) {
            const nick = presence.getAttribute('from').split('/')[1];
            if (nick === shared_converse.exports.getDefaultMUCNickname()) {
                this.join(nick + '-2');
            } else {
                const del = nick.lastIndexOf('-');
                const num = nick.substring(del + 1, nick.length);
                this.join(nick.substring(0, del + 1) + String(Number(num) + 1));
            }
        } else {
            this.save({
                'nickname_validation_message': __(
                    'The nickname you chose is reserved or ' + 'currently in use, please choose a different one.',
                ),
            });
            this.session.save({ 'connection_status': ROOMSTATUS.NICKNAME_REQUIRED });
        }
    }

    /**
     * Parses a <presence> stanza with type "error" and sets the proper
     * `connection_status` value for this {@link MUC} as
     * well as any additional output that can be shown to the user.
     * @param {Element} stanza - The presence stanza
     */
    onErrorPresence(stanza) {
        const __ = shared_converse.__;
        const error = stanza.querySelector('error');
        const error_type = error.getAttribute('type');
        const reason = sizzle_default()(`text[xmlns="${Strophe.NS.STANZAS}"]`, error).pop()?.textContent;

        if (error_type === 'modify') {
            this.handleModifyError(stanza);
        } else if (error_type === 'auth') {
            if (sizzle_default()(`not-authorized[xmlns="${Strophe.NS.STANZAS}"]`, error).length) {
                this.save({ 'password_validation_message': reason || __('Password incorrect') });
                this.session.save({ 'connection_status': ROOMSTATUS.PASSWORD_REQUIRED });
            }
            if (error.querySelector('registration-required')) {
                const message = __('You are not on the member list of this groupchat.');
                this.setDisconnectionState(message, reason);
            } else if (error.querySelector('forbidden')) {
                const { STATUS_CODE_MESSAGES } = /** @type {UserMessage} */ (shared_converse.labels.muc);
                this.setDisconnectionState(STATUS_CODE_MESSAGES[301], reason, null, ROOMSTATUS.BANNED);
            }
        } else if (error_type === 'cancel') {
            if (error.querySelector('not-allowed')) {
                const message = __('You are not allowed to create new groupchats.');
                this.setDisconnectionState(message, reason);
            } else if (error.querySelector('not-acceptable')) {
                const message = __("Your nickname doesn't conform to this groupchat's policies.");
                this.setDisconnectionState(message, reason);
            } else if (sizzle_default()(`gone[xmlns="${Strophe.NS.STANZAS}"]`, error).length) {
                const moved_jid = sizzle_default()(`gone[xmlns="${Strophe.NS.STANZAS}"]`, error)
                    .pop()
                    ?.textContent.replace(/^xmpp:/, '')
                    .replace(/\?join$/, '');
                this.save({ moved_jid, 'destroyed_reason': reason });
                this.session.save({ 'connection_status': ROOMSTATUS.DESTROYED });
            } else if (error.querySelector('conflict')) {
                this.onNicknameClash(stanza);
            } else if (error.querySelector('item-not-found')) {
                const message = __('This groupchat does not (yet) exist.');
                this.setDisconnectionState(message, reason);
            } else if (error.querySelector('service-unavailable')) {
                const message = __('This groupchat has reached its maximum number of participants.');
                this.setDisconnectionState(message, reason);
            } else if (error.querySelector('remote-server-not-found')) {
                const message = __('Remote server not found');
                this.setDisconnectionState(message, reason);
            } else if (error.querySelector('forbidden')) {
                const message = __("You're not allowed to enter this groupchat");
                this.setDisconnectionState(message, reason);
            } else {
                const message = __('An error happened while trying to enter this groupchat');
                this.setDisconnectionState(message, reason);
            }
        }
    }

    /**
     * Listens for incoming presence stanzas from the service that hosts this MUC
     * @param {Element} stanza - The presence stanza
     */
    onPresenceFromMUCHost(stanza) {
        if (stanza.getAttribute('type') === 'error') {
            const error = stanza.querySelector('error');
            if (error?.getAttribute('type') === 'wait' && error?.querySelector('resource-constraint')) {
                // If we get a <resource-constraint> error, we assume it's in context of XEP-0437 RAI.
                // We remove this MUC's host from the list of enabled domains and rejoin the MUC.
                if (this.session.get('connection_status') === ROOMSTATUS.DISCONNECTED) {
                    this.rejoin();
                }
            }
        }
    }

    /**
     * Handles incoming presence stanzas coming from the MUC
     * @param {Element} stanza
     */
    async onPresence(stanza) {
        if (stanza.getAttribute('type') === 'error') {
            return this.onErrorPresence(stanza);
        }

        const attrs = await parseMUCPresence(stanza, this);
        attrs.codes.forEach(async (code) => {
            this.createInfoMessageFromPresence(code, attrs);

            if (attrs.is_self && NEW_NICK_CODES.includes(code)) {
                this.save('nick', attrs.nick);

                if (
                    code === '303' &&
                    shared_api.settings.get('auto_register_muc_nickname') &&
                    (await shared_api.disco.supports(Strophe.NS.MUC_REGISTER, this.get('jid')))
                ) {
                    try {
                        await this.registerNickname();
                    } catch (e) {
                        src_log.error(e);
                        src_log.error('Error: could not register new nickname');
                    }
                }
            }
        });

        if (attrs.is_self) {
            this.onOwnPresence(attrs);
            if (this.getOwnRole() !== 'none' && this.session.get('connection_status') === ROOMSTATUS.CONNECTING) {
                this.session.save('connection_status', ROOMSTATUS.CONNECTED);
            }
        } else {
            this.updateOccupantsOnPresence(attrs);
        }
    }

    /**
     * Handles a received presence relating to the current user.
     *
     * For locked groupchats (which are by definition "new"), the
     * groupchat will either be auto-configured or created instantly
     * (with default config) or a configuration groupchat will be
     * rendered.
     *
     * If the groupchat is not locked, then the groupchat will be
     * auto-configured only if applicable and if the current
     * user is the groupchat's owner.
     * @param {MUCPresenceAttributes} attrs
     */
    async onOwnPresence(attrs) {
        await this.occupants.fetched;

        if (attrs['type'] === 'unavailable') {
            this.handleDisconnection(attrs);
            return;
        }

        const old_status = this.session.get('connection_status');
        if (old_status !== ROOMSTATUS.ENTERED && old_status !== ROOMSTATUS.CLOSING) {
            // Set connection_status before creating the occupant, but
            // only trigger afterwards, so that plugins can access the
            // occupant in their event handlers.
            this.session.save('connection_status', ROOMSTATUS.ENTERED, { 'silent': true });
            this.updateOccupantsOnPresence(attrs);
            this.session.trigger('change:connection_status', this.session, old_status);
        } else {
            this.updateOccupantsOnPresence(attrs);
        }

        const locked_room = attrs.codes.includes('201');
        if (locked_room) {
            if (this.get('auto_configure')) {
                await this.autoConfigureChatRoom().then(() => this.refreshDiscoInfo());
            } else if (shared_api.settings.get('muc_instant_rooms')) {
                // Accept default configuration
                await this.sendConfiguration().then(() => this.refreshDiscoInfo());
            } else {
                shared_api.modal.show('converse-muc-config-modal', { model: this });
            }
        }
    }

    /**
     * Returns a boolean to indicate whether the current user
     * was mentioned in a message.
     * @param {BaseMessage} message - The text message
     */
    isUserMentioned(message) {
        const nick = this.get('nick');
        if (message.get('references').length) {
            const mentions = message
                .get('references')
                .filter((ref) => ref.type === 'mention')
                .map((ref) => ref.value);
            return mentions.includes(nick);
        } else {
            return new RegExp(`\\b${nick}\\b`).test(message.get('body'));
        }
    }

    /**
     * @param {BaseMessage} message - The text message
     */
    incrementUnreadMsgsCounter(message) {
        const settings = {
            'num_unread_general': this.get('num_unread_general') + 1,
        };
        if (this.get('num_unread_general') === 0) {
            settings['first_unread_id'] = message.get('id');
        }
        if (this.isUserMentioned(message)) {
            settings.num_unread = this.get('num_unread') + 1;
        }
        this.save(settings);
    }

    async clearUnreadMsgCounter() {
        if (this.get('num_unread_general') > 0 || this.get('num_unread') > 0 || this.get('has_activity')) {
            await this.sendMarkerForMessage(this.messages.last());
        }
        safeSave(this, {
            'has_activity': false,
            'num_unread': 0,
            'num_unread_general': 0,
        });
    }
}

/* export default */ const muc_muc = (MUC);

;// CONCATENATED MODULE: ./src/headless/plugins/muc/occupant.js














const { Strophe: occupant_Strophe, stx: occupant_stx } = api_public.env;

/**
 * Represents a participant in a MUC
 */
class MUCOccupant extends model_with_vcard_ModelWithVCard(model_with_messages_ModelWithMessages(color_ColorAwareModel(skeletor.Model))) {
    /**
     * @typedef {import('../../shared/types').MessageAttributes} MessageAttributes
     * @typedef {import('../../shared/errors').StanzaParseError} StanzaParseError
     * @typedef {import('./message.js').default} MUCMessage
     */

    async initialize() {
        this.lazy_load_vcard = true;
        super.initialize();

        await this.fetchMessages();
        this.on('change:nick', () => this.setColor());
        this.on('change:jid', () => this.setColor());
        this.on('change:chat_state', () => sendChatState(this.get('jid'), this.get('chat_state')));
    }

    defaults() {
        return {
            hats: [],
            presence: 'offline',
            show: undefined,
            states: [],
            hidden: true,
            num_unread: 0,
            message_type: 'chat',
        };
    }

    save(key, val, options) {
        let attrs;
        if (key == null) {
            // eslint-disable-line no-eq-null
            return super.save(key, val, options);
        } else if (typeof key === 'object') {
            attrs = key;
            options = val;
        } else {
            (attrs = {})[key] = val;
        }

        if (attrs.occupant_id) {
            attrs.id = attrs.occupant_id;
        }
        return super.save(attrs, options);
    }

    getMessagesCacheKey() {
        const id = this.get('occupant_id') || this.get('jid') || this.get('nick');
        return `converse.muc-private-msgs-${id}-${shared_converse.session.get('bare_jid')}`;
    }

    getMessagesCollection() {
        return new muc_messages();
    }

    /**
     * Handler for all MUC private messages sent to this occupant.
     * This method houldn't be called directly, instead {@link MUC#queueMessage} should be called.
     * @param {MessageAttributes|StanzaParseError} attrs_or_error
     */
    async onMessage(attrs_or_error) {
        if (headless_utils.isErrorObject(attrs_or_error)) {
            const { stanza, message } = /** @type {StanzaParseError} */ (attrs_or_error);
            if (stanza) src_log.error(stanza);
            return src_log.error(message);
        }

        const attrs = /** @type {MessageAttributes} */ (attrs_or_error);
        if (attrs.type === 'error' && !(await this.shouldShowErrorMessage(attrs))) {
            return;
        }

        const message = await this.getDuplicateMessage(attrs);
        if (message) {
            await this.updateMessage(message, attrs);
            return;
        } else if (await this.handleRetraction(attrs)) {
            return;
        }

        this.setEditable(attrs, attrs.time);

        /**
         * *Hook* which allows plugins to intercept an incoming MUC private message
         * stanza before it is stored as a new message. Plugins can consume the stanza
         * entirely (e.g. to store it as a specialised placeholder) by returning
         * `{ handled: true }`, which prevents normal message creation.
         * @event _converse#beforeMessageCreated
         * @param {MUCOccupant} context - The occupant for which the message was received.
         * @param {MessageAttributes} attrs - Parsed message attributes.
         * @param {{ handled: boolean }} data - Pass `{ handled: true }` to signal
         *   that the stanza has been fully handled and should not be processed further.
         */
        const { handled } = await shared_api.hook('beforeMessageCreated', this, attrs, { handled: false });
        if (handled) return;

        if (shouldCreateGroupchatMessage(attrs)) {
            const msg = (await this.handleCorrection(attrs)) || (await this.createMessage(attrs));
            /**
             * *Hook* which is fired after a new MUC occupant message model has been
             * created and persisted. Plugins can use this to reconcile any state that
             * was stored in anticipation of this message (e.g. dangling reactions or
             * retractions that arrived before the original message).
             * @event _converse#afterMessageCreated
             * @param {MUCOccupant} context - The occupant the message belongs to.
             * @param {MUCMessage} data - The newly created message model.
             */
            if (msg) await shared_api.hook('afterMessageCreated', this, msg);
            this.handleUnreadMessage(msg);
        }
    }

    /**
     * @returns {string}
     */
    getDisplayName() {
        return this.get('nick') || this.get('jid') || '';
    }

    /**
     * Return roles which may be assigned to this occupant
     * @returns {typeof ROLES} - An array of assignable roles
     */
    getAssignableRoles() {
        let disabled = shared_api.settings.get('modtools_disable_assign');
        if (!Array.isArray(disabled)) {
            disabled = disabled ? ROLES : [];
        }
        if (this.get('role') === 'moderator') {
            return ROLES.filter((r) => !disabled.includes(r));
        } else {
            return [];
        }
    }

    /**
     * Return affiliations which may be assigned by this occupant
     * @returns {typeof AFFILIATIONS} An array of assignable affiliations
     */
    getAssignableAffiliations() {
        let disabled = shared_api.settings.get('modtools_disable_assign');
        if (!Array.isArray(disabled)) {
            disabled = disabled ? AFFILIATIONS : [];
        }
        if (this.get('affiliation') === 'owner') {
            return AFFILIATIONS.filter((a) => !disabled.includes(a));
        } else if (this.get('affiliation') === 'admin') {
            return AFFILIATIONS.filter((a) => !['owner', 'admin', ...disabled].includes(a));
        } else {
            return [];
        }
    }

    isMember() {
        return ['admin', 'owner', 'member'].includes(this.get('affiliation'));
    }

    isModerator() {
        return ['admin', 'owner'].includes(this.get('affiliation')) || this.get('role') === 'moderator';
    }

    isSelf() {
        return this.get('states').includes('110');
    }

    /**
     * @param {MessageAttributes} [attrs]
     * @return {Promise<MessageAttributes>}
     */
    async getOutgoingMessageAttributes(attrs) {
        const origin_id = headless_utils.getUniqueId();
        const text = attrs?.body;
        const body = text ? headless_utils.emojis.shortnamesToUnicode(text) : undefined;
        const muc = this.collection.chatroom;
        const own_occupant = muc.getOwnOccupant();
        attrs = Object.assign(
            {},
            attrs,
            {
                body,
                from: own_occupant.get('from'),
                fullname: shared_converse.state.profile.get('fullname'),
                id: origin_id,
                jid: this.get('jid'),
                message: body,
                msgid: origin_id,
                nick: own_occupant.get('nickname'),
                origin_id,
                sender: 'me',
                time: new Date().toISOString(),
                to: this.get('from') ?? `${muc.get('jid')}/${this.get('nick')}`,
                type: 'chat',
            },
            await headless_utils.getMediaURLsMetadata(text),
        );

        /**
         * *Hook* which allows plugins to update the attributes of an outgoing message.
         * These attributes get set on the {@link Message} and persisted.
         * @event _converse#getOutgoingMessageAttributes
         * @param {MUCOccupant} chat
         *      The chat from which this message will be sent.
         * @param {MessageAttributes} attrs
         *      The message attributes, from which the stanza will be created.
         */
        attrs = await shared_api.hook('getOutgoingMessageAttributes', this, attrs);
        return attrs;
    }

    /**
     * @param {import('../chat/message').default} message - The message object
     */
    async createMessageStanza(message) {
        const stanza = await super.createMessageStanza(message);
        stanza.cnode(occupant_stx`<x xmlns="${occupant_Strophe.NS.MUC}#user"/>`).root();
        return stanza;
    }

    /**
     * @param {import('../../shared/message').default} message
     */
    isChatMessage(message) {
        return message.get('type') === this.get('message_type');
    }
}

/* export default */ const muc_occupant = (MUCOccupant);

;// CONCATENATED MODULE: ./src/headless/plugins/muc/occupants.js
/**
 * @typedef {module:plugin-muc-parsers.MemberListItem} MemberListItem
 * @typedef {import('@converse/skeletor/dist/skeletor.d').ModelAttributes} ModelAttributes
 * @typedef {import('@converse/skeletor/dist/skeletor.d').CollectionOptions} CollectionOptions
 * @typedef {import('@converse/skeletor/dist/skeletor.d').Options} Options
 */










const { u: occupants_u } = api_public.env;


/**
 * A list of {@link MUCOccupant} instances, representing participants in a MUC.
 * @memberOf _converse
 * @extends {Collection<MUCOccupant>}
 */
class MUCOccupants extends skeletor.Collection {

    constructor (attrs, options) {
        super(
            attrs,
            Object.assign({ comparator: occupantsComparator }, options)
        );
        this.chatroom = null;
    }

    get model() {
        return muc_occupant;
    }

    initialize() {
        this.on('change:nick', () => this.sort());
        this.on('change:role', () => this.sort());
    }

    static getAutoFetchedAffiliationLists () {
        const affs = shared_api.settings.get('muc_fetch_members');
        return Array.isArray(affs) ? affs : affs ? ['member', 'admin', 'owner'] : [];
    }

    /**
     * @param {Model|ModelAttributes} attrs
     * @param {Options} [options]
     */
    create (attrs, options) {
        if (attrs.id || attrs instanceof skeletor.Model) {
            return super.create(attrs, options);
        }
        attrs.id = attrs.occupant_id || getUniqueId();
        return super.create(attrs, options);
    }

    async fetchMembers () {
        if (!['member', 'admin', 'owner'].includes(this.getOwnOccupant()?.get('affiliation'))) {
            // https://xmpp.org/extensions/xep-0045.html#affil-priv
            return;
        }
        const affiliations = MUCOccupants.getAutoFetchedAffiliationLists();
        if (affiliations.length === 0) {
            return;
        }
        const muc_jid = this.chatroom.get('jid');
        const aff_lists = await Promise.all(affiliations.map(a => getAffiliationList(a, muc_jid)));

        const new_members = aff_lists.reduce(
            /**
             * @param {MemberListItem[]} acc
             * @param {MemberListItem[]|Error} val
             * @returns {MemberListItem[]}
             */
            (acc, val) => {
                if (val instanceof Error) {
                    return acc;
                }
                return [...val, ...acc];
            }, []
        );

        const known_affiliations = affiliations.filter(
            a => !occupants_u.isErrorObject(aff_lists[affiliations.indexOf(a)])
        );
        const new_jids = /** @type {MemberListItem[]} */(new_members).map(m => m.jid).filter(m => m !== undefined);

        const new_nicks = /** @type {MemberListItem[]} */(new_members).map(
            (m) => (!m.jid && m.nick) || undefined).filter(m => m !== undefined);

        const removed_members = this.filter(m => {
            return (
                known_affiliations.includes(m.get('affiliation')) &&
                !new_nicks.includes(m.get('nick')) &&
                !new_jids.includes(m.get('jid'))
            );
        });

        const bare_jid = shared_converse.session.get('bare_jid');
        removed_members.forEach(occupant => {
            if (occupant.get('jid') === bare_jid) {
                return;
            } else if (occupant.get('show') === 'offline') {
                occupant.destroy();
            } else {
                occupant.save('affiliation', null);
            }
        });
        /** @type {MemberListItem[]} */(new_members).forEach(attrs => {
            const occupant = this.findOccupant(attrs);
            occupant ? occupant.save(attrs) : this.create(attrs);
        });
        /**
         * Triggered once the member lists for this MUC have been fetched and processed.
         * @event _converse#membersFetched
         * @example _converse.api.listen.on('membersFetched', () => { ... });
         */
        shared_api.trigger('membersFetched');
    }

    /**
     * Try to find an existing occupant based on the provided {@link OccupantData} object.
     * Fetching the user by `occupant_id` is the quickest, O(1),
     * since it's a dictionary lookup.
     * Fetching by jid or nick is O(n), since it requires traversing an array.
     * Lookup by occupant_id is done first, then jid, and then nick.
     *
     * @param {import('./types').OccupantData} data
     * @returns {MUCOccupant}
     */
    findOccupant (data) {
        if (data.occupant_id) {
            return this.get(data.occupant_id);
        }

        const jid = data.jid && Strophe.getBareJidFromJid(data.jid);
        const occupant = jid && this.findWhere({ jid }) ||
            data.nick && this.findWhere({ 'nick': data.nick });

        return occupant;
    }

    /**
     * Get the {@link MUCOccupant} instance which
     * represents the current user.
     * @method _converse.MUCOccupants#getOwnOccupant
     * @returns {MUCOccupant}
     */
    getOwnOccupant () {
        return this.findOccupant({
            jid: shared_converse.session.get('bare_jid'),
            occupant_id: this.chatroom.get('occupant_id')
        });
    }
}


// @ts-ignore
/* export default */ const occupants = (MUCOccupants);

;// CONCATENATED MODULE: ./src/headless/plugins/chat/model.js














const { Strophe: chat_model_Strophe, u: model_u } = api_public.env;

/**
 * Represents a one-on-one chat conversation.
 */
class model_ChatBox extends model_with_vcard_ModelWithVCard(model_with_messages_ModelWithMessages(model_with_contact_ModelWithContact(color_ColorAwareModel(ChatBoxBase)))) {
    /**
     * @typedef {import('./message.js').default} Message
     * @typedef {import('../muc/muc.js').default} MUC
     * @typedef {import('../../shared/types').MessageAttributes} MessageAttributes
     * @typedef {import('../../shared/errors').StanzaParseError} StanzaParseError
     */

    defaults() {
        return {
            bookmarked: false,
            hidden: isUniView() && !shared_api.settings.get('singleton'),
            message_type: 'chat',
            num_unread: 0,
            time_opened: this.get('time_opened') || new Date().getTime(),
            time_sent: new Date(0).toISOString(),
            type: PRIVATE_CHAT_TYPE,
        };
    }

    constructor(attrs, options) {
        super(attrs, options);
        this.disable_mam = false;
    }

    async initialize() {
        super.initialize();
        this.initialized = getOpenPromise();

        const jid = this.get('jid');
        this.setPresence(jid);
        await this.setModelContact(jid);

        this.on('change:chat_state', () => sendChatState(this.get('jid'), this.get('chat_state')));
        this.on('change:hidden', () => this.get('hidden') && this.setChatState(INACTIVE));

        await this.fetchMessages();
        /**
         * Triggered once a {@link ChatBox} has been created and initialized.
         * @event _converse#chatBoxInitialized
         * @type { ChatBox}
         * @example _converse.api.listen.on('chatBoxInitialized', model => { ... });
         */
        await shared_api.trigger('chatBoxInitialized', this, { synchronous: true });
        this.initialized.resolve();
    }

    /**
     * @param {string} jid
     */
    async setPresence(jid) {
        await shared_api.waitUntil('presencesInitialized');
        const { presences } = shared_converse.state;
        this.presence = presences.get(jid) || presences.create({ jid });
        this.presence.on('change:show', (item) => this.onPresenceChanged(item));
    }

    /**
     * @param {MessageAttributes|StanzaParseError} attrs_or_error
     */
    async onMessage(attrs_or_error) {
        if (model_u.isErrorObject(attrs_or_error)) {
            const { stanza, message } = /** @type {StanzaParseError} */ (attrs_or_error);
            if (stanza) src_log.error(stanza);
            return src_log.error(message);
        }

        const attrs = /** @type {MessageAttributes} */ (attrs_or_error);
        const message = await this.getDuplicateMessage(attrs);
        if (message) {
            await this.updateMessage(message, attrs);
        } else if (
            !this.handleReceipt(attrs) &&
            !this.handleChatMarker(attrs) &&
            !(await this.handleRetraction(attrs))
        ) {
            this.setEditable(attrs, attrs.time);

            if (attrs['chat_state'] && attrs.sender === 'them') {
                this.notifications.set('chat_state', attrs.chat_state);
            }
            /**
             * *Hook* which allows plugins to intercept an incoming message stanza
             * before it is stored as a new message. Plugins can consume the stanza
             * entirely (e.g. to store it as a specialised placeholder) by returning
             * `{ handled: true }`, which prevents normal message creation.
             * @event _converse#beforeMessageCreated
             * @param {ChatBox} context - The chatbox for which the message was received.
             * @param {MessageAttributes} attrs - Parsed message attributes.
             * @param {{ handled: boolean }} data - Pass `{ handled: true }` to signal
             *   that the stanza has been fully handled and should not be processed further.
             * @example
             *   api.listen.on('beforeMessageCreated', (chatbox, attrs, data) => {
             *       if (attrs.my_custom_field) {
             *           // Handle it ourselves and stop normal processing
             *           return { ...data, handled: true };
             *       }
             *       return data;
             *   });
             */
            const { handled } = await shared_api.hook('beforeMessageCreated', this, attrs, { handled: false });
            if (handled) return;

            if (model_u.shouldCreateMessage(attrs)) {
                const msg = (await this.handleCorrection(attrs)) || (await this.createMessage(attrs));
                /**
                 * *Hook* which is fired after a new message model has been created
                 * and persisted. Plugins can use this to reconcile any state that
                 * was stored in anticipation of this message (e.g. dangling reactions
                 * or retractions that arrived before the original message).
                 * @event _converse#afterMessageCreated
                 * @param {ChatBox} context - The chatbox the message belongs to.
                 * @param {Message} data - The newly created message model.
                 * @example
                 *   api.listen.on('afterMessageCreated', (chatbox, message) => {
                 *       // e.g. apply any stored dangling reactions to this message
                 *   });
                 */
                if (msg) await shared_api.hook('afterMessageCreated', this, msg);
                this.notifications.set({ 'chat_state': null });
                this.handleUnreadMessage(msg);
            }
        }
    }

    /**
     * @param {import('../roster/presence').default} item
     */
    onPresenceChanged(item) {
        const { __ } = shared_converse;
        const show = item.get('show');
        const fullname = this.getDisplayName();
        let text;
        if (show === 'offline') {
            text = __('%1$s has gone offline', fullname);
        } else if (show === 'away') {
            text = __('%1$s has gone away', fullname);
        } else if (show === 'dnd') {
            text = __('%1$s is busy', fullname);
        } else if (show === 'online') {
            text = __('%1$s is online', fullname);
        }
        text && this.createMessage({ message: text, type: 'info', is_ephemeral: true });
    }

    async close() {
        if (shared_api.connection.connected()) {
            // Immediately sending the chat state, because the
            // model is going to be destroyed afterwards.
            this.setChatState(INACTIVE);
            sendChatState(this.get('jid'), this.get('chat_state'));
        }
        await super.close();
    }

    /**
     * @returns {string|null}
     */
    getDisplayName() {
        if (this.contact) {
            const display_name = this.contact.getDisplayName({ no_jid: true });
            if (display_name) return display_name;
        }

        if (this.vcard) {
            return this.vcard.getDisplayName();
        } else {
            return this.get('jid');
        }
    }

    /**
     * @param {string} jid1
     * @param {string} jid2
     */
    isSameUser(jid1, jid2) {
        return model_u.isSameBareJID(jid1, jid2);
    }

    /**
     * @param {MessageAttributes} attrs
     */
    handleChatMarker(attrs) {
        const to_bare_jid = chat_model_Strophe.getBareJidFromJid(attrs.to);
        if (to_bare_jid !== shared_converse.session.get('bare_jid')) {
            return false;
        }

        if (attrs.is_markable) {
            if (
                this.contact &&
                !['none', 'to', undefined].includes(this.contact.get('subscription')) &&
                !attrs.is_archived &&
                !attrs.is_carbon
            ) {
                sendMarker(attrs.from, attrs.msgid, 'received');
            }
            return false;
        } else if (attrs.marker_id) {
            const message = this.messages.findWhere({ 'msgid': attrs.marker_id });
            const field_name = `marker_${attrs.marker}`;
            if (message && !message.get(field_name)) {
                message.save({ field_name: new Date().toISOString() });
            }
            return true;
        }
    }

    /**
     * @param {MessageAttributes} [attrs]
     * @return {Promise<MessageAttributes>}
     */
    async getOutgoingMessageAttributes(attrs) {
        const is_spoiler = !!this.get('composing_spoiler');
        const origin_id = model_u.getUniqueId();
        const text = attrs?.body;
        const body = text ? model_u.emojis.shortnamesToUnicode(text) : undefined;

        // Get reply attributes from chatbox model if replying to a message
        const reply_to_id = this.get('reply_to_id');
        const reply_to = this.get('reply_to');

        attrs = Object.assign(
            {},
            attrs,
            {
                body,
                from: shared_converse.session.get('jid'),
                fullname: shared_converse.state.profile.get('fullname'),
                id: origin_id,
                is_spoiler,
                jid: this.get('jid'),
                message: body,
                msgid: origin_id,
                nick: this.get('nickname'),
                origin_id,
                reply_to_id,
                reply_to,
                sender: 'me',
                time: new Date().toISOString(),
                type: this.get('message_type'),
            },
            await model_u.getMediaURLsMetadata(text),
        );

        // Clear reply state after capturing it
        if (reply_to_id) {
            this.save({ reply_to_id: undefined, reply_to: undefined });
        }

        /**
         * *Hook* which allows plugins to update the attributes of an outgoing message.
         * These attributes get set on the {@link Message} or
         * {@link MUCMessage} and persisted to storage.
         * @event _converse#getOutgoingMessageAttributes
         * @param {ChatBox|MUC} chat
         *      The chat from which this message will be sent.
         * @param {MessageAttributes} attrs
         *      The message attributes, from which the stanza will be created.
         */
        attrs = await shared_api.hook('getOutgoingMessageAttributes', this, attrs);
        return attrs;
    }

    canPostMessages() {
        return true;
    }

    /**
     * @param {import('../../shared/message').default} message
     */
    isChatMessage(message) {
        const type = message.get('type');
        return type === this.get('message_type') || type === 'normal';
    }
}

/* export default */ const chat_model = (model_ChatBox);

;// CONCATENATED MODULE: ./src/headless/plugins/chat/message.js






/**
 * Represents a (non-MUC) message.
 * These can be either `chat`, `normal` or `headline` messages.
 * @namespace _converse.Message
 * @memberOf _converse
 * @example const msg = new Message({'message': 'hello world!'});
 */
class Message extends shared_message {

    async initialize () {
        super.initialize();

        this.initialized = getOpenPromise();

        // If `type` changes from `error` to `chat`, we want to set the contact. See #2733
        this.on('change:type', () => this.setContact());
        await this.setContact();

        /**
         * Triggered once a {@link Message} has been created and initialized.
         * @event _converse#messageInitialized
         * @type {Message}
         * @example _converse.api.listen.on('messageInitialized', model => { ... });
         */
        await shared_api.trigger('messageInitialized', this, { synchronous: true });
        this.initialized.resolve();
    }

    setContact () {
        if (['chat', 'normal'].includes(this.get('type'))) {
            return this.setModelContact(Strophe.getBareJidFromJid(this.get('from')));
        }
    }

    getDisplayName () {
        if (this.contact) {
            return this.contact.getDisplayName();
        } else if (this.vcard) {
            return this.vcard.getDisplayName();
        } else {
            return this.get('from');
        }
    }
}

/* export default */ const chat_message = (Message);

;// CONCATENATED MODULE: ./src/headless/plugins/chat/messages.js



/**
 * @extends {Collection<Message>}
 */
class Messages extends skeletor.Collection {

    constructor () {
        super();
        this.comparator = 'time';
        this.model = chat_message;
        this.fetched = null;
        this.chatbox = null;
    }
}

/* export default */ const chat_messages = (Messages);

;// CONCATENATED MODULE: ./src/headless/plugins/chat/api.js
/**
 * @typedef {import('./model.js').default} ChatBox
 */






/* export default */ const chat_api = ({
    /**
     * The "chats" namespace (used for one-on-one chats)
     *
     * @namespace api.chats
     * @memberOf api
     */
    chats: {
        /**
         * @method api.chats.create
         * @param {string|string[]} jids An jid or array of jids
         * @param {object} [attrs] An object containing configuration attributes.
         * @returns {Promise<ChatBox|ChatBox[]>}
         */
        async create (jids, attrs) {
            if (typeof jids === 'string') {
                if (attrs && !attrs?.fullname) {
                    const contact = await shared_api.contacts.get(jids);
                    attrs.fullname = contact?.attributes?.fullname;
                }
                const chatbox = shared_api.chats.get(jids, attrs, true);
                if (!chatbox) {
                    src_log.error("Could not open chatbox for JID: "+jids);
                    return;
                }
                return chatbox;
            }
            if (Array.isArray(jids)) {
                return Promise.all(jids.map(async jid => {
                    const contact = await shared_api.contacts.get(jids);
                    attrs.fullname = contact?.attributes?.fullname;
                    return shared_api.chats.get(jid, attrs, true).maybeShow();
                }));
            }
            src_log.error("chats.create: You need to provide at least one JID");
            return null;
        },

        /**
         * Opens a new one-on-one chat.
         *
         * @method api.chats.open
         * @param {String|string[]} jids - e.g. 'buddy@example.com' or ['buddy1@example.com', 'buddy2@example.com']
         * @param {Object} [attrs] - Attributes to be set on the _converse.ChatBox model.
         * @param {Boolean} [attrs.minimized] - Should the chat be created in minimized state.
         * @param {Boolean} [force=false] - By default, a minimized
         *   chat won't be maximized (in `overlayed` view mode) and in
         *   `fullscreen` view mode a newly opened chat won't replace
         *   another chat already in the foreground.
         *   Set `force` to `true` if you want to force the chat to be
         *   maximized or shown.
         * @returns {Promise} Promise which resolves with the
         *   _converse.ChatBox representing the chat.
         *
         * @example
         * // To open a single chat, provide the JID of the contact you're chatting with in that chat:
         * converse.plugins.add('myplugin', {
         *     initialize: function() {
         *         const _converse = this._converse;
         *         // Note, buddy@example.org must be in your contacts roster!
         *         api.chats.open('buddy@example.com').then(chat => {
         *             // Now you can do something with the chat model
         *         });
         *     }
         * });
         *
         * @example
         * // To open an array of chats, provide an array of JIDs:
         * converse.plugins.add('myplugin', {
         *     initialize: function () {
         *         const _converse = this._converse;
         *         // Note, these users must first be in your contacts roster!
         *         api.chats.open(['buddy1@example.com', 'buddy2@example.com']).then(chats => {
         *             // Now you can do something with the chat models
         *         });
         *     }
         * });
         */
        async open (jids, attrs, force) {
            if (typeof jids === 'string') {
                const chat = await shared_api.chats.get(jids, attrs, true);
                if (chat) {
                    return chat.maybeShow(force);
                }
                return chat;
            } else if (Array.isArray(jids)) {
                return Promise.all(
                    jids.map(j => shared_api.chats.get(j, attrs, true).then(c => c && c.maybeShow(force)))
                        .filter(c => c)
                );
            }
            const err_msg = "chats.open: You need to provide at least one JID";
            src_log.error(err_msg);
            throw new Error(err_msg);
        },

        /**
         * Retrieves a chat or all chats.
         *
         * @method api.chats.get
         * @param {String|string[]} jids - e.g. 'buddy@example.com' or ['buddy1@example.com', 'buddy2@example.com']
         * @param {Object} [attrs] - Attributes to be set on the _converse.ChatBox model.
         * @param {Boolean} [create=false] - Whether the chat should be created if it's not found.
         * @returns {Promise<ChatBox[]>}
         *
         * @example
         * // To return a single chat, provide the JID of the contact you're chatting with in that chat:
         * const model = await api.chats.get('buddy@example.com');
         *
         * @example
         * // To return an array of chats, provide an array of JIDs:
         * const models = await api.chats.get(['buddy1@example.com', 'buddy2@example.com']);
         *
         * @example
         * // To return all open chats, call the method without any parameters::
         * const models = await api.chats.get();
         *
         */
        async get (jids, attrs={}, create=false) {
            await shared_api.waitUntil('chatBoxesFetched');

            /** @param {string} jid */
            async function _get (jid) {
                let model = await shared_api.chatboxes.get(jid);
                if (!model && create) {
                    model = await shared_api.chatboxes.create(jid, attrs, shared_converse.exports.ChatBox);
                } else {
                    model = (model && model.get('type') === PRIVATE_CHAT_TYPE) ? model : null;
                    if (model && Object.keys(attrs).length) {
                        model.save(attrs);
                    }
                }
                return model;
            }
            if (jids === undefined) {
                const chats = await shared_api.chatboxes.get();
                return chats?.filter(c => (c.get('type') === PRIVATE_CHAT_TYPE)) ?? [];
            } else if (typeof jids === 'string') {
                return _get(jids);
            }
            return Promise.all(jids.map(jid => _get(jid)));
        }
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/chat/plugin.js











const { Strophe: chat_plugin_Strophe } = api_public.env;


api_public.plugins.add('converse-chat', {
    dependencies: ['converse-chatboxes', 'converse-disco'],

    initialize () {
        // Configuration values for this plugin
        // ====================================
        // Refer to docs/source/configuration.rst for explanations of these
        // configuration settings.
        shared_api.settings.extend({
            'allow_message_corrections': 'all',
            'allow_message_retraction': 'all',
            'allow_message_styling': true,
            'auto_join_private_chats': [],
            'clear_messages_on_reconnection': false,
            'filter_by_resource': false,
            'prune_messages_above': undefined,
            'pruning_behavior': 'unscrolled',
            'send_chat_markers': ['received', 'displayed', 'acknowledged'],
            'send_chat_state_notifications': true,
        });

        const exports = { ChatBox: chat_model, Message: chat_message, Messages: chat_messages, handleMessageStanza: handleMessageStanza };
        Object.assign(shared_converse, exports); // TODO: DEPRECATED
        Object.assign(shared_converse.exports, exports);

        Object.assign(shared_api, chat_api);

        chatboxes_api.registry.add(PRIVATE_CHAT_TYPE, chat_model);

        routeToChat();
        addEventListener('hashchange', routeToChat);

        shared_api.listen.on('chatBoxesFetched', autoJoinChats);
        shared_api.listen.on('presencesInitialized', registerMessageHandlers);

        shared_api.listen.on('connected', () => enableCarbons());
        shared_api.listen.on('reconnected', () => enableCarbons());

        // Advertise XEP-0461 Message Replies support
        shared_api.listen.on('addClientFeatures', () => {
            shared_api.disco.own.features.add(chat_plugin_Strophe.NS.REPLY);
        });
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/chat/index.js







;// CONCATENATED MODULE: ./src/headless/plugins/disco/entity.js










const { Strophe: entity_Strophe, u: entity_u } = api_public.env;

/**
 * @class
 * @namespace _converse.DiscoEntity
 * @memberOf _converse
 *
 * A Disco Entity is a JID addressable entity that can be queried for features.
 *
 * See XEP-0030: https://xmpp.org/extensions/xep-0030.html
 */
class DiscoEntity extends skeletor.Model {
    get idAttribute() {
        return 'jid';
    }

    initialize(_, options) {
        super.initialize();
        this.waitUntilFeaturesDiscovered = getOpenPromise();
        this.waitUntilItemsFetched = getOpenPromise();

        this.dataforms = new skeletor.Collection();
        let id = `converse.dataforms-${this.get('jid')}`;
        this.dataforms.browserStorage = createStore(id, 'session');

        this.features = new skeletor.Collection();
        id = `converse.features-${this.get('jid')}`;
        this.features.browserStorage = createStore(id, 'session');
        this.listenTo(this.features, 'add', this.onFeatureAdded);

        this.fields = new skeletor.Collection();
        id = `converse.fields-${this.get('jid')}`;
        this.fields.browserStorage = createStore(id, 'session');
        this.listenTo(this.fields, 'add', this.onFieldAdded);

        this.items = new skeletor.Collection();
        id = `converse.items-${this.get('jid')}`;
        this.items.browserStorage = createStore(id, 'session');

        this.identities = new skeletor.Collection();
        id = `converse.identities-${this.get('jid')}`;
        this.identities.browserStorage = createStore(id, 'session');

        this.fetchFeatures(options);
    }

    /**
     * Returns a Promise which resolves with a map indicating
     * whether a given identity is provided by this entity.
     * @method _converse.DiscoEntity#getIdentity
     * @param {String} category - The identity category
     * @param {String} type - The identity type
     */
    async getIdentity(category, type) {
        await this.waitUntilItemsFetched;
        return this.identities.findWhere({ category, type });
    }

    /**
     * Returns a Promise which resolves with a map indicating
     * whether a given feature is supported.
     * @method _converse.DiscoEntity#getFeature
     * @param {String} feature - The feature that might be supported.
     */
    async getFeature(feature) {
        await this.waitUntilFeaturesDiscovered;
        if (this.features.findWhere({ var: feature })) {
            return this;
        }
    }

    onFeatureAdded(feature) {
        feature.entity = this;
        /**
         * Triggered when Converse has learned of a service provided by the XMPP server.
         * See XEP-0030.
         * @event _converse#serviceDiscovered
         * @type { Model }
         * @example _converse.api.listen.on('featuresDiscovered', feature => { ... });
         */
        shared_api.trigger('serviceDiscovered', feature);
    }

    onFieldAdded(field) {
        field.entity = this;
        /**
         * Triggered when Converse has learned of a disco extension field.
         * See XEP-0030.
         * @event _converse#discoExtensionFieldDiscovered
         * @example _converse.api.listen.on('discoExtensionFieldDiscovered', () => { ... });
         */
        shared_api.trigger('discoExtensionFieldDiscovered', field);
    }

    /**
     * @param {import('./types').FetchEntityFeaturesOptions} options
     */
    async fetchFeatures(options) {
        if (options.ignore_cache) {
            await this.queryInfo(options);
        } else {
            const store_id = this.features.browserStorage.name;

            // Checking only whether features have been cached, even though
            // there are other things that should be cached as well. We assume
            // that if features have been cached, everything else has been also.
            const result = await this.features.browserStorage.store.getItem(store_id);
            if ((result && result.length === 0) || result === null) {
                await this.queryInfo();
            } else {
                await new Promise((resolve) => this.fetch({ success: resolve, error: resolve }));

                await new Promise((resolve) =>
                    this.features.fetch({
                        add: true,
                        success: () => {
                            this.waitUntilFeaturesDiscovered.resolve(this);
                            this.trigger('featuresDiscovered');
                            resolve();
                        },
                        error: resolve,
                    })
                );

                await new Promise((resolve) => this.identities.fetch({ add: true, success: resolve, error: resolve }));

                const items = this.get('items');
                if (Array.isArray(items)) {
                    await Promise.all(
                        items.map(/** @param {string} jid */ async (jid) => await shared_api.disco.entities.get(jid, true))
                    );
                } else {
                    await this.queryForItems();
                }
                this.waitUntilItemsFetched.resolve();
            }
        }
    }

    /**
     * @param {import('./types').DiscoInfoOptions} [options]
     */
    async queryInfo(options) {
        let stanza;
        try {
            stanza = await shared_api.disco.info(this.get('jid'), null, options);
        } catch (iq) {
            if (entity_u.isElement(iq)) {
                const e = await parseErrorStanza(iq);
                if (e.message !== 'item-not-found') {
                    src_log.error(`Error querying disco#info for ${this.get('jid')}: ${e.message}`);
                }
                this.save({ error: e.message });
                this.waitUntilFeaturesDiscovered.resolve(e);
                this.waitUntilItemsFetched.resolve(e);
            } else {
                if (iq === null) {
                    src_log.error(`Timeout for disco#info query for ${this.get('jid')}`);
                } else {
                    src_log.error(`Error querying disco#info for ${this.get('jid')}: ${iq}`);
                }
                this.waitUntilFeaturesDiscovered.resolve(iq);
                this.waitUntilItemsFetched.resolve(iq);
            }
            return;
        }
        this.onInfo(stanza);
    }

    /**
     * @param {Element} stanza
     */
    onDiscoItems(stanza) {
        const item_els = sizzle_default()(`query[xmlns="${entity_Strophe.NS.DISCO_ITEMS}"] item`, stanza);
        const item_jids = [];
        item_els.forEach((item) => {
            if (item.getAttribute('node')) {
                // XXX: Ignore nodes for now.
                // See: https://xmpp.org/extensions/xep-0030.html#items-nodes
                return;
            }
            const jid = item.getAttribute('jid');
            let entity = shared_converse.state.disco_entities.get(jid);
            if (entity) {
                const parent_jids = entity.get('parent_jids') || [];
                entity.set({ parent_jids: [...parent_jids, this.get('jid')] });
            } else {
                entity = shared_api.disco.entities.create({
                    jid,
                    parent_jids: [this.get('jid')],
                    name: item.getAttribute('name'),
                });
            }
            item_jids.push(entity.get('jid'));
        });
        this.save({ items: item_jids });
    }

    async queryForItems() {
        if (this.identities.where({ category: 'server' }).length === 0) {
            // Don't fetch features and items if this is not a
            // server or a conference component.
            return;
        }
        const stanza = await shared_api.disco.items(this.get('jid'));
        this.onDiscoItems(stanza);
    }

    /**
     * @param {Element} stanza
     */
    async onInfo(stanza) {
        Array.from(stanza.querySelectorAll('identity')).forEach((identity) => {
            this.identities.create({
                category: identity.getAttribute('category'),
                type: identity.getAttribute('type'),
                name: identity.getAttribute('name'),
            });
        });

        sizzle_default()(`x[type="result"][xmlns="${entity_Strophe.NS.XFORM}"]`, stanza).forEach((form) => {
            const data = {};
            sizzle_default()('field', form).forEach((field) => {
                data[field.getAttribute('var')] = {
                    'value': field.querySelector('value')?.textContent,
                    'type': field.getAttribute('type'),
                };
            });
            this.dataforms.create(data);
        });

        if (stanza.querySelector(`feature[var="${entity_Strophe.NS.DISCO_ITEMS}"]`)) {
            await this.queryForItems();
        }
        this.waitUntilItemsFetched.resolve();

        Array.from(stanza.querySelectorAll('feature')).forEach((feature) => {
            this.features.create({
                'var': feature.getAttribute('var'),
                'from': stanza.getAttribute('from'),
            });
        });

        // XEP-0128 Service Discovery Extensions
        sizzle_default()('x[type="result"][xmlns="jabber:x:data"] field', stanza).forEach((field) => {
            this.fields.create({
                'var': field.getAttribute('var'),
                'value': field.querySelector('value')?.textContent,
                'from': stanza.getAttribute('from'),
            });
        });

        this.waitUntilFeaturesDiscovered.resolve(this);
        this.trigger('featuresDiscovered');
    }
}

/* export default */ const plugins_disco_entity = (DiscoEntity);

;// CONCATENATED MODULE: ./src/headless/plugins/disco/entities.js




/**
 * @extends {Collection<DiscoEntity>}
 */
class DiscoEntities extends skeletor.Collection {

    constructor () {
        super();
        this.model = plugins_disco_entity;
    }

    fetchEntities () {
        return new Promise((resolve, reject) => {
            this.fetch({
                add: true,
                success: resolve,
                error (_m, e) {
                    src_log.error(e);
                    reject (new Error("Could not fetch disco entities"));
                }
            });
        });
    }
}

/* export default */ const entities = (DiscoEntities);

;// CONCATENATED MODULE: ./src/headless/plugins/disco/api.js






const { Stanza: api_Stanza, Strophe: api_Strophe, stx: api_stx } = api_public.env;

/* export default */ const disco_api = ({
    /**
     * @typedef {import('./entities').default} DiscoEntities
     * @typedef {import('./entity').default} DiscoEntity
     * @typedef {import('./index').DiscoState} DiscoState
     * @typedef {import('@converse/skeletor').Collection} Collection
     */

    /**
     * The XEP-0030 service discovery API
     *
     * This API lets you discover information about entities on the
     * XMPP network.
     *
     * @namespace api.disco
     * @memberOf api
     */
    disco: {
        /**
         * @namespace api.disco.stream
         * @memberOf api.disco
         */
        stream: {
            /**
             * @method api.disco.stream.getFeature
             * @param {String} name The feature name
             * @param {String} xmlns The XML namespace
             * @example _converse.api.disco.stream.getFeature('ver', 'urn:xmpp:features:rosterver')
             */
            async getFeature(name, xmlns) {
                await shared_api.waitUntil('streamFeaturesAdded');

                const stream_features = /** @type {Collection} */ (shared_converse.state.stream_features);
                if (!name || !xmlns) {
                    throw new Error('name and xmlns need to be provided when calling disco.stream.getFeature');
                }
                if (stream_features === undefined && !shared_api.connection.connected()) {
                    // Happens during tests when disco lookups happen asynchronously after teardown.
                    const msg = `Tried to get feature ${name} ${xmlns} but stream_features has been torn down`;
                    src_log.warn(msg);
                    return;
                }
                return stream_features.findWhere({ name, xmlns });
            },
        },

        /**
         * @namespace api.disco.own
         * @memberOf api.disco
         */
        own: {
            /**
             * @namespace api.disco.own.identities
             * @memberOf api.disco.own
             */
            identities: {
                /**
                 * Lets you add new identities for this client (i.e. instance of Converse)
                 * @method api.disco.own.identities.add
                 *
                 * @param {String} category - server, client, gateway, directory, etc.
                 * @param {String} type - phone, pc, web, etc.
                 * @param {String} name - "Converse"
                 * @param {String} lang - en, el, de, etc.
                 *
                 * @example _converse.api.disco.own.identities.clear();
                 */
                add(category, type, name, lang) {
                    const disco = /** @type {DiscoState} */ (shared_converse.state.disco);
                    for (var i = 0; i < disco._identities.length; i++) {
                        if (
                            disco._identities[i].category == category &&
                            disco._identities[i].type == type &&
                            disco._identities[i].name == name &&
                            disco._identities[i].lang == lang
                        ) {
                            return false;
                        }
                    }
                    disco._identities.push({ category: category, type: type, name: name, lang: lang });
                },
                /**
                 * Clears all previously registered identities.
                 * @method api.disco.own.identities.clear
                 * @example _converse.api.disco.own.identities.clear();
                 */
                clear() {
                    /** @type {DiscoState} */ shared_converse.state.disco._identities = [];
                },
                /**
                 * Returns all of the identities registered for this client
                 * (i.e. instance of Converse).
                 * @method api.disco.identities.get
                 * @example const identities = api.disco.own.identities.get();
                 */
                get() {
                    return /** @type {DiscoState} */ shared_converse.state.disco._identities;
                },
            },

            /**
             * @namespace api.disco.own.features
             * @memberOf api.disco.own
             */
            features: {
                /**
                 * Lets you register new disco features for this client (i.e. instance of Converse)
                 * @method api.disco.own.features.add
                 * @param {String} name - e.g. http://jabber.org/protocol/caps
                 * @example _converse.api.disco.own.features.add("http://jabber.org/protocol/caps");
                 */
                add(name) {
                    const disco = /** @type {DiscoState} */ (shared_converse.state.disco);
                    for (let i = 0; i < disco._features.length; i++) {
                        if (disco._features[i] == name) {
                            return false;
                        }
                    }
                    disco._features.push(name);
                },
                /**
                 * Clears all previously registered features.
                 * @method api.disco.own.features.clear
                 * @example _converse.api.disco.own.features.clear();
                 */
                clear() {
                    const disco = /** @type {DiscoState} */ (shared_converse.state.disco);
                    disco._features = [];
                },
                /**
                 * Returns all of the features registered for this client (i.e. instance of Converse).
                 * @method api.disco.own.features.get
                 * @example const features = api.disco.own.features.get();
                 */
                get() {
                    return /** @type {DiscoState} */ shared_converse.state.disco._features;
                },
            },
        },

        /**
         * Query for information about an XMPP entity
         *
         * @method api.disco.info
         * @param {string} jid The Jabber ID of the entity to query
         * @param {string} [node] A specific node identifier associated with the JID
         * @param {import('./types').DiscoInfoOptions} [options]
         * @returns {promise} Promise which resolves once we have a result from the server.
         */
        info(jid, node, options) {
            const info = api_stx`
                <iq from="${shared_api.connection.get().jid}"
                    to="${jid}"
                    type="get"
                    xmlns="jabber:client">
                    <query xmlns="${api_Strophe.NS.DISCO_INFO}"
                           ${node ? api_Stanza.unsafeXML(`node="${node}"`) : ''}>
                    </query>
                </iq>`;
            return shared_api.sendIQ(info, options?.timeout);
        },

        /**
         * Query for items associated with an XMPP entity
         *
         * @method api.disco.items
         * @param {string} jid The Jabber ID of the entity to query for items
         * @param {string} [node] A specific node identifier associated with the JID
         * @returns {promise} Promise which resolves once we have a result from the server.
         */
        items(jid, node) {
            return shared_api.sendIQ(
                api_stx`
                    <iq from="${shared_api.connection.get().jid}"
                        to="${jid}"
                        type="get"
                        xmlns="jabber:client">
                        <query xmlns="${api_Strophe.NS.DISCO_ITEMS}"
                               ${node ? api_Stanza.unsafeXML(`node="${node}"`) : ''}>
                        </query>
                    </iq>`
            );
        },

        /**
         * Namespace for methods associated with disco entities
         *
         * @namespace api.disco.entities
         * @memberOf api.disco
         */
        entities: {
            /**
             * Finds the first entity advertising a given feature.
             *
             * @method api.disco.entities.find
             * @param {string} feature The feature var to search for.
             * @param {string} [jid] The entity JID whose subtree to search. If omitted, own bare JID and domain are queried.
             * @returns {Promise<DiscoEntity[]>} An array of matching DiscoEntity instances.
             */
            async find(feature, jid) {
                await shared_api.waitUntil('discoInitialized');
                const disco_entities = /** @type {DiscoEntities} */ (shared_converse.state.disco_entities);
                if (!disco_entities) return [];

                const candidates = [];
                if (jid) {
                    const entity = await shared_api.disco.entities.get(jid, true);
                    if (entity) {
                        const items = await shared_api.disco.entities.items(jid);
                        candidates.push(entity, ...items);
                    }
                } else {
                    const bare_jid = shared_converse.session.get('bare_jid');
                    const bare_entity = await shared_api.disco.entities.get(bare_jid, true);
                    if (bare_entity) candidates.push(bare_entity);

                    const domain = api_Strophe.getDomainFromJid(bare_jid);
                    const domain_entity = await shared_api.disco.entities.get(domain, true);
                    if (domain_entity) {
                        const items = await shared_api.disco.entities.items(domain);
                        candidates.push(domain_entity, ...items);
                    }
                }

                const unique = Array.from(new Map(candidates.map((e) => [e.get('jid'), e])).values());
                const checks = unique.map(async (entity) => {
                    const has = await entity.getFeature(feature);
                    return has ? entity : null;
                });
                const results = await Promise.all(checks);
                return results.filter((e) => e);
            },

            /**
             * Get the corresponding `DiscoEntity` instance.
             *
             * @method api.disco.entities.get
             * @param {string} jid The Jabber ID of the entity
             * @param {boolean} [create] Whether the entity should be created if it doesn't exist.
             * @return {Promise<DiscoEntity|DiscoEntities|undefined>}
             * @example _converse.api.disco.entities.get(jid);
             */
            async get(jid, create = false) {
                await shared_api.waitUntil('discoInitialized');
                const disco_entities = /** @type {DiscoEntities} */ (shared_converse.state.disco_entities);
                if (!jid) {
                    return disco_entities;
                }
                if (disco_entities === undefined) {
                    // Happens during tests when disco lookups happen asynchronously after teardown.
                    src_log.warn(`Tried to look up entity ${jid} but disco_entities has been torn down`);
                    return;
                }
                const entity = disco_entities.get(jid);
                if (entity || !create) {
                    return /** @type {DiscoEntity} */(entity);
                }
                return shared_api.disco.entities.create({ jid });
            },

            /**
             * Return the disco items advertised on this entity
             *
             * @method api.disco.entities.items
             * @param {string} jid - The Jabber ID of the entity for which we want to fetch items
             * @returns {Promise<DiscoEntity[]>}
             * @example api.disco.entities.items(jid);
             */
            async items(jid) {
                const entity = await shared_api.disco.entities.get(jid);
                if (entity) {
                    await entity.waitUntilItemsFetched;

                    const item_jids = entity.get('items') || [];
                    return Promise.all(item_jids.map(/** @param {string} jid */ (jid) => shared_api.disco.entities.get(jid)));
                }
                return [];
            },

            /**
             * Create a new  disco entity. It's identity and features
             * will automatically be fetched from cache or from the
             * XMPP server.
             *
             * Fetching from cache can be disabled by passing in
             * `ignore_cache: true` in the options parameter.
             *
             * @method api.disco.entities.create
             * @param {object} data
             * @param {string} data.jid - The Jabber ID of the entity
             * @param {string} data.parent_jid - The Jabber ID of the parent entity
             * @param {string} data.name
             * @param {object} [options] - Additional options
             * @param {boolean} [options.ignore_cache]
             *     If true, fetch all features from the XMPP server instead of restoring them from cache
             * @example _converse.api.disco.entities.create({ jid }, {'ignore_cache': true});
             */
            create(data, options) {
                const disco_entities = /** @type {DiscoEntities} */ (shared_converse.state.disco_entities);
                return disco_entities.create(data, options);
            },
        },

        /**
         * @namespace api.disco.features
         * @memberOf api.disco
         */
        features: {
            /**
             * Return a given feature of a disco entity
             *
             * @method api.disco.features.get
             * @param {string} feature The feature that might be
             *     supported. In the XML stanza, this is the `var`
             *     attribute of the `<feature>` element. For
             *     example: `http://jabber.org/protocol/muc`
             * @param {string} jid The JID of the entity
             *     (and its associated items) which should be queried
             * @returns {Promise<import('@converse/skeletor').Model|import('@converse/skeletor').Model[]>}
             *     A promise which resolves with a list containing
             *     _converse.Entity instances representing the entity
             *     itself or those items associated with the entity if
             *     they support the given feature.
             * @example
             * api.disco.features.get(Strophe.NS.MAM, _converse.bare_jid);
             */
            async get(feature, jid) {
                if (!jid) throw new TypeError('api.disco.features.get: You need to provide an entity JID');

                const entity = await shared_api.disco.entities.get(jid, true);

                if (shared_converse.state.disco_entities === undefined && !shared_api.connection.connected()) {
                    // Happens during tests when disco lookups happen asynchronously after teardown.
                    src_log.warn(
                        `Tried to get feature ${feature} for ${jid} but ` +
                            `_converse.disco_entities has been torn down`
                    );
                    return [];
                }

                const items = await shared_api.disco.entities.items(jid);
                const promises = [entity.getFeature(feature), ...items.map((i) => i.getFeature(feature))];
                const result = await Promise.all(promises);
                return result.filter((f) => f instanceof Object);
            },

            /**
             * Returns true if an entity with the given JID, or if one of its
             * associated items, supports a given feature.
             *
             * @method api.disco.features.has
             * @param {string} feature The feature that might be
             *     supported. In the XML stanza, this is the `var`
             *     attribute of the `<feature>` element. For
             *     example: `http://jabber.org/protocol/muc`
             * @param {string} jid The JID of the entity
             *     (and its associated items) which should be queried
             * @returns {Promise<boolean>} A promise which resolves with a boolean
             * @example
             *      api.disco.features.has(Strophe.NS.MAM, _converse.bare_jid);
             */
            async has(feature, jid) {
                if (!jid) throw new TypeError('api.disco.feature.has: You need to provide an entity JID');

                const entity = await shared_api.disco.entities.get(jid, true);
                if (!entity) {
                    src_log.warn(`api.disco.has: could not get entity for ${jid}`);
                    return false;
                }

                if (shared_converse.state.disco_entities === undefined && !shared_api.connection.connected()) {
                    // Happens during tests when disco lookups happen asynchronously after teardown.
                    src_log.warn(`Tried to check if ${jid} supports feature ${feature}`);
                    return false;
                }

                if (await entity.getFeature(feature)) {
                    return true;
                }

                const items = await shared_api.disco.entities.items(jid);
                const result = await Promise.all(items.map((i) => i.getFeature(feature)));
                return result.map((f) => f instanceof Object).includes(true);
            },
        },

        /**
         * Used to determine whether an entity supports a given feature.
         *
         * @method api.disco.supports
         * @param {string} feature The feature that might be
         *     supported. In the XML stanza, this is the `var`
         *     attribute of the `<feature>` element. For
         *     example: `http://jabber.org/protocol/muc`
         * @param {string} jid The JID of the entity
         *     (and its associated items) which should be queried
         * @returns {Promise<boolean>|boolean} A promise which resolves with `true` or `false`.
         * @example
         * if (await api.disco.supports(Strophe.NS.MAM, _converse.bare_jid)) {
         *     // The feature is supported
         * } else {
         *     // The feature is not supported
         * }
         */
        supports(feature, jid) {
            try {
                return shared_api.disco.features.has(feature, jid);
            } catch (e) {
                src_log.error(e);
                return false;
            }
        },

        /**
         * Refresh the features, fields and identities associated with a
         * disco entity by refetching them from the server
         * @method api.disco.refresh
         * @param {string} jid The JID of the entity whose features are refreshed.
         * @param {import('./types').DiscoInfoOptions} [options]
         * @returns {Promise} A promise which resolves once the features have been refreshed
         * @example
         * await api.disco.refresh('room@conference.example.org');
         */
        async refresh(jid, options) {
            if (!jid) throw new TypeError('api.disco.refresh: You need to provide an entity JID');

            await shared_api.waitUntil('discoInitialized');
            let entity = await shared_api.disco.entities.get(jid);
            if (entity) {
                entity.features.reset();
                entity.fields.reset();
                entity.identities.reset();
                if (!entity.waitUntilFeaturesDiscovered.isPending) {
                    entity.waitUntilFeaturesDiscovered = getOpenPromise();
                }
                if (!entity.waitUntilItemsFetched.isPending) {
                    entity.waitUntilItemsFetched = getOpenPromise();
                }
                entity.queryInfo(options);
            } else {
                // Create it if it doesn't exist
                entity = await shared_api.disco.entities.create({ jid }, { ignore_cache: true, timeout: options.timeout });
            }
            return entity.waitUntilItemsFetched;
        },

        /**
         * Return all the features associated with a disco entity
         *
         * @method api.disco.getFeatures
         * @param { string } jid The JID of the entity whose features are returned.
         * @returns {promise} A promise which resolves with the returned features
         * @example
         * const features = await api.disco.getFeatures('room@conference.example.org');
         */
        async getFeatures(jid) {
            if (!jid) throw new TypeError('api.disco.getFeatures: You need to provide an entity JID');

            await shared_api.waitUntil('discoInitialized');
            let entity = await shared_api.disco.entities.get(jid, true);
            entity = await entity.waitUntilFeaturesDiscovered;
            return entity.features;
        },

        /**
         * Return all the service discovery extensions fields
         * associated with an entity.
         *
         * See [XEP-0129: Service Discovery Extensions](https://xmpp.org/extensions/xep-0128.html)
         *
         * @method api.disco.getFields
         * @param { string } jid The JID of the entity whose fields are returned.
         * @example
         * const fields = await api.disco.getFields('room@conference.example.org');
         */
        async getFields(jid) {
            if (!jid) throw new TypeError('api.disco.getFields: You need to provide an entity JID');

            await shared_api.waitUntil('discoInitialized');
            let entity = await shared_api.disco.entities.get(jid, true);
            entity = await entity.waitUntilFeaturesDiscovered;
            return entity.fields;
        },

        /**
         * Get the identity (with the given category and type) for a given disco entity.
         *
         * For example, when determining support for PEP (personal eventing protocol), you
         * want to know whether the user's own JID has an identity with
         * `category='pubsub'` and `type='pep'` as explained in this section of
         * XEP-0163: https://xmpp.org/extensions/xep-0163.html#support
         *
         * @method api.disco.getIdentity
         * @param {string} category -The identity category.
         *     In the XML stanza, this is the `category`
         *     attribute of the `<identity>` element.
         *     For example: 'pubsub'
         * @param {string} type - The identity type.
         *     In the XML stanza, this is the `type`
         *     attribute of the `<identity>` element.
         *     For example: 'pep'
         * @param {string} jid - The JID of the entity which might have the identity
         * @returns {promise} A promise which resolves with a map indicating
         *     whether an identity with a given type is provided by the entity.
         * @example
         * api.disco.getIdentity('pubsub', 'pep', _converse.bare_jid).then(
         *     function (identity) {
         *         if (identity) {
         *             // The entity DOES have this identity
         *         } else {
         *             // The entity DOES NOT have this identity
         *         }
         *     }
         * ).catch(e => log.error(e));
         */
        async getIdentity(category, type, jid) {
            const e = await shared_api.disco.entities.get(jid, true);
            if (e === undefined && !shared_api.connection.connected()) {
                // Happens during tests when disco lookups happen asynchronously after teardown.
                const msg =
                    `Tried to look up category ${category} for ${jid} ` +
                    `but _converse.disco_entities has been torn down`;
                src_log.warn(msg);
                return;
            }
            return e.getIdentity(category, type);
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/disco/utils.js






const { Strophe: disco_utils_Strophe, Stanza: disco_utils_Stanza, stx: disco_utils_stx } = api_public.env;

/**
 * @param {Element} stanza
 */
function onDiscoInfoRequest(stanza) {
    const node = stanza.getElementsByTagName('query')[0].getAttribute('node');
    const from = stanza.getAttribute('from');
    const id = stanza.getAttribute('id');

    const result = disco_utils_stx`
        <iq type="result"
            id="${id}"
            ${from ? disco_utils_Stanza.unsafeXML(`to="${from}"`) : ''}
            xmlns="jabber:client">
            <query xmlns="${disco_utils_Strophe.NS.DISCO_INFO}"
                   ${node ? disco_utils_Stanza.unsafeXML(`node="${node}"`) : ''}>
                ${shared_converse.state.disco._identities.map((identity) => {
                    return disco_utils_stx`
                        <identity category="${identity.category}"
                            type="${identity.type}"
                            ${identity.name ? disco_utils_Stanza.unsafeXML(`name="${identity.name}"`) : ''}
                            ${identity.lang ? disco_utils_Stanza.unsafeXML(`xml:lang="${identity.lang}"`) : ''}>
                        </identity>`;
                })}
                ${shared_converse.state.disco._features.map((f) => disco_utils_stx`<feature var="${f}"></feature>`)}
            </query>
        </iq>`;
    shared_api.send(result);
    return true;
}

function addClientFeatures() {
    // See https://xmpp.org/registrar/disco-categories.html
    shared_api.disco.own.identities.add('client', 'web', 'Converse');

    shared_api.disco.own.features.add(disco_utils_Strophe.NS.CHATSTATES);
    shared_api.disco.own.features.add(disco_utils_Strophe.NS.DISCO_INFO);
    shared_api.disco.own.features.add(disco_utils_Strophe.NS.ROSTERX); // Limited support
    shared_api.disco.own.features.add(disco_utils_Strophe.NS.CARBONS);
    /**
     * Triggered in converse-disco once the core disco features of
     * Converse have been added.
     * @event _converse#addClientFeatures
     * @example _converse.api.listen.on('addClientFeatures', () => { ... });
     */
    shared_api.trigger('addClientFeatures');
    return this;
}

async function initializeDisco() {
    addClientFeatures();
    shared_api.connection.get()
        .addHandler((stanza) => onDiscoInfoRequest(stanza), disco_utils_Strophe.NS.DISCO_INFO, 'iq', 'get', null, null);

    const disco_entities = new shared_converse.exports.DiscoEntities();

    Object.assign(shared_converse, { disco_entities }); // XXX: DEPRECATED
    Object.assign(shared_converse.state, { disco_entities });

    const bare_jid = shared_converse.session.get('bare_jid');
    const id = `converse.disco-entities-${bare_jid}`;

    disco_entities.browserStorage = createStore(id, 'session');
    const collection = await disco_entities.fetchEntities();

    const domain = shared_converse.session.get('domain');

    if (collection.length === 0 || !collection.get(domain)) {
        // If we don't have an entity for our own XMPP server, create one.
        shared_api.disco.entities.create({ 'jid': domain }, { 'ignore_cache': true });
    }
    /**
     * Triggered once the `converse-disco` plugin has been initialized and the
     * `_converse.disco_entities` collection will be available and populated with at
     * least the service discovery features of the user's own server.
     * @event _converse#discoInitialized
     * @example _converse.api.listen.on('discoInitialized', () => { ... });
     */
    shared_api.trigger('discoInitialized');
}

function initStreamFeatures() {
    // Initialize the stream_features collection, and if we're
    // re-attaching to a pre-existing BOSH session, we restore the
    // features from cache.
    // Otherwise the features will be created once we've received them
    // from the server (see populateStreamFeatures).
    if (!shared_converse.state.stream_features) {
        const bare_jid = shared_converse.session.get('bare_jid');
        const id = `converse.stream-features-${bare_jid}`;
        shared_api.promises.add('streamFeaturesAdded');

        const stream_features = new skeletor.Collection();
        stream_features.browserStorage = createStore(id, 'session');
        Object.assign(shared_converse, { stream_features }); // XXX: DEPRECATED
        Object.assign(shared_converse.state, { stream_features });
    }
}

function notifyStreamFeaturesAdded() {
    /**
     * Triggered as soon as the stream features are known.
     * If you want to check whether a stream feature is supported before proceeding,
     * then you'll first want to wait for this event.
     * @event _converse#streamFeaturesAdded
     * @example _converse.api.listen.on('streamFeaturesAdded', () => { ... });
     */
    shared_api.trigger('streamFeaturesAdded');
}

function populateStreamFeatures() {
    // Strophe.js sets the <stream:features> element on the
    // Strophe.Connection instance.
    //
    // Once this is we populate the stream_features collection
    // and trigger streamFeaturesAdded.
    initStreamFeatures();
    Array.from(shared_api.connection.get().features.childNodes).forEach((feature) => {
        shared_converse.state.stream_features.create({
            'name': feature.nodeName,
            'xmlns': feature.getAttribute('xmlns'),
        });
    });
    notifyStreamFeaturesAdded();
}

function utils_clearSession() {
    const { disco_entities } = shared_converse.state;
    disco_entities?.forEach((e) => e.features.clearStore());
    disco_entities?.forEach((e) => e.identities.clearStore());
    disco_entities?.forEach((e) => e.dataforms.clearStore());
    disco_entities?.forEach((e) => e.fields.clearStore());
    disco_entities?.clearStore();
    delete shared_converse.state.disco_entities;
    Object.assign(shared_converse, { disco_entities: undefined });
}

;// CONCATENATED MODULE: ./src/headless/plugins/disco/index.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description Converse plugin which add support for XEP-0030: Service Discovery
 */








const { Strophe: disco_Strophe } = api_public.env;

/**
 * @typedef {Object} DiscoState
 * @property {Array} _identities
 * @property {Array} _features
 */

api_public.plugins.add('converse-disco', {
    initialize () {
        Object.assign(shared_api, disco_api);

        shared_api.promises.add('discoInitialized');
        shared_api.promises.add('streamFeaturesAdded');

        const exports = { DiscoEntity: plugins_disco_entity, DiscoEntities: entities };

        Object.assign(shared_converse, exports); // XXX: DEPRECATED
        Object.assign(shared_converse.exports, exports);

        const disco = {
            _identities: [],
            _features: []
        };
        Object.assign(shared_converse, { disco }); // XXX: DEPRECATED
        Object.assign(shared_converse.state, { disco });

        shared_api.listen.on('userSessionInitialized', async () => {
            initStreamFeatures();
            if (shared_converse.state.connfeedback.get('connection_status') === disco_Strophe.Status.ATTACHED) {
                // When re-attaching to a BOSH session, we fetch the stream features from the cache.
                await new Promise((success, error) => shared_converse.state.stream_features.fetch({ success, error }));
                notifyStreamFeaturesAdded();
            }
        });
        shared_api.listen.on('beforeResourceBinding', populateStreamFeatures);
        shared_api.listen.on('reconnected', initializeDisco);
        shared_api.listen.on('connected', initializeDisco);

        shared_api.listen.on('beforeTearDown', async () => {
            shared_api.promises.add('streamFeaturesAdded');
            shared_api.promises.add('discoInitialized');

            const { stream_features } = shared_converse.state;
            if (stream_features) {
                await stream_features.clearStore();
                delete shared_converse.state.stream_features;
                Object.assign(shared_converse, { stream_features: undefined }); // XXX: DEPRECATED
            }
        });

        // All disco entities stored in the cache and are refetched
        // upon login or reconnection and then stored with new ids, so to
        // avoid the cache from filling up, we remove them.
        shared_api.listen.on('will-reconnect', utils_clearSession);
        shared_api.listen.on('clearSession', utils_clearSession);
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/muc/affiliations/api.js
/**
 * @module:plugin-muc-affiliations-api
 * @typedef {module:plugin-muc-parsers.MemberListItem} MemberListItem
 */


/* export default */ const affiliations_api = ({
    /**
     * The "affiliations" namespace groups methods relevant to setting and
     * getting MUC affiliations.
     *
     * @namespace api.rooms.affiliations
     * @memberOf api.rooms
     */
    affiliations: {
        /**
         * Set the given affiliation for the given JIDs in the specified MUCs
         * @typedef {Object} User
         * @property {string} User.jid - The JID of the user whose affiliation will change
         * @property {Array} User.affiliation - The new affiliation for this user
         * @property {string} [User.reason] - An optional reason for the affiliation change
         *
         * @param {String|Array<String>} muc_jids - The JIDs of the MUCs in
         *  which the affiliation should be set.
         * @param {User[]} users - An array of objects representing users
         *  for whom the affiliation is to be set.
         * @returns {Promise}
         *
         * @example
         *  api.rooms.affiliations.set(
         *      [
         *          'muc1@muc.example.org',
         *          'muc2@muc.example.org'
         *      ], [
         *          {
         *              'jid': 'user@example.org',
         *              'affiliation': 'member',
         *              'reason': "You're one of us now!"
         *          }
         *      ]
         *  )
         */
        set (muc_jids, users) {
            users = !Array.isArray(users) ? [users] : users;
            muc_jids = !Array.isArray(muc_jids) ? [muc_jids] : muc_jids;
            return setAffiliations(muc_jids, users);
        },

        /**
         * Returns an array of {@link MemberListItem} objects, representing occupants
         * that have the given affiliation.
         * @typedef {("admin"|"owner"|"member")} NonOutcastAffiliation
         * @param {NonOutcastAffiliation} affiliation
         * @param {string} jid - The JID of the MUC for which the affiliation list should be fetched
         * @returns {Promise<MemberListItem[]|Error>}
         */
        get (affiliation, jid) {
            return getAffiliationList(affiliation, jid);
        }
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/muc/plugin.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description Implements the core logic for XEP-0045 Multi-User Chat
 */


















api_public.AFFILIATION_CHANGES = AFFILIATION_CHANGES;
api_public.AFFILIATION_CHANGES_LIST = AFFILIATION_CHANGES_LIST;
api_public.MUC_TRAFFIC_STATES = MUC_TRAFFIC_STATES;
api_public.MUC_TRAFFIC_STATES_LIST = MUC_TRAFFIC_STATES_LIST;
api_public.MUC_ROLE_CHANGES = MUC_ROLE_CHANGES;
api_public.MUC_ROLE_CHANGES_LIST = MUC_ROLE_CHANGES_LIST;

api_public.MUC = { INFO_CODES: INFO_CODES };

api_public.MUC_NICK_CHANGED_CODE = MUC_NICK_CHANGED_CODE;
api_public.ROOM_FEATURES = ROOM_FEATURES;
api_public.ROOMSTATUS = ROOMSTATUS;

const { Strophe: muc_plugin_Strophe } = api_public.env;

// Add Strophe Namespaces
muc_plugin_Strophe.addNamespace('MUC_ADMIN', muc_plugin_Strophe.NS.MUC + '#admin');
muc_plugin_Strophe.addNamespace('MUC_OWNER', muc_plugin_Strophe.NS.MUC + '#owner');
muc_plugin_Strophe.addNamespace('MUC_REGISTER', 'jabber:iq:register');
muc_plugin_Strophe.addNamespace('MUC_ROOMCONF', muc_plugin_Strophe.NS.MUC + '#roomconfig');
muc_plugin_Strophe.addNamespace('MUC_USER', muc_plugin_Strophe.NS.MUC + '#user');
muc_plugin_Strophe.addNamespace('MUC_HATS', 'urn:xmpp:hats:0');
muc_plugin_Strophe.addNamespace('CONFINFO', 'urn:ietf:params:xml:ns:conference-info');

api_public.plugins.add('converse-muc', {
    dependencies: ['converse-chatboxes', 'converse-chat', 'converse-disco'],

    initialize() {
        /* The initialize function gets called as soon as the plugin is
         * loaded by converse.js's plugin machinery.
         */
        const { __, ___ } = shared_converse;

        // Configuration values for this plugin
        // ====================================
        // Refer to docs/source/configuration.rst for explanations of these
        // configuration settings.
        shared_api.settings.extend({
            allow_muc_invitations: true,
            auto_join_on_invite: false,
            auto_join_rooms: [],
            auto_register_muc_nickname: true,
            colorize_username: false,
            hide_muc_participants: false,
            locked_muc_domain: false,
            modtools_disable_assign: false,
            muc_clear_messages_on_leave: true,
            muc_domain: undefined,
            muc_fetch_members: true,
            muc_history_max_stanzas: undefined,
            muc_instant_rooms: true,
            muc_nickname_from_jid: false,
            muc_send_probes: false,
            muc_show_info_messages: [
                ...api_public.MUC.INFO_CODES.visibility_changes,
                ...api_public.MUC.INFO_CODES.self,
                ...api_public.MUC.INFO_CODES.non_privacy_changes,
                ...api_public.MUC.INFO_CODES.muc_logging_changes,
                ...api_public.MUC.INFO_CODES.nickname_changes,
                ...api_public.MUC.INFO_CODES.disconnected,
                ...api_public.MUC.INFO_CODES.affiliation_changes,
                ...api_public.MUC.INFO_CODES.join_leave_events,
                ...api_public.MUC.INFO_CODES.role_changes,
            ],
            muc_show_logs_before_join: false,
            muc_subscribe_to_rai: false,
        });
        shared_api.promises.add(['roomsAutoJoined']);

        if (shared_api.settings.get('locked_muc_domain') && typeof shared_api.settings.get('muc_domain') !== 'string') {
            throw new Error(
                'Config Error: it makes no sense to set locked_muc_domain ' + 'to true when muc_domain is not set',
            );
        }

        // This is for tests (at least until we can import modules inside tests)
        api_public.env.muc_utils = { computeAffiliationsDelta: computeAffiliationsDelta };
        Object.assign(shared_api, muc_api);
        Object.assign(shared_api.rooms, affiliations_api);

        /**
         * https://xmpp.org/extensions/xep-0045.html
         * -----------------------------------------
         */
        const STATUS_CODE_MESSAGES = {
            '100': __('This groupchat is not anonymous'),
            '102': __('This groupchat now shows unavailable members'),
            '103': __('This groupchat does not show unavailable members'),
            '104': __('The groupchat configuration has changed'),
            '170': __('Groupchat logging is now enabled'),
            '171': __('Groupchat logging is now disabled'),
            '172': __('This groupchat is now no longer anonymous'),
            '173': __('This groupchat is now semi-anonymous'),
            '174': __('This groupchat is now fully-anonymous'),
            '201': __('A new groupchat has been created'),
            // XXX: Note the triple underscore function and not double underscore.
            '210': ___('Your nickname has been automatically set to %1$s'),
            '301': __('You have been banned from this groupchat'),
            // XXX: Note the triple underscore function and not double underscore.
            '303': ___('Your nickname has been changed to %1$s'),
            '307': __('You have been kicked from this groupchat'),
            '321': __('You have been removed from this groupchat because of an affiliation change'),
            '322': __(
                "You have been removed from this groupchat because it has changed to members-only and you're not a member",
            ),
            '332': __('You have been removed from this groupchat because the service hosting it is being shut down'),
            '333': __('You have exited this groupchat due to a technical problem'),
        };
        const labels = { muc: { STATUS_CODE_MESSAGES } };
        Object.assign(shared_converse.labels, labels);
        Object.assign(shared_converse, labels); // XXX DEPRECATED

        routeToRoom();
        addEventListener('hashchange', routeToRoom);

        // TODO: DEPRECATED
        const legacy_exports = {
            ChatRoom: muc_muc,
            ChatRoomMessage: muc_message,
            ChatRoomMessages: muc_messages,
            ChatRoomOccupant: muc_occupant,
            ChatRoomOccupants: occupants,
        };
        Object.assign(shared_converse, legacy_exports);

        const exports = {
            MUC: muc_muc,
            MUCMessage: muc_message,
            MUCMessages: muc_messages,
            MUCOccupant: muc_occupant,
            MUCOccupants: occupants,
            getDefaultMUCNickname: getDefaultMUCNickname,
            isInfoVisible: isInfoVisible,
            onDirectMUCInvitation: onDirectMUCInvitation,
        };
        Object.assign(shared_converse.exports, exports);
        Object.assign(shared_converse, exports); // XXX DEPRECATED

        /** @type {module:shared-api.APIEndpoint} */ shared_api.chatboxes.registry.add(CHATROOMS_TYPE, muc_muc);

        if (shared_api.settings.get('allow_muc_invitations')) {
            shared_api.listen.on('connected', registerDirectInvitationHandler);
            shared_api.listen.on('reconnected', registerDirectInvitationHandler);
        }

        shared_api.listen.on('getDuplicateMessageQueries', getMUCDuplicateMessageQueries);

        shared_api.listen.on('addClientFeatures', () => shared_api.disco.own.features.add(`${muc_plugin_Strophe.NS.CONFINFO}+notify`));
        shared_api.listen.on('addClientFeatures', onAddClientFeatures);
        shared_api.listen.on('beforeResourceBinding', onBeforeResourceBinding);
        shared_api.listen.on('beforeTearDown', onBeforeTearDown);
        shared_api.listen.on('chatBoxesFetched', autoJoinRooms);
        shared_api.listen.on('disconnected', disconnectChatRooms);
        shared_api.listen.on('statusInitialized', onStatusInitialized);

        document.addEventListener('visibilitychange', onWindowStateChanged);
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/muc/index.js










Object.assign(headless_utils, { muc: { isChatRoom: isChatRoom, setAffiliation: setAffiliation, getDefaultMUCService: getDefaultMUCService }});



;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/utils.js





const { u: bookmarks_utils_u } = api_public.env;

/**
 * @returns {import('shared/types').StorageKeys}
 */
function getStorageKeys() {
    const { session } = shared_converse;
    const storage_key = `converse.room-bookmarks.${session.get('bare_jid')}`;
    const fetched_flag_key = `${storage_key}-fetched`;
    return { storage_key, fetched_flag_key };
}

/**
 * @param {string} jid - The JID of the bookmark.
 * @returns {string|null} The nickname if found, otherwise null.
 */
function getNicknameFromBookmark(jid) {
    if (!shared_api.settings.get('allow_bookmarks')) {
        return null;
    }
    return shared_converse.state.bookmarks?.get(jid)?.get('nick');
}

/**
 * @param {import('../chat/message')} message
 * @returns {true}
 */
function handleBookmarksPush(message) {
    shared_api.waitUntil('bookmarksInitialized')
        .then(() => shared_converse.state.bookmarks.setBookmarksFromStanza(message))
        .catch(/** @param {Error} e */ (e) => src_log.fatal(e));
    return true;
}


Object.assign(bookmarks_utils_u, {
    bookmarks: {
        getStorageKeys,
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/collection.js
/**
 * @typedef {import('../muc/muc.js').default} MUC
 */















const { Strophe: collection_Strophe, stx: collection_stx } = api_public.env;

/**
 * @extends {Collection<Bookmark>}
 */
class Bookmarks extends skeletor.Collection {
    get idAttribute() {
        return 'jid';
    }

    constructor() {
        super([], { comparator: (/** @type {Bookmark} */ b) => b.getDisplayName().toLowerCase() });
        this.model = bookmarks_model;
    }

    async initialize() {
        this.on('add', (bm) =>
            this.openBookmarkedRoom(bm)
                .then((bm) => this.markRoomAsBookmarked(bm))
                .catch((e) => src_log.fatal(e))
        );
        this.on('change:autojoin', this.onAutoJoinChanged, this);
        this.on(
            'remove',
            /** @param { Bookmark } bookmark }*/ (bookmark) => {
                this.sendRemoveBookmarkStanza(bookmark);
                this.leaveRoom(bookmark);
            }
        );

        const { storage_key, fetched_flag_key } = getStorageKeys();
        this.fetched_flag = fetched_flag_key;
        initStorage(this, storage_key);

        await this.fetchBookmarks();

        /**
         * Triggered once the {@link Bookmarks} collection
         * has been created and cached bookmarks have been fetched.
         * @event _converse#bookmarksInitialized
         * @type {Bookmarks}
         * @example _converse.api.listen.on('bookmarksInitialized', (bookmarks) => { ... });
         */
        shared_api.trigger('bookmarksInitialized', this);
    }

    static async checkBookmarksSupport() {
        const bare_jid = shared_converse.session.get('bare_jid');
        if (!bare_jid) return false;

        const identity = await shared_api.disco.getIdentity('pubsub', 'pep', bare_jid);
        if (shared_api.settings.get('allow_public_bookmarks')) {
            return !!identity;
        } else {
            return shared_api.disco.supports(collection_Strophe.NS.PUBSUB + '#publish-options', bare_jid);
        }
    }

    /**
     * @param {Bookmark} bookmark
     */
    async openBookmarkedRoom(bookmark) {
        if (shared_api.settings.get('muc_respect_autojoin') && bookmark.get('autojoin')) {
            const groupchat = await shared_api.rooms.create(bookmark.get('jid'), {
                nick: bookmark.get('nick'),
                password: bookmark.get('password'),
            });
            groupchat.maybeShow();
        }
        return bookmark;
    }

    fetchBookmarks() {
        const deferred = getOpenPromise();
        if (shared_converse.state.session.get(this.fetched_flag)) {
            this.fetch({
                success: () => deferred.resolve(),
                error: () => deferred.resolve(),
            });
        } else {
            this.fetchBookmarksFromServer(deferred);
        }
        return deferred;
    }

    /**
     * @param {import('./types').BookmarkAttrs} attrs
     * @param {boolean} [create=true]
     * @param {import('@converse/skeletor').FetchOrCreateOptions} [options]
     */
    async setBookmark(attrs, create = true, options = {}) {
        if (!attrs.jid) return src_log.warn('No JID provided for setBookmark');

        let send_stanza = false;

        let bookmark = this.get(attrs.jid);
        if (bookmark) {
            // Check if any attrs changed
            const has_changed = Object.keys(attrs).reduce((result, k) => {
                return result || (attrs[k] ?? '') !== (bookmark.attributes[k] ?? '');
            }, false);
            if (has_changed) {
                bookmark.save(attrs, options);
                send_stanza = true;
            }
        } else if (create) {
            bookmark = await this.create(attrs, options);
            send_stanza = true;
        }

        if (bookmark && send_stanza) {
            this.sendBookmarkStanza(bookmark).catch((iq) => this.onBookmarkError(iq));
        }
    }

    /**
     * @param {Bookmark} bookmark
     * @returns {Promise<void|Element>}
     */
    async sendRemoveBookmarkStanza(bookmark) {
        const bare_jid = shared_converse.session.get('bare_jid');
        const node = (await shared_api.disco.supports(`${collection_Strophe.NS.BOOKMARKS2}#compat`, bare_jid))
            ? collection_Strophe.NS.BOOKMARKS2
            : collection_Strophe.NS.BOOKMARKS;

        if (node === collection_Strophe.NS.BOOKMARKS2) {
            const stanza = collection_stx`
                <iq from="${bare_jid}"
                    to="${bare_jid}"
                    type="set"
                    xmlns="jabber:client">
                <pubsub xmlns="http://jabber.org/protocol/pubsub">
                    <retract node="${node}" notify="true">
                        <item id="${bookmark.get('jid')}"/>
                    </retract>
                </pubsub>
                </iq>`;
            return shared_api.sendIQ(stanza);
        }

        return this.sendBookmarkStanza().catch((iq) => this.onBookmarkError(iq));
    }

    /**
     * @param {'urn:xmpp:bookmarks:1'|'storage:bookmarks'} node
     * @param {Bookmark} [bookmark]
     * @returns {Stanza|Stanza[]}
     */
    getPublishedItems(node, bookmark) {
        if (node === collection_Strophe.NS.BOOKMARKS2) {
            if (!bookmark) throw new Error('getPublishedItems: missing bookmark');

            const extensions = bookmark.get('extensions') ?? [];
            return collection_stx`<item id="${bookmark.get('jid')}">
                        <conference xmlns="${collection_Strophe.NS.BOOKMARKS2}"
                                name="${bookmark.get('name') || A}"
                                autojoin="${bookmark.get('autojoin')}">
                            ${bookmark.get('nick') ? collection_stx`<nick>${bookmark.get('nick')}</nick>` : ''}
                            ${bookmark.get('password') ? collection_stx`<password>${bookmark.get('password')}</password>` : ''}
                        ${
                            extensions.length
                                ? collection_stx`<extensions>${extensions.map((e) => Stanza.fromString(e))}</extensions>`
                                : ''
                        }
                        </conference>
                    </item>`;
        } else {
            return collection_stx`<item id="current">
                <storage xmlns="${collection_Strophe.NS.BOOKMARKS}">
                ${this.map(
                    /** @param {MUC} model */ (model) =>
                        collection_stx`<conference name="${model.get('name')}" autojoin="${model.get('autojoin')}"
                        jid="${model.get('jid')}">
                        ${model.get('nick') ? collection_stx`<nick>${model.get('nick')}</nick>` : ''}
                        ${model.get('password') ? collection_stx`<password>${model.get('password')}</password>` : ''}
                    </conference>`
                )}
                </storage>
            </item>`;
        }
    }

    /**
     * @param {Bookmark} [bookmark]
     * @returns {Promise<void|Element>}
     */
    async sendBookmarkStanza(bookmark) {
        const bare_jid = shared_converse.session.get('bare_jid');
        const node = (await shared_api.disco.supports(`${collection_Strophe.NS.BOOKMARKS2}#compat`, bare_jid))
            ? collection_Strophe.NS.BOOKMARKS2
            : collection_Strophe.NS.BOOKMARKS;
        const supports_max = await shared_api.disco.supports(`${collection_Strophe.NS.PUBSUB}#config-node-max`, bare_jid);
        return shared_api.pubsub.publish(null, node, this.getPublishedItems(node, bookmark), {
            persist_items: true,
            max_items: supports_max ? 'max' : 9999,
            send_last_published_item: 'never',
            access_model: 'whitelist',
        });
    }

    /**
     * @param {Element} iq
     */
    onBookmarkError(iq) {
        src_log.error('Error while trying to update bookmarks');
        src_log.error(iq);
    }

    /**
     * @param {Promise} deferred
     */
    async fetchBookmarksFromServer(deferred) {
        const bare_jid = shared_converse.session.get('bare_jid');
        const ns = (await shared_api.disco.supports(`${collection_Strophe.NS.BOOKMARKS2}#compat`, bare_jid))
            ? collection_Strophe.NS.BOOKMARKS2
            : collection_Strophe.NS.BOOKMARKS;

        const stanza = collection_stx`
            <iq type="get" from="${shared_api.connection.get().jid}" xmlns="jabber:client">
                <pubsub xmlns="${collection_Strophe.NS.PUBSUB}">
                    <items node="${ns}"/>
                </pubsub>
            </iq>`;
        shared_api.sendIQ(stanza)
            .then(/** @param {Element} iq */ (iq) => this.onBookmarksReceived(deferred, iq))
            .catch(/** @param {Element} iq */ (iq) => this.onBookmarksReceivedError(deferred, iq));
    }

    /**
     * @param {Bookmark} bookmark
     */
    markRoomAsBookmarked(bookmark) {
        const { chatboxes } = shared_converse.state;
        const groupchat = chatboxes.get(bookmark.get('jid'));
        groupchat?.save('bookmarked', true);
    }

    /**
     * @param {Bookmark} bookmark
     */
    onAutoJoinChanged(bookmark) {
        if (bookmark.get('autojoin')) {
            this.openBookmarkedRoom(bookmark);
        } else {
            this.leaveRoom(bookmark);
        }
    }

    /**
     * @param {Bookmark} bookmark
     */
    async leaveRoom(bookmark) {
        const groupchat = await shared_api.rooms.get(bookmark.get('jid'));
        groupchat?.close();
    }

    /**
     * @param {Element} stanza
     */
    async setBookmarksFromStanza(stanza) {
        const bookmarks = await parseStanzaForBookmarks(stanza);
        bookmarks.forEach(
            /** @param {import('./types.js').BookmarkAttrs} attrs */
            (attrs) => {
                const bookmark = this.get(attrs.jid);
                bookmark ? bookmark.save(attrs) : this.create(attrs);
            }
        );
    }

    /**
     * @param {Object} deferred
     * @param {Element} iq
     */
    async onBookmarksReceived(deferred, iq) {
        await this.setBookmarksFromStanza(iq);
        shared_converse.state.session.set(this.fetched_flag, true);
        if (deferred !== undefined) {
            return deferred.resolve();
        }
    }

    /**
     * @param {Object} deferred
     * @param {Element} iq
     */
    async onBookmarksReceivedError(deferred, iq) {
        if (iq === null) {
            const { __ } = shared_converse;
            src_log.error('Error: timeout while fetching bookmarks');
            shared_api.alert('error', __('Timeout Error'), [
                __(
                    'The server did not return your bookmarks within the allowed time. ' +
                        'You can reload the page to request them again.'
                ),
            ]);
            deferred?.reject(new Error('Could not fetch bookmarks'));
        } else {
            const { errors } = api_public.env;
            const e = await parseErrorStanza(iq);
            if (e instanceof errors.ItemNotFoundError) {
                // Not an exception, the user simply doesn't have any bookmarks.
                shared_converse.state.session.set(this.fetched_flag, true);
                deferred?.resolve();
            } else {
                src_log.error('Error while fetching bookmarks');
                if (iq) src_log.error(iq);
                deferred?.reject(new Error('Could not fetch bookmarks'));
            }
        }
    }

    async getUnopenedBookmarks() {
        await shared_api.waitUntil('bookmarksInitialized');
        await shared_api.waitUntil('chatBoxesFetched');
        const { chatboxes } = shared_converse.state;
        return this.filter((b) => !chatboxes.get(b.get('jid')));
    }
}

/* export default */ const bookmarks_collection = (Bookmarks);

;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/api.js



const { waitUntil: bookmarks_api_waitUntil } = api_promise;

/**
 * Groups methods relevant to XEP-0402 (and XEP-0048) MUC bookmarks.
 * @namespace api.bookmarks
 * @memberOf api
 */
const api_bookmarks = {
    /**
     * Calling this function will result in an IQ stanza being sent out to set
     * the bookmark on the server.
     *
     * @method api.bookmarks.set
     * @param {import('./types').BookmarkAttrs} attrs - The room attributes
     * @param {boolean} [create=true] - Whether the bookmark should be created if it doesn't exist
     * @param {object} [options] - Skeletor set/add options
     * @returns {Promise<import('./model').default>}
     */
    async set(attrs, create = true, options = {}) {
        const bookmarks = await bookmarks_api_waitUntil('bookmarksInitialized');
        return bookmarks.setBookmark(attrs, create, options);
    },

    /**
     * @method api.bookmarks.get
     * @param {string} jid - The JID of the bookmark to return.
     * @returns {Promise<import('./model').default|undefined>}
     */
    async get(jid) {
        const bookmarks = await bookmarks_api_waitUntil('bookmarksInitialized');
        return bookmarks.get(jid);
    },
};

const bookmarks_api = { bookmarks: api_bookmarks };

/* export default */ const plugins_bookmarks_api = (bookmarks_api);

;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/plugin.js
/**
 * @copyright 2025, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */










const { Strophe: bookmarks_plugin_Strophe } = api_public.env;

bookmarks_plugin_Strophe.addNamespace('BOOKMARKS', 'storage:bookmarks');
bookmarks_plugin_Strophe.addNamespace('BOOKMARKS2', 'urn:xmpp:bookmarks:1');

api_public.plugins.add('converse-bookmarks', {
    dependencies: ['converse-chatboxes', 'converse-muc'],

    initialize() {
        // Configuration values for this plugin
        // ====================================
        // Refer to docs/source/configuration.rst for explanations of these
        // configuration settings.
        shared_api.settings.extend({
            allow_bookmarks: true,
            allow_public_bookmarks: false,
            muc_respect_autojoin: true,
        });

        shared_api.promises.add('bookmarksInitialized');

        Object.assign(shared_api, plugins_bookmarks_api);

        const exports = { Bookmark: bookmarks_model, Bookmarks: bookmarks_collection };
        Object.assign(shared_converse, exports); // TODO: DEPRECATED
        Object.assign(shared_converse.exports, exports);

        shared_api.listen.on(
            'getNicknameForMUC',
            /**
             * @param {import('../muc/muc').default} muc
             * @param {string|null} nick
             * @returns {string}
             */
            (muc, nick) => {
                return nick || getNicknameFromBookmark(muc.get('jid'));
            }
        );

        shared_api.listen.on(
            'parseMUCPresence',
            /**
             * @param {Element} _stanza
             * @param {import('../muc/types').MUCPresenceAttributes} attrs
             */
            (_stanza, attrs) => {
                if (attrs.is_self && attrs.codes.includes('303')) {
                    shared_api.bookmarks.get(attrs.muc_jid).then(
                        /** @param {Bookmark} bookmark */ (bookmark) => {
                            if (!bookmark) src_log.warn('parseMUCPresence: no bookmark returned');

                            const { nick, muc_jid: jid } = attrs;
                            shared_api.bookmarks.set({
                                jid,
                                nick,
                                autojoin: bookmark?.get('autojoin') ?? true,
                                password: bookmark?.get('password') ?? '',
                                name: bookmark?.get('name') ?? '',
                                extensions: bookmark?.get('extensions') ?? [],
                            });
                        }
                    );
                }
                return attrs;
            }
        );

        shared_api.listen.on(
            'enteredNewRoom',
            /** @param {import('../muc/muc').default} muc */
            async ({ attributes }) => {
                const { jid, nick, password, name } = /** @type {import("../muc/types").MUCAttributes} */ (attributes);
                await shared_api.bookmarks.set({
                    jid,
                    autojoin: true,
                    nick,
                    ...(password ? { password } : {}),
                    ...(name ? { name } : {}),
                });
            }
        );

        shared_api.listen.on(
            'leaveRoom',
            /** @param {import('../muc/muc').default} muc */
            async ({ attributes }) => {
                const { jid } = /** @type {import("../muc/types").MUCAttributes} */ (attributes);
                await shared_api.bookmarks.set(
                    {
                        jid,
                        autojoin: false,
                    },
                    false,
                    // Don't trigger a Skeletor `change` event.
                    // This MUC is being left explicitly by the user,
                    // so we don't want to trigger the `onAutoJoinChanged`
                    // listener in ./collection.js to again call `close()`
                    // on the MUC.
                    {
                        silent: true,
                    }
                );
            }
        );

        shared_api.listen.on('addClientFeatures', () => {
            if (shared_api.settings.get('allow_bookmarks')) {
                shared_api.disco.own.features.add(bookmarks_plugin_Strophe.NS.BOOKMARKS + '+notify');
            }
        });

        shared_api.listen.on('clearSession', () => {
            const { state } = shared_converse;
            if (state.bookmarks) {
                state.bookmarks.clearStore({ silent: true });
                const { fetched_flag_key } = getStorageKeys();
                shared_converse.state.session.set(fetched_flag_key, undefined);
                delete state.bookmarks;
            }
        });

        shared_api.listen.on('connected', async () => {
            if (!shared_api.settings.get('allow_bookmarks')) return;

            // Add a handler for bookmarks pushed from other connected clients
            const bare_jid = shared_converse.session.get('bare_jid');
            const connection = shared_api.connection.get();
            connection.addHandler(handleBookmarksPush, bookmarks_plugin_Strophe.NS.BOOKMARKS, 'message', 'headline', null, bare_jid);
            connection.addHandler(handleBookmarksPush, bookmarks_plugin_Strophe.NS.BOOKMARKS2, 'message', 'headline', null, bare_jid);
            await Promise.all([shared_api.waitUntil('chatBoxesFetched')]);

            if (await bookmarks_collection.checkBookmarksSupport()) {
                shared_converse.state.bookmarks = new shared_converse.exports.Bookmarks();
                Object.assign(shared_converse, { bookmarks: shared_converse.state.bookmarks }); // TODO: DEPRECATED
            }
        });
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/index.js






;// CONCATENATED MODULE: ./src/headless/plugins/blocklist/model.js



const { Strophe: blocklist_model_Strophe } = api_public.env;

class BlockedEntity extends skeletor.Model {
    get idAttribute () {
        return 'jid';
    }

    getDisplayName () {
        return blocklist_model_Strophe.xmlunescape(this.get('name'));
    }
}

/* export default */ const blocklist_model = (BlockedEntity);

;// CONCATENATED MODULE: ./src/headless/plugins/blocklist/collection.js









const { stx: blocklist_collection_stx, u: collection_u } = api_public.env;

/**
 * @extends {Collection<BlockedEntity>}
 */
class Blocklist extends skeletor.Collection {
    get idAttribute() {
        return 'jid';
    }

    constructor() {
        super();
        this.model = blocklist_model;
    }

    async initialize() {
        const { session } = shared_converse;
        const cache_key = `converse.blocklist-${session.get('bare_jid')}`;
        this.fetched_flag = `${cache_key}-fetched`;
        initStorage(this, cache_key);

        this.on('add', this.rejectContactRequest);

        await this.fetchBlocklist();

        /**
         * Triggered once the {@link Blocklist} collection
         * has been created and cached blocklist have been fetched.
         * @event _converse#blocklistInitialized
         * @type {Blocklist}
         * @example _converse.api.listen.on('blocklistInitialized', (blocklist) => { ... });
         */
        shared_api.trigger('blocklistInitialized', this);
    }

    /**
     * @param {BlockedEntity} item
     */
    async rejectContactRequest(item) {
        const roster = await shared_api.waitUntil('rosterContactsFetched');
        const contact = roster.get(item.get('jid'));
        if (contact?.get('requesting')) {
            const chat = await shared_api.chats.get(contact.get('jid'));
            chat?.close();
            contact.unauthorize().destroy();
        }
    }

    fetchBlocklist() {
        const deferred = getOpenPromise();
        if (shared_converse.state.session.get(this.fetched_flag)) {
            this.fetch({
                success: () => deferred.resolve(),
                error: () => deferred.resolve(),
            });
        } else {
            this.fetchBlocklistFromServer(deferred);
        }
        return deferred;
    }

    /**
     * @param {Object} deferred
     */
    async fetchBlocklistFromServer(deferred) {
        const stanza = blocklist_collection_stx`<iq xmlns="jabber:client"
            type="get"
            id="${collection_u.getUniqueId()}"><blocklist xmlns="urn:xmpp:blocking"/></iq>`;

        try {
            this.onBlocklistReceived(deferred, await shared_api.sendIQ(stanza));
        } catch (e) {
            src_log.error(e);
            deferred.resolve();
            return;
        }
    }

    /**
     * @param {Object} deferred
     * @param {Element} iq
     */
    async onBlocklistReceived(deferred, iq) {
        Array.from(iq.querySelectorAll('blocklist item')).forEach((item) => {
            const jid = item.getAttribute('jid');
            const blocked = this.get(jid);
            blocked ? blocked.save({ jid }) : this.create({ jid });
        });

        shared_converse.state.session.set(this.fetched_flag, true);
        if (deferred !== undefined) {
            return deferred.resolve();
        }
    }
}

/* export default */ const blocklist_collection = (Blocklist);

;// CONCATENATED MODULE: ./src/headless/plugins/blocklist/utils.js



const { Strophe: blocklist_utils_Strophe, stx: blocklist_utils_stx, u: blocklist_utils_u } = api_public.env;

/**
 * Sends an IQ stanza to remove one or more JIDs from the blocklist
 * @param {string|string[]} jid
 */
async function sendUnblockStanza(jid) {
    const jids = Array.isArray(jid) ? jid : [jid];
    const stanza = blocklist_utils_stx`
        <iq xmlns="jabber:client" type="set" id="${blocklist_utils_u.getUniqueId()}">
            <unblock xmlns="${blocklist_utils_Strophe.NS.BLOCKING}">
                ${jids.map((id) => blocklist_utils_stx`<item jid="${id}"/>`)}
            </unblock>
        </iq>`;
    await send.sendIQ(stanza);
}

/**
 * Sends an IQ stanza to add one or more JIDs from the blocklist
 * @param {string|string[]} jid
 */
async function sendBlockStanza(jid) {
    const jids = Array.isArray(jid) ? jid : [jid];
    const stanza = blocklist_utils_stx`
        <iq xmlns="jabber:client" type="set" id="${blocklist_utils_u.getUniqueId()}">
            <block xmlns="${blocklist_utils_Strophe.NS.BLOCKING}">
                ${jids.map((id) => blocklist_utils_stx`<item jid="${id}"/>`)}
            </block>
        </iq>`;
    await send.sendIQ(stanza);
}

;// CONCATENATED MODULE: ./src/headless/plugins/blocklist/api.js



const { waitUntil: blocklist_api_waitUntil } = api_promise;

/**
 * Groups methods relevant to XEP-0191 Blocking Command
 * @namespace api.blocklist
 * @memberOf api
 */
const api_blocklist = {
    /**
     * Retrieves the current user's blocklist
     * @returns {Promise<import('./collection').default>}
     */
    async get() {
        return await blocklist_api_waitUntil('blocklistInitialized');
    },

    /**
     * Adds a new entity to the blocklist
     * @param {string|string[]} jid
     * @param {boolean} [send_stanza=true]
     * @returns {Promise<import('./collection').default>}
     */
    async add(jid, send_stanza = true) {
        const blocklist = await blocklist_api_waitUntil('blocklistInitialized');
        const jids = Array.isArray(jid) ? jid : [jid];
        if (send_stanza) await sendBlockStanza(jids);
        jids.forEach((jid) => blocklist.create({ jid }));
        return blocklist;
    },

    /**
     * Removes an entity from the blocklist
     * @param {string|string[]} jid
     * @param {boolean} [send_stanza=true]
     * @returns {Promise<import('./collection').default>}
     */
    async remove(jid, send_stanza = true) {
        const blocklist = await blocklist_api_waitUntil('blocklistInitialized');
        const jids = Array.isArray(jid) ? jid : [jid];
        if (send_stanza) await sendUnblockStanza(jids);
        jids.forEach((jid) => blocklist.get(jid)?.destroy());
        blocklist.remove(jids);
        return blocklist;
    },
};

const blocklist_api = { blocklist: api_blocklist };

/* export default */ const plugins_blocklist_api = (blocklist_api);

;// CONCATENATED MODULE: ./src/headless/plugins/roster/filter.js


class RosterFilter extends skeletor.Model {
    initialize () {
        super.initialize();
        this.set({
            text: '',
            type: 'items',
            state: 'online'
        });
    }
}



;// CONCATENATED MODULE: ./src/headless/plugins/roster/utils.js
/**
 * @typedef {import('./contacts').default} RosterContacts
 */










const { stx: roster_utils_stx } = api_public.env;

function initRoster() {
    // Initialize the collections that represent the roster contacts and groups
    const roster = new shared_converse.exports.RosterContacts();
    Object.assign(shared_converse, { roster }); // XXX Deprecated
    Object.assign(shared_converse.state, { roster });

    const bare_jid = shared_converse.session.get('bare_jid');
    let id = `converse.contacts-${bare_jid}`;
    initStorage(roster, id);

    const roster_filter = new RosterFilter();
    Object.assign(shared_converse, { roster_filter }); // XXX Deprecated
    Object.assign(shared_converse.state, { roster_filter });

    roster_filter.id = `_converse.rosterfilter-${bare_jid}`;
    initStorage(roster_filter, roster_filter.id);
    roster_filter.fetch();

    id = `converse-roster-model-${bare_jid}`;
    roster.data = new skeletor.Model();
    roster.data.id = id;
    initStorage(roster.data, id);
    roster.data.fetch();
    /**
     * Triggered once the `RosterContacts`
     * been created, but not yet populated with data.
     * This event is useful when you want to create views for these collections.
     * @event _converse#chatBoxMaximized
     * @example _converse.api.listen.on('rosterInitialized', () => { ... });
     * @example _converse.api.waitUntil('rosterInitialized').then(() => { ... });
     */
    shared_api.trigger('rosterInitialized', roster);
}

/**
 * Fetch all the roster groups, and then the roster contacts.
 * Emit an event after fetching is done in each case.
 * @param {boolean} ignore_cache - If set to to true, the local cache
 *      will be ignored it's guaranteed that the XMPP server
 *      will be queried for the roster.
 */
async function populateRoster(ignore_cache = false) {
    const connection = shared_api.connection.get();
    if (ignore_cache) {
        connection.send_initial_presence = true;
    }
    const roster = /** @type {RosterContacts} */ (shared_converse.state.roster);
    try {
        await roster.fetchRosterContacts();
        shared_api.trigger('rosterContactsFetched', roster);
    } catch (reason) {
        src_log.error(reason);
    } finally {
        if (connection.send_initial_presence) {
            shared_api.user.presence.send();
            shared_converse.state.profile.save({ presence: 'online' });
        }
    }
}

let utils_presence_ref;

function utils_registerPresenceHandler() {
    utils_unregisterPresenceHandler();
    const connection = shared_api.connection.get();
    utils_presence_ref = connection.addHandler(
        /** @param {Element} presence */
        (presence) => {
            const roster = /** @type {RosterContacts} */ (shared_converse.state.roster);
            roster.presenceHandler(presence);
            return true;
        },
        null,
        'presence',
        null,
    );
}

function utils_unregisterPresenceHandler() {
    if (utils_presence_ref) {
        const connection = shared_api.connection.get();
        connection.deleteHandler(utils_presence_ref);
        utils_presence_ref = null;
    }
}

async function clearPresences() {
    await shared_converse.state.presences?.clearStore();
}

/**
 * Roster specific event handler for the clearSession event
 */
async function utils_onClearSession() {
    await clearPresences();
    if (shouldClearCache(shared_converse)) {
        const roster = /** @type {RosterContacts} */ (shared_converse.state.roster);
        if (roster) {
            roster.data?.destroy();
            await roster.clearStore();
            delete shared_converse.state.roster;
            Object.assign(shared_converse, { roster: undefined }); // XXX DEPRECATED
        }
    }
}

/**
 * Roster specific event handler for the presencesInitialized event
 * @param {Boolean} reconnecting
 */
function onPresencesInitialized(reconnecting) {
    if (reconnecting) {
        /**
         * Similar to `rosterInitialized`, but instead pertaining to reconnection.
         * This event indicates that the roster and its groups are now again
         * available after Converse.js has reconnected.
         * @event _converse#rosterReadyAfterReconnection
         * @example _converse.api.listen.on('rosterReadyAfterReconnection', () => { ... });
         */
        shared_api.trigger('rosterReadyAfterReconnection');
    } else {
        initRoster();
    }
    const roster = /** @type {RosterContacts} */ (shared_converse.state.roster);
    roster.onConnected();
    utils_registerPresenceHandler();
    populateRoster(!shared_api.connection.get().restored);
}

/**
 * Roster specific event handler for the statusInitialized event
 * @param { Boolean } reconnecting
 */
async function utils_onStatusInitialized(reconnecting) {
    if (reconnecting) {
        // When reconnecting and not resuming a previous session,
        // we clear all cached presence data, since it might be stale
        // and we'll receive new presence updates
        !shared_api.connection.get().hasResumed() && (await clearPresences());
    } else {
        const presences = new shared_converse.exports.Presences();
        Object.assign(shared_converse, { presences });
        Object.assign(shared_converse.state, { presences });

        const bare_jid = shared_converse.session.get('bare_jid');
        const id = `converse.presences-${bare_jid}`;

        initStorage(presences, id, 'session');
        // We might be continuing an existing session, so we fetch cached presence data.
        await new Promise((r) => presences.fetch({ success: r, error: r }));
    }
    /**
     * Triggered once the _converse.Presences collection has been
     * initialized and its cached data fetched.
     * Returns a boolean indicating whether this event has fired due to
     * Converse having reconnected.
     * @event _converse#presencesInitialized
     * @type {boolean}
     * @example _converse.api.listen.on('presencesInitialized', (reconnecting) => { ... });
     */
    shared_api.trigger('presencesInitialized', reconnecting);
}

/**
 * Roster specific handler for the rosterContactsFetched promise
 */
function onRosterContactsFetched() {
    const roster = /** @type {RosterContacts} */ (shared_converse.state.roster);
    roster.on('add', (contact) => {
        // When a new contact is added, check if we already have a
        // chatbox open for it, and if so attach it to the chatbox.
        const chatbox = shared_converse.state.chatboxes.findWhere({ jid: contact.get('jid') });
        chatbox?.setModelContact(contact.get('jid'));
    });
}

/**
 * Reject or cancel another user's subscription to our presence updates.
 * @function rejectPresenceSubscription
 * @param {String} jid - The Jabber ID of the user whose subscription is being canceled
 * @param {String} [message] - An optional message to the user
 */
function rejectPresenceSubscription(jid, message) {
    const pres = roster_utils_stx`
        <presence to="${jid}" type="unsubscribed" xmlns="jabber:client">
            ${message ? roster_utils_stx`<status>${message}</status>` : ''}
        </presence>`;
    shared_api.send(pres);
}

/**
 * @param {import('./contact.js').default} contact
 * @return {boolean}
 */
function isUnsavedContact(contact) {
    const is_self = shared_converse.session.get('bare_jid') === contact.get('jid');
    return !is_self && !contact.get('subscription');
}

;// CONCATENATED MODULE: ./src/headless/plugins/blocklist/plugin.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description Adds support for XEP-0191 Blocking Command
 */









const { Strophe: blocklist_plugin_Strophe, sizzle: plugin_sizzle } = api_public.env;

blocklist_plugin_Strophe.addNamespace("BLOCKING", "urn:xmpp:blocking");

api_public.plugins.add("converse-blocklist", {
    /**
     * @typedef {import('../roster/contact').default} RosterContact
     * @typedef {import('../roster/contacts').default} RosterContacts
     */

    dependencies: ["converse-disco"],

    initialize() {
        const exports = { Blocklist: blocklist_collection, BlockedEntity: blocklist_model };
        Object.assign(shared_converse.exports, exports);
        Object.assign(shared_api, plugins_blocklist_api);

        shared_api.promises.add(["blocklistInitialized"]);

        shared_api.listen.on(
            "cachedRoster",
            /** @param {RosterContacts} roster */
            async (roster) => {
                const domain = shared_converse.session.get("domain");
                const blocking_supported = await shared_api.disco.supports(blocklist_plugin_Strophe.NS.BLOCKING, domain);
                if (blocking_supported) {
                    const blocklist = await shared_api.blocklist.get();
                    const requesting_contacts = roster.filter(
                        /** @param {RosterContact} m */ (m) => m.get("requesting")
                    );
                    requesting_contacts.forEach(
                        /** @param {RosterContact} m */ async (m) => {
                            if (blocklist.get(m.get("jid"))) {
                                rejectPresenceSubscription(m.get("jid"));
                                m.destroy();
                            }
                        }
                    );
                }
            }
        );

        shared_api.listen.on(
            "getErrorAttributesForMessage",
            /**
             * @param {import('../chat/model.js').default} _message
             * @param {import('../../shared/types').MessageErrorAttributes} new_attrs
             * @param {import('../../shared/types').MessageAttributes} attrs
             */
            (_message, new_attrs, attrs) => {
                if (attrs.errors.find((e) => e.name === "blocked" && e.xmlns === `${blocklist_plugin_Strophe.NS.BLOCKING}:errors`)) {
                    const { __ } = shared_converse;
                    new_attrs.error = __("You are blocked from sending messages.");
                }
                return new_attrs;
            }
        );

        shared_api.listen.on("connected", () => {
            const connection = shared_api.connection.get();
            connection.addHandler(
                /** @param {Element} stanza */ (stanza) => {
                    const bare_jid = shared_converse.session.get("bare_jid");
                    const from = stanza.getAttribute("from");
                    if (blocklist_plugin_Strophe.getBareJidFromJid(from ?? bare_jid) != bare_jid) {
                        src_log.warn(`Received a blocklist push stanza from a suspicious JID ${from}`);
                        return true;
                    }

                    const add_jids = plugin_sizzle(`block[xmlns="${blocklist_plugin_Strophe.NS.BLOCKING}"] item`, stanza).map(
                        /** @param {Element} item */ (item) => item.getAttribute("jid")
                    );
                    if (add_jids.length) shared_api.blocklist.add(add_jids, false);

                    const remove_jids = plugin_sizzle(`unblock[xmlns="${blocklist_plugin_Strophe.NS.BLOCKING}"] item`, stanza).map(
                        /** @param {Element} item */ (item) => item.getAttribute("jid")
                    );
                    if (remove_jids.length) shared_api.blocklist.remove(remove_jids, false);

                    return true;
                },
                blocklist_plugin_Strophe.NS.BLOCKING,
                "iq",
                "set"
            );
        });

        shared_api.listen.on("clearSession", () => {
            const { state } = shared_converse;
            if (state.blocklist) {
                state.blocklist.clearStore({ "silent": true });
                state.session.set(state.blocklist.fetched_flag, undefined);
                delete state.blocklist;
            }
        });

        shared_api.listen.on("discoInitialized", async () => {
            const domain = shared_converse.session.get("domain");
            if (await shared_api.disco.supports(blocklist_plugin_Strophe.NS.BLOCKING, domain)) {
                shared_converse.state.blocklist = new shared_converse.exports.Blocklist();
            }
        });
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/blocklist/index.js


;// CONCATENATED MODULE: ./src/headless/plugins/bosh/api.js


/* export default */ const bosh_api = ({
    /**
     * This API namespace lets you access the BOSH tokens
     * @namespace api.tokens
     * @memberOf api
     */
    tokens: {
        /**
         * @method api.tokens.get
         * @param {string} [id] The type of token to return ('rid' or 'sid').
         * @returns {string} A token, either the RID or SID token depending on what's asked for.
         * @example _converse.api.tokens.get('rid');
         */
        get (id) {
            const connection = shared_api.connection.get();
            if (!connection) return null;

            if (id.toLowerCase() === 'rid') {
                return connection.rid || connection._proto.rid;
            } else if (id.toLowerCase() === 'sid') {
                return connection.sid || connection._proto.sid;
            }
        }
    }

});

;// CONCATENATED MODULE: ./src/headless/plugins/bosh/utils.js
/**
 * @typedef {module:shared.api.user} LoginHookPayload
 */










const BOSH_SESSION_ID = 'converse.bosh-session';

let bosh_session;

async function initBOSHSession() {
    const id = BOSH_SESSION_ID;
    if (!bosh_session) {
        bosh_session = new skeletor.Model({ id });
        bosh_session.browserStorage = /** @type {any} */ (createStore(id, 'session'));
        await new Promise((resolve) => bosh_session.fetch({ 'success': resolve, 'error': resolve }));
    }

    let jid = shared_converse.session.get('jid');
    if (jid) {
        if (bosh_session.get('jid') !== jid) {
            jid = await setUserJID(jid);
            bosh_session.clear({ 'silent': true });
            bosh_session.save({ jid });
        }
    } else {
        // Keepalive
        const jid = bosh_session.get('jid');
        jid && (await setUserJID(jid));
    }
    return bosh_session;
}

function startNewPreboundBOSHSession() {
    if (!shared_api.settings.get('prebind_url')) {
        throw new Error('startNewPreboundBOSHSession: If you use prebind then you MUST supply a prebind_url');
    }
    const connection = shared_api.connection.get();
    const xhr = new XMLHttpRequest();
    xhr.open('GET', shared_api.settings.get('prebind_url'), true);
    xhr.setRequestHeader('Accept', 'application/json, text/javascript');
    xhr.onload = async function (event) {
        if (xhr.status >= 200 && xhr.status < 400) {
            const data = JSON.parse(xhr.responseText);
            const jid = await setUserJID(data.jid);
            connection.attach(jid, data.sid, data.rid, connection.onConnectStatusChanged, BOSH_WAIT);
        } else {
            xhr.onerror(event);
        }
    };
    xhr.onerror = function () {
        shared_api.connection.destroy();
        /**
         * Triggered when fetching prebind tokens failed
         * @event _converse#noResumeableBOSHSession
         * @type { _converse }
         * @example _converse.api.listen.on('noResumeableBOSHSession', _converse => { ... });
         */
        shared_api.trigger('noResumeableBOSHSession', shared_converse);
    };
    xhr.send();
}

/**
 * @param {unknown} _
 * @param {LoginHookPayload} payload
 */
async function attemptPrebind(_, payload) {
    if (payload.success) return payload;

    const { automatic } = payload;
    // See whether there is a BOSH session to re-attach to
    if (await restoreBOSHSession()) {
        return { ...payload, success: true };
    } else if (shared_api.settings.get('authentication') === PREBIND && (!automatic || shared_api.settings.get('auto_login'))) {
        startNewPreboundBOSHSession();
        return { ...payload, success: true };
    }
    return payload;
}

function saveJIDToSession() {
    if (bosh_session !== undefined) {
        bosh_session.save({ 'jid': shared_converse.session.get('jid') });
    }
}

function bosh_utils_clearSession() {
    if (bosh_session === undefined) {
        // Remove manually, even if we don't have the corresponding
        // model, to avoid trying to reconnect to a stale BOSH session
        const id = BOSH_SESSION_ID;
        sessionStorage.removeItem(id);
        sessionStorage.removeItem(`${id}-${id}`);
    } else {
        bosh_session.destroy();
        bosh_session = undefined;
    }
}

async function restoreBOSHSession() {
    const jid = (await initBOSHSession()).get('jid');
    const connection = shared_api.connection.get();
    if (jid && connection._proto instanceof Strophe.Bosh) {
        try {
            connection.restore(jid, connection.onConnectStatusChanged);
            return true;
        } catch (e) {
            !isTestEnv() && src_log.warn('Could not restore session for jid: ' + jid + ' Error message: ' + e.message);
            return false;
        }
    }
    return false;
}

;// CONCATENATED MODULE: ./src/headless/plugins/bosh/index.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description Converse.js plugin which add support for XEP-0206: XMPP Over BOSH
 */








api_public.plugins.add('converse-bosh', {

    enabled () {
        return !shared_converse.api.settings.get("blacklisted_plugins").includes('converse-bosh');
    },

    initialize () {
        shared_api.settings.extend({
            bosh_service_url: undefined,
            prebind_url: null
        });

        Object.assign(shared_api, bosh_api);

        shared_api.listen.on('clearSession', bosh_utils_clearSession);
        shared_api.listen.on('setUserJID', saveJIDToSession);
        shared_api.listen.on('login', attemptPrebind);
        shared_api.listen.on('addClientFeatures',
            () => shared_api.disco.own.features.add(Strophe.NS.BOSH)
        );
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/caps/utils.js
/**
 * @typedef {import('strophe.js/src/builder.js').Builder} Strophe.Builder
 */




const { Strophe: caps_utils_Strophe, stx: caps_utils_stx } = api_public.env;

function propertySort (array, property) {
    return array.sort((a, b) => { return a[property] > b[property] ? -1 : 1 });
}

async function generateVerificationString () {
    const identities = shared_converse.api.disco.own.identities.get();
    const features = shared_converse.api.disco.own.features.get();

    if (identities.length > 1) {
        propertySort(identities, "category");
        propertySort(identities, "type");
        propertySort(identities, "lang");
    }

    let S = identities.reduce((result, id) => `${result}${id.category}/${id.type}/${id?.lang ?? ''}/${id.name}<`, "");
    features.sort();
    S = features.reduce((result, feature) => `${result}${feature}<`, S);

    const ab = await crypto.subtle.digest('SHA-1', stringToArrayBuffer(S));
    return arrayBufferToBase64(ab);
}

/**
 * Given a stanza, adds a XEP-0115 CAPS element
 * @param {Strophe.Builder} stanza
 */
async function addCapsNode (stanza) {
    const node = caps_utils_stx`<c
        xmlns="${caps_utils_Strophe.NS.CAPS}"
        hash="sha-1"
        node="https://conversejs.org"
        ver="${await generateVerificationString()}"></c>`;
    stanza.root().cnode(node).up();
    return stanza;
}

;// CONCATENATED MODULE: ./src/headless/plugins/caps/index.js
/**
 * @copyright 2022, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */




const { Strophe: caps_Strophe } = api_public.env;

caps_Strophe.addNamespace('CAPS', "http://jabber.org/protocol/caps");


api_public.plugins.add('converse-caps', {

    dependencies: ['converse-status'],

    initialize () {
        shared_api.listen.on('constructedPresence', (_, p) => addCapsNode(p));
        shared_api.listen.on('constructedMUCPresence', (_, p) => addCapsNode(p));
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/chatboxes/chatboxes.js
/**
 * @typedef {import('../../shared/chatbox').default} ChatBoxBase
 */





/**
 * @extends {Collection<ChatBoxBase>}
 */
class ChatBoxes extends skeletor.Collection {
    /**
     * @param {ChatBoxBase[]} models
     * @param {object} options
     */
    constructor(models, options) {
        super(models, Object.assign({ comparator: 'time_opened' }, options));
    }

    /**
     * @param {Collection} collection
     */
    onChatBoxesFetched(collection) {
        collection.filter((c) => !c.isValid()).forEach((c) => c.destroy());
        /**
         * Triggered once all chat boxes have been recreated from the browser cache
         * @event _converse#chatBoxesFetched
         * @type {object}
         * @property {ChatBoxBase} chatbox
         * @property {Element} stanza
         * @example _converse.api.listen.on('chatBoxesFetched', obj => { ... });
         * @example _converse.api.waitUntil('chatBoxesFetched').then(() => { ... });
         */
        shared_api.trigger('chatBoxesFetched');
    }

    /**
     * @param {boolean} reconnecting
     */
    onConnected(reconnecting) {
        if (reconnecting) return;

        const bare_jid = shared_converse.session.get('bare_jid');
        initStorage(this, `converse.chatboxes-${bare_jid}`);
        this.fetch({
            add: true,
            success: (c) => this.onChatBoxesFetched(c),
        });
    }

    /**
     * @param {import('./types').CreateModelAttributes} attrs
     * @param {import('@converse/skeletor/dist/skeletor.d').ModelOptions} options
     */
    createModel(attrs, options) {
        if (!attrs.type) {
            throw new Error('You need to specify a type of chatbox to be created');
        }
        const ChatBox = shared_api.chatboxes.registry.get(attrs.type);
        return new ChatBox(attrs, options);
    }
}

/* export default */ const chatboxes_chatboxes = (ChatBoxes);

;// CONCATENATED MODULE: ./src/headless/plugins/chatboxes/index.js
/**
 * @copyright 2022, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */









const { Strophe: chatboxes_Strophe } = api_public.env;


api_public.plugins.add('converse-chatboxes', {

    dependencies: ["converse-emoji", "converse-roster", "converse-vcard"],

    initialize () {

        shared_api.promises.add([
            'chatBoxesFetched',
            'chatBoxesInitialized',
            'privateChatsAutoJoined'
        ]);

        Object.assign(shared_api, { chatboxes: chatboxes_api});

        Object.assign(shared_converse, { ChatBoxes: chatboxes_chatboxes }); // TODO: DEPRECATED
        Object.assign(shared_converse.exports, { ChatBoxes: chatboxes_chatboxes });

        shared_api.listen.on('addClientFeatures', () => {
            shared_api.disco.own.features.add(chatboxes_Strophe.NS.MESSAGE_CORRECT);
            shared_api.disco.own.features.add(chatboxes_Strophe.NS.HTTPUPLOAD);
            shared_api.disco.own.features.add(chatboxes_Strophe.NS.OUTOFBAND);
        });

        let chatboxes;

        shared_api.listen.on('pluginsInitialized', () => {
            chatboxes = new shared_converse.exports.ChatBoxes();
            Object.assign(shared_converse, { chatboxes }); // TODO: DEPRECATED
            Object.assign(shared_converse.state, { chatboxes });

            /**
             * Triggered once the _converse.ChatBoxes collection has been initialized.
             * @event _converse#chatBoxesInitialized
             * @example _converse.api.listen.on('chatBoxesInitialized', () => { ... });
             * @example _converse.api.waitUntil('chatBoxesInitialized').then(() => { ... });
             */
            shared_api.trigger('chatBoxesInitialized');
        });

        shared_api.listen.on('presencesInitialized', (reconnecting) => chatboxes.onConnected(reconnecting));
        shared_api.listen.on('reconnected', () => chatboxes.forEach(m => m.onReconnection()));
        shared_api.listen.on('clearSession', onClearSession);

        // XXX: Would be nice to keep track of the last open chat and to show that again.
        shared_api.listen.on('chatBoxClosed', () => {
            if (isUniView()) {
                shared_converse.state.chatboxes.find((c) => c.get('jid'))?.maybeShow();
            }
        });

    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/adhoc/utils.js




const { Strophe: adhoc_utils_Strophe, u: adhoc_utils_u } = api_public.env;

/**
 * Given a "result" IQ stanza that contains a list of ad-hoc commands, parse it
 * and return the list of commands as JSON objects.
 * @param {Element} stanza
 * @returns {import('./types').AdHocCommand[]}
 */
function parseForCommands(stanza) {
    const items = sizzle_default()(`query[xmlns="${adhoc_utils_Strophe.NS.DISCO_ITEMS}"][node="${adhoc_utils_Strophe.NS.ADHOC}"] item`, stanza);
    return items.map(adhoc_utils_u.getAttributes);
}

/**
 * Given a "result" IQ stanza containing the outcome of an Ad-hoc command that
 * was executed, parse it and return the values as a JSON object.
 * @param {Element} iq
 * @returns {import('./types').AdHocCommandResult}
 */
function parseCommandResult(iq) {
    const cmd_el = sizzle_default()(`command[xmlns="${adhoc_utils_Strophe.NS.ADHOC}"]`, iq).pop();
    const note = cmd_el.querySelector('note');

    return {
        ...parseXForm(iq),
        sessionid: cmd_el.getAttribute('sessionid'),
        note: note
            ? {
                  text: note.textContent,
                  type: /** @type {'info'|'warn'|'error'} */ (note.getAttribute('type')),
              }
            : null,
        actions: Array.from(cmd_el.querySelector('actions')?.children ?? []).map((a) => a.nodeName.toLowerCase()),
    };
}

;// CONCATENATED MODULE: ./src/headless/plugins/adhoc/api.js






const { Strophe: adhoc_api_Strophe, u: api_u, stx: adhoc_api_stx } = api_public.env;


/* export default */ const adhoc_api = ({
    /**
     * @typedef {import('./types').AdHocCommandResult} AdHocCommandResult
     */

    /**
     * The XEP-0050 Ad-Hoc Commands API
     *
     * This API lets you discover ad-hoc commands available for an entity in the XMPP network.
     *
     * @namespace api.adhoc
     * @memberOf api
     */
    adhoc: {
        /**
         * @method api.adhoc.getCommands
         * @param {string} to_jid
         */
        async getCommands (to_jid) {
            try {
                return parseForCommands(await shared_api.disco.items(to_jid, adhoc_api_Strophe.NS.ADHOC));
            } catch (e) {
                if (e === null) {
                    src_log.error(`Error: timeout while fetching ad-hoc commands for ${to_jid}`);
                } else {
                    src_log.error(`Error while fetching ad-hoc commands for ${to_jid}`);
                    src_log.error(e);
                }
                return [];
            }
        },

        /**
         * @method api.adhoc.fetchCommandForm
         * @param {string} jid
         * @param {string} node
         * @returns {Promise<AdHocCommandResult>}
         */
        async fetchCommandForm (jid, node) {
            const stanza = adhoc_api_stx`
                <iq type="set" to="${jid}" xmlns="jabber:client">
                    <command xmlns="${adhoc_api_Strophe.NS.ADHOC}" action="execute" node="${node}"></command>
                </iq>`;
            return parseCommandResult(await shared_api.sendIQ(stanza));
        },

        /**
         * @method api.adhoc.runCommand
         * @param {String} jid
         * @param {String} sessionid
         * @param {import('./types').AdHocCommandAction} action
         * @param {String} node
         * @param {Array<{ [k:string]: string }>} inputs
         */
        async runCommand (jid, sessionid, node, action, inputs) {
            const iq =
                adhoc_api_stx`<iq type="set" to="${jid}" xmlns="jabber:client">
                    <command sessionid="${sessionid}" node="${node}" action="${action}" xmlns="${adhoc_api_Strophe.NS.ADHOC}">
                        ${ !['cancel', 'prev'].includes(action) ? adhoc_api_stx`
                            <x xmlns="${adhoc_api_Strophe.NS.XFORM}" type="submit">
                                ${ inputs.map(({ name, value }) => adhoc_api_stx`<field var="${name}">
                                    ${ Array.isArray(value)
                                        ? value.map(v => adhoc_api_stx`<value>${v}</value>`) : adhoc_api_stx`<value>${value}</value>` }
                                </field>`) }
                            </x>` : '' }
                    </command>
                </iq>`;

            const result = await shared_api.sendIQ(iq, null, false);
            if (result === null) {
                src_log.warn(`A timeout occurred while trying to run an ad-hoc command`);
                const { __ } = shared_converse;
                return {
                    status: 'error',
                    note: __('A timeout occurred'),
                }
            } else if (api_u.isErrorStanza(result)) {
                src_log.error('Error while trying to execute an ad-hoc command');
                src_log.error(result);
            }

            const command = result.querySelector('command');
            const status = command?.getAttribute('status');
            const resultData = command?.querySelector('x[type=result]');
            return {
                status,
                ...(status === 'executing' || (status === 'completed' && resultData) ? parseCommandResult(result) : {}),
                note: result.querySelector('note')?.textContent
            }
        }
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/adhoc/index.js



const { Strophe: adhoc_Strophe } = api_public.env;

adhoc_Strophe.addNamespace('ADHOC', 'http://jabber.org/protocol/commands');


api_public.plugins.add('converse-adhoc', {

    dependencies: ["converse-disco"],

    initialize () {
        Object.assign(this._converse.api, adhoc_api);
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/headlines/feed.js





/**
 * Shows headline messages
 */
class feed_HeadlinesFeed extends ChatBoxBase {
    defaults() {
        return {
            'bookmarked': false,
            'hidden': isUniView() && !shared_api.settings.get('singleton'),
            'message_type': 'headline',
            'num_unread': 0,
            'time_opened': this.get('time_opened') || new Date().getTime(),
            'time_sent': undefined,
            'type': HEADLINES_TYPE,
        };
    }

    constructor(attrs, options) {
        super(attrs, options);
        this.disable_mam = true; // Don't do MAM queries for this box
    }

    async initialize() {
        await super.initialize();
        await this.fetchMessages();
        /**
         * Triggered once a { @link _converse.HeadlinesFeed } has been created and initialized.
         * @event _converse#headlinesFeedInitialized
         * @type {HeadlinesFeed}
         * @example _converse.api.listen.on('headlinesFeedInitialized', model => { ... });
         */
        shared_api.trigger('headlinesFeedInitialized', this);
    }

    canPostMessages() {
        return false;
    }

    /**
     * @param {import('../../shared/message').default} message
     */
    isChatMessage(message) {
        const type = message.get('type');
        return type === this.get('message_type') || type === 'normal';
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/headlines/api.js
/**
 * @typedef {import('./feed.js').default} HeadlinesFeed
 */




/* export default */ const headlines_api = ({
    /**
     * The "headlines" namespace, which is used for headline-channels
     * which are read-only channels containing messages of type
     * "headline".
     *
     * @namespace api.headlines
     * @memberOf api
     */
    headlines: {
        /**
         * Retrieves a headline-channel or all headline-channels.
         *
         * @method api.headlines.get
         * @param {String|String[]} jids - e.g. 'buddy@example.com' or ['buddy1@example.com', 'buddy2@example.com']
         * @param { Object } [attrs] - Attributes to be set on the _converse.ChatBox model.
         * @param { Boolean } [create=false] - Whether the chat should be created if it's not found.
         * @returns { Promise<HeadlinesFeed[]|HeadlinesFeed> }
         */
        async get (jids, attrs={}, create=false) {
            /**
             * @param {string} jid
             * @returns {Promise<HeadlinesFeed>}
             */
            async function _get (jid) {
                let model = await shared_api.chatboxes.get(jid);
                if (!model && create) {
                    const { HeadlinesFeed } = shared_converse.exports;
                    model = await shared_api.chatboxes.create(jid, attrs, HeadlinesFeed);
                } else {
                    model = (model && model.get('type') === HEADLINES_TYPE) ? model : null;
                    if (model && Object.keys(attrs).length) {
                        model.save(attrs);
                    }
                }
                return model;
            }

            if (jids === undefined) {
                const chats = await shared_api.chatboxes.get();
                return chats?.filter(c => (c.get('type') === HEADLINES_TYPE)) ?? [];
            } else if (typeof jids === 'string') {
                return _get(jids);
            }
            return Promise.all(jids.map(jid => _get(jid)));
        }
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/headlines/utils.js







/**
 * Handler method for all incoming messages of type "headline".
 * @param { Element } stanza
 */
async function onHeadlineMessage (stanza) {
    if (isHeadline(stanza) || isServerMessage(stanza)) {
        const from_jid = stanza.getAttribute('from');

        await shared_api.waitUntil('rosterInitialized')
        if (from_jid.includes('@') &&
                !shared_converse.state.roster.get(from_jid) &&
                !shared_api.settings.get("allow_non_roster_messaging")) {
            return;
        }
        if (stanza.querySelector('body') === null) {
            // Avoid creating a chat box if we have nothing to show inside it.
            return;
        }

        const chatbox = await shared_api.chatboxes.create(from_jid, {
            'id': from_jid,
            'jid': from_jid,
            'type': HEADLINES_TYPE,
            'from': from_jid
        }, feed_HeadlinesFeed);

        const attrs = await parseMessage(stanza);
        await chatbox.createMessage(attrs);
        shared_api.trigger('message', {chatbox, stanza, attrs});
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/headlines/index.js
/**
 * @module converse-headlines
 * @copyright 2022, the Converse.js contributors
 */








api_public.plugins.add('converse-headlines', {
    dependencies: ["converse-chat"],

    initialize () {
        const exports = { HeadlinesFeed: feed_HeadlinesFeed };
        Object.assign(shared_converse, exports); // XXX: DEPRECATED
        Object.assign(shared_converse.exports, exports);

        function registerHeadlineHandler () {
            shared_api.connection.get()?.addHandler(m => {
                onHeadlineMessage(m);
                return true; // keep the handler
            }, null, 'message');
        }
        shared_api.listen.on('connected', registerHeadlineHandler);
        shared_api.listen.on('reconnected', registerHeadlineHandler);

        Object.assign(shared_api, headlines_api);

        shared_api.chatboxes.registry.add(HEADLINES_TYPE, feed_HeadlinesFeed);
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/constants.js
const UNDECIDED = 0;
const TRUSTED = 1;
const UNTRUSTED = -1;

const TAG_LENGTH = 128;

const KEY_ALGO = {
    'name': 'AES-GCM',
    'length': 128
};

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/devicelist.js









const { Strophe: devicelist_Strophe, stx: devicelist_stx, sizzle: devicelist_sizzle, u: devicelist_u } = api_public.env;

class DeviceList extends skeletor.Model {
    get idAttribute() {
        return "jid";
    }

    async initialize() {
        super.initialize();
        this.initialized = getOpenPromise();
        await this.initDevices();
        this.initialized.resolve();
    }

    initDevices() {
        this.devices = new shared_converse.exports.Devices();
        const bare_jid = shared_converse.session.get("bare_jid");
        const id = `converse.devicelist-${bare_jid}-${this.get("jid")}`;
        devicelist_u.initStorage(this.devices, id);
        return this.fetchDevices();
    }

    /**
     * @param {import('./devices').default} collection
     */
    async onDevicesFound(collection) {
        if (collection.length === 0) {
            let ids = [];
            try {
                ids = await this.fetchDevicesFromServer();
            } catch (e) {
                if (e === null) {
                    src_log.error(`Timeout error while fetching OMEMO devices for ${this.get("jid")}`);
                    this.destroy();
                } else if (devicelist_u.isElement(e) && (await parseErrorStanza(e)) instanceof ItemNotFoundError) {
                    src_log.debug(`No OMEMO devices found for ${this.get("jid")}`);
                } else {
                    src_log.error(`Could not fetch OMEMO devices for ${this.get("jid")}`);
                    src_log.error(e);
                    this.destroy();
                }
            }
            const bare_jid = shared_converse.session.get("bare_jid");
            if (this.get("jid") === bare_jid) {
                this.publishCurrentDevice(ids);
            }
        }
    }

    fetchDevices() {
        if (this._devices_promise === undefined) {
            this._devices_promise = new Promise((resolve) => {
                this.devices.fetch({
                    success: (c) => resolve(this.onDevicesFound(c)),
                    error: (_, e) => {
                        src_log.error(e);
                        resolve();
                    },
                });
            });
        }
        return this._devices_promise;
    }

    /**
     * @returns {Promise<string>}
     */
    async getOwnDeviceId() {
        const { omemo_store } = shared_converse.state;
        let device_id = omemo_store.get("device_id");
        if (!this.devices.get(device_id)) {
            // Generate a new bundle if we cannot find our device
            await omemo_store.generateBundle();
            device_id = omemo_store.get("device_id");
        }
        return device_id;
    }

    /**
     * @param {string[]} device_ids
     */
    async publishCurrentDevice(device_ids) {
        const bare_jid = shared_converse.session.get("bare_jid");
        if (this.get("jid") !== bare_jid) {
            return; // We only publish for ourselves.
        }
        await shared_api.omemo.session.restore();

        if (!shared_converse.state.omemo_store) {
            // Happens during tests. The connection gets torn down
            // before publishCurrentDevice has time to finish.
            src_log.debug("publishCurrentDevice: omemo_store is not defined, likely a timing issue");
            return;
        }
        if (!device_ids.includes(await this.getOwnDeviceId())) {
            return this.publishDevices();
        }
    }

    /**
     * @returns {Promise<import('./device').default[]>}
     */
    async fetchDevicesFromServer() {
        const bare_jid = shared_converse.session.get("bare_jid");
        const stanza = devicelist_stx`
            <iq type='get' from='${bare_jid}' to='${this.get("jid")}' xmlns="jabber:client">
                <pubsub xmlns='${devicelist_Strophe.NS.PUBSUB}'>
                    <items node='${devicelist_Strophe.NS.OMEMO_DEVICELIST}'/>
                </pubsub>
            </iq>`;

        const iq = await shared_api.sendIQ(stanza);
        const selector = `list[xmlns="${devicelist_Strophe.NS.OMEMO}"] device`;
        const device_ids = devicelist_sizzle(selector, iq).map((d) => d.getAttribute("id"));
        const jid = this.get("jid");
        return Promise.all(device_ids.map((id) => this.devices.create({ id, jid }, { promise: true })));
    }

    /**
     * Sends an IQ stanza to the current user's "devices" PEP node to
     * ensure that all devices are published for potential chat partners to see.
     * See: https://xmpp.org/extensions/attic/xep-0384-0.3.0.html#usecases-announcing
     */
    publishDevices() {
        const item = devicelist_stx`
            <item id='current'>
                <list xmlns='${devicelist_Strophe.NS.OMEMO}'>
                    ${this.devices.filter((d) => d.get("active")).map((d) => devicelist_stx`<device id='${d.get("id")}'/>`)}
                </list>
            </item>`;
        const options = { access_model: "open" };
        return shared_api.pubsub.publish(null, devicelist_Strophe.NS.OMEMO_DEVICELIST, item, options, false);
    }

    /**
     * @param {string[]} device_ids
     */
    async removeOwnDevices(device_ids) {
        const bare_jid = shared_converse.session.get("bare_jid");
        if (this.get("jid") !== bare_jid) {
            throw new Error("Cannot remove devices from someone else's device list");
        }
        await Promise.all(
            device_ids
                .map((id) => this.devices.get(id))
                .map(
                    (d) =>
                        new Promise((resolve) =>
                            d.destroy({
                                success: resolve,
                                error: (_, e) => {
                                    src_log.error(e);
                                    resolve();
                                },
                            })
                        )
                )
        );
        return this.publishDevices();
    }
}

/* export default */ const omemo_devicelist = (DeviceList);

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/devicelists.js



/**
 * @extends {Collection<DeviceList>}
 */
class DeviceLists extends skeletor.Collection {
    constructor() {
        super();
        this.model = omemo_devicelist;
    }
}

/* export default */ const omemo_devicelists = (DeviceLists);

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/utils.js











const { u: omemo_utils_u, Strophe: omemo_utils_Strophe, stx: omemo_utils_stx } = api_public.env;
const { arrayBufferToHex: utils_arrayBufferToHex, base64ToArrayBuffer: utils_base64ToArrayBuffer } = omemo_utils_u;

/**
 * @param {Element} stanza
 */
async function updateDevicesFromStanza(stanza) {
    const items_el = sizzle_default()(`items[node="${omemo_utils_Strophe.NS.OMEMO_DEVICELIST}"]`, stanza).pop();
    if (!items_el) return;

    const device_selector = `item list[xmlns="${omemo_utils_Strophe.NS.OMEMO}"] device`;
    const device_ids = sizzle_default()(device_selector, items_el).map((d) => d.getAttribute('id'));
    const jid = stanza.getAttribute('from');
    const devicelist = await shared_api.omemo.devicelists.get(jid, true);
    const devices = devicelist.devices;
    const removed_ids = devices.pluck('id').filter(/** @param {string} id */ (id) => !device_ids.includes(id));

    const bare_jid = shared_converse.session.get('bare_jid');

    removed_ids.forEach(
        /** @param {string} id */ (id) => {
            if (jid === bare_jid && id === shared_converse.state.omemo_store.get('device_id')) {
                return; // We don't set the current device as inactive
            }
            devices.get(id).save('active', false);
        }
    );
    device_ids.forEach(
        /** @param {string} device_id */ (device_id) => {
            const device = devices.get(device_id);
            if (device) {
                device.save('active', true);
            } else {
                devices.create({ id: device_id, jid });
            }
        }
    );
    if (omemo_utils_u.isSameBareJID(bare_jid, jid)) {
        // Make sure our own device is on the list
        // (i.e. if it was removed, add it again).
        devicelist.publishCurrentDevice(device_ids);
    }
}

/**
 * @param {Element} stanza
 */
async function updateBundleFromStanza(stanza) {
    const items_el = sizzle_default()(`items`, stanza).pop();
    if (!items_el || !items_el.getAttribute('node').startsWith(omemo_utils_Strophe.NS.OMEMO_BUNDLES)) {
        return;
    }
    const device_id = items_el.getAttribute('node').split(':')[1];
    const jid = stanza.getAttribute('from');
    const bundle_el = sizzle_default()(`item > bundle`, items_el).pop();
    const devicelist = await shared_api.omemo.devicelists.get(jid, true);
    const device = devicelist.devices.get(device_id) || devicelist.devices.create({ 'id': device_id, jid });
    const bundle = omemo_utils_u.omemo.parseBundle(bundle_el);
    device.save({ bundle });
}

/**
 * @param {Element} message
 */
async function handlePEPPush(message) {
    try {
        if (sizzle_default()(`event[xmlns="${omemo_utils_Strophe.NS.PUBSUB}#event"]`, message).length) {
            await shared_api.waitUntil('OMEMOInitialized');
            await updateDevicesFromStanza(message);
            await updateBundleFromStanza(message);
        }
    } catch (e) {
        src_log.error(e);
    }
}

/**
 * Register a pubsub handler for devices pushed from other connected clients
 */
function utils_registerPEPPushHandler() {
    shared_api.connection.get().addHandler(
        /** @param {Element} message */
        (message) => {
            handlePEPPush(message);
            return true;
        },
        null,
        'message'
    );
}

async function fetchDeviceLists() {
    const bare_jid = shared_converse.session.get('bare_jid');

    shared_converse.state.devicelists = new omemo_devicelists();
    const id = `converse.devicelists-${bare_jid}`;
    initStorage(shared_converse.state.devicelists, id);
    await new Promise((resolve) => {
        shared_converse.state.devicelists.fetch({
            success: resolve,
            /**
             * @param {unknown} _m
             * @param {unknown} e
             */
            error: (_m, e) => {
                src_log.error(e);
                resolve();
            },
        });
    });
    // Call API method to wait for our own device list to be fetched from the
    // server or to be created. If we have no pre-existing OMEMO session, this
    // will cause a new device and bundle to be generated and published.
    await shared_api.omemo.devicelists.get(bare_jid, true);
}

/**
 * @param {boolean} reconnecting
 */
async function initOMEMO(reconnecting) {
    if (reconnecting) {
        return;
    }
    if (!shared_converse.state.config.get('trusted') || shared_api.settings.get('clear_cache_on_logout')) {
        src_log.warn('Not initializing OMEMO, since this browser is not trusted or clear_cache_on_logout is set to true');
        return;
    }
    try {
        await fetchDeviceLists();
        await shared_api.omemo.session.restore();
        await shared_converse.state.omemo_store.publishBundle();
    } catch (e) {
        src_log.error('Could not initialize OMEMO support');
        src_log.error(e);
        return;
    }
    /**
     * Triggered once OMEMO support has been initialized
     * @event _converse#OMEMOInitialized
     * @example _converse.api.listen.on('OMEMOInitialized', () => { ... });
     */
    shared_api.trigger('OMEMOInitialized');
}

/**
 * @param {String} jid - The Jabber ID for which the device list will be returned.
 * @param {boolean} [create=false] - Set to `true` if the device list
 *      should be created if it cannot be found.
 */
async function getDeviceList(jid, create = false) {
    const { devicelists } = shared_converse.state;
    const list = devicelists.get(jid) || (create ? devicelists.create({ jid }) : null);
    await list?.initialized;
    return list;
}

/**
 * @param {import('./device.js').default} device
 */
async function generateFingerprint(device) {
    if (device.get('bundle')?.fingerprint) {
        return;
    }
    const bundle = await device.getBundle();
    bundle['fingerprint'] = utils_arrayBufferToHex(utils_base64ToArrayBuffer(bundle['identity_key']));
    device.save('bundle', bundle);
    device.trigger('change:bundle'); // Doesn't get triggered automatically due to pass-by-reference
}

/**
 * @param {Error|errors.IQError|errors.UserFacingError} e
 * @param {import('../../shared/chatbox.js').default} chat
 */
function handleMessageSendError(e, chat) {
    const { __ } = shared_converse;
    if (e instanceof IQError) {
        chat.save('omemo_supported', false);

        const err_msgs = [];
        if (sizzle_default()(`presence-subscription-required[xmlns="${omemo_utils_Strophe.NS.PUBSUB_ERROR}"]`, e.iq).length) {
            err_msgs.push(
                __(
                    "Sorry, we're unable to send an encrypted message because %1$s " +
                        'requires you to be subscribed to their presence in order to see their OMEMO information',
                    e.iq.getAttribute('from')
                )
            );
        } else if (sizzle_default()(`remote-server-not-found[xmlns="urn:ietf:params:xml:ns:xmpp-stanzas"]`, e.iq).length) {
            err_msgs.push(
                __(
                    "Sorry, we're unable to send an encrypted message because the remote server for %1$s could not be found",
                    e.iq.getAttribute('from')
                )
            );
        } else {
            err_msgs.push(__('Unable to send an encrypted message due to an unexpected error.'));
            err_msgs.push(e.iq.outerHTML);
        }
        shared_api.alert('error', __('Error'), err_msgs);
    } else if (e instanceof UserFacingError) {
        shared_api.alert('error', __('Error'), [e.message]);
    }
    throw e;
}

/**
 * @param {string} jid
 * @returns {Promise<import('./devices.js').default>}
 */
async function getDevicesForContact(jid) {
    await shared_api.waitUntil('OMEMOInitialized');
    const devicelist = await shared_api.omemo.devicelists.get(jid, true);
    await devicelist.fetchDevices();
    return devicelist.devices;
}

/**
 * @param {string} jid
 * @param {number} id
 */
function getSessionCipher(jid, id) {
    const { libsignal } = /** @type import('./types').WindowWithLibsignal */ (window);
    const address = new libsignal.SignalProtocolAddress(jid, id);
    return new libsignal.SessionCipher(shared_converse.state.omemo_store, address);
}

/**
 * @param {ArrayBuffer} key_and_tag
 * @param {import('./device.js').default} device
 */
function encryptKey(key_and_tag, device) {
    return getSessionCipher(device.get('jid'), Number(device.get('id')))
        .encrypt(key_and_tag)
        .then(/** @param {ArrayBuffer} payload */ (payload) => ({ payload, device }));
}

/**
 * @param {import('./device.js').default} device
 */
async function buildSession(device) {
    const { libsignal } = /** @type import('./types').WindowWithLibsignal */ (window);
    const address = new libsignal.SignalProtocolAddress(device.get('jid'), device.get('id'));
    const sessionBuilder = new libsignal.SessionBuilder(shared_converse.state.omemo_store, address);
    const prekey = device.getRandomPreKey();
    const bundle = await device.getBundle();
    const device_id = device.get('id');

    return sessionBuilder.processPreKey({
        registrationId: typeof device_id === 'string' ? parseInt(device_id, 10) : device_id,
        identityKey: utils_base64ToArrayBuffer(bundle.identity_key),
        signedPreKey: {
            keyId: bundle.signed_prekey.id, // <Number>
            publicKey: utils_base64ToArrayBuffer(bundle.signed_prekey.public_key),
            signature: utils_base64ToArrayBuffer(bundle.signed_prekey.signature),
        },
        preKey: {
            keyId: prekey.id, // <Number>
            publicKey: utils_base64ToArrayBuffer(prekey.key),
        },
    });
}

/**
 * @param {import('./device.js').default} device
 */
async function getSession(device) {
    if (!device.get('bundle')) {
        src_log.error(`Could not build an OMEMO session for device ${device.get('id')} because we don't have its bundle`);
        return null;
    }
    const { libsignal } = /** @type import('./types').WindowWithLibsignal */ (window);
    const address = new libsignal.SignalProtocolAddress(device.get('jid'), device.get('id'));
    const session = await shared_converse.state.omemo_store.loadSession(address.toString());
    if (session) {
        return session;
    } else {
        try {
            return await buildSession(device);
        } catch (e) {
            src_log.error(`Could not build an OMEMO session for device ${device.get('id')}`);
            src_log.error(e);
            return null;
        }
    }
}

/**
 * @param {import('../../shared/chatbox.js').default} chatbox
 * @returns {Promise<import('./device.js').default[]>}
 */
async function getBundlesAndBuildSessions(chatbox) {
    /**
     * @typedef {import('./device.js').default} Device
     */
    const { __ } = shared_converse;
    const no_devices_err = __('Sorry, no devices found to which we can send an OMEMO encrypted message.');
    let devices;
    if (chatbox instanceof muc_muc) {
        const collections = await Promise.all(
            chatbox.occupants.map(
                /** @param {import('../../plugins/muc/occupant').default} o */
                (o) => getDevicesForContact(o.get('jid'))
            )
        );
        devices = collections.reduce((a, b) => a.concat(b.models), []);
    } else if (chatbox.get('type') === PRIVATE_CHAT_TYPE) {
        const their_devices = await getDevicesForContact(chatbox.get('jid'));
        if (their_devices.length === 0) {
            throw new UserFacingError(no_devices_err);
        }
        const bare_jid = shared_converse.session.get('bare_jid');
        const own_list = await shared_api.omemo.devicelists.get(bare_jid);
        const own_devices = own_list.devices;
        devices = [...own_devices.models, ...their_devices.models];
    }
    // Filter out our own device
    const id = shared_converse.state.omemo_store.get('device_id');
    devices = devices.filter(/** @param {Device} d */ (d) => d.get('id') !== id);

    // Fetch bundles if necessary
    await Promise.all(devices.map(/** @param {Device} d */ (d) => d.getBundle()));

    const sessions = await Promise.all(
        devices.map(
            /** @param {Device} [d] */ (d) => {
                return (d && getSession(d)) || null;
            }
        )
    );

    if (sessions.includes(null)) {
        // We couldn't build a session for certain devices.
        devices = devices.filter(/** @param {Device} d */ (d) => sessions[devices.indexOf(d)]);
        if (devices.length === 0) {
            throw new UserFacingError(no_devices_err);
        }
    }
    return devices;
}

/**
 * @param {string} plaintext
 * @returns {Promise<import('./types').EncryptedMessage>}
 */
async function encryptMessage(plaintext) {
    // The client MUST use fresh, randomly generated key/IV pairs
    // with AES-128 in Galois/Counter Mode (GCM).

    // For GCM a 12 byte IV is strongly suggested as other IV lengths
    // will require additional calculations. In principle any IV size
    // can be used as long as the IV doesn't ever repeat. NIST however
    // suggests that only an IV size of 12 bytes needs to be supported
    // by implementations.
    //
    // https://crypto.stackexchange.com/questions/26783/ciphertext-and-tag-size-and-iv-transmission-with-aes-in-gcm-mode
    const iv = crypto.getRandomValues(new window.Uint8Array(12));
    const key = await crypto.subtle.generateKey(KEY_ALGO, true, ['encrypt', 'decrypt']);
    const algo = /** @type {AesGcmParams} */ {
        iv,
        name: 'AES-GCM',
        tagLength: TAG_LENGTH,
    };
    const encrypted = await crypto.subtle.encrypt(algo, key, omemo_utils_u.stringToArrayBuffer(plaintext));
    const length = encrypted.byteLength - ((128 + 7) >> 3);
    const ciphertext = encrypted.slice(0, length);
    const tag = encrypted.slice(length);
    const exported_key = await crypto.subtle.exportKey('raw', key);
    return {
        tag,
        key: exported_key,
        key_and_tag: omemo_utils_u.appendArrayBuffer(exported_key, tag),
        payload: omemo_utils_u.arrayBufferToBase64(ciphertext),
        iv: omemo_utils_u.arrayBufferToBase64(iv),
    };
}

/**
 * @param {import('./types').EncryptedMessage} obj
 * @returns {Promise<string>}
 */
async function decryptMessage(obj) {
    const key_obj = await crypto.subtle.importKey('raw', obj.key, KEY_ALGO, true, ['encrypt', 'decrypt']);
    const cipher = omemo_utils_u.appendArrayBuffer(omemo_utils_u.base64ToArrayBuffer(obj.payload), obj.tag);
    const algo = /** @type {AesGcmParams} */ {
        name: 'AES-GCM',
        iv: omemo_utils_u.base64ToArrayBuffer(obj.iv),
        tagLength: TAG_LENGTH,
    };
    return omemo_utils_u.arrayBufferToString(await crypto.subtle.decrypt(algo, key_obj, cipher));
}

/**
 * @param {import('../../shared/chatbox.js').default} chat
 * @param {import('../../shared/types').MessageAndStanza} data
 * @return {Promise<import('../../shared/types').MessageAndStanza>}
 */
async function createOMEMOMessageStanza(chat, data) {
    let { stanza } = data;
    const { message } = data;
    if (!message.get('is_encrypted')) {
        return data;
    }
    if (!message.get('body')) {
        throw new Error('No message body to encrypt!');
    }
    const devices = await getBundlesAndBuildSessions(chat);
    const { key_and_tag, iv, payload } = await encryptMessage(message.get('plaintext'));

    // The 16 bytes key and the GCM authentication tag (The tag
    // SHOULD have at least 128 bit) are concatenated and for each
    // intended recipient device, i.e. both own devices as well as
    // devices associated with the contact, the result of this
    // concatenation is encrypted using the corresponding
    // long-standing SignalProtocol session.
    const dicts = await Promise.all(
        devices
            .filter((device) => device.get('trusted') != UNTRUSTED && device.get('active'))
            .map((device) => encryptKey(key_and_tag, device))
    );

    // An encrypted header is added to the message for
    // each device that is supposed to receive it.
    // These headers simply contain the key that the
    // payload message is encrypted with,
    // and they are separately encrypted using the
    // session corresponding to the counterpart device.
    stanza
        .cnode(
            omemo_utils_stx`
            <encrypted xmlns="${omemo_utils_Strophe.NS.OMEMO}">
                <header sid="${shared_converse.state.omemo_store.get('device_id')}">
                    ${dicts.map(({ payload, device }) => {
                        const prekey = 3 == parseInt(payload.type, 10);
                        if (prekey) {
                            return omemo_utils_stx`<key rid="${device.get('id')}" prekey="true">${btoa(payload.body)}</key>`;
                        }
                        return omemo_utils_stx`<key rid="${device.get('id')}">${btoa(payload.body)}</key>`;
                    })}
                    <iv>${iv}</iv>
                </header>
                <payload>${payload}</payload>
            </encrypted>`
        )
        .root();

    stanza.cnode(omemo_utils_stx`<store xmlns="${omemo_utils_Strophe.NS.HINTS}"/>`).root();
    stanza.cnode(omemo_utils_stx`<encryption xmlns="${omemo_utils_Strophe.NS.EME}" namespace="${omemo_utils_Strophe.NS.OMEMO}"/>`).root();
    return { message, stanza };
}

/**
 * @param {import('../../shared/chatbox.js').default} chat
 * @param {import('../../shared/types').MessageAttributes} attrs
 * @return {import('../../shared/types').MessageAttributes}
 */
function getOutgoingMessageAttributes(chat, attrs) {
    const { __ } = shared_converse;
    if (chat.get('omemo_active') && attrs.body) {
        return {
            ...attrs,
            is_encrypted: true,
            plaintext: attrs.body,
            body: __(
                'This is an OMEMO encrypted message which your client doesn’t seem to support. ' +
                    'Find more information on https://conversations.im/omemo'
            ),
        };
    }
    return attrs;
}

/**
 * @param {string} jid
 */
async function contactHasOMEMOSupport(jid) {
    /* Checks whether the contact advertises any OMEMO-compatible devices. */
    const devices = await omemo_utils_u.omemo.getDevicesForContact(jid);
    return devices.length > 0;
}

/**
 * @param {import('../../shared/chatbox.js').default} chatbox
 */
async function checkOMEMOSupported(chatbox) {
    let supported;
    if (chatbox.get('type') === CHATROOMS_TYPE) {
        await shared_api.waitUntil('OMEMOInitialized');
        const { features } = /** @type {MUC} */ (chatbox);
        supported = features.get('nonanonymous') && features.get('membersonly');
    } else if (chatbox.get('type') === PRIVATE_CHAT_TYPE) {
        supported = await contactHasOMEMOSupport(chatbox.get('jid'));
    }
    chatbox.set('omemo_supported', !!supported);
    if (supported && shared_api.settings.get('omemo_default')) {
        chatbox.set('omemo_active', true);
    }
}

/**
 * @param {MUC} chatroom
 * @param {import('../../plugins/muc/occupant').default} occupant
 */
async function onOccupantAdded(chatroom, occupant) {
    if (occupant.isSelf() || !chatroom.features.get('nonanonymous') || !chatroom.features.get('membersonly')) {
        return;
    }
    const { __ } = shared_converse;
    if (chatroom.get('omemo_active')) {
        const supported = await contactHasOMEMOSupport(occupant.get('jid'));
        if (!supported) {
            chatroom.createMessage({
                'message': __(
                    "%1$s doesn't appear to have a client that supports OMEMO. " +
                        'Encrypted chat will no longer be possible in this grouchat.',
                    occupant.get('nick')
                ),
                'type': 'error',
            });
            chatroom.save({ 'omemo_active': false, 'omemo_supported': false });
        }
    }
}

/**
 * @param {import('../../shared/chatbox.js').default} chatbox
 */
function onChatInitialized(chatbox) {
    checkOMEMOSupported(chatbox);
    if (chatbox.get('type') === CHATROOMS_TYPE) {
        /** @type {MUC} */ (chatbox).occupants.on(
            'add',
            /** @param {import('../../plugins/muc/occupant').default} o */ (o) =>
                onOccupantAdded(/** @type {MUC} */ (chatbox), o)
        );
        /** @type {MUC} */ (chatbox).features.on('change', () => checkOMEMOSupported(chatbox));
    }
}

/**
 * @param {import('../../shared/message').default} message
 * @param {import('../../shared/types').FileUploadMessageAttributes} attrs
 */
function setEncryptedFileURL(message, attrs) {
    if (message.file.xep454_ivkey) {
        const url = attrs.oob_url.replace(/^https?:/, 'aesgcm:') + '#' + message.file.xep454_ivkey;
        return {
            ...attrs,
            ...{
                oob_url: null, // Since only the body gets encrypted, we don't set the oob_url
                message: url,
                body: url,
            },
        };
    }
    return attrs;
}

/**
 * @param {File} file
 * @returns {Promise<File>}
 */
async function encryptFile(file) {
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const key = await crypto.subtle.generateKey({ name: 'AES-GCM', length: 256 }, true, ['encrypt', 'decrypt']);
    const encrypted = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, key, await file.arrayBuffer());
    const exported_key = await window.crypto.subtle.exportKey('raw', key);
    const encrypted_file = new File([encrypted], file.name, { type: file.type, lastModified: file.lastModified });

    Object.assign(encrypted_file, { xep454_ivkey: utils_arrayBufferToHex(iv) + utils_arrayBufferToHex(exported_key) });
    return encrypted_file;
}

Object.assign(omemo_utils_u, {
    omemo: {
        ...omemo_utils_u.omemo,
        decryptMessage,
        encryptMessage,
        generateFingerprint,
        getDevicesForContact,
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/parsers.js
/**
 * @typedef {import('../..//shared/types').MessageAttributes} MessageAttributes
 * @typedef {import('../../plugins/muc/types').MUCMessageAttributes} MUCMessageAttributes
 */








const { Strophe: omemo_parsers_Strophe } = api_public.env;

function getDecryptionErrorAttributes(e) {
    const { __ } = shared_converse;
    return {
        'error_text':
            __('Sorry, could not decrypt a received OMEMO message due to an error.') + ` ${e.name} ${e.message}`,
        'error_condition': e.name,
        'error_message': e.message,
        'error_type': 'Decryption',
        'is_ephemeral': true,
        'is_error': true,
        'type': 'error',
    };
}

/**
 * We use the bare, real (i.e. non-MUC) JID as encrypted session identifier.
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 */
function getJIDForDecryption(attrs) {
    const { __ } = shared_converse;
    let from_jid;
    if (attrs.sender === 'me') {
        from_jid = shared_converse.session.get('bare_jid');
    } else if (attrs.contact_jid) {
        from_jid = attrs.contact_jid;
    } else if ('from_real_jid' in attrs) {
        from_jid = attrs.from_real_jid;
    } else {
        from_jid = attrs.from;
    }

    if (!from_jid) {
        Object.assign(attrs, {
            error_text: __(
                'Sorry, could not decrypt a received OMEMO ' +
                    "message because we don't have the XMPP address for that user."
            ),
            error_type: 'Decryption',
            is_ephemeral: true,
            is_error: true,
            type: 'error',
        });
        throw new Error('Could not find JID to decrypt OMEMO message for');
    }
    return from_jid;
}

/**
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 * @param {ArrayBuffer} key_and_tag
 */
async function handleDecryptedWhisperMessage(attrs, key_and_tag) {
    const from_jid = getJIDForDecryption(attrs);
    const devicelist = await shared_api.omemo.devicelists.get(from_jid, true);
    const encrypted = attrs.encrypted;
    let device = devicelist.devices.get(encrypted.device_id);
    if (!device) {
        device = await devicelist.devices.create({ 'id': encrypted.device_id, 'jid': from_jid }, { 'promise': true });
    }
    if (encrypted.payload) {
        const key = key_and_tag.slice(0, 16);
        const tag = key_and_tag.slice(16);
        const result = await decryptMessage({
            ...encrypted,
            payload: encrypted.payload,
            ...{ key, tag }
        });
        device.save('active', true);
        return result;
    }
}

/**
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 */
async function decryptWhisperMessage(attrs) {
    const from_jid = getJIDForDecryption(attrs);
    const session_cipher = getSessionCipher(from_jid, parseInt(attrs.encrypted.device_id, 10));
    const key = headless_utils.base64ToArrayBuffer(attrs.encrypted.key);
    try {
        const key_and_tag = await session_cipher.decryptWhisperMessage(key, 'binary');
        const plaintext = await handleDecryptedWhisperMessage(attrs, key_and_tag);
        return Object.assign(attrs, { plaintext });
    } catch (e) {
        src_log.error(`${e.name} ${e.message}`);
        return Object.assign(attrs, getDecryptionErrorAttributes(e));
    }
}

/**
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 */
async function decryptPrekeyWhisperMessage(attrs) {
    const from_jid = getJIDForDecryption(attrs);
    const session_cipher = getSessionCipher(from_jid, parseInt(attrs.encrypted.device_id, 10));
    const key = headless_utils.base64ToArrayBuffer(attrs.encrypted.key);
    let key_and_tag;
    try {
        key_and_tag = await session_cipher.decryptPreKeyWhisperMessage(key, 'binary');
    } catch (e) {
        // TODO from the XEP:
        // There are various reasons why decryption of an
        // OMEMOKeyExchange or an OMEMOAuthenticatedMessage
        // could fail. One reason is if the message was
        // received twice and already decrypted once, in this
        // case the client MUST ignore the decryption failure
        // and not show any warnings/errors. In all other cases
        // of decryption failure, clients SHOULD respond by
        // forcibly doing a new key exchange and sending a new
        // OMEMOKeyExchange with a potentially empty SCE
        // payload. By building a new session with the original
        // sender this way, the invalid session of the original
        // sender will get overwritten with this newly created,
        // valid session.
        src_log.error(`${e.name} ${e.message}`);
        return Object.assign(attrs, getDecryptionErrorAttributes(e));
    }
    // TODO from the XEP:
    // When a client receives the first message for a given
    // ratchet key with a counter of 53 or higher, it MUST send
    // a heartbeat message. Heartbeat messages are normal OMEMO
    // encrypted messages where the SCE payload does not include
    // any elements. These heartbeat messages cause the ratchet
    // to forward, thus consequent messages will have the
    // counter restarted from 0.
    try {
        const plaintext = await handleDecryptedWhisperMessage(attrs, key_and_tag);
        const { omemo_store } = shared_converse.state;
        await omemo_store.generateMissingPreKeys();
        await omemo_store.publishBundle();
        if (plaintext) {
            return Object.assign(attrs, { 'plaintext': plaintext });
        } else {
            return Object.assign(attrs, { 'is_only_key': true });
        }
    } catch (e) {
        src_log.error(`${e.name} ${e.message}`);
        return Object.assign(attrs, getDecryptionErrorAttributes(e));
    }
}

/**
 * Hook handler for {@link parseMessage} and {@link parseMUCMessage}, which
 * parses the passed in `message` stanza for OMEMO attributes and then sets
 * them on the attrs object.
 * @param {Element} stanza - The message stanza
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 * @returns {Promise<MUCMessageAttributes| MessageAttributes|
        import('./types').MUCMessageAttrsWithEncryption|import('./types').MessageAttrsWithEncryption>}
 */
async function parseEncryptedMessage(stanza, attrs) {
    if (
        shared_api.settings.get('clear_cache_on_logout') ||
        !attrs.is_encrypted ||
        attrs.encryption_namespace !== omemo_parsers_Strophe.NS.OMEMO
    ) {
        return attrs;
    }
    const encrypted_el = sizzle_default()(`encrypted[xmlns="${omemo_parsers_Strophe.NS.OMEMO}"]`, stanza).pop();
    const header = encrypted_el.querySelector('header');
    attrs.encrypted = { 'device_id': header.getAttribute('sid') };

    const device_id = await shared_api.omemo?.getDeviceID();
    const key = device_id && sizzle_default()(`key[rid="${device_id}"]`, encrypted_el).pop();
    if (key) {
        Object.assign(attrs.encrypted, {
            iv: header.querySelector('iv').textContent,
            key: key.textContent,
            payload: encrypted_el.querySelector('payload')?.textContent || null,
            prekey: ['true', '1'].includes(key.getAttribute('prekey')),
        });
    } else {
        return Object.assign(attrs, {
            error_condition: 'not-encrypted-for-this-device',
            error_type: 'Decryption',
            is_ephemeral: true,
            is_error: true,
            type: 'error',
        });
    }
    // https://xmpp.org/extensions/xep-0384.html#usecases-receiving
    if (attrs.encrypted.prekey === true) {
        return decryptPrekeyWhisperMessage(attrs);
    } else {
        return decryptWhisperMessage(attrs);
    }
}

/**
 * Given an XML element representing a user's OMEMO bundle, parse it
 * and return a map.
 * @param {Element} bundle_el
 * @returns {import('./types').Bundle}
 */
function parseBundle(bundle_el) {
    const signed_prekey_public_el = bundle_el.querySelector('signedPreKeyPublic');
    const signed_prekey_signature_el = bundle_el.querySelector('signedPreKeySignature');
    const prekeys = sizzle_default()(`prekeys > preKeyPublic`, bundle_el).map(
        /** @param {Element} el */ (el) => ({
            id: parseInt(el.getAttribute('preKeyId'), 10),
            key: el.textContent,
        })
    );
    return {
        identity_key: bundle_el.querySelector('identityKey').textContent.trim(),
        signed_prekey: {
            id: parseInt(signed_prekey_public_el.getAttribute('signedPreKeyId'), 10),
            public_key: signed_prekey_public_el.textContent,
            signature: signed_prekey_signature_el.textContent,
        },
        prekeys,
    };
}

Object.assign(headless_utils, {
    omemo: {
        ...headless_utils.omemo,
        parseBundle,
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/device.js









const { Strophe: device_Strophe, sizzle: device_sizzle, stx: device_stx, u: device_u } = api_public.env;

class Device extends skeletor.Model {
    defaults() {
        return {
            trusted: UNDECIDED,
            active: true,
        };
    }

    /**
     * @returns {import('./types').PreKey}
     */
    getRandomPreKey() {
        // XXX: assumes that the bundle has already been fetched
        const bundle = this.get("bundle");
        return bundle.prekeys[device_u.getRandomInt(bundle.prekeys.length)];
    }

    /**
     * Fetch the device's OMEMO bundle from the server.
     * A bundle is a collection of publicly accessible data that can
     * be used to build a session with a device, namely its public IdentityKey,
     * a signed PreKey with corresponding signature, and a list of (single use) PreKeys.
     * @returns {Promise<import('./types').Bundle>}
     */
    async fetchBundleFromServer() {
        const bare_jid = shared_converse.session.get("bare_jid");
        const stanza = device_stx`
            <iq type="get" from="${bare_jid}" to="${this.get("jid")}" xmlns="jabber:client">
                <pubsub xmlns="${device_Strophe.NS.PUBSUB}">
                    <items node="${device_Strophe.NS.OMEMO_BUNDLES}:${this.get("id")}"/>
                </pubsub>
            </iq>`;

        let iq;
        try {
            iq = await shared_api.sendIQ(stanza);
        } catch (iq) {
            src_log.error(`Could not fetch bundle for device ${this.get("id")} from ${this.get("jid")}`);
            src_log.error(iq);
            if (iq && iq.querySelector('error')) {
                throw new IQError('Could not fetch bundle', iq);
            }
            return null;
        }
        if (iq.querySelector("error")) {
            throw new IQError("Could not fetch bundle", iq);
        }
        const publish_el = device_sizzle(`items[node="${device_Strophe.NS.OMEMO_BUNDLES}:${this.get("id")}"]`, iq).pop();
        const bundle_el = device_sizzle(`bundle[xmlns="${device_Strophe.NS.OMEMO}"]`, publish_el).pop();
        const bundle = parseBundle(bundle_el);
        this.save("bundle", bundle);
        return bundle;
    }

    /**
     * Fetch and save the bundle information associated with
     * this device, if the information is not cached already.
     * @returns {Promise<import('./types').Bundle>}
     */
    getBundle() {
        if (this.get("bundle")) {
            return Promise.resolve(this.get("bundle"));
        } else {
            return this.fetchBundleFromServer();
        }
    }
}

/* export default */ const omemo_device = (Device);

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/devices.js



/**
 * @extends {Collection<Device>}
 */
class Devices extends skeletor.Collection {
    constructor() {
        super();
        this.model = omemo_device;
    }
}

/* export default */ const omemo_devices = (Devices);

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/store.js







const { Strophe: store_Strophe, stx: store_stx, u: store_u } = api_public.env;

class OMEMOStore extends skeletor.Model {
    /**
     * @typedef {Window & globalThis & {libsignal: any} } WindowWithLibsignal
     */
    get Direction() {
        return {
            SENDING: 1,
            RECEIVING: 2,
        };
    }

    /**
     * @returns {Promise<import('./types').KeyPair>}
     */
    getIdentityKeyPair() {
        const keypair = this.get('identity_keypair');
        return Promise.resolve({
            'privKey': store_u.base64ToArrayBuffer(keypair.privKey),
            'pubKey': store_u.base64ToArrayBuffer(keypair.pubKey),
        });
    }

    getLocalRegistrationId() {
        return Promise.resolve(parseInt(this.get('device_id'), 10));
    }

    /**
     * @param {string} identifier
     * @param {ArrayBuffer} identity_key
     * @param {unknown} _direction
     */
    isTrustedIdentity(identifier, identity_key, _direction) {
        if (identifier === null || identifier === undefined) {
            throw new Error("Can't check identity key for invalid key");
        }
        if (!(identity_key instanceof ArrayBuffer)) {
            throw new Error('Expected identity_key to be an ArrayBuffer');
        }
        const trusted = this.get('identity_key' + identifier);
        if (trusted === undefined) {
            return Promise.resolve(true);
        }
        return Promise.resolve(store_u.arrayBufferToBase64(identity_key) === trusted);
    }

    /**
     * @param {string} identifier
     */
    loadIdentityKey(identifier) {
        if (identifier === null || identifier === undefined) {
            throw new Error("Can't load identity_key for invalid identifier");
        }
        return Promise.resolve(store_u.base64ToArrayBuffer(this.get('identity_key' + identifier)));
    }

    /**
     * @param {string} identifier
     * @param {string} identity_key
     */
    saveIdentity(identifier, identity_key) {
        if (identifier === null || identifier === undefined) {
            throw new Error("Can't save identity_key for invalid identifier");
        }
        const { libsignal } = /** @type WindowWithLibsignal */ (window);
        const address = new libsignal.SignalProtocolAddress.fromString(identifier);
        const existing = this.get('identity_key' + address.getName());
        const b64_idkey = store_u.arrayBufferToBase64(identity_key);
        this.save('identity_key' + address.getName(), b64_idkey);

        if (existing && b64_idkey !== existing) {
            return Promise.resolve(true);
        } else {
            return Promise.resolve(false);
        }
    }

    getPreKeys() {
        return this.get('prekeys') || {};
    }

    /**
     * @param {string} key_id
     */
    loadPreKey(key_id) {
        const res = this.getPreKeys()[key_id];
        if (res) {
            return Promise.resolve({
                'privKey': store_u.base64ToArrayBuffer(res.privKey),
                'pubKey': store_u.base64ToArrayBuffer(res.pubKey),
            });
        }
        return Promise.resolve();
    }

    /**
     * @param {string} key_id
     * @param {import('./types').KeyPair} key_pair
     */
    storePreKey(key_id, key_pair) {
        const prekey = {};
        prekey[key_id] = {
            'pubKey': store_u.arrayBufferToBase64(key_pair.pubKey),
            'privKey': store_u.arrayBufferToBase64(key_pair.privKey),
        };
        this.save('prekeys', Object.assign(this.getPreKeys(), prekey));
        return Promise.resolve();
    }

    /**
     * @param {string} key_id
     */
    removePreKey(key_id) {
        const prekeys = { ...this.getPreKeys() };
        delete prekeys[key_id];
        this.save('prekeys', prekeys);
        return Promise.resolve();
    }

    /**
     * @param {string} _key_id
     * @returns {Promise<import('./types').KeyPair|void>}
     */
    loadSignedPreKey(_key_id) {
        const res = this.get('signed_prekey');
        if (res) {
            return Promise.resolve({
                'privKey': store_u.base64ToArrayBuffer(res.privKey),
                'pubKey': store_u.base64ToArrayBuffer(res.pubKey),
            });
        }
        return Promise.resolve();
    }

    /**
     * @param {import('./types').SignedPreKey} spk
     */
    storeSignedPreKey(spk) {
        if (typeof spk !== 'object') {
            // XXX: We've changed the signature of this method from the
            // example given in InMemorySignalProtocolStore.
            // Should be fine because the libsignal code doesn't
            // actually call this method.
            throw new Error('storeSignedPreKey: expected an object');
        }
        this.save('signed_prekey', {
            'id': spk.keyId,
            'privKey': store_u.arrayBufferToBase64(spk.keyPair.privKey),
            'pubKey': store_u.arrayBufferToBase64(spk.keyPair.pubKey),
            // XXX: The InMemorySignalProtocolStore does not pass
            // in or store the signature, but we need it when we
            // publish our bundle and this method isn't called from
            // within libsignal code, so we modify it to also store
            // the signature.
            'signature': store_u.arrayBufferToBase64(spk.signature),
        });
        return Promise.resolve();
    }

    /**
     * @param {string} key_id
     */
    removeSignedPreKey(key_id) {
        if (this.get('signed_prekey')['id'] === key_id) {
            this.unset('signed_prekey');
            this.save();
        }
        return Promise.resolve();
    }

    /**
     * @param {string} identifier
     */
    loadSession(identifier) {
        return Promise.resolve(this.get('session' + identifier));
    }

    /**
     * @param {string} identifier
     * @param {object} record
     */
    storeSession(identifier, record) {
        return Promise.resolve(this.save('session' + identifier, record));
    }

    /**
     * @param {string} identifier
     */
    removeSession(identifier) {
        return Promise.resolve(this.unset('session' + identifier));
    }

    /**
     * @param {string} [identifier='']
     */
    removeAllSessions(identifier='') {
        const keys = Object.keys(this.attributes).filter((key) =>
            key.startsWith('session' + identifier) ? key : false
        );
        const attrs = {};
        keys.forEach((key) => {
            attrs[key] = undefined;
        });
        this.save(attrs);
        return Promise.resolve();
    }

    publishBundle() {
        const signed_prekey = this.get('signed_prekey');
        const node = `${store_Strophe.NS.OMEMO_BUNDLES}:${this.get('device_id')}`;
        const item = store_stx`
            <item>
                <bundle xmlns="${store_Strophe.NS.OMEMO}">
                    <signedPreKeyPublic signedPreKeyId="${signed_prekey.id}">${signed_prekey.pubKey}</signedPreKeyPublic>
                    <signedPreKeySignature>${signed_prekey.signature}</signedPreKeySignature>
                    <identityKey>${this.get('identity_keypair').pubKey}</identityKey>
                    <prekeys>${Object.values(this.get('prekeys')).map(
                        (prekey, id) => store_stx`<preKeyPublic preKeyId="${id}">${prekey.pubKey}</preKeyPublic>`
                    )}
                    </prekeys>
                </bundle>
            </item>`;
        const options = { access_model: 'open' };
        return shared_api.pubsub.publish(null, node, item, options, false);
    }

    async generateMissingPreKeys() {
        const { libsignal } = /** @type WindowWithLibsignal */ (window);
        const { KeyHelper } = libsignal;

        const prekeyIds = Object.keys(this.getPreKeys());
        const missing_keys = Array.from({ length: shared_converse.NUM_PREKEYS }, (_, id) => id.toString()).filter(
            (id) => !prekeyIds.includes(id)
        );

        if (missing_keys.length < 1) {
            src_log.debug('No missing prekeys to generate for our own device');
            return Promise.resolve();
        }

        const keys = await Promise.all(missing_keys.map((id) => KeyHelper.generatePreKey(parseInt(id, 10))));
        keys.forEach((k) => this.storePreKey(k.keyId, k.keyPair));

        const prekeys = this.getPreKeys();
        const marshalled_keys = Object.keys(prekeys).map((id) => ({
            id,
            key: prekeys[id].pubKey,
        }));

        const bare_jid = shared_converse.session.get('bare_jid');
        const devicelist = await getDeviceList(bare_jid);
        const device = devicelist.devices.get(this.get('device_id'));
        const bundle = await device.getBundle();
        device.save('bundle', Object.assign(bundle, { 'prekeys': marshalled_keys }));
    }

    /**
     * Generates, stores and then returns pre-keys.
     *
     * Pre-keys are one half of a X3DH key exchange and are published as part
     * of the device bundle.
     *
     * For a new contact or device to establish an encrypted session, it needs
     * to use a pre-key, which it chooses randomly from the list of available
     * ones.
     */
    async generatePreKeys() {
        const amount = shared_converse.NUM_PREKEYS;
        const { libsignal } = /** @type WindowWithLibsignal */ (window);
        const { KeyHelper } = libsignal;
        const keys = await Promise.all([...Array(amount).keys()].map((id) => KeyHelper.generatePreKey(id)));

        keys.forEach((k) => this.storePreKey(k.keyId, k.keyPair));

        return keys.map((k) => ({
            id: k.keyId,
            key: store_u.arrayBufferToBase64(k.keyPair.pubKey),
        }));
    }

    /**
     * Generate the cryptographic data used by the X3DH key agreement protocol
     * in order to build a session with other devices.
     *
     * By generating a bundle, and publishing it via PubSub, we allow other
     * clients to download it and start asynchronous encrypted sessions with us,
     * even if we're offline at that time.
     */
    async generateBundle() {
        const { libsignal } = /** @type WindowWithLibsignal */ (window);

        // The first thing that needs to happen if a client wants to
        // start using OMEMO is they need to generate an IdentityKey
        // and a Device ID.

        // The IdentityKey is a Curve25519 public/private Key pair.
        const identity_keypair = await libsignal.KeyHelper.generateIdentityKeyPair();
        const identity_key = store_u.arrayBufferToBase64(identity_keypair.pubKey);

        // The Device ID is a randomly generated integer between 1 and 2^31 - 1.
        const device_id = await generateDeviceID();

        this.save({
            device_id,
            identity_key,
            identity_keypair: {
                privKey: store_u.arrayBufferToBase64(identity_keypair.privKey),
                pubKey: identity_key,
            },
        });

        const signed_prekey = await libsignal.KeyHelper.generateSignedPreKey(identity_keypair, 0);
        this.storeSignedPreKey(signed_prekey);

        const prekeys = await this.generatePreKeys();

        const bundle = { identity_key, device_id, prekeys };
        bundle['signed_prekey'] = {
            id: signed_prekey.keyId,
            public_key: store_u.arrayBufferToBase64(signed_prekey.keyPair.pubKey),
            signature: store_u.arrayBufferToBase64(signed_prekey.signature),
        };

        const bare_jid = shared_converse.session.get('bare_jid');
        const devicelist = await shared_api.omemo.devicelists.get(bare_jid);
        const device = await devicelist.devices.create({ id: bundle.device_id, 'jid': bare_jid }, { promise: true });
        device.save('bundle', bundle);
    }

    fetchSession() {
        if (this._setup_promise === undefined) {
            this._setup_promise = new Promise((resolve, reject) => {
                this.fetch({
                    success: () => {
                        if (!this.get('device_id')) {
                            this.generateBundle().then(resolve).catch(reject);
                        } else {
                            resolve();
                        }
                    },
                    /**
                     * @param {unknown} _model
                     * @param {unknown} resp
                     */
                    error: (_model, resp) => {
                        src_log.warn(`Could restore OMEMO session, we'll generate a new one: ${resp}`);
                        this.generateBundle().then(resolve).catch(reject);
                    },
                });
            });
        }
        return this._setup_promise;
    }
}

async function generateDeviceID() {
    /**
     * @typedef {module:plugins-omemo-index.WindowWithLibsignal} WindowWithLibsignal
     */
    const { libsignal } = /** @type WindowWithLibsignal */ (window);

    /* Generates a device ID, making sure that it's unique */
    const bare_jid = shared_converse.session.get('bare_jid');
    const devicelist = await getDeviceList(bare_jid, true);
    const existing_ids = devicelist.devices.pluck('id');
    let device_id = libsignal.KeyHelper.generateRegistrationId();

    // Before publishing a freshly generated device id for the first time,
    // a device MUST check whether that device id already exists, and if so, generate a new one.
    let i = 0;
    while (existing_ids.includes(device_id)) {
        device_id = libsignal.KeyHelper.generateRegistrationId();
        i++;
        if (i === 10) {
            throw new Error('Unable to generate a unique device ID');
        }
    }
    return device_id.toString();
}

/* export default */ const store = (OMEMOStore);

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/api.js






/* export default */ const omemo_api = ({
    /**
     * The "omemo" namespace groups methods relevant to OMEMO
     * encryption.
     *
     * @namespace _converse.api.omemo
     * @memberOf _converse.api
     */
    omemo: {
        /**
         * Returns the device ID of the current device.
         */
        async getDeviceID() {
            await shared_api.waitUntil('OMEMOInitialized');
            return shared_converse.state.omemo_store.get('device_id');
        },

        session: {
            async restore() {
                const { state } = shared_converse;
                if (state.omemo_store === undefined) {
                    const { state } = shared_converse;
                    const bare_jid = shared_converse.session.get('bare_jid');
                    const id = `converse.omemosession-${bare_jid}`;
                    state.omemo_store = new store({ id });
                    initStorage(state.omemo_store, id);
                }
                await state.omemo_store.fetchSession();
            },
        },

        /**
         * The "devicelists" namespace groups methods related to OMEMO device lists
         *
         * @namespace _converse.api.omemo.devicelists
         * @memberOf _converse.api.omemo
         */
        devicelists: {
            /**
             * Returns the {@link DeviceList} for a particular JID.
             * The device list will be created if it doesn't exist already.
             * @method _converse.api.omemo.devicelists.get
             * @param {String} jid - The Jabber ID for which the device list will be returned.
             * @param {boolean} create=false - Set to `true` if the device list
             *      should be created if it cannot be found.
             */
            async get(jid, create = false) {
                return await getDeviceList(jid, create);
            },
        },

        /**
         * The "bundle" namespace groups methods relevant to the user's OMEMO bundle.
         * @namespace _converse.api.omemo.bundle
         * @memberOf _converse.api.omemo
         */
        bundle: {
            /**
             * Lets you generate a new OMEMO device bundle
             *
             * @method _converse.api.omemo.bundle.generate
             * @returns {promise} Promise which resolves once we have a result from the server.
             */
            async generate() {
                await shared_api.waitUntil('OMEMOInitialized');
                // Remove current device
                const bare_jid = shared_converse.session.get('bare_jid');
                const devicelist = await shared_api.omemo.devicelists.get(bare_jid);

                const { omemo_store } = shared_converse.state;
                const device_id = omemo_store.get('device_id');
                if (device_id) {
                    const device = devicelist.devices.get(device_id);
                    omemo_store.unset(device_id);
                    if (device) {
                        await new Promise((done) => device.destroy({ 'success': done, 'error': done }));
                    }
                    devicelist.devices.trigger('remove');
                }

                // Generate new device bundle and publish
                // We'll need to create new sessions (i.e. send out new PreKeyWhisperMessage) when sending messages
                // See: https://xmpp.org/extensions/attic/xep-0384-0.3.0.html#usecases-announcing
                await omemo_store.generateBundle();
                await omemo_store.removeAllSessions();
                await omemo_store.publishBundle();
                await devicelist.publishDevices();

                const device = devicelist.devices.get(omemo_store.get('device_id'));
                return generateFingerprint(device);
            },
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/plugin.js












const { u: plugin_u, Strophe: omemo_plugin_Strophe } = api_public.env;

api_public.plugins.add('converse-omemo', {
    dependencies: ['converse-pubsub', 'converse-profile'],

    /**
     * @param {import('../../shared/_converse.js').ConversePrivateGlobal} _converse
     */
    enabled(_converse) {
        /**
         * @typedef {Window & globalThis & {libsignal: any} } WindowWithLibsignal
         */
        return (
            /** @type WindowWithLibsignal */ (window).libsignal &&
            _converse.state.config.get('trusted') &&
            !_converse.api.settings.get('clear_cache_on_logout') &&
            !_converse.api.settings.get('blacklisted_plugins').includes('converse-omemo')
        );
    },

    initialize() {
        shared_api.settings.extend({ omemo_default: false });
        shared_api.promises.add(['OMEMOInitialized']);

        const exports = {
            Device: omemo_device,
            Devices: omemo_devices,
            DeviceList: omemo_devicelist,
            DeviceLists: omemo_devicelists,
            OMEMOStore: store,
        };

        Object.assign(shared_converse.api, omemo_api);
        Object.assign(shared_converse, exports); // DEPRECATED
        Object.assign(shared_converse.exports, exports);

        shared_api.listen.on(
            'createMessageStanza',
            /**
             * @param {import('../../shared/chatbox.js').default} chat
             * @param {import('../../shared/types').MessageAndStanza} data
             */
            async (chat, data) => {
                try {
                    data = await createOMEMOMessageStanza(chat, data);
                } catch (e) {
                    handleMessageSendError(e, chat);
                }
                return data;
            }
        );

        shared_api.listen.on('connected', utils_registerPEPPushHandler);

        shared_api.listen.on('chatRoomInitialized', onChatInitialized);
        shared_api.listen.on('chatBoxInitialized', onChatInitialized);
        shared_api.listen.on('getOutgoingMessageAttributes', getOutgoingMessageAttributes);

        shared_api.listen.on('statusInitialized', initOMEMO);
        shared_api.listen.on('addClientFeatures', () => shared_api.disco.own.features.add(`${omemo_plugin_Strophe.NS.OMEMO_DEVICELIST}+notify`));

        shared_api.listen.on('parseMessage', parseEncryptedMessage);
        shared_api.listen.on('parseMUCMessage', parseEncryptedMessage);

        shared_api.listen.on('afterFileUploaded', setEncryptedFileURL);
        shared_api.listen.on(
            'beforeFileUpload',
            /**
             * @param {import('../../shared/chatbox.js').default} chat
             * @param {File} file
             */
            (chat, file) => (chat.get('omemo_active') ? encryptFile(file) : file)
        );

        shared_api.listen.on('clearSession', () => {
            delete shared_converse.state.omemo_store;
            if (plugin_u.shouldClearCache(shared_converse) && shared_converse.state.devicelists) {
                shared_converse.state.devicelists.clearStore();
                delete shared_converse.state.devicelists;
            }
        });
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/index.js







const { Strophe: omemo_Strophe } = api_public.env;

omemo_Strophe.addNamespace('OMEMO_DEVICELIST', omemo_Strophe.NS.OMEMO + '.devicelist');
omemo_Strophe.addNamespace('OMEMO_VERIFICATION', omemo_Strophe.NS.OMEMO + '.verification');
omemo_Strophe.addNamespace('OMEMO_WHITELISTED', omemo_Strophe.NS.OMEMO + '.whitelisted');
omemo_Strophe.addNamespace('OMEMO_BUNDLES', omemo_Strophe.NS.OMEMO + '.bundles');



;// CONCATENATED MODULE: ./src/headless/plugins/mam/placeholder.js




class MAMPlaceholderMessage extends skeletor.Model {
    defaults() {
        return {
            msgid: getUniqueId(),
            is_ephemeral: false,
        };
    }

    async fetchMissingMessages() {
        this.set("fetching", true);
        const options = {
            rsm: {
                before: this.get("before") ?? "", // We always query backwards (newest first)
            },
            mam: {
                start: this.get("start"),
            },
        };
        await headless_utils.mam.fetchArchivedMessages(this.collection.chatbox, options);
        this.destroy();
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/mam/utils.js
/**
 * @typedef {import('../muc/muc').default} MUC
 * @typedef {import('../chat/model').default} ChatBox
 * @typedef {import('@converse/skeletor').Model} Model
 */













const { NS: utils_NS } = Strophe;
const mam_utils_u = api_public.env.utils;
const { stx: mam_utils_stx } = api_public.env;

/**
 * @param {Element|Error} e
 * @param {Element} iq
 */
async function onMAMError(e, iq) {
    if (mam_utils_u.isElement(e)) {
        const err = await parseErrorStanza(e);
        if (err?.name === "feature-not-implemented") {
            src_log.warn(`Message Archive Management (XEP-0313) not supported by ${iq.getAttribute("to")}`);
            return;
        }
    }
    src_log.error(`Error while trying to set archiving preferences for ${iq.getAttribute("to")}.`);
    src_log.error(iq);
}

/**
 * Handle returned IQ stanza containing Message Archive
 * Management (XEP-0313) preferences.
 *
 * XXX: For now we only handle the global default preference.
 * The XEP also provides for per-JID preferences, which is
 * currently not supported in converse.js.
 *
 * Per JID preferences will be set in chat boxes, so it'll
 * probably be handled elsewhere in any case.
 *
 * @param {Element} iq
 * @param {Model} feature
 */
function onMAMPreferences(iq, feature) {
    const preference = sizzle_default()(`prefs[xmlns="${utils_NS.MAM}"]`, iq).pop();
    const default_pref = preference.getAttribute("default");
    if (default_pref !== shared_api.settings.get("message_archiving")) {
        const stanza = $iq({ "type": "set" }).c("prefs", {
            "xmlns": utils_NS.MAM,
            "default": shared_api.settings.get("message_archiving"),
        });
        Array.from(preference.children).forEach((child) => stanza.cnode(child).up());

        // XXX: Strictly speaking, the server should respond with the updated prefs
        // (see example 18: https://xmpp.org/extensions/xep-0313.html#config)
        // but Prosody doesn't do this, so we don't rely on it.
        shared_api.sendIQ(stanza)
            .then(() => feature.save({ "preferences": { "default": shared_api.settings.get("message_archiving") } }))
            .catch(/** @param {Error|Element} e */ (e) => shared_converse.exports.onMAMError(e, stanza.tree()));
    } else {
        feature.save({ "preferences": { "default": shared_api.settings.get("message_archiving") } });
    }
}

/**
 * @param {Model} feature
 */
function getMAMPrefsFromFeature(feature) {
    const prefs = feature.get("preferences") || {};
    if (feature.get("var") !== utils_NS.MAM || shared_api.settings.get("message_archiving") === undefined) {
        return;
    }
    if (prefs["default"] !== shared_api.settings.get("message_archiving")) {
        const stanza = mam_utils_stx`
            <iq type="get" xmlns="jabber:client">
                <prefs xmlns="${utils_NS.MAM}"></prefs>
            </iq>`;
        shared_api.sendIQ(stanza)
            .then(/** @param {Element} iq */ (iq) => shared_converse.exports.onMAMPreferences(iq, feature))
            .catch(/** @param {Error|Element} e */ (e) => shared_converse.exports.onMAMError(e, stanza.tree()));
    }
}

/**
 * @param {MUC} muc
 */
function preMUCJoinMAMFetch(muc) {
    if (
        !shared_api.settings.get("muc_show_logs_before_join") ||
        !muc.features.get("mam_enabled") ||
        muc.get("prejoin_mam_fetched")
    ) {
        return;
    }
    fetchNewestMessages(muc);
    muc.save({ prejoin_mam_fetched: true });
}

/**
 * @param {ChatBox|MUC} model
 * @param {Error|string} error
 */
async function createMessageFromError(model, error) {
    if (error instanceof TimeoutError) {
        const msg = await model.createMessage({
            type: "error",
            message: error.message,
            retry_event_id: error.retry_event_id,
            is_ephemeral: 20000,
        });
        msg.error = error;
    }
}

/**
 * @param {ChatBox|MUC} model
 * @param {Object} result
 * @param {Object} query
 * @param {Object} options
 * @param {('forwards'|'backwards'|false)} [should_page=false]
 */
async function handleMAMResult(model, result, query, options, should_page = false) {
    const is_muc = model.get("type") === CHATROOMS_TYPE;
    const doParseMessage = /** @param {Element} s*/ (s) =>
        is_muc ? parseMUCMessage(s, /** @type {MUC} */ (model)) : parseMessage(s);

    const messages = await Promise.all(result.messages.map(doParseMessage));
    result.messages = messages;

    /**
     * Synchronous event which allows listeners to first do some
     * work based on the MAM result before calling the handlers here.
     * @event _converse#MAMResult
     */
    const data = { query, "chatbox": model, messages };
    await shared_api.trigger("MAMResult", data, { "synchronous": true });

    messages.forEach((m) => model.queueMessage(m));
    if (result.error) {
        const event_id = (result.error.retry_event_id = mam_utils_u.getUniqueId());
        shared_api.listen.once(event_id, () => fetchArchivedMessages(model, options, should_page));
        createMessageFromError(model, result.error);
    }
}

/**
 * Fetch XEP-0313 archived messages based on the passed in criteria.
 * @param {ChatBox|MUC} model
 * @param {import('./types').FetchArchivedMessagesOptions} [options]
 * @param {('forwards'|'backwards'|false)} [should_page=false] - Determines whether
 *  this function should recursively page through the entire result set if a limited
 *  number of results were returned.
 */
async function fetchArchivedMessages(model, options = {}, should_page = false) {
    if (model.disable_mam) return;

    const is_muc = model.get("type") === CHATROOMS_TYPE;
    const bare_jid = shared_converse.session.get("bare_jid");
    const mam_jid = is_muc ? model.get("jid") : bare_jid;

    const supported = await shared_api.disco.supports(utils_NS.MAM, mam_jid);
    if (!supported) return;

    const max = shared_api.settings.get("archived_messages_page_size");
    const query = /** @type {import('./types').ArchiveQueryOptions} */ {
        is_groupchat: is_muc,
        rsm: {
            max,
            ...options.rsm,
        },
        mam: {
            with: model.get("jid"),
            ...options.mam,
        },
    };

    const result = await shared_api.archive.query(query);
    await handleMAMResult(model, result, query, options, should_page);

    if (result.rsm && !result.complete) {
        if (should_page) {
            if (should_page === "forwards") {
                options = result.rsm.next(max, options.rsm.before).query;
            } else if (should_page === "backwards") {
                options = result.rsm.previous(max, options.rsm.after).query;
            }
            return fetchArchivedMessages(model, options, should_page);
        } else {
            createGapPlaceholder(model, options, result);
        }
    }
}

/**
 * Creates a placeholder to fill gaps in the history.
 * @param {ChatBox|MUC} model
 * @param {import('./types').ArchiveQueryOptions} [options]
 * @param {import('./types').MAMQueryResult} [result]
 */
async function createGapPlaceholder(model, options, result) {
    const msgs = await Promise.all(result.messages);

    const is_muc = model.get("type") === CHATROOMS_TYPE;
    const mam_jid = is_muc ? model.get("jid") : shared_converse.session.get("bare_jid");

    const { rsm } = result;
    const key = `stanza_id ${mam_jid}`;
    const adjacent_message = msgs.find((m) => m[key] === rsm.result.first);
    const adjacent_message_date = new Date(adjacent_message["time"]);

    const msg_data = {
        before: rsm.result.first,
        start: options.mam?.start,
        template_hook: "getMessageTemplate",
        time: new Date(adjacent_message_date.getTime() - 1).toISOString(),
    };

    if (model.messages.findWhere(msg_data)) {
        src_log.debug("Gap placeholder already exists, not recreating.");
        return;
    }

    model.messages.add(new MAMPlaceholderMessage(msg_data));
}

/**
 * Creates a placeholder to fetch messages at the top of the chat history.
 * @param {ChatBox|MUC} model
 */
function createScrollupPlaceholder(model) {
    if (model.messages.length) {
        const is_muc = model.get("type") === CHATROOMS_TYPE;
        const mam_jid = is_muc ? model.get("jid") : shared_converse.session.get("bare_jid");
        const key = `stanza_id ${mam_jid}`;
        const oldest_message = model.getOldestMessage();
        if (!oldest_message) return;

        const msg_data = {
            before: oldest_message.get(key),
            template_hook: "getMessageTemplate",
            time: new Date((new Date(oldest_message.get('time'))).getTime() - 1).toISOString(),
        };

        if (model.messages.findWhere(msg_data)) {
            src_log.debug("Gap placeholder already exists, not recreating.");
            return;
        }
        model.messages.add(new MAMPlaceholderMessage(msg_data));
    }
}

/**
 * Fetches messages that might have been archived *after*
 * the last archived message in our local cache.
 * @param {ChatBox|MUC} model
 */
function fetchNewestMessages(model) {
    if (model.disable_mam) return;

    // XXX: It's important to first get the most recent message, before making any
    // async calls, like `api.disco.supports`, so that we can avoid a race
    // condition with possible new incoming messages.
    // We want the most recent cached message, otherwise we would query with
    // the wrong `start` value. This function used to call
    // `api.disco.supports`, but it's also called in `fetchArchivedMessages`,
    // so it's not necessary here.
    const most_recent_msg = model.getMostRecentMessage();
    const should_page = shared_api.settings.get("mam_request_all_pages") ? "backwards" : false;

    if (most_recent_msg) {
        return fetchArchivedMessages(model, { mam: { start: most_recent_msg.get("time") }, rsm: { before: "" } }, should_page);
    } else {
        return fetchArchivedMessages(model, { rsm: { before: "" } }, should_page);
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/rsm.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description XEP-0059 Result Set Management
 *   Some code taken from the Strophe RSM plugin, licensed under the MIT License
 *   Copyright 2006-2017 Strophe (https://github.com/strophe/strophejs)
 */



const { Strophe: rsm_Strophe, $build: rsm_$build } = api_public.env;

rsm_Strophe.addNamespace("RSM", "http://jabber.org/protocol/rsm");

const RSM_QUERY_PARAMETERS = ["after", "before", "index", "max"];

const rsm_toNumber = (v) => Number(v);
const rsm_toString = (v) => v.toString();

const RSM_TYPES = {
    after: rsm_toString,
    before: rsm_toString,
    count: rsm_toNumber,
    first: rsm_toString,
    index: rsm_toNumber,
    last: rsm_toString,
    max: rsm_toNumber,
};

// This array contains both query attributes and response attributes
const RSM_ATTRIBUTES = Object.keys(RSM_TYPES);

/**
 * Instances of this class are used to page through query results according to XEP-0059 Result Set Management
 * @class RSM
 */
class RSM {
    static getQueryParameters(options = {}) {
        return RSM_QUERY_PARAMETERS.reduce((result, key) => {
            if (options[key] !== undefined) {
                result[key] = options[key];
            }
            return result;
        }, {});
    }

    static parseXMLResult(set) {
        const result = {};
        for (var i = 0; i < RSM_ATTRIBUTES.length; i++) {
            const attr = RSM_ATTRIBUTES[i];
            const elem = set.getElementsByTagName(attr)[0];
            if (!isUndefined(elem) && elem !== null) {
                result[attr] = RSM_TYPES[attr](rsm_Strophe.getText(elem));
                if (attr == "first") {
                    result.index = RSM_TYPES["index"](elem.getAttribute("index"));
                }
            }
        }
        return result;
    }

    /**
     * Creates a new RSM instance
     * @param { Object } options - Configuration options
     */
    constructor(options = {}) {
        this.query = RSM.getQueryParameters(options);
        this.result = options.xml ? RSM.parseXMLResult(options.xml) : {};
    }

    /**
     * Returns a `<set>` XML element that confirms to XEP-0059 Result Set Management.
     * The element is constructed based on the RSMQueryOptions
     * that are set on this RSM instance.
     * @returns {Element}
     */
    toXML() {
        const xml = rsm_$build("set", { xmlns: rsm_Strophe.NS.RSM });
        const reducer = (xml, a) =>
            !isUndefined(this.query[a])
                ? xml
                      .c(a)
                      .t((this.query[a] || "").toString())
                      .up()
                : xml;
        return RSM_QUERY_PARAMETERS.reduce(reducer, xml).tree();
    }

    /**
     * Returns a string representation of the result-set XML
     * @returns {string}
     */
    toString() {
        return rsm_Strophe.serialize(this.toXML());
    }

    /**
     * @param {string} max
     * @param {string} before
     */
    next(max, before) {
        const options = Object.assign({}, this.query, { after: this.result.last, before, max });
        return new RSM(options);
    }

    /**
     * @param {string} max
     * @param {string} after
     */
    previous(max, after) {
        const options = Object.assign({}, this.query, { after, before: this.result.first, max });
        return new RSM(options);
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/mam/api.js









const { NS: api_NS } = Strophe;
const { dayjs: api_dayjs, stx: mam_api_stx, u: mam_api_u } = api_public.env;


/* export default */ const mam_api = ({
    /**
     * The [XEP-0313](https://xmpp.org/extensions/xep-0313.html) Message Archive Management API
     *
     * Enables you to query an XMPP server for archived messages.
     *
     * See also the [message-archiving](https://conversejs.org/docs/configuration/#message-archiving)
     * option in the configuration settings section, which you'll
     * usually want to use in conjunction with this API.
     *
     * @namespace _converse.api.archive
     * @memberOf _converse.api
     */
    archive: {
         /**
          * Query for archived messages.
          *
          * The options parameter can also be an instance of
          * RSM to enable easy querying between results pages.
          *
          * @method _converse.api.archive.query
          * @param {import('./types').ArchiveQueryOptions} [options={}] - Optional query parameters
          * @throws {Error} An error is thrown if the XMPP server responds with an error.
          * @returns {Promise<import('./types').MAMQueryResult>}
          *
          * @example
          * // Requesting all archived messages
          * // ================================
          * //
          * // The simplest query that can be made is to simply not pass in any parameters.
          * // Such a query will return all archived messages for the current user.
          *
          * let result;
          * try {
          *     result = await api.archive.query();
          * } catch (e) {
          *     // The query was not successful, perhaps inform the user?
          *     // The IQ stanza returned by the XMPP server is passed in, so that you
          *     // may inspect it and determine what the problem was.
          * }
          * // Do something with the messages, like showing them in your webpage.
          * result.messages.forEach(m => this.showMessage(m));
          *
          * @example
          * // Requesting all archived messages for a particular contact or room
          * // =================================================================
          * //
          * // To query for messages sent between the current user and another user or room,
          * // the query options need to contain the the JID (Jabber ID) of the user or
          * // room under the  `with` key.
          *
          * // For a particular user
          * let result;
          * try {
          *    result = await api.archive.query({ mam: { with: 'john@doe.net' }});
          * } catch (e) {
          *     // The query was not successful
          * }
          *
          * // For a particular room
          * let result;
          * try {
          *    result = await api.archive.query({ mam: { with: 'discuss@conference.doglovers.net' }}, is_groupchat: true });
          * } catch (e) {
          *     // The query was not successful
          * }
          *
          * @example
          * // Requesting all archived messages before or after a certain date
          * // ===============================================================
          * //
          * // The MAM `start` and `end` parameters are used to query for messages
          * // within a certain timeframe. The passed in date values may either be ISO8601
          * // formatted date strings, or JavaScript Date objects.
          *
          *  const options = {
          *      mam: {
          *          'with': 'john@doe.net',
          *          'start': '2010-06-07T00:00:00Z',
          *          'end': '2010-07-07T13:23:54Z'
          *      },
          *  };
          * let result;
          * try {
          *    result = await api.archive.query(options);
          * } catch (e) {
          *     // The query was not successful
          * }
          *
          * @example
          * // Limiting the amount of messages returned
          * // ========================================
          * //
          * // The amount of returned messages may be limited with the `max` parameter.
          * // By default, the messages are returned from oldest to newest.
          *
          * // Return maximum 10 archived messages
          * let result;
          * try {
          *     result = await api.archive.query({ mam: { with: 'john@doe.net', max:10 }});
          * } catch (e) {
          *     // The query was not successful
          * }
          *
          * @example
          * // Paging forwards through a set of archived messages
          * // ==================================================
          * //
          * // When limiting the amount of messages returned per query, you might want to
          * // repeatedly make a further query to fetch the next batch of messages.
          * //
          * // To simplify this usecase for you, the callback method receives not only an array
          * // with the returned archived messages, but also a special RSM (*Result Set Management*)
          * // object which contains the query parameters you passed in, as well
          * // as two utility methods `next`, and `previous`.
          * //
          * // When you call one of these utility methods on the returned RSM object, and then
          * // pass the result into a new query, you'll receive the next or previous batch of
          * // archived messages. Please note, when calling these methods, pass in an integer
          * // to limit your results.
          *
          * const options = { mam: { with: 'john@doe.net' }, rsm: { max:10 }};
          * let result;
          * try {
          *     result = await api.archive.query(options);
          * } catch (e) {
          *     // The query was not successful
          * }
          * // Do something with the messages, like showing them in your webpage.
          * result.messages.forEach(m => this.showMessage(m));
          *
          * while (!result.complete) {
          *     try {
          *         result = await api.archive.query({
          *             mam: { ...options.mam },
          *             rsm: {
          *                 ...options.rsm,
          *                 ...rsm.next(10).query
          *                 }
          *             });
          *     } catch (e) {
          *         // The query was not successful
          *     }
          *     // Do something with the messages, like showing them in your webpage.
          *     result.messages.forEach(m => this.showMessage(m));
          * }
          *
          * @example
          * // Paging backwards through a set of archived messages
          * // ===================================================
          * //
          * // To page backwards through the archive, you need to know the UID of the message
          * // which you'd like to page backwards from and then pass that as value for the
          * // `before` parameter. If you simply want to page backwards from the most recent
          * // message, pass in the `before` parameter with an empty string value `''`.
          *
          * let result;
          * const options = { rsm: { before: '', max:5 }};
          * try {
          *     result = await api.archive.query(options);
          * } catch (e) {
          *     // The query was not successful
          * }
          * // Do something with the messages, like showing them in your webpage.
          * result.messages.forEach(m => this.showMessage(m));
          *
          * // Now we query again, to get the previous batch.
          * try {
          *     try {
          *         result = await api.archive.query({
          *             mam: { ...options.mam },
          *             rsm: {
          *                 ...options.rsm,
          *                 ...rsm.previous(5).query
          *                 }
          *             });
          * } catch (e) {
          *     // The query was not successful
          * }
          * // Do something with the messages, like showing them in your webpage.
          * result.messages.forEach(m => this.showMessage(m));
          *
          */
        async query (options={}) {
            if (!shared_api.connection.connected()) {
                throw new Error('Can\'t call `api.archive.query` before having established an XMPP session');
            }

            let toJID;
            if (options && options.is_groupchat) {
                if (!options.mam?.with) {
                    throw new Error(
                        'You need to specify a "with" value containing '+
                        'the groupchat JID, when querying groupchat messages.');
                }
                toJID = options.mam.with;
            }

            const withJID = !options.is_groupchat && options.mam?.with || null;

            const bare_jid = shared_converse.session.get('bare_jid');
            const jid = toJID || bare_jid;
            const supported = await shared_api.disco.supports(api_NS.MAM, jid);
            if (!supported) {
                src_log.warn(`Did not fetch MAM archive for ${jid} because it doesn't support ${api_NS.MAM}`);
                return { messages: [] };
            }

            // Validate start and end dates and add them to attrs (in the right format)
            const { start: startDate, end: endDate } = ['start', 'end'].reduce((acc, t) => {
                if (options.mam?.[t]) {
                    const date = api_dayjs(options.mam[t]);
                    if (date.isValid()) {
                        acc[t] = date.toISOString();
                    } else {
                        throw new TypeError(`archive.query: invalid date provided for: ${t}`);
                    }
                }
                return acc;
            }, { start: null, end: null });

            const connection = shared_api.connection.get();
            const rsm = options.rsm ? new RSM(options.rsm) : {};
            const queryid = mam_api_u.getUniqueId();

            const stanza = mam_api_stx`
                <iq id="${mam_api_u.getUniqueId()}"
                        ${toJID ? Stanza.unsafeXML(`to="${Strophe.xmlescape(toJID)}"`) : ""}
                        type="set"
                        xmlns="jabber:client">
                    <query queryid="${queryid}" xmlns="${api_NS.MAM}">
                        ${
                            withJID || startDate || endDate
                                ? mam_api_stx`
                            <x type="submit" xmlns="${api_NS.XFORM}">
                                <field type="hidden" var="FORM_TYPE"><value>${api_NS.MAM}</value></field>
                                ${withJID ? mam_api_stx`<field var="with"><value>${withJID}</value></field>` : ""}
                                ${startDate ? mam_api_stx`<field var="start"><value>${startDate}</value></field>` : ""}
                                ${endDate ? mam_api_stx`<field var="end"><value>${endDate}</value></field>` : ""}
                            </x>`
                                : ""
                        }
                        ${Object.keys(rsm.query ?? {}).length ? Stanza.fromString(rsm.toString()) : ""}
                    </query>
                </iq>`;

            const messages = [];
            const message_handler = connection.addHandler(/** @param {Element} stanza */(stanza) => {
                const result = sizzle_default()(`message > result[xmlns="${api_NS.MAM}"]`, stanza).pop();
                if (result === undefined || result.getAttribute('queryid') !== queryid) {
                    return true;
                }
                const from = stanza.getAttribute('from') || bare_jid;
                if (options.is_groupchat) {
                    if (from !== options.mam?.with) {
                        src_log.warn(`Ignoring alleged groupchat MAM message from ${stanza.getAttribute('from')}`);
                        return true;
                    }
                } else if (from !== bare_jid) {
                    src_log.warn(`Ignoring alleged MAM message from ${stanza.getAttribute('from')}`);
                    return true;
                }
                messages.push(stanza);
                return true;
            }, api_NS.MAM);

            let error;
            const timeout = shared_api.settings.get('message_archiving_timeout');
            const iq_result = await shared_api.sendIQ(stanza, timeout, false);
            if (iq_result === null) {
                const { __ } = shared_converse;
                const err_msg = __("Timeout while trying to fetch archived messages.");
                src_log.error(err_msg);
                error = new TimeoutError(err_msg);
                return { messages, error };

            } else if (mam_api_u.isErrorStanza(iq_result)) {
                const { __ } = shared_converse;
                const err_msg = __('An error occurred while querying for archived messages.');
                src_log.error(err_msg);
                src_log.error(iq_result);
                error = new Error(err_msg);
                return { messages, error };
            }
            connection.deleteHandler(message_handler);

            let rsm_result;
            const fin = iq_result && sizzle_default()(`fin[xmlns="${api_NS.MAM}"]`, iq_result).pop();
            const complete = fin?.getAttribute('complete') === 'true';
            const set = sizzle_default()(`set[xmlns="${api_NS.RSM}"]`, fin).pop();
            if (set) {
                rsm_result = new RSM({...options.rsm, xml: set});
            }
            return { messages, rsm: rsm_result, complete };
        }
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/mam/plugin.js
/**
 * @description XEP-0313 Message Archive Management
 * @copyright 2022, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */










const { NS: plugin_NS } = Strophe;

api_public.plugins.add("converse-mam", {
    dependencies: ["converse-disco", "converse-muc"],

    initialize() {
        shared_api.settings.extend({
            archived_messages_page_size: "50",
            mam_request_all_pages: false,
            message_archiving: undefined, // Supported values are 'always', 'never', 'roster'
            // https://xmpp.org/extensions/xep-0313.html#prefs
            message_archiving_timeout: 60000, // Time (in milliseconds) to wait before aborting MAM request
        });

        Object.assign(shared_api, mam_api);
        // This is mainly done to aid with tests
        const exports = { onMAMError: onMAMError, onMAMPreferences: onMAMPreferences, handleMAMResult: handleMAMResult, MAMPlaceholderMessage: MAMPlaceholderMessage };
        Object.assign(shared_converse, exports); // XXX DEPRECATED
        Object.assign(shared_converse.exports, exports);

        /************************ Event Handlers ************************/
        shared_api.listen.on("addClientFeatures", () => shared_api.disco.own.features.add(plugin_NS.MAM));
        shared_api.listen.on("serviceDiscovered", getMAMPrefsFromFeature);
        shared_api.listen.on("chatRoomViewInitialized", ({ model }) => {
            if (shared_api.settings.get("muc_show_logs_before_join")) {
                preMUCJoinMAMFetch(model);
                // If we want to show MAM logs before entering the MUC, we need
                // to be informed once it's clear that this MUC supports MAM.
                model.features.on("change:mam_enabled", () => preMUCJoinMAMFetch(model));
            }
        });
        shared_api.listen.on(
            "enteredNewRoom",
            /** @param {import('../muc/muc').default} muc */ (muc) =>
                muc.features.get("mam_enabled") && fetchNewestMessages(muc)
        );

        shared_api.listen.on("chatReconnected", (chat) => {
            if (![CHATROOMS_TYPE, PRIVATE_CHAT_TYPE].includes(chat.get("type"))) {
                return;
            }
            fetchNewestMessages(chat);
        });

        shared_api.listen.on("afterMessagesFetched", (chat) => {
            if (chat.get("type") === PRIVATE_CHAT_TYPE) {
                fetchNewestMessages(chat);
            }
            createScrollupPlaceholder(chat);
        });
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/mam/index.js





Object.assign(headless_utils, { mam: { fetchArchivedMessages: fetchArchivedMessages }});



;// CONCATENATED MODULE: ./src/headless/plugins/ping/utils.js




const { Strophe: ping_utils_Strophe, stx: ping_utils_stx } = api_public.env;

let lastStanzaDate;

function utils_onWindowStateChanged () {
    if (!document.hidden) shared_api.ping(null, 5000);
}

function setLastStanzaDate (date) {
    lastStanzaDate = date;
}

function pong (ping) {
    lastStanzaDate = new Date();
    const from = ping.getAttribute('from');
    const id = ping.getAttribute('id');
    const iq = ping_utils_stx`<iq type="result" to="${from}" id="${id}" xmlns="jabber:client"></iq>`;
    shared_api.sendIQ(iq);
    return true;
}

function registerPongHandler () {
    const connection = shared_api.connection.get();
    if (connection.disco) {
        shared_api.disco.own.features.add(ping_utils_Strophe.NS.PING);
    }
    return connection.addHandler(pong, ping_utils_Strophe.NS.PING, "iq", "get");
}

function registerPingHandler () {
    shared_api.connection.get()?.addHandler(() => {
        if (shared_api.settings.get('ping_interval') > 0) {
            // Handler on each stanza, saves the received date
            // in order to ping only when needed.
            lastStanzaDate = new Date();
            return true;
        }
    });
}

let intervalId;

function registerHandlers () {
    // Wrapper so that we can spy on registerPingHandler in tests
    registerPongHandler();
    registerPingHandler();
    clearInterval(intervalId);
    intervalId = setInterval(onEverySecond, 1000);
}

function unregisterIntervalHandler () {
    clearInterval(intervalId);
}

function onEverySecond () {
    if (isTestEnv() || !shared_api.connection.authenticated()) {
        return;
    }
    const ping_interval = shared_api.settings.get('ping_interval');
    if (ping_interval > 0) {
        const now = new Date();
        lastStanzaDate = lastStanzaDate ?? now;
        if ((now.valueOf() - lastStanzaDate.valueOf())/1000 > ping_interval) {
            shared_api.ping();
        }
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/ping/api.js






const { Strophe: ping_api_Strophe, u: ping_api_u, stx: ping_api_stx } = api_public.env;

/* export default */ const ping_api = ({
    /**
     * Pings the entity represented by the passed in JID by sending an IQ stanza to it.
     * @method api.ping
     * @param {string} [jid] - The JID of the service to ping
     *  If the ping is sent out to the user's bare JID and no response is received it will attempt to reconnect.
     * @param {number} [timeout] - The amount of time in
     *  milliseconds to wait for a response. The default is 10000;
     * @returns {Promise<boolean|null>}
     *  Whether the pinged entity responded with a non-error IQ stanza.
     *  If we already know we're not connected, no ping is sent out and `null` is returned.
     */
    async ping(jid, timeout) {
        if (!shared_api.connection.authenticated()) {
            src_log.debug("Not pinging when we know we're not authenticated");
            return null;
        }

        // XXX: We could first check here if the server advertised that it supports PING.
        // However, some servers don't advertise while still responding to pings
        // const feature = _converse.disco_entities[_converse.domain].features.findWhere({'var': Strophe.NS.PING});
        setLastStanzaDate(new Date());
        const bare_jid = shared_converse.session.get('bare_jid');
        jid = jid || ping_api_Strophe.getDomainFromJid(bare_jid);
        const iq = ping_api_stx`
            <iq type="get"
                to="${jid}"
                id="${ping_api_u.getUniqueId('ping')}"
                xmlns="jabber:client">
                <ping xmlns="${ping_api_Strophe.NS.PING}"></ping>
            </iq>`;

        const result = await shared_api.sendIQ(iq, timeout || 10000, false);
        if (result === null) {
            src_log.warn(`Timeout while pinging ${jid}`);
            if (jid === ping_api_Strophe.getDomainFromJid(bare_jid)) {
                shared_api.connection.reconnect();
            }
            return false;
        } else if (ping_api_u.isErrorStanza(result)) {
            src_log.error(`Error while pinging ${jid}`);
            src_log.error(result);
            return false;
        }
        return true;
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/ping/index.js
/**
 * @description
 * Converse.js plugin which add support for application-level pings
 * as specified in XEP-0199 XMPP Ping.
 * @copyright 2022, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */





const { Strophe: ping_Strophe } = api_public.env;


ping_Strophe.addNamespace('PING', "urn:xmpp:ping");


api_public.plugins.add('converse-ping', {

    initialize () {
        shared_api.settings.extend({
            ping_interval: 60 //in seconds
        });

        Object.assign(shared_api, ping_api);

        shared_api.listen.on('connected', registerHandlers);
        shared_api.listen.on('reconnected', registerHandlers);
        shared_api.listen.on('disconnected', unregisterIntervalHandler);

        document.addEventListener('visibilitychange', utils_onWindowStateChanged);
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/pubsub/parsers.js


/**
 * @param {Element} iq - An IQ result stanza
 * @returns {import('./types').PubSubConfigOptions}
 */
function parseStanzaForPubSubConfig(iq) {
    return parseXForm(iq).fields.reduce((acc, f) => {
        if (f.var.startsWith('pubsub#')) {
            const key = f.var.replace(/^pubsub#/, '');
            const value = (f.type === 'boolean') ? f.checked : (f.value ?? null);
            acc[key] = value;
        }
        return acc;
    }, {});
}

;// CONCATENATED MODULE: ./src/headless/plugins/pubsub/api.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */







const { Strophe: pubsub_api_Strophe, stx: pubsub_api_stx } = api_public.env;

/* export default */ const pubsub_api = ({
    /**
     * @typedef {import('strophe.js').Builder} Builder
     * @typedef {import('strophe.js').Stanza} Stanza
     * @typedef {import('./types').PubSubConfigOptions} PubSubConfigOptions
     *
     * The "pubsub" namespace groups methods relevant to PubSub
     * @namespace _converse.api.pubsub
     * @memberOf _converse.api
     */
    pubsub: {
        config: {
            /**
             * Fetches the configuration for a PubSub node
             * @method _converse.api.pubsub.config.get
             * @param {string} jid - The JID of the pubsub service where the node resides
             * @param {string} node - The node to configure
             * @returns {Promise<import('./types').PubSubConfigOptions>}
             */
            async get(jid, node) {
                if (!node) throw new Error('api.pubsub.config.get: Node value required');

                const bare_jid = shared_converse.session.get('bare_jid');
                const full_jid = shared_converse.session.get('jid');
                const entity_jid = jid || bare_jid;

                const stanza = pubsub_api_stx`
                    <iq xmlns="jabber:client"
                        from="${full_jid}"
                        type="get"
                        to="${entity_jid}">
                    <pubsub xmlns="${pubsub_api_Strophe.NS.PUBSUB}#owner"><configure node="${node}"/></pubsub>
                    </iq>`;

                let response;
                try {
                    response = await shared_api.sendIQ(stanza);
                } catch (error) {
                    throw await parseErrorStanza(error);
                }
                return parseStanzaForPubSubConfig(response);
            },

            /**
             * Configures a PubSub node
             * @method _converse.api.pubsub.config.set
             * @param {string} jid The JID of the pubsub service where the node resides
             * @param {string} node The node to configure
             * @param {PubSubConfigOptions} config The configuration options
             * @returns {Promise<import('./types').PubSubConfigOptions>}
             */
            async set(jid, node, config) {
                if (!node) throw new Error('api.pubsub.config.set: Node value required');

                const bare_jid = shared_converse.session.get('bare_jid');
                const entity_jid = jid || bare_jid;
                const new_config = {
                    ...(await shared_api.pubsub.config.get(entity_jid, node)),
                    ...config,
                };

                const stanza = pubsub_api_stx`
                    <iq xmlns="jabber:client"
                        from="${bare_jid}"
                        type="set"
                        to="${entity_jid}">
                    <pubsub xmlns="${pubsub_api_Strophe.NS.PUBSUB}#owner">
                        <configure node="${node}">
                            <x xmlns="${pubsub_api_Strophe.NS.XFORM}" type="submit">
                                <field var="FORM_TYPE" type="hidden">
                                    <value>${pubsub_api_Strophe.NS.PUBSUB}#nodeconfig</value>
                                </field>
                                ${Object.entries(new_config).map(([k, v]) => pubsub_api_stx`<field var="pubsub#${k}"><value>${v}</value></field>`)}
                            </x>
                        </configure>
                    </pubsub>
                    </iq>`;

                try {
                    await shared_api.sendIQ(stanza);
                } catch (error) {
                    throw await parseErrorStanza(error);
                }
                return new_config;
            },
        },

        /**
         * Publishes an item to a PubSub node
         * @method _converse.api.pubsub.publish
         * @param {string} jid The JID of the pubsub service where the node resides.
         * @param {string} node The node being published to
         * @param {Builder|Stanza|(Builder|Stanza)[]} item The XML element(s) being published
         * @param {PubSubConfigOptions} options The publisher options
         *      (see https://xmpp.org/extensions/xep-0060.html#publisher-publish-options)
         * @param {boolean} strict_options Indicates whether the publisher
         *      options are a strict requirement or not. If they're NOT
         *      strict, then Converse will publish to the node even if
         *      the publish options precondition cannot be met.
         * @returns {Promise<void|Element>}
         */
        async publish(jid, node, item, options, strict_options = true) {
            if (!node) throw new Error('api.pubsub.publish: node value required');
            if (!item) throw new Error('api.pubsub.publish: item value required');

            const bare_jid = shared_converse.session.get('bare_jid');
            const entity_jid = jid || bare_jid;

            const stanza = pubsub_api_stx`
                <iq xmlns="jabber:client"
                    from="${bare_jid}"
                    type="set"
                    to="${entity_jid}">
                <pubsub xmlns="${pubsub_api_Strophe.NS.PUBSUB}">
                    <publish node="${node}">${item}</publish>
                    ${
                        options
                            ? pubsub_api_stx`<publish-options>
                    <x xmlns="${pubsub_api_Strophe.NS.XFORM}" type="submit">
                        <field var="FORM_TYPE" type="hidden">
                            <value>${pubsub_api_Strophe.NS.PUBSUB}#publish-options</value>
                        </field>
                        ${Object.entries(options).map(([k, v]) => pubsub_api_stx`<field var="pubsub#${k}"><value>${v}</value></field>`)}
                    </x></publish-options>`
                            : ''
                    }
                </pubsub>
                </iq>`;

            if (entity_jid === bare_jid) {
                // This is PEP, check for support
                const supports_pep =
                    (await shared_api.disco.getIdentity('pubsub', 'pep', bare_jid)) ||
                    (await shared_api.disco.getIdentity('pubsub', 'pep', pubsub_api_Strophe.getDomainFromJid(bare_jid)));

                if (!supports_pep) {
                    src_log.warn(`api.pubsub.publish: Not publishing via PEP because it's not supported!`);
                    src_log.warn(stanza);
                    return;
                }
            }

            // Check for #publish-options support.
            const supports_publish_options =
                (await shared_api.disco.supports(pubsub_api_Strophe.NS.PUBSUB + '#publish-options', entity_jid)) ||
                (entity_jid === bare_jid &&
                    // XEP-0223 says we need to check the server for support
                    // (although Prosody returns it on the bare jid)
                    (await shared_api.disco.supports(
                        pubsub_api_Strophe.NS.PUBSUB + '#publish-options',
                        pubsub_api_Strophe.getDomainFromJid(entity_jid)
                    )));

            if (!supports_publish_options && strict_options) {
                src_log.warn(`api.pubsub.publish: #publish-options not supported, refusing to publish item.`);
                src_log.warn(stanza);
                return;
            }

            try {
                await shared_api.sendIQ(stanza);
            } catch (iq) {
                const e = await parseErrorStanza(iq);
                if (
                    e.name === 'conflict' &&
                    /** @type {import('shared/errors').StanzaError} */(e).extra[pubsub_api_Strophe.NS.PUBSUB_ERROR] === 'precondition-not-met'
                ) {
                    // Manually configure the node if we can't set it via publish-options
                    await shared_api.pubsub.config.set(entity_jid, node, options);
                    try {
                        await shared_api.sendIQ(stanza);
                    } catch (e) {
                        src_log.error(e);
                        if (!strict_options) {
                            // The publish-options precondition couldn't be met.
                            // We re-publish but without publish-options.
                            const el = stanza.tree();
                            el.querySelector('publish-options').outerHTML = '';
                            src_log.warn(`api.pubsub.publish: #publish-options precondition-not-met, publishing anyway.`);
                            await shared_api.sendIQ(el);
                        }
                    }
                } else {
                    throw iq;
                }
            }
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/pubsub/index.js
/**
 * @module converse-pubsub
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */





const { Strophe: pubsub_Strophe, sizzle: pubsub_sizzle } = api_public.env;

pubsub_Strophe.addNamespace('PUBSUB_ERROR', pubsub_Strophe.NS.PUBSUB + '#errors');

api_public.plugins.add('converse-pubsub', {
    dependencies: ['converse-disco'],

    initialize() {
        const { api } = shared_converse;
        Object.assign(shared_converse.api, pubsub_api);

        api.listen.on(
            'parseErrorStanza',
            /**
             * @param {Element} stanza
             * @param {import('shared/types.js').ErrorExtra} extra
             */
            (stanza, extra) => {
                const pubsub_err = pubsub_sizzle(`error [xmlns="${pubsub_Strophe.NS.PUBSUB_ERROR}"]`, stanza).pop();
                if (pubsub_err) {
                    return {
                        ...extra,
                        [pubsub_Strophe.NS.PUBSUB_ERROR]: pubsub_err.nodeName,
                    };
                }
                return extra;
            }
        );
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/reactions/parsers.js


const { Strophe: reactions_parsers_Strophe } = api_public.env;

/**
 * @typedef {import('../../plugins/muc/muc').default} MUC
 * @typedef {import('../../plugins/muc/types').MUCMessageAttributes} MUCMessageAttributes
 * @typedef {import('../../shared/types').MessageAttributes} MessageAttributes
 * @typedef {import('./types').MUCMessageAttrsWithReactions} MUCMessageAttrsWithReactions
 * @typedef {import('./types').MessageAttrsWithReactions} MessageAttrsWithReactions
 */

/**
 * Parse reactions from a message stanza and return updated attributes.
 *
 * Per XEP-0444, a reaction stanza references an existing message via
 * `<reactions id="...">`. This parser extracts the referenced message ID
 * and creates a reactions object keyed by the reacting party's stable
 * identity key (since each incoming reaction stanza only contains reactions
 * from a single sender).
 *
 * The key used for the `reactions` map follows this priority chain for MUC:
 *
 * 1. **occupant_id** (XEP-0421) — stable across nick changes, works in all
 *    MUC anonymity modes.
 * 2. **real bare JID** (`from_real_jid`) — used only when the MUC is
 *    non-anonymous, to avoid key inconsistency in semi-anonymous rooms where
 *    only moderators can see real JIDs.
 * 3. **full JID** (`room@domain/nick`) — last-resort fallback.
 *
 * For 1:1 chats the key is always the sender's bare JID.
 *
 * Later, when the message attributes are applied to the original message,
 * the `getUpdatedMessageAttributes` hook merges this single-reactor object
 * with existing reactions from other reactors.
 *
 * @param {Element} stanza - The XMPP message stanza
 * @param {MessageAttributes|MUCMessageAttributes} attrs - Current message attributes
 * @param {MUC} [chatbox] - The MUC model,
 *   passed for MUC messages so we can inspect room features (e.g. anonymity mode).
 *   For 1:1 chats, this parameter is `undefined`.
 * @returns {Promise<MessageAttrsWithReactions|MUCMessageAttrsWithReactions>}
 */
async function parseReactionsMessage(stanza, attrs, chatbox) {
    const reactions_element = stanza.getElementsByTagNameNS(reactions_parsers_Strophe.NS.REACTIONS, 'reactions')[0];

    if (!reactions_element) {
        return attrs;
    }

    const reaction_to_id = reactions_element.getAttribute('id');
    if (!reaction_to_id) {
        return attrs;
    }

    const reaction_elements = reactions_element.getElementsByTagName('reaction');
    const emojis = Array.from(reaction_elements)
        .map((el) => el.textContent)
        .filter((e) => e);

    let reacting_key;
    if (attrs.type === 'groupchat') {
        const muc_attrs = /** @type {MUCMessageAttributes} */ (attrs);
        const muc_chatbox = /** @type {import('../../plugins/muc/muc.js').default|undefined} */ (chatbox);
        if (muc_attrs.occupant_id) {
            // XEP-0421: stable across nick changes, preferred in all MUC types
            reacting_key = muc_attrs.occupant_id;
        } else if (muc_attrs.from_real_jid && muc_chatbox?.features?.get('nonanonymous')) {
            // Non-anonymous MUC: real bare JID is visible to all participants
            // and is stable across nick changes
            reacting_key = muc_attrs.from_real_jid;
        } else {
            // Semi-anonymous MUC without XEP-0421: fall back to full JID
            reacting_key = attrs.from;
        }
    } else {
        reacting_key = reactions_parsers_Strophe.getBareJidFromJid(attrs.from);
    }

    const reactions = { [reacting_key]: emojis };

    return Object.assign(attrs, {
        reaction_to_id,
        reactions,
    });
}

;// CONCATENATED MODULE: ./src/headless/plugins/reactions/utils.js




const { Strophe: reactions_utils_Strophe, u: reactions_utils_u } = api_public.env;

/**
 * @typedef {import('../../shared/types').MessageAttributes} MessageAttributes
 * @typedef {import('../../plugins/muc/types').MUCMessageAttributes} MUCMessageAttributes
 * @typedef {import('./types').MessageAttrsWithReactions} MessageAttrsWithReactions
 * @typedef {import('./types').MUCMessageAttrsWithReactions} MUCMessageAttrsWithReactions
 * @typedef {import('../../shared/types').ChatBoxOrMUC} ChatBoxOrMUC
 * @typedef {import('../../shared/message').default} BaseMessage
 */

/**
 * Hook handler for the `getDuplicateMessageQueries` hook.
 *
 * Adds query objects so that incoming reaction stanzas can be matched against
 * the message they target. Per XEP-0444, the `<reactions id="...">` attribute
 * contains the id of the original message. Different clients use different id
 * types for this reference:
 *
 * - The sender's client-assigned stanza id (`msgid` / `origin_id`).
 * - The MUC-assigned stanza_id (`stanza_id <muc-jid>`), as used by Conversations
 *   and other compliant clients.
 *
 * By contributing all three query objects here we ensure a single O(n) scan
 * in {@link getDuplicateMessage} covers all cases, with no reaction-specific
 * logic leaking into shared code.
 *
 * @param {ChatBoxOrMUC} chatbox
 * @param {object[]} queries
 * @param {MessageAttrsWithReactions|MUCMessageAttrsWithReactions} attrs
 * @returns {object[]}
 */
function getDuplicateMessageQueries(chatbox, queries, attrs) {
    const reaction_to_id = /** @type {string|undefined} */ (attrs.reaction_to_id);
    if (!reaction_to_id) return queries;

    /** @type {object[]} */
    const extra = [{ origin_id: reaction_to_id }, { msgid: reaction_to_id }];

    if (chatbox.get('type') === 'chatroom') {
        extra.push({ [`stanza_id ${chatbox.get('jid')}`]: reaction_to_id });
    }

    return [...queries, ...extra];
}

/**
 * This hook handler merges the incoming single-reactor reactions
 * with all existing reactions from other reactors, so that no
 * reactions are lost when the message is saved. Keys are
 * occupant_id, bare JID, or full JID depending on the context
 * (see {@link parseReactionsMessage} for the priority chain).
 *
 * @param {BaseMessage} message
 * @param {MessageAttributes|MUCMessageAttributes} new_attrs
 * @param {MessageAttrsWithReactions|MUCMessageAttrsWithReactions} original_attrs
 * @returns {MessageAttrsWithReactions|MUCMessageAttrsWithReactions} - Updated attributes
 */
function getUpdatedMessageAttributes(message, new_attrs, original_attrs) {
    const incoming_reactions = original_attrs?.reactions;
    if (!incoming_reactions) return new_attrs;

    const reactions = { ...(message.get('reactions') || {}) };

    for (const key in incoming_reactions) {
        if (incoming_reactions[key]?.length) {
            reactions[key] = incoming_reactions[key];
        } else {
            delete reactions[key];
        }
    }
    return { ...new_attrs, reactions };
}

/**
 * Handler for the getErrorAttributesForMessage hook.
 *
 * When a reaction fails to send (e.g., due to a server error or stanza timeout),
 * this hook ensures that the user's own reaction is not preserved locally as if
 * it had been delivered successfully.
 *
 * It removes the current user's reaction from the message's reactions map,
 * so that the UI will not show a local-only reaction that failed to reach
 * the recipient.
 *
 * @param {BaseMessage} message
 * @param {MessageAttrsWithReactions|MUCMessageAttrsWithReactions} new_attrs
 * @param {MessageAttrsWithReactions|MUCMessageAttrsWithReactions} original_attrs
 * @returns {MessageAttrsWithReactions|MUCMessageAttrsWithReactions}
 */
function getErrorAttributesForMessage(message, new_attrs, original_attrs) {
    if (original_attrs.reaction_to_id) {
        const chatbox = message.collection?.chatbox;
        const my_key = chatbox ? getOwnReactionJID(chatbox) : reactions_utils_Strophe.getBareJidFromJid(shared_api.connection.get().jid);
        const reactions = { ...message.get('reactions') };
        delete reactions[my_key];
        new_attrs.reactions = reactions;
    }
    return new_attrs;
}

/**
 * Handler for the beforeMessageCreated hook.
 *
 * When a reaction stanza arrives for a message that isn't in local
 * state yet (e.g. during MAM catch-up where messages arrive out of
 * order), store it as a dangling reaction so it can be applied once
 * the original message arrives.
 *
 * @param {ChatBoxOrMUC} chatbox
 * @param {MessageAttrsWithReactions|MUCMessageAttrsWithReactions} attrs
 * @param {{handled: boolean}} data - The hook data object
 * @returns {{handled: boolean}} - Updated hook data
 */
function onBeforeMessageCreated(chatbox, attrs, data) {
    if (!attrs.reaction_to_id) return data;

    // If the target message already exists, the normal getDuplicateMessage
    // flow will have matched it and updateMessage will be called instead
    // so we only reach here if the target is missing.
    attrs.dangling_reaction = true;
    chatbox.createMessage(attrs);
    return { ...data, handled: true };
}

/**
 * Handler for the afterMessageCreated hook.
 *
 * When a new message is created, check whether any dangling reactions
 * were waiting for it. If so, merge their reactions onto the new
 * message and destroy the placeholders.
 *
 * @param {ChatBoxOrMUC} chatbox
 * @param {BaseMessage} message - The newly created message model
 */
async function onAfterMessageCreated(chatbox, message) {
    const msgid = message.get('msgid');
    const origin_id = message.get('origin_id');

    // Collect all stanza_id values from the new message so we can match dangling
    // reactions that reference the message by its server-assigned stanza_id
    // (e.g. as sent by Conversations and other XEP-0444 compliant MUC clients).
    const stanza_id_values = Object.keys(message.attributes)
        .filter((k) => k.startsWith('stanza_id '))
        .map((k) => message.get(k))
        .filter(Boolean);

    if (!msgid && !origin_id && !stanza_id_values.length) return;

    const danglings = chatbox.messages.models.filter((m) => {
        if (!m.get('dangling_reaction')) return false;
        const reaction_to_id = m.get('reaction_to_id');
        return reaction_to_id === msgid || reaction_to_id === origin_id || stanza_id_values.includes(reaction_to_id);
    });
    if (!danglings.length) return;

    const reactions = { ...(message.get('reactions') || {}) };
    for (const dangling of danglings) {
        const incoming = dangling.get('reactions') || {};
        for (const jid in incoming) {
            if (incoming[jid]?.length) {
                reactions[jid] = incoming[jid];
            } else {
                delete reactions[jid];
            }
        }
        dangling.destroy();
    }
    message.save({ reactions });
}

/**
 * Returns the key under which the current user's reactions are stored
 * on a given message's `reactions` map.
 *
 * The key follows the same priority chain used when parsing incoming
 * reaction stanzas ({@link parseReactionsMessage}):
 *
 * 1. **occupant_id** (XEP-0421) — stable across nick changes, works in all
 *    MUC anonymity modes.
 * 2. **real bare JID** — used only when the MUC is non-anonymous (every
 *    participant can see real JIDs), to avoid inconsistency in semi-anonymous
 *    rooms where only moderators see real JIDs.
 * 3. **full JID** (`room@domain/nick`) — last-resort fallback.
 *
 * For 1:1 chats the key is always the own bare JID.
 *
 * @param {ChatBoxOrMUC} chatbox
 * @returns {string}
 */
function getOwnReactionJID(chatbox) {
    if (chatbox.get('type') === 'chatroom') {
        if (chatbox.get('occupant_id')) {
            return chatbox.get('occupant_id');
        }
        if (chatbox.features?.get('nonanonymous')) {
            return shared_converse.session.get('bare_jid');
        }
        return `${chatbox.get('jid')}/${chatbox.get('nick')}`;
    }
    return reactions_utils_Strophe.getBareJidFromJid(shared_api.connection.get().jid);
}


Object.assign(reactions_utils_u, {
    reactions: {
        ...reactions_utils_u.reactions,
        getOwnReactionJID,
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/reactions/plugin.js
/**
 * @module converse-reactions
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description XEP-0444: Message Reactions - Headless core logic
 */







const { Strophe: reactions_plugin_Strophe } = api_public.env;

reactions_plugin_Strophe.addNamespace('REACTIONS', 'urn:xmpp:reactions:0');

api_public.plugins.add('converse-reactions', {
    dependencies: ['converse-chat', 'converse-muc', 'converse-pubsub', 'converse-emoji'],

    initialize() {
        shared_api.listen.on('parseMessage', parseReactionsMessage);
        shared_api.listen.on('parseMUCMessage', parseReactionsMessage);

        shared_api.listen.on('getDuplicateMessageQueries', getDuplicateMessageQueries);
        shared_api.listen.on('getUpdatedMessageAttributes', getUpdatedMessageAttributes);
        shared_api.listen.on('getErrorAttributesForMessage', getErrorAttributesForMessage);

        shared_api.listen.on('beforeMessageCreated', onBeforeMessageCreated);
        shared_api.listen.on('afterMessageCreated', onAfterMessageCreated);
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/reactions/index.js
/**
 * XEP-0444: Message Reactions - Headless core
 */


;// CONCATENATED MODULE: ./src/headless/plugins/status/api.js




let api_idle_seconds = 0;
let idle = false;

/* export default */ const status_api = ({
    /**
     * Set and get the user's chat status, also called their *availability*.
     * @namespace _converse.api.user.status
     * @memberOf _converse.api.user
     */
    status: {
        /**
         * Return the current user's availability status.
         * @method _converse.api.user.status.get
         * @example _converse.api.user.status.get();
         */
        async get() {
            await shared_api.waitUntil('statusInitialized');

            const show = shared_converse.state.profile.get('show');
            if (show) {
                return show;
            }
            const status = shared_converse.state.profile.get('status');
            if (!status) {
                return 'online';
            }
            return status;
        },

        /**
         * The user's status can be set to one of the following values:
         * @method _converse.api.user.status.set
         * @param { string } value The user's chat status (e.g. 'away', 'dnd', 'offline', 'online', 'unavailable' or 'xa')
         * @param { string } [message] A custom status message
         *
         * @example _converse.api.user.status.set('dnd');
         * @example _converse.api.user.status.set('dnd', 'In a meeting');
         */
        async set(value, message) {
            if (!Object.keys(STATUS_WEIGHTS).includes(value)) {
                throw new Error(
                    'Invalid availability value. See https://xmpp.org/rfcs/rfc3921.html#rfc.section.2.2.2.1'
                );
            }

            let show = PRES_SHOW_VALUES.includes(value) ? value : undefined;
            if (value === 'away') {
                show = 'dnd';
            }

            const type = PRES_TYPE_VALUES.includes(value) ? value : undefined;
            const data = { show, type };

            if (typeof message === 'string') {
                data.status_message = message;
            }
            await shared_api.waitUntil('statusInitialized');
            shared_converse.state.profile.save(data);
        },

        /**
         * Set and retrieve the user's custom status message.
         *
         * @namespace _converse.api.user.status.message
         * @memberOf _converse.api.user.status
         */
        message: {
            /**
             * @method _converse.api.user.status.message.get
             * @returns {Promise<string>} The status message
             * @example const message = _converse.api.user.status.message.get()
             */
            async get() {
                await shared_api.waitUntil('statusInitialized');
                return shared_converse.state.profile.get('status_message');
            },
            /**
             * @method _converse.api.user.status.message.set
             * @param {string} status The status message
             * @example _converse.api.user.status.message.set('In a meeting');
             */
            async set(status) {
                await shared_api.waitUntil('statusInitialized');
                shared_converse.state.profile.save({ status_message: status });
            },
        },
    },

    /**
     * Set and get the user's idle status
     * @namespace _converse.api.user.idle
     * @memberOf _converse.api.user
     */
    idle: {
        /**
         * @method _converse.api.user.idle.get
         * @returns {import('./types').IdleStatus}
         * @example _converse.api.user.idle.get();
         */
        get() {
            return { idle, seconds: api_idle_seconds };
        },

        /**
         * @method _converse.api.user.idle.set
         * @param {import('./types').IdleStatus} status
         */
        set(status) {
            if (status.idle) {
                idle = status.idle;
            }
            if (typeof status.seconds === 'number') {
                api_idle_seconds = status.seconds;
            }
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/roster/contact.js










const { Strophe: contact_Strophe, stx: contact_stx, u: contact_u } = api_public.env;

class contact_RosterContact extends model_with_vcard_ModelWithVCard(color_ColorAwareModel(skeletor.Model)) {
    get idAttribute() {
        return 'jid';
    }

    defaults() {
        return {
            groups: [],
            num_unread: 0,
        };
    }

    async initialize(attrs) {
        this.lazy_load_vcard = true;
        super.initialize();
        this.initialized = getOpenPromise();
        await this.setPresence();
        const { jid } = attrs;
        this.set({
            ...attrs,
            ...{
                jid: contact_Strophe.getBareJidFromJid(jid).toLowerCase(),
                user_id: contact_Strophe.getNodeFromJid(jid),
            },
        });
        /**
         * When a contact's presence status has changed.
         * The presence status is either `online`, `offline`, `dnd`, `away` or `xa`.
         * @event _converse#contactPresenceChanged
         * @type {RosterContact}
         * @example _converse.api.listen.on('contactPresenceChanged', contact => { ... });
         */
        this.listenTo(this.presence, 'change:show', () => shared_api.trigger('contactPresenceChanged', this));
        this.listenTo(this.presence, 'change:show', () => this.trigger('presence:change'));
        this.listenTo(this.presence, 'change:presence', () => shared_api.trigger('contactPresenceChanged', this));
        this.listenTo(this.presence, 'change:presence', () => this.trigger('presence:change'));
        /**
         * Synchronous event which provides a hook for further initializing a RosterContact
         * @event _converse#rosterContactInitialized
         * @param {RosterContact} contact
         */
        await shared_api.trigger('rosterContactInitialized', this, { synchronous: true });
        this.initialized.resolve();
    }

    async setPresence() {
        const jid = this.get('jid');
        await shared_api.waitUntil('presencesInitialized');
        const { presences } = shared_converse.state;
        this.presence = presences.get(jid) || presences.create({ jid });
    }

    getStatus() {
        return this.presence?.getStatus() || 'offline';
    }

    async openChat() {
        return await shared_api.chats.open(this.get('jid'), {}, true);
    }

    /**
     * @param {import('./types').ContactDisplayNameOptions} [options]
     * @returns {string}
     */
    getDisplayName(options) {
        return this.get('nickname') || this.vcard?.getDisplayName() || (options?.no_jid ? null : this.get('jid'));
    }

    /**
     * Send a presence subscription request to this roster contact
     * @param {string} [message] - An optional message to explain the
     *      reason for the subscription request.
     */
    subscribe(message) {
        shared_api.user.presence.send({
            type: 'subscribe',
            to: this.get('jid'),
            status: message,
        });
        this.save('ask', 'subscribe'); // ask === 'subscribe' Means we have asked to subscribe to them.
        return this;
    }

    /**
     * Upon receiving the presence stanza of type "subscribed",
     * the user SHOULD acknowledge receipt of that subscription
     * state notification by sending a presence stanza of type
     * "subscribe" to the contact
     */
    ackSubscribe() {
        shared_api.send(contact_stx`<presence type="subscribe" to="${this.get('jid')}" xmlns="jabber:client"></presence>`);
    }

    /**
     * Upon receiving the presence stanza of type "unsubscribed",
     * the user SHOULD acknowledge receipt of that subscription state
     * notification by sending a presence stanza of type "unsubscribe"
     * this step lets the user's server know that it MUST no longer
     * send notification of the subscription state change to the user.
     */
    ackUnsubscribe() {
        shared_api.send(contact_stx`<presence type="unsubscribe" to="${this.get('jid')}" xmlns="jabber:client"></presence>`);
        this.sendRosterRemoveStanza();
        this.destroy();
    }

    /**
     * Unauthorize this contact's presence subscription
     * @param {string} [message] - Optional message to send to the person being unauthorized
     */
    unauthorize(message) {
        rejectPresenceSubscription(this.get('jid'), message);
        this.save({ requesting: false });
        return this;
    }

    /**
     * Authorize presence subscription
     * @param {string} [message] - Optional message to send to the person being authorized
     */
    authorize(message) {
        shared_api.send(contact_stx`
            <presence
                to="${this.get('jid')}"
                type="subscribed"
                xmlns="jabber:client">
                    ${message && message !== '' ? contact_stx`<status>${message}</status>` : ''}
            </presence>`);

        this.save({
            requesting: false,
            subscription: 'from',
        });
        return this;
    }

    /**
     * Remove this contact from the roster
     * @param {boolean} [unauthorize] - Whether to also unauthorize the
     * @returns {Promise<Error|Element>}
     */
    async remove(unauthorize) {
        const subscription = this.get('subscription');
        if (subscription === 'none' && this.get('ask') !== 'subscribe') {
            this.destroy();
            return;
        }
        if (this.get('ask') === 'subscribe' || subscription === 'to') {
            // See: https://datatracker.ietf.org/doc/html/rfc6121#section-3.3.1
            shared_api.send(contact_stx`<presence type="unsubscribe" to="${this.get('jid')}" xmlns="jabber:client"></presence>`);
        }
        if (unauthorize && ['from', 'both'].includes(subscription)) {
            // See: https://datatracker.ietf.org/doc/html/rfc6121#section-3.2.1
            this.unauthorize();
        }
        const promise = this.sendRosterRemoveStanza();
        if (this.collection) this.destroy();

        try {
            return await promise;
        } catch (e) {
            if (contact_u.isElement(e)) {
                // Return if it's only an error stanza
                return e;
            }
            throw e;
        }
    }

    /**
     * @param {import('./types').RosterContactUpdateAttrs} attrs
     * @returns {Promise}
     */
    async update(attrs) {
        this.save(attrs);
        return await shared_api.sendIQ(
            contact_stx`<iq xmlns="jabber:client" type="set">
                <query xmlns="${contact_Strophe.NS.ROSTER}">
                    <item jid="${this.get('jid')}" name="${this.get('nickname')}">
                        ${this.get('groups')?.map(/** @param {string} group */ (group) => contact_stx`<group>${group}</group>`)}
                    </item>
                </query>
            </iq>`,
        );
    }

    /**
     * Instruct the XMPP server to remove this contact from our roster
     * @returns {Promise}
     */
    async sendRosterRemoveStanza() {
        const iq = contact_stx`<iq type="set" xmlns="jabber:client">
            <query xmlns="${contact_Strophe.NS.ROSTER}">
                <item jid="${this.get('jid')}" subscription="remove"/>
            </query>
        </iq>`;
        return await shared_api.sendIQ(iq);
    }

    isUnsaved() {
        return this.get('subscription') === undefined;
    }
}

/* export default */ const roster_contact = (contact_RosterContact);

;// CONCATENATED MODULE: ./src/headless/plugins/roster/contacts.js









const { Strophe: contacts_Strophe, sizzle: contacts_sizzle, stx: contacts_stx, u: contacts_u, Stanza: contacts_Stanza } = api_public.env;

/**
 * @extends {Collection<RosterContact>}
 */
class RosterContacts extends skeletor.Collection {
    constructor() {
        super();
        this.model = roster_contact;
        this.data = null;
    }

    initialize() {
        const bare_jid = shared_converse.session.get('bare_jid');
        const id = `roster.state-${bare_jid}-${this.get('jid')}`;
        this.state = new skeletor.Model(
            /** @type {import('./types').ContactsStateAttrs} */ ({ id, 'collapsed_groups': [] })
        );
        initStorage(this.state, id);
        this.state.fetch();
        shared_api.listen.on(
            'chatBoxClosed',
            /** @param {import('../../shared/chatbox').default} model */
            (model) => this.removeUnsavedContact(model)
        );
    }

    /**
     * @param {import('../../shared/chatbox').default} model
     */
    removeUnsavedContact(model) {
        const contact = this.get(model.get('jid'));
        if (contact && contact.get('subscription') === undefined) {
            contact.destroy();
        }
    }

    onConnected() {
        // Called as soon as the connection has been established
        // (either after initial login, or after reconnection).
        // Use the opportunity to register stanza handlers.
        this.registerRosterHandler();
        this.registerRosterXHandler();
    }

    /**
     * Register a handler for roster IQ "set" stanzas, which update
     * roster contacts.
     */
    registerRosterHandler() {
        // Register a handler for roster IQ "set" stanzas, which update
        // roster contacts.
        shared_api.connection.get().addHandler(
            /** @param {Element} iq */ (iq) => {
                shared_converse.state.roster.onRosterPush(iq);
                return true;
            },
            contacts_Strophe.NS.ROSTER,
            'iq',
            'set'
        );
    }

    /**
     * Register a handler for RosterX message stanzas, which are
     * used to suggest roster contacts to a user.
     */
    registerRosterXHandler() {
        let t = 0;
        const connection = shared_api.connection.get();
        connection.addHandler(
            /** @param {Element} msg */ (msg) => {
                setTimeout(() => {
                    const { roster } = shared_converse.state;
                    shared_api.connection.get().flush();
                    roster.subscribeToSuggestedItems(msg);
                }, t);
                t += msg.querySelectorAll('item').length * 250;
                return true;
            },
            contacts_Strophe.NS.ROSTERX,
            'message',
            null
        );
    }

    /**
     * Fetches the roster contacts, first by trying the browser cache,
     * and if that's empty, then by querying the XMPP server.
     * @returns {promise} Promise which resolves once the contacts have been fetched.
     */
    async fetchRosterContacts() {
        const result = await new Promise((resolve, reject) => {
            this.fetch({
                add: true,
                silent: true,
                success: resolve,
                error: (_, e) => reject(e),
            });
        });
        if (contacts_u.isErrorObject(result)) {
            src_log.error(result);
            // Force a full roster refresh
            shared_converse.session.save('roster_cached', false);
            this.data.save('version', undefined);
        }

        if (shared_converse.session.get('roster_cached')) {
            /**
             * The contacts roster has been retrieved from the local cache
             * @event _converse#cachedRoster
             * @type {RosterContacts}
             * @example _converse.api.listen.on('cachedRoster', (items) => { ... });
             * @example _converse.api.waitUntil('cachedRoster').then(items => { ... });
             */
            shared_api.trigger('cachedRoster', result);
        } else {
            shared_api.connection.get().send_initial_presence = true;
            return shared_converse.state.roster.fetchFromServer();
        }
    }

    /**
     * @param {Element} msg
     */
    subscribeToSuggestedItems(msg) {
        Array.from(msg.querySelectorAll('item')).forEach((item) => {
            if (item.getAttribute('action') === 'add') {
                this.addContact({
                    jid: item.getAttribute('jid'),
                    name: item.getAttribute('name'),
                    subscription: 'to',
                });
            }
        });
        return true;
    }

    /**
     * @param {string} jid
     */
    isSelf(jid) {
        return contacts_u.isSameBareJID(jid, shared_api.connection.get().jid);
    }

    /**
     * Send an IQ stanza to the XMPP server to add a new roster contact.
     * @param {import('./types').RosterContactAttributes} attributes
     */
    sendContactAddIQ(attributes) {
        const { jid, groups } = attributes;
        const name = attributes.name ? attributes.name : null;
        const iq = contacts_stx`
            <iq type="set" xmlns="jabber:client">
                <query xmlns="${contacts_Strophe.NS.ROSTER}">
                    <item jid="${jid}" ${name ? contacts_Stanza.unsafeXML(`name="${contacts_Strophe.xmlescape(name)}"`) : ''}>
                        ${groups?.map(/** @param {string} g */ (g) => contacts_stx`<group>${g}</group>`)}
                    </item>
                </query>
            </iq>`;
        return shared_api.sendIQ(iq);
    }

    /**
     * Adds a {@link RosterContact} instance to {@link RosterContacts} and
     * optionally (if subscribe=true) subscribe to the contact's presence
     * updates which also adds the contact to the roster on the XMPP server.
     * @param {import('./types').RosterContactAttributes} attributes
     * @param {boolean} [persist=true] - Whether the contact should be persisted to the user's roster.
     * @param {boolean} [subscribe=true] - Whether we should subscribe to the contacts presence updates.
     * @param {string} [message=''] - An optional message to include with the presence subscription
     * @returns {Promise<RosterContact>}
     */
    async addContact(attributes, persist = true, subscribe = true, message = '') {
        const { jid, name } = attributes ?? {};
        if (!jid || !contacts_u.isValidJID(jid)) throw new Error('Invalid JID provided to addContact');

        await shared_api.waitUntil('rosterContactsFetched');

        if (persist) {
            try {
                await this.sendContactAddIQ(attributes);
            } catch (e) {
                src_log.error(e);
                const { __ } = shared_converse;
                alert(__('Sorry, an error occurred while trying to add %1$s as a contact.', name || jid));
                throw e;
            }
        }

        const contact = await this.create(
            {
                ...{
                    ask: undefined,
                    nickname: name,
                    groups: [],
                    requesting: false,
                    subscription: persist ? 'none' : undefined,
                },
                ...attributes,
            },
            { sort: false }
        );

        if (contact && subscribe) contact.subscribe(message);

        return contact;
    }

    /**
     * @param {string} bare_jid
     * @param {Element} presence
     * @param {string} [auth_msg=''] - Optional message to be included in the
     *   authorization of the contacts subscription request.
     * @param {string} [sub_msg=''] - Optional message to be included in our
     *   reciprocal subscription request.
     */
    async subscribeBack(bare_jid, presence, auth_msg = '', sub_msg = '') {
        const contact = this.get(bare_jid);
        const { RosterContact } = shared_converse.exports;
        if (contact instanceof RosterContact) {
            contact.authorize().subscribe();
        } else {
            // Can happen when a subscription is retried or roster was deleted
            const nickname = contacts_sizzle(`nick[xmlns="${contacts_Strophe.NS.NICK}"]`, presence).pop()?.textContent || undefined;
            const contact = await this.addContact({
                jid: bare_jid,
                name: nickname,
                groups: [],
                subscription: 'from',
            });
            if (contact instanceof RosterContact) {
                contact.authorize(auth_msg).subscribe(sub_msg);
            }
        }
    }

    /**
     * Handle roster updates from the XMPP server.
     * See: https://xmpp.org/rfcs/rfc6121.html#roster-syntax-actions-push
     * @param {Element} iq - The IQ stanza received from the XMPP server.
     */
    onRosterPush(iq) {
        const id = iq.getAttribute('id');
        const from = iq.getAttribute('from');
        const bare_jid = shared_converse.session.get('bare_jid');
        if (from && from !== bare_jid) {
            // https://tools.ietf.org/html/rfc6121#page-15
            //
            // A receiving client MUST ignore the stanza unless it has no 'from'
            // attribute (i.e., implicitly from the bare JID of the user's
            // account) or it has a 'from' attribute whose value matches the
            // user's bare JID <user@domainpart>.
            src_log.warn(`Ignoring roster illegitimate roster push message from ${iq.getAttribute('from')}`);
            return;
        }
        shared_api.send(contacts_stx`<iq type="result" id="${id}" from="${shared_api.connection.get().jid}" xmlns="jabber:client" />`);

        const query = contacts_sizzle(`query[xmlns="${contacts_Strophe.NS.ROSTER}"]`, iq).pop();
        this.data.save('version', query.getAttribute('ver'));

        const items = contacts_sizzle(`item`, query);
        if (items.length > 1) {
            src_log.error(iq);
            throw new Error('Roster push query may not contain more than one "item" element.');
        }
        if (items.length === 0) {
            src_log.warn(iq);
            src_log.warn('Received a roster push stanza without an "item" element.');
            return;
        }

        this.updateContact(items.pop());
        /**
         * When the roster receives a push event from server (i.e. new entry in your contacts roster).
         * @event _converse#rosterPush
         * @type {Element}
         * @example _converse.api.listen.on('rosterPush', iq => { ... });
         */
        shared_api.trigger('rosterPush', iq);
        return;
    }

    shouldUseRosterVersioning() {
        return (
            shared_api.settings.get('enable_roster_versioning') &&
            this.data.get('version') &&
            shared_api.disco.stream.getFeature('ver', 'urn:xmpp:features:rosterver')
        );
    }

    /**
     * Fetches the roster from the XMPP server and updates the local state
     * @emits _converse#roster
     * @returns {Promise}
     */
    async fetchFromServer() {
        const stanza = contacts_stx`
            <iq type="get" id="${contacts_u.getUniqueId('roster')}" xmlns="jabber:client">
                <query xmlns="${contacts_Strophe.NS.ROSTER}"
                    ${this.shouldUseRosterVersioning() ? contacts_Stanza.unsafeXML(`ver="${this.data.get('version')}"`) : ''}>
                </query>
            </iq>`;

        const iq = await shared_api.sendIQ(stanza, null, false);

        if (iq.getAttribute('type') === 'result') {
            const query = contacts_sizzle(`query[xmlns="${contacts_Strophe.NS.ROSTER}"]`, iq).pop();
            if (query) {
                const items = contacts_sizzle(`item`, query);
                if (!this.data.get('version') && this.models.length) {
                    // We're getting the full roster, so remove all cached
                    // contacts that aren't included in it.
                    const jids = items.map(/** @param {Element} item */ (item) => item.getAttribute('jid'));
                    this.forEach((m) => !m.get('requesting') && !jids.includes(m.get('jid')) && m.destroy());
                }
                items.forEach((item) => this.updateContact(item));
                this.data.save('version', query.getAttribute('ver'));
            }
        } else if (!contacts_u.isServiceUnavailableError(iq)) {
            // Some unknown error happened, so we will try to fetch again if the page reloads.
            src_log.error(iq);
            src_log.error('Error while trying to fetch roster from the server');
            return;
        }

        shared_converse.session.save('roster_cached', true);
        /**
         * When the roster has been received from the XMPP server.
         * See also the `cachedRoster` event further up, which gets called instead of
         * `roster` if its already in the cache.
         * @event _converse#roster
         * @type {Element}
         * @example _converse.api.listen.on('roster', iq => { ... });
         * @example _converse.api.waitUntil('roster').then(iq => { ... });
         */
        shared_api.trigger('roster', iq);
    }

    /**
     * Update or create RosterContact models based on the given `item` XML
     * node received in the resulting IQ stanza from the server.
     * @param {Element} item
     */
    updateContact(item) {
        const jid = item.getAttribute('jid');
        const contact = this.get(jid);
        const subscription = item.getAttribute('subscription');
        if (subscription === 'remove') {
            return contact?.destroy();
        }

        const ask = item.getAttribute('ask');
        const nickname = item.getAttribute('name');
        const groups = [...new Set(contacts_sizzle('group', item).map((e) => e.textContent?.trim()).filter((n) => n))];

        if (contact) {
            // We only find out about requesting contacts via the
            // presence handler, so if we receive a contact
            // here, we know they aren't requesting anymore.
            contact.save({ subscription, ask, nickname, groups, 'requesting': null });
        } else {
            this.create({ nickname, ask, groups, jid, subscription }, { sort: false });
        }
    }

    /**
     * @param {Element} presence
     */
    createRequestingContact(presence) {
        const jid = contacts_Strophe.getBareJidFromJid(presence.getAttribute('from'));
        const nickname = contacts_sizzle(`nick[xmlns="${contacts_Strophe.NS.NICK}"]`, presence).pop()?.textContent || null;
        const user_data = {
            jid,
            subscription: 'none',
            ask: null,
            requesting: true,
            nickname: nickname,
        };
        /**
         * Triggered when someone has requested to subscribe to your presence (i.e. to be your contact).
         * @event _converse#contactRequest
         * @type {RosterContact}
         * @example _converse.api.listen.on('contactRequest', contact => { ... });
         */
        shared_api.trigger('contactRequest', this.create(user_data));
    }

    /**
     * @param {Element} presence
     */
    handleIncomingSubscription(presence) {
        const jid = presence.getAttribute('from'),
            bare_jid = contacts_Strophe.getBareJidFromJid(jid),
            contact = this.get(bare_jid);

        if (!shared_api.settings.get('allow_contact_requests')) {
            const { __ } = shared_converse;
            rejectPresenceSubscription(jid, __('This client does not allow presence subscriptions'));
        }
        if (shared_api.settings.get('auto_subscribe')) {
            if (!contact || contact.get('subscription') !== 'to') {
                this.subscribeBack(bare_jid, presence);
            } else {
                contact.authorize();
            }
        } else {
            if (contact) {
                if (contact.get('subscription') !== 'none') {
                    contact.authorize();
                } else if (contact.get('ask') === 'subscribe') {
                    contact.authorize();
                }
            } else {
                this.createRequestingContact(presence);
            }
        }
    }

    /**
     * @param {Element} stanza
     */
    handleOwnPresence(stanza) {
        const jid = stanza.getAttribute('from');
        const resource = contacts_Strophe.getResourceFromJid(jid);
        const presence_type = stanza.getAttribute('type');
        const { profile } = shared_converse.state;

        if (
            shared_api.connection.get().jid !== jid &&
            presence_type !== 'unavailable' &&
            (shared_api.settings.get('synchronize_availability') === true ||
                shared_api.settings.get('synchronize_availability') === resource)
        ) {
            // Another resource has changed its status and
            // synchronize_availability option set to update,
            // we'll update ours as well.
            const show = stanza.querySelector('show')?.textContent;
            profile.save({ show, presence: 'online' }, { silent: true });

            const status_message = stanza.querySelector('status')?.textContent;
            if (status_message) profile.save({ status_message });
        }
        if (shared_converse.session.get('jid') === jid && presence_type === 'unavailable') {
            // XXX: We've received an "unavailable" presence from our
            // own resource. Apparently this happens due to a
            // Prosody bug, whereby we send an IQ stanza to remove
            // a roster contact, and Prosody then sends
            // "unavailable" globally, instead of directed to the
            // particular user that's removed.
            //
            // Here is the bug report: https://prosody.im/issues/1121
            //
            // I'm not sure whether this might legitimately happen
            // in other cases.
            //
            // As a workaround for now we simply send our presence again,
            // otherwise we're treated as offline.
            shared_api.user.presence.send();
        }
    }

    /**
     * @param {Element} presence
     */
    presenceHandler(presence) {
        const presence_type = presence.getAttribute('type');
        if (presence_type === 'error') return true;

        const jid = presence.getAttribute('from');
        const bare_jid = contacts_Strophe.getBareJidFromJid(jid);
        if (this.isSelf(bare_jid)) {
            return this.handleOwnPresence(presence);
        } else if (contacts_sizzle(`query[xmlns="${contacts_Strophe.NS.MUC}"]`, presence).length) {
            return; // Ignore MUC
        }

        const contact = this.get(bare_jid);

        if (contact) {
            const status = presence.querySelector('status')?.textContent;
            if (contact.get('status') !== status) contact.save({ status });
        }

        if (presence_type === 'subscribed' && contact) {
            contact.ackSubscribe();
        } else if (presence_type === 'unsubscribed' && contact) {
            contact.ackUnsubscribe();
        } else if (presence_type === 'unsubscribe') {
            return;
        } else if (presence_type === 'subscribe') {
            this.handleIncomingSubscription(presence);
        } else if (presence_type === 'unavailable' && contact) {
            const resource = contacts_Strophe.getResourceFromJid(jid);
            contact.presence.removeResource(resource);
        } else if (contact) {
            // presence_type is undefined
            contact.presence.addResource(presence);
        }
    }
}

/* export default */ const contacts = (RosterContacts);

;// CONCATENATED MODULE: ./src/headless/plugins/roster/resource.js


class Resource extends skeletor.Model {
    get idAttribute () { // eslint-disable-line class-methods-use-this
        return 'name';
    }
}

/* export default */ const roster_resource = (Resource);

;// CONCATENATED MODULE: ./src/headless/plugins/roster/resources.js



/**
 * @extends {Collection<Resource>}
 */
class Resources extends skeletor.Collection {

    constructor () {
        super();
        this.model = roster_resource;
    }
}

/* export default */ const resources = (Resources);

;// CONCATENATED MODULE: ./src/headless/plugins/roster/parsers.js


const { Strophe: roster_parsers_Strophe, sizzle: roster_parsers_sizzle, dayjs: roster_parsers_dayjs } = api_public.env;

/**
 * @param {Element} stanza
 * @returns {import('./types').Presence}
 */
function parsePresence(stanza) {
    const jid = stanza.getAttribute('from');
    const type = /** @type {import('./types').PresenceTypes} */(stanza.getAttribute('type'));
    const resource = roster_parsers_Strophe.getResourceFromJid(jid);
    const delay = roster_parsers_sizzle(`delay[xmlns="${roster_parsers_Strophe.NS.DELAY}"]`, stanza).pop();
    const priority = stanza.querySelector('priority')?.textContent;
    const show = /** @type {import('./types').PresenceShowValues|undefined} */(stanza.querySelector('show')?.textContent);
    const timestamp = delay ? roster_parsers_dayjs(delay.getAttribute('stamp')).toISOString() : new Date().toISOString();
    return {
        resource,
        show,
        timestamp,
        type,
        priority: Number.isNaN(parseInt(priority, 10)) ? 0 : parseInt(priority, 10),
    };
}

;// CONCATENATED MODULE: ./src/headless/plugins/roster/presence.js





/**
 * @extends {Model<import('./types').PresenceAttrs>}
 */
class Presence extends skeletor.Model {
    get idAttribute() {
        return 'jid';
    }

    defaults() {
        return {
            presence: /** @type {import('./types').PresenceTypes | 'offline'} */('offline'),
        };
    }

    initialize() {
        super.initialize();
        this.resources = new resources();
        const id = `converse.identities-${this.get('jid')}`;
        initStorage(this.resources, id, 'session');

        this.listenTo(this.resources, 'update', this.onResourcesChanged);
        this.listenTo(this.resources, 'change', this.onResourcesChanged);
    }

    onResourcesChanged() {
        const hpr = this.getHighestPriorityResource();
        const { presence, show } = hpr?.attributes ?? {};
        this.save({ presence, show });
    }

    getStatus() {
        const presence = this.get('presence');
        if (presence === 'offline') {
            return 'offline';
        }
        return this.get('show') || presence || 'offline';
    }

    /**
     * Return the resource with the highest priority.
     * If multiple resources have the same priority, take the latest one.
     */
    getHighestPriorityResource() {
        return this.resources.sortBy((r) => `${r.get('priority')}-${r.get('timestamp')}`).reverse()[0];
    }

    /**
     * Adds a new resource and it's associated attributes as taken
     * from the passed in presence stanza.
     * Also updates the presence if the resource has higher priority (and is newer).
     * @param {Element} presence: The presence stanza
     */
    addResource(presence) {
        const attrs = parsePresence(presence);
        const settings = {
            name: attrs.resource,
            presence: attrs.type === 'unavailable' ? 'offline' : 'online',
            priority: attrs.priority,
            show: attrs.show,
            timestamp: attrs.timestamp,
        };
        const resource = this.resources.get(settings.name);
        if (resource) {
            resource.save(settings);
        } else {
            this.resources.create(settings);
        }
    }

    /**
     * Remove the passed in resource from the resources map.
     * Also redetermines the presence given that there's one less
     * resource.
     * @param {string} name: The resource name
     */
    removeResource(name) {
        const resource = this.resources.get(name);
        resource?.destroy();
    }
}

/* export default */ const roster_presence = (Presence);

;// CONCATENATED MODULE: ./src/headless/plugins/roster/presences.js



/**
 * @extends {Collection<Presence>}
 */
class Presences extends skeletor.Collection {
    constructor () {
        super();
        this.model = roster_presence;
    }
}

/* export default */ const roster_presences = (Presences);

;// CONCATENATED MODULE: ./src/headless/plugins/status/profile.js







const { Stanza: profile_Stanza, Strophe: profile_Strophe, stx: profile_stx } = api_public.env;

class Profile extends model_with_vcard_ModelWithVCard(color_ColorAwareModel(skeletor.Model)) {
    defaults() {
        return {
            presence: 'online',
            status: null,
            show: null,
            groups: [],
        };
    }

    /**
     * @return {import('./types').ConnectionStatus}
     */
    getStatus () {
        const presence  = this.get('presence');
        if (presence === 'offline' || presence === 'unavailable') {
            return 'offline';
        }
        return this.get('show') || presence || 'offline';
    }

    get(attr) {
        if (attr === 'jid') {
            return shared_converse.session.get('bare_jid');
        } else if (attr === 'nickname') {
            return shared_api.settings.get('nickname');
        }
        return super.get(attr);
    }

    /**
     * @param {string|Object} key
     * @param {string|Object} [val]
     * @param {Object} [options]
     */
    set(key, val, options) {
        if (key === 'jid' || key === 'nickname') {
            throw new Error('Readonly property');
        }
        return super.set(key, val, options);
    }

    initialize() {
        super.initialize();
        this.on('change', (item) => {
            if (item.changed?.status || item.changed?.status_message || item.changed?.show) {
                shared_api.user.presence.send({
                    show: this.get('show'),
                    status: this.get('status_message'),
                });
            }
        });
    }

    /**
     * @param {import('../roster/types.js').ContactDisplayNameOptions} [options]
     */
    getDisplayName(options) {
        const { __ } = shared_converse;
        const name = this.vcard?.get('fullname') || this.getNickname() || this.get('jid');
        return options?.context === 'roster' ? `${name} (${__('me')})` : name;
    }

    getNickname() {
        return this.vcard?.get('nickname') || shared_api.settings.get('nickname');
    }

    /**
     * Constructs a presence stanza
     * @param {import('./types').PresenceAttrs} [attrs={}]
     * @returns {Promise<Stanza>}
     */
    async constructPresence(attrs = {}) {
        const { type, to } = attrs;
        const { profile } = shared_converse.state;
        const status = typeof attrs.status === 'string' ? attrs.status : this.get('status_message');
        const show = attrs.show || this.get('status');
        const include_nick = type === 'subscribe';
        const nick = include_nick ? profile.getNickname() : null;
        const priority = shared_api.settings.get('priority');
        const { idle: is_idle, seconds: idle_seconds } = shared_api.user.idle.get();

        let idle_since;
        if (is_idle) {
            idle_since = new Date();
            idle_since.setSeconds(idle_since.getSeconds() - idle_seconds);
        }

        const presence = profile_stx`
            <presence ${to ? profile_Stanza.unsafeXML(`to="${profile_Strophe.xmlescape(to)}"`) : ''}
                    ${type ? profile_Stanza.unsafeXML(`type="${profile_Strophe.xmlescape(type)}"`) : ''}
                    xmlns="jabber:client">
                ${nick ? profile_stx`<nick xmlns="${profile_Strophe.NS.NICK}">${nick}</nick>` : ''}
                ${show ? profile_stx`<show>${show}</show>` : ''}
                ${status ? profile_stx`<status>${status}</status>` : ''}
                <priority>${Number.isNaN(Number(priority)) ? 0 : priority}</priority>
                ${idle_since ? profile_stx`<idle xmlns="${profile_Strophe.NS.IDLE}" since="${idle_since.toISOString()}"></idle>` : ''}
            </presence>`;

        /**
         * *Hook* which allows plugins to modify a presence stanza
         * @event _converse#constructedPresence
         */
        return await shared_api.hook('constructedPresence', null, presence);
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/status/utils.js




/**
 * @param {boolean} reconnecting
 */
function status_utils_onStatusInitialized(reconnecting) {
    /**
     * Triggered when the user's own chat status has been initialized.
     * @event _converse#statusInitialized
     * @example _converse.api.listen.on('statusInitialized', status => { ... });
     * @example _converse.api.waitUntil('statusInitialized').then(() => { ... });
     */
    shared_api.trigger('statusInitialized', reconnecting);
}

/**
 * @param {boolean} reconnecting
 */
function initStatus(reconnecting) {
    // If there's no profile obj, then we were never connected to
    // begin with, so we set reconnecting to false.
    reconnecting = shared_converse.state.profile === undefined ? false : reconnecting;
    if (reconnecting) {
        status_utils_onStatusInitialized(reconnecting);
    } else {
        const id = `converse.xmppstatus-${shared_converse.session.get('bare_jid')}`;
        shared_converse.state.profile = new shared_converse.exports.Profile({ id });
        shared_converse.state.xmppstatus = shared_converse.state.profile; // Deprecated
        Object.assign(shared_converse, { xmppstatus: shared_converse.state.profile }); // Deprecated
        initStorage(shared_converse.state.profile, id, 'session');
        shared_converse.state.profile.fetch({
            success: () => status_utils_onStatusInitialized(reconnecting),
            error: () => status_utils_onStatusInitialized(reconnecting),
            silent: true,
        });
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/status/plugin.js








api_public.plugins.add('converse-status', {
    initialize() {
        shared_api.settings.extend({ priority: 0 });
        shared_api.promises.add(['statusInitialized']);

        const exports = {
            XMPPStatus: Profile, // Deprecated
            Profile: Profile,
        };
        Object.assign(shared_converse, exports); // Deprecated
        Object.assign(shared_converse.exports, exports);
        Object.assign(shared_converse.api.user, status_api);

        shared_api.listen.on('clearSession', () => {
            if (shouldClearCache(shared_converse) && shared_converse.state.profile) {
                shared_converse.state.profile.destroy();
                delete shared_converse.state.profile;
                Object.assign(shared_converse, { profile: undefined }); // XXX DEPRECATED
                shared_api.promises.add(['statusInitialized']);
            }
        });

        shared_api.listen.on('connected', () => initStatus(false));
        shared_api.listen.on('reconnected', () => initStatus(true));
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/status/index.js





;// CONCATENATED MODULE: ./src/headless/plugins/roster/api.js





const { Strophe: roster_api_Strophe } = api_public.env;

/* export default */ const roster_api = ({
    /**
     * @namespace _converse.api.contacts
     * @memberOf _converse.api
     *
     * @typedef {import('./contact').default} RosterContact
     */
    contacts: {
        /**
         * This method is used to retrieve roster contacts.
         *
         * @method _converse.api.contacts.get
         * @param {(string[]|string)} jids The JID or JIDs of the contacts to be returned.
         * @returns {promise} Promise which resolves with the
         *  {@link RosterContact} (or an array of them) representing the contact.
         *
         * @example
         * // Fetch a single contact
         * _converse.api.listen.on('rosterContactsFetched', function () {
         *     const contact = await _converse.api.contacts.get('buddy@example.com')
         *     // ...
         * });
         *
         * @example
         * // To get multiple contacts, pass in an array of JIDs:
         * _converse.api.listen.on('rosterContactsFetched', function () {
         *     const contacts = await _converse.api.contacts.get(
         *         ['buddy1@example.com', 'buddy2@example.com']
         *     )
         *     // ...
         * });
         *
         * @example
         * // To return all contacts, simply call ``get`` without any parameters:
         * _converse.api.listen.on('rosterContactsFetched', function () {
         *     const contacts = await _converse.api.contacts.get();
         *     // ...
         * });
         */
        async get(jids) {
            await shared_api.waitUntil('rosterContactsFetched');
            const { roster } = shared_converse.state;
            const _getter = /** @param {string} jid */ (jid) => roster.get(roster_api_Strophe.getBareJidFromJid(jid));
            if (jids === undefined) {
                jids = roster.pluck('jid');
            } else if (typeof jids === 'string') {
                return _getter(jids);
            }
            return /** @type {string[]} */ (jids).map(_getter);
        },

        /**
         * Remove a contact from the roster
         * @param {string} jid
         * @param {boolean} [unsubscribe] - Whether we should unsubscribe
         * from the contact's presence updates.
         */
        async remove(jid, unsubscribe) {
            await shared_api.waitUntil('rosterContactsFetched');
            const contact = await shared_api.contacts.get(jid);
            contact.remove(unsubscribe);
        },

        /**
         * Add a contact.
         * @param {import('./types').RosterContactAttributes} attributes
         * @param {boolean} [persist=true] - Whether the contact should be persisted to the user's roster.
         * @param {boolean} [subscribe=true] - Whether we should subscribe to the contacts presence updates.
         * @param {string} [message=''] - An optional message to include with the presence subscription
         * @param {boolean} subscribe - Whether a presence subscription should
         *      be sent out to the contact being added.
         * @returns {Promise<RosterContact>}
         * @example
         *      api.contacts.add({ jid: 'buddy@example.com', groups: ['Buddies'] })
         */
        async add(attributes, persist = true, subscribe = true, message = '') {
            if (!isValidJID(attributes?.jid)) throw new Error('api.contacts.add: Valid JID required');

            const { roster } = shared_converse.state;
            return roster.addContact(attributes, persist, subscribe, message);
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/roster/plugin.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */












api_public.plugins.add('converse-roster', {
    dependencies: ['converse-status'],

    initialize() {
        shared_api.settings.extend({
            allow_contact_requests: true,
            auto_subscribe: false,
            enable_roster_versioning: true,
            show_self_in_roster: true,
            synchronize_availability: true,
        });

        shared_api.promises.add([
            'cachedRoster',
            'roster',
            'rosterContactsFetched',
            'rosterInitialized',
            'presencesInitialized',
        ]);

        // API methods only available to plugins
        Object.assign(shared_converse.api, roster_api);
        Object.assign(headless_utils, { roster: { isUnsavedContact: isUnsavedContact } });

        const { __ } = shared_converse;
        const labels = {
            HEADER_UNSAVED_CONTACTS: __('Unsaved contacts'),
            HEADER_CURRENT_CONTACTS: __('My contacts'),
            HEADER_PENDING_CONTACTS: __('Pending contacts'),
            HEADER_REQUESTING_CONTACTS: __('Contact requests'),
            HEADER_UNGROUPED: __('Ungrouped'),
            HEADER_UNREAD: __('New messages'),
        };
        Object.assign(shared_converse, labels); // XXX DEPRECATED
        Object.assign(shared_converse.labels, labels);

        const exports = { Presence: roster_presence, Presences: roster_presences, RosterContact: roster_contact, RosterContacts: contacts };
        Object.assign(shared_converse, exports); // XXX DEPRECATED
        Object.assign(shared_converse.exports, exports);

        shared_api.listen.on('beforeTearDown', () => utils_unregisterPresenceHandler());
        shared_api.listen.on('clearSession', utils_onClearSession);
        shared_api.listen.on('presencesInitialized', onPresencesInitialized);
        shared_api.listen.on('statusInitialized', utils_onStatusInitialized);
        shared_api.listen.on('streamResumptionFailed', () => shared_converse.session.set('roster_cached', false));

        shared_api.waitUntil('rosterContactsFetched').then(onRosterContactsFetched);
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/roster/index.js









;// CONCATENATED MODULE: ./src/headless/plugins/smacks/utils.js







const { Strophe: smacks_utils_Strophe, u: smacks_utils_u, stx: smacks_utils_stx } = api_public.env;

function isStreamManagementSupported() {
    if (shared_api.connection.isType('bosh') && !isTestEnv()) {
        return false;
    }
    return shared_api.disco.stream.getFeature('sm', smacks_utils_Strophe.NS.SM);
}

/**
 * @param {Element} el
 */
function handleAck(el) {
    if (!shared_converse.session.get('smacks_enabled')) {
        return true;
    }
    const handled = parseInt(el.getAttribute('h'), 10);
    const last_known_handled = shared_converse.session.get('num_stanzas_handled_by_server');
    const delta = handled - last_known_handled;

    if (delta < 0) {
        const err_msg =
            `New reported stanza count lower than previous. ` + `New: ${handled} - Previous: ${last_known_handled}`;
        src_log.error(err_msg);
    }
    const unacked_stanzas = shared_converse.session.get('unacked_stanzas');
    if (delta > unacked_stanzas.length) {
        const err_msg =
            `Higher reported acknowledge count than unacknowledged stanzas. ` +
            `Reported Acknowledged Count: ${delta} -` +
            `Unacknowledged Stanza Count: ${unacked_stanzas.length} -` +
            `New: ${handled} - Previous: ${last_known_handled}`;
        src_log.error(err_msg);
    }
    shared_converse.session.save({
        'num_stanzas_handled_by_server': handled,
        'num_stanzas_since_last_ack': 0,
        'unacked_stanzas': unacked_stanzas.slice(delta),
    });
    return true;
}

function sendAck() {
    if (shared_converse.session.get('smacks_enabled')) {
        const h = shared_converse.session.get('num_stanzas_handled');
        const stanza = smacks_utils_stx`<a xmlns="${smacks_utils_Strophe.NS.SM}" h="${h}"/>`;
        shared_api.send(stanza);
    }
    return true;
}

/**
 * @param {Element} el
 */
function stanzaHandler(el) {
    if (shared_converse.session.get('smacks_enabled')) {
        if (smacks_utils_u.isTagEqual(el, 'iq') || smacks_utils_u.isTagEqual(el, 'presence') || smacks_utils_u.isTagEqual(el, 'message')) {
            const h = shared_converse.session.get('num_stanzas_handled');
            shared_converse.session.save('num_stanzas_handled', h + 1);
        }
    }
    return true;
}

function initSessionData() {
    const { session } = shared_converse;
    session.save({
        smacks_enabled: shared_converse.session.get('smacks_enabled') || false,
        num_stanzas_handled: shared_converse.session.get('num_stanzas_handled') || 0,
        num_stanzas_handled_by_server: shared_converse.session.get('num_stanzas_handled_by_server') || 0,
        num_stanzas_since_last_ack: shared_converse.session.get('num_stanzas_since_last_ack') || 0,
        unacked_stanzas: shared_converse.session.get('unacked_stanzas') || [],
    });
}

function resetSessionData() {
    const { session } = shared_converse;
    smacks_utils_u.safeSave(session, {
        smacks_enabled: false,
        smacks_stream_id: null,
        num_stanzas_handled: 0,
        num_stanzas_handled_by_server: 0,
        num_stanzas_since_last_ack: 0,
        unacked_stanzas: [],
    });
}

/**
 * @param {Element} el
 */
function saveSessionData(el) {
    const data = { 'smacks_enabled': true };
    if (['1', 'true'].includes(el.getAttribute('resume'))) {
        data['smacks_stream_id'] = el.getAttribute('id');
    }
    shared_converse.session.save(data);
    return true;
}

/**
 * @param {Element} el
 */
function onFailedStanza(el) {
    resetSessionData();
    /**
     * Triggered when the XEP-0198 stream could not be resumed.
     * @event _converse#streamResumptionFailed
     */
    shared_api.trigger('streamResumptionFailed');

    if (el.querySelector('item-not-found')) {
        src_log.warn('Could not resume previous SMACKS session, session id not found. A new session will be established.');
    } else {
        src_log.warn('Failed to resume previous SMACKS session. A new session will be established.');
        src_log.warn(el.outerHTML);
    }
    return true;
}

function resendUnackedStanzas() {
    const stanzas = shared_converse.session.get('unacked_stanzas');
    // We clear the unacked_stanzas array because it'll get populated
    // again in `onStanzaSent`
    shared_converse.session.save('unacked_stanzas', []);

    // XXX: Currently we're resending *all* unacked stanzas, including
    // IQ[type="get"] stanzas that longer have handlers (because the
    // page reloaded or we reconnected, causing removal of handlers).
    //
    // *Side-note:* Is it necessary to clear handlers upon reconnection?
    //
    // I've considered not resending those stanzas, but then keeping
    // track of what's been sent and ack'd and their order gets
    // prohibitively complex.
    //
    // It's unclear how much of a problem this poses.
    //
    // Two possible solutions are running @converse/headless as a
    // service worker or handling IQ[type="result"] stanzas
    // differently, more like push stanzas, so that they don't need
    // explicit handlers.
    stanzas.forEach((s) => shared_api.send(smacks_utils_u.toStanza(s)));
}

/**
 * @param {Element} el
 */
function onResumedStanza(el) {
    saveSessionData(el);
    handleAck(el);
    resendUnackedStanzas();
    const connection = shared_api.connection.get();
    connection.do_bind = false; // No need to bind our resource anymore
    connection.authenticated = true;
    connection.restored = true;
    // Store in session so we know on reconnect that we had resumed
    shared_converse.session.save('smacks_resumed', true);
    connection._changeConnectStatus(smacks_utils_Strophe.Status.CONNECTED, null);
}

async function sendResumeStanza() {
    const promise = getOpenPromise();
    const connection = shared_api.connection.get();
    connection._addSysHandler((el) => promise.resolve(onResumedStanza(el)), smacks_utils_Strophe.NS.SM, 'resumed');
    connection._addSysHandler((el) => promise.resolve(onFailedStanza(el)), smacks_utils_Strophe.NS.SM, 'failed');

    const previous_id = shared_converse.session.get('smacks_stream_id');
    const h = shared_converse.session.get('num_stanzas_handled');
    const stanza = smacks_utils_stx`<resume xmlns="${smacks_utils_Strophe.NS.SM}" h="${h}" previd="${previous_id}"/>`;
    shared_api.send(stanza);
    connection.flush();
    await promise;
}

async function sendEnableStanza() {
    if (!shared_api.settings.get('enable_smacks') || shared_converse.session.get('smacks_enabled')) {
        return;
    }
    if (await isStreamManagementSupported()) {
        const promise = getOpenPromise();
        const connection = shared_api.connection.get();
        connection._addSysHandler((el) => promise.resolve(saveSessionData(el)), smacks_utils_Strophe.NS.SM, 'enabled');
        connection._addSysHandler((el) => promise.resolve(onFailedStanza(el)), smacks_utils_Strophe.NS.SM, 'failed');

        const resume = shared_api.connection.isType('websocket') || isTestEnv();
        const stanza = smacks_utils_stx`<enable xmlns="${smacks_utils_Strophe.NS.SM}" resume="${resume}"/>`;
        shared_api.send(stanza);
        connection.flush();
        await promise;
    }
}

const smacks_handlers = [];

async function enableStreamManagement() {
    if (!shared_api.settings.get('enable_smacks')) {
        return;
    }
    if (!(await isStreamManagementSupported())) {
        return;
    }

    const conn = shared_api.connection.get();
    while (smacks_handlers.length) {
        conn.deleteHandler(smacks_handlers.pop());
    }
    smacks_handlers.push(conn.addHandler(stanzaHandler));
    smacks_handlers.push(conn.addHandler(sendAck, smacks_utils_Strophe.NS.SM, 'r'));
    smacks_handlers.push(conn.addHandler(handleAck, smacks_utils_Strophe.NS.SM, 'a'));

    const { session } = shared_converse;
    if (session?.get('smacks_stream_id')) {
        await sendResumeStanza();
    } else {
        resetSessionData();
    }
}

/**
 * @param {Element} stanza
 */
function onStanzaSent(stanza) {
    if (!shared_converse.session) {
        src_log.warn('No _converse.session!');
        return;
    }
    if (!shared_converse.session.get('smacks_enabled')) {
        return;
    }
    if (smacks_utils_u.isTagEqual(stanza, 'iq') || smacks_utils_u.isTagEqual(stanza, 'presence') || smacks_utils_u.isTagEqual(stanza, 'message')) {
        const stanza_string = smacks_utils_Strophe.serialize(stanza);
        shared_converse.session.save(
            'unacked_stanzas',
            (shared_converse.session.get('unacked_stanzas') || []).concat([stanza_string]),
        );
        const max_unacked = shared_api.settings.get('smacks_max_unacked_stanzas');
        if (max_unacked > 0) {
            const num = shared_converse.session.get('num_stanzas_since_last_ack') + 1;
            if (num % max_unacked === 0) {
                // Request confirmation of sent stanzas
                shared_api.send(smacks_utils_stx`<r xmlns="${smacks_utils_Strophe.NS.SM}"/>`);
            }
            shared_converse.session.save({ 'num_stanzas_since_last_ack': num });
        }
    }
}

function onWillReconnect() {
    if (shared_converse.session.get('smacks_resumed')) {
        resetSessionData();
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/smacks/index.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description Converse.js plugin which adds support for XEP-0198: Stream Management
 */




const { Strophe: smacks_Strophe } = api_public.env;

smacks_Strophe.addNamespace('SM', 'urn:xmpp:sm:3');

api_public.plugins.add('converse-smacks', {
    initialize() {
        // Configuration values for this plugin
        // ====================================
        // Refer to docs/source/configuration.rst for explanations of these
        // configuration settings.
        shared_api.settings.extend({
            enable_smacks: true,
            smacks_max_unacked_stanzas: 5,
        });
        shared_api.listen.on('afterResourceBinding', sendEnableStanza);
        shared_api.listen.on('beforeResourceBinding', enableStreamManagement);
        shared_api.listen.on('will-reconnect', onWillReconnect);
        shared_api.listen.on('send', onStanzaSent);
        shared_api.listen.on('userSessionInitialized', initSessionData);
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/vcard.js




class VCard extends skeletor.Model {
    /**
     * @param {import("../../shared/types").ModelAttributes} attrs
     * @param {import("./types").VCardModelOptions} options
     */
    constructor(attrs, options) {
        super(attrs, options);
        this._vcard = null;
    }

    /**
     * @param {import("../../shared/types").ModelAttributes} [_attrs]
     * @param {import("./types").VCardModelOptions} [options]
     */
    initialize(_attrs, options) {
        this.lazy_load = shared_api.settings.get('lazy_load_vcards') && !!options?.lazy_load;

        if (this.lazy_load) {
            this.once("visibilityChanged", () => shared_api.vcard.update(this));
        } else {
            shared_api.vcard.update(this);
        }
    }

    get idAttribute() {
        return "jid";
    }

    getDisplayName() {
        return this.get("nickname") || this.get("fullname") || this.get("jid");
    }
}

/* export default */ const vcard_vcard = (VCard);

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/vcards.js







/**
 * @extends {Collection<VCard>}
 */
class VCards extends skeletor.Collection {
    constructor() {
        super();
        this.model = vcard_vcard;
    }

    async initialize() {
        const { session } = shared_converse;
        const bare_jid = session.get("bare_jid");
        const cache_key = `${bare_jid}-converse.vcards`;
        initStorage(this, cache_key);

        await this.fetchVCards();

        /**
         * Triggered as soon as the `_converse.state.vcards` collection has
         * been initialized and populated from cache.
         * @event _converse#VCardsInitialized
         */
        shared_api.trigger("VCardsInitialized");
    }

    fetchVCards() {
        const deferred = getOpenPromise();
        this.fetch(
            {
                success: () => deferred.resolve(),
                error: () => deferred.resolve(),
            },
        );
        return deferred;
    }
}

/* export default */ const vcard_vcards = (VCards);

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/api.js
/**
 * @typedef {import('@converse/skeletor').Model} Model
 */






const { Strophe: vcard_api_Strophe, dayjs: vcard_api_dayjs, u: vcard_api_u, stx: vcard_api_stx } = api_public.env;

/* export default */ const vcard_api = ({
    /**
     * The XEP-0054 VCard API
     *
     * This API lets you access and update user VCards
     *
     * @namespace _converse.api.vcard
     * @memberOf _converse.api
     */
    vcard: {
        /**
         * Enables setting new values for a VCard.
         *
         * Sends out an IQ stanza to set the user's VCard and if
         * successful, it updates the {@link _converse.VCard}
         * for the passed in JID.
         *
         * @method _converse.api.vcard.set
         * @param {string} jid The JID for which the VCard should be set
         * @param {import("./types").VCardData} data A map of VCard keys and values
         * @example
         * let jid = _converse.bare_jid;
         * _converse.api.vcard.set( jid, {
         *     'fn': 'John Doe',
         *     'nickname': 'jdoe'
         * }).then(() => {
         *     // Success
         * }).catch((e) => {
         *     // Failure, e is your error object
         * }).
         */
        async set(jid, data) {
            if (!jid) throw Error('No jid provided for the VCard data');
            shared_api.waitUntil('VCardsInitialized');

            let vcard = shared_converse.state.vcards.get(jid);
            const old_vcard_attrs = vcard?.attributes ?? null;
            if (vcard && old_vcard_attrs.image !== data.image) {
                // Optimistically update the vcard with image data. Otherwise some servers (e.g. Ejabberd)
                // could send a XEP-0153 vcard:update presence which would cause us to refetch the vcard again.
                const buffer = vcard_api_u.base64ToArrayBuffer(data.image);
                const hash_ab = await crypto.subtle.digest('SHA-1', buffer);
                vcard.save({
                    image: data.image,
                    image_type: data.image_type,
                    image_hash: vcard_api_u.arrayBufferToHex(hash_ab),
                });
            }

            let result;
            const vcard_el = vcard_api_stx`
                <vCard xmlns="vcard-temp">
                    <FN>${data.fn ?? ''}</FN>
                    <NICKNAME>${data.nickname ?? ''}</NICKNAME>
                    <URL>${data.url ?? ''}</URL>
                    <ROLE>${data.role ?? ''}</ROLE>
                    <EMAIL><INTERNET/><PREF/><USERID>${data.email ?? ''}</USERID></EMAIL>
                    <PHOTO>
                        <TYPE>${data.image_type ?? ''}</TYPE>
                        <BINVAL>${data.image ?? ''}</BINVAL>
                    </PHOTO>
                </vCard>`;
            try {
                result = await shared_api.sendIQ(createStanza('set', jid, vcard_el));
            } catch (e) {
                if (old_vcard_attrs) vcard.save(old_vcard_attrs);
                throw e;
            }

            vcard = await shared_api.vcard.update(jid, true);
            if (vcard_api_u.isOwnJID(jid)) {
                // Send out a XEP-0153 presence with the image hash
                const node = vcard_api_stx`<x xmlns="${vcard_api_Strophe.NS.VCARD_UPDATE}">
                    <photo>${vcard.get('image_hash') ?? ''}</photo>
                </x>`;
                shared_api.user.presence.send({}, node);
            }
            return result;
        },

        /**
         * @method _converse.api.vcard.get
         * @param {Model|string} model Either a `Model` instance, or a string JID.
         *     If a `Model` instance is passed in, then it must have either a `jid`
         *     attribute or a `muc_jid` attribute.
         * @param {boolean} [force] A boolean indicating whether the vcard should be
         *     fetched from the server even if it's been fetched before.
         * @returns {Promise<import("./types").VCardResult|null>} A Promise which resolves
         *     with the VCard data for a particular JID or for a `Model` instance which
         *     represents an entity with a JID (such as a roster contact, chat or chatroom occupant).
         *
         * @example
         * const { api } = _converse;
         * api.waitUntil('rosterContactsFetched').then(() => {
         *     api.vcard.get('someone@example.org').then(
         *         (vcard) => {
         *             // Do something with the vcard...
         *         }
         *     );
         * });
         */
        async get(model, force) {
            shared_api.waitUntil("VCardsInitialized");

            if (typeof model === "string") return fetchVCard(model);

            const jid = model.get('jid');
            const vcard_updated = model.get("vcard_updated");
            const vcard_error = model.get("vcard_error");

            if (vcard_updated || vcard_error) {
                const muc = shared_converse.state.chatboxes.get(jid);
                if (!muc || !force) return null;

                // We don't get XEP-0153 presence updates for MUCs, so we need
                // to refresh from time to time.
                // We check how long ago it was fetched. If it was longer ago than
                // the last 7 days plus some jitter (to prevent an IQ fetch flood),
                // we try again.
                const { random, round } = Math;
                const subtract_flag = round(random());
                const recent_date = vcard_api_dayjs()
                    .subtract(7, "days")
                    .subtract(round(random() * 24) * subtract_flag, "hours")
                    .add(round(random() * 24) * (!subtract_flag ? 1 : 0), "hours");

                const updated_recently = vcard_api_dayjs(vcard_updated).isAfter(recent_date);
                if (!force && updated_recently) return null;
            }

            if (!jid) {
                src_log.error('No JID to get vcard for');
                return null;
            }

            return fetchVCard(jid);
        },

        /**
         * Fetches the VCard associated with a particular `Model` instance
         * (by using its `jid` or `muc_jid` attribute) and then updates the model with the
         * returned VCard data.
         *
         * @method _converse.api.vcard.update
         * @param {Model} model A `Model` instance
         * @param {boolean} [force] A boolean indicating whether the vcard should be
         *     fetched again even if it's been fetched before.
         * @returns {promise} A promise which resolves once the update has completed.
         * @example
         * const { api } = _converse;
         * api.waitUntil('rosterContactsFetched').then(async () => {
         *     const chatbox = await api.chats.get('someone@example.org');
         *     api.vcard.update(chatbox);
         * });
         */
        async update(model, force) {
            shared_api.waitUntil('VCardsInitialized');
            const data = await this.get(model, force);
            if (data === null) {
                return;
            }
            model = typeof model === 'string' ? shared_converse.state.vcards.get(model) : model;
            if (!model) {
                src_log.error(`Could not find a VCard model for ${model}`);
                return;
            }
            if (Object.keys(data).length) {
                delete data['stanza'];
                vcard_api_u.safeSave(model, data);
            }
            return model;
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/plugin.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */









const { Strophe: vcard_plugin_Strophe } = api_public.env;

api_public.plugins.add('converse-vcard', {
    dependencies: ['converse-status', 'converse-roster'],

    enabled() {
        return !shared_api.settings.get('blacklisted_plugins')?.includes('converse-vcard');
    },

    initialize() {
        shared_api.settings.extend({
            lazy_load_vcards: true,
        });

        shared_api.promises.add('VCardsInitialized');

        Object.assign(shared_converse.api, vcard_api);

        const exports = { VCard: vcard_vcard, VCards: vcard_vcards };
        Object.assign(shared_converse, exports); // XXX DEPRECATED
        Object.assign(shared_converse.exports, exports);

        shared_api.listen.on(
            'chatRoomInitialized',
            /** @param {import('../muc/muc').default} m */ (m) => {
                m.listenTo(m.occupants, 'change:image_hash', (o) => onOccupantAvatarChanged(o));
            }
        );

        shared_api.listen.on('addClientFeatures', () => {
            shared_api.disco.own.features.add(vcard_plugin_Strophe.NS.VCARD);
            shared_api.disco.own.features.add(vcard_plugin_Strophe.NS.VCARD_UPDATE);
        });
        shared_api.listen.on('clearSession', () => clearVCardsSession());

        shared_api.listen.on('visibilityChanged', ({ el }) => {
            const { model } = el;
            if (model?.vcard) model.vcard.trigger('visibilityChanged');
        });

        shared_api.listen.on('connected', () => {
            const vcards = new shared_converse.exports.VCards();
            shared_converse.state.vcards = vcards;
            Object.assign(shared_converse, { vcards }); // XXX DEPRECATED
        });

        shared_api.listen.on('presencesInitialized', () => registerPresenceHandler());
        shared_api.listen.on('beforeTearDown', () => unregisterPresenceHandler());
        shared_api.listen.on('constructedPresence', (_, p) => updatePresence(p));
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/index.js







;// CONCATENATED MODULE: ./src/headless/index.js














// START: Removable components
// ---------------------------
// The following components may be removed if they're not needed.

 // XEP-0199 XMPP Ping

 // XEP-0206 BOSH
 // XEP-0115 Entity Capabilities
 // RFC-6121 Instant messaging

 // XEP-0030 Service discovery
 // XEP-0050 Ad Hoc Commands
 // Support for headline messages
 // Support for headline messages

// XEP-0313 Message Archive Management


// XEP-0045 Multi-user chat


 // XEP-0199 XMPP Ping
 // XEP-0060 Pubsub
 // XEP-0444 Message Reactions

// RFC-6121 Contacts Roster


 // XEP-0198 Stream Management

 // XEP-0054 VCard-temp
// ---------------------------
// END: Removable components



const constants = Object.assign({}, shared_constants_namespaceObject, muc_constants_namespaceObject, omemo_constants_namespaceObject);

Object.assign(shared_converse.constants, constants);




window['converse'] = api_public;

/* export default */ const headless = (api_public);

})();

var __webpack_exports__BaseMessage = __webpack_exports__.XQ;
var __webpack_exports__Bookmark = __webpack_exports__.Xh;
var __webpack_exports__Bookmarks = __webpack_exports__._r;
var __webpack_exports__Builder = __webpack_exports__.M$;
var __webpack_exports__ChatBox = __webpack_exports__.sB;
var __webpack_exports__Collection = __webpack_exports__.pM;
var __webpack_exports__Device = __webpack_exports__.pF;
var __webpack_exports__DeviceList = __webpack_exports__.fs;
var __webpack_exports__DeviceLists = __webpack_exports__.K_;
var __webpack_exports__Devices = __webpack_exports__.uk;
var __webpack_exports__EmojiPicker = __webpack_exports__.pP;
var __webpack_exports__EventEmitter = __webpack_exports__.bk;
var __webpack_exports__MAMPlaceholderMessage = __webpack_exports__.yp;
var __webpack_exports__MUC = __webpack_exports__.mu;
var __webpack_exports__MUCMessage = __webpack_exports__.pJ;
var __webpack_exports__MUCMessages = __webpack_exports__.Q1;
var __webpack_exports__MUCOccupant = __webpack_exports__.PW;
var __webpack_exports__MUCOccupants = __webpack_exports__.O0;
var __webpack_exports__Message = __webpack_exports__.QB;
var __webpack_exports__Messages = __webpack_exports__.B2;
var __webpack_exports__Model = __webpack_exports__.Kx;
var __webpack_exports__ModelWithMessages = __webpack_exports__.w;
var __webpack_exports__Presence = __webpack_exports__.Cq;
var __webpack_exports__Presences = __webpack_exports__.T7;
var __webpack_exports__Profile = __webpack_exports__.WV;
var __webpack_exports__RosterContact = __webpack_exports__.C7;
var __webpack_exports__RosterContacts = __webpack_exports__.yP;
var __webpack_exports__RosterFilter = __webpack_exports__.G2;
var __webpack_exports__Stanza = __webpack_exports__.Qd;
var __webpack_exports__VCard = __webpack_exports__.Jn;
var __webpack_exports__VCards = __webpack_exports__.K2;
var __webpack_exports___converse = __webpack_exports__.JR;
var __webpack_exports__api = __webpack_exports__.FH;
var __webpack_exports__constants = __webpack_exports__.AA;
var __webpack_exports__converse = __webpack_exports__.iq;
var __webpack_exports__default = __webpack_exports__.Ay;
var __webpack_exports__errors = __webpack_exports__.sO;
var __webpack_exports__i18n = __webpack_exports__.Ru;
var __webpack_exports__log = __webpack_exports__.Rm;
var __webpack_exports__parsers = __webpack_exports__.T_;
var __webpack_exports__u = __webpack_exports__.u;
export { __webpack_exports__BaseMessage as BaseMessage, __webpack_exports__Bookmark as Bookmark, __webpack_exports__Bookmarks as Bookmarks, __webpack_exports__Builder as Builder, __webpack_exports__ChatBox as ChatBox, __webpack_exports__Collection as Collection, __webpack_exports__Device as Device, __webpack_exports__DeviceList as DeviceList, __webpack_exports__DeviceLists as DeviceLists, __webpack_exports__Devices as Devices, __webpack_exports__EmojiPicker as EmojiPicker, __webpack_exports__EventEmitter as EventEmitter, __webpack_exports__MAMPlaceholderMessage as MAMPlaceholderMessage, __webpack_exports__MUC as MUC, __webpack_exports__MUCMessage as MUCMessage, __webpack_exports__MUCMessages as MUCMessages, __webpack_exports__MUCOccupant as MUCOccupant, __webpack_exports__MUCOccupants as MUCOccupants, __webpack_exports__Message as Message, __webpack_exports__Messages as Messages, __webpack_exports__Model as Model, __webpack_exports__ModelWithMessages as ModelWithMessages, __webpack_exports__Presence as Presence, __webpack_exports__Presences as Presences, __webpack_exports__Profile as Profile, __webpack_exports__RosterContact as RosterContact, __webpack_exports__RosterContacts as RosterContacts, __webpack_exports__RosterFilter as RosterFilter, __webpack_exports__Stanza as Stanza, __webpack_exports__VCard as VCard, __webpack_exports__VCards as VCards, __webpack_exports___converse as _converse, __webpack_exports__api as api, __webpack_exports__constants as constants, __webpack_exports__converse as converse, __webpack_exports__default as default, __webpack_exports__errors as errors, __webpack_exports__i18n as i18n, __webpack_exports__log as log, __webpack_exports__parsers as parsers, __webpack_exports__u as u };

//# sourceMappingURL=converse-headless.esm.js.map